var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

(function webpackUniversalModuleDefinition(root, factory) {
  exports = factory();
})(typeof self !== "undefined" ? self : exports, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module["default"];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, "a", getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 498);
      /******/
    }([
      /* 0 */

      /***/

      /* 1 */

      /***/

      /* 2 */

      /***/

      /* 3 */

      /***/

      /* 4 */

      /***/

      /* 5 */

      /***/

      /* 6 */

      /***/

      /* 7 */

      /***/

      /* 8 */

      /***/

      /* 9 */

      /***/

      /* 10 */

      /***/

      /* 11 */

      /***/

      /* 12 */

      /***/

      /* 13 */

      /***/

      /* 14 */

      /***/

      /* 15 */

      /***/

      /* 16 */

      /***/

      /* 17 */

      /***/

      /* 18 */

      /***/

      /* 19 */

      /***/

      /* 20 */

      /***/

      /* 21 */

      /***/

      /* 22 */

      /***/

      /* 23 */

      /***/

      /* 24 */

      /***/

      /* 25 */

      /***/

      /* 26 */

      /***/

      /* 27 */

      /***/

      /* 28 */

      /***/

      /* 29 */

      /***/

      /* 30 */

      /***/

      /* 31 */

      /***/

      /* 32 */

      /***/

      /* 33 */

      /***/

      /* 34 */

      /***/

      /* 35 */

      /***/

      /* 36 */

      /***/

      /* 37 */

      /***/

      /* 38 */

      /***/

      /* 39 */

      /***/

      /* 40 */

      /***/

      /* 41 */

      /***/

      /* 42 */

      /***/

      /* 43 */

      /***/

      /* 44 */

      /***/

      /* 45 */

      /***/

      /* 46 */

      /***/

      /* 47 */

      /***/

      /* 48 */

      /***/

      /* 49 */

      /***/

      /* 50 */

      /***/

      /* 51 */

      /***/

      /* 52 */

      /***/

      /* 53 */

      /***/

      /* 54 */

      /***/

      /* 55 */

      /***/

      /* 56 */

      /***/

      /* 57 */

      /***/

      /* 58 */

      /***/

      /* 59 */

      /***/

      /* 60 */

      /***/

      /* 61 */

      /***/

      /* 62 */

      /***/

      /* 63 */

      /***/

      /* 64 */

      /***/

      /* 65 */

      /***/

      /* 66 */

      /***/

      /* 67 */

      /***/

      /* 68 */

      /***/

      /* 69 */

      /***/

      /* 70 */

      /***/

      /* 71 */

      /***/

      /* 72 */

      /***/

      /* 73 */

      /***/

      /* 74 */

      /***/

      /* 75 */

      /***/

      /* 76 */

      /***/

      /* 77 */

      /***/

      /* 78 */

      /***/

      /* 79 */

      /***/

      /* 80 */

      /***/

      /* 81 */

      /***/

      /* 82 */

      /***/

      /* 83 */

      /***/

      /* 84 */

      /***/

      /* 85 */

      /***/

      /* 86 */

      /***/

      /* 87 */

      /***/

      /* 88 */

      /***/

      /* 89 */

      /***/

      /* 90 */

      /***/

      /* 91 */

      /***/

      /* 92 */

      /***/

      /* 93 */

      /***/

      /* 94 */

      /***/

      /* 95 */

      /***/

      /* 96 */

      /***/

      /* 97 */

      /***/

      /* 98 */

      /***/

      /* 99 */

      /***/

      /* 100 */

      /***/

      /* 101 */

      /***/

      /* 102 */

      /***/

      /* 103 */

      /***/

      /* 104 */

      /***/

      /* 105 */

      /***/

      /* 106 */

      /***/

      /* 107 */

      /***/

      /* 108 */

      /***/

      /* 109 */

      /***/

      /* 110 */

      /***/

      /* 111 */

      /***/

      /* 112 */

      /***/

      /* 113 */

      /***/

      /* 114 */

      /***/

      /* 115 */

      /***/

      /* 116 */

      /***/

      /* 117 */

      /***/

      /* 118 */

      /***/

      /* 119 */

      /***/

      /* 120 */

      /***/

      /* 121 */

      /***/

      /* 122 */

      /***/

      /* 123 */

      /***/

      /* 124 */

      /***/

      /* 125 */

      /***/

      /* 126 */

      /***/

      /* 127 */

      /***/

      /* 128 */

      /***/

      /* 129 */

      /***/

      /* 130 */

      /***/

      /* 131 */

      /***/

      /* 132 */

      /***/

      /* 133 */

      /***/

      /* 134 */

      /***/

      /* 135 */

      /***/

      /* 136 */

      /***/

      /* 137 */

      /***/

      /* 138 */

      /***/

      /* 139 */

      /***/

      /* 140 */

      /***/

      /* 141 */

      /***/

      /* 142 */

      /***/

      /* 143 */

      /***/

      /* 144 */

      /***/

      /* 145 */

      /***/

      /* 146 */

      /***/

      /* 147 */

      /***/

      /* 148 */

      /***/

      /* 149 */

      /***/

      /* 150 */

      /***/

      /* 151 */

      /***/

      /* 152 */

      /***/

      /* 153 */

      /***/

      /* 154 */

      /***/

      /* 155 */

      /***/

      /* 156 */

      /***/

      /* 157 */

      /***/

      /* 158 */

      /***/

      /* 159 */

      /***/

      /* 160 */

      /***/

      /* 161 */

      /***/

      /* 162 */

      /***/

      /* 163 */

      /***/

      /* 164 */

      /***/

      /* 165 */

      /***/

      /* 166 */

      /***/

      /* 167 */

      /***/

      /* 168 */

      /***/

      /* 169 */

      /***/

      /* 170 */

      /***/

      /* 171 */

      /***/

      /* 172 */

      /***/

      /* 173 */

      /***/

      /* 174 */

      /***/

      /* 175 */

      /***/

      /* 176 */

      /***/

      /* 177 */

      /***/

      /* 178 */

      /***/

      /* 179 */

      /***/

      /* 180 */

      /***/

      /* 181 */

      /***/

      /* 182 */

      /***/

      /* 183 */

      /***/

      /* 184 */

      /***/

      /* 185 */

      /***/

      /* 186 */

      /***/

      /* 187 */

      /***/

      /* 188 */

      /***/

      /* 189 */

      /***/

      /* 190 */

      /***/

      /* 191 */

      /***/

      /* 192 */

      /***/

      /* 193 */

      /***/

      /* 194 */

      /***/

      /* 195 */

      /***/

      /* 196 */

      /***/

      /* 197 */

      /***/

      /* 198 */

      /***/

      /* 199 */

      /***/

      /* 200 */

      /***/

      /* 201 */

      /***/

      /* 202 */

      /***/

      /* 203 */

      /***/

      /* 204 */

      /***/

      /* 205 */

      /***/

      /* 206 */

      /***/

      /* 207 */

      /***/

      /* 208 */

      /***/

      /* 209 */

      /***/

      /* 210 */

      /***/

      /* 211 */

      /***/

      /* 212 */

      /***/

      /* 213 */

      /***/

      /* 214 */

      /***/

      /* 215 */

      /***/

      /* 216 */

      /***/

      /* 217 */

      /***/

      /* 218 */

      /***/

      /* 219 */

      /***/

      /* 220 */

      /***/

      /* 221 */

      /***/

      /* 222 */

      /***/

      /* 223 */

      /***/

      /* 224 */

      /***/

      /* 225 */

      /***/

      /* 226 */

      /***/

      /* 227 */

      /***/

      /* 228 */

      /***/

      /* 229 */

      /***/

      /* 230 */

      /***/

      /* 231 */

      /***/

      /* 232 */

      /***/

      /* 233 */

      /***/

      /* 234 */

      /***/

      /* 235 */

      /***/

      /* 236 */

      /***/

      /* 237 */

      /***/

      /* 238 */

      /***/

      /* 239 */

      /***/

      /* 240 */

      /***/

      /* 241 */

      /***/

      /* 242 */

      /***/

      /* 243 */

      /***/

      /* 244 */

      /***/

      /* 245 */

      /***/

      /* 246 */

      /***/

      /* 247 */

      /***/

      /* 248 */

      /***/

      /* 249 */

      /***/

      /* 250 */

      /***/

      /* 251 */

      /***/

      /* 252 */

      /***/

      /* 253 */

      /***/

      /* 254 */

      /***/

      /* 255 */

      /***/

      /* 256 */

      /***/

      /* 257 */

      /***/

      /* 258 */

      /***/

      /* 259 */

      /***/

      /* 260 */

      /***/

      /* 261 */

      /***/

      /* 262 */

      /***/

      /* 263 */

      /***/

      /* 264 */

      /***/

      /* 265 */

      /***/

      /* 266 */

      /***/

      /* 267 */

      /***/

      /* 268 */

      /***/

      /* 269 */

      /***/

      /* 270 */

      /***/

      /* 271 */

      /***/

      /* 272 */

      /***/

      /* 273 */

      /***/

      /* 274 */

      /***/

      /* 275 */

      /***/

      /* 276 */

      /***/

      /* 277 */

      /***/

      /* 278 */

      /***/

      /* 279 */

      /***/

      /* 280 */

      /***/

      /* 281 */

      /***/

      /* 282 */

      /***/

      /* 283 */

      /***/

      /* 284 */

      /***/

      /* 285 */

      /***/

      /* 286 */

      /***/

      /* 287 */

      /***/

      /* 288 */

      /***/

      /* 289 */

      /***/

      /* 290 */

      /***/

      /* 291 */

      /***/

      /* 292 */

      /***/

      /* 293 */

      /***/

      /* 294 */

      /***/

      /* 295 */

      /***/

      /* 296 */

      /***/

      /* 297 */

      /***/

      /* 298 */

      /***/

      /* 299 */

      /***/

      /* 300 */

      /***/

      /* 301 */

      /***/

      /* 302 */

      /***/

      /* 303 */

      /***/

      /* 304 */

      /***/

      /* 305 */

      /***/

      /* 306 */

      /***/

      /* 307 */

      /***/

      /* 308 */

      /***/

      /* 309 */

      /***/

      /* 310 */

      /***/

      /* 311 */

      /***/

      /* 312 */

      /***/

      /* 313 */

      /***/

      /* 314 */

      /***/

      /* 315 */

      /***/

      /* 316 */

      /***/

      /* 317 */

      /***/

      /* 318 */

      /***/

      /* 319 */

      /***/

      /* 320 */

      /***/

      /* 321 */

      /***/

      /* 322 */

      /***/

      /* 323 */

      /***/

      /* 324 */

      /***/

      /* 325 */

      /***/

      /* 326 */

      /***/

      /* 327 */

      /***/

      /* 328 */

      /***/

      /* 329 */

      /***/

      /* 330 */

      /***/

      /* 331 */

      /***/

      /* 332 */

      /***/

      /* 333 */

      /***/

      /* 334 */

      /***/

      /* 335 */

      /***/

      /* 336 */

      /***/

      /* 337 */

      /***/

      /* 338 */

      /***/

      /* 339 */

      /***/

      /* 340 */

      /***/

      /* 341 */

      /***/

      /* 342 */

      /***/

      /* 343 */

      /***/

      /* 344 */

      /***/

      /* 345 */

      /***/

      /* 346 */

      /***/

      /* 347 */

      /***/

      /* 348 */

      /***/

      /* 349 */

      /***/

      /* 350 */

      /***/

      /* 351 */

      /***/

      /* 352 */

      /***/

      /* 353 */

      /***/

      /* 354 */

      /***/

      /* 355 */

      /***/

      /* 356 */

      /***/

      /* 357 */

      /***/

      /* 358 */

      /***/

      /* 359 */

      /***/

      /* 360 */

      /***/

      /* 361 */

      /***/

      /* 362 */

      /***/

      /* 363 */

      /***/

      /* 364 */

      /***/

      /* 365 */

      /***/

      /* 366 */

      /***/

      /* 367 */

      /***/

      /* 368 */

      /***/

      /* 369 */

      /***/

      /* 370 */

      /***/

      /* 371 */

      /***/

      /* 372 */

      /***/

      /* 373 */

      /***/

      /* 374 */

      /***/

      /* 375 */

      /***/

      /* 376 */

      /***/

      /* 377 */

      /***/

      /* 378 */

      /***/

      /* 379 */

      /***/

      /* 380 */

      /***/

      /* 381 */

      /***/

      /* 382 */

      /***/

      /* 383 */

      /***/

      /* 384 */

      /***/

      /* 385 */

      /***/

      /* 386 */

      /***/

      /* 387 */

      /***/

      /* 388 */

      /***/

      /* 389 */

      /***/

      /* 390 */

      /***/

      /* 391 */

      /***/

      /* 392 */

      /***/

      /* 393 */

      /***/

      /* 394 */

      /***/

      /* 395 */

      /***/

      /* 396 */

      /***/

      /* 397 */

      /***/

      /* 398 */

      /***/

      /* 399 */

      /***/

      /* 400 */

      /***/

      /* 401 */

      /***/

      /* 402 */

      /***/

      /* 403 */

      /***/

      /* 404 */

      /***/

      /* 405 */

      /***/

      /* 406 */

      /***/

      /* 407 */

      /***/

      /* 408 */

      /***/

      /* 409 */

      /***/

      /* 410 */

      /***/

      /* 411 */

      /***/

      /* 412 */

      /***/

      /* 413 */

      /***/

      /* 414 */

      /***/

      /* 415 */

      /***/

      /* 416 */

      /***/

      /* 417 */

      /***/

      /* 418 */

      /***/

      /* 419 */

      /***/

      /* 420 */

      /***/

      /* 421 */

      /***/

      /* 422 */

      /***/

      /* 423 */

      /***/

      /* 424 */

      /***/

      /* 425 */

      /***/

      /* 426 */

      /***/

      /* 427 */

      /***/

      /* 428 */

      /***/

      /* 429 */

      /***/

      /* 430 */

      /***/

      /* 431 */

      /***/

      /* 432 */

      /***/

      /* 433 */

      /***/

      /* 434 */

      /***/

      /* 435 */

      /***/

      /* 436 */

      /***/

      /* 437 */

      /***/

      /* 438 */

      /***/

      /* 439 */

      /***/

      /* 440 */

      /***/

      /* 441 */

      /***/

      /* 442 */

      /***/

      /* 443 */

      /***/

      /* 444 */

      /***/

      /* 445 */

      /***/

      /* 446 */

      /***/

      /* 447 */

      /***/

      /* 448 */

      /***/

      /* 449 */

      /***/

      /* 450 */

      /***/

      /* 451 */

      /***/

      /* 452 */

      /***/

      /* 453 */

      /***/

      /* 454 */

      /***/

      /* 455 */

      /***/

      /* 456 */

      /***/

      /* 457 */

      /***/

      /* 458 */

      /***/

      /* 459 */

      /***/

      /* 460 */

      /***/

      /* 461 */

      /***/

      /* 462 */

      /***/

      /* 463 */

      /***/

      /* 464 */

      /***/

      /* 465 */

      /***/

      /* 466 */

      /***/

      /* 467 */

      /***/

      /* 468 */

      /***/

      /* 469 */

      /***/

      /* 470 */

      /***/

      /* 471 */

      /***/

      /* 472 */

      /***/

      /* 473 */

      /***/

      /* 474 */

      /***/

      /* 475 */

      /***/

      /* 476 */

      /***/

      /* 477 */

      /***/

      /* 478 */

      /***/

      /* 479 */

      /***/

      /* 480 */

      /***/

      /* 481 */

      /***/

      /* 482 */

      /***/

      /* 483 */

      /***/

      /* 484 */

      /***/

      /* 485 */

      /***/

      /* 486 */

      /***/

      /* 487 */

      /***/

      /* 488 */

      /***/

      /* 489 */

      /***/

      /* 490 */

      /***/

      /* 491 */

      /***/

      /* 492 */

      /***/

      /* 493 */

      /***/

      /* 494 */

      /***/

      /* 495 */

      /***/

      /* 496 */

      /***/

      /* 497 */

      /***/

      /* 498 */

      /***/

      /* 499 */

      /***/

      /* 500 */

      /***/

      /* 501 */

      /***/

      /* 502 */

      /***/

      /* 503 */

      /***/

      /* 504 */

      /***/

      /* 505 */

      /***/

      /* 506 */

      /***/

      /* 507 */

      /***/

      /* 508 */

      /***/

      /* 509 */

      /***/

      /* 510 */

      /***/

      /* 511 */

      /***/

      /* 512 */

      /***/

      /* 513 */

      /***/

      /* 514 */

      /***/

      /* 515 */

      /***/

      /* 516 */

      /***/

      /* 517 */

      /***/

      /* 518 */

      /***/

      /* 519 */

      /***/

      /* 520 */

      /***/

      /* 521 */

      /***/

      /* 522 */

      /***/

      /* 523 */

      /***/

      /* 524 */

      /***/

      /* 525 */

      /***/

      /* 526 */

      /***/

      /* 527 */

      /***/

      /* 528 */

      /***/

      /* 529 */

      /***/

      /* 530 */

      /***/

      /* 531 */

      /***/

      /* 532 */

      /***/

      /* 533 */

      /***/

      /* 534 */

      /***/

      /* 535 */

      /***/

      /* 536 */

      /***/

      /* 537 */

      /***/

      /* 538 */

      /***/

      /* 539 */

      /***/

      /* 540 */

      /***/

      /* 541 */

      /***/

      /* 542 */

      /***/

      /* 543 */

      /***/

      /* 544 */

      /***/

      /* 545 */

      /***/

      /* 546 */

      /***/

      /* 547 */

      /***/

      /* 548 */

      /***/

      /* 549 */

      /***/

      /* 550 */

      /***/

      /* 551 */

      /***/

      /* 552 */

      /***/

      /* 553 */

      /***/

      /* 554 */

      /***/

      /* 555 */

      /***/

      /* 556 */

      /***/

      /* 557 */

      /***/

      /* 558 */

      /***/

      /* 559 */

      /***/

      /* 560 */

      /***/

      /* 561 */

      /***/

      /* 562 */

      /***/

      /* 563 */

      /***/

      /* 564 */

      /***/

      /* 565 */

      /***/

      /* 566 */

      /***/

      /* 567 */

      /***/

      /* 568 */

      /***/

      /* 569 */

      /***/

      /* 570 */

      /***/

      /* 571 */

      /***/

      /* 572 */

      /***/

      /* 573 */

      /***/

      /* 574 */

      /***/

      /* 575 */

      /***/

      /* 576 */

      /***/

      /* 577 */

      /***/

      /* 578 */

      /***/

      /* 579 */

      /***/

      /* 580 */

      /***/

      /* 581 */

      /***/

      /* 582 */

      /***/

      /* 583 */

      /***/

      /* 584 */

      /***/

      /* 585 */

      /***/

      /* 586 */

      /***/

      /* 587 */

      /***/

      /* 588 */

      /***/

      /* 589 */

      /***/

      /* 590 */

      /***/

      /* 591 */

      /***/

      /* 592 */

      /***/

      /* 593 */

      /***/

      /* 594 */

      /***/

      /* 595 */

      /***/

      /* 596 */

      /***/

      /* 597 */

      /***/

      /* 598 */

      /***/

      /* 599 */

      /***/

      /* 600 */

      /***/

      /* 601 */

      /***/

      /* 602 */

      /***/

      /* 603 */

      /***/

      /* 604 */

      /***/

      /* 605 */

      /***/

      /* 606 */

      /***/

      /* 607 */

      /***/

      /* 608 */

      /***/

      /* 609 */

      /***/

      /* 610 */

      /***/

      /* 611 */

      /***/

      /* 612 */

      /***/

      /* 613 */

      /***/

      /* 614 */

      /***/

      /* 615 */

      /***/

      /* 616 */

      /***/

      /* 617 */

      /***/

      /* 618 */

      /***/

      /* 619 */

      /***/

      /* 620 */

      /***/

      /* 621 */

      /***/

      /* 622 */

      /***/

      /* 623 */

      /***/

      /* 624 */

      /***/

      /* 625 */

      /***/

      /* 626 */

      /***/

      /* 627 */

      /***/

      /* 628 */

      /***/

      /* 629 */

      /***/

      /* 630 */

      /***/

      /* 631 */

      /***/

      /* 632 */

      /***/

      /* 633 */

      /***/

      /* 634 */

      /***/

      /* 635 */

      /***/

      /* 636 */

      /***/

      /* 637 */

      /***/

      /* 638 */

      /***/

      /* 639 */

      /***/

      /* 640 */

      /***/

      /* 641 */

      /***/

      /* 642 */

      /***/

      /* 643 */

      /***/

      /* 644 */

      /***/

      /* 645 */

      /***/

      /* 646 */

      /***/

      /* 647 */

      /***/

      /* 648 */

      /***/

      /* 649 */

      /***/

      /* 650 */

      /***/

      /* 651 */

      /***/

      /* 652 */

      /***/

      /* 653 */

      /***/

      /* 654 */

      /***/

      /* 655 */

      /***/

      /* 656 */

      /***/

      /* 657 */

      /***/

      /* 658 */

      /***/

      /* 659 */

      /***/

      /* 660 */

      /***/

      /* 661 */

      /***/

      /* 662 */

      /***/

      /* 663 */

      /***/

      /* 664 */

      /***/

      /* 665 */

      /***/

      /* 666 */

      /***/

      /* 667 */

      /***/

      /* 668 */

      /***/

      /* 669 */

      /***/

      /* 670 */

      /***/

      /* 671 */

      /***/

      /* 672 */

      /***/

      /* 673 */

      /***/

      /* 674 */

      /***/

      /* 675 */

      /***/

      /* 676 */

      /***/

      /* 677 */

      /***/

      /* 678 */

      /***/

      /* 679 */

      /***/

      /* 680 */

      /***/

      /* 681 */

      /***/

      /* 682 */

      /***/

      /* 683 */

      /***/

      /* 684 */

      /***/

      /* 685 */

      /***/

      /* 686 */

      /***/

      /* 687 */

      /***/

      /* 688 */

      /***/

      /* 689 */

      /***/

      /* 690 */

      /***/

      /* 691 */

      /***/

      /* 692 */

      /***/

      /* 693 */

      /***/

      /* 694 */

      /***/

      /* 695 */

      /***/

      /* 696 */

      /***/

      /* 697 */

      /***/

      /* 698 */

      /***/

      /* 699 */

      /***/

      /* 700 */

      /***/

      /* 701 */

      /***/

      /* 702 */

      /***/

      /* 703 */

      /***/

      /* 704 */

      /***/

      /* 705 */

      /***/

      /* 706 */

      /***/

      /* 707 */

      /***/

      /* 708 */

      /***/

      /* 709 */

      /***/

      /* 710 */

      /***/

      /* 711 */

      /***/

      /* 712 */

      /***/

      /* 713 */

      /***/

      /* 714 */

      /***/

      /* 715 */

      /***/

      /* 716 */

      /***/

      /* 717 */

      /***/

      /* 718 */

      /***/

      /* 719 */

      /***/

      /* 720 */

      /***/

      /* 721 */

      /***/

      /* 722 */

      /***/

      /* 723 */

      /***/

      /* 724 */

      /***/

      /* 725 */

      /***/

      /* 726 */

      /***/

      /* 727 */

      /***/

      /* 728 */

      /***/

      /* 729 */

      /***/

      /* 730 */

      /***/

      /* 731 */

      /***/

      /* 732 */

      /***/

      /* 733 */

      /***/

      /* 734 */

      /***/

      /* 735 */

      /***/

      /* 736 */

      /***/

      /* 737 */

      /***/

      /* 738 */

      /***/

      /* 739 */

      /***/

      /* 740 */

      /***/

      /* 741 */

      /***/

      /* 742 */

      /***/

      /* 743 */

      /***/

      /* 744 */

      /***/

      /* 745 */

      /***/

      /* 746 */

      /***/

      /* 747 */

      /***/

      /* 748 */

      /***/

      /* 749 */

      /***/

      /* 750 */

      /***/

      /* 751 */

      /***/

      /* 752 */

      /***/

      /* 753 */

      /***/

      /* 754 */

      /***/

      /* 755 */

      /***/

      /* 756 */

      /***/

      /* 757 */

      /***/

      /* 758 */

      /***/

      /* 759 */

      /***/

      /* 760 */

      /***/

      /* 761 */

      /***/

      /* 762 */

      /***/

      /* 763 */

      /***/

      /* 764 */

      /***/

      /* 765 */

      /***/

      /* 766 */

      /***/

      /* 767 */

      /***/

      /* 768 */

      /***/

      /* 769 */

      /***/

      /* 770 */

      /***/

      /******/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = requiredArgs;

      function requiredArgs(required, args) {
        if (args.length < required) {
          throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
        }
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = toDate;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name toDate
       * @category Common Helpers
       * @summary Convert the given argument to an instance of Date.
       *
       * @description
       * Convert the given argument to an instance of Date.
       *
       * If the argument is an instance of Date, the function returns its clone.
       *
       * If the argument is a number, it is treated as a timestamp.
       *
       * If the argument is none of the above, the function returns Invalid Date.
       *
       * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
       *
       * @param {Date|Number} argument - the value to convert
       * @returns {Date} the parsed date in the local time zone
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Clone the date:
       * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
       * //=> Tue Feb 11 2014 11:30:30
       *
       * @example
       * // Convert the timestamp to date:
       * const result = toDate(1392098430000)
       * //=> Tue Feb 11 2014 11:30:30
       */


      function toDate(argument) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var argStr = Object.prototype.toString.call(argument); // Clone the date

        if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
          // Prevent the date to lose the milliseconds when passed to new Date() in IE10
          return new Date(argument.getTime());
        } else if (typeof argument === "number" || argStr === "[object Number]") {
          return new Date(argument);
        } else {
          if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

            console.warn(new Error().stack);
          }

          return new Date(NaN);
        }
      }
      /***/

    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = buildFormatLongFn;

      function buildFormatLongFn(args) {
        return function () {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // TODO: Remove String()

          var width = options.width ? String(options.width) : args.defaultWidth;
          var format = args.formats[width] || args.formats[args.defaultWidth];
          return format;
        };
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = buildLocalizeFn;

      function buildLocalizeFn(args) {
        return function (dirtyIndex, dirtyOptions) {
          var options = dirtyOptions || {};
          var context = options.context ? String(options.context) : "standalone";
          var valuesArray;

          if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
          } else {
            var _defaultWidth = args.defaultWidth;

            var _width = options.width ? String(options.width) : args.defaultWidth;

            valuesArray = args.values[_width] || args.values[_defaultWidth];
          }

          var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!

          return valuesArray[index];
        };
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = buildMatchFn;

      function buildMatchFn(args) {
        return function (string) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var width = options.width;
          var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
          var matchResult = string.match(matchPattern);

          if (!matchResult) {
            return null;
          }

          var matchedString = matchResult[0];
          var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
          var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
            return pattern.test(matchedString);
          }) : findKey(parsePatterns, function (pattern) {
            return pattern.test(matchedString);
          });
          var value;
          value = args.valueCallback ? args.valueCallback(key) : key;
          value = options.valueCallback ? options.valueCallback(value) : value;
          var rest = string.slice(matchedString.length);
          return {
            value: value,
            rest: rest
          };
        };
      }

      function findKey(object, predicate) {
        for (var key in object) {
          if (object.hasOwnProperty(key) && predicate(object[key])) {
            return key;
          }
        }

        return undefined;
      }

      function findIndex(array, predicate) {
        for (var key = 0; key < array.length; key++) {
          if (predicate(array[key])) {
            return key;
          }
        }

        return undefined;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = buildMatchPatternFn;

      function buildMatchPatternFn(args) {
        return function (string) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var matchResult = string.match(args.matchPattern);
          if (!matchResult) return null;
          var matchedString = matchResult[0];
          var parseResult = string.match(args.parsePattern);
          if (!parseResult) return null;
          var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
          value = options.valueCallback ? options.valueCallback(value) : value;
          var rest = string.slice(matchedString.length);
          return {
            value: value,
            rest: rest
          };
        };
      }

      module.exports = exports.default;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = toInteger;

      function toInteger(dirtyNumber) {
        if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
          return NaN;
        }

        var number = Number(dirtyNumber);

        if (isNaN(number)) {
          return number;
        }

        return number < 0 ? Math.ceil(number) : Math.floor(number);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return daysInWeek;
      });
      /* unused harmony export maxTime */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return millisecondsInMinute;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return millisecondsInHour;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return millisecondsInSecond;
      });
      /* unused harmony export minTime */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "e", function () {
        return minutesInHour;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "f", function () {
        return monthsInQuarter;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "g", function () {
        return monthsInYear;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "h", function () {
        return quartersInYear;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "i", function () {
        return secondsInHour;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "j", function () {
        return secondsInMinute;
      });
      /**
       * Days in 1 week.
       *
       * @name daysInWeek
       * @constant
       * @type {number}
       * @default
       */


      var daysInWeek = 7;
      /**
       * Maximum allowed time.
       *
       * @name maxTime
       * @constant
       * @type {number}
       * @default
       */

      var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
      /**
       * Milliseconds in 1 minute
       *
       * @name millisecondsInMinute
       * @constant
       * @type {number}
       * @default
       */

      var millisecondsInMinute = 60000;
      /**
       * Milliseconds in 1 hour
       *
       * @name millisecondsInHour
       * @constant
       * @type {number}
       * @default
       */

      var millisecondsInHour = 3600000;
      /**
       * Milliseconds in 1 second
       *
       * @name millisecondsInSecond
       * @constant
       * @type {number}
       * @default
       */

      var millisecondsInSecond = 1000;
      /**
       * Minimum allowed time.
       *
       * @name minTime
       * @constant
       * @type {number}
       * @default
       */

      var minTime = -maxTime;
      /**
       * Minutes in 1 hour
       *
       * @name minutesInHour
       * @constant
       * @type {number}
       * @default
       */

      var minutesInHour = 60;
      /**
       * Months in 1 quarter
       *
       * @name monthsInQuarter
       * @constant
       * @type {number}
       * @default
       */

      var monthsInQuarter = 3;
      /**
       * Months in 1 year
       *
       * @name monthsInYear
       * @constant
       * @type {number}
       * @default
       */

      var monthsInYear = 12;
      /**
       * Quarters in 1 year
       *
       * @name quartersInYear
       * @constant
       * @type {number}
       * @default
       */

      var quartersInYear = 4;
      /**
       * Seconds in 1 hour
       *
       * @name secondsInHour
       * @constant
       * @type {number}
       * @default
       */

      var secondsInHour = 3600;
      /**
       * Seconds in 1 minute
       *
       * @name secondsInMinute
       * @constant
       * @type {number}
       * @default
       */

      var secondsInMinute = 60;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = isSameUTCWeek;

      var _index = _interopRequireDefault(__webpack_require__(681));

      var _index2 = _interopRequireDefault(__webpack_require__(63));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
        (0, _index2.default)(2, arguments);
        var dateLeftStartOfWeek = (0, _index.default)(dirtyDateLeft, options);
        var dateRightStartOfWeek = (0, _index.default)(dirtyDateRight, options);
        return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
      }

      module.exports = exports.default;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isValid;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isDate_index_js__ = __webpack_require__(81);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isValid
       * @category Common Helpers
       * @summary Is the given date valid?
       *
       * @description
       * Returns false if argument is Invalid Date and true otherwise.
       * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
       * Invalid Date is a Date, whose time value is NaN.
       *
       * Time value of Date: http://es5.github.io/#x15.9.1.1
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - Now `isValid` doesn't throw an exception
       *   if the first argument is not an instance of Date.
       *   Instead, argument is converted beforehand using `toDate`.
       *
       *   Examples:
       *
       *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
       *   |---------------------------|---------------|---------------|
       *   | `new Date()`              | `true`        | `true`        |
       *   | `new Date('2016-01-01')`  | `true`        | `true`        |
       *   | `new Date('')`            | `false`       | `false`       |
       *   | `new Date(1488370835081)` | `true`        | `true`        |
       *   | `new Date(NaN)`           | `false`       | `false`       |
       *   | `'2016-01-01'`            | `TypeError`   | `false`       |
       *   | `''`                      | `TypeError`   | `false`       |
       *   | `1488370835081`           | `TypeError`   | `true`        |
       *   | `NaN`                     | `TypeError`   | `false`       |
       *
       *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
       *   that try to coerce arguments to the expected type
       *   (which is also the case with other *date-fns* functions).
       *
       * @param {*} date - the date to check
       * @returns {Boolean} the date is valid
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // For the valid date:
       * const result = isValid(new Date(2014, 1, 31))
       * //=> true
       *
       * @example
       * // For the value, convertable into a date:
       * const result = isValid(1393804800000)
       * //=> true
       *
       * @example
       * // For the invalid date:
       * const result = isValid(new Date(''))
       * //=> false
       */


      function isValid(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);

        if (!Object(__WEBPACK_IMPORTED_MODULE_0__isDate_index_js__["a"
        /* default */
        ])(dirtyDate) && typeof dirtyDate !== "number") {
          return false;
        }

        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        return !isNaN(Number(date));
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addDays;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addDays
       * @category Day Helpers
       * @summary Add the specified number of days to the given date.
       *
       * @description
       * Add the specified number of days to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} - the new date with the days added
       * @throws {TypeError} - 2 arguments required
       *
       * @example
       * // Add 10 days to 1 September 2014:
       * const result = addDays(new Date(2014, 8, 1), 10)
       * //=> Thu Sep 11 2014 00:00:00
       */


      function addDays(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);

        if (isNaN(amount)) {
          return new Date(NaN);
        }

        if (!amount) {
          // If 0 days, no-op to avoid changing times in the hour before end of DST
          return date;
        }

        date.setDate(date.getDate() + amount);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getTimezoneOffsetInMilliseconds;
      /**
       * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
       * They usually appear for dates that denote time before the timezones were introduced
       * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
       * and GMT+01:00:00 after that date)
       *
       * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
       * which would lead to incorrect calculations.
       *
       * This function returns the timezone offset in milliseconds that takes seconds in account.
       */

      function getTimezoneOffsetInMilliseconds(date) {
        var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
        utcDate.setUTCFullYear(date.getFullYear());
        return date.getTime() - utcDate.getTime();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfWeek
       * @category Week Helpers
       * @summary Return the start of a week for the given date.
       *
       * @description
       * Return the start of a week for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Date} the start of a week
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // The start of a week for 2 September 2014 11:55:00:
       * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Sun Aug 31 2014 00:00:00
       *
       * @example
       * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
       * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
       * //=> Mon Sep 01 2014 00:00:00
       */


      function startOfWeek(dirtyDate, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ])(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
        }

        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var day = date.getDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setDate(date.getDate() - diff);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = nextDay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(10);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__getDay_index_js__ = __webpack_require__(42);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name nextDay
       * @category Weekday Helpers
       * @summary When is the next day of the week?
       *
       * @description
       * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
       *
       * @param {Date | number} date - the date to check
       * @param {Day} day - day of the week
       * @returns {Date} - the date is the next day of week
       * @throws {TypeError} - 2 arguments required
       *
       * @example
       * // When is the next Monday after Mar, 20, 2020?
       * const result = nextDay(new Date(2020, 2, 20), 1)
       * //=> Mon Mar 23 2020 00:00:00
       *
       * @example
       * // When is the next Tuesday after Mar, 21, 2020?
       * const result = nextDay(new Date(2020, 2, 21), 2)
       * //=> Tue Mar 24 2020 00:00:00
       */


      function nextDay(date, day) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var delta = day - Object(__WEBPACK_IMPORTED_MODULE_1__getDay_index_js__["a"
        /* default */
        ])(date);
        if (delta <= 0) delta += 7;
        return Object(__WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a"
        /* default */
        ])(date, delta);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = previousDay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__getDay_index_js__ = __webpack_require__(42);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__subDays_index_js__ = __webpack_require__(43);
      /**
       * @name previousDay
       * @category Weekday Helpers
       * @summary When is the previous day of the week?
       *
       * @description
       * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
       *
       * @param {Date | number} date - the date to check
       * @param {number} day - day of the week
       * @returns {Date} - the date is the previous day of week
       * @throws {TypeError} - 2 arguments required
       *
       * @example
       * // When is the previous Monday before Mar, 20, 2020?
       * const result = previousDay(new Date(2020, 2, 20), 1)
       * //=> Mon Mar 16 2020 00:00:00
       *
       * @example
       * // When is the previous Tuesday before Mar, 21, 2020?
       * const result = previousDay(new Date(2020, 2, 21), 2)
       * //=> Tue Mar 17 2020 00:00:00
       */


      function previousDay(date, day) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var delta = Object(__WEBPACK_IMPORTED_MODULE_1__getDay_index_js__["a"
        /* default */
        ])(date) - day;
        if (delta <= 0) delta += 7;
        return Object(__WEBPACK_IMPORTED_MODULE_2__subDays_index_js__["a"
        /* default */
        ])(date, delta);
      }
      /***/

    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var formatRelativeLocale = {
        lastWeek: "'last' eeee 'at' p",
        yesterday: "'yesterday at' p",
        today: "'today at' p",
        tomorrow: "'tomorrow at' p",
        nextWeek: "eeee 'at' p",
        other: "P"
      };

      var formatRelative = function (token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      };

      var _default = formatRelative;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["B", "A"],
        abbreviated: ["BC", "AD"],
        wide: ["Before Christ", "Anno Domini"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
      }; // Note: in English, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      };
      var dayValues = {
        narrow: ["S", "M", "T", "W", "T", "F", "S"],
        short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        }
      };

      var ordinalNumber = function (dirtyNumber, _options) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`.
        //
        // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'.

        var rem100 = number % 100;

        if (rem100 > 20 || rem100 < 10) {
          switch (rem100 % 10) {
            case 1:
              return number + "st";

            case 2:
              return number + "nd";

            case 3:
              return number + "rd";
          }
        }

        return number + "th";
      };

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return quarter - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
      };
      var parseEraPatterns = {
        any: [/^b/i, /^(a|c)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__add_index_js__ = __webpack_require__(499);
      /* unused harmony reexport add */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addBusinessDays_index_js__ = __webpack_require__(73);
      /* unused harmony reexport addBusinessDays */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__addDays_index_js__ = __webpack_require__(10);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return __WEBPACK_IMPORTED_MODULE_2__addDays_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__addHours_index_js__ = __webpack_require__(47);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return __WEBPACK_IMPORTED_MODULE_3__addHours_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__addISOWeekYears_index_js__ = __webpack_require__(75);
      /* unused harmony reexport addISOWeekYears */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__addMilliseconds_index_js__ = __webpack_require__(28);
      /* unused harmony reexport addMilliseconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__addMinutes_index_js__ = __webpack_require__(48);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return __WEBPACK_IMPORTED_MODULE_6__addMinutes_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__addMonths_index_js__ = __webpack_require__(27);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return __WEBPACK_IMPORTED_MODULE_7__addMonths_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_8__addQuarters_index_js__ = __webpack_require__(49);
      /* unused harmony reexport addQuarters */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_9__addSeconds_index_js__ = __webpack_require__(77);
      /* unused harmony reexport addSeconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_10__addWeeks_index_js__ = __webpack_require__(36);
      /* unused harmony reexport addWeeks */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_11__addYears_index_js__ = __webpack_require__(78);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "e", function () {
        return __WEBPACK_IMPORTED_MODULE_11__addYears_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_12__areIntervalsOverlapping_index_js__ = __webpack_require__(500);
      /* unused harmony reexport areIntervalsOverlapping */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_13__clamp_index_js__ = __webpack_require__(501);
      /* unused harmony reexport clamp */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_14__closestIndexTo_index_js__ = __webpack_require__(502);
      /* unused harmony reexport closestIndexTo */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_15__closestTo_index_js__ = __webpack_require__(503);
      /* unused harmony reexport closestTo */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_16__compareAsc_index_js__ = __webpack_require__(21);
      /* unused harmony reexport compareAsc */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_17__compareDesc_index_js__ = __webpack_require__(504);
      /* unused harmony reexport compareDesc */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_18__daysToWeeks_index_js__ = __webpack_require__(505);
      /* unused harmony reexport daysToWeeks */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_19__differenceInBusinessDays_index_js__ = __webpack_require__(506);
      /* unused harmony reexport differenceInBusinessDays */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_20__differenceInCalendarDays_index_js__ = __webpack_require__(20);
      /* unused harmony reexport differenceInCalendarDays */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_21__differenceInCalendarISOWeekYears_index_js__ = __webpack_require__(82);
      /* unused harmony reexport differenceInCalendarISOWeekYears */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_22__differenceInCalendarISOWeeks_index_js__ = __webpack_require__(507);
      /* unused harmony reexport differenceInCalendarISOWeeks */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_23__differenceInCalendarMonths_index_js__ = __webpack_require__(83);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "f", function () {
        return __WEBPACK_IMPORTED_MODULE_23__differenceInCalendarMonths_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_24__differenceInCalendarQuarters_index_js__ = __webpack_require__(508);
      /* unused harmony reexport differenceInCalendarQuarters */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_25__differenceInCalendarWeeks_index_js__ = __webpack_require__(85);
      /* unused harmony reexport differenceInCalendarWeeks */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_26__differenceInCalendarYears_index_js__ = __webpack_require__(86);
      /* unused harmony reexport differenceInCalendarYears */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_27__differenceInDays_index_js__ = __webpack_require__(50);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "g", function () {
        return __WEBPACK_IMPORTED_MODULE_27__differenceInDays_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_28__differenceInHours_index_js__ = __webpack_require__(87);
      /* unused harmony reexport differenceInHours */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_29__differenceInISOWeekYears_index_js__ = __webpack_require__(509);
      /* unused harmony reexport differenceInISOWeekYears */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_30__differenceInMilliseconds_index_js__ = __webpack_require__(37);
      /* unused harmony reexport differenceInMilliseconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_31__differenceInMinutes_index_js__ = __webpack_require__(89);
      /* unused harmony reexport differenceInMinutes */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_32__differenceInMonths_index_js__ = __webpack_require__(38);
      /* unused harmony reexport differenceInMonths */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_33__differenceInQuarters_index_js__ = __webpack_require__(510);
      /* unused harmony reexport differenceInQuarters */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_34__differenceInSeconds_index_js__ = __webpack_require__(53);
      /* unused harmony reexport differenceInSeconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_35__differenceInWeeks_index_js__ = __webpack_require__(511);
      /* unused harmony reexport differenceInWeeks */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_36__differenceInYears_index_js__ = __webpack_require__(91);
      /* unused harmony reexport differenceInYears */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_37__eachDayOfInterval_index_js__ = __webpack_require__(92);
      /* unused harmony reexport eachDayOfInterval */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_38__eachHourOfInterval_index_js__ = __webpack_require__(512);
      /* unused harmony reexport eachHourOfInterval */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_39__eachMinuteOfInterval_index_js__ = __webpack_require__(513);
      /* unused harmony reexport eachMinuteOfInterval */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_40__eachMonthOfInterval_index_js__ = __webpack_require__(514);
      /* unused harmony reexport eachMonthOfInterval */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_41__eachQuarterOfInterval_index_js__ = __webpack_require__(515);
      /* unused harmony reexport eachQuarterOfInterval */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_42__eachWeekOfInterval_index_js__ = __webpack_require__(516);
      /* unused harmony reexport eachWeekOfInterval */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_43__eachWeekendOfInterval_index_js__ = __webpack_require__(56);
      /* unused harmony reexport eachWeekendOfInterval */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_44__eachWeekendOfMonth_index_js__ = __webpack_require__(517);
      /* unused harmony reexport eachWeekendOfMonth */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_45__eachWeekendOfYear_index_js__ = __webpack_require__(518);
      /* unused harmony reexport eachWeekendOfYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_46__eachYearOfInterval_index_js__ = __webpack_require__(519);
      /* unused harmony reexport eachYearOfInterval */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_47__endOfDay_index_js__ = __webpack_require__(51);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "h", function () {
        return __WEBPACK_IMPORTED_MODULE_47__endOfDay_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_48__endOfDecade_index_js__ = __webpack_require__(520);
      /* unused harmony reexport endOfDecade */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_49__endOfHour_index_js__ = __webpack_require__(521);
      /* unused harmony reexport endOfHour */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_50__endOfISOWeek_index_js__ = __webpack_require__(522);
      /* unused harmony reexport endOfISOWeek */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_51__endOfISOWeekYear_index_js__ = __webpack_require__(523);
      /* unused harmony reexport endOfISOWeekYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_52__endOfMinute_index_js__ = __webpack_require__(524);
      /* unused harmony reexport endOfMinute */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_53__endOfMonth_index_js__ = __webpack_require__(52);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "i", function () {
        return __WEBPACK_IMPORTED_MODULE_53__endOfMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_54__endOfQuarter_index_js__ = __webpack_require__(525);
      /* unused harmony reexport endOfQuarter */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_55__endOfSecond_index_js__ = __webpack_require__(526);
      /* unused harmony reexport endOfSecond */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_56__endOfToday_index_js__ = __webpack_require__(527);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "j", function () {
        return __WEBPACK_IMPORTED_MODULE_56__endOfToday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_57__endOfTomorrow_index_js__ = __webpack_require__(528);
      /* unused harmony reexport endOfTomorrow */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_58__endOfWeek_index_js__ = __webpack_require__(94);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "k", function () {
        return __WEBPACK_IMPORTED_MODULE_58__endOfWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_59__endOfYear_index_js__ = __webpack_require__(93);
      /* unused harmony reexport endOfYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_60__endOfYesterday_index_js__ = __webpack_require__(529);
      /* unused harmony reexport endOfYesterday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_61__format_index_js__ = __webpack_require__(95);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "l", function () {
        return __WEBPACK_IMPORTED_MODULE_61__format_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_62__formatDistance_index_js__ = __webpack_require__(102);
      /* unused harmony reexport formatDistance */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_63__formatDistanceStrict_index_js__ = __webpack_require__(105);
      /* unused harmony reexport formatDistanceStrict */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_64__formatDistanceToNow_index_js__ = __webpack_require__(543);
      /* unused harmony reexport formatDistanceToNow */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_65__formatDistanceToNowStrict_index_js__ = __webpack_require__(544);
      /* unused harmony reexport formatDistanceToNowStrict */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_66__formatDuration_index_js__ = __webpack_require__(545);
      /* unused harmony reexport formatDuration */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_67__formatISO_index_js__ = __webpack_require__(546);
      /* unused harmony reexport formatISO */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_68__formatISO9075_index_js__ = __webpack_require__(547);
      /* unused harmony reexport formatISO9075 */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_69__formatISODuration_index_js__ = __webpack_require__(548);
      /* unused harmony reexport formatISODuration */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_70__formatRFC3339_index_js__ = __webpack_require__(549);
      /* unused harmony reexport formatRFC3339 */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_71__formatRFC7231_index_js__ = __webpack_require__(550);
      /* unused harmony reexport formatRFC7231 */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_72__formatRelative_index_js__ = __webpack_require__(551);
      /* unused harmony reexport formatRelative */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_73__fromUnixTime_index_js__ = __webpack_require__(552);
      /* unused harmony reexport fromUnixTime */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_74__getDate_index_js__ = __webpack_require__(106);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "m", function () {
        return __WEBPACK_IMPORTED_MODULE_74__getDate_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_75__getDay_index_js__ = __webpack_require__(42);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "n", function () {
        return __WEBPACK_IMPORTED_MODULE_75__getDay_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_76__getDayOfYear_index_js__ = __webpack_require__(553);
      /* unused harmony reexport getDayOfYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_77__getDaysInMonth_index_js__ = __webpack_require__(107);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "o", function () {
        return __WEBPACK_IMPORTED_MODULE_77__getDaysInMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_78__getDaysInYear_index_js__ = __webpack_require__(554);
      /* unused harmony reexport getDaysInYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_79__getDecade_index_js__ = __webpack_require__(555);
      /* unused harmony reexport getDecade */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_80__getHours_index_js__ = __webpack_require__(556);
      /* unused harmony reexport getHours */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_81__getISODay_index_js__ = __webpack_require__(109);
      /* unused harmony reexport getISODay */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_82__getISOWeek_index_js__ = __webpack_require__(110);
      /* unused harmony reexport getISOWeek */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_83__getISOWeekYear_index_js__ = __webpack_require__(23);
      /* unused harmony reexport getISOWeekYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_84__getISOWeeksInYear_index_js__ = __webpack_require__(557);
      /* unused harmony reexport getISOWeeksInYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_85__getMilliseconds_index_js__ = __webpack_require__(558);
      /* unused harmony reexport getMilliseconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_86__getMinutes_index_js__ = __webpack_require__(559);
      /* unused harmony reexport getMinutes */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_87__getMonth_index_js__ = __webpack_require__(560);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "p", function () {
        return __WEBPACK_IMPORTED_MODULE_87__getMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_88__getOverlappingDaysInIntervals_index_js__ = __webpack_require__(561);
      /* unused harmony reexport getOverlappingDaysInIntervals */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_89__getQuarter_index_js__ = __webpack_require__(84);
      /* unused harmony reexport getQuarter */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_90__getSeconds_index_js__ = __webpack_require__(562);
      /* unused harmony reexport getSeconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_91__getTime_index_js__ = __webpack_require__(111);
      /* unused harmony reexport getTime */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_92__getUnixTime_index_js__ = __webpack_require__(563);
      /* unused harmony reexport getUnixTime */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_93__getWeek_index_js__ = __webpack_require__(112);
      /* unused harmony reexport getWeek */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_94__getWeekOfMonth_index_js__ = __webpack_require__(564);
      /* unused harmony reexport getWeekOfMonth */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_95__getWeekYear_index_js__ = __webpack_require__(113);
      /* unused harmony reexport getWeekYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_96__getWeeksInMonth_index_js__ = __webpack_require__(565);
      /* unused harmony reexport getWeeksInMonth */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_97__getYear_index_js__ = __webpack_require__(566);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "q", function () {
        return __WEBPACK_IMPORTED_MODULE_97__getYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_98__hoursToMilliseconds_index_js__ = __webpack_require__(567);
      /* unused harmony reexport hoursToMilliseconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_99__hoursToMinutes_index_js__ = __webpack_require__(568);
      /* unused harmony reexport hoursToMinutes */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_100__hoursToSeconds_index_js__ = __webpack_require__(569);
      /* unused harmony reexport hoursToSeconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_101__intervalToDuration_index_js__ = __webpack_require__(570);
      /* unused harmony reexport intervalToDuration */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_102__intlFormat_index_js__ = __webpack_require__(571);
      /* unused harmony reexport intlFormat */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_103__isAfter_index_js__ = __webpack_require__(572);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "r", function () {
        return __WEBPACK_IMPORTED_MODULE_103__isAfter_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_104__isBefore_index_js__ = __webpack_require__(573);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "s", function () {
        return __WEBPACK_IMPORTED_MODULE_104__isBefore_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_105__isDate_index_js__ = __webpack_require__(81);
      /* unused harmony reexport isDate */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_106__isEqual_index_js__ = __webpack_require__(574);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "t", function () {
        return __WEBPACK_IMPORTED_MODULE_106__isEqual_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_107__isExists_index_js__ = __webpack_require__(575);
      /* unused harmony reexport isExists */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_108__isFirstDayOfMonth_index_js__ = __webpack_require__(576);
      /* unused harmony reexport isFirstDayOfMonth */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_109__isFriday_index_js__ = __webpack_require__(577);
      /* unused harmony reexport isFriday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_110__isFuture_index_js__ = __webpack_require__(578);
      /* unused harmony reexport isFuture */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_111__isLastDayOfMonth_index_js__ = __webpack_require__(90);
      /* unused harmony reexport isLastDayOfMonth */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_112__isLeapYear_index_js__ = __webpack_require__(108);
      /* unused harmony reexport isLeapYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_113__isMatch_index_js__ = __webpack_require__(579);
      /* unused harmony reexport isMatch */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_114__isMonday_index_js__ = __webpack_require__(585);
      /* unused harmony reexport isMonday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_115__isPast_index_js__ = __webpack_require__(586);
      /* unused harmony reexport isPast */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_116__isSameDay_index_js__ = __webpack_require__(30);
      /* unused harmony reexport isSameDay */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_117__isSameHour_index_js__ = __webpack_require__(118);
      /* unused harmony reexport isSameHour */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_118__isSameISOWeek_index_js__ = __webpack_require__(120);
      /* unused harmony reexport isSameISOWeek */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_119__isSameISOWeekYear_index_js__ = __webpack_require__(587);
      /* unused harmony reexport isSameISOWeekYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_120__isSameMinute_index_js__ = __webpack_require__(121);
      /* unused harmony reexport isSameMinute */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_121__isSameMonth_index_js__ = __webpack_require__(122);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "u", function () {
        return __WEBPACK_IMPORTED_MODULE_121__isSameMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_122__isSameQuarter_index_js__ = __webpack_require__(123);
      /* unused harmony reexport isSameQuarter */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_123__isSameSecond_index_js__ = __webpack_require__(124);
      /* unused harmony reexport isSameSecond */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_124__isSameWeek_index_js__ = __webpack_require__(60);
      /* unused harmony reexport isSameWeek */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_125__isSameYear_index_js__ = __webpack_require__(126);
      /* unused harmony reexport isSameYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_126__isSaturday_index_js__ = __webpack_require__(74);
      /* unused harmony reexport isSaturday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_127__isSunday_index_js__ = __webpack_require__(46);
      /* unused harmony reexport isSunday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_128__isThisHour_index_js__ = __webpack_require__(588);
      /* unused harmony reexport isThisHour */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_129__isThisISOWeek_index_js__ = __webpack_require__(589);
      /* unused harmony reexport isThisISOWeek */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_130__isThisMinute_index_js__ = __webpack_require__(590);
      /* unused harmony reexport isThisMinute */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_131__isThisMonth_index_js__ = __webpack_require__(591);
      /* unused harmony reexport isThisMonth */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_132__isThisQuarter_index_js__ = __webpack_require__(592);
      /* unused harmony reexport isThisQuarter */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_133__isThisSecond_index_js__ = __webpack_require__(593);
      /* unused harmony reexport isThisSecond */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_134__isThisWeek_index_js__ = __webpack_require__(594);
      /* unused harmony reexport isThisWeek */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_135__isThisYear_index_js__ = __webpack_require__(595);
      /* unused harmony reexport isThisYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_136__isThursday_index_js__ = __webpack_require__(596);
      /* unused harmony reexport isThursday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_137__isToday_index_js__ = __webpack_require__(597);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "v", function () {
        return __WEBPACK_IMPORTED_MODULE_137__isToday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_138__isTomorrow_index_js__ = __webpack_require__(598);
      /* unused harmony reexport isTomorrow */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_139__isTuesday_index_js__ = __webpack_require__(599);
      /* unused harmony reexport isTuesday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_140__isValid_index_js__ = __webpack_require__(9);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "w", function () {
        return __WEBPACK_IMPORTED_MODULE_140__isValid_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_141__isWednesday_index_js__ = __webpack_require__(600);
      /* unused harmony reexport isWednesday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_142__isWeekend_index_js__ = __webpack_require__(34);
      /* unused harmony reexport isWeekend */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_143__isWithinInterval_index_js__ = __webpack_require__(601);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "x", function () {
        return __WEBPACK_IMPORTED_MODULE_143__isWithinInterval_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_144__isYesterday_index_js__ = __webpack_require__(602);
      /* unused harmony reexport isYesterday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_145__lastDayOfDecade_index_js__ = __webpack_require__(603);
      /* unused harmony reexport lastDayOfDecade */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_146__lastDayOfISOWeek_index_js__ = __webpack_require__(604);
      /* unused harmony reexport lastDayOfISOWeek */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_147__lastDayOfISOWeekYear_index_js__ = __webpack_require__(605);
      /* unused harmony reexport lastDayOfISOWeekYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_148__lastDayOfMonth_index_js__ = __webpack_require__(114);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "y", function () {
        return __WEBPACK_IMPORTED_MODULE_148__lastDayOfMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_149__lastDayOfQuarter_index_js__ = __webpack_require__(606);
      /* unused harmony reexport lastDayOfQuarter */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_150__lastDayOfWeek_index_js__ = __webpack_require__(127);
      /* unused harmony reexport lastDayOfWeek */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_151__lastDayOfYear_index_js__ = __webpack_require__(607);
      /* unused harmony reexport lastDayOfYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_152__lightFormat_index_js__ = __webpack_require__(608);
      /* unused harmony reexport lightFormat */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_153__max_index_js__ = __webpack_require__(79);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "z", function () {
        return __WEBPACK_IMPORTED_MODULE_153__max_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_154__milliseconds_index_js__ = __webpack_require__(609);
      /* unused harmony reexport milliseconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_155__millisecondsToHours_index_js__ = __webpack_require__(610);
      /* unused harmony reexport millisecondsToHours */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_156__millisecondsToMinutes_index_js__ = __webpack_require__(611);
      /* unused harmony reexport millisecondsToMinutes */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_157__millisecondsToSeconds_index_js__ = __webpack_require__(612);
      /* unused harmony reexport millisecondsToSeconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_158__min_index_js__ = __webpack_require__(80);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "A", function () {
        return __WEBPACK_IMPORTED_MODULE_158__min_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_159__minutesToHours_index_js__ = __webpack_require__(613);
      /* unused harmony reexport minutesToHours */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_160__minutesToMilliseconds_index_js__ = __webpack_require__(614);
      /* unused harmony reexport minutesToMilliseconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_161__minutesToSeconds_index_js__ = __webpack_require__(615);
      /* unused harmony reexport minutesToSeconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_162__monthsToQuarters_index_js__ = __webpack_require__(616);
      /* unused harmony reexport monthsToQuarters */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_163__monthsToYears_index_js__ = __webpack_require__(617);
      /* unused harmony reexport monthsToYears */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_164__nextDay_index_js__ = __webpack_require__(13);
      /* unused harmony reexport nextDay */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_165__nextFriday_index_js__ = __webpack_require__(618);
      /* unused harmony reexport nextFriday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_166__nextMonday_index_js__ = __webpack_require__(619);
      /* unused harmony reexport nextMonday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_167__nextSaturday_index_js__ = __webpack_require__(620);
      /* unused harmony reexport nextSaturday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_168__nextSunday_index_js__ = __webpack_require__(621);
      /* unused harmony reexport nextSunday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_169__nextThursday_index_js__ = __webpack_require__(622);
      /* unused harmony reexport nextThursday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_170__nextTuesday_index_js__ = __webpack_require__(623);
      /* unused harmony reexport nextTuesday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_171__nextWednesday_index_js__ = __webpack_require__(624);
      /* unused harmony reexport nextWednesday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_172__parse_index_js__ = __webpack_require__(117);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "B", function () {
        return __WEBPACK_IMPORTED_MODULE_172__parse_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_173__parseISO_index_js__ = __webpack_require__(625);
      /* unused harmony reexport parseISO */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_174__parseJSON_index_js__ = __webpack_require__(626);
      /* unused harmony reexport parseJSON */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_175__previousDay_index_js__ = __webpack_require__(14);
      /* unused harmony reexport previousDay */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_176__previousFriday_index_js__ = __webpack_require__(627);
      /* unused harmony reexport previousFriday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_177__previousMonday_index_js__ = __webpack_require__(628);
      /* unused harmony reexport previousMonday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_178__previousSaturday_index_js__ = __webpack_require__(629);
      /* unused harmony reexport previousSaturday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_179__previousSunday_index_js__ = __webpack_require__(630);
      /* unused harmony reexport previousSunday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_180__previousThursday_index_js__ = __webpack_require__(631);
      /* unused harmony reexport previousThursday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_181__previousTuesday_index_js__ = __webpack_require__(632);
      /* unused harmony reexport previousTuesday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_182__previousWednesday_index_js__ = __webpack_require__(633);
      /* unused harmony reexport previousWednesday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_183__quartersToMonths_index_js__ = __webpack_require__(634);
      /* unused harmony reexport quartersToMonths */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_184__quartersToYears_index_js__ = __webpack_require__(635);
      /* unused harmony reexport quartersToYears */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_185__roundToNearestMinutes_index_js__ = __webpack_require__(636);
      /* unused harmony reexport roundToNearestMinutes */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_186__secondsToHours_index_js__ = __webpack_require__(637);
      /* unused harmony reexport secondsToHours */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_187__secondsToMilliseconds_index_js__ = __webpack_require__(638);
      /* unused harmony reexport secondsToMilliseconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_188__secondsToMinutes_index_js__ = __webpack_require__(639);
      /* unused harmony reexport secondsToMinutes */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_189__set_index_js__ = __webpack_require__(640);
      /* unused harmony reexport set */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_190__setDate_index_js__ = __webpack_require__(641);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "C", function () {
        return __WEBPACK_IMPORTED_MODULE_190__setDate_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_191__setDay_index_js__ = __webpack_require__(642);
      /* unused harmony reexport setDay */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_192__setDayOfYear_index_js__ = __webpack_require__(643);
      /* unused harmony reexport setDayOfYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_193__setHours_index_js__ = __webpack_require__(644);
      /* unused harmony reexport setHours */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_194__setISODay_index_js__ = __webpack_require__(645);
      /* unused harmony reexport setISODay */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_195__setISOWeek_index_js__ = __webpack_require__(646);
      /* unused harmony reexport setISOWeek */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_196__setISOWeekYear_index_js__ = __webpack_require__(76);
      /* unused harmony reexport setISOWeekYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_197__setMilliseconds_index_js__ = __webpack_require__(647);
      /* unused harmony reexport setMilliseconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_198__setMinutes_index_js__ = __webpack_require__(648);
      /* unused harmony reexport setMinutes */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_199__setMonth_index_js__ = __webpack_require__(61);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "D", function () {
        return __WEBPACK_IMPORTED_MODULE_199__setMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_200__setQuarter_index_js__ = __webpack_require__(649);
      /* unused harmony reexport setQuarter */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_201__setSeconds_index_js__ = __webpack_require__(650);
      /* unused harmony reexport setSeconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_202__setWeek_index_js__ = __webpack_require__(651);
      /* unused harmony reexport setWeek */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_203__setWeekYear_index_js__ = __webpack_require__(652);
      /* unused harmony reexport setWeekYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_204__setYear_index_js__ = __webpack_require__(653);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "E", function () {
        return __WEBPACK_IMPORTED_MODULE_204__setYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_205__startOfDay_index_js__ = __webpack_require__(35);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "F", function () {
        return __WEBPACK_IMPORTED_MODULE_205__startOfDay_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_206__startOfDecade_index_js__ = __webpack_require__(654);
      /* unused harmony reexport startOfDecade */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_207__startOfHour_index_js__ = __webpack_require__(119);
      /* unused harmony reexport startOfHour */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_208__startOfISOWeek_index_js__ = __webpack_require__(19);
      /* unused harmony reexport startOfISOWeek */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_209__startOfISOWeekYear_index_js__ = __webpack_require__(29);
      /* unused harmony reexport startOfISOWeekYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_210__startOfMinute_index_js__ = __webpack_require__(54);
      /* unused harmony reexport startOfMinute */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_211__startOfMonth_index_js__ = __webpack_require__(39);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "G", function () {
        return __WEBPACK_IMPORTED_MODULE_211__startOfMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_212__startOfQuarter_index_js__ = __webpack_require__(55);
      /* unused harmony reexport startOfQuarter */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_213__startOfSecond_index_js__ = __webpack_require__(125);
      /* unused harmony reexport startOfSecond */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_214__startOfToday_index_js__ = __webpack_require__(655);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "H", function () {
        return __WEBPACK_IMPORTED_MODULE_214__startOfToday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_215__startOfTomorrow_index_js__ = __webpack_require__(656);
      /* unused harmony reexport startOfTomorrow */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_216__startOfWeek_index_js__ = __webpack_require__(12);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "I", function () {
        return __WEBPACK_IMPORTED_MODULE_216__startOfWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_217__startOfWeekYear_index_js__ = __webpack_require__(59);
      /* unused harmony reexport startOfWeekYear */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_218__startOfYear_index_js__ = __webpack_require__(57);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "J", function () {
        return __WEBPACK_IMPORTED_MODULE_218__startOfYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_219__startOfYesterday_index_js__ = __webpack_require__(657);
      /* unused harmony reexport startOfYesterday */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_220__sub_index_js__ = __webpack_require__(115);
      /* unused harmony reexport sub */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_221__subBusinessDays_index_js__ = __webpack_require__(658);
      /* unused harmony reexport subBusinessDays */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_222__subDays_index_js__ = __webpack_require__(43);
      /* unused harmony reexport subDays */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_223__subHours_index_js__ = __webpack_require__(659);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "K", function () {
        return __WEBPACK_IMPORTED_MODULE_223__subHours_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_224__subISOWeekYears_index_js__ = __webpack_require__(88);
      /* unused harmony reexport subISOWeekYears */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_225__subMilliseconds_index_js__ = __webpack_require__(32);
      /* unused harmony reexport subMilliseconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_226__subMinutes_index_js__ = __webpack_require__(660);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "L", function () {
        return __WEBPACK_IMPORTED_MODULE_226__subMinutes_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_227__subMonths_index_js__ = __webpack_require__(116);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "M", function () {
        return __WEBPACK_IMPORTED_MODULE_227__subMonths_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_228__subQuarters_index_js__ = __webpack_require__(661);
      /* unused harmony reexport subQuarters */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_229__subSeconds_index_js__ = __webpack_require__(662);
      /* unused harmony reexport subSeconds */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_230__subWeeks_index_js__ = __webpack_require__(663);
      /* unused harmony reexport subWeeks */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_231__subYears_index_js__ = __webpack_require__(664);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "N", function () {
        return __WEBPACK_IMPORTED_MODULE_231__subYears_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_232__toDate_index_js__ = __webpack_require__(1);
      /* unused harmony reexport toDate */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_233__weeksToDays_index_js__ = __webpack_require__(665);
      /* unused harmony reexport weeksToDays */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_234__yearsToMonths_index_js__ = __webpack_require__(666);
      /* unused harmony reexport yearsToMonths */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_235__yearsToQuarters_index_js__ = __webpack_require__(667);
      /* unused harmony reexport yearsToQuarters */

      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_236__constants_index_js__ = __webpack_require__(7);
      /* unused harmony namespace reexport */
      // This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(12);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfISOWeek
       * @category ISO Week Helpers
       * @summary Return the start of an ISO week for the given date.
       *
       * @description
       * Return the start of an ISO week for the given date.
       * The result will be in the local timezone.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of an ISO week
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of an ISO week for 2 September 2014 11:55:00:
       * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Mon Sep 01 2014 00:00:00
       */


      function startOfISOWeek(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ])(dirtyDate, {
          weekStartsOn: 1
        });
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInCalendarDays;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(11);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__ = __webpack_require__(35);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_DAY = 86400000;
      /**
       * @name differenceInCalendarDays
       * @category Day Helpers
       * @summary Get the number of calendar days between the given dates.
       *
       * @description
       * Get the number of calendar days between the given dates. This means that the times are removed
       * from the dates and then the difference in days is calculated.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of calendar days
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many calendar days are between
       * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
       * const result = differenceInCalendarDays(
       *   new Date(2012, 6, 2, 0, 0),
       *   new Date(2011, 6, 2, 23, 0)
       * )
       * //=> 366
       * // How many calendar days are between
       * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
       * const result = differenceInCalendarDays(
       *   new Date(2011, 6, 3, 0, 1),
       *   new Date(2011, 6, 2, 23, 59)
       * )
       * //=> 1
       */

      function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var startOfDayLeft = Object(__WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var startOfDayRight = Object(__WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        var timestampLeft = startOfDayLeft.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(startOfDayLeft);
        var timestampRight = startOfDayRight.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(startOfDayRight); // Round the number of days to the nearest integer
        // because the number of milliseconds in a day is not constant
        // (e.g. it's different in the day of the daylight saving time clock shift)

        return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = compareAsc;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name compareAsc
       * @category Common Helpers
       * @summary Compare the two dates and return -1, 0 or 1.
       *
       * @description
       * Compare the two dates and return 1 if the first date is after the second,
       * -1 if the first date is before the second or 0 if dates are equal.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to compare
       * @param {Date|Number} dateRight - the second date to compare
       * @returns {Number} the result of the comparison
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Compare 11 February 1987 and 10 July 1989:
       * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
       * //=> -1
       *
       * @example
       * // Sort the array of dates:
       * const result = [
       *   new Date(1995, 6, 2),
       *   new Date(1987, 1, 11),
       *   new Date(1989, 6, 10)
       * ].sort(compareAsc)
       * //=> [
       * //   Wed Feb 11 1987 00:00:00,
       * //   Mon Jul 10 1989 00:00:00,
       * //   Sun Jul 02 1995 00:00:00
       * // ]
       */


      function compareAsc(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        var diff = dateLeft.getTime() - dateRight.getTime();

        if (diff < 0) {
          return -1;
        } else if (diff > 0) {
          return 1; // Return 0 if diff is 0; return NaN if diff is NaN
        } else {
          return diff;
        }
      }
      /***/

    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "less than a second",
          other: "less than {{count}} seconds"
        },
        xSeconds: {
          one: "1 second",
          other: "{{count}} seconds"
        },
        halfAMinute: "half a minute",
        lessThanXMinutes: {
          one: "less than a minute",
          other: "less than {{count}} minutes"
        },
        xMinutes: {
          one: "1 minute",
          other: "{{count}} minutes"
        },
        aboutXHours: {
          one: "about 1 hour",
          other: "about {{count}} hours"
        },
        xHours: {
          one: "1 hour",
          other: "{{count}} hours"
        },
        xDays: {
          one: "1 day",
          other: "{{count}} days"
        },
        aboutXWeeks: {
          one: "about 1 week",
          other: "about {{count}} weeks"
        },
        xWeeks: {
          one: "1 week",
          other: "{{count}} weeks"
        },
        aboutXMonths: {
          one: "about 1 month",
          other: "about {{count}} months"
        },
        xMonths: {
          one: "1 month",
          other: "{{count}} months"
        },
        aboutXYears: {
          one: "about 1 year",
          other: "about {{count}} years"
        },
        xYears: {
          one: "1 year",
          other: "{{count}} years"
        },
        overXYears: {
          one: "over 1 year",
          other: "over {{count}} years"
        },
        almostXYears: {
          one: "almost 1 year",
          other: "almost {{count}} years"
        }
      };

      var formatDistance = function (token, count, options) {
        var result;
        var tokenValue = formatDistanceLocale[token];

        if (typeof tokenValue === "string") {
          result = tokenValue;
        } else if (count === 1) {
          result = tokenValue.one;
        } else {
          result = tokenValue.other.replace("{{count}}", count.toString());
        }

        if (options !== null && options !== void 0 && options.addSuffix) {
          if (options.comparison && options.comparison > 0) {
            return "in " + result;
          } else {
            return result + " ago";
          }
        }

        return result;
      };

      var _default = formatDistance;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getISOWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getISOWeekYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Get the ISO week-numbering year of the given date.
       *
       * @description
       * Get the ISO week-numbering year of the given date,
       * which always starts 3 days before the year's first Thursday.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `getISOYear` to `getISOWeekYear`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the ISO week-numbering year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which ISO-week numbering year is 2 January 2005?
       * const result = getISOWeekYear(new Date(2005, 0, 2))
       * //=> 2004
       */


      function getISOWeekYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var year = date.getFullYear();
        var fourthOfJanuaryOfNextYear = new Date(0);
        fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
        fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
        var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ])(fourthOfJanuaryOfNextYear);
        var fourthOfJanuaryOfThisYear = new Date(0);
        fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
        fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
        var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ])(fourthOfJanuaryOfThisYear);

        if (date.getTime() >= startOfNextYear.getTime()) {
          return year + 1;
        } else if (date.getTime() >= startOfThisYear.getTime()) {
          return year;
        } else {
          return year - 1;
        }
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(530);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(531);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(533);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(534);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(536);
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (United States).
       * @language English
       * @iso-639-2 eng
       * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
       * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
       */


      var locale = {
        code: "en-US",
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addLeadingZeros;

      function addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? "-" : "";
        var output = Math.abs(number).toString();

        while (output.length < targetLength) {
          output = "0" + output;
        }

        return sign + output;
      }
      /***/

    }, function (module, exports, __webpack_require__) {
      var map = {
        "./_lib/buildFormatLongFn/index.js": 2,
        "./_lib/buildLocalizeFn/index.js": 3,
        "./_lib/buildMatchFn/index.js": 4,
        "./_lib/buildMatchPatternFn/index.js": 5,
        "./af/_lib/formatDistance/index.js": 128,
        "./af/_lib/formatLong/index.js": 129,
        "./af/_lib/formatRelative/index.js": 130,
        "./af/_lib/localize/index.js": 131,
        "./af/_lib/match/index.js": 132,
        "./af/index.js": 675,
        "./ar-DZ/_lib/formatDistance/index.js": 133,
        "./ar-DZ/_lib/formatLong/index.js": 134,
        "./ar-DZ/_lib/formatRelative/index.js": 135,
        "./ar-DZ/_lib/localize/index.js": 136,
        "./ar-DZ/_lib/match/index.js": 137,
        "./ar-DZ/index.js": 676,
        "./ar-MA/_lib/formatDistance/index.js": 138,
        "./ar-MA/_lib/formatLong/index.js": 139,
        "./ar-MA/_lib/formatRelative/index.js": 140,
        "./ar-MA/_lib/localize/index.js": 141,
        "./ar-MA/_lib/match/index.js": 142,
        "./ar-MA/index.js": 677,
        "./ar-SA/_lib/formatDistance/index.js": 143,
        "./ar-SA/_lib/formatLong/index.js": 144,
        "./ar-SA/_lib/formatRelative/index.js": 145,
        "./ar-SA/_lib/localize/index.js": 146,
        "./ar-SA/_lib/match/index.js": 147,
        "./ar-SA/index.js": 678,
        "./ar-TN/_lib/formatDistance/index.js": 148,
        "./ar-TN/_lib/formatLong/index.js": 149,
        "./ar-TN/_lib/formatRelative/index.js": 150,
        "./ar-TN/_lib/localize/index.js": 151,
        "./ar-TN/_lib/match/index.js": 152,
        "./ar-TN/index.js": 679,
        "./az/_lib/formatDistance/index.js": 153,
        "./az/_lib/formatLong/index.js": 154,
        "./az/_lib/formatRelative/index.js": 155,
        "./az/_lib/localize/index.js": 156,
        "./az/_lib/match/index.js": 157,
        "./az/index.js": 680,
        "./be/_lib/formatDistance/index.js": 158,
        "./be/_lib/formatLong/index.js": 159,
        "./be/_lib/formatRelative/index.js": 160,
        "./be/_lib/localize/index.js": 161,
        "./be/_lib/match/index.js": 162,
        "./be/index.js": 684,
        "./bg/_lib/formatDistance/index.js": 163,
        "./bg/_lib/formatLong/index.js": 164,
        "./bg/_lib/formatRelative/index.js": 165,
        "./bg/_lib/localize/index.js": 166,
        "./bg/_lib/match/index.js": 167,
        "./bg/index.js": 685,
        "./bn/_lib/formatDistance/index.js": 168,
        "./bn/_lib/formatLong/index.js": 169,
        "./bn/_lib/formatRelative/index.js": 170,
        "./bn/_lib/localize/index.js": 64,
        "./bn/_lib/match/index.js": 171,
        "./bn/index.js": 686,
        "./bs/_lib/formatDistance/index.js": 172,
        "./bs/_lib/formatLong/index.js": 173,
        "./bs/_lib/formatRelative/index.js": 174,
        "./bs/_lib/localize/index.js": 175,
        "./bs/_lib/match/index.js": 176,
        "./bs/index.js": 687,
        "./ca/_lib/formatDistance/index.js": 177,
        "./ca/_lib/formatLong/index.js": 178,
        "./ca/_lib/formatRelative/index.js": 179,
        "./ca/_lib/localize/index.js": 180,
        "./ca/_lib/match/index.js": 181,
        "./ca/index.js": 688,
        "./cs/_lib/formatDistance/index.js": 182,
        "./cs/_lib/formatLong/index.js": 183,
        "./cs/_lib/formatRelative/index.js": 184,
        "./cs/_lib/localize/index.js": 185,
        "./cs/_lib/match/index.js": 186,
        "./cs/index.js": 689,
        "./cy/_lib/formatDistance/index.js": 187,
        "./cy/_lib/formatLong/index.js": 188,
        "./cy/_lib/formatRelative/index.js": 189,
        "./cy/_lib/localize/index.js": 190,
        "./cy/_lib/match/index.js": 191,
        "./cy/index.js": 690,
        "./da/_lib/formatDistance/index.js": 192,
        "./da/_lib/formatLong/index.js": 193,
        "./da/_lib/formatRelative/index.js": 194,
        "./da/_lib/localize/index.js": 195,
        "./da/_lib/match/index.js": 196,
        "./da/index.js": 691,
        "./de-AT/_lib/localize/index.js": 197,
        "./de-AT/index.js": 692,
        "./de/_lib/formatDistance/index.js": 65,
        "./de/_lib/formatLong/index.js": 66,
        "./de/_lib/formatRelative/index.js": 67,
        "./de/_lib/localize/index.js": 198,
        "./de/_lib/match/index.js": 68,
        "./de/index.js": 693,
        "./el/_lib/formatDistance/index.js": 199,
        "./el/_lib/formatLong/index.js": 200,
        "./el/_lib/formatRelative/index.js": 201,
        "./el/_lib/localize/index.js": 202,
        "./el/_lib/match/index.js": 203,
        "./el/index.js": 694,
        "./en-AU/_lib/formatLong/index.js": 204,
        "./en-AU/index.js": 695,
        "./en-CA/_lib/formatDistance/index.js": 205,
        "./en-CA/_lib/formatLong/index.js": 206,
        "./en-CA/index.js": 696,
        "./en-GB/_lib/formatLong/index.js": 207,
        "./en-GB/index.js": 697,
        "./en-IN/_lib/formatLong/index.js": 208,
        "./en-IN/index.js": 698,
        "./en-NZ/_lib/formatLong/index.js": 209,
        "./en-NZ/index.js": 699,
        "./en-US/_lib/formatDistance/index.js": 22,
        "./en-US/_lib/formatLong/index.js": 210,
        "./en-US/_lib/formatRelative/index.js": 15,
        "./en-US/_lib/localize/index.js": 16,
        "./en-US/_lib/match/index.js": 17,
        "./en-US/index.js": 700,
        "./en-ZA/_lib/formatLong/index.js": 211,
        "./en-ZA/index.js": 701,
        "./eo/_lib/formatDistance/index.js": 212,
        "./eo/_lib/formatLong/index.js": 213,
        "./eo/_lib/formatRelative/index.js": 214,
        "./eo/_lib/localize/index.js": 215,
        "./eo/_lib/match/index.js": 216,
        "./eo/index.js": 702,
        "./es/_lib/formatDistance/index.js": 217,
        "./es/_lib/formatLong/index.js": 218,
        "./es/_lib/formatRelative/index.js": 219,
        "./es/_lib/localize/index.js": 220,
        "./es/_lib/match/index.js": 221,
        "./es/index.js": 703,
        "./et/_lib/formatDistance/index.js": 222,
        "./et/_lib/formatLong/index.js": 223,
        "./et/_lib/formatRelative/index.js": 224,
        "./et/_lib/localize/index.js": 225,
        "./et/_lib/match/index.js": 226,
        "./et/index.js": 704,
        "./eu/_lib/formatDistance/index.js": 227,
        "./eu/_lib/formatLong/index.js": 228,
        "./eu/_lib/formatRelative/index.js": 229,
        "./eu/_lib/localize/index.js": 230,
        "./eu/_lib/match/index.js": 231,
        "./eu/index.js": 705,
        "./fa-IR/_lib/formatDistance/index.js": 232,
        "./fa-IR/_lib/formatLong/index.js": 233,
        "./fa-IR/_lib/formatRelative/index.js": 234,
        "./fa-IR/_lib/localize/index.js": 235,
        "./fa-IR/_lib/match/index.js": 236,
        "./fa-IR/index.js": 706,
        "./fi/_lib/formatDistance/index.js": 237,
        "./fi/_lib/formatLong/index.js": 238,
        "./fi/_lib/formatRelative/index.js": 239,
        "./fi/_lib/localize/index.js": 240,
        "./fi/_lib/match/index.js": 241,
        "./fi/index.js": 707,
        "./fr-CA/_lib/formatLong/index.js": 242,
        "./fr-CA/index.js": 708,
        "./fr-CH/_lib/formatDistance/index.js": 243,
        "./fr-CH/_lib/formatLong/index.js": 244,
        "./fr-CH/_lib/formatRelative/index.js": 245,
        "./fr-CH/_lib/formatters/index.js": 709,
        "./fr-CH/_lib/localize/index.js": 246,
        "./fr-CH/_lib/match/index.js": 247,
        "./fr-CH/index.js": 710,
        "./fr/_lib/formatDistance/index.js": 69,
        "./fr/_lib/formatLong/index.js": 248,
        "./fr/_lib/formatRelative/index.js": 70,
        "./fr/_lib/formatters/index.js": 711,
        "./fr/_lib/localize/index.js": 71,
        "./fr/_lib/match/index.js": 72,
        "./fr/index.js": 712,
        "./gd/_lib/formatDistance/index.js": 249,
        "./gd/_lib/formatLong/index.js": 250,
        "./gd/_lib/formatRelative/index.js": 251,
        "./gd/_lib/localize/index.js": 252,
        "./gd/_lib/match/index.js": 253,
        "./gd/index.js": 713,
        "./gl/_lib/formatDistance/index.js": 254,
        "./gl/_lib/formatLong/index.js": 255,
        "./gl/_lib/formatRelative/index.js": 256,
        "./gl/_lib/localize/index.js": 257,
        "./gl/_lib/match/index.js": 258,
        "./gl/index.js": 714,
        "./gu/_lib/formatDistance/index.js": 259,
        "./gu/_lib/formatLong/index.js": 260,
        "./gu/_lib/formatRelative/index.js": 261,
        "./gu/_lib/localize/index.js": 262,
        "./gu/_lib/match/index.js": 263,
        "./gu/index.js": 715,
        "./he/_lib/formatDistance/index.js": 264,
        "./he/_lib/formatLong/index.js": 265,
        "./he/_lib/formatRelative/index.js": 266,
        "./he/_lib/localize/index.js": 267,
        "./he/_lib/match/index.js": 268,
        "./he/index.js": 716,
        "./hi/_lib/formatDistance/index.js": 269,
        "./hi/_lib/formatLong/index.js": 270,
        "./hi/_lib/formatRelative/index.js": 271,
        "./hi/_lib/localize/index.js": 44,
        "./hi/_lib/match/index.js": 272,
        "./hi/index.js": 717,
        "./hr/_lib/formatDistance/index.js": 273,
        "./hr/_lib/formatLong/index.js": 274,
        "./hr/_lib/formatRelative/index.js": 275,
        "./hr/_lib/localize/index.js": 276,
        "./hr/_lib/match/index.js": 277,
        "./hr/index.js": 718,
        "./ht/_lib/formatDistance/index.js": 278,
        "./ht/_lib/formatLong/index.js": 279,
        "./ht/_lib/formatRelative/index.js": 280,
        "./ht/_lib/formatters/index.js": 719,
        "./ht/_lib/localize/index.js": 281,
        "./ht/_lib/match/index.js": 282,
        "./ht/index.js": 720,
        "./hu/_lib/formatDistance/index.js": 283,
        "./hu/_lib/formatLong/index.js": 284,
        "./hu/_lib/formatRelative/index.js": 285,
        "./hu/_lib/localize/index.js": 286,
        "./hu/_lib/match/index.js": 287,
        "./hu/index.js": 721,
        "./hy/_lib/formatDistance/index.js": 288,
        "./hy/_lib/formatLong/index.js": 289,
        "./hy/_lib/formatRelative/index.js": 290,
        "./hy/_lib/localize/index.js": 291,
        "./hy/_lib/match/index.js": 292,
        "./hy/index.js": 722,
        "./id/_lib/formatDistance/index.js": 293,
        "./id/_lib/formatLong/index.js": 294,
        "./id/_lib/formatRelative/index.js": 295,
        "./id/_lib/localize/index.js": 296,
        "./id/_lib/match/index.js": 297,
        "./id/index.js": 723,
        "./is/_lib/formatDistance/index.js": 298,
        "./is/_lib/formatLong/index.js": 299,
        "./is/_lib/formatRelative/index.js": 300,
        "./is/_lib/localize/index.js": 301,
        "./is/_lib/match/index.js": 302,
        "./is/index.js": 724,
        "./it/_lib/formatDistance/index.js": 303,
        "./it/_lib/formatLong/index.js": 304,
        "./it/_lib/formatRelative/index.js": 305,
        "./it/_lib/localize/index.js": 306,
        "./it/_lib/match/index.js": 307,
        "./it/index.js": 725,
        "./ja-Hira/_lib/formatDistance/index.js": 308,
        "./ja-Hira/_lib/formatLong/index.js": 309,
        "./ja-Hira/_lib/formatRelative/index.js": 310,
        "./ja-Hira/_lib/localize/index.js": 311,
        "./ja-Hira/_lib/match/index.js": 312,
        "./ja-Hira/index.js": 726,
        "./ja/_lib/formatDistance/index.js": 313,
        "./ja/_lib/formatLong/index.js": 314,
        "./ja/_lib/formatRelative/index.js": 315,
        "./ja/_lib/localize/index.js": 316,
        "./ja/_lib/match/index.js": 317,
        "./ja/index.js": 727,
        "./ka/_lib/formatDistance/index.js": 318,
        "./ka/_lib/formatLong/index.js": 319,
        "./ka/_lib/formatRelative/index.js": 320,
        "./ka/_lib/localize/index.js": 321,
        "./ka/_lib/match/index.js": 322,
        "./ka/index.js": 728,
        "./kk/_lib/formatDistance/index.js": 323,
        "./kk/_lib/formatLong/index.js": 324,
        "./kk/_lib/formatRelative/index.js": 325,
        "./kk/_lib/localize/index.js": 326,
        "./kk/_lib/match/index.js": 327,
        "./kk/index.js": 729,
        "./kn/_lib/formatDistance/index.js": 328,
        "./kn/_lib/formatLong/index.js": 329,
        "./kn/_lib/formatRelative/index.js": 330,
        "./kn/_lib/localize/index.js": 331,
        "./kn/_lib/match/index.js": 332,
        "./kn/index.js": 730,
        "./ko/_lib/formatDistance/index.js": 333,
        "./ko/_lib/formatLong/index.js": 334,
        "./ko/_lib/formatRelative/index.js": 335,
        "./ko/_lib/localize/index.js": 336,
        "./ko/_lib/match/index.js": 337,
        "./ko/index.js": 731,
        "./lb/_lib/formatDistance/index.js": 338,
        "./lb/_lib/formatLong/index.js": 339,
        "./lb/_lib/formatRelative/index.js": 340,
        "./lb/_lib/localize/index.js": 341,
        "./lb/_lib/match/index.js": 342,
        "./lb/index.js": 732,
        "./lt/_lib/formatDistance/index.js": 343,
        "./lt/_lib/formatLong/index.js": 344,
        "./lt/_lib/formatRelative/index.js": 345,
        "./lt/_lib/localize/index.js": 346,
        "./lt/_lib/match/index.js": 347,
        "./lt/index.js": 733,
        "./lv/_lib/formatDistance/index.js": 348,
        "./lv/_lib/formatLong/index.js": 349,
        "./lv/_lib/formatRelative/index.js": 350,
        "./lv/_lib/localize/index.js": 351,
        "./lv/_lib/match/index.js": 352,
        "./lv/index.js": 734,
        "./mk/_lib/formatDistance/index.js": 353,
        "./mk/_lib/formatLong/index.js": 354,
        "./mk/_lib/formatRelative/index.js": 355,
        "./mk/_lib/localize/index.js": 356,
        "./mk/_lib/match/index.js": 357,
        "./mk/index.js": 735,
        "./mn/_lib/formatDistance/index.js": 358,
        "./mn/_lib/formatLong/index.js": 359,
        "./mn/_lib/formatRelative/index.js": 360,
        "./mn/_lib/localize/index.js": 361,
        "./mn/_lib/match/index.js": 362,
        "./mn/index.js": 736,
        "./ms/_lib/formatDistance/index.js": 363,
        "./ms/_lib/formatLong/index.js": 364,
        "./ms/_lib/formatRelative/index.js": 365,
        "./ms/_lib/localize/index.js": 366,
        "./ms/_lib/match/index.js": 367,
        "./ms/index.js": 737,
        "./mt/_lib/formatDistance/index.js": 368,
        "./mt/_lib/formatLong/index.js": 369,
        "./mt/_lib/formatRelative/index.js": 370,
        "./mt/_lib/localize/index.js": 371,
        "./mt/_lib/match/index.js": 372,
        "./mt/index.js": 738,
        "./nb/_lib/formatDistance/index.js": 373,
        "./nb/_lib/formatLong/index.js": 374,
        "./nb/_lib/formatRelative/index.js": 375,
        "./nb/_lib/localize/index.js": 376,
        "./nb/_lib/match/index.js": 377,
        "./nb/index.js": 739,
        "./nl-BE/_lib/formatDistance/index.js": 378,
        "./nl-BE/_lib/formatLong/index.js": 379,
        "./nl-BE/_lib/formatRelative/index.js": 380,
        "./nl-BE/_lib/localize/index.js": 381,
        "./nl-BE/_lib/match/index.js": 382,
        "./nl-BE/index.js": 740,
        "./nl/_lib/formatDistance/index.js": 383,
        "./nl/_lib/formatLong/index.js": 384,
        "./nl/_lib/formatRelative/index.js": 385,
        "./nl/_lib/localize/index.js": 386,
        "./nl/_lib/match/index.js": 387,
        "./nl/index.js": 741,
        "./nn/_lib/formatDistance/index.js": 388,
        "./nn/_lib/formatLong/index.js": 389,
        "./nn/_lib/formatRelative/index.js": 390,
        "./nn/_lib/localize/index.js": 391,
        "./nn/_lib/match/index.js": 392,
        "./nn/index.js": 742,
        "./pl/_lib/formatDistance/index.js": 393,
        "./pl/_lib/formatLong/index.js": 394,
        "./pl/_lib/formatRelative/index.js": 395,
        "./pl/_lib/localize/index.js": 396,
        "./pl/_lib/match/index.js": 397,
        "./pl/index.js": 743,
        "./pt-BR/_lib/formatDistance/index.js": 398,
        "./pt-BR/_lib/formatLong/index.js": 399,
        "./pt-BR/_lib/formatRelative/index.js": 400,
        "./pt-BR/_lib/localize/index.js": 401,
        "./pt-BR/_lib/match/index.js": 402,
        "./pt-BR/index.js": 744,
        "./pt/_lib/formatDistance/index.js": 403,
        "./pt/_lib/formatLong/index.js": 404,
        "./pt/_lib/formatRelative/index.js": 405,
        "./pt/_lib/localize/index.js": 406,
        "./pt/_lib/match/index.js": 407,
        "./pt/index.js": 745,
        "./ro/_lib/formatDistance/index.js": 408,
        "./ro/_lib/formatLong/index.js": 409,
        "./ro/_lib/formatRelative/index.js": 410,
        "./ro/_lib/localize/index.js": 411,
        "./ro/_lib/match/index.js": 412,
        "./ro/index.js": 746,
        "./ru/_lib/formatDistance/index.js": 413,
        "./ru/_lib/formatLong/index.js": 414,
        "./ru/_lib/formatRelative/index.js": 415,
        "./ru/_lib/localize/index.js": 416,
        "./ru/_lib/match/index.js": 417,
        "./ru/index.js": 747,
        "./sk/_lib/formatDistance/index.js": 418,
        "./sk/_lib/formatLong/index.js": 419,
        "./sk/_lib/formatRelative/index.js": 420,
        "./sk/_lib/localize/index.js": 421,
        "./sk/_lib/match/index.js": 422,
        "./sk/index.js": 748,
        "./sl/_lib/formatDistance/index.js": 423,
        "./sl/_lib/formatLong/index.js": 424,
        "./sl/_lib/formatRelative/index.js": 425,
        "./sl/_lib/localize/index.js": 426,
        "./sl/_lib/match/index.js": 427,
        "./sl/index.js": 749,
        "./sq/_lib/formatDistance/index.js": 428,
        "./sq/_lib/formatLong/index.js": 429,
        "./sq/_lib/formatRelative/index.js": 430,
        "./sq/_lib/localize/index.js": 431,
        "./sq/_lib/match/index.js": 432,
        "./sq/index.js": 750,
        "./sr-Latn/_lib/formatDistance/index.js": 433,
        "./sr-Latn/_lib/formatLong/index.js": 434,
        "./sr-Latn/_lib/formatRelative/index.js": 435,
        "./sr-Latn/_lib/localize/index.js": 436,
        "./sr-Latn/_lib/match/index.js": 437,
        "./sr-Latn/index.js": 751,
        "./sr/_lib/formatDistance/index.js": 438,
        "./sr/_lib/formatLong/index.js": 439,
        "./sr/_lib/formatRelative/index.js": 440,
        "./sr/_lib/localize/index.js": 441,
        "./sr/_lib/match/index.js": 442,
        "./sr/index.js": 752,
        "./sv/_lib/formatDistance/index.js": 443,
        "./sv/_lib/formatLong/index.js": 444,
        "./sv/_lib/formatRelative/index.js": 445,
        "./sv/_lib/localize/index.js": 446,
        "./sv/_lib/match/index.js": 447,
        "./sv/index.js": 753,
        "./ta/_lib/formatDistance/index.js": 448,
        "./ta/_lib/formatLong/index.js": 449,
        "./ta/_lib/formatRelative/index.js": 450,
        "./ta/_lib/localize/index.js": 451,
        "./ta/_lib/match/index.js": 452,
        "./ta/index.js": 754,
        "./te/_lib/formatDistance/index.js": 453,
        "./te/_lib/formatLong/index.js": 454,
        "./te/_lib/formatRelative/index.js": 455,
        "./te/_lib/localize/index.js": 456,
        "./te/_lib/match/index.js": 457,
        "./te/index.js": 755,
        "./th/_lib/formatDistance/index.js": 458,
        "./th/_lib/formatLong/index.js": 459,
        "./th/_lib/formatRelative/index.js": 460,
        "./th/_lib/localize/index.js": 461,
        "./th/_lib/match/index.js": 462,
        "./th/index.js": 756,
        "./tr/_lib/formatDistance/index.js": 463,
        "./tr/_lib/formatLong/index.js": 464,
        "./tr/_lib/formatRelative/index.js": 465,
        "./tr/_lib/localize/index.js": 466,
        "./tr/_lib/match/index.js": 467,
        "./tr/index.js": 757,
        "./ug/_lib/formatDistance/index.js": 468,
        "./ug/_lib/formatLong/index.js": 469,
        "./ug/_lib/formatRelative/index.js": 470,
        "./ug/_lib/localize/index.js": 471,
        "./ug/_lib/match/index.js": 472,
        "./ug/index.js": 758,
        "./uk/_lib/formatDistance/index.js": 473,
        "./uk/_lib/formatLong/index.js": 474,
        "./uk/_lib/formatRelative/index.js": 475,
        "./uk/_lib/localize/index.js": 476,
        "./uk/_lib/match/index.js": 477,
        "./uk/index.js": 759,
        "./uz/_lib/formatDistance/index.js": 478,
        "./uz/_lib/formatLong/index.js": 479,
        "./uz/_lib/formatRelative/index.js": 480,
        "./uz/_lib/localize/index.js": 481,
        "./uz/_lib/match/index.js": 482,
        "./uz/index.js": 760,
        "./vi/_lib/formatDistance/index.js": 483,
        "./vi/_lib/formatLong/index.js": 484,
        "./vi/_lib/formatRelative/index.js": 485,
        "./vi/_lib/localize/index.js": 486,
        "./vi/_lib/match/index.js": 487,
        "./vi/index.js": 761,
        "./zh-CN/_lib/formatDistance/index.js": 488,
        "./zh-CN/_lib/formatLong/index.js": 489,
        "./zh-CN/_lib/formatRelative/index.js": 490,
        "./zh-CN/_lib/localize/index.js": 491,
        "./zh-CN/_lib/match/index.js": 492,
        "./zh-CN/index.js": 762,
        "./zh-TW/_lib/formatDistance/index.js": 493,
        "./zh-TW/_lib/formatLong/index.js": 494,
        "./zh-TW/_lib/formatRelative/index.js": 495,
        "./zh-TW/_lib/localize/index.js": 496,
        "./zh-TW/_lib/match/index.js": 497,
        "./zh-TW/index.js": 763
      };

      function webpackContext(req) {
        return __webpack_require__(webpackContextResolve(req));
      }

      ;

      function webpackContextResolve(req) {
        var id = map[req];
        if (!(id + 1)) // check for number or string
          throw new Error("Cannot find module '" + req + "'.");
        return id;
      }

      ;

      webpackContext.keys = function webpackContextKeys() {
        return Object.keys(map);
      };

      webpackContext.resolve = webpackContextResolve;
      module.exports = webpackContext;
      webpackContext.id = 26;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addMonths;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addMonths
       * @category Month Helpers
       * @summary Add the specified number of months to the given date.
       *
       * @description
       * Add the specified number of months to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the months added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 5 months to 1 September 2014:
       * const result = addMonths(new Date(2014, 8, 1), 5)
       * //=> Sun Feb 01 2015 00:00:00
       */


      function addMonths(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);

        if (isNaN(amount)) {
          return new Date(NaN);
        }

        if (!amount) {
          // If 0 months, no-op to avoid changing times in the hour before end of DST
          return date;
        }

        var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
        // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
        // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
        // want except that dates will wrap around the end of a month, meaning that
        // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
        // we'll default to the end of the desired month by adding 1 to the desired
        // month and using a date of 0 to back up one day to the end of the desired
        // month.

        var endOfDesiredMonth = new Date(date.getTime());
        endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
        var daysInMonth = endOfDesiredMonth.getDate();

        if (dayOfMonth >= daysInMonth) {
          // If we're already at the end of the month, then this is the correct date
          // and we're done.
          return endOfDesiredMonth;
        } else {
          // Otherwise, we now know that setting the original day-of-month value won't
          // cause an overflow, so set the desired day-of-month. Note that we can't
          // just set the date of `endOfDesiredMonth` because that object may have had
          // its time changed in the unusual case where where a DST transition was on
          // the last day of the month and its local time was in the hour skipped or
          // repeated next to a DST transition.  So we use `date` instead which is
          // guaranteed to still have the original time.
          date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
          return date;
        }
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addMilliseconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addMilliseconds
       * @category Millisecond Helpers
       * @summary Add the specified number of milliseconds to the given date.
       *
       * @description
       * Add the specified number of milliseconds to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the milliseconds added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
       * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
       * //=> Thu Jul 10 2014 12:45:30.750
       */


      function addMilliseconds(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate).getTime();
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return new Date(timestamp + amount);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfISOWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__ = __webpack_require__(23);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfISOWeekYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Return the start of an ISO week-numbering year for the given date.
       *
       * @description
       * Return the start of an ISO week-numbering year,
       * which always starts 3 days before the year's first Thursday.
       * The result will be in the local timezone.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of an ISO week-numbering year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of an ISO week-numbering year for 2 July 2005:
       * const result = startOfISOWeekYear(new Date(2005, 6, 2))
       * //=> Mon Jan 03 2005 00:00:00
       */


      function startOfISOWeekYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var year = Object(__WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a"
        /* default */
        ])(dirtyDate);
        var fourthOfJanuary = new Date(0);
        fourthOfJanuary.setFullYear(year, 0, 4);
        fourthOfJanuary.setHours(0, 0, 0, 0);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ])(fourthOfJanuary);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameDay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__ = __webpack_require__(35);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameDay
       * @category Day Helpers
       * @summary Are the given dates in the same day?
       *
       * @description
       * Are the given dates in the same day?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same day
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
       * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
       * //=> true
       */


      function isSameDay(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeftStartOfDay = Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRightStartOfDay = Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getRoundingMethod;
      var roundingMap = {
        ceil: Math.ceil,
        round: Math.round,
        floor: Math.floor,
        trunc: function (value) {
          return value < 0 ? Math.ceil(value) : Math.floor(value);
        } // Math.trunc is not supported by IE

      };
      var defaultRoundingMethod = "trunc";

      function getRoundingMethod(method) {
        return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subMilliseconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(28);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subMilliseconds
       * @category Millisecond Helpers
       * @summary Subtract the specified number of milliseconds from the given date.
       *
       * @description
       * Subtract the specified number of milliseconds from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the milliseconds subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
       * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
       * //=> Thu Jul 10 2014 12:45:29.250
       */


      function subMilliseconds(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a"
        /* default */
        ])(dirtyDate, -amount);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "c", function () {
        return isFunction;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "e", function () {
        return isString;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return isDate;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return isObject;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return BooleanParse;
      });

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      var isFunction = function isFunction(unknown) {
        return typeof unknown === "function";
      };

      var isString = function isString(unknown) {
        return typeof unknown === "string" || !!unknown && (typeof unknown === "undefined" ? "undefined" : _typeof(unknown)) === "object" && Object.prototype.toString.call(unknown) === "[object String]";
      };

      var isDate = function isDate(unknown) {
        return (Object.prototype.toString.call(unknown) === "[object Date]" || unknown instanceof Date) && !isNaN(unknown.valueOf());
      };

      var isObject = function isObject(unknown) {
        return (typeof unknown === "function" || (typeof unknown === "undefined" ? "undefined" : _typeof(unknown)) === "object" && !!unknown) && !Array.isArray(unknown);
      };

      var falsy = /^(?:f(?:alse)?|no?|0+)$/i;

      var BooleanParse = function BooleanParse(val) {
        return !falsy.test(val) && !!val;
      };
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isWeekend;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isWeekend
       * @category Weekday Helpers
       * @summary Does the given date fall on a weekend?
       *
       * @description
       * Does the given date fall on a weekend?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date falls on a weekend
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Does 5 October 2014 fall on a weekend?
       * const result = isWeekend(new Date(2014, 9, 5))
       * //=> true
       */


      function isWeekend(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var day = date.getDay();
        return day === 0 || day === 6;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfDay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfDay
       * @category Day Helpers
       * @summary Return the start of a day for the given date.
       *
       * @description
       * Return the start of a day for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a day
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a day for 2 September 2014 11:55:00:
       * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Sep 02 2014 00:00:00
       */


      function startOfDay(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addWeeks;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(10);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addWeeks
       * @category Week Helpers
       * @summary Add the specified number of weeks to the given date.
       *
       * @description
       * Add the specified number of week to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the weeks added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 4 weeks to 1 September 2014:
       * const result = addWeeks(new Date(2014, 8, 1), 4)
       * //=> Mon Sep 29 2014 00:00:00
       */


      function addWeeks(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        var days = amount * 7;
        return Object(__WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["a"
        /* default */
        ])(dirtyDate, days);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInMilliseconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInMilliseconds
       * @category Millisecond Helpers
       * @summary Get the number of milliseconds between the given dates.
       *
       * @description
       * Get the number of milliseconds between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of milliseconds
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many milliseconds are between
       * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
       * const result = differenceInMilliseconds(
       *   new Date(2014, 6, 2, 12, 30, 21, 700),
       *   new Date(2014, 6, 2, 12, 30, 20, 600)
       * )
       * //=> 1100
       */


      function differenceInMilliseconds(dateLeft, dateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dateLeft).getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dateRight).getTime();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInMonths;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarMonths_index_js__ = __webpack_require__(83);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(21);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__isLastDayOfMonth_index_js__ = __webpack_require__(90);
      /**
       * @name differenceInMonths
       * @category Month Helpers
       * @summary Get the number of full months between the given dates.
       *
       * @description
       * Get the number of full months between the given dates using trunc as a default rounding method.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of full months
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many full months are between 31 January 2014 and 1 September 2014?
       * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
       * //=> 7
       */


      function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        var sign = Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a"
        /* default */
        ])(dateLeft, dateRight);
        var difference = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarMonths_index_js__["a"
        /* default */
        ])(dateLeft, dateRight));
        var result; // Check for the difference of less than month

        if (difference < 1) {
          result = 0;
        } else {
          if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
            // This will check if the date is end of Feb and assign a higher end of month date
            // to compare it with Jan
            dateLeft.setDate(30);
          }

          dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
          // If so, result must be decreased by 1 in absolute value

          var isLastMonthNotFull = Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a"
          /* default */
          ])(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month

          if (Object(__WEBPACK_IMPORTED_MODULE_4__isLastDayOfMonth_index_js__["a"
          /* default */
          ])(Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ])(dirtyDateLeft)) && difference === 1 && Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a"
          /* default */
          ])(dirtyDateLeft, dateRight) === 1) {
            isLastMonthNotFull = false;
          }

          result = sign * (difference - Number(isLastMonthNotFull));
        } // Prevent negative zero


        return result === 0 ? 0 : result;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfMonth
       * @category Month Helpers
       * @summary Return the start of a month for the given date.
       *
       * @description
       * Return the start of a month for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a month for 2 September 2014 11:55:00:
       * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Mon Sep 01 2014 00:00:00
       */


      function startOfMonth(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        date.setDate(1);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfUTCISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function startOfUTCISOWeek(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var weekStartsOn = 1;
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfUTCWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function startOfUTCWeek(dirtyDate, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ])(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
        }

        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getDay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getDay
       * @category Weekday Helpers
       * @summary Get the day of the week of the given date.
       *
       * @description
       * Get the day of the week of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which day of the week is 29 February 2012?
       * const result = getDay(new Date(2012, 1, 29))
       * //=> 3
       */


      function getDay(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var day = date.getDay();
        return day;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subDays;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(10);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subDays
       * @category Day Helpers
       * @summary Subtract the specified number of days from the given date.
       *
       * @description
       * Subtract the specified number of days from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the days subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 10 days from 1 September 2014:
       * const result = subDays(new Date(2014, 8, 1), 10)
       * //=> Fri Aug 22 2014 00:00:00
       */


      function subDays(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["a"
        /* default */
        ])(dirtyDate, -amount);
      }
      /***/

    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var numberValues = {
        locale: {
          "1": "\u0967",
          "2": "\u0968",
          "3": "\u0969",
          "4": "\u096A",
          "5": "\u096B",
          "6": "\u096C",
          "7": "\u096D",
          "8": "\u096E",
          "9": "\u096F",
          "0": "\u0966"
        },
        number: {
          "\u0967": "1",
          "\u0968": "2",
          "\u0969": "3",
          "\u096A": "4",
          "\u096B": "5",
          "\u096C": "6",
          "\u096D": "7",
          "\u096E": "8",
          "\u096F": "9",
          "\u0966": "0"
        }
      }; // CLDR #1585 - #1592

      var eraValues = {
        narrow: ["\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935", "\u0908\u0938\u094D\u0935\u0940"],
        abbreviated: ["\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935", "\u0908\u0938\u094D\u0935\u0940"],
        wide: ["\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935", "\u0908\u0938\u0935\u0940 \u0938\u0928"]
      }; // CLDR #1593 - #1616

      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["\u0924\u093F1", "\u0924\u093F2", "\u0924\u093F3", "\u0924\u093F4"],
        wide: ["\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940", "\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940", "\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940", "\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"]
      }; // Note: in English, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.
      // https://www.unicode.org/cldr/charts/32/summary/hi.html
      // CLDR #1617 - #1688

      var monthValues = {
        narrow: ["\u091C", "\u092B\u093C", "\u092E\u093E", "\u0905", "\u092E\u0908", "\u091C\u0942", "\u091C\u0941", "\u0905\u0917", "\u0938\u093F", "\u0905\u0915\u094D\u0924\u0942", "\u0928", "\u0926\u093F"],
        abbreviated: ["\u091C\u0928", "\u092B\u093C\u0930", "\u092E\u093E\u0930\u094D\u091A", "\u0905\u092A\u094D\u0930\u0948\u0932", "\u092E\u0908", "\u091C\u0942\u0928", "\u091C\u0941\u0932", "\u0905\u0917", "\u0938\u093F\u0924", "\u0905\u0915\u094D\u0924\u0942", "\u0928\u0935", "\u0926\u093F\u0938"],
        wide: ["\u091C\u0928\u0935\u0930\u0940", "\u092B\u093C\u0930\u0935\u0930\u0940", "\u092E\u093E\u0930\u094D\u091A", "\u0905\u092A\u094D\u0930\u0948\u0932", "\u092E\u0908", "\u091C\u0942\u0928", "\u091C\u0941\u0932\u093E\u0908", "\u0905\u0917\u0938\u094D\u0924", "\u0938\u093F\u0924\u0902\u092C\u0930", "\u0905\u0915\u094D\u0924\u0942\u092C\u0930", "\u0928\u0935\u0902\u092C\u0930", "\u0926\u093F\u0938\u0902\u092C\u0930"]
      }; // CLDR #1689 - #1744

      var dayValues = {
        narrow: ["\u0930", "\u0938\u094B", "\u092E\u0902", "\u092C\u0941", "\u0917\u0941", "\u0936\u0941", "\u0936"],
        short: ["\u0930", "\u0938\u094B", "\u092E\u0902", "\u092C\u0941", "\u0917\u0941", "\u0936\u0941", "\u0936"],
        abbreviated: ["\u0930\u0935\u093F", "\u0938\u094B\u092E", "\u092E\u0902\u0917\u0932", "\u092C\u0941\u0927", "\u0917\u0941\u0930\u0941", "\u0936\u0941\u0915\u094D\u0930", "\u0936\u0928\u093F"],
        wide: ["\u0930\u0935\u093F\u0935\u093E\u0930", "\u0938\u094B\u092E\u0935\u093E\u0930", "\u092E\u0902\u0917\u0932\u0935\u093E\u0930", "\u092C\u0941\u0927\u0935\u093E\u0930", "\u0917\u0941\u0930\u0941\u0935\u093E\u0930", "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930", "\u0936\u0928\u093F\u0935\u093E\u0930"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
          pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
          midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
          noon: "\u0926\u094B\u092A\u0939\u0930",
          morning: "\u0938\u0941\u092C\u0939",
          afternoon: "\u0926\u094B\u092A\u0939\u0930",
          evening: "\u0936\u093E\u092E",
          night: "\u0930\u093E\u0924"
        },
        abbreviated: {
          am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
          pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
          midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
          noon: "\u0926\u094B\u092A\u0939\u0930",
          morning: "\u0938\u0941\u092C\u0939",
          afternoon: "\u0926\u094B\u092A\u0939\u0930",
          evening: "\u0936\u093E\u092E",
          night: "\u0930\u093E\u0924"
        },
        wide: {
          am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
          pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
          midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
          noon: "\u0926\u094B\u092A\u0939\u0930",
          morning: "\u0938\u0941\u092C\u0939",
          afternoon: "\u0926\u094B\u092A\u0939\u0930",
          evening: "\u0936\u093E\u092E",
          night: "\u0930\u093E\u0924"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
          pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
          midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
          noon: "\u0926\u094B\u092A\u0939\u0930",
          morning: "\u0938\u0941\u092C\u0939",
          afternoon: "\u0926\u094B\u092A\u0939\u0930",
          evening: "\u0936\u093E\u092E",
          night: "\u0930\u093E\u0924"
        },
        abbreviated: {
          am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
          pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
          midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
          noon: "\u0926\u094B\u092A\u0939\u0930",
          morning: "\u0938\u0941\u092C\u0939",
          afternoon: "\u0926\u094B\u092A\u0939\u0930",
          evening: "\u0936\u093E\u092E",
          night: "\u0930\u093E\u0924"
        },
        wide: {
          am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
          pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
          midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
          noon: "\u0926\u094B\u092A\u0939\u0930",
          morning: "\u0938\u0941\u092C\u0939",
          afternoon: "\u0926\u094B\u092A\u0939\u0930",
          evening: "\u0936\u093E\u092E",
          night: "\u0930\u093E\u0924"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = localize.localeToNumber(dirtyNumber);
        var localeNumber = localize.numberToLocale(number);
        var rem10 = number % 10;

        switch (rem10) {
          case 2:
          case 3:
          case 4:
          case 6:
          case 1:
          case 5:
          case 7:
          case 8:
          case 9:
          case 0:
            return localeNumber;
        }
      }

      function localeToNumber(locale) {
        var number = locale.toString().replace(/[१२३४५६७८९०]/g, function (match) {
          return numberValues.number[match];
        });
        return Number(number);
      }

      function numberToLocale(number) {
        return number.toString().replace(/\d/g, function (match) {
          return numberValues.locale[match];
        });
      }

      var localize = {
        localeToNumber: localeToNumber,
        numberToLocale: numberToLocale,
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "c", function () {
        return uuid;
      });
      /* unused harmony export deepMerge */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return detectSupportsPassive;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return newDate;
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(33);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(18);

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = undefined;

          try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }

          return arr2;
        } else {
          return Array.from(arr);
        }
      }

      var uuid = function uuid() {
        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return prefix + ([10000000] + -1000 + -4000 + -8000 + -100000000000).replace(/[018]/g, function (c) {
          return (c ^ (window.crypto || window.msCrypto).getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
        });
      };

      var deepMerge = function deepMerge() {
        for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
          sources[_key] = arguments[_key];
        }

        var acc = {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var source = _step.value;

            if (source instanceof Array) {
              if (!(acc instanceof Array)) {
                acc = [];
              }

              acc = [].concat(_toConsumableArray(acc), _toConsumableArray(source));
            } else if (source instanceof Object) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = Object.entries(source)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref = _step2.value;

                  var _ref2 = _slicedToArray(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (value instanceof Object && key in acc) {
                    value = deepMerge(acc[key], value);
                  }

                  acc = _extends({}, acc, _defineProperty({}, key, value));
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return acc;
      };

      var detectSupportsPassive = function detectSupportsPassive() {
        var supportsPassive = false;

        try {
          var opts = Object.defineProperty({}, "passive", {
            get: function get() {
              supportsPassive = true;
            }
          });
          window.addEventListener("testPassive", null, opts);
          window.removeEventListener("testPassive", null, opts);
        } catch (e) {}

        return supportsPassive;
      };

      var newDate = function newDate(date, format) {
        var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "yyyy-MM-dd HH:mm";

        if (!date) {
          return undefined;
        } // Clone Date


        if (__WEBPACK_IMPORTED_MODULE_0__type__["b"
        /* isDate */
        ](date)) {
          return new Date(date.getTime());
        } // Parse Date


        var result = __WEBPACK_IMPORTED_MODULE_1_date_fns__["B"
        /* parse */
        ](date, format, new Date());

        if (!__WEBPACK_IMPORTED_MODULE_0__type__["b"
        /* isDate */
        ](result)) {
          result = __WEBPACK_IMPORTED_MODULE_1_date_fns__["B"
          /* parse */
          ](date, fallback, new Date());
        }

        return result;
      };
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSunday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSunday
       * @category Weekday Helpers
       * @summary Is the given date Sunday?
       *
       * @description
       * Is the given date Sunday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Sunday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 21 September 2014 Sunday?
       * var result = isSunday(new Date(2014, 8, 21))
       * //=> true
       */


      function isSunday(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate).getDay() === 0;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addHours;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(28);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_HOUR = 3600000;
      /**
       * @name addHours
       * @category Hour Helpers
       * @summary Add the specified number of hours to the given date.
       *
       * @description
       * Add the specified number of hours to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the hours added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 2 hours to 10 July 2014 23:00:00:
       * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
       * //=> Fri Jul 11 2014 01:00:00
       */

      function addHours(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a"
        /* default */
        ])(dirtyDate, amount * MILLISECONDS_IN_HOUR);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addMinutes;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(28);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_MINUTE = 60000;
      /**
       * @name addMinutes
       * @category Minute Helpers
       * @summary Add the specified number of minutes to the given date.
       *
       * @description
       * Add the specified number of minutes to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the minutes added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 30 minutes to 10 July 2014 12:00:00:
       * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
       * //=> Thu Jul 10 2014 12:30:00
       */

      function addMinutes(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a"
        /* default */
        ])(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addQuarters;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(27);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addQuarters
       * @category Quarter Helpers
       * @summary Add the specified number of year quarters to the given date.
       *
       * @description
       * Add the specified number of year quarters to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the quarters added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 1 quarter to 1 September 2014:
       * const result = addQuarters(new Date(2014, 8, 1), 1)
       * //=> Mon Dec 01 2014 00:00:00
       */


      function addQuarters(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        var months = amount * 3;
        return Object(__WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["a"
        /* default */
        ])(dirtyDate, months);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInDays;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__ = __webpack_require__(20);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0); // Like `compareAsc` but uses local time not UTC, which is needed
      // for accurate equality comparisons of UTC timestamps that end up
      // having the same representation in local time, e.g. one hour before
      // DST ends vs. the instant that DST ends.


      function compareLocalAsc(dateLeft, dateRight) {
        var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();

        if (diff < 0) {
          return -1;
        } else if (diff > 0) {
          return 1; // Return 0 if diff is 0; return NaN if diff is NaN
        } else {
          return diff;
        }
      }
      /**
       * @name differenceInDays
       * @category Day Helpers
       * @summary Get the number of full days between the given dates.
       *
       * @description
       * Get the number of full day periods between two dates. Fractional days are
       * truncated towards zero.
       *
       * One "full day" is the distance between a local time in one day to the same
       * local time on the next or previous day. A full day can sometimes be less than
       * or more than 24 hours if a daylight savings change happens between two dates.
       *
       * To ignore DST and only measure exact 24-hour periods, use this instead:
       * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
       *
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of full days according to the local timezone
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many full days are between
       * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
       * const result = differenceInDays(
       *   new Date(2012, 6, 2, 0, 0),
       *   new Date(2011, 6, 2, 23, 0)
       * )
       * //=> 365
       * // How many full days are between
       * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
       * const result = differenceInDays(
       *   new Date(2011, 6, 3, 0, 1),
       *   new Date(2011, 6, 2, 23, 59)
       * )
       * //=> 0
       * // How many full days are between
       * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
       * // Note: because local time is used, the
       * // result will always be 92 days, even in
       * // time zones where DST starts and the
       * // period has only 92*24-1 hours.
       * const result = differenceInDays(
       *   new Date(2020, 5, 1),
       *   new Date(2020, 2, 1)
       * )
      //=> 92
       */


      function differenceInDays(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        var sign = compareLocalAsc(dateLeft, dateRight);
        var difference = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__["a"
        /* default */
        ])(dateLeft, dateRight));
        dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
        // If so, result must be decreased by 1 in absolute value

        var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
        var result = sign * (difference - isLastDayNotFull); // Prevent negative zero

        return result === 0 ? 0 : result;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfDay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfDay
       * @category Day Helpers
       * @summary Return the end of a day for the given date.
       *
       * @description
       * Return the end of a day for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a day
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of a day for 2 September 2014 11:55:00:
       * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Sep 02 2014 23:59:59.999
       */


      function endOfDay(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfMonth
       * @category Month Helpers
       * @summary Return the end of a month for the given date.
       *
       * @description
       * Return the end of a month for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of a month for 2 September 2014 11:55:00:
       * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Sep 30 2014 23:59:59.999
       */


      function endOfMonth(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var month = date.getMonth();
        date.setFullYear(date.getFullYear(), month + 1, 0);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInSeconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__ = __webpack_require__(37);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_roundingMethods_index_js__ = __webpack_require__(31);
      /**
       * @name differenceInSeconds
       * @category Second Helpers
       * @summary Get the number of seconds between the given dates.
       *
       * @description
       * Get the number of seconds between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @param {Object} [options] - an object with options.
       * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
       * @returns {Number} the number of seconds
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many seconds are between
       * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
       * const result = differenceInSeconds(
       *   new Date(2014, 6, 2, 12, 30, 20, 0),
       *   new Date(2014, 6, 2, 12, 30, 7, 999)
       * )
       * //=> 12
       */


      function differenceInSeconds(dateLeft, dateRight, options) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__["a"
        /* default */
        ])(dateLeft, dateRight) / 1000;
        return Object(__WEBPACK_IMPORTED_MODULE_2__lib_roundingMethods_index_js__["a"
        /* getRoundingMethod */
        ])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfMinute;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfMinute
       * @category Minute Helpers
       * @summary Return the start of a minute for the given date.
       *
       * @description
       * Return the start of a minute for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a minute
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a minute for 1 December 2014 22:15:45.400:
       * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
       * //=> Mon Dec 01 2014 22:15:00
       */


      function startOfMinute(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        date.setSeconds(0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfQuarter;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfQuarter
       * @category Quarter Helpers
       * @summary Return the start of a year quarter for the given date.
       *
       * @description
       * Return the start of a year quarter for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a quarter
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a quarter for 2 September 2014 11:55:00:
       * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Jul 01 2014 00:00:00
       */


      function startOfQuarter(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var currentMonth = date.getMonth();
        var month = currentMonth - currentMonth % 3;
        date.setMonth(month, 1);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = eachWeekendOfInterval;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__eachDayOfInterval_index_js__ = __webpack_require__(92);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isSunday_index_js__ = __webpack_require__(46);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__isWeekend_index_js__ = __webpack_require__(34);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachWeekendOfInterval
       * @category Interval Helpers
       * @summary List all the Saturdays and Sundays in the given date interval.
       *
       * @description
       * Get all the Saturdays and Sundays in the given date interval.
       *
       * @param {Interval} interval - the given interval. See [Interval]{@link https://date-fns.org/docs/Interval}
       * @returns {Date[]} an array containing all the Saturdays and Sundays
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Lists all Saturdays and Sundays in the given date interval
       * const result = eachWeekendOfInterval({
       *   start: new Date(2018, 8, 17),
       *   end: new Date(2018, 8, 30)
       * })
       * //=> [
       * //   Sat Sep 22 2018 00:00:00,
       * //   Sun Sep 23 2018 00:00:00,
       * //   Sat Sep 29 2018 00:00:00,
       * //   Sun Sep 30 2018 00:00:00
       * // ]
       */


      function eachWeekendOfInterval(interval) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var dateInterval = Object(__WEBPACK_IMPORTED_MODULE_0__eachDayOfInterval_index_js__["a"
        /* default */
        ])(interval);
        var weekends = [];
        var index = 0;

        while (index < dateInterval.length) {
          var date = dateInterval[index++];

          if (Object(__WEBPACK_IMPORTED_MODULE_2__isWeekend_index_js__["a"
          /* default */
          ])(date)) {
            weekends.push(date);
            if (Object(__WEBPACK_IMPORTED_MODULE_1__isSunday_index_js__["a"
            /* default */
            ])(date)) index = index + 5;
          }
        }

        return weekends;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfYear
       * @category Year Helpers
       * @summary Return the start of a year for the given date.
       *
       * @description
       * Return the start of a year for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a year for 2 September 2014 11:55:00:
       * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
       * //=> Wed Jan 01 2014 00:00:00
       */


      function startOfYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var cleanDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var date = new Date(0);
        date.setFullYear(cleanDate.getFullYear(), 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getUTCWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(41);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function getUTCWeekYear(dirtyDate, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate, dirtyOptions);
        var year = date.getUTCFullYear();
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ])(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
          throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
        }

        var firstWeekOfNextYear = new Date(0);
        firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
        firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
        var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a"
        /* default */
        ])(firstWeekOfNextYear, dirtyOptions);
        var firstWeekOfThisYear = new Date(0);
        firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
        var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a"
        /* default */
        ])(firstWeekOfThisYear, dirtyOptions);

        if (date.getTime() >= startOfNextYear.getTime()) {
          return year + 1;
        } else if (date.getTime() >= startOfThisYear.getTime()) {
          return year;
        } else {
          return year - 1;
        }
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getWeekYear_index_js__ = __webpack_require__(113);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__ = __webpack_require__(12);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfWeekYear
       * @category Week-Numbering Year Helpers
       * @summary Return the start of a local week-numbering year for the given date.
       *
       * @description
       * Return the start of a local week-numbering year.
       * The exact calculation depends on the values of
       * `options.weekStartsOn` (which is the index of the first day of the week)
       * and `options.firstWeekContainsDate` (which is the day of January, which is always in
       * the first week of the week-numbering year)
       *
       * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @returns {Date} the start of a week-numbering year
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       *
       * @example
       * // The start of an a week-numbering year for 2 July 2005 with default settings:
       * const result = startOfWeekYear(new Date(2005, 6, 2))
       * //=> Sun Dec 26 2004 00:00:00
       *
       * @example
       * // The start of a week-numbering year for 2 July 2005
       * // if Monday is the first day of week
       * // and 4 January is always in the first week of the year:
       * const result = startOfWeekYear(new Date(2005, 6, 2), {
       *   weekStartsOn: 1,
       *   firstWeekContainsDate: 4
       * })
       * //=> Mon Jan 03 2005 00:00:00
       */


      function startOfWeekYear(dirtyDate, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ])(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ])(options.firstWeekContainsDate);
        var year = Object(__WEBPACK_IMPORTED_MODULE_0__getWeekYear_index_js__["a"
        /* default */
        ])(dirtyDate, dirtyOptions);
        var firstWeek = new Date(0);
        firstWeek.setFullYear(year, 0, firstWeekContainsDate);
        firstWeek.setHours(0, 0, 0, 0);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__["a"
        /* default */
        ])(firstWeek, dirtyOptions);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(12);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameWeek
       * @category Week Helpers
       * @summary Are the given dates in the same week?
       *
       * @description
       * Are the given dates in the same week?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Boolean} the dates are in the same week
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // Are 31 August 2014 and 4 September 2014 in the same week?
       * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
       * //=> true
       *
       * @example
       * // If week starts with Monday,
       * // are 31 August 2014 and 4 September 2014 in the same week?
       * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
       *   weekStartsOn: 1
       * })
       * //=> false
       */


      function isSameWeek(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeftStartOfWeek = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ])(dirtyDateLeft, dirtyOptions);
        var dateRightStartOfWeek = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ])(dirtyDateRight, dirtyOptions);
        return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__ = __webpack_require__(107);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setMonth
       * @category Month Helpers
       * @summary Set the month to the given date.
       *
       * @description
       * Set the month to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} month - the month of the new date
       * @returns {Date} the new date with the month set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set February to 1 September 2014:
       * const result = setMonth(new Date(2014, 8, 1), 1)
       * //=> Sat Feb 01 2014 00:00:00
       */


      function setMonth(dirtyDate, dirtyMonth) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var month = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyMonth);
        var year = date.getFullYear();
        var day = date.getDate();
        var dateWithDesiredMonth = new Date(0);
        dateWithDesiredMonth.setFullYear(year, month, 15);
        dateWithDesiredMonth.setHours(0, 0, 0, 0);
        var daysInMonth = Object(__WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__["a"
        /* default */
        ])(dateWithDesiredMonth); // Set the last day of the new month
        // if the original date was the last day of the longer month

        date.setMonth(month, Math.min(day, daysInMonth));
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var EventEmitter = function () {
        function EventEmitter() {
          var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

          _classCallCheck(this || _global, EventEmitter);

          (this || _global)._listeners = new Map(listeners);
          (this || _global)._middlewares = new Map();
        }

        _createClass(EventEmitter, [{
          key: "listenerCount",
          value: function listenerCount(eventName) {
            if (!(this || _global)._listeners.has(eventName)) {
              return 0;
            }

            var eventListeners = (this || _global)._listeners.get(eventName);

            return eventListeners.length;
          }
        }, {
          key: "removeListeners",
          value: function removeListeners() {
            var _this = this || _global;

            var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var middleware = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (eventName !== null) {
              if (Array.isArray(eventName)) {
                name.forEach(function (e) {
                  return _this.removeListeners(e, middleware);
                });
              } else {
                (this || _global)._listeners.delete(eventName);

                if (middleware) {
                  this.removeMiddleware(eventName);
                }
              }
            } else {
              (this || _global)._listeners = new Map();
            }
          }
        }, {
          key: "middleware",
          value: function middleware(eventName, fn) {
            var _this2 = this || _global;

            if (Array.isArray(eventName)) {
              name.forEach(function (e) {
                return _this2.middleware(e, fn);
              });
            } else {
              if (!Array.isArray((this || _global)._middlewares.get(eventName))) {
                (this || _global)._middlewares.set(eventName, []);
              }

              (this || _global)._middlewares.get(eventName).push(fn);
            }
          }
        }, {
          key: "removeMiddleware",
          value: function removeMiddleware() {
            var _this3 = this || _global;

            var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (eventName !== null) {
              if (Array.isArray(eventName)) {
                name.forEach(function (e) {
                  return _this3.removeMiddleware(e);
                });
              } else {
                (this || _global)._middlewares.delete(eventName);
              }
            } else {
              (this || _global)._middlewares = new Map();
            }
          }
        }, {
          key: "on",
          value: function on(name, callback) {
            var _this4 = this || _global;

            var once = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (Array.isArray(name)) {
              name.forEach(function (e) {
                return _this4.on(e, callback);
              });
            } else {
              name = name.toString();
              var split = name.split(/,|, | /);

              if (split.length > 1) {
                split.forEach(function (e) {
                  return _this4.on(e, callback);
                });
              } else {
                if (!Array.isArray((this || _global)._listeners.get(name))) {
                  (this || _global)._listeners.set(name, []);
                }

                (this || _global)._listeners.get(name).push({
                  once: once,
                  callback: callback
                });
              }
            }
          }
        }, {
          key: "once",
          value: function once(name, callback) {
            this.on(name, callback, true);
          }
        }, {
          key: "emit",
          value: function emit(name, data) {
            var _this5 = this || _global;

            var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            name = name.toString();

            var listeners = (this || _global)._listeners.get(name);

            var middlewares = null;
            var doneCount = 0;
            var execute = silent;

            if (Array.isArray(listeners)) {
              listeners.forEach(function (listener, index) {
                // Start Middleware checks unless we're doing a silent emit
                if (!silent) {
                  middlewares = _this5._middlewares.get(name); // Check and execute Middleware

                  if (Array.isArray(middlewares)) {
                    middlewares.forEach(function (middleware) {
                      middleware(data, function () {
                        var newData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                        if (newData !== null) {
                          data = newData;
                        }

                        doneCount++;
                      }, name);
                    });

                    if (doneCount >= middlewares.length) {
                      execute = true;
                    }
                  } else {
                    execute = true;
                  }
                } // If Middleware checks have been passed, execute


                if (execute) {
                  if (listener.once) {
                    listeners[index] = null;
                  }

                  listener.callback({
                    type: name,
                    timeStamp: new Date().getTime(),
                    data: data
                  });
                }
              }); // Dirty way of removing used Events

              while (listeners.indexOf(null) !== -1) {
                listeners.splice(listeners.indexOf(null), 1);
              }
            }
          }
        }]);

        return EventEmitter;
      }();
      /* harmony default export */


      __webpack_exports__["a"] = EventEmitter;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = requiredArgs;

      function requiredArgs(required, args) {
        if (args.length < required) {
          throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
        }
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var numberValues = {
        locale: {
          "1": "\u09E7",
          "2": "\u09E8",
          "3": "\u09E9",
          "4": "\u09EA",
          "5": "\u09EB",
          "6": "\u09EC",
          "7": "\u09ED",
          "8": "\u09EE",
          "9": "\u09EF",
          "0": "\u09E6"
        },
        number: {
          "\u09E7": "1",
          "\u09E8": "2",
          "\u09E9": "3",
          "\u09EA": "4",
          "\u09EB": "5",
          "\u09EC": "6",
          "\u09ED": "7",
          "\u09EE": "8",
          "\u09EF": "9",
          "\u09E6": "0"
        }
      };
      var eraValues = {
        narrow: ["\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983", "\u0996\u09CD\u09B0\u09BF\u0983"],
        abbreviated: ["\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC", "\u0996\u09CD\u09B0\u09BF\u0983"],
        wide: ["\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC", "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"]
      };
      var quarterValues = {
        narrow: ["\u09E7", "\u09E8", "\u09E9", "\u09EA"],
        abbreviated: ["\u09E7\u09A4\u09CD\u09B0\u09C8", "\u09E8\u09A4\u09CD\u09B0\u09C8", "\u09E9\u09A4\u09CD\u09B0\u09C8", "\u09EA\u09A4\u09CD\u09B0\u09C8"],
        wide: ["\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995", "\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995", "\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995", "\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"]
      };
      var monthValues = {
        narrow: ["\u099C\u09BE\u09A8\u09C1", "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1", "\u09AE\u09BE\u09B0\u09CD\u099A", "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2", "\u09AE\u09C7", "\u099C\u09C1\u09A8", "\u099C\u09C1\u09B2\u09BE\u0987", "\u0986\u0997\u09B8\u09CD\u099F", "\u09B8\u09C7\u09AA\u09CD\u099F", "\u0985\u0995\u09CD\u099F\u09CB", "\u09A8\u09AD\u09C7", "\u09A1\u09BF\u09B8\u09C7"],
        abbreviated: ["\u099C\u09BE\u09A8\u09C1", "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1", "\u09AE\u09BE\u09B0\u09CD\u099A", "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2", "\u09AE\u09C7", "\u099C\u09C1\u09A8", "\u099C\u09C1\u09B2\u09BE\u0987", "\u0986\u0997\u09B8\u09CD\u099F", "\u09B8\u09C7\u09AA\u09CD\u099F", "\u0985\u0995\u09CD\u099F\u09CB", "\u09A8\u09AD\u09C7", "\u09A1\u09BF\u09B8\u09C7"],
        wide: ["\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF", "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF", "\u09AE\u09BE\u09B0\u09CD\u099A", "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2", "\u09AE\u09C7", "\u099C\u09C1\u09A8", "\u099C\u09C1\u09B2\u09BE\u0987", "\u0986\u0997\u09B8\u09CD\u099F", "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0", "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0", "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0", "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"]
      };
      var dayValues = {
        narrow: ["\u09B0", "\u09B8\u09CB", "\u09AE", "\u09AC\u09C1", "\u09AC\u09C3", "\u09B6\u09C1", "\u09B6"],
        short: ["\u09B0\u09AC\u09BF", "\u09B8\u09CB\u09AE", "\u09AE\u0999\u09CD\u0997\u09B2", "\u09AC\u09C1\u09A7", "\u09AC\u09C3\u09B9", "\u09B6\u09C1\u0995\u09CD\u09B0", "\u09B6\u09A8\u09BF"],
        abbreviated: ["\u09B0\u09AC\u09BF", "\u09B8\u09CB\u09AE", "\u09AE\u0999\u09CD\u0997\u09B2", "\u09AC\u09C1\u09A7", "\u09AC\u09C3\u09B9", "\u09B6\u09C1\u0995\u09CD\u09B0", "\u09B6\u09A8\u09BF"],
        wide: ["\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0", "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0", "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0", "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0", "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ", "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0", "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u09AA\u09C2",
          pm: "\u0985\u09AA",
          midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
          noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
          morning: "\u09B8\u0995\u09BE\u09B2",
          afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
          evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
          night: "\u09B0\u09BE\u09A4"
        },
        abbreviated: {
          am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
          pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
          midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
          noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
          morning: "\u09B8\u0995\u09BE\u09B2",
          afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
          evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
          night: "\u09B0\u09BE\u09A4"
        },
        wide: {
          am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
          pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
          midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
          noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
          morning: "\u09B8\u0995\u09BE\u09B2",
          afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
          evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
          night: "\u09B0\u09BE\u09A4"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u09AA\u09C2",
          pm: "\u0985\u09AA",
          midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
          noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
          morning: "\u09B8\u0995\u09BE\u09B2",
          afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
          evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
          night: "\u09B0\u09BE\u09A4"
        },
        abbreviated: {
          am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
          pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
          midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
          noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
          morning: "\u09B8\u0995\u09BE\u09B2",
          afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
          evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
          night: "\u09B0\u09BE\u09A4"
        },
        wide: {
          am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
          pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
          midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
          noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
          morning: "\u09B8\u0995\u09BE\u09B2",
          afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
          evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
          night: "\u09B0\u09BE\u09A4"
        }
      };

      function dateOrdinalNumber(number, localeNumber) {
        if (number > 18 && number <= 31) {
          return localeNumber + "\u09B6\u09C7";
        } else {
          switch (number) {
            case 1:
              return localeNumber + "\u09B2\u09BE";

            case 2:
            case 3:
              return localeNumber + "\u09B0\u09BE";

            case 4:
              return localeNumber + "\u09A0\u09BE";

            default:
              return localeNumber + "\u0987";
          }
        }
      }

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = localize.localeToNumber(dirtyNumber);
        var localeNumber = localize.numberToLocale(number);
        var unit = dirtyOptions.unit;

        if (unit === "date") {
          return dateOrdinalNumber(number, localeNumber);
        }

        if (number > 10 || number === 0) return localeNumber + "\u09A4\u09AE";
        var rem10 = number % 10;

        switch (rem10) {
          case 2:
          case 3:
            return localeNumber + "\u09DF";

          case 4:
            return localeNumber + "\u09B0\u09CD\u09A5";

          case 6:
            return localeNumber + "\u09B7\u09CD\u09A0";

          case 1:
          case 5:
          case 7:
          case 8:
          case 9:
          case 0:
            return localeNumber + "\u09AE";
        }
      }

      function localeToNumber(locale) {
        var number = locale.toString().replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
          return numberValues.number[match];
        });
        return Number(number);
      }

      function numberToLocale(number) {
        return number.toString().replace(/\d/g, function (match) {
          return numberValues.locale[match];
        });
      }

      var localize = {
        localeToNumber: localeToNumber,
        numberToLocale: numberToLocale,
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          standalone: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
          },
          withPreposition: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
          }
        },
        xSeconds: {
          standalone: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
          },
          withPreposition: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
          }
        },
        halfAMinute: {
          standalone: "halbe Minute",
          withPreposition: "halben Minute"
        },
        lessThanXMinutes: {
          standalone: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
          },
          withPreposition: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
          }
        },
        xMinutes: {
          standalone: {
            one: "1 Minute",
            other: "{{count}} Minuten"
          },
          withPreposition: {
            one: "1 Minute",
            other: "{{count}} Minuten"
          }
        },
        aboutXHours: {
          standalone: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
          },
          withPreposition: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
          }
        },
        xHours: {
          standalone: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
          },
          withPreposition: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
          }
        },
        xDays: {
          standalone: {
            one: "1 Tag",
            other: "{{count}} Tage"
          },
          withPreposition: {
            one: "1 Tag",
            other: "{{count}} Tagen"
          }
        },
        aboutXWeeks: {
          standalone: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
          },
          withPreposition: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
          }
        },
        xWeeks: {
          standalone: {
            one: "1 Woche",
            other: "{{count}} Wochen"
          },
          withPreposition: {
            one: "1 Woche",
            other: "{{count}} Wochen"
          }
        },
        aboutXMonths: {
          standalone: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monate"
          },
          withPreposition: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monaten"
          }
        },
        xMonths: {
          standalone: {
            one: "1 Monat",
            other: "{{count}} Monate"
          },
          withPreposition: {
            one: "1 Monat",
            other: "{{count}} Monaten"
          }
        },
        aboutXYears: {
          standalone: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahre"
          },
          withPreposition: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahren"
          }
        },
        xYears: {
          standalone: {
            one: "1 Jahr",
            other: "{{count}} Jahre"
          },
          withPreposition: {
            one: "1 Jahr",
            other: "{{count}} Jahren"
          }
        },
        overXYears: {
          standalone: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahre"
          },
          withPreposition: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahren"
          }
        },
        almostXYears: {
          standalone: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahre"
          },
          withPreposition: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahren"
          }
        }
      };

      var formatDistance = function (token, count, options) {
        var result;
        var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;

        if (typeof tokenValue === "string") {
          result = tokenValue;
        } else if (count === 1) {
          result = tokenValue.one;
        } else {
          result = tokenValue.other.replace("{{count}}", String(count));
        }

        if (options !== null && options !== void 0 && options.addSuffix) {
          if (options.comparison && options.comparison > 0) {
            return "in " + result;
          } else {
            return "vor " + result;
          }
        }

        return result;
      };

      var _default = formatDistance;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008


      var dateFormats = {
        full: "EEEE, do MMMM y",
        // Montag, 7. Januar 2018
        long: "do MMMM y",
        // 7. Januar 2018
        medium: "do MMM y",
        // 7. Jan. 2018
        short: "dd.MM.y" // 07.01.2018

      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'um' {{time}}",
        long: "{{date}} 'um' {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var formatRelativeLocale = {
        lastWeek: "'letzten' eeee 'um' p",
        yesterday: "'gestern um' p",
        today: "'heute um' p",
        tomorrow: "'morgen um' p",
        nextWeek: "eeee 'um' p",
        other: "P"
      };

      var formatRelative = function (token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      };

      var _default = formatRelative;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
        abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
        wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
      };
      var parseEraPatterns = {
        any: [/^v/i, /^n/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](\.)? Quartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
        wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smdmf]/i,
        short: /^(so|mo|di|mi|do|fr|sa)/i,
        abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
        wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
      };
      var parseDayPatterns = {
        any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
        abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
        wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^v/i,
          pm: /^n/i,
          midnight: /^Mitte/i,
          noon: /^Mitta/i,
          morning: /morgens/i,
          afternoon: /nachmittags/i,
          // will never be matched. Afternoon is matched by `pm`
          evening: /abends/i,
          night: /nachts/i // will never be matched. Night is matched by `pm`

        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "moins d\u2019une seconde",
          other: "moins de {{count}} secondes"
        },
        xSeconds: {
          one: "1 seconde",
          other: "{{count}} secondes"
        },
        halfAMinute: "30 secondes",
        lessThanXMinutes: {
          one: "moins d\u2019une minute",
          other: "moins de {{count}} minutes"
        },
        xMinutes: {
          one: "1 minute",
          other: "{{count}} minutes"
        },
        aboutXHours: {
          one: "environ 1 heure",
          other: "environ {{count}} heures"
        },
        xHours: {
          one: "1 heure",
          other: "{{count}} heures"
        },
        xDays: {
          one: "1 jour",
          other: "{{count}} jours"
        },
        aboutXWeeks: {
          one: "environ 1 semaine",
          other: "environ {{count}} semaines"
        },
        xWeeks: {
          one: "1 semaine",
          other: "{{count}} semaines"
        },
        aboutXMonths: {
          one: "environ 1 mois",
          other: "environ {{count}} mois"
        },
        xMonths: {
          one: "1 mois",
          other: "{{count}} mois"
        },
        aboutXYears: {
          one: "environ 1 an",
          other: "environ {{count}} ans"
        },
        xYears: {
          one: "1 an",
          other: "{{count}} ans"
        },
        overXYears: {
          one: "plus d\u2019un an",
          other: "plus de {{count}} ans"
        },
        almostXYears: {
          one: "presqu\u2019un an",
          other: "presque {{count}} ans"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "dans " + result;
          } else {
            return "il y a " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'dernier \xE0' p",
        yesterday: "'hier \xE0' p",
        today: "'aujourd\u2019hui \xE0' p",
        tomorrow: "'demain \xE0' p'",
        nextWeek: "eeee 'prochain \xE0' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["av. J.-C", "ap. J.-C"],
        abbreviated: ["av. J.-C", "ap. J.-C"],
        wide: ["avant J\xE9sus-Christ", "apr\xE8s J\xE9sus-Christ"]
      };
      var quarterValues = {
        narrow: ["T1", "T2", "T3", "T4"],
        abbreviated: ["1er trim.", "2\xE8me trim.", "3\xE8me trim.", "4\xE8me trim."],
        wide: ["1er trimestre", "2\xE8me trimestre", "3\xE8me trimestre", "4\xE8me trimestre"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["janv.", "f\xE9vr.", "mars", "avr.", "mai", "juin", "juil.", "ao\xFBt", "sept.", "oct.", "nov.", "d\xE9c."],
        wide: ["janvier", "f\xE9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\xFBt", "septembre", "octobre", "novembre", "d\xE9cembre"]
      };
      var dayValues = {
        narrow: ["D", "L", "M", "M", "J", "V", "S"],
        short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
        abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
        wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "minuit",
          noon: "midi",
          morning: "mat.",
          afternoon: "ap.m.",
          evening: "soir",
          night: "mat."
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "minuit",
          noon: "midi",
          morning: "matin",
          afternoon: "apr\xE8s-midi",
          evening: "soir",
          night: "matin"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "minuit",
          noon: "midi",
          morning: "du matin",
          afternoon: "de l\u2019apr\xE8s-midi",
          evening: "du soir",
          night: "du matin"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber);
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var suffix;

        if (number === 0) {
          return number;
        }

        if (unit === "year" || unit === "hour" || unit === "week") {
          if (number === 1) {
            suffix = "\xE8re";
          } else {
            suffix = "\xE8me";
          }
        } else {
          if (number === 1) {
            suffix = "er";
          } else {
            suffix = "\xE8me";
          }
        }

        return number + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
        abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
        wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
      };
      var parseEraPatterns = {
        any: [/^av/i, /^ap/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^t[1234]/i,
        wide: /^[1234](er|ème|e)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
        wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[lmjvsd]/i,
        short: /^(di|lu|ma|me|je|ve|sa)/i,
        abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
        wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
        any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
        any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^min/i,
          noon: /^mid/i,
          morning: /mat/i,
          afternoon: /ap/i,
          evening: /soir/i,
          night: /nuit/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addBusinessDays;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isWeekend_index_js__ = __webpack_require__(34);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__isSunday_index_js__ = __webpack_require__(46);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__isSaturday_index_js__ = __webpack_require__(74);
      /**
       * @name addBusinessDays
       * @category Day Helpers
       * @summary Add the specified number of business days (mon - fri) to the given date.
       *
       * @description
       * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of business days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the business days added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 10 business days to 1 September 2014:
       * const result = addBusinessDays(new Date(2014, 8, 1), 10)
       * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
       */


      function addBusinessDays(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var startedOnWeekend = Object(__WEBPACK_IMPORTED_MODULE_0__isWeekend_index_js__["a"
        /* default */
        ])(date);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        if (isNaN(amount)) return new Date(NaN);
        var hours = date.getHours();
        var sign = amount < 0 ? -1 : 1;
        var fullWeeks = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ])(amount / 5);
        date.setDate(date.getDate() + fullWeeks * 7); // Get remaining days not part of a full week

        var restDays = Math.abs(amount % 5); // Loops over remaining days

        while (restDays > 0) {
          date.setDate(date.getDate() + sign);
          if (!Object(__WEBPACK_IMPORTED_MODULE_0__isWeekend_index_js__["a"
          /* default */
          ])(date)) restDays -= 1;
        } // If the date is a weekend day and we reduce a dividable of
        // 5 from it, we land on a weekend date.
        // To counter this, we add days accordingly to land on the next business day


        if (startedOnWeekend && Object(__WEBPACK_IMPORTED_MODULE_0__isWeekend_index_js__["a"
        /* default */
        ])(date) && amount !== 0) {
          // If we're reducing days, we want to add days until we land on a weekday
          // If we're adding days we want to reduce days until we land on a weekday
          if (Object(__WEBPACK_IMPORTED_MODULE_5__isSaturday_index_js__["a"
          /* default */
          ])(date)) date.setDate(date.getDate() + (sign < 0 ? 2 : -1));
          if (Object(__WEBPACK_IMPORTED_MODULE_4__isSunday_index_js__["a"
          /* default */
          ])(date)) date.setDate(date.getDate() + (sign < 0 ? 1 : -2));
        } // Restore hours to avoid DST lag


        date.setHours(hours);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSaturday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSaturday
       * @category Weekday Helpers
       * @summary Is the given date Saturday?
       *
       * @description
       * Is the given date Saturday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Saturday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 27 September 2014 Saturday?
       * var result = isSaturday(new Date(2014, 8, 27))
       * //=> true
       */


      function isSaturday(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate).getDay() === 6;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addISOWeekYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__getISOWeekYear_index_js__ = __webpack_require__(23);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__setISOWeekYear_index_js__ = __webpack_require__(76);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addISOWeekYears
       * @category ISO Week-Numbering Year Helpers
       * @summary Add the specified number of ISO week-numbering years to the given date.
       *
       * @description
       * Add the specified number of ISO week-numbering years to the given date.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `addISOYears` to `addISOWeekYears`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of ISO week-numbering years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the ISO week-numbering years added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 5 ISO week-numbering years to 2 July 2010:
       * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
       * //=> Fri Jun 26 2015 00:00:00
       */


      function addISOWeekYears(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_2__setISOWeekYear_index_js__["a"
        /* default */
        ])(dirtyDate, Object(__WEBPACK_IMPORTED_MODULE_1__getISOWeekYear_index_js__["a"
        /* default */
        ])(dirtyDate) + amount);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setISOWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__ = __webpack_require__(29);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__differenceInCalendarDays_index_js__ = __webpack_require__(20);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setISOWeekYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Set the ISO week-numbering year to the given date.
       *
       * @description
       * Set the ISO week-numbering year to the given date,
       * saving the week number and the weekday number.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `setISOYear` to `setISOWeekYear`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} isoWeekYear - the ISO week-numbering year of the new date
       * @returns {Date} the new date with the ISO week-numbering year set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set ISO week-numbering year 2007 to 29 December 2008:
       * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
       * //=> Mon Jan 01 2007 00:00:00
       */


      function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
        Object(__WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var isoWeekYear = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyISOWeekYear);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_3__differenceInCalendarDays_index_js__["a"
        /* default */
        ])(date, Object(__WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__["a"
        /* default */
        ])(date));
        var fourthOfJanuary = new Date(0);
        fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
        fourthOfJanuary.setHours(0, 0, 0, 0);
        date = Object(__WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__["a"
        /* default */
        ])(fourthOfJanuary);
        date.setDate(date.getDate() + diff);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addSeconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(28);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addSeconds
       * @category Second Helpers
       * @summary Add the specified number of seconds to the given date.
       *
       * @description
       * Add the specified number of seconds to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the seconds added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 30 seconds to 10 July 2014 12:45:00:
       * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
       * //=> Thu Jul 10 2014 12:45:30
       */


      function addSeconds(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a"
        /* default */
        ])(dirtyDate, amount * 1000);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(27);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addYears
       * @category Year Helpers
       * @summary Add the specified number of years to the given date.
       *
       * @description
       * Add the specified number of years to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the years added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 5 years to 1 September 2014:
       * const result = addYears(new Date(2014, 8, 1), 5)
       * //=> Sun Sep 01 2019 00:00:00
       */


      function addYears(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["a"
        /* default */
        ])(dirtyDate, amount * 12);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = max;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name max
       * @category Common Helpers
       * @summary Return the latest of the given dates.
       *
       * @description
       * Return the latest of the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - `max` function now accepts an array of dates rather than spread arguments.
       *
       *   ```javascript
       *   // Before v2.0.0
       *   var date1 = new Date(1989, 6, 10)
       *   var date2 = new Date(1987, 1, 11)
       *   var maxDate = max(date1, date2)
       *
       *   // v2.0.0 onward:
       *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
       *   var maxDate = max(dates)
       *   ```
       *
       * @param {Date[]|Number[]} datesArray - the dates to compare
       * @returns {Date} the latest of the dates
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which of these dates is the latest?
       * var result = max([
       *   new Date(1989, 6, 10),
       *   new Date(1987, 1, 11),
       *   new Date(1995, 6, 2),
       *   new Date(1990, 0, 1)
       * ])
       * //=> Sun Jul 02 1995 00:00:00
       */


      function max(dirtyDatesArray) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

        if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") {
          datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
        } else if (typeof dirtyDatesArray === "object" && dirtyDatesArray !== null) {
          datesArray = Array.prototype.slice.call(dirtyDatesArray);
        } else {
          // `dirtyDatesArray` is non-iterable, return Invalid Date
          return new Date(NaN);
        }

        var result;
        datesArray.forEach(function (dirtyDate) {
          var currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ])(dirtyDate);

          if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
            result = currentDate;
          }
        });
        return result || new Date(NaN);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = min;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name min
       * @category Common Helpers
       * @summary Returns the earliest of the given dates.
       *
       * @description
       * Returns the earliest of the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - `min` function now accepts an array of dates rather than spread arguments.
       *
       *   ```javascript
       *   // Before v2.0.0
       *   const date1 = new Date(1989, 6, 10)
       *   const date2 = new Date(1987, 1, 11)
       *   const minDate = min(date1, date2)
       *
       *   // v2.0.0 onward:
       *   const dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
       *   const minDate = min(dates)
       *   ```
       *
       * @param {Date[]|Number[]} datesArray - the dates to compare
       * @returns {Date} - the earliest of the dates
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which of these dates is the earliest?
       * const result = min([
       *   new Date(1989, 6, 10),
       *   new Date(1987, 1, 11),
       *   new Date(1995, 6, 2),
       *   new Date(1990, 0, 1)
       * ])
       * //=> Wed Feb 11 1987 00:00:00
       */


      function min(dirtyDatesArray) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

        if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") {
          datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
        } else if (typeof dirtyDatesArray === "object" && dirtyDatesArray !== null) {
          datesArray = Array.prototype.slice.call(dirtyDatesArray);
        } else {
          // `dirtyDatesArray` is non-iterable, return Invalid Date
          return new Date(NaN);
        }

        var result;
        datesArray.forEach(function (dirtyDate) {
          var currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ])(dirtyDate);

          if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
            result = currentDate;
          }
        });
        return result || new Date(NaN);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isDate;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isDate
       * @category Common Helpers
       * @summary Is the given value a date?
       *
       * @description
       * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {*} value - the value to check
       * @returns {boolean} true if the given value is a date
       * @throws {TypeError} 1 arguments required
       *
       * @example
       * // For a valid date:
       * const result = isDate(new Date())
       * //=> true
       *
       * @example
       * // For an invalid date:
       * const result = isDate(new Date(NaN))
       * //=> true
       *
       * @example
       * // For some value:
       * const result = isDate('2014-02-31')
       * //=> false
       *
       * @example
       * // For an object:
       * const result = isDate({})
       * //=> false
       */


      function isDate(value) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInCalendarISOWeekYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__ = __webpack_require__(23);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInCalendarISOWeekYears
       * @category ISO Week-Numbering Year Helpers
       * @summary Get the number of calendar ISO week-numbering years between the given dates.
       *
       * @description
       * Get the number of calendar ISO week-numbering years between the given dates.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `differenceInCalendarISOYears` to `differenceInCalendarISOWeekYears`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of calendar ISO week-numbering years
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
       * const result = differenceInCalendarISOWeekYears(
       *   new Date(2012, 0, 1),
       *   new Date(2010, 0, 1)
       * )
       * //=> 2
       */


      function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a"
        /* default */
        ])(dirtyDateLeft) - Object(__WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a"
        /* default */
        ])(dirtyDateRight);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInCalendarMonths;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInCalendarMonths
       * @category Month Helpers
       * @summary Get the number of calendar months between the given dates.
       *
       * @description
       * Get the number of calendar months between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of calendar months
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many calendar months are between 31 January 2014 and 1 September 2014?
       * var result = differenceInCalendarMonths(
       *   new Date(2014, 8, 1),
       *   new Date(2014, 0, 31)
       * )
       * //=> 8
       */


      function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
        var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
        return yearDiff * 12 + monthDiff;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getQuarter;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getQuarter
       * @category Quarter Helpers
       * @summary Get the year quarter of the given date.
       *
       * @description
       * Get the year quarter of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the quarter
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which quarter is 2 July 2014?
       * const result = getQuarter(new Date(2014, 6, 2))
       * //=> 3
       */


      function getQuarter(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var quarter = Math.floor(date.getMonth() / 3) + 1;
        return quarter;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInCalendarWeeks;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(12);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(11);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000;
      /**
       * @name differenceInCalendarWeeks
       * @category Week Helpers
       * @summary Get the number of calendar weeks between the given dates.
       *
       * @description
       * Get the number of calendar weeks between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Number} the number of calendar weeks
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
       * const result = differenceInCalendarWeeks(
       *   new Date(2014, 6, 20),
       *   new Date(2014, 6, 5)
       * )
       * //=> 3
       *
       * @example
       * // If the week starts on Monday,
       * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
       * const result = differenceInCalendarWeeks(
       *   new Date(2014, 6, 20),
       *   new Date(2014, 6, 5),
       *   { weekStartsOn: 1 }
       * )
       * //=> 2
       */

      function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var startOfWeekLeft = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ])(dirtyDateLeft, dirtyOptions);
        var startOfWeekRight = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ])(dirtyDateRight, dirtyOptions);
        var timestampLeft = startOfWeekLeft.getTime() - Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(startOfWeekLeft);
        var timestampRight = startOfWeekRight.getTime() - Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(startOfWeekRight); // Round the number of days to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)

        return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInCalendarYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInCalendarYears
       * @category Year Helpers
       * @summary Get the number of calendar years between the given dates.
       *
       * @description
       * Get the number of calendar years between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of calendar years
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many calendar years are between 31 December 2013 and 11 February 2015?
       * const result = differenceInCalendarYears(
       *   new Date(2015, 1, 11),
       *   new Date(2013, 11, 31)
       * )
       * //=> 2
       */


      function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        return dateLeft.getFullYear() - dateRight.getFullYear();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInHours;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__constants_index_js__ = __webpack_require__(7);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInMilliseconds_index_js__ = __webpack_require__(37);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_roundingMethods_index_js__ = __webpack_require__(31);
      /**
       * @name differenceInHours
       * @category Hour Helpers
       * @summary Get the number of hours between the given dates.
       *
       * @description
       * Get the number of hours between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @param {Object} [options] - an object with options.
       * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
       * @returns {Number} the number of hours
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
       * const result = differenceInHours(
       *   new Date(2014, 6, 2, 19, 0),
       *   new Date(2014, 6, 2, 6, 50)
       * )
       * //=> 12
       */


      function differenceInHours(dateLeft, dateRight, options) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);

        var diff = Object(__WEBPACK_IMPORTED_MODULE_1__differenceInMilliseconds_index_js__["a"
        /* default */
        ])(dateLeft, dateRight) / __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["b"
        /* millisecondsInHour */
        ];

        return Object(__WEBPACK_IMPORTED_MODULE_3__lib_roundingMethods_index_js__["a"
        /* getRoundingMethod */
        ])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subISOWeekYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addISOWeekYears_index_js__ = __webpack_require__(75);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subISOWeekYears
       * @category ISO Week-Numbering Year Helpers
       * @summary Subtract the specified number of ISO week-numbering years from the given date.
       *
       * @description
       * Subtract the specified number of ISO week-numbering years from the given date.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `subISOYears` to `subISOWeekYears`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of ISO week-numbering years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the ISO week-numbering years subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 5 ISO week-numbering years from 1 September 2014:
       * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
       * //=> Mon Aug 31 2009 00:00:00
       */


      function subISOWeekYears(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addISOWeekYears_index_js__["a"
        /* default */
        ])(dirtyDate, -amount);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInMinutes;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__constants_index_js__ = __webpack_require__(7);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInMilliseconds_index_js__ = __webpack_require__(37);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_roundingMethods_index_js__ = __webpack_require__(31);
      /**
       * @name differenceInMinutes
       * @category Minute Helpers
       * @summary Get the number of minutes between the given dates.
       *
       * @description
       * Get the signed number of full (rounded towards 0) minutes between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @param {Object} [options] - an object with options.
       * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
       * @returns {Number} the number of minutes
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
       * const result = differenceInMinutes(
       *   new Date(2014, 6, 2, 12, 20, 0),
       *   new Date(2014, 6, 2, 12, 7, 59)
       * )
       * //=> 12
       *
       * @example
       * // How many minutes are between 10:01:59 and 10:00:00
       * const result = differenceInMinutes(
       *   new Date(2000, 0, 1, 10, 0, 0),
       *   new Date(2000, 0, 1, 10, 1, 59)
       * )
       * //=> -1
       */


      function differenceInMinutes(dateLeft, dateRight, options) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);

        var diff = Object(__WEBPACK_IMPORTED_MODULE_1__differenceInMilliseconds_index_js__["a"
        /* default */
        ])(dateLeft, dateRight) / __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["c"
        /* millisecondsInMinute */
        ];

        return Object(__WEBPACK_IMPORTED_MODULE_3__lib_roundingMethods_index_js__["a"
        /* getRoundingMethod */
        ])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isLastDayOfMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__endOfDay_index_js__ = __webpack_require__(51);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__ = __webpack_require__(52);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isLastDayOfMonth
       * @category Month Helpers
       * @summary Is the given date the last day of a month?
       *
       * @description
       * Is the given date the last day of a month?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is the last day of a month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 28 February 2014 the last day of a month?
       * var result = isLastDayOfMonth(new Date(2014, 1, 28))
       * //=> true
       */


      function isLastDayOfMonth(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        return Object(__WEBPACK_IMPORTED_MODULE_1__endOfDay_index_js__["a"
        /* default */
        ])(date).getTime() === Object(__WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__["a"
        /* default */
        ])(date).getTime();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarYears_index_js__ = __webpack_require__(86);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(21);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInYears
       * @category Year Helpers
       * @summary Get the number of full years between the given dates.
       *
       * @description
       * Get the number of full years between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of full years
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many full years are between 31 December 2013 and 11 February 2015?
       * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
       * //=> 1
       */


      function differenceInYears(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        var sign = Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a"
        /* default */
        ])(dateLeft, dateRight);
        var difference = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarYears_index_js__["a"
        /* default */
        ])(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
        // with leap days

        dateLeft.setFullYear(1584);
        dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
        // If so, result must be decreased by 1 in absolute value

        var isLastYearNotFull = Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a"
        /* default */
        ])(dateLeft, dateRight) === -sign;
        var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero

        return result === 0 ? 0 : result;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = eachDayOfInterval;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachDayOfInterval
       * @category Interval Helpers
       * @summary Return the array of dates within the specified time interval.
       *
       * @description
       * Return the array of dates within the specified time interval.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `eachDay` to `eachDayOfInterval`.
       *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
       *
       *   ```
       *   2.1.3
       *   time interval
       *   part of the time axis limited by two instants
       *   ```
       *
       *   Also, this function now accepts an object with `start` and `end` properties
       *   instead of two arguments as an interval.
       *   This function now throws `RangeError` if the start of the interval is after its end
       *   or if any date in the interval is `Invalid Date`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
       *
       *   // v2.0.0 onward
       *
       *   eachDayOfInterval(
       *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
       *   )
       *   ```
       *
       * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
       * @param {Object} [options] - an object with options.
       * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
       * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.step` must be a number greater than 1
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Each day between 6 October 2014 and 10 October 2014:
       * const result = eachDayOfInterval({
       *   start: new Date(2014, 9, 6),
       *   end: new Date(2014, 9, 10)
       * })
       * //=> [
       * //   Mon Oct 06 2014 00:00:00,
       * //   Tue Oct 07 2014 00:00:00,
       * //   Wed Oct 08 2014 00:00:00,
       * //   Thu Oct 09 2014 00:00:00,
       * //   Fri Oct 10 2014 00:00:00
       * // ]
       */


      function eachDayOfInterval(dirtyInterval, options) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var interval = dirtyInterval || {};
        var startDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(interval.start);
        var endDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(interval.end);
        var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(startDate.getTime() <= endTime)) {
          throw new RangeError("Invalid interval");
        }

        var dates = [];
        var currentDate = startDate;
        currentDate.setHours(0, 0, 0, 0);
        var step = options && "step" in options ? Number(options.step) : 1;
        if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number greater than 1");

        while (currentDate.getTime() <= endTime) {
          dates.push(Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ])(currentDate));
          currentDate.setDate(currentDate.getDate() + step);
          currentDate.setHours(0, 0, 0, 0);
        }

        return dates;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfYear
       * @category Year Helpers
       * @summary Return the end of a year for the given date.
       *
       * @description
       * Return the end of a year for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of a year for 2 September 2014 11:55:00:
       * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
       * //=> Wed Dec 31 2014 23:59:59.999
       */


      function endOfYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var year = date.getFullYear();
        date.setFullYear(year + 1, 0, 0);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfWeek
       * @category Week Helpers
       * @summary Return the end of a week for the given date.
       *
       * @description
       * Return the end of a week for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Date} the end of a week
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // The end of a week for 2 September 2014 11:55:00:
       * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Sat Sep 06 2014 23:59:59.999
       *
       * @example
       * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
       * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
       * //=> Sun Sep 07 2014 23:59:59.999
       */


      function endOfWeek(dirtyDate, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ])(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
        }

        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var day = date.getDay();
        var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
        date.setDate(date.getDate() + diff);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = format;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isValid_index_js__ = __webpack_require__(9);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__locale_en_US_index_js__ = __webpack_require__(24);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__subMilliseconds_index_js__ = __webpack_require__(32);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_format_formatters_index_js__ = __webpack_require__(539);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_format_longFormatters_index_js__ = __webpack_require__(100);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(11);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__ = __webpack_require__(101);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__ = __webpack_require__(0); // This RegExp consists of three parts separated by `|`:
      // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
      //   (one of the certain letters followed by `o`)
      // - (\w)\1* matches any sequences of the same letter
      // - '' matches two quote characters in a row
      // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
      //   except a single quote symbol, which ends the sequence.
      //   Two quote characters do not end the sequence.
      //   If there is no matching single quote
      //   then the sequence will continue until the end of the string.
      // - . matches any single character unmatched by previous parts of the RegExps


      var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
      // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

      var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      var escapedStringRegExp = /^'([^]*?)'?$/;
      var doubleQuoteRegExp = /''/g;
      var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
      /**
       * @name format
       * @category Common Helpers
       * @summary Format the date.
       *
       * @description
       * Return the formatted date string in the given format. The result may vary by locale.
       *
       * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
       * > See: https://git.io/fxCyr
       *
       * The characters wrapped between two single quotes characters (') are escaped.
       * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
       * (see the last example)
       *
       * Format of the string is based on Unicode Technical Standard #35:
       * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
       * with a few additions (see note 7 below the table).
       *
       * Accepted patterns:
       * | Unit                            | Pattern | Result examples                   | Notes |
       * |---------------------------------|---------|-----------------------------------|-------|
       * | Era                             | G..GGG  | AD, BC                            |       |
       * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
       * |                                 | GGGGG   | A, B                              |       |
       * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
       * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
       * |                                 | yy      | 44, 01, 00, 17                    | 5     |
       * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
       * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
       * |                                 | yyyyy   | ...                               | 3,5   |
       * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
       * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
       * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
       * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
       * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
       * |                                 | YYYYY   | ...                               | 3,5   |
       * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
       * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
       * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
       * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
       * |                                 | RRRRR   | ...                               | 3,5,7 |
       * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
       * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
       * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
       * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
       * |                                 | uuuuu   | ...                               | 3,5   |
       * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
       * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
       * |                                 | QQ      | 01, 02, 03, 04                    |       |
       * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
       * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
       * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
       * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
       * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
       * |                                 | qq      | 01, 02, 03, 04                    |       |
       * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
       * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
       * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
       * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
       * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
       * |                                 | MM      | 01, 02, ..., 12                   |       |
       * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
       * |                                 | MMMM    | January, February, ..., December  | 2     |
       * |                                 | MMMMM   | J, F, ..., D                      |       |
       * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
       * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
       * |                                 | LL      | 01, 02, ..., 12                   |       |
       * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
       * |                                 | LLLL    | January, February, ..., December  | 2     |
       * |                                 | LLLLL   | J, F, ..., D                      |       |
       * | Local week of year              | w       | 1, 2, ..., 53                     |       |
       * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
       * |                                 | ww      | 01, 02, ..., 53                   |       |
       * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
       * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
       * |                                 | II      | 01, 02, ..., 53                   | 7     |
       * | Day of month                    | d       | 1, 2, ..., 31                     |       |
       * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
       * |                                 | dd      | 01, 02, ..., 31                   |       |
       * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
       * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
       * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
       * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
       * |                                 | DDDD    | ...                               | 3     |
       * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
       * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
       * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
       * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
       * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
       * |                                 | ii      | 01, 02, ..., 07                   | 7     |
       * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
       * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
       * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
       * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
       * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
       * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
       * |                                 | ee      | 02, 03, ..., 01                   |       |
       * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
       * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
       * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
       * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
       * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
       * |                                 | cc      | 02, 03, ..., 01                   |       |
       * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
       * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
       * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
       * | AM, PM                          | a..aa   | AM, PM                            |       |
       * |                                 | aaa     | am, pm                            |       |
       * |                                 | aaaa    | a.m., p.m.                        | 2     |
       * |                                 | aaaaa   | a, p                              |       |
       * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
       * |                                 | bbb     | am, pm, noon, midnight            |       |
       * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
       * |                                 | bbbbb   | a, p, n, mi                       |       |
       * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
       * |                                 | BBBB    | at night, in the morning, ...     | 2     |
       * |                                 | BBBBB   | at night, in the morning, ...     |       |
       * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
       * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
       * |                                 | hh      | 01, 02, ..., 11, 12               |       |
       * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
       * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
       * |                                 | HH      | 00, 01, 02, ..., 23               |       |
       * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
       * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
       * |                                 | KK      | 01, 02, ..., 11, 00               |       |
       * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
       * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
       * |                                 | kk      | 24, 01, 02, ..., 23               |       |
       * | Minute                          | m       | 0, 1, ..., 59                     |       |
       * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
       * |                                 | mm      | 00, 01, ..., 59                   |       |
       * | Second                          | s       | 0, 1, ..., 59                     |       |
       * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
       * |                                 | ss      | 00, 01, ..., 59                   |       |
       * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
       * |                                 | SS      | 00, 01, ..., 99                   |       |
       * |                                 | SSS     | 000, 001, ..., 999                |       |
       * |                                 | SSSS    | ...                               | 3     |
       * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
       * |                                 | XX      | -0800, +0530, Z                   |       |
       * |                                 | XXX     | -08:00, +05:30, Z                 |       |
       * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
       * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
       * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
       * |                                 | xx      | -0800, +0530, +0000               |       |
       * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
       * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
       * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
       * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
       * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
       * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
       * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
       * | Seconds timestamp               | t       | 512969520                         | 7     |
       * |                                 | tt      | ...                               | 3,7   |
       * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
       * |                                 | TT      | ...                               | 3,7   |
       * | Long localized date             | P       | 04/29/1453                        | 7     |
       * |                                 | PP      | Apr 29, 1453                      | 7     |
       * |                                 | PPP     | April 29th, 1453                  | 7     |
       * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
       * | Long localized time             | p       | 12:00 AM                          | 7     |
       * |                                 | pp      | 12:00:00 AM                       | 7     |
       * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
       * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
       * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
       * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
       * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
       * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
       * Notes:
       * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
       *    are the same as "stand-alone" units, but are different in some languages.
       *    "Formatting" units are declined according to the rules of the language
       *    in the context of a date. "Stand-alone" units are always nominative singular:
       *
       *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
       *
       *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
       *
       * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
       *    the single quote characters (see below).
       *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
       *    the output will be the same as default pattern for this unit, usually
       *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
       *    are marked with "2" in the last column of the table.
       *
       *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
       *
       *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
       *
       *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
       *
       *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
       *
       *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
       *
       * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
       *    The output will be padded with zeros to match the length of the pattern.
       *
       *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
       *
       * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
       *    These tokens represent the shortest form of the quarter.
       *
       * 5. The main difference between `y` and `u` patterns are B.C. years:
       *
       *    | Year | `y` | `u` |
       *    |------|-----|-----|
       *    | AC 1 |   1 |   1 |
       *    | BC 1 |   1 |   0 |
       *    | BC 2 |   2 |  -1 |
       *
       *    Also `yy` always returns the last two digits of a year,
       *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
       *
       *    | Year | `yy` | `uu` |
       *    |------|------|------|
       *    | 1    |   01 |   01 |
       *    | 14   |   14 |   14 |
       *    | 376  |   76 |  376 |
       *    | 1453 |   53 | 1453 |
       *
       *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
       *    except local week-numbering years are dependent on `options.weekStartsOn`
       *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
       *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
       *
       * 6. Specific non-location timezones are currently unavailable in `date-fns`,
       *    so right now these tokens fall back to GMT timezones.
       *
       * 7. These patterns are not in the Unicode Technical Standard #35:
       *    - `i`: ISO day of week
       *    - `I`: ISO week of year
       *    - `R`: ISO week-numbering year
       *    - `t`: seconds timestamp
       *    - `T`: milliseconds timestamp
       *    - `o`: ordinal number modifier
       *    - `P`: long localized date
       *    - `p`: long localized time
       *
       * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
       *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
       *
       * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
       *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The second argument is now required for the sake of explicitness.
       *
       *   ```javascript
       *   // Before v2.0.0
       *   format(new Date(2016, 0, 1))
       *
       *   // v2.0.0 onward
       *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
       *   ```
       *
       * - New format string API for `format` function
       *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
       *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
       *
       * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
       *
       * @param {Date|Number} date - the original date
       * @param {String} format - the string of tokens
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
       * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
       *   see: https://git.io/fxCyr
       * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
       *   see: https://git.io/fxCyr
       * @returns {String} the formatted date string
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `options.locale` must contain `localize` property
       * @throws {RangeError} `options.locale` must contain `formatLong` property
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} format string contains an unescaped latin alphabet character
       *
       * @example
       * // Represent 11 February 2014 in middle-endian format:
       * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
       * //=> '02/11/2014'
       *
       * @example
       * // Represent 2 July 2014 in Esperanto:
       * import { eoLocale } from 'date-fns/locale/eo'
       * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
       *   locale: eoLocale
       * })
       * //=> '2-a de julio 2014'
       *
       * @example
       * // Escape string by single quote characters:
       * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
       * //=> "3 o'clock"
       */

      function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var locale = options.locale || __WEBPACK_IMPORTED_MODULE_1__locale_en_US_index_js__["a"
        /* default */
        ];
        var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a"
        /* default */
        ])(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a"
        /* default */
        ])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
          throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
        }

        var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a"
        /* default */
        ])(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a"
        /* default */
        ])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
        }

        if (!locale.localize) {
          throw new RangeError("locale must contain localize property");
        }

        if (!locale.formatLong) {
          throw new RangeError("locale must contain formatLong property");
        }

        var originalDate = Object(__WEBPACK_IMPORTED_MODULE_3__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);

        if (!Object(__WEBPACK_IMPORTED_MODULE_0__isValid_index_js__["a"
        /* default */
        ])(originalDate)) {
          throw new RangeError("Invalid time value");
        } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
        // This ensures that when UTC functions will be implemented, locales will be compatible with them.
        // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


        var timezoneOffset = Object(__WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(originalDate);
        var utcDate = Object(__WEBPACK_IMPORTED_MODULE_2__subMilliseconds_index_js__["a"
        /* default */
        ])(originalDate, timezoneOffset);
        var formatterOptions = {
          firstWeekContainsDate: firstWeekContainsDate,
          weekStartsOn: weekStartsOn,
          locale: locale,
          _originalDate: originalDate
        };
        var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
          var firstCharacter = substring[0];

          if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = __WEBPACK_IMPORTED_MODULE_5__lib_format_longFormatters_index_js__["a"
            /* default */
            ][firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
          }

          return substring;
        }).join("").match(formattingTokensRegExp).map(function (substring) {
          // Replace two single quote characters with one single quote character
          if (substring === "''") {
            return "'";
          }

          var firstCharacter = substring[0];

          if (firstCharacter === "'") {
            return cleanEscapedString(substring);
          }

          var formatter = __WEBPACK_IMPORTED_MODULE_4__lib_format_formatters_index_js__["a"
          /* default */
          ][firstCharacter];

          if (formatter) {
            if (!options.useAdditionalWeekYearTokens && Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["b"
            /* isProtectedWeekYearToken */
            ])(substring)) {
              Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["c"
              /* throwProtectedError */
              ])(substring, dirtyFormatStr, dirtyDate);
            }

            if (!options.useAdditionalDayOfYearTokens && Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["a"
            /* isProtectedDayOfYearToken */
            ])(substring)) {
              Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["c"
              /* throwProtectedError */
              ])(substring, dirtyFormatStr, dirtyDate);
            }

            return formatter(utcDate, substring, locale.localize, formatterOptions);
          }

          if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
            throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
          }

          return substring;
        }).join("");
        return result;
      }

      function cleanEscapedString(input) {
        return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__ = __webpack_require__(25);
      /*
       * |     | Unit                           |     | Unit                           |
       * |-----|--------------------------------|-----|--------------------------------|
       * |  a  | AM, PM                         |  A* |                                |
       * |  d  | Day of month                   |  D  |                                |
       * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
       * |  m  | Minute                         |  M  | Month                          |
       * |  s  | Second                         |  S  | Fraction of second             |
       * |  y  | Year (abs)                     |  Y  |                                |
       *
       * Letters marked by * are not implemented but reserved by Unicode standard.
       */


      var formatters = {
        // Year
        y: function (date, token) {
          // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
          // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
          // |----------|-------|----|-------|-------|-------|
          // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
          // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
          // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
          // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
          // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
          var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

          var year = signedYear > 0 ? signedYear : 1 - signedYear;
          return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ])(token === "yy" ? year % 100 : year, token.length);
        },
        // Month
        M: function (date, token) {
          var month = date.getUTCMonth();
          return token === "M" ? String(month + 1) : Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ])(month + 1, 2);
        },
        // Day of the month
        d: function (date, token) {
          return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ])(date.getUTCDate(), token.length);
        },
        // AM or PM
        a: function (date, token) {
          var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";

          switch (token) {
            case "a":
            case "aa":
              return dayPeriodEnumValue.toUpperCase();

            case "aaa":
              return dayPeriodEnumValue;

            case "aaaaa":
              return dayPeriodEnumValue[0];

            case "aaaa":
            default:
              return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
          }
        },
        // Hour [1-12]
        h: function (date, token) {
          return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ])(date.getUTCHours() % 12 || 12, token.length);
        },
        // Hour [0-23]
        H: function (date, token) {
          return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ])(date.getUTCHours(), token.length);
        },
        // Minute
        m: function (date, token) {
          return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ])(date.getUTCMinutes(), token.length);
        },
        // Second
        s: function (date, token) {
          return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ])(date.getUTCSeconds(), token.length);
        },
        // Fraction of second
        S: function (date, token) {
          var numberOfDigits = token.length;
          var milliseconds = date.getUTCMilliseconds();
          var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
          return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ])(fractionalSeconds, token.length);
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatters;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getUTCISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(40);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__ = __webpack_require__(541);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376

      function getUTCISOWeek(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a"
        /* default */
        ])(date).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__["a"
        /* default */
        ])(date).getTime(); // Round the number of days to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)

        return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getUTCISOWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(40);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function getUTCISOWeekYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var year = date.getUTCFullYear();
        var fourthOfJanuaryOfNextYear = new Date(0);
        fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
        fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
        var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a"
        /* default */
        ])(fourthOfJanuaryOfNextYear);
        var fourthOfJanuaryOfThisYear = new Date(0);
        fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
        fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
        var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a"
        /* default */
        ])(fourthOfJanuaryOfThisYear);

        if (date.getTime() >= startOfNextYear.getTime()) {
          return year + 1;
        } else if (date.getTime() >= startOfThisYear.getTime()) {
          return year;
        } else {
          return year - 1;
        }
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getUTCWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__ = __webpack_require__(41);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__ = __webpack_require__(542);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376

      function getUTCWeek(dirtyDate, options) {
        Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__["a"
        /* default */
        ])(date, options).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__["a"
        /* default */
        ])(date, options).getTime(); // Round the number of days to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)

        return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      function dateLongFormatter(pattern, formatLong) {
        switch (pattern) {
          case "P":
            return formatLong.date({
              width: "short"
            });

          case "PP":
            return formatLong.date({
              width: "medium"
            });

          case "PPP":
            return formatLong.date({
              width: "long"
            });

          case "PPPP":
          default:
            return formatLong.date({
              width: "full"
            });
        }
      }

      function timeLongFormatter(pattern, formatLong) {
        switch (pattern) {
          case "p":
            return formatLong.time({
              width: "short"
            });

          case "pp":
            return formatLong.time({
              width: "medium"
            });

          case "ppp":
            return formatLong.time({
              width: "long"
            });

          case "pppp":
          default:
            return formatLong.time({
              width: "full"
            });
        }
      }

      function dateTimeLongFormatter(pattern, formatLong) {
        var matchResult = pattern.match(/(P+)(p+)?/);
        var datePattern = matchResult[1];
        var timePattern = matchResult[2];

        if (!timePattern) {
          return dateLongFormatter(pattern, formatLong);
        }

        var dateTimeFormat;

        switch (datePattern) {
          case "P":
            dateTimeFormat = formatLong.dateTime({
              width: "short"
            });
            break;

          case "PP":
            dateTimeFormat = formatLong.dateTime({
              width: "medium"
            });
            break;

          case "PPP":
            dateTimeFormat = formatLong.dateTime({
              width: "long"
            });
            break;

          case "PPPP":
          default:
            dateTimeFormat = formatLong.dateTime({
              width: "full"
            });
            break;
        }

        return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
      }

      var longFormatters = {
        p: timeLongFormatter,
        P: dateTimeLongFormatter
      };
      /* harmony default export */

      __webpack_exports__["a"] = longFormatters;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isProtectedDayOfYearToken;
      /* harmony export (immutable) */

      __webpack_exports__["b"] = isProtectedWeekYearToken;
      /* harmony export (immutable) */

      __webpack_exports__["c"] = throwProtectedError;
      var protectedDayOfYearTokens = ["D", "DD"];
      var protectedWeekYearTokens = ["YY", "YYYY"];

      function isProtectedDayOfYearToken(token) {
        return protectedDayOfYearTokens.indexOf(token) !== -1;
      }

      function isProtectedWeekYearToken(token) {
        return protectedWeekYearTokens.indexOf(token) !== -1;
      }

      function throwProtectedError(token, format, input) {
        if (token === "YYYY") {
          throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        } else if (token === "YY") {
          throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        } else if (token === "D") {
          throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        } else if (token === "DD") {
          throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        }
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__ = __webpack_require__(21);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInMonths_index_js__ = __webpack_require__(38);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__differenceInSeconds_index_js__ = __webpack_require__(53);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__locale_en_US_index_js__ = __webpack_require__(24);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_cloneObject_index_js__ = __webpack_require__(103);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(11);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MINUTES_IN_DAY = 1440;
      var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
      var MINUTES_IN_MONTH = 43200;
      var MINUTES_IN_TWO_MONTHS = 86400;
      /**
       * @name formatDistance
       * @category Common Helpers
       * @summary Return the distance between the given dates in words.
       *
       * @description
       * Return the distance between the given dates in words.
       *
       * | Distance between dates                                            | Result              |
       * |-------------------------------------------------------------------|---------------------|
       * | 0 ... 30 secs                                                     | less than a minute  |
       * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
       * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
       * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
       * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
       * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
       * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
       * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
       * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
       * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
       * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
       * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
       * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
       * | N yrs ... N yrs 3 months                                          | about N years       |
       * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
       * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
       *
       * With `options.includeSeconds == true`:
       * | Distance between dates | Result               |
       * |------------------------|----------------------|
       * | 0 secs ... 5 secs      | less than 5 seconds  |
       * | 5 secs ... 10 secs     | less than 10 seconds |
       * | 10 secs ... 20 secs    | less than 20 seconds |
       * | 20 secs ... 40 secs    | half a minute        |
       * | 40 secs ... 60 secs    | less than a minute   |
       * | 60 secs ... 90 secs    | 1 minute             |
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `distanceInWords ` to `formatDistance`
       *   to make its name consistent with `format` and `formatRelative`.
       *
       * - The order of arguments is swapped to make the function
       *   consistent with `differenceIn...` functions.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   distanceInWords(
       *     new Date(1986, 3, 4, 10, 32, 0),
       *     new Date(1986, 3, 4, 11, 32, 0),
       *     { addSuffix: true }
       *   ) //=> 'in about 1 hour'
       *
       *   // v2.0.0 onward
       *
       *   formatDistance(
       *     new Date(1986, 3, 4, 11, 32, 0),
       *     new Date(1986, 3, 4, 10, 32, 0),
       *     { addSuffix: true }
       *   ) //=> 'in about 1 hour'
       *   ```
       *
       * @param {Date|Number} date - the date
       * @param {Date|Number} baseDate - the date to compare with
       * @param {Object} [options] - an object with options.
       * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
       * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @returns {String} the distance in words
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `baseDate` must not be Invalid Date
       * @throws {RangeError} `options.locale` must contain `formatDistance` property
       *
       * @example
       * // What is the distance between 2 July 2014 and 1 January 2015?
       * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
       * //=> '6 months'
       *
       * @example
       * // What is the distance between 1 January 2015 00:00:15
       * // and 1 January 2015 00:00:00, including seconds?
       * const result = formatDistance(
       *   new Date(2015, 0, 1, 0, 0, 15),
       *   new Date(2015, 0, 1, 0, 0, 0),
       *   { includeSeconds: true }
       * )
       * //=> 'less than 20 seconds'
       *
       * @example
       * // What is the distance from 1 January 2016
       * // to 1 January 2015, with a suffix?
       * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
       *   addSuffix: true
       * })
       * //=> 'about 1 year ago'
       *
       * @example
       * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
       * import { eoLocale } from 'date-fns/locale/eo'
       * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
       *   locale: eoLocale
       * })
       * //=> 'pli ol 1 jaro'
       */

      function formatDistance(dirtyDate, dirtyBaseDate) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object(__WEBPACK_IMPORTED_MODULE_7__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var locale = options.locale || __WEBPACK_IMPORTED_MODULE_3__locale_en_US_index_js__["a"
        /* default */
        ];

        if (!locale.formatDistance) {
          throw new RangeError("locale must contain formatDistance property");
        }

        var comparison = Object(__WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__["a"
        /* default */
        ])(dirtyDate, dirtyBaseDate);

        if (isNaN(comparison)) {
          throw new RangeError("Invalid time value");
        }

        var localizeOptions = Object(__WEBPACK_IMPORTED_MODULE_5__lib_cloneObject_index_js__["a"
        /* default */
        ])(options);
        localizeOptions.addSuffix = Boolean(options.addSuffix);
        localizeOptions.comparison = comparison;
        var dateLeft;
        var dateRight;

        if (comparison > 0) {
          dateLeft = Object(__WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a"
          /* default */
          ])(dirtyBaseDate);
          dateRight = Object(__WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a"
          /* default */
          ])(dirtyDate);
        } else {
          dateLeft = Object(__WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a"
          /* default */
          ])(dirtyDate);
          dateRight = Object(__WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a"
          /* default */
          ])(dirtyBaseDate);
        }

        var seconds = Object(__WEBPACK_IMPORTED_MODULE_2__differenceInSeconds_index_js__["a"
        /* default */
        ])(dateRight, dateLeft);
        var offsetInSeconds = (Object(__WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(dateRight) - Object(__WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(dateLeft)) / 1000;
        var minutes = Math.round((seconds - offsetInSeconds) / 60);
        var months; // 0 up to 2 mins

        if (minutes < 2) {
          if (options.includeSeconds) {
            if (seconds < 5) {
              return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            } else if (seconds < 10) {
              return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            } else if (seconds < 20) {
              return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            } else if (seconds < 40) {
              return locale.formatDistance("halfAMinute", null, localizeOptions);
            } else if (seconds < 60) {
              return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            } else {
              return locale.formatDistance("xMinutes", 1, localizeOptions);
            }
          } else {
            if (minutes === 0) {
              return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            } else {
              return locale.formatDistance("xMinutes", minutes, localizeOptions);
            }
          } // 2 mins up to 0.75 hrs

        } else if (minutes < 45) {
          return locale.formatDistance("xMinutes", minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
        } else if (minutes < 90) {
          return locale.formatDistance("aboutXHours", 1, localizeOptions); // 1.5 hrs up to 24 hrs
        } else if (minutes < MINUTES_IN_DAY) {
          var hours = Math.round(minutes / 60);
          return locale.formatDistance("aboutXHours", hours, localizeOptions); // 1 day up to 1.75 days
        } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
          return locale.formatDistance("xDays", 1, localizeOptions); // 1.75 days up to 30 days
        } else if (minutes < MINUTES_IN_MONTH) {
          var days = Math.round(minutes / MINUTES_IN_DAY);
          return locale.formatDistance("xDays", days, localizeOptions); // 1 month up to 2 months
        } else if (minutes < MINUTES_IN_TWO_MONTHS) {
          months = Math.round(minutes / MINUTES_IN_MONTH);
          return locale.formatDistance("aboutXMonths", months, localizeOptions);
        }

        months = Object(__WEBPACK_IMPORTED_MODULE_1__differenceInMonths_index_js__["a"
        /* default */
        ])(dateRight, dateLeft); // 2 months up to 12 months

        if (months < 12) {
          var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
          return locale.formatDistance("xMonths", nearestMonth, localizeOptions); // 1 year up to max Date
        } else {
          var monthsSinceStartOfYear = months % 12;
          var years = Math.floor(months / 12); // N years up to 1 years 3 months

          if (monthsSinceStartOfYear < 3) {
            return locale.formatDistance("aboutXYears", years, localizeOptions); // N years 3 months up to N years 9 months
          } else if (monthsSinceStartOfYear < 9) {
            return locale.formatDistance("overXYears", years, localizeOptions); // N years 9 months up to N year 12 months
          } else {
            return locale.formatDistance("almostXYears", years + 1, localizeOptions);
          }
        }
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = cloneObject;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__assign_index_js__ = __webpack_require__(104);

      function cloneObject(dirtyObject) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__assign_index_js__["a"
        /* default */
        ])({}, dirtyObject);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = assign;

      function assign(target, dirtyObject) {
        if (target == null) {
          throw new TypeError("assign requires that input parameter not be null or undefined");
        }

        dirtyObject = dirtyObject || {};

        for (var property in dirtyObject) {
          if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
            target[property] = dirtyObject[property];
          }
        }

        return target;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistanceStrict;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(11);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__compareAsc_index_js__ = __webpack_require__(21);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_cloneObject_index_js__ = __webpack_require__(103);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__locale_en_US_index_js__ = __webpack_require__(24);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_MINUTE = 1000 * 60;
      var MINUTES_IN_DAY = 60 * 24;
      var MINUTES_IN_MONTH = MINUTES_IN_DAY * 30;
      var MINUTES_IN_YEAR = MINUTES_IN_DAY * 365;
      /**
       * @name formatDistanceStrict
       * @category Common Helpers
       * @summary Return the distance between the given dates in words.
       *
       * @description
       * Return the distance between the given dates in words, using strict units.
       * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
       * 'less than' and the like.
       *
       * | Distance between dates | Result              |
       * |------------------------|---------------------|
       * | 0 ... 59 secs          | [0..59] seconds     |
       * | 1 ... 59 mins          | [1..59] minutes     |
       * | 1 ... 23 hrs           | [1..23] hours       |
       * | 1 ... 29 days          | [1..29] days        |
       * | 1 ... 11 months        | [1..11] months      |
       * | 1 ... N years          | [1..N]  years       |
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `distanceInWordsStrict` to `formatDistanceStrict`
       *   to make its name consistent with `format` and `formatRelative`.
       *
       * - The order of arguments is swapped to make the function
       *   consistent with `differenceIn...` functions.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   distanceInWordsStrict(
       *     new Date(2015, 0, 2),
       *     new Date(2014, 6, 2)
       *   ) //=> '6 months'
       *
       *   // v2.0.0 onward
       *
       *   formatDistanceStrict(
       *     new Date(2014, 6, 2),
       *     new Date(2015, 0, 2)
       *   ) //=> '6 months'
       *   ```
       *
       * - `partialMethod` option is renamed to `roundingMethod`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   distanceInWordsStrict(
       *     new Date(1986, 3, 4, 10, 32, 0),
       *     new Date(1986, 3, 4, 10, 33, 1),
       *     { partialMethod: 'ceil' }
       *   ) //=> '2 minutes'
       *
       *   // v2.0.0 onward
       *
       *   formatDistanceStrict(
       *     new Date(1986, 3, 4, 10, 33, 1),
       *     new Date(1986, 3, 4, 10, 32, 0),
       *     { roundingMethod: 'ceil' }
       *   ) //=> '2 minutes'
       *   ```
       *
       * - If `roundingMethod` is not specified, it now defaults to `round` instead of `floor`.
       *
       * - `unit` option now accepts one of the strings:
       *   'second', 'minute', 'hour', 'day', 'month' or 'year' instead of 's', 'm', 'h', 'd', 'M' or 'Y'
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   distanceInWordsStrict(
       *     new Date(1986, 3, 4, 10, 32, 0),
       *     new Date(1986, 3, 4, 10, 33, 1),
       *     { unit: 'm' }
       *   )
       *
       *   // v2.0.0 onward
       *
       *   formatDistanceStrict(
       *     new Date(1986, 3, 4, 10, 33, 1),
       *     new Date(1986, 3, 4, 10, 32, 0),
       *     { unit: 'minute' }
       *   )
       *   ```
       *
       * @param {Date|Number} date - the date
       * @param {Date|Number} baseDate - the date to compare with
       * @param {Object} [options] - an object with options.
       * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
       * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
       * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @returns {String} the distance in words
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `baseDate` must not be Invalid Date
       * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
       * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
       * @throws {RangeError} `options.locale` must contain `formatDistance` property
       *
       * @example
       * // What is the distance between 2 July 2014 and 1 January 2015?
       * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
       * //=> '6 months'
       *
       * @example
       * // What is the distance between 1 January 2015 00:00:15
       * // and 1 January 2015 00:00:00?
       * const result = formatDistanceStrict(
       *   new Date(2015, 0, 1, 0, 0, 15),
       *   new Date(2015, 0, 1, 0, 0, 0)
       * )
       * //=> '15 seconds'
       *
       * @example
       * // What is the distance from 1 January 2016
       * // to 1 January 2015, with a suffix?
       * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
       *   addSuffix: true
       * })
       * //=> '1 year ago'
       *
       * @example
       * // What is the distance from 1 January 2016
       * // to 1 January 2015, in minutes?
       * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
       *   unit: 'minute'
       * })
       * //=> '525600 minutes'
       *
       * @example
       * // What is the distance from 1 January 2015
       * // to 28 January 2015, in months, rounded up?
       * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
       *   unit: 'month',
       *   roundingMethod: 'ceil'
       * })
       * //=> '1 month'
       *
       * @example
       * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
       * import { eoLocale } from 'date-fns/locale/eo'
       * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
       *   locale: eoLocale
       * })
       * //=> '1 jaro'
       */

      function formatDistanceStrict(dirtyDate, dirtyBaseDate) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object(__WEBPACK_IMPORTED_MODULE_5__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var locale = options.locale || __WEBPACK_IMPORTED_MODULE_4__locale_en_US_index_js__["a"
        /* default */
        ];

        if (!locale.formatDistance) {
          throw new RangeError("locale must contain localize.formatDistance property");
        }

        var comparison = Object(__WEBPACK_IMPORTED_MODULE_1__compareAsc_index_js__["a"
        /* default */
        ])(dirtyDate, dirtyBaseDate);

        if (isNaN(comparison)) {
          throw new RangeError("Invalid time value");
        }

        var localizeOptions = Object(__WEBPACK_IMPORTED_MODULE_3__lib_cloneObject_index_js__["a"
        /* default */
        ])(options);
        localizeOptions.addSuffix = Boolean(options.addSuffix);
        localizeOptions.comparison = comparison;
        var dateLeft;
        var dateRight;

        if (comparison > 0) {
          dateLeft = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
          /* default */
          ])(dirtyBaseDate);
          dateRight = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
          /* default */
          ])(dirtyDate);
        } else {
          dateLeft = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
          /* default */
          ])(dirtyDate);
          dateRight = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
          /* default */
          ])(dirtyBaseDate);
        }

        var roundingMethod = options.roundingMethod == null ? "round" : String(options.roundingMethod);
        var roundingMethodFn;

        if (roundingMethod === "floor") {
          roundingMethodFn = Math.floor;
        } else if (roundingMethod === "ceil") {
          roundingMethodFn = Math.ceil;
        } else if (roundingMethod === "round") {
          roundingMethodFn = Math.round;
        } else {
          throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
        }

        var milliseconds = dateRight.getTime() - dateLeft.getTime();
        var minutes = milliseconds / MILLISECONDS_IN_MINUTE;
        var timezoneOffset = Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(dateRight) - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(dateLeft); // Use DST-normalized difference in minutes for years, months and days;
        // use regular difference in minutes for hours, minutes and seconds.

        var dstNormalizedMinutes = (milliseconds - timezoneOffset) / MILLISECONDS_IN_MINUTE;
        var unit;

        if (options.unit == null) {
          if (minutes < 1) {
            unit = "second";
          } else if (minutes < 60) {
            unit = "minute";
          } else if (minutes < MINUTES_IN_DAY) {
            unit = "hour";
          } else if (dstNormalizedMinutes < MINUTES_IN_MONTH) {
            unit = "day";
          } else if (dstNormalizedMinutes < MINUTES_IN_YEAR) {
            unit = "month";
          } else {
            unit = "year";
          }
        } else {
          unit = String(options.unit);
        } // 0 up to 60 seconds


        if (unit === "second") {
          var seconds = roundingMethodFn(milliseconds / 1000);
          return locale.formatDistance("xSeconds", seconds, localizeOptions); // 1 up to 60 mins
        } else if (unit === "minute") {
          var roundedMinutes = roundingMethodFn(minutes);
          return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions); // 1 up to 24 hours
        } else if (unit === "hour") {
          var hours = roundingMethodFn(minutes / 60);
          return locale.formatDistance("xHours", hours, localizeOptions); // 1 up to 30 days
        } else if (unit === "day") {
          var days = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_DAY);
          return locale.formatDistance("xDays", days, localizeOptions); // 1 up to 12 months
        } else if (unit === "month") {
          var months = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_MONTH);
          return months === 12 && options.unit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions); // 1 year up to max Date
        } else if (unit === "year") {
          var years = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_YEAR);
          return locale.formatDistance("xYears", years, localizeOptions);
        }

        throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getDate;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getDate
       * @category Day Helpers
       * @summary Get the day of the month of the given date.
       *
       * @description
       * Get the day of the month of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the day of month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which day of the month is 29 February 2012?
       * const result = getDate(new Date(2012, 1, 29))
       * //=> 29
       */


      function getDate(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var dayOfMonth = date.getDate();
        return dayOfMonth;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getDaysInMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getDaysInMonth
       * @category Month Helpers
       * @summary Get the number of days in a month of the given date.
       *
       * @description
       * Get the number of days in a month of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the number of days in a month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // How many days are in February 2000?
       * const result = getDaysInMonth(new Date(2000, 1))
       * //=> 29
       */


      function getDaysInMonth(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var year = date.getFullYear();
        var monthIndex = date.getMonth();
        var lastDayOfMonth = new Date(0);
        lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
        lastDayOfMonth.setHours(0, 0, 0, 0);
        return lastDayOfMonth.getDate();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isLeapYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isLeapYear
       * @category Year Helpers
       * @summary Is the given date in the leap year?
       *
       * @description
       * Is the given date in the leap year?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in the leap year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 1 September 2012 in the leap year?
       * var result = isLeapYear(new Date(2012, 8, 1))
       * //=> true
       */


      function isLeapYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var year = date.getFullYear();
        return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getISODay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getISODay
       * @category Weekday Helpers
       * @summary Get the day of the ISO week of the given date.
       *
       * @description
       * Get the day of the ISO week of the given date,
       * which is 7 for Sunday, 1 for Monday etc.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the day of ISO week
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which day of the ISO week is 26 February 2012?
       * const result = getISODay(new Date(2012, 1, 26))
       * //=> 7
       */


      function getISODay(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var day = date.getDay();

        if (day === 0) {
          day = 7;
        }

        return day;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__ = __webpack_require__(29);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000;
      /**
       * @name getISOWeek
       * @category ISO Week Helpers
       * @summary Get the ISO week of the given date.
       *
       * @description
       * Get the ISO week of the given date.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the ISO week
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which week of the ISO-week numbering year is 2 January 2005?
       * const result = getISOWeek(new Date(2005, 0, 2))
       * //=> 53
       */

      function getISOWeek(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ])(date).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__["a"
        /* default */
        ])(date).getTime(); // Round the number of days to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)

        return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getTime;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getTime
       * @category Timestamp Helpers
       * @summary Get the milliseconds timestamp of the given date.
       *
       * @description
       * Get the milliseconds timestamp of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the timestamp
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Get the timestamp of 29 February 2012 11:45:05.123:
       * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
       * //=> 1330515905123
       */


      function getTime(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var timestamp = date.getTime();
        return timestamp;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(12);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__ = __webpack_require__(59);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000;
      /**
       * @name getWeek
       * @category Week Helpers
       * @summary Get the local week index of the given date.
       *
       * @description
       * Get the local week index of the given date.
       * The exact calculation depends on the values of
       * `options.weekStartsOn` (which is the index of the first day of the week)
       * and `options.firstWeekContainsDate` (which is the day of January, which is always in
       * the first week of the week-numbering year)
       *
       * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @returns {Number} the week
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       *
       * @example
       * // Which week of the local week numbering year is 2 January 2005 with default options?
       * const result = getISOWeek(new Date(2005, 0, 2))
       * //=> 2
       *
       * // Which week of the local week numbering year is 2 January 2005,
       * // if Monday is the first day of the week,
       * // and the first week of the year always contains 4 January?
       * const result = getISOWeek(new Date(2005, 0, 2), {
       *   weekStartsOn: 1,
       *   firstWeekContainsDate: 4
       * })
       * //=> 53
       */

      function getWeek(dirtyDate, options) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ])(date, options).getTime() - Object(__WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__["a"
        /* default */
        ])(date, options).getTime(); // Round the number of days to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)

        return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(12);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getWeekYear
       * @category Week-Numbering Year Helpers
       * @summary Get the local week-numbering year of the given date.
       *
       * @description
       * Get the local week-numbering year of the given date.
       * The exact calculation depends on the values of
       * `options.weekStartsOn` (which is the index of the first day of the week)
       * and `options.firstWeekContainsDate` (which is the day of January, which is always in
       * the first week of the week-numbering year)
       *
       * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @returns {Number} the local week-numbering year
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       *
       * @example
       * // Which week numbering year is 26 December 2004 with the default settings?
       * const result = getWeekYear(new Date(2004, 11, 26))
       * //=> 2005
       *
       * @example
       * // Which week numbering year is 26 December 2004 if week starts on Saturday?
       * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
       * //=> 2004
       *
       * @example
       * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
       * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
       * //=> 2004
       */


      function getWeekYear(dirtyDate, options) {
        var _options$locale, _options$locale$optio;

        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var year = date.getFullYear();
        var localeFirstWeekContainsDate = options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ])(localeFirstWeekContainsDate);
        var firstWeekContainsDate = (options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
          throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
        }

        var firstWeekOfNextYear = new Date(0);
        firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
        firstWeekOfNextYear.setHours(0, 0, 0, 0);
        var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ])(firstWeekOfNextYear, options);
        var firstWeekOfThisYear = new Date(0);
        firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
        firstWeekOfThisYear.setHours(0, 0, 0, 0);
        var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ])(firstWeekOfThisYear, options);

        if (date.getTime() >= startOfNextYear.getTime()) {
          return year + 1;
        } else if (date.getTime() >= startOfThisYear.getTime()) {
          return year;
        } else {
          return year - 1;
        }
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = lastDayOfMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfMonth
       * @category Month Helpers
       * @summary Return the last day of a month for the given date.
       *
       * @description
       * Return the last day of a month for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the last day of a month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The last day of a month for 2 September 2014 11:55:00:
       * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Sep 30 2014 00:00:00
       */


      function lastDayOfMonth(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var month = date.getMonth();
        date.setFullYear(date.getFullYear(), month + 1, 0);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = sub;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__subDays_index_js__ = __webpack_require__(43);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__subMonths_index_js__ = __webpack_require__(116);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__ = __webpack_require__(6);
      /**
       * @name sub
       * @category Common Helpers
       * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
       *
       * @description
       * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
       *
       * | Key     | Description                        |
       * |---------|------------------------------------|
       * | years   | Amount of years to be subtracted   |
       * | months  | Amount of months to be subtracted  |
       * | weeks   | Amount of weeks to be subtracted   |
       * | days    | Amount of days to be subtracted    |
       * | hours   | Amount of hours to be subtracted   |
       * | minutes | Amount of minutes to be subtracted |
       * | seconds | Amount of seconds to be subtracted |
       *
       * All values default to 0
       *
       * @returns {Date} the new date with the seconds subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract the following duration from 15 June 2017 15:29:20
       * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
       *   years: 2,
       *   months: 9,
       *   weeks: 1,
       *   days: 7,
       *   hours: 5,
       *   minutes: 9,
       *   seconds: 30
       * })
       * //=> Mon Sep 1 2014 10:19:50
       */


      function sub(date, duration) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        if (!duration || typeof duration !== "object") return new Date(NaN);
        var years = duration.years ? Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.years) : 0;
        var months = duration.months ? Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.months) : 0;
        var weeks = duration.weeks ? Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.weeks) : 0;
        var days = duration.days ? Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.days) : 0;
        var hours = duration.hours ? Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.hours) : 0;
        var minutes = duration.minutes ? Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.minutes) : 0;
        var seconds = duration.seconds ? Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.seconds) : 0; // Subtract years and months

        var dateWithoutMonths = Object(__WEBPACK_IMPORTED_MODULE_1__subMonths_index_js__["a"
        /* default */
        ])(date, months + years * 12); // Subtract weeks and days

        var dateWithoutDays = Object(__WEBPACK_IMPORTED_MODULE_0__subDays_index_js__["a"
        /* default */
        ])(dateWithoutMonths, days + weeks * 7); // Subtract hours, minutes and seconds

        var minutestoSub = minutes + hours * 60;
        var secondstoSub = seconds + minutestoSub * 60;
        var mstoSub = secondstoSub * 1000;
        var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
        return finalDate;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subMonths;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(27);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subMonths
       * @category Month Helpers
       * @summary Subtract the specified number of months from the given date.
       *
       * @description
       * Subtract the specified number of months from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the months subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 5 months from 1 February 2015:
       * const result = subMonths(new Date(2015, 1, 1), 5)
       * //=> Mon Sep 01 2014 00:00:00
       */


      function subMonths(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["a"
        /* default */
        ])(dirtyDate, -amount);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = parse;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__ = __webpack_require__(24);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__ = __webpack_require__(32);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_assign_index_js__ = __webpack_require__(104);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__ = __webpack_require__(100);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(11);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__ = __webpack_require__(101);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_8__lib_parsers_index_js__ = __webpack_require__(580);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
      // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
      //   (one of the certain letters followed by `o`)
      // - (\w)\1* matches any sequences of the same letter
      // - '' matches two quote characters in a row
      // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
      //   except a single quote symbol, which ends the sequence.
      //   Two quote characters do not end the sequence.
      //   If there is no matching single quote
      //   then the sequence will continue until the end of the string.
      // - . matches any single character unmatched by previous parts of the RegExps

      var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
      // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

      var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      var escapedStringRegExp = /^'([^]*?)'?$/;
      var doubleQuoteRegExp = /''/g;
      var notWhitespaceRegExp = /\S/;
      var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
      /**
       * @name parse
       * @category Common Helpers
       * @summary Parse the date.
       *
       * @description
       * Return the date parsed from string using the given format string.
       *
       * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
       * > See: https://git.io/fxCyr
       *
       * The characters in the format string wrapped between two single quotes characters (') are escaped.
       * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
       *
       * Format of the format string is based on Unicode Technical Standard #35:
       * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
       * with a few additions (see note 5 below the table).
       *
       * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
       * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
       *
       * ```javascript
       * parse('23 AM', 'HH a', new Date())
       * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
       * ```
       *
       * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
       *
       * Accepted format string patterns:
       * | Unit                            |Prior| Pattern | Result examples                   | Notes |
       * |---------------------------------|-----|---------|-----------------------------------|-------|
       * | Era                             | 140 | G..GGG  | AD, BC                            |       |
       * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
       * |                                 |     | GGGGG   | A, B                              |       |
       * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
       * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
       * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
       * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
       * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
       * |                                 |     | yyyyy   | ...                               | 2,4   |
       * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
       * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
       * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
       * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
       * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
       * |                                 |     | YYYYY   | ...                               | 2,4   |
       * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
       * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
       * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
       * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
       * |                                 |     | RRRRR   | ...                               | 2,4,5 |
       * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
       * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
       * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
       * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
       * |                                 |     | uuuuu   | ...                               | 2,4   |
       * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
       * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
       * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
       * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
       * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
       * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
       * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
       * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
       * |                                 |     | qq      | 01, 02, 03, 04                    |       |
       * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
       * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
       * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
       * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
       * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
       * |                                 |     | MM      | 01, 02, ..., 12                   |       |
       * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
       * |                                 |     | MMMM    | January, February, ..., December  | 2     |
       * |                                 |     | MMMMM   | J, F, ..., D                      |       |
       * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
       * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
       * |                                 |     | LL      | 01, 02, ..., 12                   |       |
       * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
       * |                                 |     | LLLL    | January, February, ..., December  | 2     |
       * |                                 |     | LLLLL   | J, F, ..., D                      |       |
       * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
       * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
       * |                                 |     | ww      | 01, 02, ..., 53                   |       |
       * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
       * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
       * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
       * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
       * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
       * |                                 |     | dd      | 01, 02, ..., 31                   |       |
       * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
       * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
       * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
       * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
       * |                                 |     | DDDD    | ...                               | 2     |
       * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
       * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
       * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
       * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
       * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
       * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
       * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
       * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
       * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
       * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
       * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
       * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
       * |                                 |     | ee      | 02, 03, ..., 01                   |       |
       * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
       * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
       * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
       * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
       * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
       * |                                 |     | cc      | 02, 03, ..., 01                   |       |
       * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
       * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
       * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
       * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
       * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
       * |                                 |     | aaaaa   | a, p                              |       |
       * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
       * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
       * |                                 |     | bbbbb   | a, p, n, mi                       |       |
       * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
       * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
       * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
       * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
       * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
       * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
       * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
       * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
       * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
       * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
       * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
       * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
       * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
       * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
       * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
       * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
       * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
       * |                                 |     | mm      | 00, 01, ..., 59                   |       |
       * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
       * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
       * |                                 |     | ss      | 00, 01, ..., 59                   |       |
       * | Seconds timestamp               |  40 | t       | 512969520                         |       |
       * |                                 |     | tt      | ...                               | 2     |
       * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
       * |                                 |     | SS      | 00, 01, ..., 99                   |       |
       * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
       * |                                 |     | SSSS    | ...                               | 2     |
       * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
       * |                                 |     | TT      | ...                               | 2     |
       * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
       * |                                 |     | XX      | -0800, +0530, Z                   |       |
       * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
       * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
       * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
       * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
       * |                                 |     | xx      | -0800, +0530, +0000               |       |
       * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
       * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
       * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
       * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
       * |                                 |     | PP      | May 29, 1453                      |       |
       * |                                 |     | PPP     | May 29th, 1453                    |       |
       * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
       * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
       * |                                 |     | pp      | 12:00:00 AM                       |       |
       * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
       * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
       * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
       * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
       * Notes:
       * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
       *    are the same as "stand-alone" units, but are different in some languages.
       *    "Formatting" units are declined according to the rules of the language
       *    in the context of a date. "Stand-alone" units are always nominative singular.
       *    In `format` function, they will produce different result:
       *
       *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
       *
       *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
       *
       *    `parse` will try to match both formatting and stand-alone units interchangably.
       *
       * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
       *    the single quote characters (see below).
       *    If the sequence is longer than listed in table:
       *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
       *      as wide as the sequence
       *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
       *      These variations are marked with "2" in the last column of the table.
       *
       * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
       *    These tokens represent the shortest form of the quarter.
       *
       * 4. The main difference between `y` and `u` patterns are B.C. years:
       *
       *    | Year | `y` | `u` |
       *    |------|-----|-----|
       *    | AC 1 |   1 |   1 |
       *    | BC 1 |   1 |   0 |
       *    | BC 2 |   2 |  -1 |
       *
       *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
       *
       *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
       *
       *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
       *
       *    while `uu` will just assign the year as is:
       *
       *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
       *
       *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
       *
       *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
       *    except local week-numbering years are dependent on `options.weekStartsOn`
       *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
       *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
       *
       * 5. These patterns are not in the Unicode Technical Standard #35:
       *    - `i`: ISO day of week
       *    - `I`: ISO week of year
       *    - `R`: ISO week-numbering year
       *    - `o`: ordinal number modifier
       *    - `P`: long localized date
       *    - `p`: long localized time
       *
       * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
       *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
       *
       * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
       *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
       *
       * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
       *    on the given locale.
       *
       *    using `en-US` locale: `P` => `MM/dd/yyyy`
       *    using `en-US` locale: `p` => `hh:mm a`
       *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
       *    using `pt-BR` locale: `p` => `HH:mm`
       *
       * Values will be assigned to the date in the descending order of its unit's priority.
       * Units of an equal priority overwrite each other in the order of appearance.
       *
       * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
       * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
       *
       * `referenceDate` must be passed for correct work of the function.
       * If you're not sure which `referenceDate` to supply, create a new instance of Date:
       * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
       * In this case parsing will be done in the context of the current date.
       * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
       * then `Invalid Date` will be returned.
       *
       * The result may vary by locale.
       *
       * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
       *
       * If parsing failed, `Invalid Date` will be returned.
       * Invalid Date is a Date, whose time value is NaN.
       * Time value of Date: http://es5.github.io/#x15.9.1.1
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - Old `parse` was renamed to `toDate`.
       *   Now `parse` is a new function which parses a string using a provided format.
       *
       *   ```javascript
       *   // Before v2.0.0
       *   parse('2016-01-01')
       *
       *   // v2.0.0 onward (toDate no longer accepts a string)
       *   toDate(1392098430000) // Unix to timestamp
       *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
       *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
       *   ```
       *
       * @param {String} dateString - the string to parse
       * @param {String} formatString - the string of tokens
       * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
       *   see: https://git.io/fxCyr
       * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
       *   see: https://git.io/fxCyr
       * @returns {Date} the parsed date
       * @throws {TypeError} 3 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       * @throws {RangeError} `options.locale` must contain `match` property
       * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} format string contains an unescaped latin alphabet character
       *
       * @example
       * // Parse 11 February 2014 from middle-endian format:
       * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
       * //=> Tue Feb 11 2014 00:00:00
       *
       * @example
       * // Parse 28th of February in Esperanto locale in the context of 2010 year:
       * import eo from 'date-fns/locale/eo'
       * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
       *   locale: eo
       * })
       * //=> Sun Feb 28 2010 00:00:00
       */

      function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__["a"
        /* default */
        ])(3, arguments);
        var dateString = String(dirtyDateString);
        var formatString = String(dirtyFormatString);
        var options = dirtyOptions || {};
        var locale = options.locale || __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__["a"
        /* default */
        ];

        if (!locale.match) {
          throw new RangeError("locale must contain match property");
        }

        var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a"
        /* default */
        ])(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a"
        /* default */
        ])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
          throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
        }

        var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a"
        /* default */
        ])(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a"
        /* default */
        ])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
        }

        if (formatString === "") {
          if (dateString === "") {
            return Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
            /* default */
            ])(dirtyReferenceDate);
          } else {
            return new Date(NaN);
          }
        }

        var subFnOptions = {
          firstWeekContainsDate: firstWeekContainsDate,
          weekStartsOn: weekStartsOn,
          locale: locale
        }; // If timezone isn't specified, it will be set to the system timezone

        var setters = [{
          priority: TIMEZONE_UNIT_PRIORITY,
          subPriority: -1,
          set: dateToSystemTimezone,
          index: 0
        }];
        var i;
        var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
          var firstCharacter = substring[0];

          if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__["a"
            /* default */
            ][firstCharacter];
            return longFormatter(substring, locale.formatLong, subFnOptions);
          }

          return substring;
        }).join("").match(formattingTokensRegExp);
        var usedTokens = [];

        for (i = 0; i < tokens.length; i++) {
          var token = tokens[i];

          if (!options.useAdditionalWeekYearTokens && Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["b"
          /* isProtectedWeekYearToken */
          ])(token)) {
            Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c"
            /* throwProtectedError */
            ])(token, formatString, dirtyDateString);
          }

          if (!options.useAdditionalDayOfYearTokens && Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["a"
          /* isProtectedDayOfYearToken */
          ])(token)) {
            Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c"
            /* throwProtectedError */
            ])(token, formatString, dirtyDateString);
          }

          var firstCharacter = token[0];
          var parser = __WEBPACK_IMPORTED_MODULE_8__lib_parsers_index_js__["a"
          /* default */
          ][firstCharacter];

          if (parser) {
            var incompatibleTokens = parser.incompatibleTokens;

            if (Array.isArray(incompatibleTokens)) {
              var incompatibleToken = void 0;

              for (var _i = 0; _i < usedTokens.length; _i++) {
                var usedToken = usedTokens[_i].token;

                if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
                  incompatibleToken = usedTokens[_i];
                  break;
                }
              }

              if (incompatibleToken) {
                throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
              }
            } else if (parser.incompatibleTokens === "*" && usedTokens.length) {
              throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
            }

            usedTokens.push({
              token: firstCharacter,
              fullToken: token
            });
            var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

            if (!parseResult) {
              return new Date(NaN);
            }

            setters.push({
              priority: parser.priority,
              subPriority: parser.subPriority || 0,
              set: parser.set,
              validate: parser.validate,
              value: parseResult.value,
              index: setters.length
            });
            dateString = parseResult.rest;
          } else {
            if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
              throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            } // Replace two single quote characters with one single quote character


            if (token === "''") {
              token = "'";
            } else if (firstCharacter === "'") {
              token = cleanEscapedString(token);
            } // Cut token from string, or, if string doesn't match the token, return Invalid Date


            if (dateString.indexOf(token) === 0) {
              dateString = dateString.slice(token.length);
            } else {
              return new Date(NaN);
            }
          }
        } // Check if the remaining input contains something other than whitespace


        if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
          return new Date(NaN);
        }

        var uniquePrioritySetters = setters.map(function (setter) {
          return setter.priority;
        }).sort(function (a, b) {
          return b - a;
        }).filter(function (priority, index, array) {
          return array.indexOf(priority) === index;
        }).map(function (priority) {
          return setters.filter(function (setter) {
            return setter.priority === priority;
          }).sort(function (a, b) {
            return b.subPriority - a.subPriority;
          });
        }).map(function (setterArray) {
          return setterArray[0];
        });
        var date = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(dirtyReferenceDate);

        if (isNaN(date)) {
          return new Date(NaN);
        } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
        // This ensures that when UTC functions will be implemented, locales will be compatible with them.
        // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


        var utcDate = Object(__WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__["a"
        /* default */
        ])(date, Object(__WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(date));
        var flags = {};

        for (i = 0; i < uniquePrioritySetters.length; i++) {
          var setter = uniquePrioritySetters[i];

          if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
            return new Date(NaN);
          }

          var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

          if (result[0]) {
            utcDate = result[0];
            Object(__WEBPACK_IMPORTED_MODULE_3__lib_assign_index_js__["a"
            /* default */
            ])(flags, result[1]); // Result is date
          } else {
            utcDate = result;
          }
        }

        return utcDate;
      }

      function dateToSystemTimezone(date, flags) {
        if (flags.timestampIsSet) {
          return date;
        }

        var convertedDate = new Date(0);
        convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
        convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
        return convertedDate;
      }

      function cleanEscapedString(input) {
        return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameHour;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfHour_index_js__ = __webpack_require__(119);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameHour
       * @category Hour Helpers
       * @summary Are the given dates in the same hour?
       *
       * @description
       * Are the given dates in the same hour?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same hour
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
       * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
       * //=> true
       */


      function isSameHour(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeftStartOfHour = Object(__WEBPACK_IMPORTED_MODULE_0__startOfHour_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRightStartOfHour = Object(__WEBPACK_IMPORTED_MODULE_0__startOfHour_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfHour;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfHour
       * @category Hour Helpers
       * @summary Return the start of an hour for the given date.
       *
       * @description
       * Return the start of an hour for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of an hour
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of an hour for 2 September 2014 11:55:00:
       * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
       * //=> Tue Sep 02 2014 11:00:00
       */


      function startOfHour(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        date.setMinutes(0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__ = __webpack_require__(60);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameISOWeek
       * @category ISO Week Helpers
       * @summary Are the given dates in the same ISO week?
       *
       * @description
       * Are the given dates in the same ISO week?
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same ISO week
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
       * var result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
       * //=> true
       */


      function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__["a"
        /* default */
        ])(dirtyDateLeft, dirtyDateRight, {
          weekStartsOn: 1
        });
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameMinute;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfMinute_index_js__ = __webpack_require__(54);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameMinute
       * @category Minute Helpers
       * @summary Are the given dates in the same minute?
       *
       * @description
       * Are the given dates in the same minute?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same minute
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
       * // in the same minute?
       * var result = isSameMinute(
       *   new Date(2014, 8, 4, 6, 30),
       *   new Date(2014, 8, 4, 6, 30, 15)
       * )
       * //=> true
       */


      function isSameMinute(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeftStartOfMinute = Object(__WEBPACK_IMPORTED_MODULE_0__startOfMinute_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRightStartOfMinute = Object(__WEBPACK_IMPORTED_MODULE_0__startOfMinute_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameMonth
       * @category Month Helpers
       * @summary Are the given dates in the same month?
       *
       * @description
       * Are the given dates in the same month?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same month
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 2 September 2014 and 25 September 2014 in the same month?
       * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
       * //=> true
       */


      function isSameMonth(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameQuarter;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__ = __webpack_require__(55);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameQuarter
       * @category Quarter Helpers
       * @summary Are the given dates in the same year quarter?
       *
       * @description
       * Are the given dates in the same year quarter?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same quarter
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 1 January 2014 and 8 March 2014 in the same quarter?
       * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
       * //=> true
       */


      function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeftStartOfQuarter = Object(__WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRightStartOfQuarter = Object(__WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameSecond;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfSecond_index_js__ = __webpack_require__(125);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameSecond
       * @category Second Helpers
       * @summary Are the given dates in the same second?
       *
       * @description
       * Are the given dates in the same second?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same second
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
       * // in the same second?
       * var result = isSameSecond(
       *   new Date(2014, 8, 4, 6, 30, 15),
       *   new Date(2014, 8, 4, 6, 30, 15, 500)
       * )
       * //=> true
       */


      function isSameSecond(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeftStartOfSecond = Object(__WEBPACK_IMPORTED_MODULE_0__startOfSecond_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRightStartOfSecond = Object(__WEBPACK_IMPORTED_MODULE_0__startOfSecond_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfSecond;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfSecond
       * @category Second Helpers
       * @summary Return the start of a second for the given date.
       *
       * @description
       * Return the start of a second for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a second
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a second for 1 December 2014 22:15:45.400:
       * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
       * //=> Mon Dec 01 2014 22:15:45.000
       */


      function startOfSecond(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        date.setMilliseconds(0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameYear
       * @category Year Helpers
       * @summary Are the given dates in the same year?
       *
       * @description
       * Are the given dates in the same year?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same year
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 2 September 2014 and 25 September 2014 in the same year?
       * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
       * //=> true
       */


      function isSameYear(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        return dateLeft.getFullYear() === dateRight.getFullYear();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = lastDayOfWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfWeek
       * @category Week Helpers
       * @summary Return the last day of a week for the given date.
       *
       * @description
       * Return the last day of a week for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Date} the last day of a week
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // The last day of a week for 2 September 2014 11:55:00:
       * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Sat Sep 06 2014 00:00:00
       *
       * @example
       * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
       * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
       * //=> Sun Sep 07 2014 00:00:00
       */


      function lastDayOfWeek(dirtyDate, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ])(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError("weekStartsOn must be between 0 and 6");
        }

        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var day = date.getDay();
        var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + diff);
        return date;
      }
      /***/

    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "minder as 'n sekonde",
          other: "minder as {{count}} sekondes"
        },
        xSeconds: {
          one: "1 sekonde",
          other: "{{count}} sekondes"
        },
        halfAMinute: "'n halwe minuut",
        lessThanXMinutes: {
          one: "minder as 'n minuut",
          other: "minder as {{count}} minute"
        },
        xMinutes: {
          one: "'n minuut",
          other: "{{count}} minute"
        },
        aboutXHours: {
          one: "ongeveer 1 uur",
          other: "ongeveer {{count}} ure"
        },
        xHours: {
          one: "1 uur",
          other: "{{count}} ure"
        },
        xDays: {
          one: "1 dag",
          other: "{{count}} dae"
        },
        aboutXWeeks: {
          one: "ongeveer 1 week",
          other: "ongeveer {{count}} weke"
        },
        xWeeks: {
          one: "1 week",
          other: "{{count}} weke"
        },
        aboutXMonths: {
          one: "ongeveer 1 maand",
          other: "ongeveer {{count}} maande"
        },
        xMonths: {
          one: "1 maand",
          other: "{{count}} maande"
        },
        aboutXYears: {
          one: "ongeveer 1 jaar",
          other: "ongeveer {{count}} jaar"
        },
        xYears: {
          one: "1 jaar",
          other: "{{count}} jaar"
        },
        overXYears: {
          one: "meer as 1 jaar",
          other: "meer as {{count}} jaar"
        },
        almostXYears: {
          one: "byna 1 jaar",
          other: "byna {{count}} jaar"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "oor " + result;
          } else {
            return result + " gelede";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM yyyy",
        long: "d MMMM yyyy",
        medium: "d MMM yyyy",
        short: "yyyy/MM/dd"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'om' {{time}}",
        long: "{{date}} 'om' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'verlede' eeee 'om' p",
        yesterday: "'gister om' p",
        today: "'vandag om' p",
        tomorrow: "'m\xF4re om' p",
        nextWeek: "eeee 'om' p",
        other: "P"
      };

      function formatRelative(token) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["vC", "nC"],
        abbreviated: ["vC", "nC"],
        wide: ["voor Christus", "na Christus"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["K1", "K2", "K3", "K4"],
        wide: ["1ste kwartaal", "2de kwartaal", "3de kwartaal", "4de kwartaal"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
        wide: ["Januarie", "Februarie", "Maart", "April", "Mei", "Junie", "Julie", "Augustus", "September", "Oktober", "November", "Desember"]
      };
      var dayValues = {
        narrow: ["S", "M", "D", "W", "D", "V", "S"],
        short: ["So", "Ma", "Di", "Wo", "Do", "Vr", "Sa"],
        abbreviated: ["Son", "Maa", "Din", "Woe", "Don", "Vry", "Sat"],
        wide: ["Sondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrydag", "Saterdag"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "vm",
          pm: "nm",
          midnight: "middernag",
          noon: "middaguur",
          morning: "oggend",
          afternoon: "middag",
          evening: "laat middag",
          night: "aand"
        },
        abbreviated: {
          am: "vm",
          pm: "nm",
          midnight: "middernag",
          noon: "middaguur",
          morning: "oggend",
          afternoon: "middag",
          evening: "laat middag",
          night: "aand"
        },
        wide: {
          am: "vm",
          pm: "nm",
          midnight: "middernag",
          noon: "middaguur",
          morning: "oggend",
          afternoon: "middag",
          evening: "laat middag",
          night: "aand"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "vm",
          pm: "nm",
          midnight: "middernag",
          noon: "uur die middag",
          morning: "uur die oggend",
          afternoon: "uur die middag",
          evening: "uur die aand",
          night: "uur die aand"
        },
        abbreviated: {
          am: "vm",
          pm: "nm",
          midnight: "middernag",
          noon: "uur die middag",
          morning: "uur die oggend",
          afternoon: "uur die middag",
          evening: "uur die aand",
          night: "uur die aand"
        },
        wide: {
          am: "vm",
          pm: "nm",
          midnight: "middernag",
          noon: "uur die middag",
          morning: "uur die oggend",
          afternoon: "uur die middag",
          evening: "uur die aand",
          night: "uur die aand"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        var rem100 = number % 100;

        if (rem100 < 20) {
          switch (rem100) {
            case 1:
            case 8:
              return number + "ste";

            default:
              return number + "de";
          }
        }

        return number + "ste";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^([vn]\.? ?C\.?)/,
        abbreviated: /^([vn]\. ?C\.?)/,
        wide: /^((voor|na) Christus)/
      };
      var parseEraPatterns = {
        any: [/^v/, /^n/]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^K[1234]/i,
        wide: /^[1234](st|d)e kwartaal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
        wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^J/i, /^F/i, /^M/i, /^A/i, /^M/i, /^J/i, /^J/i, /^A/i, /^S/i, /^O/i, /^N/i, /^D/i],
        any: [/^Jan/i, /^Feb/i, /^Mrt/i, /^Apr/i, /^Mei/i, /^Jun/i, /^Jul/i, /^Aug/i, /^Sep/i, /^Okt/i, /^Nov/i, /^Dec/i]
      };
      var matchDayPatterns = {
        narrow: /^[smdwv]/i,
        short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
        abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
        wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
      };
      var parseDayPatterns = {
        narrow: [/^S/i, /^M/i, /^D/i, /^W/i, /^D/i, /^V/i, /^S/i],
        any: [/^So/i, /^Ma/i, /^Di/i, /^Wo/i, /^Do/i, /^Vr/i, /^Sa/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^vm/i,
          pm: /^nm/i,
          midnight: /^middernag/i,
          noon: /^middaguur/i,
          morning: /oggend/i,
          afternoon: /middag/i,
          evening: /laat middag/i,
          night: /aand/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
          two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
          threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
          other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
        },
        xSeconds: {
          one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
          two: "\u062B\u0627\u0646\u062A\u064A\u0646",
          threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
          other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
        },
        halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
        lessThanXMinutes: {
          one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
          two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
          threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
          other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
        },
        xMinutes: {
          one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
          two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
          threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
          other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
        },
        aboutXHours: {
          one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        },
        xHours: {
          one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
          two: "\u0633\u0627\u0639\u062A\u064A\u0646",
          threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
          other: "{{count}} \u0633\u0627\u0639\u0629"
        },
        xDays: {
          one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
          two: "\u064A\u0648\u0645\u064A\u0646",
          threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
          other: "{{count}} \u064A\u0648\u0645"
        },
        aboutXWeeks: {
          one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        },
        xWeeks: {
          one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
          two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
          threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
          other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
        },
        aboutXMonths: {
          one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        },
        xMonths: {
          one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
          two: "\u0634\u0647\u0631\u064A\u0646",
          threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
          other: "{{count}} \u0634\u0647\u0631"
        },
        aboutXYears: {
          one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        },
        xYears: {
          one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
          two: "\u0639\u0627\u0645\u064A\u0646",
          threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
          other: "{{count}} \u0639\u0627\u0645"
        },
        overXYears: {
          one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
          two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
          threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
          other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
        },
        almostXYears: {
          one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2) {
          result = formatDistanceLocale[token].two;
        } else if (count <= 10) {
          result = formatDistanceLocale[token].threeToTen.replace("{{count}}", count);
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
          } else {
            return "\u0645\u0646\u0630 " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, MMMM do, y",
        long: "MMMM do, y",
        medium: "MMM d, y",
        short: "MM/dd/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} '\u0639\u0646\u062F' {{time}}",
        long: "{{date}} '\u0639\u0646\u062F' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
        yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
        today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
        tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
        nextWeek: "eeee '\u0639\u0646\u062F' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u0642", "\u0628"],
        abbreviated: ["\u0642.\u0645.", "\u0628.\u0645."],
        wide: ["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F", "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["\u06311", "\u06312", "\u06313", "\u06314"],
        wide: ["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
      };
      var monthValues = {
        narrow: ["\u062C", "\u0641", "\u0645", "\u0623", "\u0645", "\u062C", "\u062C", "\u0623", "\u0633", "\u0623", "\u0646", "\u062F"],
        abbreviated: ["\u062C\u0627\u0646\u0640", "\u0641\u064A\u0641\u0640", "\u0645\u0627\u0631\u0633", "\u0623\u0641\u0631\u064A\u0644", "\u0645\u0627\u064A\u0640", "\u062C\u0648\u0627\u0646\u0640", "\u062C\u0648\u064A\u0640", "\u0623\u0648\u062A", "\u0633\u0628\u062A\u0640", "\u0623\u0643\u062A\u0640", "\u0646\u0648\u0641\u0640", "\u062F\u064A\u0633\u0640"],
        wide: ["\u062C\u0627\u0646\u0641\u064A", "\u0641\u064A\u0641\u0631\u064A", "\u0645\u0627\u0631\u0633", "\u0623\u0641\u0631\u064A\u0644", "\u0645\u0627\u064A", "\u062C\u0648\u0627\u0646", "\u062C\u0648\u064A\u0644\u064A\u0629", "\u0623\u0648\u062A", "\u0633\u0628\u062A\u0645\u0628\u0631", "\u0623\u0643\u062A\u0648\u0628\u0631", "\u0646\u0648\u0641\u0645\u0628\u0631", "\u062F\u064A\u0633\u0645\u0628\u0631"]
      };
      var dayValues = {
        narrow: ["\u062D", "\u0646", "\u062B", "\u0631", "\u062E", "\u062C", "\u0633"],
        short: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
        abbreviated: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u0640", "\u062B\u0644\u0627", "\u0623\u0631\u0628\u0640", "\u062E\u0645\u064A\u0640", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
        wide: ["\u0627\u0644\u0623\u062D\u062F", "\u0627\u0644\u0627\u062B\u0646\u064A\u0646", "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621", "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621", "\u0627\u0644\u062E\u0645\u064A\u0633", "\u0627\u0644\u062C\u0645\u0639\u0629", "\u0627\u0644\u0633\u0628\u062A"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646",
          noon: "\u0638",
          morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
          evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
          night: "\u0644\u064A\u0644\u0627\u064B"
        },
        abbreviated: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
          noon: "\u0638\u0647\u0631",
          morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
          evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
          night: "\u0644\u064A\u0644\u0627\u064B"
        },
        wide: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
          noon: "\u0638\u0647\u0631",
          morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
          evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
          night: "\u0644\u064A\u0644\u0627\u064B"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646",
          noon: "\u0638",
          morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
          evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
          night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
        },
        abbreviated: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
          noon: "\u0638\u0647\u0631",
          morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
          evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
          night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
        },
        wide: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
          noon: "\u0638\u0647\u0631",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
          evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
          night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
        }
      };

      function ordinalNumber(dirtyNumber) {
        return String(dirtyNumber);
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ق|ب)/i,
        abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
        wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
      };
      var parseEraPatterns = {
        any: [/^قبل/i, /^بعد/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ر[1234]/i,
        wide: /^الربع [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[جفمأسند]/i,
        abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
        wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
        any: [/^جان/i, /^فيف/i, /^مار/i, /^أفر/i, /^ماي/i, /^جوا/i, /^جوي/i, /^أوت/i, /^سبت/i, /^أكت/i, /^نوف/i, /^ديس/i]
      };
      var matchDayPatterns = {
        narrow: /^[حنثرخجس]/i,
        short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
        abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
        wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
      };
      var parseDayPatterns = {
        narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
        wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
        any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
          two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
          threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
          other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
        },
        xSeconds: {
          one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
          two: "\u062B\u0627\u0646\u062A\u064A\u0646",
          threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
          other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
        },
        halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
        lessThanXMinutes: {
          one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
          two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
          threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
          other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
        },
        xMinutes: {
          one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
          two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
          threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
          other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
        },
        aboutXHours: {
          one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        },
        xHours: {
          one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
          two: "\u0633\u0627\u0639\u062A\u064A\u0646",
          threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
          other: "{{count}} \u0633\u0627\u0639\u0629"
        },
        xDays: {
          one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
          two: "\u064A\u0648\u0645\u064A\u0646",
          threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
          other: "{{count}} \u064A\u0648\u0645"
        },
        aboutXWeeks: {
          one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        },
        xWeeks: {
          one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
          two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
          threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
          other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
        },
        aboutXMonths: {
          one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        },
        xMonths: {
          one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
          two: "\u0634\u0647\u0631\u064A\u0646",
          threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
          other: "{{count}} \u0634\u0647\u0631"
        },
        aboutXYears: {
          one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        },
        xYears: {
          one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
          two: "\u0639\u0627\u0645\u064A\u0646",
          threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
          other: "{{count}} \u0639\u0627\u0645"
        },
        overXYears: {
          one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
          two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
          threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
          other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
        },
        almostXYears: {
          one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2) {
          result = formatDistanceLocale[token].two;
        } else if (count <= 10) {
          result = formatDistanceLocale[token].threeToTen.replace("{{count}}", count);
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
          } else {
            return "\u0645\u0646\u0630 " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, MMMM do, y",
        long: "MMMM do, y",
        medium: "MMM d, y",
        short: "MM/dd/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} '\u0639\u0646\u062F' {{time}}",
        long: "{{date}} '\u0639\u0646\u062F' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
        yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
        today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
        tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
        nextWeek: "eeee '\u0639\u0646\u062F' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u0642", "\u0628"],
        abbreviated: ["\u0642.\u0645.", "\u0628.\u0645."],
        wide: ["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F", "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["\u06311", "\u06312", "\u06313", "\u06314"],
        wide: ["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
      };
      var monthValues = {
        narrow: ["\u064A", "\u0641", "\u0645", "\u0623", "\u0645", "\u064A", "\u064A", "\u063A", "\u0634", "\u0623", "\u0646", "\u062F"],
        abbreviated: ["\u064A\u0646\u0627", "\u0641\u0628\u0631", "\u0645\u0627\u0631\u0633", "\u0623\u0628\u0631\u064A\u0644", "\u0645\u0627\u064A", "\u064A\u0648\u0646\u0640", "\u064A\u0648\u0644\u0640", "\u063A\u0634\u062A", "\u0634\u062A\u0646\u0640", "\u0623\u0643\u062A\u0640", "\u0646\u0648\u0646\u0640", "\u062F\u062C\u0646\u0640"],
        wide: ["\u064A\u0646\u0627\u064A\u0631", "\u0641\u0628\u0631\u0627\u064A\u0631", "\u0645\u0627\u0631\u0633", "\u0623\u0628\u0631\u064A\u0644", "\u0645\u0627\u064A", "\u064A\u0648\u0646\u064A\u0648", "\u064A\u0648\u0644\u064A\u0648\u0632", "\u063A\u0634\u062A", "\u0634\u062A\u0646\u0628\u0631", "\u0623\u0643\u062A\u0648\u0628\u0631", "\u0646\u0648\u0646\u0628\u0631", "\u062F\u062C\u0646\u0628\u0631"]
      };
      var dayValues = {
        narrow: ["\u062D", "\u0646", "\u062B", "\u0631", "\u062E", "\u062C", "\u0633"],
        short: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
        abbreviated: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u0640", "\u062B\u0644\u0627", "\u0623\u0631\u0628\u0640", "\u062E\u0645\u064A\u0640", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
        wide: ["\u0627\u0644\u0623\u062D\u062F", "\u0627\u0644\u0625\u062B\u0646\u064A\u0646", "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621", "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621", "\u0627\u0644\u062E\u0645\u064A\u0633", "\u0627\u0644\u062C\u0645\u0639\u0629", "\u0627\u0644\u0633\u0628\u062A"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646",
          noon: "\u0638",
          morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
          evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
          night: "\u0644\u064A\u0644\u0627\u064B"
        },
        abbreviated: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
          noon: "\u0638\u0647\u0631",
          morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
          evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
          night: "\u0644\u064A\u0644\u0627\u064B"
        },
        wide: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
          noon: "\u0638\u0647\u0631",
          morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
          evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
          night: "\u0644\u064A\u0644\u0627\u064B"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646",
          noon: "\u0638",
          morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
          evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
          night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
        },
        abbreviated: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
          noon: "\u0638\u0647\u0631",
          morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
          evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
          night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
        },
        wide: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
          noon: "\u0638\u0647\u0631",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
          evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
          night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
        }
      };

      function ordinalNumber(dirtyNumber) {
        return String(dirtyNumber);
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ق|ب)/i,
        abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
        wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
      };
      var parseEraPatterns = {
        any: [/^قبل/i, /^بعد/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ر[1234]/i,
        wide: /^الربع [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[يفمأمسند]/i,
        abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
        wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^غ/i, /^ش/i, /^أ/i, /^ن/i, /^د/i],
        any: [/^ين/i, /^فب/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^غشت/i, /^ش/i, /^أك/i, /^ن/i, /^د/i]
      };
      var matchDayPatterns = {
        narrow: /^[حنثرخجس]/i,
        short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
        abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
        wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
      };
      var parseDayPatterns = {
        narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
        wide: [/^الأحد/i, /^الإثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
        any: [/^أح/i, /^إث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
          two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
          threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
          other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
        },
        xSeconds: {
          one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
          two: "\u062B\u0627\u0646\u062A\u064A\u0646",
          threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
          other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
        },
        halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
        lessThanXMinutes: {
          one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
          two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
          threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
          other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
        },
        xMinutes: {
          one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
          two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
          threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
          other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
        },
        aboutXHours: {
          one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        },
        xHours: {
          one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
          two: "\u0633\u0627\u0639\u062A\u064A\u0646",
          threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
          other: "{{count}} \u0633\u0627\u0639\u0629"
        },
        xDays: {
          one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
          two: "\u064A\u0648\u0645\u064A\u0646",
          threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
          other: "{{count}} \u064A\u0648\u0645"
        },
        aboutXWeeks: {
          one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        },
        xWeeks: {
          one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
          two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
          threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
          other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
        },
        aboutXMonths: {
          one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        },
        xMonths: {
          one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
          two: "\u0634\u0647\u0631\u064A\u0646",
          threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
          other: "{{count}} \u0634\u0647\u0631"
        },
        aboutXYears: {
          one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        },
        xYears: {
          one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
          two: "\u0639\u0627\u0645\u064A\u0646",
          threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
          other: "{{count}} \u0639\u0627\u0645"
        },
        overXYears: {
          one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
          two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
          threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
          other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
        },
        almostXYears: {
          one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
          other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2) {
          result = formatDistanceLocale[token].two;
        } else if (count <= 10) {
          result = formatDistanceLocale[token].threeToTen.replace("{{count}}", count);
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
          } else {
            return "\u0645\u0646\u0630 " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, MMMM do, y",
        long: "MMMM do, y",
        medium: "MMM d, y",
        short: "MM/dd/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} '\u0639\u0646\u062F' {{time}}",
        long: "{{date}} '\u0639\u0646\u062F' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
        yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
        today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
        tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
        nextWeek: "eeee '\u0639\u0646\u062F' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u0642", "\u0628"],
        abbreviated: ["\u0642.\u0645.", "\u0628.\u0645."],
        wide: ["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F", "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["\u06311", "\u06312", "\u06313", "\u06314"],
        wide: ["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
      };
      var monthValues = {
        narrow: ["\u064A", "\u0641", "\u0645", "\u0623", "\u0645", "\u064A", "\u064A", "\u0623", "\u0633", "\u0623", "\u0646", "\u062F"],
        abbreviated: ["\u064A\u0646\u0627", "\u0641\u0628\u0631", "\u0645\u0627\u0631\u0633", "\u0623\u0628\u0631\u064A\u0644", "\u0645\u0627\u064A\u0648", "\u064A\u0648\u0646\u0640", "\u064A\u0648\u0644\u0640", "\u0623\u063A\u0633\u0640", "\u0633\u0628\u062A\u0640", "\u0623\u0643\u062A\u0640", "\u0646\u0648\u0641\u0640", "\u062F\u064A\u0633\u0640"],
        wide: ["\u064A\u0646\u0627\u064A\u0631", "\u0641\u0628\u0631\u0627\u064A\u0631", "\u0645\u0627\u0631\u0633", "\u0623\u0628\u0631\u064A\u0644", "\u0645\u0627\u064A\u0648", "\u064A\u0648\u0646\u064A\u0648", "\u064A\u0648\u0644\u064A\u0648", "\u0623\u063A\u0633\u0637\u0633", "\u0633\u0628\u062A\u0645\u0628\u0631", "\u0623\u0643\u062A\u0648\u0628\u0631", "\u0646\u0648\u0641\u0645\u0628\u0631", "\u062F\u064A\u0633\u0645\u0628\u0631"]
      };
      var dayValues = {
        narrow: ["\u062D", "\u0646", "\u062B", "\u0631", "\u062E", "\u062C", "\u0633"],
        short: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
        abbreviated: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u0640", "\u062B\u0644\u0627", "\u0623\u0631\u0628\u0640", "\u062E\u0645\u064A\u0640", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
        wide: ["\u0627\u0644\u0623\u062D\u062F", "\u0627\u0644\u0627\u062B\u0646\u064A\u0646", "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621", "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621", "\u0627\u0644\u062E\u0645\u064A\u0633", "\u0627\u0644\u062C\u0645\u0639\u0629", "\u0627\u0644\u0633\u0628\u062A"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646",
          noon: "\u0638",
          morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
          evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
          night: "\u0644\u064A\u0644\u0627\u064B"
        },
        abbreviated: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
          noon: "\u0638\u0647\u0631",
          morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
          evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
          night: "\u0644\u064A\u0644\u0627\u064B"
        },
        wide: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
          noon: "\u0638\u0647\u0631",
          morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
          evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
          night: "\u0644\u064A\u0644\u0627\u064B"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646",
          noon: "\u0638",
          morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
          evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
          night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
        },
        abbreviated: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
          noon: "\u0638\u0647\u0631",
          morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
          evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
          night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
        },
        wide: {
          am: "\u0635",
          pm: "\u0645",
          midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
          noon: "\u0638\u0647\u0631",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
          evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
          night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
        }
      };

      function ordinalNumber(dirtyNumber) {
        return String(dirtyNumber);
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ق|ب)/i,
        abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
        wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
      };
      var parseEraPatterns = {
        any: [/^قبل/i, /^بعد/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ر[1234]/i,
        wide: /^الربع [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[يفمأمسند]/i,
        abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
        wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
        any: [/^ين/i, /^ف/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^أغ/i, /^س/i, /^أك/i, /^ن/i, /^د/i]
      };
      var matchDayPatterns = {
        narrow: /^[حنثرخجس]/i,
        short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
        abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
        wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
      };
      var parseDayPatterns = {
        narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
        wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
        any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
          two: "\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
          threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
          other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
        },
        xSeconds: {
          one: "\u062B\u0627\u0646\u064A\u0629",
          two: "\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
          threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
          other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
        },
        halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
        lessThanXMinutes: {
          one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
          two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
          threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
          other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
        },
        xMinutes: {
          one: "\u062F\u0642\u064A\u0642\u0629",
          two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
          threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
          other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
        },
        aboutXHours: {
          one: "\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
          two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
          threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
          other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
        },
        xHours: {
          one: "\u0633\u0627\u0639\u0629",
          two: "\u0633\u0627\u0639\u062A\u064A\u0646",
          threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639",
          other: "{{count}} \u0633\u0627\u0639\u0629"
        },
        xDays: {
          one: "\u0646\u0647\u0627\u0631",
          two: "\u0646\u0647\u0627\u0631\u064A\u0646",
          threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
          other: "{{count}} \u064A\u0648\u0645"
        },
        aboutXWeeks: {
          one: "\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
          two: "\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
          threeToTen: "{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
          other: "{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
        },
        xWeeks: {
          one: "\u062C\u0645\u0639\u0629",
          two: "\u062C\u0645\u0639\u062A\u064A\u0646",
          threeToTen: "{{count}} \u062C\u0645\u0627\u0639",
          other: "{{count}} \u062C\u0645\u0639\u0629"
        },
        aboutXMonths: {
          one: "\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
          two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
          threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
          other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
        },
        xMonths: {
          one: "\u0634\u0647\u0631",
          two: "\u0634\u0647\u0631\u064A\u0646",
          threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629",
          other: "{{count}} \u0634\u0647\u0631"
        },
        aboutXYears: {
          one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
          two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
          threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
          other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
        },
        xYears: {
          one: "\u0639\u0627\u0645",
          two: "\u0639\u0627\u0645\u064A\u0646",
          threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
          other: "{{count}} \u0639\u0627\u0645"
        },
        overXYears: {
          one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
          two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
          threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
          other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
        },
        almostXYears: {
          one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
          two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
          threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
          other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
        }
      };

      var formatDistance = function (token, count, options) {
        var usageGroup = formatDistanceLocale[token];
        var result;

        if (typeof usageGroup === "string") {
          result = usageGroup;
        } else if (count === 1) {
          result = usageGroup.one;
        } else if (count === 2) {
          result = usageGroup.two;
        } else if (count <= 10) {
          result = usageGroup.threeToTen.replace("{{count}}", String(count));
        } else {
          result = usageGroup.other.replace("{{count}}", String(count));
        }

        if (options !== null && options !== void 0 && options.addSuffix) {
          if (options.comparison && options.comparison > 0) {
            return "\u0641\u064A " + result;
          } else {
            return "\u0639\u0646\u062F\u0648 " + result;
          }
        }

        return result;
      };

      var _default = formatDistance;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE\u060C do MMMM y",
        long: "do MMMM y",
        medium: "d MMM y",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "HH:mm:ss",
        long: "HH:mm:ss",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} '\u0645\u0639' {{time}}",
        long: "{{date}} '\u0645\u0639' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var formatRelativeLocale = {
        lastWeek: "eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
        yesterday: "'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
        today: "'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
        tomorrow: "'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
        nextWeek: "eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
        other: "P"
      };

      var formatRelative = function (token) {
        return formatRelativeLocale[token];
      };

      var _default = formatRelative;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u0642", "\u0628"],
        abbreviated: ["\u0642.\u0645.", "\u0628.\u0645."],
        wide: ["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F", "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["\u06311", "\u06312", "\u06313", "\u06314"],
        wide: ["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
      };
      var monthValues = {
        narrow: ["\u062F", "\u0646", "\u0623", "\u0633", "\u0623", "\u062C", "\u062C", "\u0645", "\u0623", "\u0645", "\u0641", "\u062C"],
        abbreviated: ["\u062C\u0627\u0646\u0641\u064A", "\u0641\u064A\u0641\u0631\u064A", "\u0645\u0627\u0631\u0633", "\u0623\u0641\u0631\u064A\u0644", "\u0645\u0627\u064A", "\u062C\u0648\u0627\u0646", "\u062C\u0648\u064A\u0644\u064A\u0629", "\u0623\u0648\u062A", "\u0633\u0628\u062A\u0645\u0628\u0631", "\u0623\u0643\u062A\u0648\u0628\u0631", "\u0646\u0648\u0641\u0645\u0628\u0631", "\u062F\u064A\u0633\u0645\u0628\u0631"],
        wide: ["\u062C\u0627\u0646\u0641\u064A", "\u0641\u064A\u0641\u0631\u064A", "\u0645\u0627\u0631\u0633", "\u0623\u0641\u0631\u064A\u0644", "\u0645\u0627\u064A", "\u062C\u0648\u0627\u0646", "\u062C\u0648\u064A\u0644\u064A\u0629", "\u0623\u0648\u062A", "\u0633\u0628\u062A\u0645\u0628\u0631", "\u0623\u0643\u062A\u0648\u0628\u0631", "\u0646\u0648\u0641\u0645\u0628\u0631", "\u062F\u064A\u0633\u0645\u0628\u0631"]
      };
      var dayValues = {
        narrow: ["\u062D", "\u0646", "\u062B", "\u0631", "\u062E", "\u062C", "\u0633"],
        short: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
        abbreviated: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
        wide: ["\u0627\u0644\u0623\u062D\u062F", "\u0627\u0644\u0627\u062B\u0646\u064A\u0646", "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621", "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621", "\u0627\u0644\u062E\u0645\u064A\u0633", "\u0627\u0644\u062C\u0645\u0639\u0629", "\u0627\u0644\u0633\u0628\u062A"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u0635",
          pm: "\u0639",
          morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
          noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
          evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
          night: "\u0627\u0644\u0644\u064A\u0644",
          midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
        },
        abbreviated: {
          am: "\u0635",
          pm: "\u0639",
          morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
          noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
          evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
          night: "\u0627\u0644\u0644\u064A\u0644",
          midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
        },
        wide: {
          am: "\u0635",
          pm: "\u0639",
          morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
          noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
          evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
          night: "\u0627\u0644\u0644\u064A\u0644",
          midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0635",
          pm: "\u0639",
          morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
          noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
          evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
          night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
          midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
        },
        abbreviated: {
          am: "\u0635",
          pm: "\u0639",
          morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
          noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
          evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
          night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
          midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
        },
        wide: {
          am: "\u0635",
          pm: "\u0639",
          morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
          noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
          afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
          evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
          night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
          midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
        }
      };

      var ordinalNumber = function (num) {
        return String(num);
      };

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return quarter - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /[قب]/,
        abbreviated: /[قب]\.م\./,
        wide: /(قبل|بعد) الميلاد/
      };
      var parseEraPatterns = {
        any: [/قبل/, /بعد/]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /ر[1234]/,
        wide: /الربع (الأول|الثاني|الثالث|الرابع)/
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[جفمأسند]/,
        abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
        wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
      };
      var parseMonthPatterns = {
        narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
        any: [/^جانفي/i, /^فيفري/i, /^مارس/i, /^أفريل/i, /^ماي/i, /^جوان/i, /^جويلية/i, /^أوت/i, /^سبتمبر/i, /^أكتوبر/i, /^نوفمبر/i, /^ديسمبر/i]
      };
      var matchDayPatterns = {
        narrow: /^[حنثرخجس]/i,
        short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
        abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
        wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
      };
      var parseDayPatterns = {
        narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
        wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
        any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
        any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ص/,
          pm: /^ع/,
          midnight: /نص الليل/,
          noon: /قايلة/,
          afternoon: /بعد القايلة/,
          morning: /صباح/,
          evening: /عشية/,
          night: /ليل/
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "bir saniy\u0259d\u0259n az",
          other: "{{count}} bir saniy\u0259d\u0259n az"
        },
        xSeconds: {
          one: "1 saniy\u0259",
          other: "{{count}} saniy\u0259"
        },
        halfAMinute: "yar\u0131m d\u0259qiq\u0259",
        lessThanXMinutes: {
          one: "bir d\u0259qiq\u0259d\u0259n az",
          other: "{{count}} bir d\u0259qiq\u0259d\u0259n az"
        },
        xMinutes: {
          one: "bir d\u0259qiq\u0259",
          other: "{{count}} d\u0259qiq\u0259"
        },
        aboutXHours: {
          one: "t\u0259xmin\u0259n 1 saat",
          other: "t\u0259xmin\u0259n {{count}} saat"
        },
        xHours: {
          one: "1 saat",
          other: "{{count}} saat"
        },
        xDays: {
          one: "1 g\xFCn",
          other: "{{count}} g\xFCn"
        },
        aboutXWeeks: {
          one: "t\u0259xmin\u0259n 1 h\u0259ft\u0259",
          other: "t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
        },
        xWeeks: {
          one: "1 h\u0259ft\u0259",
          other: "{{count}} h\u0259ft\u0259"
        },
        aboutXMonths: {
          one: "t\u0259xmin\u0259n 1 ay",
          other: "t\u0259xmin\u0259n {{count}} ay"
        },
        xMonths: {
          one: "1 ay",
          other: "{{count}} ay"
        },
        aboutXYears: {
          one: "t\u0259xmin\u0259n 1 il",
          other: "t\u0259xmin\u0259n {{count}} il"
        },
        xYears: {
          one: "1 il",
          other: "{{count}} il"
        },
        overXYears: {
          one: "1 ild\u0259n \xE7ox",
          other: "{{count}} ild\u0259n \xE7ox"
        },
        almostXYears: {
          one: "dem\u0259k olar ki 1 il",
          other: "dem\u0259k olar ki {{count}} il"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + " \u0259vv\u0259l";
          } else {
            return result + " sonra";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, do MMMM y 'il'",
        long: "do MMMM y 'il'",
        medium: "d MMM y 'il'",
        short: "dd.MM.yyyy"
      };
      var timeFormats = {
        full: "H:mm:ss zzzz",
        long: "H:mm:ss z",
        medium: "H:mm:ss",
        short: "H:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}} - 'd\u0259'",
        long: "{{date}} {{time}} - 'd\u0259'",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'sonuncu' eeee p -'d\u0259'",
        yesterday: "'d\xFCn\u0259n' p -'d\u0259'",
        today: "'bug\xFCn' p -'d\u0259'",
        tomorrow: "'sabah' p -'d\u0259'",
        nextWeek: "eeee p -'d\u0259'",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["B", "A"],
        abbreviated: ["BC", "AD"],
        wide: ["Hz. \u0130sa'dan \xF6nc\u0259", "Anno Domini"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["K1", "K2", "K3", "K4"],
        wide: ["1ci kvartal", "2ci kvartal", "3c\xFC kvartal", "4c\xFC kvartal"] // Note: in English, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.

      };
      var monthValues = {
        narrow: ["Y", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
        abbreviated: ["Yan", "Fev", "Mar", "Apr", "May", "\u0130yun", "\u0130yul", "Avq", "Sen", "Okt", "Noy", "Dek"],
        wide: ["Yanvar", "Fevral", "Mart", "Aprel", "May", "\u0130yun", "\u0130yul", "Avqust", "Sentyabr", "Oktyabr", "Noyabr", "Dekabr"]
      };
      var dayValues = {
        narrow: ["B.", "B.e", "\xC7.a", "\xC7.", "C.a", "C.", "\u015E."],
        short: ["B.", "B.e", "\xC7.a", "\xC7.", "C.a", "C.", "\u015E."],
        abbreviated: ["Baz", "Baz.e", "\xC7\u0259r.a", "\xC7\u0259r", "C\xFCm.a", "C\xFCm", "\u015E\u0259"],
        wide: ["Bazar", "Bazar ert\u0259si", "\xC7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131", "\xC7\u0259r\u015F\u0259nb\u0259", "C\xFCm\u0259 ax\u015Fam\u0131", "C\xFCm\u0259", "\u015E\u0259nb\u0259"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "am",
          pm: "pm",
          midnight: "gec\u0259yar\u0131",
          noon: "g\xFCn",
          morning: "s\u0259h\u0259r",
          afternoon: "g\xFCnd\xFCz",
          evening: "ax\u015Fam",
          night: "gec\u0259"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "gec\u0259yar\u0131",
          noon: "g\xFCn",
          morning: "s\u0259h\u0259r",
          afternoon: "g\xFCnd\xFCz",
          evening: "ax\u015Fam",
          night: "gec\u0259"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "gec\u0259yar\u0131",
          noon: "g\xFCn",
          morning: "s\u0259h\u0259r",
          afternoon: "g\xFCnd\xFCz",
          evening: "ax\u015Fam",
          night: "gec\u0259"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "gec\u0259yar\u0131",
          noon: "g\xFCn",
          morning: "s\u0259h\u0259r",
          afternoon: "g\xFCnd\xFCz",
          evening: "ax\u015Fam",
          night: "gec\u0259"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "gec\u0259yar\u0131",
          noon: "g\xFCn",
          morning: "s\u0259h\u0259r",
          afternoon: "g\xFCnd\xFCz",
          evening: "ax\u015Fam",
          night: "gec\u0259"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "gec\u0259yar\u0131",
          noon: "g\xFCn",
          morning: "s\u0259h\u0259r",
          afternoon: "g\xFCnd\xFCz",
          evening: "ax\u015Fam",
          night: "gec\u0259"
        }
      };
      var suffixes = {
        1: "-inci",
        5: "-inci",
        8: "-inci",
        70: "-inci",
        80: "-inci",
        2: "-nci",
        7: "-nci",
        20: "-nci",
        50: "-nci",
        3: "-\xFCnc\xFC",
        4: "-\xFCnc\xFC",
        100: "-\xFCnc\xFC",
        6: "-nc\u0131",
        9: "-uncu",
        10: "-uncu",
        30: "-uncu",
        60: "-\u0131nc\u0131",
        90: "-\u0131nc\u0131"
      };

      function getSuffix(number) {
        if (number === 0) {
          // special case for zero
          return number + "-\u0131nc\u0131";
        }

        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return suffixes[a] || suffixes[b] || suffixes[c];
      }

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        var suffix = getSuffix(number);
        return number + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(b|a)$/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
        wide: /^(Hz. İsa'dan öncə|ümumi eradan əvvəl|anno domini|ümumi dövr)$/i
      };
      var parseEraPatterns = {
        any: [/^b$/i, /^(a|c)$/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]$/i,
        abbreviated: /^K[1234]$/i,
        wide: /^[1234](ci)? kvartal$/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[(?-i)yfmaisond]$/i,
        abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
        wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
      };
      var parseMonthPatterns = {
        narrow: [/^[(?-i)y]$/i, /^[(?-i)f]$/i, /^[(?-i)m]$/i, /^[(?-i)a]$/i, /^[(?-i)m]$/i, /^[(?-i)i]$/i, /^[(?-i)i]$/i, /^[(?-i)a]$/i, /^[(?-i)s]$/i, /^[(?-i)o]$/i, /^[(?-i)n]$/i, /^[(?-i)d]$/i],
        abbreviated: [/^Yan$/i, /^Fev$/i, /^Mar$/i, /^Apr$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avg$/i, /^Sen$/i, /^Okt$/i, /^Noy$/i, /^Dek$/i],
        wide: [/^Yanvar$/i, /^Fevral$/i, /^Mart$/i, /^Aprel$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avgust$/i, /^Sentyabr$/i, /^Oktyabr$/i, /^Noyabr$/i, /^Dekabr$/i]
      };
      var matchDayPatterns = {
        narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
        short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
        abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
        wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
      };
      var parseDayPatterns = {
        narrow: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i],
        abbreviated: [/^Baz\.e$/i, /^Çər$/i, /^Çər\.a$/i, /^Cüm$/i, /^Cüm\.a$/i, /^Şə$/i],
        wide: [/^Bazar$/i, /^Bazar ertəsi$/i, /^Çərşənbə axşamı$/i, /^Çərşənbə$/i, /^Cümə axşamı$/i, /^Cümə$/i, /^Şənbə$/i],
        any: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
        any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a$/i,
          pm: /^p$/i,
          midnight: /^gecəyarı$/i,
          noon: /^gün$/i,
          morning: /səhər$/i,
          afternoon: /gündüz$/i,
          evening: /axşam$/i,
          night: /gecə$/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;

      function declension(scheme, count) {
        // scheme for count=1 exists
        if (scheme.one !== undefined && count === 1) {
          return scheme.one;
        }

        var rem10 = count % 10;
        var rem100 = count % 100; // 1, 21, 31, ...

        if (rem10 === 1 && rem100 !== 11) {
          return scheme.singularNominative.replace("{{count}}", count); // 2, 3, 4, 22, 23, 24, 32 ...
        } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
          return scheme.singularGenitive.replace("{{count}}", count); // 5, 6, 7, 8, 9, 10, 11, ...
        } else {
          return scheme.pluralGenitive.replace("{{count}}", count);
        }
      }

      function buildLocalizeTokenFn(scheme) {
        return function (count, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              if (scheme.future) {
                return declension(scheme.future, count);
              } else {
                return "\u043F\u0440\u0430\u0437 " + declension(scheme.regular, count);
              }
            } else {
              if (scheme.past) {
                return declension(scheme.past, count);
              } else {
                return declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
              }
            }
          } else {
            return declension(scheme.regular, count);
          }
        };
      }

      var formatDistanceLocale = {
        lessThanXSeconds: buildLocalizeTokenFn({
          regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
          },
          future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
          }
        }),
        xSeconds: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
          },
          past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
          },
          future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
          }
        }),
        halfAMinute: function (_, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
            } else {
              return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
            }
          }

          return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        },
        lessThanXMinutes: buildLocalizeTokenFn({
          regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
          },
          future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
          }
        }),
        xMinutes: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
          },
          past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
          },
          future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
          }
        }),
        aboutXHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
          },
          future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
          }
        }),
        xHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
          },
          past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
          },
          future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
          }
        }),
        xDays: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
          }
        }),
        aboutXWeeks: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO

          },
          future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO

          }
        }),
        xWeeks: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
          }
        }),
        aboutXMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
          },
          future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
          }
        }),
        xMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
          }
        }),
        aboutXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
          },
          future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
          }
        }),
        xYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
          }
        }),
        overXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
          },
          future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
          }
        }),
        almostXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
          },
          future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
          }
        })
      };

      function formatDistance(token, count, options) {
        options = options || {};
        return formatDistanceLocale[token](count, options);
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM y '\u0433.'",
        long: "d MMMM y '\u0433.'",
        medium: "d MMM y '\u0433.'",
        short: "dd.MM.y"
      };
      var timeFormats = {
        full: "H:mm:ss zzzz",
        long: "H:mm:ss z",
        medium: "H:mm:ss",
        short: "H:mm"
      };
      var dateTimeFormats = {
        any: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "any"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;

      var _index = _interopRequireDefault(__webpack_require__(8));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var accusativeWeekdays = ["\u043D\u044F\u0434\u0437\u0435\u043B\u044E", "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A", "\u0430\u045E\u0442\u043E\u0440\u0430\u043A", "\u0441\u0435\u0440\u0430\u0434\u0443", "\u0447\u0430\u0446\u0432\u0435\u0440", "\u043F\u044F\u0442\u043D\u0456\u0446\u0443", "\u0441\u0443\u0431\u043E\u0442\u0443"];

      function lastWeek(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 5:
          case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";

          case 1:
          case 2:
          case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
        }
      }

      function thisWeek(day) {
        var weekday = accusativeWeekdays[day];
        return "'\u0443 " + weekday + " \u0430' p";
      }

      function nextWeek(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 5:
          case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";

          case 1:
          case 2:
          case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return lastWeek(day);
          }
        },
        yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
        today: "'\u0441\u0451\u043D\u043D\u044F \u0430' p",
        tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
        nextWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return nextWeek(day);
          }
        },
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date, baseDate, options);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u0434\u0430 \u043D.\u044D.", "\u043D.\u044D."],
        abbreviated: ["\u0434\u0430 \u043D. \u044D.", "\u043D. \u044D."],
        wide: ["\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B", "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1-\u044B \u043A\u0432.", "2-\u0456 \u043A\u0432.", "3-\u0456 \u043A\u0432.", "4-\u044B \u043A\u0432."],
        wide: ["1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
      };
      var monthValues = {
        narrow: ["\u0421", "\u041B", "\u0421", "\u041A", "\u041C", "\u0427", "\u041B", "\u0416", "\u0412", "\u041A", "\u041B", "\u0421"],
        abbreviated: ["\u0441\u0442\u0443\u0434\u0437.", "\u043B\u044E\u0442.", "\u0441\u0430\u043A.", "\u043A\u0440\u0430\u0441.", "\u043C\u0430\u0439", "\u0447\u044D\u0440\u0432.", "\u043B\u0456\u043F.", "\u0436\u043D.", "\u0432\u0435\u0440.", "\u043A\u0430\u0441\u0442\u0440.", "\u043B\u0456\u0441\u0442.", "\u0441\u043D\u0435\u0436."],
        wide: ["\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C", "\u043B\u044E\u0442\u044B", "\u0441\u0430\u043A\u0430\u0432\u0456\u043A", "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A", "\u043C\u0430\u0439", "\u0447\u044D\u0440\u0432\u0435\u043D\u044C", "\u043B\u0456\u043F\u0435\u043D\u044C", "\u0436\u043D\u0456\u0432\u0435\u043D\u044C", "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C", "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A", "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434", "\u0441\u043D\u0435\u0436\u0430\u043D\u044C"]
      };
      var formattingMonthValues = {
        narrow: ["\u0421", "\u041B", "\u0421", "\u041A", "\u041C", "\u0427", "\u041B", "\u0416", "\u0412", "\u041A", "\u041B", "\u0421"],
        abbreviated: ["\u0441\u0442\u0443\u0434\u0437.", "\u043B\u044E\u0442.", "\u0441\u0430\u043A.", "\u043A\u0440\u0430\u0441.", "\u043C\u0430\u044F", "\u0447\u044D\u0440\u0432.", "\u043B\u0456\u043F.", "\u0436\u043D.", "\u0432\u0435\u0440.", "\u043A\u0430\u0441\u0442\u0440.", "\u043B\u0456\u0441\u0442.", "\u0441\u043D\u0435\u0436."],
        wide: ["\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F", "\u043B\u044E\u0442\u0430\u0433\u0430", "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430", "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430", "\u043C\u0430\u044F", "\u0447\u044D\u0440\u0432\u0435\u043D\u044F", "\u043B\u0456\u043F\u0435\u043D\u044F", "\u0436\u043D\u0456\u045E\u043D\u044F", "\u0432\u0435\u0440\u0430\u0441\u043D\u044F", "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430", "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430", "\u0441\u043D\u0435\u0436\u043D\u044F"]
      };
      var dayValues = {
        narrow: ["\u041D", "\u041F", "\u0410", "\u0421", "\u0427", "\u041F", "\u0421"],
        short: ["\u043D\u0434", "\u043F\u043D", "\u0430\u045E", "\u0441\u0440", "\u0447\u0446", "\u043F\u0442", "\u0441\u0431"],
        abbreviated: ["\u043D\u044F\u0434\u0437", "\u043F\u0430\u043D", "\u0430\u045E\u0442", "\u0441\u0435\u0440", "\u0447\u0430\u0446", "\u043F\u044F\u0442", "\u0441\u0443\u0431"],
        wide: ["\u043D\u044F\u0434\u0437\u0435\u043B\u044F", "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A", "\u0430\u045E\u0442\u043E\u0440\u0430\u043A", "\u0441\u0435\u0440\u0430\u0434\u0430", "\u0447\u0430\u0446\u0432\u0435\u0440", "\u043F\u044F\u0442\u043D\u0456\u0446\u0430", "\u0441\u0443\u0431\u043E\u0442\u0430"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u043E\u045E\u043D.",
          noon: "\u043F\u043E\u045E\u0434.",
          morning: "\u0440\u0430\u043D.",
          afternoon: "\u0434\u0437\u0435\u043D\u044C",
          evening: "\u0432\u0435\u0447.",
          night: "\u043D\u043E\u0447"
        },
        abbreviated: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u043E\u045E\u043D.",
          noon: "\u043F\u043E\u045E\u0434.",
          morning: "\u0440\u0430\u043D.",
          afternoon: "\u0434\u0437\u0435\u043D\u044C",
          evening: "\u0432\u0435\u0447.",
          night: "\u043D\u043E\u0447"
        },
        wide: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
          noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
          morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
          afternoon: "\u0434\u0437\u0435\u043D\u044C",
          evening: "\u0432\u0435\u0447\u0430\u0440",
          night: "\u043D\u043E\u0447"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u043E\u045E\u043D.",
          noon: "\u043F\u043E\u045E\u0434.",
          morning: "\u0440\u0430\u043D.",
          afternoon: "\u0434\u043D\u044F",
          evening: "\u0432\u0435\u0447.",
          night: "\u043D\u043E\u0447\u044B"
        },
        abbreviated: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u043E\u045E\u043D.",
          noon: "\u043F\u043E\u045E\u0434.",
          morning: "\u0440\u0430\u043D.",
          afternoon: "\u0434\u043D\u044F",
          evening: "\u0432\u0435\u0447.",
          night: "\u043D\u043E\u0447\u044B"
        },
        wide: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
          noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
          morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
          afternoon: "\u0434\u043D\u044F",
          evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
          night: "\u043D\u043E\u0447\u044B"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var number = Number(dirtyNumber);
        var suffix;
        /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
         *  For date-month combinations should be used `d` formatter.
         *  Correct:   `d MMMM` (4 верасня)
         *  Incorrect: `do MMMM` (4-га верасня)
         *
         *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
         *  So for phrase "5th day of month" (`do дзень месяца`)
         *  library will produce:            `5-га дзень месяца`
         *  but correct spelling should be:  `5-ы дзень месяца`
         *
         *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
         */

        if (unit === "date") {
          suffix = "-\u0433\u0430";
        } else if (unit === "hour" || unit === "minute" || unit === "second") {
          suffix = "-\u044F";
        } else {
          suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
        }

        return number + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "any",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^((да )?н\.?\s?э\.?)/i,
        abbreviated: /^((да )?н\.?\s?э\.?)/i,
        wide: /^(да нашай эры|нашай эры|наша эра)/i
      };
      var parseEraPatterns = {
        any: [/^д/i, /^н/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
        wide: /^[1234](-?[ыі]?)? квартал/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[слкмчжв]/i,
        abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
        wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
      };
      var parseMonthPatterns = {
        narrow: [/^с/i, /^л/i, /^с/i, /^к/i, /^м/i, /^ч/i, /^л/i, /^ж/i, /^в/i, /^к/i, /^л/i, /^с/i],
        any: [/^ст/i, /^лю/i, /^са/i, /^кр/i, /^ма/i, /^ч/i, /^ліп/i, /^ж/i, /^в/i, /^ка/i, /^ліс/i, /^сн/i]
      };
      var matchDayPatterns = {
        narrow: /^[нпасч]/i,
        short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
        abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
        wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
      };
      var parseDayPatterns = {
        narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
        any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
        abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
        wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^дп/i,
          pm: /^пп/i,
          midnight: /^поўн/i,
          noon: /^поўд/i,
          morning: /^р/i,
          afternoon: /^д[зн]/i,
          evening: /^в/i,
          night: /^н/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
          other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        },
        xSeconds: {
          one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
          other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        },
        halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
        lessThanXMinutes: {
          one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
          other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
        },
        xMinutes: {
          one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
          other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
        },
        aboutXHours: {
          one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
          other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
        },
        xHours: {
          one: "1 \u0447\u0430\u0441",
          other: "{{count}} \u0447\u0430\u0441\u0430"
        },
        xDays: {
          one: "1 \u0434\u0435\u043D",
          other: "{{count}} \u0434\u043D\u0438"
        },
        aboutXWeeks: {
          one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
          other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
        },
        xWeeks: {
          one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
          other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
        },
        aboutXMonths: {
          one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
          other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
        },
        xMonths: {
          one: "1 \u043C\u0435\u0441\u0435\u0446",
          other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
        },
        aboutXYears: {
          one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
          other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
        },
        xYears: {
          one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
          other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
        },
        overXYears: {
          one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
          other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
        },
        almostXYears: {
          one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
          other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "\u0441\u043B\u0435\u0434 " + result;
          } else {
            return "\u043F\u0440\u0435\u0434\u0438 " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, dd MMMM yyyy",
        long: "dd MMMM yyyy",
        medium: "dd MMM yyyy",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "H:mm"
      };
      var dateTimeFormats = {
        any: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "any"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;

      var _index = _interopRequireDefault(__webpack_require__(8));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // Adapted from the `ru` translation


      var weekdays = ["\u043D\u0435\u0434\u0435\u043B\u044F", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u044F\u0434\u0430", "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A", "\u043F\u0435\u0442\u044A\u043A", "\u0441\u044A\u0431\u043E\u0442\u0430"];

      function lastWeek(day) {
        var weekday = weekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 6:
            return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";

          case 1:
          case 2:
          case 4:
          case 5:
            return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
        }
      }

      function thisWeek(day) {
        var weekday = weekdays[day];

        if (day === 2
        /* Tue */
        ) {
          return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
        } else {
          return "'\u0432 " + weekday + " \u0432' p";
        }
      }

      function nextWeek(day) {
        var weekday = weekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 6:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";

          case 1:
          case 2:
          case 4:
          case 5:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return lastWeek(day);
          }
        },
        yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
        today: "'\u0434\u043D\u0435\u0441 \u0432' p",
        tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
        nextWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return nextWeek(day);
          }
        },
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date, baseDate, options);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u043F\u0440.\u043D.\u0435.", "\u043D.\u0435."],
        abbreviated: ["\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.", "\u043D. \u0435."],
        wide: ["\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430", "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."],
        wide: ["1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"]
      };
      var monthValues = {
        abbreviated: ["\u044F\u043D\u0443", "\u0444\u0435\u0432", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0439", "\u044E\u043D\u0438", "\u044E\u043B\u0438", "\u0430\u0432\u0433", "\u0441\u0435\u043F", "\u043E\u043A\u0442", "\u043D\u043E\u0435", "\u0434\u0435\u043A"],
        wide: ["\u044F\u043D\u0443\u0430\u0440\u0438", "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0438\u043B", "\u043C\u0430\u0439", "\u044E\u043D\u0438", "\u044E\u043B\u0438", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438", "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438", "\u043D\u043E\u0435\u043C\u0432\u0440\u0438", "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"]
      };
      var dayValues = {
        narrow: ["\u041D", "\u041F", "\u0412", "\u0421", "\u0427", "\u041F", "\u0421"],
        short: ["\u043D\u0434", "\u043F\u043D", "\u0432\u0442", "\u0441\u0440", "\u0447\u0442", "\u043F\u0442", "\u0441\u0431"],
        abbreviated: ["\u043D\u0435\u0434", "\u043F\u043E\u043D", "\u0432\u0442\u043E", "\u0441\u0440\u044F", "\u0447\u0435\u0442", "\u043F\u0435\u0442", "\u0441\u044A\u0431"],
        wide: ["\u043D\u0435\u0434\u0435\u043B\u044F", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u044F\u0434\u0430", "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A", "\u043F\u0435\u0442\u044A\u043A", "\u0441\u044A\u0431\u043E\u0442\u0430"]
      };
      var dayPeriodValues = {
        wide: {
          am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
          pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
          midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
          noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
          morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
          afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
          evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
          night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
        }
      };

      function isFeminine(unit) {
        return unit === "year" || unit === "week" || unit === "minute" || unit === "second";
      }

      function isNeuter(unit) {
        return unit === "quarter";
      }

      function numberWithSuffix(number, unit, masculine, feminine, neuter) {
        var suffix = isNeuter(unit) ? neuter : isFeminine(unit) ? feminine : masculine;
        return number + "-" + suffix;
      }

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var number = Number(dirtyNumber);

        if (number === 0) {
          return numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
        } else if (number % 1000 === 0) {
          return numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
        } else if (number % 100 === 0) {
          return numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
        }

        var rem100 = number % 100;

        if (rem100 > 20 || rem100 < 10) {
          switch (rem100 % 10) {
            case 1:
              return numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");

            case 2:
              return numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");

            case 7:
            case 8:
              return numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
          }
        }

        return numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^((пр)?н\.?\s?е\.?)/i,
        abbreviated: /^((пр)?н\.?\s?е\.?)/i,
        wide: /^(преди новата ера|новата ера|нова ера)/i
      };
      var parseEraPatterns = {
        any: [/^п/i, /^н/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
        wide: /^[1234](-?[врт]?о?)? тримесечие/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchDayPatterns = {
        narrow: /^[нпвсч]/i,
        short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
        abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
        wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
      };
      var parseDayPatterns = {
        narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
        any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i]
      };
      var matchMonthPatterns = {
        abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
        wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
      };
      var parseMonthPatterns = {
        any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^юн/i, /^юл/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^преди о/i,
          pm: /^след о/i,
          midnight: /^в пол/i,
          noon: /^на об/i,
          morning: /^сут/i,
          afternoon: /^следо/i,
          evening: /^веч/i,
          night: /^през н/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;

      var _index = _interopRequireDefault(__webpack_require__(64));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
          other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
        },
        xSeconds: {
          one: "\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
          other: "{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
        },
        halfAMinute: "\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
        lessThanXMinutes: {
          one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
          other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
        },
        xMinutes: {
          one: "\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
          other: "{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
        },
        aboutXHours: {
          one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
          other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
        },
        xHours: {
          one: "\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
          other: "{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
        },
        xDays: {
          one: "\u09E7 \u09A6\u09BF\u09A8",
          other: "{{count}} \u09A6\u09BF\u09A8"
        },
        aboutXWeeks: {
          one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
          other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
        },
        xWeeks: {
          one: "\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
          other: "{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
        },
        aboutXMonths: {
          one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
          other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
        },
        xMonths: {
          one: "\u09E7 \u09AE\u09BE\u09B8",
          other: "{{count}} \u09AE\u09BE\u09B8"
        },
        aboutXYears: {
          one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
          other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
        },
        xYears: {
          one: "\u09E7 \u09AC\u099B\u09B0",
          other: "{{count}} \u09AC\u099B\u09B0"
        },
        overXYears: {
          one: "\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
          other: "{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
        },
        almostXYears: {
          one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
          other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", _index.default.numberToLocale(count));
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + " \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
          } else {
            return result + " \u0986\u0997\u09C7";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, MMMM do, y",
        long: "MMMM do, y",
        medium: "MMM d, y",
        short: "MM/dd/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
        long: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
        yesterday: "'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
        today: "'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
        tomorrow: "'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
        nextWeek: "eeee '\u09B8\u09AE\u09DF' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
        abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
        wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
      };
      var parseEraPatterns = {
        narrow: [/^খ্রিঃপূঃ/i, /^খ্রিঃ/i],
        abbreviated: [/^খ্রিঃপূর্ব/i, /^খ্রিঃ/i],
        wide: [/^খ্রিস্টপূর্ব/i, /^খ্রিস্টাব্দ/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[১২৩৪]/i,
        abbreviated: /^[১২৩৪]ত্রৈ/i,
        wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
      };
      var parseQuarterPatterns = {
        any: [/১/i, /২/i, /৩/i, /৪/i]
      };
      var matchMonthPatterns = {
        narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
        abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
        wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
      };
      var parseMonthPatterns = {
        any: [/^জানু/i, /^ফেব্রু/i, /^মার্চ/i, /^এপ্রিল/i, /^মে/i, /^জুন/i, /^জুলাই/i, /^আগস্ট/i, /^সেপ্ট/i, /^অক্টো/i, /^নভে/i, /^ডিসে/i]
      };
      var matchDayPatterns = {
        narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
        short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
        abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
        wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
      };
      var parseDayPatterns = {
        narrow: [/^র/i, /^সো/i, /^ম/i, /^বু/i, /^বৃ/i, /^শু/i, /^শ/i],
        short: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
        abbreviated: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
        wide: [/^রবিবার/i, /^সোমবার/i, /^মঙ্গলবার/i, /^বুধবার/i, /^বৃহস্পতিবার /i, /^শুক্রবার/i, /^শনিবার/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
        abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
        wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^পূ/i,
          pm: /^অপ/i,
          midnight: /^মধ্যরাত/i,
          noon: /^মধ্যাহ্ন/i,
          morning: /সকাল/i,
          afternoon: /বিকাল/i,
          evening: /সন্ধ্যা/i,
          night: /রাত/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
          },
          dual: "manje od {{count}} sekunde",
          other: "manje od {{count}} sekundi"
        },
        xSeconds: {
          one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
          },
          dual: "{{count}} sekunde",
          other: "{{count}} sekundi"
        },
        halfAMinute: "pola minute",
        lessThanXMinutes: {
          one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
          },
          dual: "manje od {{count}} minute",
          other: "manje od {{count}} minuta"
        },
        xMinutes: {
          one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
          },
          dual: "{{count}} minute",
          other: "{{count}} minuta"
        },
        aboutXHours: {
          one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
          },
          dual: "oko {{count}} sata",
          other: "oko {{count}} sati"
        },
        xHours: {
          one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
          },
          dual: "{{count}} sata",
          other: "{{count}} sati"
        },
        xDays: {
          one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
          },
          dual: "{{count}} dana",
          other: "{{count}} dana"
        },
        aboutXWeeks: {
          one: {
            standalone: "oko 1 sedmicu",
            withPrepositionAgo: "oko 1 sedmicu",
            withPrepositionIn: "oko 1 sedmicu"
          },
          dual: "oko {{count}} sedmice",
          other: "oko {{count}} sedmice"
        },
        xWeeks: {
          one: {
            standalone: "1 sedmicu",
            withPrepositionAgo: "1 sedmicu",
            withPrepositionIn: "1 sedmicu"
          },
          dual: "{{count}} sedmice",
          other: "{{count}} sedmice"
        },
        aboutXMonths: {
          one: {
            standalone: "oko 1 mjesec",
            withPrepositionAgo: "oko 1 mjesec",
            withPrepositionIn: "oko 1 mjesec"
          },
          dual: "oko {{count}} mjeseca",
          other: "oko {{count}} mjeseci"
        },
        xMonths: {
          one: {
            standalone: "1 mjesec",
            withPrepositionAgo: "1 mjesec",
            withPrepositionIn: "1 mjesec"
          },
          dual: "{{count}} mjeseca",
          other: "{{count}} mjeseci"
        },
        aboutXYears: {
          one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
          },
          dual: "oko {{count}} godine",
          other: "oko {{count}} godina"
        },
        xYears: {
          one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
          },
          dual: "{{count}} godine",
          other: "{{count}} godina"
        },
        overXYears: {
          one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
          },
          dual: "preko {{count}} godine",
          other: "preko {{count}} godina"
        },
        almostXYears: {
          one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
          },
          dual: "gotovo {{count}} godine",
          other: "gotovo {{count}} godina"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              result = formatDistanceLocale[token].one.withPrepositionIn;
            } else {
              result = formatDistanceLocale[token].one.withPrepositionAgo;
            }
          } else {
            result = formatDistanceLocale[token].one.standalone;
          }
        } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
        String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
        ) {
          result = formatDistanceLocale[token].dual.replace("{{count}}", count);
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "za " + result;
          } else {
            return "prije " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d. MMMM yyyy.",
        long: "d. MMMM yyyy.",
        medium: "d. MMM yy.",
        short: "dd. MM. yy."
      };
      var timeFormats = {
        full: "HH:mm:ss (zzzz)",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'u' {{time}}",
        long: "{{date}} 'u' {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function (date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'pro\u0161le nedjelje u' p";

            case 3:
              return "'pro\u0161le srijede u' p";

            case 6:
              return "'pro\u0161le subote u' p";

            default:
              return "'pro\u0161li' EEEE 'u' p";
          }
        },
        yesterday: "'ju\u010De u' p",
        today: "'danas u' p",
        tomorrow: "'sutra u' p",
        nextWeek: function (date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'sljede\u0107e nedjelje u' p";

            case 3:
              return "'sljede\u0107u srijedu u' p";

            case 6:
              return "'sljede\u0107u subotu u' p";

            default:
              return "'sljede\u0107i' EEEE 'u' p";
          }
        },
        other: "P"
      };

      function formatRelative(token, date, _baseDate, _options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return String(number).concat(".");
      }

      var eraValues = {
        narrow: ["pr.n.e.", "AD"],
        abbreviated: ["pr. Hr.", "po. Hr."],
        wide: ["Prije Hrista", "Poslije Hrista"]
      };
      var monthValues = {
        narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
        abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
        wide: ["januar", "februar", "mart", "april", "maj", "juni", "juli", "avgust", "septembar", "oktobar", "novembar", "decembar"]
      };
      var formattingMonthValues = {
        narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
        abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
        wide: ["januar", "februar", "mart", "april", "maj", "juni", "juli", "avgust", "septembar", "oktobar", "novembar", "decembar"]
      };
      var quarterValues = {
        narrow: ["1.", "2.", "3.", "4."],
        abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
        wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
      };
      var dayValues = {
        narrow: ["N", "P", "U", "S", "\u010C", "P", "S"],
        short: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
        abbreviated: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
        wide: ["nedjelja", "ponedjeljak", "utorak", "srijeda", "\u010Detvrtak", "petak", "subota"]
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutru",
          afternoon: "popodne",
          evening: "uve\u010De",
          night: "no\u0107u"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutru",
          afternoon: "popodne",
          evening: "uve\u010De",
          night: "no\u0107u"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutru",
          afternoon: "poslije podne",
          evening: "uve\u010De",
          night: "no\u0107u"
        }
      };
      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutru",
          afternoon: "popodne",
          evening: "uve\u010De",
          night: "no\u0107u"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutru",
          afternoon: "popodne",
          evening: "uve\u010De",
          night: "no\u0107u"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutru",
          afternoon: "poslije podne",
          evening: "uve\u010De",
          night: "no\u0107u"
        }
      };
      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)\./i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(pr\.n\.e\.|AD)/i,
        abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
        wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
      };
      var parseEraPatterns = {
        any: [/^pr/i, /^(po|nova)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]\.\s?kv\.?/i,
        wide: /^[1234]\. kvartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(10|11|12|[123456789])\./i,
        abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
        wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
      };
      var parseMonthPatterns = {
        narrow: [/(10|11|12|[123456789])/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[npusčc]/i,
        short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
        abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
        wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^pono/i,
          noon: /^pod/i,
          morning: /jutro/i,
          afternoon: /(poslije\s|po)+podne/i,
          evening: /(uvece|uveče)/i,
          night: /(nocu|noću)/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      /**
       * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
       *    l'1 de juliol ('l'u')
       *    l'11 de novembre ('l'onze')
       *    l'11a clàusula del contracte ('l'onzena')
       *    la contractació d'11 jugadors ('d'onze')
       *    l'aval d'11.000 socis ('d'onze mil')
       *
       * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
       */

      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "menys d'un segon",
          eleven: "menys d'onze segons",
          other: "menys de {{count}} segons"
        },
        xSeconds: {
          one: "1 segon",
          other: "{{count}} segons"
        },
        halfAMinute: "mig minut",
        lessThanXMinutes: {
          one: "menys d'un minut",
          eleven: "menys d'onze minuts",
          other: "menys de {{count}} minuts"
        },
        xMinutes: {
          one: "1 minut",
          other: "{{count}} minuts"
        },
        aboutXHours: {
          one: "aproximadament una hora",
          other: "aproximadament {{count}} hores"
        },
        xHours: {
          one: "1 hora",
          other: "{{count}} hores"
        },
        xDays: {
          one: "1 dia",
          other: "{{count}} dies"
        },
        aboutXWeeks: {
          one: "aproximadament una setmana",
          other: "aproximadament {{count}} setmanes"
        },
        xWeeks: {
          one: "1 setmana",
          other: "{{count}} setmanes"
        },
        aboutXMonths: {
          one: "aproximadament un mes",
          other: "aproximadament {{count}} mesos"
        },
        xMonths: {
          one: "1 mes",
          other: "{{count}} mesos"
        },
        aboutXYears: {
          one: "aproximadament un any",
          other: "aproximadament {{count}} anys"
        },
        xYears: {
          one: "1 any",
          other: "{{count}} anys"
        },
        overXYears: {
          one: "m\xE9s d'un any",
          eleven: "m\xE9s d'onze anys",
          other: "m\xE9s de {{count}} anys"
        },
        almostXYears: {
          one: "gaireb\xE9 un any",
          other: "gaireb\xE9 {{count}} anys"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 11 && formatDistanceLocale[token].eleven) {
          result = formatDistanceLocale[token].eleven;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "en " + result;
          } else {
            return "fa " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d 'de' MMMM y",
        long: "d 'de' MMMM y",
        medium: "d MMM y",
        short: "dd/MM/y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'a les' {{time}}",
        long: "{{date}} 'a les' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'el' eeee 'passat a la' LT",
        yesterday: "'ahir a la' p",
        today: "'avui a la' p",
        tomorrow: "'dem\xE0 a la' p",
        nextWeek: "eeee 'a la' p",
        other: "P"
      };
      var formatRelativeLocalePlural = {
        lastWeek: "'el' eeee 'passat a les' p",
        yesterday: "'ahir a les' p",
        today: "'avui a les' p",
        tomorrow: "'dem\xE0 a les' p",
        nextWeek: "eeee 'a les' p",
        other: "P"
      };

      function formatRelative(token, date, _baseDate, _options) {
        if (date.getUTCHours() !== 1) {
          return formatRelativeLocalePlural[token];
        }

        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * General information
       * Reference: https://aplicacions.llengua.gencat.cat
       * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
       */

      /**
       * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
       * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
       */


      var eraValues = {
        narrow: ["aC", "dC"],
        abbreviated: ["a. de C.", "d. de C."],
        wide: ["abans de Crist", "despr\xE9s de Crist"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["T1", "T2", "T3", "T4"],
        wide: ["1r trimestre", "2n trimestre", "3r trimestre", "4t trimestre"]
      };
      /**
       * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
       * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
       *
       * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
       */

      var monthValues = {
        narrow: ["GN", "FB", "M\xC7", "AB", "MG", "JN", "JL", "AG", "ST", "OC", "NV", "DS"],

        /**
         * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
         * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
         * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
         */
        abbreviated: ["gen.", "febr.", "mar\xE7", "abr.", "maig", "juny", "jul.", "ag.", "set.", "oct.", "nov.", "des."],
        wide: ["gener", "febrer", "mar\xE7", "abril", "maig", "juny", "juliol", "agost", "setembre", "octubre", "novembre", "desembre"]
      };
      /**
       * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
       * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
       * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
       *
       * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
       * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
       * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
       *
       * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
       */

      var dayValues = {
        narrow: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
        short: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
        abbreviated: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
        wide: ["diumenge", "dilluns", "dimarts", "dimecres", "dijous", "divendres", "dissabte"]
      };
      /**
       * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
       */

      var dayPeriodValues = {
        narrow: {
          am: "am",
          pm: "pm",
          midnight: "mitjanit",
          noon: "migdia",
          morning: "mat\xED",
          afternoon: "tarda",
          evening: "vespre",
          night: "nit"
        },
        abbreviated: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "mitjanit",
          noon: "migdia",
          morning: "mat\xED",
          afternoon: "tarda",
          evening: "vespre",
          night: "nit"
        },
        wide: {
          am: "ante meridiem",
          pm: "post meridiem",
          midnight: "mitjanit",
          noon: "migdia",
          morning: "mat\xED",
          afternoon: "tarda",
          evening: "vespre",
          night: "nit"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "am",
          pm: "pm",
          midnight: "de la mitjanit",
          noon: "del migdia",
          morning: "del mat\xED",
          afternoon: "de la tarda",
          evening: "del vespre",
          night: "de la nit"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "de la mitjanit",
          noon: "del migdia",
          morning: "del mat\xED",
          afternoon: "de la tarda",
          evening: "del vespre",
          night: "de la nit"
        },
        wide: {
          am: "ante meridiem",
          pm: "post meridiem",
          midnight: "de la mitjanit",
          noon: "del migdia",
          morning: "del mat\xED",
          afternoon: "de la tarda",
          evening: "del vespre",
          night: "de la nit"
        }
      };
      /**
       * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
       * És optatiu posar punt després de la lletra.
       *
       * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
       *
       * @param {Number} dirtyNumber
       * @param {Object} [_dirtyOptions]
       */

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        var rem100 = number % 100;

        if (rem100 > 20 || rem100 < 10) {
          switch (rem100 % 10) {
            case 1:
              return number + "r";

            case 2:
              return number + "n";

            case 3:
              return number + "r";

            case 4:
              return number + "t";
          }
        }

        return number + "\xE8";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(aC|dC)/i,
        abbreviated: /^(a. de C.|d. de C.)/i,
        wide: /^(abans de Crist|despr[eé]s de Crist)/i
      };
      var parseEraPatterns = {
        narrow: [/^aC/i, /^dC/i],
        abbreviated: [/^(a. de C.)/i, /^(d. de C.)/i],
        wide: [/^(abans de Crist)/i, /^(despr[eé]s de Crist)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^T[1234]/i,
        wide: /^[1234](è|r|n|r|t)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
        abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
        wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
      };
      var parseMonthPatterns = {
        narrow: [/^GN/i, /^FB/i, /^MÇ/i, /^AB/i, /^MG/i, /^JN/i, /^JL/i, /^AG/i, /^ST/i, /^OC/i, /^NV/i, /^DS/i],
        abbreviated: [/^gen./i, /^febr./i, /^març/i, /^abr./i, /^maig/i, /^juny/i, /^jul./i, /^ag./i, /^set./i, /^oct./i, /^nov./i, /^des./i],
        wide: [/^gener/i, /^febrer/i, /^març/i, /^abril/i, /^maig/i, /^juny/i, /^juliol/i, /^agost/i, /^setembre/i, /^octubre/i, /^novembre/i, /^desembre/i]
      };
      var matchDayPatterns = {
        narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
        short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
        abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
        wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
      };
      var parseDayPatterns = {
        narrow: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
        abbreviated: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
        wide: [/^diumenge/i, /^dilluns/i, /^dimarts/i, /^dimecres/i, /^dijous/i, /^divendres/i, /^disssabte/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
        abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
        wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mitjanit/i,
          noon: /^migdia/i,
          morning: /matí/i,
          afternoon: /tarda/i,
          evening: /vespre/i,
          night: /nit/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            regular: "m\xE9n\u011B ne\u017E sekunda",
            past: "p\u0159ed m\xE9n\u011B ne\u017E sekundou",
            future: "za m\xE9n\u011B ne\u017E sekundu"
          },
          few: {
            regular: "m\xE9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xE9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xE9n\u011B ne\u017E {{count}} sekundy"
          },
          many: {
            regular: "m\xE9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xE9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xE9n\u011B ne\u017E {{count}} sekund"
          }
        },
        xSeconds: {
          one: {
            regular: "sekunda",
            past: "p\u0159ed sekundou",
            future: "za sekundu"
          },
          few: {
            regular: "{{count}} sekundy",
            past: "p\u0159ed {{count}} sekundami",
            future: "za {{count}} sekundy"
          },
          many: {
            regular: "{{count}} sekund",
            past: "p\u0159ed {{count}} sekundami",
            future: "za {{count}} sekund"
          }
        },
        halfAMinute: {
          other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
          }
        },
        lessThanXMinutes: {
          one: {
            regular: "m\xE9n\u011B ne\u017E minuta",
            past: "p\u0159ed m\xE9n\u011B ne\u017E minutou",
            future: "za m\xE9n\u011B ne\u017E minutu"
          },
          few: {
            regular: "m\xE9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xE9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xE9n\u011B ne\u017E {{count}} minuty"
          },
          many: {
            regular: "m\xE9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xE9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xE9n\u011B ne\u017E {{count}} minut"
          }
        },
        xMinutes: {
          one: {
            regular: "minuta",
            past: "p\u0159ed minutou",
            future: "za minutu"
          },
          few: {
            regular: "{{count}} minuty",
            past: "p\u0159ed {{count}} minutami",
            future: "za {{count}} minuty"
          },
          many: {
            regular: "{{count}} minut",
            past: "p\u0159ed {{count}} minutami",
            future: "za {{count}} minut"
          }
        },
        aboutXHours: {
          one: {
            regular: "p\u0159ibli\u017En\u011B hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
            future: "p\u0159ibli\u017En\u011B za hodinu"
          },
          few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
          },
          many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
          }
        },
        xHours: {
          one: {
            regular: "hodina",
            past: "p\u0159ed hodinou",
            future: "za hodinu"
          },
          few: {
            regular: "{{count}} hodiny",
            past: "p\u0159ed {{count}} hodinami",
            future: "za {{count}} hodiny"
          },
          many: {
            regular: "{{count}} hodin",
            past: "p\u0159ed {{count}} hodinami",
            future: "za {{count}} hodin"
          }
        },
        xDays: {
          one: {
            regular: "den",
            past: "p\u0159ed dnem",
            future: "za den"
          },
          few: {
            regular: "{{count}} dny",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dny"
          },
          many: {
            regular: "{{count}} dn\xED",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xED"
          }
        },
        aboutXWeeks: {
          one: {
            regular: "p\u0159ibli\u017En\u011B t\xFDden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed t\xFDdnem",
            future: "p\u0159ibli\u017En\u011B za t\xFDden"
          },
          few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xFDdny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xFDdny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xFDdny"
          },
          many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xFDdn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xFDdny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xFDdn\u016F"
          }
        },
        xWeeks: {
          one: {
            regular: "t\xFDden",
            past: "p\u0159ed t\xFDdnem",
            future: "za t\xFDden"
          },
          few: {
            regular: "{{count}} t\xFDdny",
            past: "p\u0159ed {{count}} t\xFDdny",
            future: "za {{count}} t\xFDdny"
          },
          many: {
            regular: "{{count}} t\xFDdn\u016F",
            past: "p\u0159ed {{count}} t\xFDdny",
            future: "za {{count}} t\xFDdn\u016F"
          }
        },
        aboutXMonths: {
          one: {
            regular: "p\u0159ibli\u017En\u011B m\u011Bs\xEDc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xEDcem",
            future: "p\u0159ibli\u017En\u011B za m\u011Bs\xEDc"
          },
          few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xEDce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xEDci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xEDce"
          },
          many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xEDc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xEDci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xEDc\u016F"
          }
        },
        xMonths: {
          one: {
            regular: "m\u011Bs\xEDc",
            past: "p\u0159ed m\u011Bs\xEDcem",
            future: "za m\u011Bs\xEDc"
          },
          few: {
            regular: "{{count}} m\u011Bs\xEDce",
            past: "p\u0159ed {{count}} m\u011Bs\xEDci",
            future: "za {{count}} m\u011Bs\xEDce"
          },
          many: {
            regular: "{{count}} m\u011Bs\xEDc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xEDci",
            future: "za {{count}} m\u011Bs\xEDc\u016F"
          }
        },
        aboutXYears: {
          one: {
            regular: "p\u0159ibli\u017En\u011B rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
            future: "p\u0159ibli\u017En\u011B za rok"
          },
          few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
          },
          many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
          }
        },
        xYears: {
          one: {
            regular: "rok",
            past: "p\u0159ed rokem",
            future: "za rok"
          },
          few: {
            regular: "{{count}} roky",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} roky"
          },
          many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
          }
        },
        overXYears: {
          one: {
            regular: "v\xEDce ne\u017E rok",
            past: "p\u0159ed v\xEDce ne\u017E rokem",
            future: "za v\xEDce ne\u017E rok"
          },
          few: {
            regular: "v\xEDce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xEDce ne\u017E {{count}} roky",
            future: "za v\xEDce ne\u017E {{count}} roky"
          },
          many: {
            regular: "v\xEDce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xEDce ne\u017E {{count}} roky",
            future: "za v\xEDce ne\u017E {{count}} rok\u016F"
          }
        },
        almostXYears: {
          one: {
            regular: "skoro rok",
            past: "skoro p\u0159ed rokem",
            future: "skoro za rok"
          },
          few: {
            regular: "skoro {{count}} roky",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} roky"
          },
          many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
          }
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var scheme = formatDistanceLocale[token]; // cs pluralization

        var pluralToken;

        if (typeof scheme.other === "object") {
          pluralToken = "other";
        } else if (count === 1) {
          pluralToken = "one";
        } else if (count > 1 && count < 5 || count === 0) {
          pluralToken = "few";
        } else {
          pluralToken = "many";
        } // times


        var suffixExist = options.addSuffix === true;
        var comparison = options.comparison;
        var timeToken;

        if (suffixExist && comparison === -1) {
          timeToken = "past";
        } else if (suffixExist && comparison === 1) {
          timeToken = "future";
        } else {
          timeToken = "regular";
        }

        return scheme[pluralToken][timeToken].replace("{{count}}", count);
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d. MMMM yyyy",
        long: "d. MMMM yyyy",
        medium: "d. M. yyyy",
        short: "dd.MM.yyyy"
      };
      var timeFormats = {
        full: "H:mm:ss zzzz",
        long: "H:mm:ss z",
        medium: "H:mm:ss",
        short: "H:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'v' {{time}}",
        long: "{{date}} 'v' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var accusativeWeekdays = ["ned\u011Bli", "pond\u011Bl\xED", "\xFAter\xFD", "st\u0159edu", "\u010Dtvrtek", "p\xE1tek", "sobotu"];
      var formatRelativeLocale = {
        lastWeek: "'posledn\xED' eeee 've' p",
        yesterday: "'v\u010Dera v' p",
        today: "'dnes v' p",
        tomorrow: "'z\xEDtra v' p",
        nextWeek: function (date, _baseDate, _options) {
          var day = date.getUTCDay();
          return "'v " + accusativeWeekdays[day] + " o' p";
        },
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date, baseDate, options);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["p\u0159. n. l.", "n. l."],
        abbreviated: ["p\u0159. n. l.", "n. l."],
        wide: ["p\u0159ed na\u0161\xEDm letopo\u010Dtem", "na\u0161eho letopo\u010Dtu"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1. \u010Dtvrtlet\xED", "2. \u010Dtvrtlet\xED", "3. \u010Dtvrtlet\xED", "4. \u010Dtvrtlet\xED"],
        wide: ["1. \u010Dtvrtlet\xED", "2. \u010Dtvrtlet\xED", "3. \u010Dtvrtlet\xED", "4. \u010Dtvrtlet\xED"]
      };
      var monthValues = {
        narrow: ["L", "\xDA", "B", "D", "K", "\u010C", "\u010C", "S", "Z", "\u0158", "L", "P"],
        abbreviated: ["led", "\xFAno", "b\u0159e", "dub", "kv\u011B", "\u010Dvn", "\u010Dvc", "srp", "z\xE1\u0159", "\u0159\xEDj", "lis", "pro"],
        wide: ["leden", "\xFAnor", "b\u0159ezen", "duben", "kv\u011Bten", "\u010Derven", "\u010Dervenec", "srpen", "z\xE1\u0159\xED", "\u0159\xEDjen", "listopad", "prosinec"]
      };
      var formattingMonthValues = {
        narrow: ["L", "\xDA", "B", "D", "K", "\u010C", "\u010C", "S", "Z", "\u0158", "L", "P"],
        abbreviated: ["led", "\xFAno", "b\u0159e", "dub", "kv\u011B", "\u010Dvn", "\u010Dvc", "srp", "z\xE1\u0159", "\u0159\xEDj", "lis", "pro"],
        wide: ["ledna", "\xFAnora", "b\u0159ezna", "dubna", "kv\u011Btna", "\u010Dervna", "\u010Dervence", "srpna", "z\xE1\u0159\xED", "\u0159\xEDjna", "listopadu", "prosince"]
      };
      var dayValues = {
        narrow: ["ne", "po", "\xFAt", "st", "\u010Dt", "p\xE1", "so"],
        short: ["ne", "po", "\xFAt", "st", "\u010Dt", "p\xE1", "so"],
        abbreviated: ["ned", "pon", "\xFAte", "st\u0159", "\u010Dtv", "p\xE1t", "sob"],
        wide: ["ned\u011Ble", "pond\u011Bl\xED", "\xFAter\xFD", "st\u0159eda", "\u010Dtvrtek", "p\xE1tek", "sobota"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "dop.",
          pm: "odp.",
          midnight: "p\u016Flnoc",
          noon: "poledne",
          morning: "r\xE1no",
          afternoon: "odpoledne",
          evening: "ve\u010Der",
          night: "noc"
        },
        abbreviated: {
          am: "dop.",
          pm: "odp.",
          midnight: "p\u016Flnoc",
          noon: "poledne",
          morning: "r\xE1no",
          afternoon: "odpoledne",
          evening: "ve\u010Der",
          night: "noc"
        },
        wide: {
          am: "dopoledne",
          pm: "odpoledne",
          midnight: "p\u016Flnoc",
          noon: "poledne",
          morning: "r\xE1no",
          afternoon: "odpoledne",
          evening: "ve\u010Der",
          night: "noc"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "dop.",
          pm: "odp.",
          midnight: "p\u016Flnoc",
          noon: "poledne",
          morning: "r\xE1no",
          afternoon: "odpoledne",
          evening: "ve\u010Der",
          night: "noc"
        },
        abbreviated: {
          am: "dop.",
          pm: "odp.",
          midnight: "p\u016Flnoc",
          noon: "poledne",
          morning: "r\xE1no",
          afternoon: "odpoledne",
          evening: "ve\u010Der",
          night: "noc"
        },
        wide: {
          am: "dopoledne",
          pm: "odpoledne",
          midnight: "p\u016Flnoc",
          noon: "poledne",
          morning: "r\xE1no",
          afternoon: "odpoledne",
          evening: "ve\u010Der",
          night: "noc"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + ".";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)\.?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(p[řr]ed Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
        abbreviated: /^(pe[řr]ed Kr\.|pe[řr]ed n\. l\.|po Kr\.|n\. l\.)/i,
        wide: /^(p[řr]ed Kristem|pred na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
      };
      var parseEraPatterns = {
        any: [/^p[řr]/i, /^(po|n)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
        wide: /^[1234]\. [čc]tvrtlet[íi]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[lúubdkčcszřrlp]/i,
        abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
        wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
      };
      var parseMonthPatterns = {
        narrow: [/^l/i, /^[úu]/i, /^b/i, /^d/i, /^k/i, /^[čc]/i, /^[čc]/i, /^s/i, /^z/i, /^[řr]/i, /^l/i, /^p/i],
        any: [/^led/i, /^[úu]n/i, /^b[řr]e/i, /^dub/i, /^kv[ěe]/i, /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i, /^[čc]vc|[čc]erven(ec|ce)/i, /^srp/i, /^z[áa][řr]/i, /^[řr][íi]j/i, /^lis/i, /^pro/i]
      };
      var matchDayPatterns = {
        narrow: /^[npuúsčps]/i,
        short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
        abbreviated: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
        wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
      };
      var parseDayPatterns = {
        narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
        any: [/^ne/i, /^po/i, /^ut/i, /^st/i, /^[čc]t/i, /^p/i, /^so/i]
      };
      var matchDayPeriodPatterns = {
        any: /^dopoledne|dop\.?|odpoledne|odp\.?|půlnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^dop/i,
          pm: /^odp/i,
          midnight: /^p[ůu]lnoc/i,
          noon: /^poledne/i,
          morning: /r[áa]no/i,
          afternoon: /odpoledne/i,
          evening: /ve[čc]er/i,
          night: /noc/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "llai na eiliad",
          other: "llai na {{count}} eiliad"
        },
        xSeconds: {
          one: "1 eiliad",
          other: "{{count}} eiliad"
        },
        halfAMinute: "hanner munud",
        lessThanXMinutes: {
          one: "llai na munud",
          two: "llai na 2 funud",
          other: "llai na {{count}} munud"
        },
        xMinutes: {
          one: "1 munud",
          two: "2 funud",
          other: "{{count}} munud"
        },
        aboutXHours: {
          one: "tua 1 awr",
          other: "tua {{count}} awr"
        },
        xHours: {
          one: "1 awr",
          other: "{{count}} awr"
        },
        xDays: {
          one: "1 diwrnod",
          two: "2 ddiwrnod",
          other: "{{count}} diwrnod"
        },
        aboutXWeeks: {
          one: "tua 1 wythnos",
          two: "tua pythefnos",
          other: "tua {{count}} wythnos"
        },
        xWeeks: {
          one: "1 wythnos",
          two: "pythefnos",
          other: "{{count}} wythnos"
        },
        aboutXMonths: {
          one: "tua 1 mis",
          two: "tua 2 fis",
          other: "tua {{count}} mis"
        },
        xMonths: {
          one: "1 mis",
          two: "2 fis",
          other: "{{count}} mis"
        },
        aboutXYears: {
          one: "tua 1 flwyddyn",
          two: "tua 2 flynedd",
          other: "tua {{count}} mlynedd"
        },
        xYears: {
          one: "1 flwyddyn",
          two: "2 flynedd",
          other: "{{count}} mlynedd"
        },
        overXYears: {
          one: "dros 1 flwyddyn",
          two: "dros 2 flynedd",
          other: "dros {{count}} mlynedd"
        },
        almostXYears: {
          one: "bron 1 flwyddyn",
          two: "bron 2 flynedd",
          other: "bron {{count}} mlynedd"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2 && !!formatDistanceLocale[token].two) {
          result = formatDistanceLocale[token].two;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "mewn " + result;
          } else {
            return result + " yn \xF4l";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM yyyy",
        long: "d MMMM yyyy",
        medium: "d MMM yyyy",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} 'am' {{time}}",
        long: "{{date}} 'am' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'diwethaf am' p",
        yesterday: "'ddoe am' p",
        today: "'heddiw am' p",
        tomorrow: "'yfory am' p",
        nextWeek: "eeee 'am' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["C", "O"],
        abbreviated: ["CC", "OC"],
        wide: ["Cyn Crist", "Ar \xF4l Crist"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Ch1", "Ch2", "Ch3", "Ch4"],
        wide: ["Chwarter 1af", "2ail chwarter", "3ydd chwarter", "4ydd chwarter"]
      }; // Note: in English, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["I", "Ch", "Ma", "E", "Mi", "Me", "G", "A", "Md", "H", "T", "Rh"],
        abbreviated: ["Ion", "Chwe", "Maw", "Ebr", "Mai", "Meh", "Gor", "Aws", "Med", "Hyd", "Tach", "Rhag"],
        wide: ["Ionawr", "Chwefror", "Mawrth", "Ebrill", "Mai", "Mehefin", "Gorffennaf", "Awst", "Medi", "Hydref", "Tachwedd", "Rhagfyr"]
      };
      var dayValues = {
        narrow: ["S", "Ll", "M", "M", "I", "G", "S"],
        short: ["Su", "Ll", "Ma", "Me", "Ia", "Gw", "Sa"],
        abbreviated: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
        wide: ["dydd Sul", "dydd Llun", "dydd Mawrth", "dydd Mercher", "dydd Iau", "dydd Gwener", "dydd Sadwrn"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "b",
          pm: "h",
          midnight: "hn",
          noon: "hd",
          morning: "bore",
          afternoon: "prynhawn",
          evening: "gyda'r nos",
          night: "nos"
        },
        abbreviated: {
          am: "yb",
          pm: "yh",
          midnight: "hanner nos",
          noon: "hanner dydd",
          morning: "bore",
          afternoon: "prynhawn",
          evening: "gyda'r nos",
          night: "nos"
        },
        wide: {
          am: "y.b.",
          pm: "y.h.",
          midnight: "hanner nos",
          noon: "hanner dydd",
          morning: "bore",
          afternoon: "prynhawn",
          evening: "gyda'r nos",
          night: "nos"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "b",
          pm: "h",
          midnight: "hn",
          noon: "hd",
          morning: "yn y bore",
          afternoon: "yn y prynhawn",
          evening: "gyda'r nos",
          night: "yn y nos"
        },
        abbreviated: {
          am: "yb",
          pm: "yh",
          midnight: "hanner nos",
          noon: "hanner dydd",
          morning: "yn y bore",
          afternoon: "yn y prynhawn",
          evening: "gyda'r nos",
          night: "yn y nos"
        },
        wide: {
          am: "y.b.",
          pm: "y.h.",
          midnight: "hanner nos",
          noon: "hanner dydd",
          morning: "yn y bore",
          afternoon: "yn y prynhawn",
          evening: "gyda'r nos",
          night: "yn y nos"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);

        if (number < 20) {
          switch (number) {
            case 0:
              return number + "fed";

            case 1:
              return number + "af";

            case 2:
              return number + "ail";

            case 3:
            case 4:
              return number + "ydd";

            case 5:
            case 6:
              return number + "ed";

            case 7:
            case 8:
            case 9:
            case 10:
            case 12:
            case 15:
            case 18:
              return number + "fed";

            case 11:
            case 13:
            case 14:
            case 16:
            case 17:
            case 19:
              return number + "eg";
          }
        } else if (number >= 50 && number <= 60 || number === 80 || number >= 100) {
          return number + "fed";
        }

        return number + "ain";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(c|o)/i,
        abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
        wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
      };
      var parseEraPatterns = {
        wide: [/^c/i, /^(ar ôl crist|ar ol crist)/i],
        any: [/^c/i, /^o/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ch[1234]/i,
        wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
        abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
        wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
      };
      var parseMonthPatterns = {
        narrow: [/^i/i, /^ch/i, /^m/i, /^e/i, /^m/i, /^m/i, /^g/i, /^a/i, /^m/i, /^h/i, /^t/i, /^rh/i],
        any: [/^io/i, /^ch/i, /^maw/i, /^e/i, /^mai/i, /^meh/i, /^g/i, /^a/i, /^med/i, /^h/i, /^t/i, /^rh/i]
      };
      var matchDayPatterns = {
        narrow: /^(s|ll|m|i|g)/i,
        short: /^(su|ll|ma|me|ia|gw|sa)/i,
        abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
        wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^ll/i, /^m/i, /^m/i, /^i/i, /^g/i, /^s/i],
        wide: [/^dydd su/i, /^dydd ll/i, /^dydd ma/i, /^dydd me/i, /^dydd i/i, /^dydd g/i, /^dydd sa/i],
        any: [/^su/i, /^ll/i, /^ma/i, /^me/i, /^i/i, /^g/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
        any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^b|(y\.?\s?b\.?)/i,
          pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
          midnight: /^hn|hanner nos/i,
          noon: /^hd|hanner dydd/i,
          morning: /bore/i,
          afternoon: /prynhawn/i,
          evening: /^gyda'r nos$/i,
          night: /blah/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "mindre end \xE9t sekund",
          other: "mindre end {{count}} sekunder"
        },
        xSeconds: {
          one: "1 sekund",
          other: "{{count}} sekunder"
        },
        halfAMinute: "\xE9t halvt minut",
        lessThanXMinutes: {
          one: "mindre end \xE9t minut",
          other: "mindre end {{count}} minutter"
        },
        xMinutes: {
          one: "1 minut",
          other: "{{count}} minutter"
        },
        aboutXHours: {
          one: "cirka 1 time",
          other: "cirka {{count}} timer"
        },
        xHours: {
          one: "1 time",
          other: "{{count}} timer"
        },
        xDays: {
          one: "1 dag",
          other: "{{count}} dage"
        },
        aboutXWeeks: {
          one: "cirka 1 uge",
          other: "cirka {{count}} uger"
        },
        xWeeks: {
          one: "1 uge",
          other: "{{count}} uger"
        },
        aboutXMonths: {
          one: "cirka 1 m\xE5ned",
          other: "cirka {{count}} m\xE5neder"
        },
        xMonths: {
          one: "1 m\xE5ned",
          other: "{{count}} m\xE5neder"
        },
        aboutXYears: {
          one: "cirka 1 \xE5r",
          other: "cirka {{count}} \xE5r"
        },
        xYears: {
          one: "1 \xE5r",
          other: "{{count}} \xE5r"
        },
        overXYears: {
          one: "over 1 \xE5r",
          other: "over {{count}} \xE5r"
        },
        almostXYears: {
          one: "n\xE6sten 1 \xE5r",
          other: "n\xE6sten {{count}} \xE5r"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "om " + result;
          } else {
            return result + " siden";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE 'den' d. MMMM y",
        long: "d. MMMM y",
        medium: "d. MMM y",
        short: "dd/MM/y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'kl'. {{time}}",
        long: "{{date}} 'kl'. {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'sidste' eeee 'kl.' p",
        yesterday: "'i g\xE5r kl.' p",
        today: "'i dag kl.' p",
        tomorrow: "'i morgen kl.' p",
        nextWeek: "'p\xE5' eeee 'kl.' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["fvt", "vt"],
        abbreviated: ["f.v.t.", "v.t."],
        wide: ["f\xF8r vesterlandsk tidsregning", "vesterlandsk tidsregning"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
        wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
        wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
      }; // Note that 'Days - abbreviated - Formatting' has periods at the end.
      // https://www.unicode.org/cldr/charts/32/summary/da.html#1760
      // This makes grammatical sense in danish, as most abbreviations have periods.

      var dayValues = {
        narrow: ["S", "M", "T", "O", "T", "F", "L"],
        short: ["s\xF8", "ma", "ti", "on", "to", "fr", "l\xF8"],
        abbreviated: ["s\xF8n.", "man.", "tir.", "ons.", "tor.", "fre.", "l\xF8r."],
        wide: ["s\xF8ndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "l\xF8rdag"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "midnat",
          noon: "middag",
          morning: "morgen",
          afternoon: "eftermiddag",
          evening: "aften",
          night: "nat"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnat",
          noon: "middag",
          morning: "morgen",
          afternoon: "eftermiddag",
          evening: "aften",
          night: "nat"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnat",
          noon: "middag",
          morning: "morgen",
          afternoon: "eftermiddag",
          evening: "aften",
          night: "nat"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "midnat",
          noon: "middag",
          morning: "om morgenen",
          afternoon: "om eftermiddagen",
          evening: "om aftenen",
          night: "om natten"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnat",
          noon: "middag",
          morning: "om morgenen",
          afternoon: "om eftermiddagen",
          evening: "om aftenen",
          night: "om natten"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnat",
          noon: "middag",
          morning: "om morgenen",
          afternoon: "om eftermiddagen",
          evening: "om aftenen",
          night: "om natten"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + ".";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(fKr|fvt|eKr|vt)/i,
        abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
        wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
      };
      var parseEraPatterns = {
        any: [/^f/i, /^(v|e)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]. kvt\./i,
        wide: /^[1234]\.? kvartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
        wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtofl]/i,
        short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
        abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
        wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
        any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
        any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /midnat/i,
          noon: /middag/i,
          morning: /morgen/i,
          afternoon: /eftermiddag/i,
          evening: /aften/i,
          night: /nat/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["v.Chr.", "n.Chr."],
        abbreviated: ["v.Chr.", "n.Chr."],
        wide: ["vor Christus", "nach Christus"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
      }; // Note: in German, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["J\xE4n", "Feb", "M\xE4r", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
        wide: ["J\xE4nner", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
      }; // https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/

      var formattingMonthValues = {
        narrow: monthValues.narrow,
        abbreviated: ["J\xE4n.", "Feb.", "M\xE4rz", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
        wide: monthValues.wide
      };
      var dayValues = {
        narrow: ["S", "M", "D", "M", "D", "F", "S"],
        short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
        wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
      }; // https://www.unicode.org/cldr/charts/32/summary/de.html#1881

      var dayPeriodValues = {
        narrow: {
          am: "vm.",
          pm: "nm.",
          midnight: "Mitternacht",
          noon: "Mittag",
          morning: "Morgen",
          afternoon: "Nachm.",
          evening: "Abend",
          night: "Nacht"
        },
        abbreviated: {
          am: "vorm.",
          pm: "nachm.",
          midnight: "Mitternacht",
          noon: "Mittag",
          morning: "Morgen",
          afternoon: "Nachmittag",
          evening: "Abend",
          night: "Nacht"
        },
        wide: {
          am: "vormittags",
          pm: "nachmittags",
          midnight: "Mitternacht",
          noon: "Mittag",
          morning: "Morgen",
          afternoon: "Nachmittag",
          evening: "Abend",
          night: "Nacht"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "vm.",
          pm: "nm.",
          midnight: "Mitternacht",
          noon: "Mittag",
          morning: "morgens",
          afternoon: "nachm.",
          evening: "abends",
          night: "nachts"
        },
        abbreviated: {
          am: "vorm.",
          pm: "nachm.",
          midnight: "Mitternacht",
          noon: "Mittag",
          morning: "morgens",
          afternoon: "nachmittags",
          evening: "abends",
          night: "nachts"
        },
        wide: {
          am: "vormittags",
          pm: "nachmittags",
          midnight: "Mitternacht",
          noon: "Mittag",
          morning: "morgens",
          afternoon: "nachmittags",
          evening: "abends",
          night: "nachts"
        }
      };

      var ordinalNumber = function (dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + ".";
      };

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return quarter - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          formattingValues: formattingMonthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["v.Chr.", "n.Chr."],
        abbreviated: ["v.Chr.", "n.Chr."],
        wide: ["vor Christus", "nach Christus"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
      }; // Note: in German, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["Jan", "Feb", "M\xE4r", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
        wide: ["Januar", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
      }; // https://st.unicode.org/cldr-apps/v#/de/Gregorian/

      var formattingMonthValues = {
        narrow: monthValues.narrow,
        abbreviated: ["Jan.", "Feb.", "M\xE4rz", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
        wide: monthValues.wide
      };
      var dayValues = {
        narrow: ["S", "M", "D", "M", "D", "F", "S"],
        short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
        wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
      }; // https://www.unicode.org/cldr/charts/32/summary/de.html#1881

      var dayPeriodValues = {
        narrow: {
          am: "vm.",
          pm: "nm.",
          midnight: "Mitternacht",
          noon: "Mittag",
          morning: "Morgen",
          afternoon: "Nachm.",
          evening: "Abend",
          night: "Nacht"
        },
        abbreviated: {
          am: "vorm.",
          pm: "nachm.",
          midnight: "Mitternacht",
          noon: "Mittag",
          morning: "Morgen",
          afternoon: "Nachmittag",
          evening: "Abend",
          night: "Nacht"
        },
        wide: {
          am: "vormittags",
          pm: "nachmittags",
          midnight: "Mitternacht",
          noon: "Mittag",
          morning: "Morgen",
          afternoon: "Nachmittag",
          evening: "Abend",
          night: "Nacht"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "vm.",
          pm: "nm.",
          midnight: "Mitternacht",
          noon: "Mittag",
          morning: "morgens",
          afternoon: "nachm.",
          evening: "abends",
          night: "nachts"
        },
        abbreviated: {
          am: "vorm.",
          pm: "nachm.",
          midnight: "Mitternacht",
          noon: "Mittag",
          morning: "morgens",
          afternoon: "nachmittags",
          evening: "abends",
          night: "nachts"
        },
        wide: {
          am: "vormittags",
          pm: "nachmittags",
          midnight: "Mitternacht",
          noon: "Mittag",
          morning: "morgens",
          afternoon: "nachmittags",
          evening: "abends",
          night: "nachts"
        }
      };

      var ordinalNumber = function (dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + ".";
      };

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return quarter - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          formattingValues: formattingMonthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
          other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
        },
        xSeconds: {
          one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
          other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
        },
        halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
        lessThanXMinutes: {
          one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
          other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
        },
        xMinutes: {
          one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
          other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
        },
        aboutXHours: {
          one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
          other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
        },
        xHours: {
          one: "1 \u03CE\u03C1\u03B1",
          other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
        },
        xDays: {
          one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
          other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
        },
        aboutXWeeks: {
          one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
          other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
        },
        xWeeks: {
          one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
          other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
        },
        aboutXMonths: {
          one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
          other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
        },
        xMonths: {
          one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
          other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
        },
        aboutXYears: {
          one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
          other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
        },
        xYears: {
          one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
          other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
        },
        overXYears: {
          one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
          other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
        },
        almostXYears: {
          one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
          other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "\u03C3\u03B5 " + result;
          } else {
            return result + " \u03C0\u03C1\u03B9\u03BD";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM y",
        long: "d MMMM y",
        medium: "d MMM y",
        short: "d/M/yy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} - {{time}}",
        long: "{{date}} - {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function (date) {
          switch (date.getUTCDay()) {
            case 6:
              //Σάββατο
              return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";

            default:
              return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
          }
        },
        yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
        today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
        tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
        nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];
        if (typeof format === "function") return format(date, baseDate, options);
        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u03C0\u03A7", "\u03BC\u03A7"],
        abbreviated: ["\u03C0.\u03A7.", "\u03BC.\u03A7."],
        wide: ["\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD", "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["\u03A41", "\u03A42", "\u03A43", "\u03A44"],
        wide: ["1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"]
      };
      var monthValues = {
        narrow: ["\u0399", "\u03A6", "\u039C", "\u0391", "\u039C", "\u0399", "\u0399", "\u0391", "\u03A3", "\u039F", "\u039D", "\u0394"],
        abbreviated: ["\u0399\u03B1\u03BD", "\u03A6\u03B5\u03B2", "\u039C\u03AC\u03C1", "\u0391\u03C0\u03C1", "\u039C\u03AC\u03B9", "\u0399\u03BF\u03CD\u03BD", "\u0399\u03BF\u03CD\u03BB", "\u0391\u03CD\u03B3", "\u03A3\u03B5\u03C0", "\u039F\u03BA\u03C4", "\u039D\u03BF\u03AD", "\u0394\u03B5\u03BA"],
        wide: ["\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2", "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2", "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2", "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2", "\u039C\u03AC\u03B9\u03BF\u03C2", "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2", "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2", "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2", "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2", "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2", "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2", "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"]
      };
      var formattingMonthValues = {
        narrow: ["\u0399", "\u03A6", "\u039C", "\u0391", "\u039C", "\u0399", "\u0399", "\u0391", "\u03A3", "\u039F", "\u039D", "\u0394"],
        abbreviated: ["\u0399\u03B1\u03BD", "\u03A6\u03B5\u03B2", "\u039C\u03B1\u03C1", "\u0391\u03C0\u03C1", "\u039C\u03B1\u0390", "\u0399\u03BF\u03C5\u03BD", "\u0399\u03BF\u03C5\u03BB", "\u0391\u03C5\u03B3", "\u03A3\u03B5\u03C0", "\u039F\u03BA\u03C4", "\u039D\u03BF\u03B5", "\u0394\u03B5\u03BA"],
        wide: ["\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5", "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5", "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5", "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5", "\u039C\u03B1\u0390\u03BF\u03C5", "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5", "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5", "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5", "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5", "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5", "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5", "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"]
      };
      var dayValues = {
        narrow: ["\u039A", "\u0394", "T", "\u03A4", "\u03A0", "\u03A0", "\u03A3"],
        short: ["\u039A\u03C5", "\u0394\u03B5", "\u03A4\u03C1", "\u03A4\u03B5", "\u03A0\u03AD", "\u03A0\u03B1", "\u03A3\u03AC"],
        abbreviated: ["\u039A\u03C5\u03C1", "\u0394\u03B5\u03C5", "\u03A4\u03C1\u03AF", "\u03A4\u03B5\u03C4", "\u03A0\u03AD\u03BC", "\u03A0\u03B1\u03C1", "\u03A3\u03AC\u03B2"],
        wide: ["\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE", "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1", "\u03A4\u03C1\u03AF\u03C4\u03B7", "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7", "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7", "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE", "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u03C0\u03BC",
          pm: "\u03BC\u03BC",
          midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
          noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
          morning: "\u03C0\u03C1\u03C9\u03AF",
          afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
          evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
          night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
        },
        abbreviated: {
          am: "\u03C0.\u03BC.",
          pm: "\u03BC.\u03BC.",
          midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
          noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
          morning: "\u03C0\u03C1\u03C9\u03AF",
          afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
          evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
          night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
        },
        wide: {
          am: "\u03C0.\u03BC.",
          pm: "\u03BC.\u03BC.",
          midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
          noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
          morning: "\u03C0\u03C1\u03C9\u03AF",
          afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
          evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
          night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var suffix;

        if (unit === "year" || unit === "month") {
          suffix = "\u03BF\u03C2";
        } else if (unit === "week" || unit === "dayOfYear" || unit === "day" || unit === "hour" || unit === "date") {
          suffix = "\u03B7";
        } else {
          suffix = "\u03BF";
        }

        return dirtyNumber + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(πΧ|μΧ)/i,
        abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
        wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
      };
      var parseEraPatterns = {
        any: [/^π/i, /^(μ|κ)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^τ[1234]/i,
        wide: /^[1234]ο? τρ(ί|ι)μηνο/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[ιφμαμιιασονδ]/i,
        abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
        wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ι/i, /^φ/i, /^μ/i, /^α/i, /^μ/i, /^ι/i, /^ι/i, /^α/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i],
        any: [/^ια/i, /^φ/i, /^μ[άα]ρ/i, /^απ/i, /^μ[άα][ιΐ]/i, /^ιο[ύυ]ν/i, /^ιο[ύυ]λ/i, /^α[ύυ]/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i]
      };
      var matchDayPatterns = {
        narrow: /^[κδτπσ]/i,
        short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
        abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
        wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
      };
      var parseDayPatterns = {
        narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
        any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
        any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^πμ|π\.\s?μ\./i,
          pm: /^μμ|μ\.\s?μ\./i,
          midnight: /^μεσάν/i,
          noon: /^μεσημ(έ|ε)/i,
          morning: /πρω(ί|ι)/i,
          afternoon: /απ(ό|ο)γευμα/i,
          evening: /βρ(ά|α)δυ/i,
          night: /ν(ύ|υ)χτα/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM yyyy",
        long: "d MMMM yyyy",
        medium: "d MMM yyyy",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "less than a second",
          other: "less than {{count}} seconds"
        },
        xSeconds: {
          one: "a second",
          other: "{{count}} seconds"
        },
        halfAMinute: "half a minute",
        lessThanXMinutes: {
          one: "less than a minute",
          other: "less than {{count}} minutes"
        },
        xMinutes: {
          one: "a minute",
          other: "{{count}} minutes"
        },
        aboutXHours: {
          one: "about an hour",
          other: "about {{count}} hours"
        },
        xHours: {
          one: "an hour",
          other: "{{count}} hours"
        },
        xDays: {
          one: "a day",
          other: "{{count}} days"
        },
        aboutXWeeks: {
          one: "about a week",
          other: "about {{count}} weeks"
        },
        xWeeks: {
          one: "a week",
          other: "{{count}} weeks"
        },
        aboutXMonths: {
          one: "about a month",
          other: "about {{count}} months"
        },
        xMonths: {
          one: "a month",
          other: "{{count}} months"
        },
        aboutXYears: {
          one: "about a year",
          other: "about {{count}} years"
        },
        xYears: {
          one: "a year",
          other: "{{count}} years"
        },
        overXYears: {
          one: "over a year",
          other: "over {{count}} years"
        },
        almostXYears: {
          one: "almost a year",
          other: "almost {{count}} years"
        }
      };

      var formatDistance = function (token, count, options) {
        var result;
        var tokenValue = formatDistanceLocale[token];

        if (typeof tokenValue === "string") {
          result = tokenValue;
        } else if (count === 1) {
          result = tokenValue.one;
        } else {
          result = tokenValue.other.replace("{{count}}", count.toString());
        }

        if (options !== null && options !== void 0 && options.addSuffix) {
          if (options.comparison && options.comparison > 0) {
            return "in " + result;
          } else {
            return result + " ago";
          }
        }

        return result;
      };

      var _default = formatDistance;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, MMMM do, yyyy",
        long: "MMMM do, yyyy",
        medium: "MMM d, yyyy",
        short: "yyyy-MM-dd"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM yyyy",
        long: "d MMMM yyyy",
        medium: "d MMM yyyy",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM yyyy",
        long: "d MMMM, yyyy",
        medium: "d MMM, yyyy",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM yyyy",
        long: "d MMMM yyyy",
        medium: "d MMM yyyy",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, MMMM do, y",
        long: "MMMM do, y",
        medium: "MMM d, y",
        short: "MM/dd/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM yyyy",
        long: "d MMMM yyyy",
        medium: "d MMM yyyy",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "malpli ol sekundo",
          other: "malpli ol {{count}} sekundoj"
        },
        xSeconds: {
          one: "1 sekundo",
          other: "{{count}} sekundoj"
        },
        halfAMinute: "duonminuto",
        lessThanXMinutes: {
          one: "malpli ol minuto",
          other: "malpli ol {{count}} minutoj"
        },
        xMinutes: {
          one: "1 minuto",
          other: "{{count}} minutoj"
        },
        aboutXHours: {
          one: "proksimume 1 horo",
          other: "proksimume {{count}} horoj"
        },
        xHours: {
          one: "1 horo",
          other: "{{count}} horoj"
        },
        xDays: {
          one: "1 tago",
          other: "{{count}} tagoj"
        },
        aboutXMonths: {
          one: "proksimume 1 monato",
          other: "proksimume {{count}} monatoj"
        },
        xWeeks: {
          one: "1 semajno",
          other: "{{count}} semajnoj"
        },
        aboutXWeeks: {
          one: "proksimume 1 semajno",
          other: "proksimume {{count}} semajnoj"
        },
        xMonths: {
          one: "1 monato",
          other: "{{count}} monatoj"
        },
        aboutXYears: {
          one: "proksimume 1 jaro",
          other: "proksimume {{count}} jaroj"
        },
        xYears: {
          one: "1 jaro",
          other: "{{count}} jaroj"
        },
        overXYears: {
          one: "pli ol 1 jaro",
          other: "pli ol {{count}} jaroj"
        },
        almostXYears: {
          one: "preska\u016D 1 jaro",
          other: "preska\u016D {{count}} jaroj"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "post " + result;
          } else {
            return "anta\u016D " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, do 'de' MMMM y",
        long: "y-MMMM-dd",
        medium: "y-MMM-dd",
        short: "yyyy-MM-dd"
      };
      var timeFormats = {
        full: "Ho 'horo kaj' m:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        any: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "any"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'pasinta' eeee 'je' p",
        yesterday: "'hiera\u016D je' p",
        today: "'hodia\u016D je' p",
        tomorrow: "'morga\u016D je' p",
        nextWeek: "eeee 'je' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["aK", "pK"],
        abbreviated: ["a.K.E.", "p.K.E."],
        wide: ["anta\u016D Komuna Erao", "Komuna Erao"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["K1", "K2", "K3", "K4"],
        wide: ["1-a kvaronjaro", "2-a kvaronjaro", "3-a kvaronjaro", "4-a kvaronjaro"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "a\u016Dg", "sep", "okt", "nov", "dec"],
        wide: ["januaro", "februaro", "marto", "aprilo", "majo", "junio", "julio", "a\u016Dgusto", "septembro", "oktobro", "novembro", "decembro"]
      };
      var dayValues = {
        narrow: ["D", "L", "M", "M", "\u0134", "V", "S"],
        short: ["di", "lu", "ma", "me", "\u0135a", "ve", "sa"],
        abbreviated: ["dim", "lun", "mar", "mer", "\u0135a\u016D", "ven", "sab"],
        wide: ["diman\u0109o", "lundo", "mardo", "merkredo", "\u0135a\u016Ddo", "vendredo", "sabato"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "noktomezo",
          noon: "tagmezo",
          morning: "matene",
          afternoon: "posttagmeze",
          evening: "vespere",
          night: "nokte"
        },
        abbreviated: {
          am: "a.t.m.",
          pm: "p.t.m.",
          midnight: "noktomezo",
          noon: "tagmezo",
          morning: "matene",
          afternoon: "posttagmeze",
          evening: "vespere",
          night: "nokte"
        },
        wide: {
          am: "anta\u016Dtagmeze",
          pm: "posttagmeze",
          midnight: "noktomezo",
          noon: "tagmezo",
          morning: "matene",
          afternoon: "posttagmeze",
          evening: "vespere",
          night: "nokte"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + "-a";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^([ap]k)/i,
        abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
        wide: /^((antaǔ |post )?komuna erao)/i
      };
      var parseEraPatterns = {
        any: [/^a/i, /^[kp]/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^k[1234]/i,
        wide: /^[1234](-?a)? kvaronjaro/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
        wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^a(u|ŭ)/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[dlmĵjvs]/i,
        short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
        abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
        wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^(j|ĵ)/i, /^v/i, /^s/i],
        any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^(j|ĵ)/i, /^v/i, /^s/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
        abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
        wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^noktom/i,
          noon: /^t/i,
          morning: /^m/i,
          afternoon: /^posttagmeze/i,
          evening: /^v/i,
          night: /^n/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "menos de un segundo",
          other: "menos de {{count}} segundos"
        },
        xSeconds: {
          one: "1 segundo",
          other: "{{count}} segundos"
        },
        halfAMinute: "medio minuto",
        lessThanXMinutes: {
          one: "menos de un minuto",
          other: "menos de {{count}} minutos"
        },
        xMinutes: {
          one: "1 minuto",
          other: "{{count}} minutos"
        },
        aboutXHours: {
          one: "alrededor de 1 hora",
          other: "alrededor de {{count}} horas"
        },
        xHours: {
          one: "1 hora",
          other: "{{count}} horas"
        },
        xDays: {
          one: "1 d\xEDa",
          other: "{{count}} d\xEDas"
        },
        aboutXWeeks: {
          one: "alrededor de 1 semana",
          other: "alrededor de {{count}} semanas"
        },
        xWeeks: {
          one: "1 semana",
          other: "{{count}} semanas"
        },
        aboutXMonths: {
          one: "alrededor de 1 mes",
          other: "alrededor de {{count}} meses"
        },
        xMonths: {
          one: "1 mes",
          other: "{{count}} meses"
        },
        aboutXYears: {
          one: "alrededor de 1 a\xF1o",
          other: "alrededor de {{count}} a\xF1os"
        },
        xYears: {
          one: "1 a\xF1o",
          other: "{{count}} a\xF1os"
        },
        overXYears: {
          one: "m\xE1s de 1 a\xF1o",
          other: "m\xE1s de {{count}} a\xF1os"
        },
        almostXYears: {
          one: "casi 1 a\xF1o",
          other: "casi {{count}} a\xF1os"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "en " + result;
          } else {
            return "hace " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d 'de' MMMM 'de' y",
        long: "d 'de' MMMM 'de' y",
        medium: "d MMM y",
        short: "dd/MM/y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'a las' {{time}}",
        long: "{{date}} 'a las' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'el' eeee 'pasado a la' LT",
        yesterday: "'ayer a la' p",
        today: "'hoy a la' p",
        tomorrow: "'ma\xF1ana a la' p",
        nextWeek: "eeee 'a la' p",
        other: "P"
      };
      var formatRelativeLocalePlural = {
        lastWeek: "'el' eeee 'pasado a las' p",
        yesterday: "'ayer a las' p",
        today: "'hoy a las' p",
        tomorrow: "'ma\xF1ana a las' p",
        nextWeek: "eeee 'a las' p",
        other: "P"
      };

      function formatRelative(token, date, _baseDate, _options) {
        if (date.getUTCHours() !== 1) {
          return formatRelativeLocalePlural[token];
        }

        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["AC", "DC"],
        abbreviated: ["AC", "DC"],
        wide: ["antes de cristo", "despu\xE9s de cristo"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["T1", "T2", "T3", "T4"],
        wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
      };
      var monthValues = {
        narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
        abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
        wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
      };
      var dayValues = {
        narrow: ["d", "l", "m", "m", "j", "v", "s"],
        short: ["do", "lu", "ma", "mi", "ju", "vi", "sa"],
        abbreviated: ["dom", "lun", "mar", "mi\xE9", "jue", "vie", "s\xE1b"],
        wide: ["domingo", "lunes", "martes", "mi\xE9rcoles", "jueves", "viernes", "s\xE1bado"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mn",
          noon: "md",
          morning: "ma\xF1ana",
          afternoon: "tarde",
          evening: "tarde",
          night: "noche"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "medianoche",
          noon: "mediodia",
          morning: "ma\xF1ana",
          afternoon: "tarde",
          evening: "tarde",
          night: "noche"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "medianoche",
          noon: "mediodia",
          morning: "ma\xF1ana",
          afternoon: "tarde",
          evening: "tarde",
          night: "noche"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mn",
          noon: "md",
          morning: "de la ma\xF1ana",
          afternoon: "de la tarde",
          evening: "de la tarde",
          night: "de la noche"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "medianoche",
          noon: "mediodia",
          morning: "de la ma\xF1ana",
          afternoon: "de la tarde",
          evening: "de la tarde",
          night: "de la noche"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "medianoche",
          noon: "mediodia",
          morning: "de la ma\xF1ana",
          afternoon: "de la tarde",
          evening: "de la tarde",
          night: "de la noche"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + "\xBA";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ac|dc|a|d)/i,
        abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
        wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
      };
      var parseEraPatterns = {
        any: [/^ac/i, /^dc/i],
        wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^T[1234]/i,
        wide: /^[1234](º)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[efmajsond]/i,
        abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
        wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
      };
      var parseMonthPatterns = {
        narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
      };
      var matchDayPatterns = {
        narrow: /^[dlmjvs]/i,
        short: /^(do|lu|ma|mi|ju|vi|sa)/i,
        abbreviated: /^(dom|lun|mar|mie|jue|vie|sab)/i,
        wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
        any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
        any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mn/i,
          noon: /^md/i,
          morning: /mañana/i,
          afternoon: /tarde/i,
          evening: /tarde/i,
          night: /noche/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          standalone: {
            one: "v\xE4hem kui \xFCks sekund",
            other: "v\xE4hem kui {{count}} sekundit"
          },
          withPreposition: {
            one: "v\xE4hem kui \xFChe sekundi",
            other: "v\xE4hem kui {{count}} sekundi"
          }
        },
        xSeconds: {
          standalone: {
            one: "\xFCks sekund",
            other: "{{count}} sekundit"
          },
          withPreposition: {
            one: "\xFChe sekundi",
            other: "{{count}} sekundi"
          }
        },
        halfAMinute: {
          standalone: "pool minutit",
          withPreposition: "poole minuti"
        },
        lessThanXMinutes: {
          standalone: {
            one: "v\xE4hem kui \xFCks minut",
            other: "v\xE4hem kui {{count}} minutit"
          },
          withPreposition: {
            one: "v\xE4hem kui \xFChe minuti",
            other: "v\xE4hem kui {{count}} minuti"
          }
        },
        xMinutes: {
          standalone: {
            one: "\xFCks minut",
            other: "{{count}} minutit"
          },
          withPreposition: {
            one: "\xFChe minuti",
            other: "{{count}} minuti"
          }
        },
        aboutXHours: {
          standalone: {
            one: "umbes \xFCks tund",
            other: "umbes {{count}} tundi"
          },
          withPreposition: {
            one: "umbes \xFChe tunni",
            other: "umbes {{count}} tunni"
          }
        },
        xHours: {
          standalone: {
            one: "\xFCks tund",
            other: "{{count}} tundi"
          },
          withPreposition: {
            one: "\xFChe tunni",
            other: "{{count}} tunni"
          }
        },
        xDays: {
          standalone: {
            one: "\xFCks p\xE4ev",
            other: "{{count}} p\xE4eva"
          },
          withPreposition: {
            one: "\xFChe p\xE4eva",
            other: "{{count}} p\xE4eva"
          }
        },
        aboutXWeeks: {
          standalone: {
            one: "umbes \xFCks n\xE4dal",
            other: "umbes {{count}} n\xE4dalat"
          },
          withPreposition: {
            one: "umbes \xFChe n\xE4dala",
            other: "umbes {{count}} n\xE4dala"
          }
        },
        xWeeks: {
          standalone: {
            one: "\xFCks n\xE4dal",
            other: "{{count}} n\xE4dalat"
          },
          withPreposition: {
            one: "\xFChe n\xE4dala",
            other: "{{count}} n\xE4dala"
          }
        },
        aboutXMonths: {
          standalone: {
            one: "umbes \xFCks kuu",
            other: "umbes {{count}} kuud"
          },
          withPreposition: {
            one: "umbes \xFChe kuu",
            other: "umbes {{count}} kuu"
          }
        },
        xMonths: {
          standalone: {
            one: "\xFCks kuu",
            other: "{{count}} kuud"
          },
          withPreposition: {
            one: "\xFChe kuu",
            other: "{{count}} kuu"
          }
        },
        aboutXYears: {
          standalone: {
            one: "umbes \xFCks aasta",
            other: "umbes {{count}} aastat"
          },
          withPreposition: {
            one: "umbes \xFChe aasta",
            other: "umbes {{count}} aasta"
          }
        },
        xYears: {
          standalone: {
            one: "\xFCks aasta",
            other: "{{count}} aastat"
          },
          withPreposition: {
            one: "\xFChe aasta",
            other: "{{count}} aasta"
          }
        },
        overXYears: {
          standalone: {
            one: "rohkem kui \xFCks aasta",
            other: "rohkem kui {{count}} aastat"
          },
          withPreposition: {
            one: "rohkem kui \xFChe aasta",
            other: "rohkem kui {{count}} aasta"
          }
        },
        almostXYears: {
          standalone: {
            one: "peaaegu \xFCks aasta",
            other: "peaaegu {{count}} aastat"
          },
          withPreposition: {
            one: "peaaegu \xFChe aasta",
            other: "peaaegu {{count}} aasta"
          }
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var usageGroup = options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
        var result;

        if (typeof usageGroup === "string") {
          result = usageGroup;
        } else if (count === 1) {
          result = usageGroup.one;
        } else {
          result = usageGroup.other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + " p\xE4rast";
          } else {
            return result + " eest";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "eeee, d. MMMM y",
        long: "d. MMMM y",
        medium: "d. MMM y",
        short: "dd.MM.y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'kell' {{time}}",
        long: "{{date}} 'kell' {{time}}",
        medium: "{{date}}. {{time}}",
        short: "{{date}}. {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'eelmine' eeee 'kell' p",
        yesterday: "'eile kell' p",
        today: "'t\xE4na kell' p",
        tomorrow: "'homme kell' p",
        nextWeek: "'j\xE4rgmine' eeee 'kell' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["e.m.a", "m.a.j"],
        abbreviated: ["e.m.a", "m.a.j"],
        wide: ["enne meie ajaarvamist", "meie ajaarvamise j\xE4rgi"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["K1", "K2", "K3", "K4"],
        wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
      };
      var monthValues = {
        narrow: ["J", "V", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["jaan", "veebr", "m\xE4rts", "apr", "mai", "juuni", "juuli", "aug", "sept", "okt", "nov", "dets"],
        wide: ["jaanuar", "veebruar", "m\xE4rts", "aprill", "mai", "juuni", "juuli", "august", "september", "oktoober", "november", "detsember"]
      };
      var dayValues = {
        narrow: ["P", "E", "T", "K", "N", "R", "L"],
        short: ["P", "E", "T", "K", "N", "R", "L"],
        abbreviated: ["p\xFChap.", "esmasp.", "teisip.", "kolmap.", "neljap.", "reede.", "laup."],
        wide: ["p\xFChap\xE4ev", "esmasp\xE4ev", "teisip\xE4ev", "kolmap\xE4ev", "neljap\xE4ev", "reede", "laup\xE4ev"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "kesk\xF6\xF6",
          noon: "keskp\xE4ev",
          morning: "hommik",
          afternoon: "p\xE4rastl\xF5una",
          evening: "\xF5htu",
          night: "\xF6\xF6"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "kesk\xF6\xF6",
          noon: "keskp\xE4ev",
          morning: "hommik",
          afternoon: "p\xE4rastl\xF5una",
          evening: "\xF5htu",
          night: "\xF6\xF6"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "kesk\xF6\xF6",
          noon: "keskp\xE4ev",
          morning: "hommik",
          afternoon: "p\xE4rastl\xF5una",
          evening: "\xF5htu",
          night: "\xF6\xF6"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "kesk\xF6\xF6l",
          noon: "keskp\xE4eval",
          morning: "hommikul",
          afternoon: "p\xE4rastl\xF5unal",
          evening: "\xF5htul",
          night: "\xF6\xF6sel"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "kesk\xF6\xF6l",
          noon: "keskp\xE4eval",
          morning: "hommikul",
          afternoon: "p\xE4rastl\xF5unal",
          evening: "\xF5htul",
          night: "\xF6\xF6sel"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "kesk\xF6\xF6l",
          noon: "keskp\xE4eval",
          morning: "hommikul",
          afternoon: "p\xE4rastl\xF5unal",
          evening: "\xF5htul",
          night: "\xF6\xF6sel"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + ".";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          formattingValues: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          formattingValues: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          formattingValues: formattingDayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^\d+\./i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
        abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
        wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
      };
      var parseEraPatterns = {
        any: [/^e/i, /^(m|p)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^K[1234]/i,
        wide: /^[1234](\.)? kvartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jvmasond]/i,
        abbreviated: /^('jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets')/i,
        wide: /^('jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember')/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^v/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^v/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[petknrl]/i,
        short: /^[petknrl]/i,
        abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
        wide: /^('pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev')/i
      };
      var parseDayPatterns = {
        any: [/^p/i, /^e/i, /^t/i, /^k/i, /^n/i, /^r/i, /^l/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(am|pm|kesköö|keskpäev|hommik|pärastlõuna|õhtu|öö)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^keskö/i,
          noon: /^keskp/i,
          morning: /hommik/i,
          afternoon: /pärastlõuna/i,
          evening: /õhtu/i,
          night: /öö/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "segundo bat baino gutxiago",
          other: "{{count}} segundo baino gutxiago"
        },
        xSeconds: {
          one: "1 segundo",
          other: "{{count}} segundo"
        },
        halfAMinute: "minutu erdi",
        lessThanXMinutes: {
          one: "minutu bat baino gutxiago",
          other: "{{count}} minutu baino gutxiago"
        },
        xMinutes: {
          one: "1 minutu",
          other: "{{count}} minutu"
        },
        aboutXHours: {
          one: "1 ordu gutxi gorabehera",
          other: "{{count}} ordu gutxi gorabehera"
        },
        xHours: {
          one: "1 ordu",
          other: "{{count}} ordu"
        },
        xDays: {
          one: "1 egun",
          other: "{{count}} egun"
        },
        aboutXWeeks: {
          one: "aste 1 inguru",
          other: "{{count}} aste inguru"
        },
        xWeeks: {
          one: "1 aste",
          other: "{{count}} astean"
        },
        aboutXMonths: {
          one: "1 hilabete gutxi gorabehera",
          other: "{{count}} hilabete gutxi gorabehera"
        },
        xMonths: {
          one: "1 hilabete",
          other: "{{count}} hilabete"
        },
        aboutXYears: {
          one: "1 urte gutxi gorabehera",
          other: "{{count}} urte gutxi gorabehera"
        },
        xYears: {
          one: "1 urte",
          other: "{{count}} urte"
        },
        overXYears: {
          one: "1 urte baino gehiago",
          other: "{{count}} urte baino gehiago"
        },
        almostXYears: {
          one: "ia 1 urte",
          other: "ia {{count}} urte"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "en " + result;
          } else {
            return "duela " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
        long: "y'ko' MMMM'ren' d'a'",
        medium: "y MMM d",
        short: "yy/MM/dd"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'tan' {{time}}",
        long: "{{date}} 'tan' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'joan den' eeee, LT",
        yesterday: "'atzo,' p",
        today: "'gaur,' p",
        tomorrow: "'bihar,' p",
        nextWeek: "eeee, p",
        other: "P"
      };
      var formatRelativeLocalePlural = {
        lastWeek: "'joan den' eeee, p",
        yesterday: "'atzo,' p",
        today: "'gaur,' p",
        tomorrow: "'bihar,' p",
        nextWeek: "eeee, p",
        other: "P"
      };

      function formatRelative(token, date, _baseDate, _options) {
        if (date.getUTCHours() !== 1) {
          return formatRelativeLocalePlural[token];
        }

        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["k.a.", "k.o."],
        abbreviated: ["k.a.", "k.o."],
        wide: ["kristo aurretik", "kristo ondoren"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1H", "2H", "3H", "4H"],
        wide: ["1. hiruhilekoa", "2. hiruhilekoa", "3. hiruhilekoa", "4. hiruhilekoa"]
      };
      var monthValues = {
        narrow: ["u", "o", "m", "a", "m", "e", "u", "a", "i", "u", "a", "a"],
        abbreviated: ["urt", "ots", "mar", "api", "mai", "eka", "uzt", "abu", "ira", "urr", "aza", "abe"],
        wide: ["urtarrila", "otsaila", "martxoa", "apirila", "maiatza", "ekaina", "uztaila", "abuztua", "iraila", "urria", "azaroa", "abendua"]
      };
      var dayValues = {
        narrow: ["i", "a", "a", "a", "o", "o", "l"],
        short: ["ig", "al", "as", "az", "og", "or", "lr"],
        abbreviated: ["iga", "ast", "ast", "ast", "ost", "ost", "lar"],
        wide: ["igandea", "astelehena", "asteartea", "asteazkena", "osteguna", "ostirala", "larunbata"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "ge",
          noon: "eg",
          morning: "goiza",
          afternoon: "arratsaldea",
          evening: "arratsaldea",
          night: "gaua"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "gauerdia",
          noon: "eguerdia",
          morning: "goiza",
          afternoon: "arratsaldea",
          evening: "arratsaldea",
          night: "gaua"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "gauerdia",
          noon: "eguerdia",
          morning: "goiza",
          afternoon: "arratsaldea",
          evening: "arratsaldea",
          night: "gaua"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "ge",
          noon: "eg",
          morning: "goizean",
          afternoon: "arratsaldean",
          evening: "arratsaldean",
          night: "gauean"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "gauerdia",
          noon: "eguerdia",
          morning: "goizean",
          afternoon: "arratsaldean",
          evening: "arratsaldean",
          night: "gauean"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "gauerdia",
          noon: "eguerdia",
          morning: "goizean",
          afternoon: "arratsaldean",
          evening: "arratsaldean",
          night: "gauean"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + ".";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(.)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(k.a.|k.o.)/i,
        abbreviated: /^(k.a.|k.o.)/i,
        wide: /^(kristo aurretik|kristo ondoren)/i
      };
      var parseEraPatterns = {
        narrow: [/^k.a./i, /^k.o./i],
        abbreviated: [/^(k.a.)/i, /^(k.o.)/i],
        wide: [/^(kristo aurretik)/i, /^(kristo ondoren)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]H/i,
        wide: /^[1234](.)? hiruhilekoa/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[uomaei]/i,
        abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
        wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
      };
      var parseMonthPatterns = {
        narrow: [/^u/i, /^o/i, /^m/i, /^a/i, /^m/i, /^e/i, /^u/i, /^a/i, /^i/i, /^u/i, /^a/i, /^a/i],
        any: [/^urt/i, /^ots/i, /^mar/i, /^api/i, /^mai/i, /^eka/i, /^uzt/i, /^abu/i, /^ira/i, /^urr/i, /^aza/i, /^abe/i]
      };
      var matchDayPatterns = {
        narrow: /^[iaol]/i,
        short: /^(ig|al|as|az|og|or|lr)/i,
        abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
        wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
      };
      var parseDayPatterns = {
        narrow: [/^i/i, /^a/i, /^a/i, /^a/i, /^o/i, /^o/i, /^l/i],
        short: [/^ig/i, /^al/i, /^as/i, /^az/i, /^og/i, /^or/i, /^lr/i],
        abbreviated: [/^iga/i, /^ast/i, /^ast/i, /^ast/i, /^ost/i, /^ost/i, /^lar/i],
        wide: [/^igandea/i, /^astelehena/i, /^asteartea/i, /^asteazkena/i, /^osteguna/i, /^ostirala/i, /^larunbata/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
        any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
      };
      var parseDayPeriodPatterns = {
        narrow: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^ge/i,
          noon: /^eg/i,
          morning: /goiz/i,
          afternoon: /arratsaldea/i,
          evening: /arratsaldea/i,
          night: /gau/i
        },
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^gauerdia/i,
          noon: /^eguerdia/i,
          morning: /goiz/i,
          afternoon: /arratsaldea/i,
          evening: /arratsaldea/i,
          night: /gau/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
          other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
        },
        xSeconds: {
          one: "1 \u062B\u0627\u0646\u06CC\u0647",
          other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
        },
        halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
        lessThanXMinutes: {
          one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
          other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
        },
        xMinutes: {
          one: "1 \u062F\u0642\u06CC\u0642\u0647",
          other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
        },
        aboutXHours: {
          one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
          other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
        },
        xHours: {
          one: "1 \u0633\u0627\u0639\u062A",
          other: "{{count}} \u0633\u0627\u0639\u062A"
        },
        xDays: {
          one: "1 \u0631\u0648\u0632",
          other: "{{count}} \u0631\u0648\u0632"
        },
        aboutXWeeks: {
          one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
          other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
        },
        xWeeks: {
          one: "1 \u0647\u0641\u062A\u0647",
          other: "{{count}} \u0647\u0641\u062A\u0647"
        },
        aboutXMonths: {
          one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
          other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
        },
        xMonths: {
          one: "1 \u0645\u0627\u0647",
          other: "{{count}} \u0645\u0627\u0647"
        },
        aboutXYears: {
          one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
          other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
        },
        xYears: {
          one: "1 \u0633\u0627\u0644",
          other: "{{count}} \u0633\u0627\u0644"
        },
        overXYears: {
          one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
          other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
        },
        almostXYears: {
          one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
          other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "\u062F\u0631 " + result;
          } else {
            return result + " \u0642\u0628\u0644";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE do MMMM y",
        long: "do MMMM y",
        medium: "d MMM y",
        short: "yyyy/MM/dd"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} '\u062F\u0631' {{time}}",
        long: "{{date}} '\u062F\u0631' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
        yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
        today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
        tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
        nextWeek: "eeee '\u062F\u0631' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u0642", "\u0628"],
        abbreviated: ["\u0642.\u0645.", "\u0628.\u0645."],
        wide: ["\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F", "\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["\u0633\u200C\u06451", "\u0633\u200C\u06452", "\u0633\u200C\u06453", "\u0633\u200C\u06454"],
        wide: ["\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1", "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2", "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3", "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"]
      }; // Note: in English, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["\u0698", "\u0641", "\u0645", "\u0622", "\u0645", "\u062C", "\u062C", "\u0622", "\u0633", "\u0627", "\u0646", "\u062F"],
        abbreviated: ["\u0698\u0627\u0646\u0640", "\u0641\u0648\u0631", "\u0645\u0627\u0631\u0633", "\u0622\u067E\u0631", "\u0645\u06CC", "\u062C\u0648\u0646", "\u062C\u0648\u0644\u0640", "\u0622\u06AF\u0648", "\u0633\u067E\u062A\u0640", "\u0627\u06A9\u062A\u0640", "\u0646\u0648\u0627\u0645\u0640", "\u062F\u0633\u0627\u0645\u0640"],
        wide: ["\u0698\u0627\u0646\u0648\u06CC\u0647", "\u0641\u0648\u0631\u06CC\u0647", "\u0645\u0627\u0631\u0633", "\u0622\u067E\u0631\u06CC\u0644", "\u0645\u06CC", "\u062C\u0648\u0646", "\u062C\u0648\u0644\u0627\u06CC", "\u0622\u06AF\u0648\u0633\u062A", "\u0633\u067E\u062A\u0627\u0645\u0628\u0631", "\u0627\u06A9\u062A\u0628\u0631", "\u0646\u0648\u0627\u0645\u0628\u0631", "\u062F\u0633\u0627\u0645\u0628\u0631"]
      };
      var dayValues = {
        narrow: ["\u06CC", "\u062F", "\u0633", "\u0686", "\u067E", "\u062C", "\u0634"],
        short: ["1\u0634", "2\u0634", "3\u0634", "4\u0634", "5\u0634", "\u062C", "\u0634"],
        abbreviated: ["\u06CC\u06A9\u0634\u0646\u0628\u0647", "\u062F\u0648\u0634\u0646\u0628\u0647", "\u0633\u0647\u200C\u0634\u0646\u0628\u0647", "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647", "\u067E\u0646\u062C\u0634\u0646\u0628\u0647", "\u062C\u0645\u0639\u0647", "\u0634\u0646\u0628\u0647"],
        wide: ["\u06CC\u06A9\u0634\u0646\u0628\u0647", "\u062F\u0648\u0634\u0646\u0628\u0647", "\u0633\u0647\u200C\u0634\u0646\u0628\u0647", "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647", "\u067E\u0646\u062C\u0634\u0646\u0628\u0647", "\u062C\u0645\u0639\u0647", "\u0634\u0646\u0628\u0647"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u0642",
          pm: "\u0628",
          midnight: "\u0646",
          noon: "\u0638",
          morning: "\u0635",
          afternoon: "\u0628.\u0638.",
          evening: "\u0639",
          night: "\u0634"
        },
        abbreviated: {
          am: "\u0642.\u0638.",
          pm: "\u0628.\u0638.",
          midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
          noon: "\u0638\u0647\u0631",
          morning: "\u0635\u0628\u062D",
          afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
          evening: "\u0639\u0635\u0631",
          night: "\u0634\u0628"
        },
        wide: {
          am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
          pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
          midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
          noon: "\u0638\u0647\u0631",
          morning: "\u0635\u0628\u062D",
          afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
          evening: "\u0639\u0635\u0631",
          night: "\u0634\u0628"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0642",
          pm: "\u0628",
          midnight: "\u0646",
          noon: "\u0638",
          morning: "\u0635",
          afternoon: "\u0628.\u0638.",
          evening: "\u0639",
          night: "\u0634"
        },
        abbreviated: {
          am: "\u0642.\u0638.",
          pm: "\u0628.\u0638.",
          midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
          noon: "\u0638\u0647\u0631",
          morning: "\u0635\u0628\u062D",
          afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
          evening: "\u0639\u0635\u0631",
          night: "\u0634\u0628"
        },
        wide: {
          am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
          pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
          midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
          noon: "\u0638\u0647\u0631",
          morning: "\u0635\u0628\u062D",
          afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
          evening: "\u0639\u0635\u0631",
          night: "\u0634\u0628"
        }
      };

      function ordinalNumber(dirtyNumber) {
        return String(dirtyNumber);
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ق|ب)/i,
        abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
        wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
      };
      var parseEraPatterns = {
        any: [/^قبل/i, /^بعد/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^س‌م[1234]/i,
        wide: /^سه‌ماهه [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[جژفمآاماسند]/i,
        abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
        wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
      };
      var parseMonthPatterns = {
        narrow: [/^(ژ|ج)/i, /^ف/i, /^م/i, /^(آ|ا)/i, /^م/i, /^(ژ|ج)/i, /^(ج|ژ)/i, /^(آ|ا)/i, /^س/i, /^ا/i, /^ن/i, /^د/i],
        any: [/^ژا/i, /^ف/i, /^ما/i, /^آپ/i, /^(می|مه)/i, /^(ژوئن|جون)/i, /^(ژوئی|جول)/i, /^(اوت|آگ)/i, /^س/i, /^(اوک|اک)/i, /^ن/i, /^د/i]
      };
      var matchDayPatterns = {
        narrow: /^[شیدسچپج]/i,
        short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
        abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
        wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
      };
      var parseDayPatterns = {
        narrow: [/^ی/i, /^دو/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
        any: [/^(ی|1ش|یکشنبه)/i, /^(د|2ش|دوشنبه)/i, /^(س|3ش|سه‌شنبه)/i, /^(چ|4ش|چهارشنبه)/i, /^(پ|5ش|پنجشنبه)/i, /^(ج|جمعه)/i, /^(ش|شنبه)/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
        abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
        wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
          pm: /^(ب|ب.ظ.|بعدازظهر)/i,
          midnight: /^(‌نیمه‌شب|ن)/i,
          noon: /^(ظ|ظهر)/i,
          morning: /(ص|صبح)/i,
          afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
          evening: /(ع|عصر)/i,
          night: /(ش|شب)/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;

      function futureSeconds(text) {
        return text.replace(/sekuntia?/, "sekunnin");
      }

      function futureMinutes(text) {
        return text.replace(/minuuttia?/, "minuutin");
      }

      function futureHours(text) {
        return text.replace(/tuntia?/, "tunnin");
      }

      function futureDays(text) {
        return text.replace(/päivää?/, "p\xE4iv\xE4n");
      }

      function futureWeeks(text) {
        return text.replace(/(viikko|viikkoa)/, "viikon");
      }

      function futureMonths(text) {
        return text.replace(/(kuukausi|kuukautta)/, "kuukauden");
      }

      function futureYears(text) {
        return text.replace(/(vuosi|vuotta)/, "vuoden");
      }

      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "alle sekunti",
          other: "alle {{count}} sekuntia",
          futureTense: futureSeconds
        },
        xSeconds: {
          one: "sekunti",
          other: "{{count}} sekuntia",
          futureTense: futureSeconds
        },
        halfAMinute: {
          one: "puoli minuuttia",
          other: "puoli minuuttia",
          futureTense: function (_text) {
            return "puolen minuutin";
          }
        },
        lessThanXMinutes: {
          one: "alle minuutti",
          other: "alle {{count}} minuuttia",
          futureTense: futureMinutes
        },
        xMinutes: {
          one: "minuutti",
          other: "{{count}} minuuttia",
          futureTense: futureMinutes
        },
        aboutXHours: {
          one: "noin tunti",
          other: "noin {{count}} tuntia",
          futureTense: futureHours
        },
        xHours: {
          one: "tunti",
          other: "{{count}} tuntia",
          futureTense: futureHours
        },
        xDays: {
          one: "p\xE4iv\xE4",
          other: "{{count}} p\xE4iv\xE4\xE4",
          futureTense: futureDays
        },
        aboutXWeeks: {
          one: "noin viikko",
          other: "noin {{count}} viikkoa",
          futureTense: futureWeeks
        },
        xWeeks: {
          one: "viikko",
          other: "{{count}} viikkoa",
          futureTense: futureWeeks
        },
        aboutXMonths: {
          one: "noin kuukausi",
          other: "noin {{count}} kuukautta",
          futureTense: futureMonths
        },
        xMonths: {
          one: "kuukausi",
          other: "{{count}} kuukautta",
          futureTense: futureMonths
        },
        aboutXYears: {
          one: "noin vuosi",
          other: "noin {{count}} vuotta",
          futureTense: futureYears
        },
        xYears: {
          one: "vuosi",
          other: "{{count}} vuotta",
          futureTense: futureYears
        },
        overXYears: {
          one: "yli vuosi",
          other: "yli {{count}} vuotta",
          futureTense: futureYears
        },
        almostXYears: {
          one: "l\xE4hes vuosi",
          other: "l\xE4hes {{count}} vuotta",
          futureTense: futureYears
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var distance = formatDistanceLocale[token];
        var result = count === 1 ? distance.one : distance.other.replace("{{count}}", count);

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return distance.futureTense(result) + " kuluttua";
          } else {
            return result + " sitten";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "eeee d. MMMM y",
        long: "d. MMMM y",
        medium: "d. MMM y",
        short: "d.M.y"
      };
      var timeFormats = {
        full: "HH.mm.ss zzzz",
        long: "HH.mm.ss z",
        medium: "HH.mm.ss",
        short: "HH.mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'klo' {{time}}",
        long: "{{date}} 'klo' {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'viime' eeee 'klo' p",
        yesterday: "'eilen klo' p",
        today: "'t\xE4n\xE4\xE4n klo' p",
        tomorrow: "'huomenna klo' p",
        nextWeek: "'ensi' eeee 'klo' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["eaa.", "jaa."],
        abbreviated: ["eaa.", "jaa."],
        wide: ["ennen ajanlaskun alkua", "j\xE4lkeen ajanlaskun alun"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1. kvartaali", "2. kvartaali", "3. kvartaali", "4. kvartaali"]
      };
      var monthValues = {
        narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
        abbreviated: ["tammi", "helmi", "maalis", "huhti", "touko", "kes\xE4", "hein\xE4", "elo", "syys", "loka", "marras", "joulu"],
        wide: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kes\xE4kuu", "hein\xE4kuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"]
      };
      var formattingMonthValues = {
        narrow: monthValues.narrow,
        abbreviated: monthValues.abbreviated,
        wide: monthValues.wide.map(function (name) {
          return name + "ta";
        })
      };
      var dayValues = {
        narrow: ["S", "M", "T", "K", "T", "P", "L"],
        short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
        abbreviated: ["sunn.", "maan.", "tiis.", "kesk.", "torst.", "perj.", "la"],
        wide: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"]
      };
      var formattingDayValues = {
        narrow: dayValues.narrow,
        short: dayValues.short,
        abbreviated: dayValues.abbreviated,
        wide: dayValues.wide.map(function (name) {
          return name + "na";
        })
      };
      var dayPeriodValues = {
        narrow: {
          am: "ap",
          pm: "ip",
          midnight: "keskiy\xF6",
          noon: "keskip\xE4iv\xE4",
          morning: "ap",
          afternoon: "ip",
          evening: "illalla",
          night: "y\xF6ll\xE4"
        },
        abbreviated: {
          am: "ap",
          pm: "ip",
          midnight: "keskiy\xF6",
          noon: "keskip\xE4iv\xE4",
          morning: "ap",
          afternoon: "ip",
          evening: "illalla",
          night: "y\xF6ll\xE4"
        },
        wide: {
          am: "ap",
          pm: "ip",
          midnight: "keskiy\xF6ll\xE4",
          noon: "keskip\xE4iv\xE4ll\xE4",
          morning: "aamup\xE4iv\xE4ll\xE4",
          afternoon: "iltap\xE4iv\xE4ll\xE4",
          evening: "illalla",
          night: "y\xF6ll\xE4"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + ".";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          formattingValues: formattingMonthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          formattingValues: formattingDayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(\.)/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(e|j)/i,
        abbreviated: /^(eaa.|jaa.)/i,
        wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
      };
      var parseEraPatterns = {
        any: [/^e/i, /^j/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234]\.? kvartaali/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[thmkeslj]/i,
        abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
        wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
      };
      var parseMonthPatterns = {
        narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
        any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtkpl]/i,
        short: /^(su|ma|ti|ke|to|pe|la)/i,
        abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
        wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
        any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
        any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ap/i,
          pm: /^ip/i,
          midnight: /^keskiyö/i,
          noon: /^keskipäivä/i,
          morning: /aamupäivällä/i,
          afternoon: /iltapäivällä/i,
          evening: /illalla/i,
          night: /yöllä/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE d MMMM y",
        long: "d MMMM y",
        medium: "d MMM y",
        short: "yy-MM-dd"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} '\xE0' {{time}}",
        long: "{{date}} '\xE0' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "moins d\u2019une seconde",
          other: "moins de {{count}} secondes"
        },
        xSeconds: {
          one: "1 seconde",
          other: "{{count}} secondes"
        },
        halfAMinute: "30 secondes",
        lessThanXMinutes: {
          one: "moins d\u2019une minute",
          other: "moins de {{count}} minutes"
        },
        xMinutes: {
          one: "1 minute",
          other: "{{count}} minutes"
        },
        aboutXHours: {
          one: "environ 1 heure",
          other: "environ {{count}} heures"
        },
        xHours: {
          one: "1 heure",
          other: "{{count}} heures"
        },
        xDays: {
          one: "1 jour",
          other: "{{count}} jours"
        },
        aboutXWeeks: {
          one: "environ 1 semaine",
          other: "environ {{count}} semaines"
        },
        xWeeks: {
          one: "1 semaine",
          other: "{{count}} semaines"
        },
        aboutXMonths: {
          one: "environ 1 mois",
          other: "environ {{count}} mois"
        },
        xMonths: {
          one: "1 mois",
          other: "{{count}} mois"
        },
        aboutXYears: {
          one: "environ 1 an",
          other: "environ {{count}} ans"
        },
        xYears: {
          one: "1 an",
          other: "{{count}} ans"
        },
        overXYears: {
          one: "plus d\u2019un an",
          other: "plus de {{count}} ans"
        },
        almostXYears: {
          one: "presqu\u2019un an",
          other: "presque {{count}} ans"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "dans " + result;
          } else {
            return "il y a " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE d MMMM y",
        long: "d MMMM y",
        medium: "d MMM y",
        short: "dd.MM.y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} '\xE0' {{time}}",
        long: "{{date}} '\xE0' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'la semaine derni\xE8re \xE0' p",
        yesterday: "'hier \xE0' p",
        today: "'aujourd\u2019hui \xE0' p",
        tomorrow: "'demain \xE0' p'",
        nextWeek: "eeee 'la semaine prochaine \xE0' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["av. J.-C", "ap. J.-C"],
        abbreviated: ["av. J.-C", "ap. J.-C"],
        wide: ["avant J\xE9sus-Christ", "apr\xE8s J\xE9sus-Christ"]
      };
      var quarterValues = {
        narrow: ["T1", "T2", "T3", "T4"],
        abbreviated: ["1er trim.", "2\xE8me trim.", "3\xE8me trim.", "4\xE8me trim."],
        wide: ["1er trimestre", "2\xE8me trimestre", "3\xE8me trimestre", "4\xE8me trimestre"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["janv.", "f\xE9vr.", "mars", "avr.", "mai", "juin", "juil.", "ao\xFBt", "sept.", "oct.", "nov.", "d\xE9c."],
        wide: ["janvier", "f\xE9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\xFBt", "septembre", "octobre", "novembre", "d\xE9cembre"]
      };
      var dayValues = {
        narrow: ["D", "L", "M", "M", "J", "V", "S"],
        short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
        abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
        wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "minuit",
          noon: "midi",
          morning: "mat.",
          afternoon: "ap.m.",
          evening: "soir",
          night: "mat."
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "minuit",
          noon: "midi",
          morning: "matin",
          afternoon: "apr\xE8s-midi",
          evening: "soir",
          night: "matin"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "minuit",
          noon: "midi",
          morning: "du matin",
          afternoon: "de l\u2019apr\xE8s-midi",
          evening: "du soir",
          night: "du matin"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber);
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var suffix;

        if (number === 0) {
          return number;
        }

        if (unit === "year" || unit === "hour" || unit === "week") {
          if (number === 1) {
            suffix = "\xE8re";
          } else {
            suffix = "\xE8me";
          }
        } else {
          if (number === 1) {
            suffix = "er";
          } else {
            suffix = "\xE8me";
          }
        }

        return number + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
        abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
        wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
      };
      var parseEraPatterns = {
        any: [/^av/i, /^ap/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^t[1234]/i,
        wide: /^[1234](er|ème|e)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
        wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[lmjvsd]/i,
        short: /^(di|lu|ma|me|je|ve|sa)/i,
        abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
        wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
        any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
        any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^min/i,
          noon: /^mid/i,
          morning: /mat/i,
          afternoon: /ap/i,
          evening: /soir/i,
          night: /nuit/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE d MMMM y",
        long: "d MMMM y",
        medium: "d MMM y",
        short: "dd/MM/y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} '\xE0' {{time}}",
        long: "{{date}} '\xE0' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "nas lugha na diog",
          other: "nas lugha na {{count}} diogan"
        },
        xSeconds: {
          one: "1 diog",
          two: "2 dhiog",
          twenty: "20 diog",
          other: "{{count}} diogan"
        },
        halfAMinute: "leth mhionaid",
        lessThanXMinutes: {
          one: "nas lugha na mionaid",
          other: "nas lugha na {{count}} mionaidean"
        },
        xMinutes: {
          one: "1 mionaid",
          two: "2 mhionaid",
          twenty: "20 mionaid",
          other: "{{count}} mionaidean"
        },
        aboutXHours: {
          one: "mu uair de th\xECde",
          other: "mu {{count}} uairean de th\xECde"
        },
        xHours: {
          one: "1 uair de th\xECde",
          two: "2 uair de th\xECde",
          twenty: "20 uair de th\xECde",
          other: "{{count}} uairean de th\xECde"
        },
        xDays: {
          one: "1 l\xE0",
          other: "{{count}} l\xE0"
        },
        aboutXWeeks: {
          one: "mu 1 seachdain",
          other: "mu {{count}} seachdainean"
        },
        xWeeks: {
          one: "1 seachdain",
          other: "{{count}} seachdainean"
        },
        aboutXMonths: {
          one: "mu mh\xECos",
          other: "mu {{count}} m\xECosan"
        },
        xMonths: {
          one: "1 m\xECos",
          other: "{{count}} m\xECosan"
        },
        aboutXYears: {
          one: "mu bhliadhna",
          other: "mu {{count}} bliadhnaichean"
        },
        xYears: {
          one: "1 bhliadhna",
          other: "{{count}} bliadhna"
        },
        overXYears: {
          one: "c\xF2rr is bliadhna",
          other: "c\xF2rr is {{count}} bliadhnaichean"
        },
        almostXYears: {
          one: "cha mh\xF2r bliadhna",
          other: "cha mh\xF2r {{count}} bliadhnaichean"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2 && !!formatDistanceLocale[token].two) {
          result = formatDistanceLocale[token].two;
        } else if (count === 9 && !!formatDistanceLocale[token].nine) {
          result = formatDistanceLocale[token].nine;
        } else if (count === 20 && !!formatDistanceLocale[token].twenty) {
          result = formatDistanceLocale[token].twenty;
        } else if (count === 30 && !!formatDistanceLocale[token].thirty) {
          result = formatDistanceLocale[token].thirty;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "ann an " + result;
          } else {
            return "o chionn " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, MMMM do, y",
        long: "MMMM do, y",
        medium: "MMM d, y",
        short: "MM/dd/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} 'aig' {{time}}",
        long: "{{date}} 'aig' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'mu dheireadh' eeee 'aig' p",
        //FIX
        yesterday: "'an-d\xE8 aig' p",
        today: "'an-diugh aig' p",
        tomorrow: "'a-m\xE0ireach aig' p",
        nextWeek: "eeee 'aig' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["R", "A"],
        abbreviated: ["RC", "AD"],
        wide: ["ro Chr\xECosta", "anno domini"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["C1", "C2", "C3", "C4"],
        wide: ["a' chiad chairteal", "an d\xE0rna cairteal", "an treas cairteal", "an ceathramh cairteal"]
      }; // Note: in English, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["F", "G", "M", "G", "C", "\xD2", "I", "L", "S", "D", "S", "D"],
        abbreviated: ["Faoi", "Gear", "M\xE0rt", "Gibl", "C\xE8it", "\xD2gmh", "Iuch", "L\xF9n", "Sult", "D\xE0mh", "Samh", "D\xF9bh"],
        wide: ["Am Faoilleach", "An Gearran", "Am M\xE0rt", "An Giblean", "An C\xE8itean", "An t-\xD2gmhios", "An t-Iuchar", "An L\xF9nastal", "An t-Sultain", "An D\xE0mhair", "An t-Samhain", "An D\xF9bhlachd"]
      };
      var dayValues = {
        narrow: ["D", "L", "M", "C", "A", "H", "S"],
        short: ["D\xF2", "Lu", "M\xE0", "Ci", "Ar", "Ha", "Sa"],
        abbreviated: ["Did", "Dil", "Dim", "Dic", "Dia", "Dih", "Dis"],
        wide: ["Did\xF2mhnaich", "Diluain", "Dim\xE0irt", "Diciadain", "Diardaoin", "Dihaoine", "Disathairne"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "m",
          pm: "f",
          midnight: "m.o.",
          noon: "m.l.",
          morning: "madainn",
          afternoon: "feasgar",
          evening: "feasgar",
          night: "oidhche"
        },
        abbreviated: {
          am: "M.",
          pm: "F.",
          midnight: "meadhan oidhche",
          noon: "meadhan l\xE0",
          morning: "madainn",
          afternoon: "feasgar",
          evening: "feasgar",
          night: "oidhche"
        },
        wide: {
          am: "m.",
          pm: "f.",
          midnight: "meadhan oidhche",
          noon: "meadhan l\xE0",
          morning: "madainn",
          afternoon: "feasgar",
          evening: "feasgar",
          night: "oidhche"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "m",
          pm: "f",
          midnight: "m.o.",
          noon: "m.l.",
          morning: "sa mhadainn",
          afternoon: "feasgar",
          evening: "feasgar",
          night: "air an oidhche"
        },
        abbreviated: {
          am: "M.",
          pm: "F.",
          midnight: "meadhan oidhche",
          noon: "meadhan l\xE0",
          morning: "sa mhadainn",
          afternoon: "feasgar",
          evening: "feasgar",
          night: "air an oidhche"
        },
        wide: {
          am: "m.",
          pm: "f.",
          midnight: "meadhan oidhche",
          noon: "meadhan l\xE0",
          morning: "sa mhadainn",
          afternoon: "feasgar",
          evening: "feasgar",
          night: "air an oidhche"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        var rem100 = number % 100;

        if (rem100 > 20 || rem100 < 10) {
          switch (rem100 % 10) {
            case 1:
              return number + "d";

            case 2:
              return number + "na";
          }
        }

        if (rem100 === 12) {
          return number + "na";
        }

        return number + "mh";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(r|a)/i,
        abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
        wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
      };
      var parseEraPatterns = {
        any: [/^b/i, /^(a|c)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^c[1234]/i,
        wide: /^[1234](cd|na|tr|mh)? cairteal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[fgmcòilsd]/i,
        abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
        wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
      };
      var parseMonthPatterns = {
        narrow: [/^f/i, /^g/i, /^m/i, /^g/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^s/i, /^d/i, /^s/i, /^d/i],
        any: [/^fa/i, /^ge/i, /^mà/i, /^gi/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^su/i, /^d/i, /^sa/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[dlmcahs]/i,
        short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
        abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
        wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i],
        any: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
        any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^m/i,
          pm: /^f/i,
          midnight: /^meadhan oidhche/i,
          noon: /^meadhan là/i,
          morning: /sa mhadainn/i,
          afternoon: /feasgar/i,
          evening: /feasgar/i,
          night: /air an oidhche/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "menos dun segundo",
          other: "menos de {{count}} segundos"
        },
        xSeconds: {
          one: "1 segundo",
          other: "{{count}} segundos"
        },
        halfAMinute: "medio minuto",
        lessThanXMinutes: {
          one: "menos dun minuto",
          other: "menos de {{count}} minutos"
        },
        xMinutes: {
          one: "1 minuto",
          other: "{{count}} minutos"
        },
        aboutXHours: {
          one: "arredor dunha hora",
          other: "arredor de {{count}} horas"
        },
        xHours: {
          one: "1 hora",
          other: "{{count}} horas"
        },
        xDays: {
          one: "1 d\xEDa",
          other: "{{count}} d\xEDas"
        },
        aboutXWeeks: {
          one: "arredor dunha semana",
          other: "arredor de {{count}} semanas"
        },
        xWeeks: {
          one: "1 semana",
          other: "{{count}} semanas"
        },
        aboutXMonths: {
          one: "arredor de 1 mes",
          other: "arredor de {{count}} meses"
        },
        xMonths: {
          one: "1 mes",
          other: "{{count}} meses"
        },
        aboutXYears: {
          one: "arredor dun ano",
          other: "arredor de {{count}} anos"
        },
        xYears: {
          one: "1 ano",
          other: "{{count}} anos"
        },
        overXYears: {
          one: "m\xE1is dun ano",
          other: "m\xE1is de {{count}} anos"
        },
        almostXYears: {
          one: "case un ano",
          other: "case {{count}} anos"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "en " + result;
          } else {
            return "hai " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d 'de' MMMM y",
        long: "d 'de' MMMM y",
        medium: "d MMM y",
        short: "dd/MM/y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} '\xE1s' {{time}}",
        long: "{{date}} '\xE1s' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'o' eeee 'pasado \xE1' LT",
        yesterday: "'onte \xE1' p",
        today: "'hoxe \xE1' p",
        tomorrow: "'ma\xF1\xE1 \xE1' p",
        nextWeek: "eeee '\xE1' p",
        other: "P"
      };
      var formatRelativeLocalePlural = {
        lastWeek: "'o' eeee 'pasado \xE1s' p",
        yesterday: "'onte \xE1s' p",
        today: "'hoxe \xE1s' p",
        tomorrow: "'ma\xF1\xE1 \xE1s' p",
        nextWeek: "eeee '\xE1s' p",
        other: "P"
      };

      function formatRelative(token, date, _baseDate, _options) {
        if (date.getUTCHours() !== 1) {
          return formatRelativeLocalePlural[token];
        }

        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["AC", "DC"],
        abbreviated: ["AC", "DC"],
        wide: ["antes de cristo", "despois de cristo"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["T1", "T2", "T3", "T4"],
        wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
      };
      var monthValues = {
        narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
        abbreviated: ["xan", "feb", "mar", "abr", "mai", "xun", "xul", "ago", "set", "out", "nov", "dec"],
        wide: ["xaneiro", "febreiro", "marzo", "abril", "maio", "xu\xF1o", "xullo", "agosto", "setembro", "outubro", "novembro", "decembro"]
      };
      var dayValues = {
        narrow: ["d", "l", "m", "m", "j", "v", "s"],
        short: ["do", "lu", "ma", "me", "xo", "ve", "sa"],
        abbreviated: ["dom", "lun", "mar", "mer", "xov", "ven", "sab"],
        wide: ["domingo", "luns", "martes", "m\xE9rcores", "xoves", "venres", "s\xE1bado"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mn",
          noon: "md",
          morning: "ma\xF1\xE1",
          afternoon: "tarde",
          evening: "tarde",
          night: "noite"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "medianoite",
          noon: "mediod\xEDa",
          morning: "ma\xF1\xE1",
          afternoon: "tarde",
          evening: "tardi\xF1a",
          night: "noite"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "medianoite",
          noon: "mediod\xEDa",
          morning: "ma\xF1\xE1",
          afternoon: "tarde",
          evening: "tardi\xF1a",
          night: "noite"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mn",
          noon: "md",
          morning: "da ma\xF1\xE1",
          afternoon: "da tarde",
          evening: "da tardi\xF1a",
          night: "da noite"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "medianoite",
          noon: "mediod\xEDa",
          morning: "da ma\xF1\xE1",
          afternoon: "da tarde",
          evening: "da tardi\xF1a",
          night: "da noite"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "medianoite",
          noon: "mediod\xEDa",
          morning: "da ma\xF1\xE1",
          afternoon: "da tarde",
          evening: "da tardi\xF1a",
          night: "da noite"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + "\xBA";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ac|dc|a|d)/i,
        abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
        wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
      };
      var parseEraPatterns = {
        any: [/^ac/i, /^dc/i],
        wide: [/^(antes de cristo|antes da era com[uú]n)/i, /^(despois de cristo|era com[uú]n)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^T[1234]/i,
        wide: /^[1234](º)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[xfmasond]/i,
        abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
        wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
      };
      var parseMonthPatterns = {
        narrow: [/^x/i, /^f/i, /^m/i, /^a/i, /^m/i, /^x/i, /^x/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^xan/i, /^feb/i, /^mar/i, /^abr/i, /^mai/i, /^xun/i, /^xul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dec/i]
      };
      var matchDayPatterns = {
        narrow: /^[dlmxvs]/i,
        short: /^(do|lu|ma|me|xo|ve|sa)/i,
        abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
        wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^x/i, /^v/i, /^s/i],
        any: [/^do/i, /^lu/i, /^ma/i, /^me/i, /^xo/i, /^ve/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
        any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mn/i,
          noon: /^md/i,
          morning: /mañ[aá]/i,
          afternoon: /tarde/i,
          evening: /tardiña/i,
          night: /noite/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance; // Source: https://www.unicode.org/cldr/charts/32/summary/gu.html

      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
          // CLDR #1461
          other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
        },
        xSeconds: {
          one: "1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
          other: "{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
        },
        halfAMinute: "\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        lessThanXMinutes: {
          one: "\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
          // CLDR #1448
          other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
        },
        xMinutes: {
          one: "1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
          other: "{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
        },
        aboutXHours: {
          one: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
          other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
        },
        xHours: {
          one: "1 \u0A95\u0AB2\u0ABE\u0A95",
          other: "{{count}} \u0A95\u0AB2\u0ABE\u0A95"
        },
        xDays: {
          one: "1 \u0AA6\u0ABF\u0AB5\u0AB8",
          other: "{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
        },
        aboutXWeeks: {
          one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
          other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
        },
        xWeeks: {
          one: "1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
          other: "{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
        },
        aboutXMonths: {
          one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
          other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
        },
        xMonths: {
          one: "1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
          other: "{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
        },
        aboutXYears: {
          one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
          other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
        },
        xYears: {
          one: "1 \u0AB5\u0AB0\u0ACD\u0AB7",
          other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
        },
        overXYears: {
          one: "1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
          other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
        },
        almostXYears: {
          one: "\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
          other: "\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + "\u0AAE\u0ABE\u0A82";
          } else {
            return result + " \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } //Source: https://www.unicode.org/cldr/charts/32/summary/gu.html


      var dateFormats = {
        full: "EEEE, d MMMM, y",
        // CLDR #1825
        long: "d MMMM, y",
        // CLDR #1826
        medium: "d MMM, y",
        // CLDR #1827
        short: "d/M/yy" // CLDR #1828

      };
      var timeFormats = {
        full: "hh:mm:ss a zzzz",
        // CLDR #1829
        long: "hh:mm:ss a z",
        // CLDR #1830
        medium: "hh:mm:ss a",
        // CLDR #1831
        short: "hh:mm a" // CLDR #1832

      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        // CLDR #1833
        long: "{{date}} {{time}}",
        // CLDR #1834
        medium: "{{date}} {{time}}",
        // CLDR #1835
        short: "{{date}} {{time}}" // CLDR #1836

      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative; // Source: https://www.unicode.org/cldr/charts/32/summary/gu.html

      var formatRelativeLocale = {
        lastWeek: "'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
        // CLDR #1384
        yesterday: "'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
        // CLDR #1409
        today: "'\u0A86\u0A9C\u0AC7' p",
        // CLDR #1410
        tomorrow: "'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
        // CLDR #1411
        nextWeek: "eeee p",
        // CLDR #1386
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // https://www.unicode.org/cldr/charts/32/summary/gu.html
      // #1621 - #1630


      var eraValues = {
        narrow: ["\u0A88\u0AB8\u0AAA\u0AC2", "\u0A88\u0AB8"],
        abbreviated: ["\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7", "\u0A88.\u0AB8."],
        wide: ["\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7", "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"]
      }; // https://www.unicode.org/cldr/charts/32/summary/gu.html
      // #1631 - #1654

      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8", "2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8", "3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8", "4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"]
      }; // Note: in English, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.
      // https://www.unicode.org/cldr/charts/32/summary/gu.html
      // #1655 - #1726

      var monthValues = {
        narrow: ["\u0A9C\u0ABE", "\u0AAB\u0AC7", "\u0AAE\u0ABE", "\u0A8F", "\u0AAE\u0AC7", "\u0A9C\u0AC2", "\u0A9C\u0AC1", "\u0A93", "\u0AB8", "\u0A93", "\u0AA8", "\u0AA1\u0ABF"],
        abbreviated: ["\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1", "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1", "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A", "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2", "\u0AAE\u0AC7", "\u0A9C\u0AC2\u0AA8", "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88", "\u0A91\u0A97\u0AB8\u0ACD\u0A9F", "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7", "\u0A93\u0A95\u0ACD\u0A9F\u0ACB", "\u0AA8\u0AB5\u0AC7", "\u0AA1\u0ABF\u0AB8\u0AC7"],
        wide: ["\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0", "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0", "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A", "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2", "\u0AAE\u0AC7", "\u0A9C\u0AC2\u0AA8", "\u0A9C\u0AC1\u0AB2\u0ABE\u0A87", "\u0A93\u0A97\u0AB8\u0ACD\u0A9F", "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0", "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0", "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0", "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"]
      }; // https://www.unicode.org/cldr/charts/32/summary/gu.html
      // #1727 - #1768

      var dayValues = {
        narrow: ["\u0AB0", "\u0AB8\u0ACB", "\u0AAE\u0A82", "\u0AAC\u0AC1", "\u0A97\u0AC1", "\u0AB6\u0AC1", "\u0AB6"],
        short: ["\u0AB0", "\u0AB8\u0ACB", "\u0AAE\u0A82", "\u0AAC\u0AC1", "\u0A97\u0AC1", "\u0AB6\u0AC1", "\u0AB6"],
        abbreviated: ["\u0AB0\u0AB5\u0ABF", "\u0AB8\u0ACB\u0AAE", "\u0AAE\u0A82\u0A97\u0AB3", "\u0AAC\u0AC1\u0AA7", "\u0A97\u0AC1\u0AB0\u0AC1", "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0", "\u0AB6\u0AA8\u0ABF"],
        wide: ["\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0"
        /* Sunday */
        , "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0"
        /* Monday */
        , "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0"
        /* Tuesday */
        , "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0"
        /* Wednesday */
        , "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0"
        /* Thursday */
        , "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0"
        /* Friday */
        , "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0"
        /* Saturday */
        ]
      }; // https://www.unicode.org/cldr/charts/32/summary/gu.html
      // #1783 - #1824

      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
          noon: "\u0AAC.",
          morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
          afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
          evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
          night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
          noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
          morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
          afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
          evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
          night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
          noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
          morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
          afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
          evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
          night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
          noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
          morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
          afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
          evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
          night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
          noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
          morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
          afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
          evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
          night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
          noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
          morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
          afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
          evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
          night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ઈસપૂ|ઈસ)/i,
        abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
        wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
      };
      var parseEraPatterns = {
        any: [/^(ઈસપૂ|ઈસ)/i, /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i, /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        // eslint-disable-next-line no-misleading-character-class
        narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
        abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
        wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
      };
      var parseMonthPatterns = {
        narrow: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i],
        any: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i]
      };
      var matchDayPatterns = {
        narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
        short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
        abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
        wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
      };
      var parseDayPatterns = {
        narrow: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i],
        any: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
        any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^મ\.?/i,
          noon: /^બ/i,
          morning: /સ/i,
          afternoon: /બ/i,
          evening: /સાં/i,
          night: /રા/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
          two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
          other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
        },
        xSeconds: {
          one: "\u05E9\u05E0\u05D9\u05D9\u05D4",
          two: "\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
          other: "{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
        },
        halfAMinute: "\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
        lessThanXMinutes: {
          one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
          two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
          other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
        },
        xMinutes: {
          one: "\u05D3\u05E7\u05D4",
          two: "\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
          other: "{{count}} \u05D3\u05E7\u05D5\u05EA"
        },
        aboutXHours: {
          one: "\u05DB\u05E9\u05E2\u05D4",
          two: "\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
          other: "\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
        },
        xHours: {
          one: "\u05E9\u05E2\u05D4",
          two: "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
          other: "{{count}} \u05E9\u05E2\u05D5\u05EA"
        },
        xDays: {
          one: "\u05D9\u05D5\u05DD",
          two: "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
          other: "{{count}} \u05D9\u05DE\u05D9\u05DD"
        },
        aboutXWeeks: {
          one: "\u05DB\u05E9\u05D1\u05D5\u05E2",
          two: "\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
          other: "\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
        },
        xWeeks: {
          one: "\u05E9\u05D1\u05D5\u05E2",
          two: "\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
          other: "{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
        },
        aboutXMonths: {
          one: "\u05DB\u05D7\u05D5\u05D3\u05E9",
          two: "\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
          other: "\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
        },
        xMonths: {
          one: "\u05D7\u05D5\u05D3\u05E9",
          two: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
          other: "{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
        },
        aboutXYears: {
          one: "\u05DB\u05E9\u05E0\u05D4",
          two: "\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
          other: "\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
        },
        xYears: {
          one: "\u05E9\u05E0\u05D4",
          two: "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
          other: "{{count}} \u05E9\u05E0\u05D9\u05DD"
        },
        overXYears: {
          one: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
          two: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
          other: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
        },
        almostXYears: {
          one: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
          two: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
          other: "\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {}; // Return word instead of `in one day` or `one day ago`

        if (token === "xDays" && options.addSuffix && count <= 2) {
          var past = {
            1: "\u05D0\u05EA\u05DE\u05D5\u05DC",
            2: "\u05E9\u05DC\u05E9\u05D5\u05DD"
          };
          var future = {
            1: "\u05DE\u05D7\u05E8",
            2: "\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD"
          };
          return options.comparison > 0 ? future[count] : past[count];
        }

        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2) {
          result = formatDistanceLocale[token].two;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "\u05D1\u05E2\u05D5\u05D3 " + result;
          } else {
            return "\u05DC\u05E4\u05E0\u05D9 " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d \u05D1MMMM y",
        long: "d \u05D1MMMM y",
        medium: "d \u05D1MMM y",
        short: "d.M.y"
      };
      var timeFormats = {
        full: "H:mm:ss zzzz",
        long: "H:mm:ss z",
        medium: "H:mm:ss",
        short: "H:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
        long: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
        yesterday: "'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
        today: "'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
        tomorrow: "'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
        nextWeek: "eeee '\u05D1\u05E9\u05E2\u05D4' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1", "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"],
        abbreviated: ["\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1", "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"],
        wide: ["\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4", "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["\u05E8\u05D1\u05E2\u05D5\u05DF 1", "\u05E8\u05D1\u05E2\u05D5\u05DF 2", "\u05E8\u05D1\u05E2\u05D5\u05DF 3", "\u05E8\u05D1\u05E2\u05D5\u05DF 4"]
      };
      var monthValues = {
        narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
        abbreviated: ["\u05D9\u05E0\u05D5\u05F3", "\u05E4\u05D1\u05E8\u05F3", "\u05DE\u05E8\u05E5", "\u05D0\u05E4\u05E8\u05F3", "\u05DE\u05D0\u05D9", "\u05D9\u05D5\u05E0\u05D9", "\u05D9\u05D5\u05DC\u05D9", "\u05D0\u05D5\u05D2\u05F3", "\u05E1\u05E4\u05D8\u05F3", "\u05D0\u05D5\u05E7\u05F3", "\u05E0\u05D5\u05D1\u05F3", "\u05D3\u05E6\u05DE\u05F3"],
        wide: ["\u05D9\u05E0\u05D5\u05D0\u05E8", "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8", "\u05DE\u05E8\u05E5", "\u05D0\u05E4\u05E8\u05D9\u05DC", "\u05DE\u05D0\u05D9", "\u05D9\u05D5\u05E0\u05D9", "\u05D9\u05D5\u05DC\u05D9", "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8", "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8", "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8", "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8", "\u05D3\u05E6\u05DE\u05D1\u05E8"]
      };
      var dayValues = {
        narrow: ["\u05D0\u05F3", "\u05D1\u05F3", "\u05D2\u05F3", "\u05D3\u05F3", "\u05D4\u05F3", "\u05D5\u05F3", "\u05E9\u05F3"],
        short: ["\u05D0\u05F3", "\u05D1\u05F3", "\u05D2\u05F3", "\u05D3\u05F3", "\u05D4\u05F3", "\u05D5\u05F3", "\u05E9\u05F3"],
        abbreviated: ["\u05D9\u05D5\u05DD \u05D0\u05F3", "\u05D9\u05D5\u05DD \u05D1\u05F3", "\u05D9\u05D5\u05DD \u05D2\u05F3", "\u05D9\u05D5\u05DD \u05D3\u05F3", "\u05D9\u05D5\u05DD \u05D4\u05F3", "\u05D9\u05D5\u05DD \u05D5\u05F3", "\u05E9\u05D1\u05EA"],
        wide: ["\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF", "\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9", "\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9", "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9", "\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9", "\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9", "\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
          pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
          midnight: "\u05D7\u05E6\u05D5\u05EA",
          noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
          morning: "\u05D1\u05D5\u05E7\u05E8",
          afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
          evening: "\u05E2\u05E8\u05D1",
          night: "\u05DC\u05D9\u05DC\u05D4"
        },
        abbreviated: {
          am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
          pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
          midnight: "\u05D7\u05E6\u05D5\u05EA",
          noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
          morning: "\u05D1\u05D5\u05E7\u05E8",
          afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
          evening: "\u05E2\u05E8\u05D1",
          night: "\u05DC\u05D9\u05DC\u05D4"
        },
        wide: {
          am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
          pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
          midnight: "\u05D7\u05E6\u05D5\u05EA",
          noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
          morning: "\u05D1\u05D5\u05E7\u05E8",
          afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
          evening: "\u05E2\u05E8\u05D1",
          night: "\u05DC\u05D9\u05DC\u05D4"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
          pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
          midnight: "\u05D7\u05E6\u05D5\u05EA",
          noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
          morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
          afternoon: "\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
          evening: "\u05D1\u05E2\u05E8\u05D1",
          night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
        },
        abbreviated: {
          am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
          pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
          midnight: "\u05D7\u05E6\u05D5\u05EA",
          noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
          morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
          afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
          evening: "\u05D1\u05E2\u05E8\u05D1",
          night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
        },
        wide: {
          am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
          pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
          midnight: "\u05D7\u05E6\u05D5\u05EA",
          noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
          morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
          afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
          evening: "\u05D1\u05E2\u05E8\u05D1",
          night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber); // We only show words till 10

        if (number <= 0 || number > 10) return number;
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var isFemale = ["year", "hour", "minute", "second"].indexOf(unit) >= 0;
        var male = ["\u05E8\u05D0\u05E9\u05D5\u05DF", "\u05E9\u05E0\u05D9", "\u05E9\u05DC\u05D9\u05E9\u05D9", "\u05E8\u05D1\u05D9\u05E2\u05D9", "\u05D7\u05DE\u05D9\u05E9\u05D9", "\u05E9\u05D9\u05E9\u05D9", "\u05E9\u05D1\u05D9\u05E2\u05D9", "\u05E9\u05DE\u05D9\u05E0\u05D9", "\u05EA\u05E9\u05D9\u05E2\u05D9", "\u05E2\u05E9\u05D9\u05E8\u05D9"];
        var female = ["\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4", "\u05E9\u05E0\u05D9\u05D9\u05D4", "\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA", "\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA", "\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA", "\u05E9\u05D9\u05E9\u05D9\u05EA", "\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA", "\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA", "\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA", "\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"];
        var index = number - 1;
        return isFemale ? female[index] : male[index];
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
      var parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
      var matchEraPatterns = {
        narrow: /^ל(ספירה|פנה״ס)/i,
        abbreviated: /^ל(ספירה|פנה״ס)/i,
        wide: /^ל(פני ה)?ספירה/i
      };
      var parseEraPatterns = {
        any: [/^לפ/i, /^לס/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^רבעון [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^\d+/i,
        abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
        wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
      };
      var parseMonthPatterns = {
        narrow: [/^1$/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
        any: [/^ינ/i, /^פ/i, /^מר/i, /^אפ/i, /^מא/i, /^יונ/i, /^יול/i, /^אוג/i, /^ס/i, /^אוק/i, /^נ/i, /^ד/i]
      };
      var matchDayPatterns = {
        narrow: /^[אבגדהוש]׳/i,
        short: /^[אבגדהוש]׳/i,
        abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
        wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
      };
      var parseDayPatterns = {
        abbreviated: [/א׳$/i, /ב׳$/i, /ג׳$/i, /ד׳$/i, /ה׳$/i, /ו׳$/i, /^ש/i],
        wide: [/ן$/i, /ני$/i, /לישי$/i, /עי$/i, /מישי$/i, /שישי$/i, /ת$/i],
        any: [/^א/i, /^ב/i, /^ג/i, /^ד/i, /^ה/i, /^ו/i, /^ש/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^לפ/i,
          pm: /^אחה/i,
          midnight: /^ח/i,
          noon: /^צ/i,
          morning: /בוקר/i,
          afternoon: /בצ|אחר/i,
          evening: /ערב/i,
          night: /לילה/i
        }
      };
      var ordinalName = ["\u05E8\u05D0", "\u05E9\u05E0", "\u05E9\u05DC", "\u05E8\u05D1", "\u05D7", "\u05E9\u05D9", "\u05E9\u05D1", "\u05E9\u05DE", "\u05EA", "\u05E2"];
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            var number = parseInt(value, 10);
            return isNaN(number) ? ordinalName.indexOf(value) + 1 : number;
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;

      var _index = _interopRequireDefault(__webpack_require__(44));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // Source: https://www.unicode.org/cldr/charts/32/summary/hi.html


      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
          // CLDR #1310
          other: "{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
        },
        xSeconds: {
          one: "\u0967 \u0938\u0947\u0915\u0902\u0921",
          other: "{{count}} \u0938\u0947\u0915\u0902\u0921"
        },
        halfAMinute: "\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
        lessThanXMinutes: {
          one: "\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
          other: "{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
        },
        xMinutes: {
          one: "\u0967 \u092E\u093F\u0928\u091F",
          // CLDR #1307
          other: "{{count}} \u092E\u093F\u0928\u091F"
        },
        aboutXHours: {
          one: "\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
          other: "\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
        },
        xHours: {
          one: "\u0967 \u0918\u0902\u091F\u093E",
          // CLDR #1304
          other: "{{count}} \u0918\u0902\u091F\u0947" // CLDR #4467

        },
        xDays: {
          one: "\u0967 \u0926\u093F\u0928",
          // CLDR #1286
          other: "{{count}} \u0926\u093F\u0928"
        },
        aboutXWeeks: {
          one: "\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
          other: "\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
        },
        xWeeks: {
          one: "\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
          other: "{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
        },
        aboutXMonths: {
          one: "\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
          other: "\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
        },
        xMonths: {
          one: "\u0967 \u092E\u0939\u0940\u0928\u093E",
          other: "{{count}} \u092E\u0939\u0940\u0928\u0947"
        },
        aboutXYears: {
          one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
          other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937" // CLDR #4823

        },
        xYears: {
          one: "\u0967 \u0935\u0930\u094D\u0937",
          other: "{{count}} \u0935\u0930\u094D\u0937"
        },
        overXYears: {
          one: "\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
          other: "{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
        },
        almostXYears: {
          one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
          other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", _index.default.numberToLocale(count));
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + "\u092E\u0947 ";
          } else {
            return result + " \u092A\u0939\u0932\u0947";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, do MMMM, y",
        // CLDR #1787
        long: "do MMMM, y",
        // CLDR #1788
        medium: "d MMM, y",
        // CLDR #1789
        short: "dd/MM/yyyy" // CLDR #1790

      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        // CLDR #1791
        long: "h:mm:ss a z",
        // CLDR #1792
        medium: "h:mm:ss a",
        // CLDR #1793
        short: "h:mm a" // CLDR #1794

      };
      var dateTimeFormats = {
        full: "{{date}} '\u0915\u094B' {{time}}",
        // CLDR #1795
        long: "{{date}} '\u0915\u094B' {{time}}",
        // CLDR #1796
        medium: "{{date}}, {{time}}",
        // CLDR #1797
        short: "{{date}}, {{time}}" // CLDR #1798

      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'\u092A\u093F\u091B\u0932\u0947' eeee p",
        yesterday: "'\u0915\u0932' p",
        today: "'\u0906\u091C' p",
        tomorrow: "'\u0915\u0932' p",
        nextWeek: "eeee '\u0915\u094B' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      var _index3 = _interopRequireDefault(__webpack_require__(44));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
      var parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
      var matchEraPatterns = {
        narrow: /^(ईसा-पूर्व|ईस्वी)/i,
        abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
        wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
      };
      var parseEraPatterns = {
        any: [/^b/i, /^(a|c)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ति[1234]/i,
        wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        // eslint-disable-next-line no-misleading-character-class
        narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
        abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
        wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ज/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^न/i, /^दि/i],
        any: [/^जन/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^नव/i, /^दिस/i]
      };
      var matchDayPatterns = {
        // eslint-disable-next-line no-misleading-character-class
        narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
        short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
        abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
        wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
      };
      var parseDayPatterns = {
        narrow: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],
        any: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
        any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^पूर्वाह्न/i,
          pm: /^अपराह्न/i,
          midnight: /^मध्य/i,
          noon: /^दो/i,
          morning: /सु/i,
          afternoon: /दो/i,
          evening: /शा/i,
          night: /रा/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: _index3.default.localeToNumber
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
          },
          dual: "manje od {{count}} sekunde",
          other: "manje od {{count}} sekundi"
        },
        xSeconds: {
          one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
          },
          dual: "{{count}} sekunde",
          other: "{{count}} sekundi"
        },
        halfAMinute: "pola minute",
        lessThanXMinutes: {
          one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
          },
          dual: "manje od {{count}} minute",
          other: "manje od {{count}} minuta"
        },
        xMinutes: {
          one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
          },
          dual: "{{count}} minute",
          other: "{{count}} minuta"
        },
        aboutXHours: {
          one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
          },
          dual: "oko {{count}} sata",
          other: "oko {{count}} sati"
        },
        xHours: {
          one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
          },
          dual: "{{count}} sata",
          other: "{{count}} sati"
        },
        xDays: {
          one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
          },
          dual: "{{count}} dana",
          other: "{{count}} dana"
        },
        aboutXWeeks: {
          one: {
            standalone: "oko 1 tjedan",
            withPrepositionAgo: "oko 1 tjedan",
            withPrepositionIn: "oko 1 tjedan"
          },
          dual: "oko {{count}} tjedna",
          other: "oko {{count}} tjedana"
        },
        xWeeks: {
          one: {
            standalone: "1 tjedan",
            withPrepositionAgo: "1 tjedan",
            withPrepositionIn: "1 tjedan"
          },
          dual: "{{count}} tjedna",
          other: "{{count}} tjedana"
        },
        aboutXMonths: {
          one: {
            standalone: "oko 1 mjesec",
            withPrepositionAgo: "oko 1 mjesec",
            withPrepositionIn: "oko 1 mjesec"
          },
          dual: "oko {{count}} mjeseca",
          other: "oko {{count}} mjeseci"
        },
        xMonths: {
          one: {
            standalone: "1 mjesec",
            withPrepositionAgo: "1 mjesec",
            withPrepositionIn: "1 mjesec"
          },
          dual: "{{count}} mjeseca",
          other: "{{count}} mjeseci"
        },
        aboutXYears: {
          one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
          },
          dual: "oko {{count}} godine",
          other: "oko {{count}} godina"
        },
        xYears: {
          one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
          },
          dual: "{{count}} godine",
          other: "{{count}} godina"
        },
        overXYears: {
          one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
          },
          dual: "preko {{count}} godine",
          other: "preko {{count}} godina"
        },
        almostXYears: {
          one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
          },
          dual: "gotovo {{count}} godine",
          other: "gotovo {{count}} godina"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              result = formatDistanceLocale[token].one.withPrepositionIn;
            } else {
              result = formatDistanceLocale[token].one.withPrepositionAgo;
            }
          } else {
            result = formatDistanceLocale[token].one.standalone;
          }
        } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
        String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
        ) {
          result = formatDistanceLocale[token].dual.replace("{{count}}", count);
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "za " + result;
          } else {
            return "prije " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d. MMMM y.",
        long: "d. MMMM y.",
        medium: "d. MMM y.",
        short: "dd. MM. y."
      };
      var timeFormats = {
        full: "HH:mm:ss (zzzz)",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'u' {{time}}",
        long: "{{date}} 'u' {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function (date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'pro\u0161lu nedjelju u' p";

            case 3:
              return "'pro\u0161lu srijedu u' p";

            case 6:
              return "'pro\u0161lu subotu u' p";

            default:
              return "'pro\u0161li' EEEE 'u' p";
          }
        },
        yesterday: "'ju\u010Der u' p",
        today: "'danas u' p",
        tomorrow: "'sutra u' p",
        nextWeek: function (date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'idu\u0107u nedjelju u' p";

            case 3:
              return "'idu\u0107u srijedu u' p";

            case 6:
              return "'idu\u0107u subotu u' p";

            default:
              return "'pro\u0161li' EEEE 'u' p";
          }
        },
        other: "P"
      };

      function formatRelative(token, date, _baseDate, _options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return String(number).concat(".");
      }

      var eraValues = {
        narrow: ["pr.n.e.", "AD"],
        abbreviated: ["pr. Kr.", "po. Kr."],
        wide: ["Prije Krista", "Poslije Krista"]
      };
      var monthValues = {
        narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
        abbreviated: ["sij", "velj", "o\u017Eu", "tra", "svi", "lip", "srp", "kol", "ruj", "lis", "stu", "pro"],
        wide: ["sije\u010Danj", "velja\u010Da", "o\u017Eujak", "travanj", "svibanj", "lipanj", "srpanj", "kolovoz", "rujan", "listopad", "studeni", "prosinac"]
      };
      var formattingMonthValues = {
        narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
        abbreviated: ["sij", "velj", "o\u017Eu", "tra", "svi", "lip", "srp", "kol", "ruj", "lis", "stu", "pro"],
        wide: ["sije\u010Dnja", "velja\u010De", "o\u017Eujka", "travnja", "svibnja", "lipnja", "srpnja", "kolovoza", "rujna", "listopada", "studenog", "prosinca"]
      };
      var quarterValues = {
        narrow: ["1.", "2.", "3.", "4."],
        abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
        wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
      };
      var dayValues = {
        narrow: ["N", "P", "U", "S", "\u010C", "P", "S"],
        short: ["ned", "pon", "uto", "sri", "\u010Det", "pet", "sub"],
        abbreviated: ["ned", "pon", "uto", "sri", "\u010Det", "pet", "sub"],
        wide: ["nedjelja", "ponedjeljak", "utorak", "srijeda", "\u010Detvrtak", "petak", "subota"]
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutro",
          afternoon: "popodne",
          evening: "nave\u010Der",
          night: "no\u0107u"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutro",
          afternoon: "popodne",
          evening: "nave\u010Der",
          night: "no\u0107u"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutro",
          afternoon: "poslije podne",
          evening: "nave\u010Der",
          night: "no\u0107u"
        }
      };
      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutro",
          afternoon: "popodne",
          evening: "nave\u010Der",
          night: "no\u0107u"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutro",
          afternoon: "popodne",
          evening: "nave\u010Der",
          night: "no\u0107u"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutro",
          afternoon: "poslije podne",
          evening: "nave\u010Der",
          night: "no\u0107u"
        }
      };
      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)\./i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(pr\.n\.e\.|AD)/i,
        abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
        wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
      };
      var parseEraPatterns = {
        any: [/^pr/i, /^(po|nova)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]\.\s?kv\.?/i,
        wide: /^[1234]\. kvartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(10|11|12|[123456789])\./i,
        abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
        wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
      };
      var parseMonthPatterns = {
        narrow: [/(10|11|12|[123456789])/i],
        abbreviated: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i],
        wide: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i]
      };
      var matchDayPatterns = {
        narrow: /^[npusčc]/i,
        short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
        abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
        wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^pono/i,
          noon: /^pod/i,
          morning: /jutro/i,
          afternoon: /(poslije\s|po)+podne/i,
          evening: /(navece|naveče)/i,
          night: /(nocu|noću)/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "wide"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "mwens pase yon segond",
          other: "mwens pase {{count}} segond"
        },
        xSeconds: {
          one: "1 segond",
          other: "{{count}} segond"
        },
        halfAMinute: "30 segond",
        lessThanXMinutes: {
          one: "mwens pase yon minit",
          other: "mwens pase {{count}} minit"
        },
        xMinutes: {
          one: "1 minit",
          other: "{{count}} minit"
        },
        aboutXHours: {
          one: "anviwon in\xE8",
          other: "anviwon {{count}} \xE8"
        },
        xHours: {
          one: "1 l\xE8",
          other: "{{count}} l\xE8"
        },
        xDays: {
          one: "1 jou",
          other: "{{count}} jou"
        },
        aboutXWeeks: {
          one: "anviwon 1 sem\xE8n",
          other: "anviwon {{count}} sem\xE8n"
        },
        xWeeks: {
          one: "1 sem\xE8n",
          other: "{{count}} sem\xE8n"
        },
        aboutXMonths: {
          one: "anviwon 1 mwa",
          other: "anviwon {{count}} mwa"
        },
        xMonths: {
          one: "1 mwa",
          other: "{{count}} mwa"
        },
        aboutXYears: {
          one: "anviwon 1 an",
          other: "anviwon {{count}} an"
        },
        xYears: {
          one: "1 an",
          other: "{{count}} an"
        },
        overXYears: {
          one: "plis pase 1 an",
          other: "plis pase {{count}} an"
        },
        almostXYears: {
          one: "pr\xE8ske 1 an",
          other: "pr\xE8ske {{count}} an"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "nan " + result;
          } else {
            return "sa f\xE8 " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE d MMMM y",
        long: "d MMMM y",
        medium: "d MMM y",
        short: "dd/MM/y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'nan l\xE8' {{time}}",
        long: "{{date}} 'nan l\xE8' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'pase nan l\xE8' p",
        yesterday: "'y\xE8 nan l\xE8' p",
        today: "'jodi a' p",
        tomorrow: "'demen nan l\xE8' p'",
        nextWeek: "eeee 'pwochen nan l\xE8' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["av. J.-K", "ap. J.-K"],
        abbreviated: ["av. J.-K", "ap. J.-K"],
        wide: ["anvan Jezi Kris", "apre Jezi Kris"]
      };
      var quarterValues = {
        narrow: ["T1", "T2", "T3", "T4"],
        abbreviated: ["1ye trim.", "2y\xE8m trim.", "3y\xE8m trim.", "4y\xE8m trim."],
        wide: ["1ye trim\xE8s", "2y\xE8m trim\xE8s", "3y\xE8m trim\xE8s", "4y\xE8m trim\xE8s"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "O", "S", "O", "N", "D"],
        abbreviated: ["janv.", "fevr.", "mas", "avr.", "me", "jen", "jiy\xE8", "out", "sept.", "okt.", "nov.", "des."],
        wide: ["janvye", "fevrye", "mas", "avril", "me", "jen", "jiy\xE8", "out", "septanm", "okt\xF2b", "novanm", "desanm"]
      };
      var dayValues = {
        narrow: ["D", "L", "M", "M", "J", "V", "S"],
        short: ["di", "le", "ma", "m\xE8", "je", "va", "sa"],
        abbreviated: ["dim.", "len.", "mad.", "m\xE8k.", "jed.", "van.", "sam."],
        wide: ["dimanch", "lendi", "madi", "m\xE8kredi", "jedi", "vandredi", "samdi"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "minwit",
          noon: "midi",
          morning: "mat.",
          afternoon: "ap.m.",
          evening: "swa",
          night: "mat."
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "minwit",
          noon: "midi",
          morning: "maten",
          afternoon: "apr\xE8midi",
          evening: "swa",
          night: "maten"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "minwit",
          noon: "midi",
          morning: "nan maten",
          afternoon: "nan apr\xE8midi",
          evening: "nan asw\xE8",
          night: "nan maten"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber);
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var suffix;

        if (number === 0) {
          return number;
        }

        if (unit === "year" || unit === "hour" || unit === "week") {
          if (number === 1) {
            suffix = "ye";
          } else {
            suffix = "y\xE8m";
          }
        } else {
          if (number === 1) {
            suffix = "ye";
          } else {
            suffix = "y\xE8m";
          }
        }

        return number + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
        abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
        wide: /^(avan Jezi Kris|apre Jezi Kris)/i
      };
      var parseEraPatterns = {
        any: [/^av/i, /^ap/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^t[1234]/i,
        wide: /^[1234](ye|yèm)? trimès/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
        wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^ma/i, /^av/i, /^me/i, /^je/i, /^ji/i, /^ou/i, /^s/i, /^ok/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[lmjvsd]/i,
        short: /^(di|le|ma|me|je|va|sa)/i,
        abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
        wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
        any: [/^di/i, /^le/i, /^ma/i, /^mè/i, /^je/i, /^va/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
        any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^min/i,
          noon: /^mid/i,
          morning: /mat/i,
          afternoon: /ap/i,
          evening: /sw/i,
          night: /nwit/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var translations = {
        about: "k\xF6r\xFClbel\xFCl",
        over: "t\xF6bb mint",
        almost: "majdnem",
        lessthan: "kevesebb mint"
      };
      var withoutSuffixes = {
        xseconds: " m\xE1sodperc",
        halfaminute: "f\xE9l perc",
        xminutes: " perc",
        xhours: " \xF3ra",
        xdays: " nap",
        xweeks: " h\xE9t",
        xmonths: " h\xF3nap",
        xyears: " \xE9v"
      };
      var withSuffixes = {
        xseconds: {
          "-1": " m\xE1sodperccel ezel\u0151tt",
          "1": " m\xE1sodperc m\xFAlva",
          "0": " m\xE1sodperce"
        },
        halfaminute: {
          "-1": "f\xE9l perccel ezel\u0151tt",
          "1": "f\xE9l perc m\xFAlva",
          "0": "f\xE9l perce"
        },
        xminutes: {
          "-1": " perccel ezel\u0151tt",
          "1": " perc m\xFAlva",
          "0": " perce"
        },
        xhours: {
          "-1": " \xF3r\xE1val ezel\u0151tt",
          "1": " \xF3ra m\xFAlva",
          "0": " \xF3r\xE1ja"
        },
        xdays: {
          "-1": " nappal ezel\u0151tt",
          "1": " nap m\xFAlva",
          "0": " napja"
        },
        xweeks: {
          "-1": " h\xE9ttel ezel\u0151tt",
          "1": " h\xE9t m\xFAlva",
          "0": " hete"
        },
        xmonths: {
          "-1": " h\xF3nappal ezel\u0151tt",
          "1": " h\xF3nap m\xFAlva",
          "0": " h\xF3napja"
        },
        xyears: {
          "-1": " \xE9vvel ezel\u0151tt",
          "1": " \xE9v m\xFAlva",
          "0": " \xE9ve"
        }
      };

      function translate(number, addSuffix, key, comparison) {
        var translated = addSuffix ? withSuffixes[key][comparison] : withoutSuffixes[key];

        if (key === "halfaminute") {
          return translated;
        }

        return number + translated;
      }

      function formatDistance(token, count, options) {
        options = options || {};
        var adverb = token.match(/about|over|almost|lessthan/i);
        var unit = token.replace(adverb, "");
        var result;
        result = translate(count, options.addSuffix, unit.toLowerCase(), options.comparison);

        if (adverb) {
          result = translations[adverb[0].toLowerCase()] + " " + result;
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "y. MMMM d., EEEE",
        long: "y. MMMM d.",
        medium: "y. MMM d.",
        short: "y. MM. dd."
      };
      var timeFormats = {
        full: "H:mm:ss zzzz",
        long: "H:mm:ss z",
        medium: "H:mm:ss",
        short: "H:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        long: "{{date}} {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var accusativeWeekdays = ["vas\xE1rnap", "h\xE9tf\u0151n", "kedden", "szerd\xE1n", "cs\xFCt\xF6rt\xF6k\xF6n", "p\xE9nteken", "szombaton"];

      function week(isFuture) {
        return function (date, _baseDate, _options) {
          var day = date.getUTCDay();
          return (isFuture ? "" : "'m\xFAlt' ") + "'" + accusativeWeekdays[day] + "'" + " p'-kor'";
        };
      }

      var formatRelativeLocale = {
        lastWeek: week(false),
        yesterday: "'tegnap' p'-kor'",
        today: "'ma' p'-kor'",
        tomorrow: "'holnap' p'-kor'",
        nextWeek: week(true),
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date, baseDate, options);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["ie.", "isz."],
        abbreviated: ["i. e.", "i. sz."],
        wide: ["Krisztus el\u0151tt", "id\u0151sz\xE1m\xEDt\xE1sunk szerint"]
      };
      var quarterValues = {
        narrow: ["1.", "2.", "3.", "4."],
        abbreviated: ["1. n.\xE9v", "2. n.\xE9v", "3. n.\xE9v", "4. n.\xE9v"],
        wide: ["1. negyed\xE9v", "2. negyed\xE9v", "3. negyed\xE9v", "4. negyed\xE9v"]
      };
      var formattingQuarterValues = {
        narrow: ["I.", "II.", "III.", "IV."],
        abbreviated: ["I. n.\xE9v", "II. n.\xE9v", "III. n.\xE9v", "IV. n.\xE9v"],
        wide: ["I. negyed\xE9v", "II. negyed\xE9v", "III. negyed\xE9v", "IV. negyed\xE9v"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "\xC1", "M", "J", "J", "A", "Sz", "O", "N", "D"],
        abbreviated: ["jan.", "febr.", "m\xE1rc.", "\xE1pr.", "m\xE1j.", "j\xFAn.", "j\xFAl.", "aug.", "szept.", "okt.", "nov.", "dec."],
        wide: ["janu\xE1r", "febru\xE1r", "m\xE1rcius", "\xE1prilis", "m\xE1jus", "j\xFAnius", "j\xFAlius", "augusztus", "szeptember", "okt\xF3ber", "november", "december"]
      };
      var dayValues = {
        narrow: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
        short: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
        abbreviated: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
        wide: ["vas\xE1rnap", "h\xE9tf\u0151", "kedd", "szerda", "cs\xFCt\xF6rt\xF6k", "p\xE9ntek", "szombat"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "de.",
          pm: "du.",
          midnight: "\xE9jf\xE9l",
          noon: "d\xE9l",
          morning: "reggel",
          afternoon: "du.",
          evening: "este",
          night: "\xE9jjel"
        },
        abbreviated: {
          am: "de.",
          pm: "du.",
          midnight: "\xE9jf\xE9l",
          noon: "d\xE9l",
          morning: "reggel",
          afternoon: "du.",
          evening: "este",
          night: "\xE9jjel"
        },
        wide: {
          am: "de.",
          pm: "du.",
          midnight: "\xE9jf\xE9l",
          noon: "d\xE9l",
          morning: "reggel",
          afternoon: "d\xE9lut\xE1n",
          evening: "este",
          night: "\xE9jjel"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + ".";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          formattingValues: formattingQuarterValues,
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)\.?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ie\.|isz\.)/i,
        abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
        wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
      };
      var parseEraPatterns = {
        narrow: [/ie/i, /isz/i],
        abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
        any: [/előtt/i, /(szerint|i. sz.)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]\.?/i,
        abbreviated: /^[1234]?\.?\s?n\.év/i,
        wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
      };
      var parseQuarterPatterns = {
        any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmaásond]|sz/i,
        abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
        wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a|á/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s|sz/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^már/i, /^áp/i, /^máj/i, /^jún/i, /^júl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^([vhkpc]|sz|cs|sz)/i,
        short: /^([vhkp]|sze|cs|szo)/i,
        abbreviated: /^([vhkp]|sze|cs|szo)/i,
        wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
      };
      var parseDayPatterns = {
        narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
        any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
      };
      var matchDayPeriodPatterns = {
        any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^de\.?/i,
          pm: /^du\.?/i,
          midnight: /^éjf/i,
          noon: /^dé/i,
          morning: /reg/i,
          afternoon: /^délu\.?/i,
          evening: /es/i,
          night: /éjj/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
          other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
        },
        xSeconds: {
          one: "1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
          other: "{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
        },
        halfAMinute: "\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
        lessThanXMinutes: {
          one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
          other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
        },
        xMinutes: {
          one: "1 \u0580\u0578\u057A\u0565",
          other: "{{count}} \u0580\u0578\u057A\u0565"
        },
        aboutXHours: {
          one: "\u0574\u0578\u057F 1 \u056A\u0561\u0574",
          other: "\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
        },
        xHours: {
          one: "1 \u056A\u0561\u0574",
          other: "{{count}} \u056A\u0561\u0574"
        },
        xDays: {
          one: "1 \u0585\u0580",
          other: "{{count}} \u0585\u0580"
        },
        aboutXWeeks: {
          one: "\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
          other: "\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
        },
        xWeeks: {
          one: "1 \u0577\u0561\u0562\u0561\u0569",
          other: "{{count}} \u0577\u0561\u0562\u0561\u0569"
        },
        aboutXMonths: {
          one: "\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
          other: "\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
        },
        xMonths: {
          one: "1 \u0561\u0574\u056B\u057D",
          other: "{{count}} \u0561\u0574\u056B\u057D"
        },
        aboutXYears: {
          one: "\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
          other: "\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
        },
        xYears: {
          one: "1 \u057F\u0561\u0580\u056B",
          other: "{{count}} \u057F\u0561\u0580\u056B"
        },
        overXYears: {
          one: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
          other: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
        },
        almostXYears: {
          one: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
          other: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + " \u0570\u0565\u057F\u0578";
          } else {
            return result + " \u0561\u057C\u0561\u057B";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "d MMMM, y, EEEE",
        long: "d MMMM, y",
        medium: "d MMM, y",
        short: "dd.MM.yyyy"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} '\u056A\u2024'{{time}}",
        long: "{{date}} '\u056A\u2024'{{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
        yesterday: "'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
        today: "'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
        tomorrow: "'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
        nextWeek: "'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u0554", "\u0544"],
        abbreviated: ["\u0554\u0531", "\u0544\u0539"],
        wide: ["\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B", "\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["\u05541", "\u05542", "\u05543", "\u05544"],
        wide: ["1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564", "2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564", "3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564", "4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"]
      };
      var monthValues = {
        narrow: ["\u0540", "\u0553", "\u0544", "\u0531", "\u0544", "\u0540", "\u0540", "\u0555", "\u054D", "\u0540", "\u0546", "\u0534"],
        abbreviated: ["\u0570\u0578\u0582\u0576", "\u0583\u0565\u057F", "\u0574\u0561\u0580", "\u0561\u057A\u0580", "\u0574\u0561\u0575", "\u0570\u0578\u0582\u0576", "\u0570\u0578\u0582\u056C", "\u0585\u0563\u057D", "\u057D\u0565\u057A", "\u0570\u0578\u056F", "\u0576\u0578\u0575", "\u0564\u0565\u056F"],
        wide: ["\u0570\u0578\u0582\u0576\u057E\u0561\u0580", "\u0583\u0565\u057F\u0580\u057E\u0561\u0580", "\u0574\u0561\u0580\u057F", "\u0561\u057A\u0580\u056B\u056C", "\u0574\u0561\u0575\u056B\u057D", "\u0570\u0578\u0582\u0576\u056B\u057D", "\u0570\u0578\u0582\u056C\u056B\u057D", "\u0585\u0563\u0578\u057D\u057F\u0578\u057D", "\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580", "\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580", "\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580", "\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"]
      };
      var dayValues = {
        narrow: ["\u053F", "\u0535", "\u0535", "\u0549", "\u0540", "\u0548", "\u0547"],
        short: ["\u056F\u0580", "\u0565\u0580", "\u0565\u0584", "\u0579\u0584", "\u0570\u0563", "\u0578\u0582\u0580", "\u0577\u0562"],
        abbreviated: ["\u056F\u056B\u0580", "\u0565\u0580\u056F", "\u0565\u0580\u0584", "\u0579\u0578\u0580", "\u0570\u0576\u0563", "\u0578\u0582\u0580\u0562", "\u0577\u0561\u0562"],
        wide: ["\u056F\u056B\u0580\u0561\u056F\u056B", "\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B", "\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B", "\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B", "\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B", "\u0578\u0582\u0580\u0562\u0561\u0569", "\u0577\u0561\u0562\u0561\u0569"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "\u056F\u0565\u057D\u0563\u0577",
          noon: "\u056F\u0565\u057D\u0585\u0580",
          morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
          afternoon: "\u0581\u0565\u0580\u0565\u056F",
          evening: "\u0565\u0580\u0565\u056F\u0578",
          night: "\u0563\u056B\u0577\u0565\u0580"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
          noon: "\u056F\u0565\u057D\u0585\u0580",
          morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
          afternoon: "\u0581\u0565\u0580\u0565\u056F",
          evening: "\u0565\u0580\u0565\u056F\u0578",
          night: "\u0563\u056B\u0577\u0565\u0580"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
          noon: "\u056F\u0565\u057D\u0585\u0580",
          morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
          afternoon: "\u0581\u0565\u0580\u0565\u056F",
          evening: "\u0565\u0580\u0565\u056F\u0578",
          night: "\u0563\u056B\u0577\u0565\u0580"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "\u056F\u0565\u057D\u0563\u0577",
          noon: "\u056F\u0565\u057D\u0585\u0580",
          morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
          afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
          evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
          night: "\u0563\u056B\u0577\u0565\u0580\u0568"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
          noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
          morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
          afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
          evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
          night: "\u0563\u056B\u0577\u0565\u0580\u0568"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
          noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
          morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
          afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
          evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
          night: "\u0563\u056B\u0577\u0565\u0580\u0568"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        var rem100 = number % 100;

        if (rem100 < 10) {
          if (rem100 % 10 === 1) {
            return number + "\u058A\u056B\u0576";
          }
        }

        return number + "\u058A\u0580\u0564";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(Ք|Մ)/i,
        abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
        wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
      };
      var parseEraPatterns = {
        any: [/^(ք|մ)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ք[1234]/i,
        wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[հփմաօսնդ]/i,
        abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
        wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
      };
      var parseMonthPatterns = {
        narrow: [/^հ/i, /^փ/i, /^մ/i, /^ա/i, /^մ/i, /^հ/i, /^հ/i, /^օ/i, /^ս/i, /^հ/i, /^ն/i, /^դ/i],
        any: [/^հու/i, /^փ/i, /^մար/i, /^ա/i, /^մայ/i, /^հուն/i, /^հուլ/i, /^օ/i, /^ս/i, /^հոկ/i, /^ն/i, /^դ/i]
      };
      var matchDayPatterns = {
        narrow: /^[եչհոշկ]/i,
        short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
        abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
        wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
      };
      var parseDayPatterns = {
        narrow: [/^կ/i, /^ե/i, /^ե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
        short: [/^կ/i, /^եր/i, /^եք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
        abbreviated: [/^կ/i, /^երկ/i, /^երք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
        wide: [/^կ/i, /^երկ/i, /^երե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
        any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /կեսգիշեր/i,
          noon: /կեսօր/i,
          morning: /առավոտ/i,
          afternoon: /ցերեկ/i,
          evening: /երեկո/i,
          night: /գիշեր/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "kurang dari 1 detik",
          other: "kurang dari {{count}} detik"
        },
        xSeconds: {
          one: "1 detik",
          other: "{{count}} detik"
        },
        halfAMinute: "setengah menit",
        lessThanXMinutes: {
          one: "kurang dari 1 menit",
          other: "kurang dari {{count}} menit"
        },
        xMinutes: {
          one: "1 menit",
          other: "{{count}} menit"
        },
        aboutXHours: {
          one: "sekitar 1 jam",
          other: "sekitar {{count}} jam"
        },
        xHours: {
          one: "1 jam",
          other: "{{count}} jam"
        },
        xDays: {
          one: "1 hari",
          other: "{{count}} hari"
        },
        aboutXWeeks: {
          one: "sekitar 1 minggu",
          other: "sekitar {{count}} minggu"
        },
        xWeeks: {
          one: "1 minggu",
          other: "{{count}} minggu"
        },
        aboutXMonths: {
          one: "sekitar 1 bulan",
          other: "sekitar {{count}} bulan"
        },
        xMonths: {
          one: "1 bulan",
          other: "{{count}} bulan"
        },
        aboutXYears: {
          one: "sekitar 1 tahun",
          other: "sekitar {{count}} tahun"
        },
        xYears: {
          one: "1 tahun",
          other: "{{count}} tahun"
        },
        overXYears: {
          one: "lebih dari 1 tahun",
          other: "lebih dari {{count}} tahun"
        },
        almostXYears: {
          one: "hampir 1 tahun",
          other: "hampir {{count}} tahun"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "dalam waktu " + result;
          } else {
            return result + " yang lalu";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM yyyy",
        long: "d MMMM yyyy",
        medium: "d MMM yyyy",
        short: "d/M/yyyy"
      };
      var timeFormats = {
        full: "HH.mm.ss",
        long: "HH.mm.ss",
        medium: "HH.mm",
        short: "HH.mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'pukul' {{time}}",
        long: "{{date}} 'pukul' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'lalu pukul' p",
        yesterday: "'Kemarin pukul' p",
        today: "'Hari ini pukul' p",
        tomorrow: "'Besok pukul' p",
        nextWeek: "eeee 'pukul' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // All data for localization are taken from this page
      // https://www.unicode.org/cldr/charts/32/summary/id.html


      var eraValues = {
        narrow: ["SM", "M"],
        abbreviated: ["SM", "M"],
        wide: ["Sebelum Masehi", "Masehi"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["K1", "K2", "K3", "K4"],
        wide: ["Kuartal ke-1", "Kuartal ke-2", "Kuartal ke-3", "Kuartal ke-4"]
      }; // Note: in Indonesian, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Ags", "Sep", "Okt", "Nov", "Des"],
        wide: ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
      };
      var dayValues = {
        narrow: ["M", "S", "S", "R", "K", "J", "S"],
        short: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
        abbreviated: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
        wide: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "tengah malam",
          noon: "tengah hari",
          morning: "pagi",
          afternoon: "siang",
          evening: "sore",
          night: "malam"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "tengah malam",
          noon: "tengah hari",
          morning: "pagi",
          afternoon: "siang",
          evening: "sore",
          night: "malam"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "tengah malam",
          noon: "tengah hari",
          morning: "pagi",
          afternoon: "siang",
          evening: "sore",
          night: "malam"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "tengah malam",
          noon: "tengah hari",
          morning: "pagi",
          afternoon: "siang",
          evening: "sore",
          night: "malam"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "tengah malam",
          noon: "tengah hari",
          morning: "pagi",
          afternoon: "siang",
          evening: "sore",
          night: "malam"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "tengah malam",
          noon: "tengah hari",
          morning: "pagi",
          afternoon: "siang",
          evening: "sore",
          night: "malam"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // Can't use "pertama", "kedua" because can't be parsed

        switch (number) {
          default:
            return "ke-" + number;
        }
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(sm|m)/i,
        abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
        wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
      };
      var parseEraPatterns = {
        any: [/^s/i, /^(m|e)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^K-?\s[1234]/i,
        wide: /^Kuartal ke-?\s?[1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
        wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[srkjm]/i,
        short: /^(min|sen|sel|rab|kam|jum|sab)/i,
        abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
        wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
      };
      var parseDayPatterns = {
        narrow: [/^m/i, /^s/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
        any: [/^m/i, /^sen/i, /^sel/i, /^r/i, /^k/i, /^j/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
        any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^pm/i,
          midnight: /^tengah m/i,
          noon: /^tengah h/i,
          morning: /pagi/i,
          afternoon: /siang/i,
          evening: /sore/i,
          night: /malam/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "minna en 1 sek\xFAnda",
          other: "minna en {{count}} sek\xFAndur"
        },
        xSeconds: {
          one: "1 sek\xFAnda",
          other: "{{count}} sek\xFAndur"
        },
        halfAMinute: "h\xE1lf m\xEDn\xFAta",
        lessThanXMinutes: {
          one: "minna en 1 m\xEDn\xFAta",
          other: "minna en {{count}} m\xEDn\xFAtur"
        },
        xMinutes: {
          one: "1 m\xEDn\xFAta",
          other: "{{count}} m\xEDn\xFAtur"
        },
        aboutXHours: {
          one: "u.\xFE.b. 1 klukkustund",
          other: "u.\xFE.b. {{count}} klukkustundir"
        },
        xHours: {
          one: "1 klukkustund",
          other: "{{count}} klukkustundir"
        },
        xDays: {
          one: "1 dagur",
          other: "{{count}} dagar"
        },
        aboutXWeeks: {
          one: "um viku",
          other: "um {{count}} vikur"
        },
        xWeeks: {
          one: "1 viku",
          other: "{{count}} vikur"
        },
        aboutXMonths: {
          one: "u.\xFE.b. 1 m\xE1nu\xF0ur",
          other: "u.\xFE.b. {{count}} m\xE1nu\xF0ir"
        },
        xMonths: {
          one: "1 m\xE1nu\xF0ur",
          other: "{{count}} m\xE1nu\xF0ir"
        },
        aboutXYears: {
          one: "u.\xFE.b. 1 \xE1r",
          other: "u.\xFE.b. {{count}} \xE1r"
        },
        xYears: {
          one: "1 \xE1r",
          other: "{{count}} \xE1r"
        },
        overXYears: {
          one: "meira en 1 \xE1r",
          other: "meira en {{count}} \xE1r"
        },
        almostXYears: {
          one: "n\xE6stum 1 \xE1r",
          other: "n\xE6stum {{count}} \xE1r"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "\xED " + result;
          } else {
            return result + " s\xED\xF0an";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, do MMMM y",
        long: "do MMMM y",
        medium: "do MMM y",
        short: "d.MM.y"
      };
      var timeFormats = {
        full: "'kl'. HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'kl.' {{time}}",
        long: "{{date}} 'kl.' {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'s\xED\xF0asta' dddd 'kl.' p",
        yesterday: "'\xED g\xE6r kl.' p",
        today: "'\xED dag kl.' p",
        tomorrow: "'\xE1 morgun kl.' p",
        nextWeek: "dddd 'kl.' p",
        other: "L"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["f.Kr.", "e.Kr."],
        abbreviated: ["f.Kr.", "e.Kr."],
        wide: ["fyrir Krist", "eftir Krist"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1F", "2F", "3F", "4F"],
        wide: ["1. fj\xF3r\xF0ungur", "2. fj\xF3r\xF0ungur", "3. fj\xF3r\xF0ungur", "4. fj\xF3r\xF0ungur"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "\xC1", "S", "\xD3", "N", "D"],
        abbreviated: ["jan.", "feb.", "mars", "apr\xEDl", "ma\xED", "j\xFAn\xED", "j\xFAl\xED", "\xE1g\xFAst", "sept.", "okt.", "n\xF3v.", "des."],
        wide: ["jan\xFAar", "febr\xFAar", "mars", "apr\xEDl", "ma\xED", "j\xFAn\xED", "j\xFAl\xED", "\xE1g\xFAst", "september", "okt\xF3ber", "n\xF3vember", "desember"]
      };
      var dayValues = {
        narrow: ["S", "M", "\xDE", "M", "F", "F", "L"],
        short: ["Su", "M\xE1", "\xDEr", "Mi", "Fi", "F\xF6", "La"],
        abbreviated: ["sun.", "m\xE1n.", "\xFEri.", "mi\xF0.", "fim.", "f\xF6s.", "lau"],
        wide: ["sunnudagur", "m\xE1nudagur", "\xFEri\xF0judagur", "mi\xF0vikudagur", "fimmtudagur", "f\xF6studagur", "laugardagur"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "f",
          pm: "e",
          midnight: "mi\xF0n\xE6tti",
          noon: "h\xE1degi",
          morning: "morgunn",
          afternoon: "s\xED\xF0degi",
          evening: "kv\xF6ld",
          night: "n\xF3tt"
        },
        abbreviated: {
          am: "f.h.",
          pm: "e.h.",
          midnight: "mi\xF0n\xE6tti",
          noon: "h\xE1degi",
          morning: "morgunn",
          afternoon: "s\xED\xF0degi",
          evening: "kv\xF6ld",
          night: "n\xF3tt"
        },
        wide: {
          am: "fyrir h\xE1degi",
          pm: "eftir h\xE1degi",
          midnight: "mi\xF0n\xE6tti",
          noon: "h\xE1degi",
          morning: "morgunn",
          afternoon: "s\xED\xF0degi",
          evening: "kv\xF6ld",
          night: "n\xF3tt"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "f",
          pm: "e",
          midnight: "\xE1 mi\xF0n\xE6tti",
          noon: "\xE1 h\xE1degi",
          morning: "a\xF0 morgni",
          afternoon: "s\xED\xF0degis",
          evening: "um kv\xF6ld",
          night: "um n\xF3tt"
        },
        abbreviated: {
          am: "f.h.",
          pm: "e.h.",
          midnight: "\xE1 mi\xF0n\xE6tti",
          noon: "\xE1 h\xE1degi",
          morning: "a\xF0 morgni",
          afternoon: "s\xED\xF0degis",
          evening: "um kv\xF6ld",
          night: "um n\xF3tt"
        },
        wide: {
          am: "fyrir h\xE1degi",
          pm: "eftir h\xE1degi",
          midnight: "\xE1 mi\xF0n\xE6tti",
          noon: "\xE1 h\xE1degi",
          morning: "a\xF0 morgni",
          afternoon: "s\xED\xF0degis",
          evening: "um kv\xF6ld",
          night: "um n\xF3tt"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + ".";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(f\.Kr\.|e\.Kr\.)/i,
        abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
        wide: /^(fyrir Krist|eftir Krist)/i
      };
      var parseEraPatterns = {
        any: [/^(f\.Kr\.|e\.Kr\.)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234] fjórðungur/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmásónd]/i,
        abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
        wide: /^(januar|februar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^á/i, /^s/i, /^ó/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maí/i, /^jún/i, /^júl/i, /^áu/i, /^s/i, /^ó/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtwf]/i,
        short: /^(su|má|þr|mi|fi|fö|la)/i,
        abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
        wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^þ/i, /^m/i, /^f/i, /^f/i, /^l/i],
        any: [/^su/i, /^má/i, /^þr/i, /^mi/i, /^fi/i, /^fö/i, /^la/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
        any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^f/i,
          pm: /^e/i,
          midnight: /^mi/i,
          noon: /^há/i,
          morning: /morgunn/i,
          afternoon: /síðdegi/i,
          evening: /kvöld/i,
          night: /nótt/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "meno di un secondo",
          other: "meno di {{count}} secondi"
        },
        xSeconds: {
          one: "un secondo",
          other: "{{count}} secondi"
        },
        halfAMinute: "alcuni secondi",
        lessThanXMinutes: {
          one: "meno di un minuto",
          other: "meno di {{count}} minuti"
        },
        xMinutes: {
          one: "un minuto",
          other: "{{count}} minuti"
        },
        aboutXHours: {
          one: "circa un'ora",
          other: "circa {{count}} ore"
        },
        xHours: {
          one: "un'ora",
          other: "{{count}} ore"
        },
        xDays: {
          one: "un giorno",
          other: "{{count}} giorni"
        },
        aboutXWeeks: {
          one: "circa una settimana",
          other: "circa {{count}} settimane"
        },
        xWeeks: {
          one: "una settimana",
          other: "{{count}} settimane"
        },
        aboutXMonths: {
          one: "circa un mese",
          other: "circa {{count}} mesi"
        },
        xMonths: {
          one: "un mese",
          other: "{{count}} mesi"
        },
        aboutXYears: {
          one: "circa un anno",
          other: "circa {{count}} anni"
        },
        xYears: {
          one: "un anno",
          other: "{{count}} anni"
        },
        overXYears: {
          one: "pi\xF9 di un anno",
          other: "pi\xF9 di {{count}} anni"
        },
        almostXYears: {
          one: "quasi un anno",
          other: "quasi {{count}} anni"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "tra " + result;
          } else {
            return result + " fa";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE d MMMM y",
        long: "d MMMM y",
        medium: "d MMM y",
        short: "dd/MM/y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        long: "{{date}} {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;

      var _index = _interopRequireDefault(__webpack_require__(8));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var weekdays = ["domenica", "luned\xEC", "marted\xEC", "mercoled\xEC", "gioved\xEC", "venerd\xEC", "sabato"];

      function lastWeek(day) {
        switch (day) {
          case 0:
            return "'domenica scorsa alle' p";

          default:
            return "'" + weekdays[day] + " scorso alle' p";
        }
      }

      function thisWeek(day) {
        return "'" + weekdays[day] + " alle' p";
      }

      function nextWeek(day) {
        switch (day) {
          case 0:
            return "'domenica prossima alle' p";

          default:
            return "'" + weekdays[day] + " prossimo alle' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return lastWeek(day);
          }
        },
        yesterday: "'ieri alle' p",
        today: "'oggi alle' p",
        tomorrow: "'domani alle' p",
        nextWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return nextWeek(day);
          }
        },
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date, baseDate, options);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["aC", "dC"],
        abbreviated: ["a.C.", "d.C."],
        wide: ["avanti Cristo", "dopo Cristo"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["T1", "T2", "T3", "T4"],
        wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
      };
      var monthValues = {
        narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
        abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
        wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
      };
      var dayValues = {
        narrow: ["D", "L", "M", "M", "G", "V", "S"],
        short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
        abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
        wide: ["domenica", "luned\xEC", "marted\xEC", "mercoled\xEC", "gioved\xEC", "venerd\xEC", "sabato"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "m.",
          pm: "p.",
          midnight: "mezzanotte",
          noon: "mezzogiorno",
          morning: "mattina",
          afternoon: "pomeriggio",
          evening: "sera",
          night: "notte"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "mezzanotte",
          noon: "mezzogiorno",
          morning: "mattina",
          afternoon: "pomeriggio",
          evening: "sera",
          night: "notte"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "mezzanotte",
          noon: "mezzogiorno",
          morning: "mattina",
          afternoon: "pomeriggio",
          evening: "sera",
          night: "notte"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "m.",
          pm: "p.",
          midnight: "mezzanotte",
          noon: "mezzogiorno",
          morning: "di mattina",
          afternoon: "del pomeriggio",
          evening: "di sera",
          night: "di notte"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "mezzanotte",
          noon: "mezzogiorno",
          morning: "di mattina",
          afternoon: "del pomeriggio",
          evening: "di sera",
          night: "di notte"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "mezzanotte",
          noon: "mezzogiorno",
          morning: "di mattina",
          afternoon: "del pomeriggio",
          evening: "di sera",
          night: "di notte"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + "\xBA";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(aC|dC)/i,
        abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
        wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
      };
      var parseEraPatterns = {
        any: [/^a/i, /^(d|e)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^t[1234]/i,
        wide: /^[1234](º)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[gfmalsond]/i,
        abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
        wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
      };
      var parseMonthPatterns = {
        narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[dlmgvs]/i,
        short: /^(do|lu|ma|me|gi|ve|sa)/i,
        abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
        wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
        any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
        any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mezza/i,
          noon: /^mezzo/i,
          morning: /mattina/i,
          afternoon: /pomeriggio/i,
          evening: /sera/i,
          night: /notte/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "1\u3073\u3087\u3046\u307F\u307E\u3093",
          other: "{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
          oneWithSuffix: "\u3084\u304F1\u3073\u3087\u3046",
          otherWithSuffix: "\u3084\u304F{{count}}\u3073\u3087\u3046"
        },
        xSeconds: {
          one: "1\u3073\u3087\u3046",
          other: "{{count}}\u3073\u3087\u3046"
        },
        halfAMinute: "30\u3073\u3087\u3046",
        lessThanXMinutes: {
          one: "1\u3077\u3093\u307F\u307E\u3093",
          other: "{{count}}\u3075\u3093\u307F\u307E\u3093",
          oneWithSuffix: "\u3084\u304F1\u3077\u3093",
          otherWithSuffix: "\u3084\u304F{{count}}\u3075\u3093"
        },
        xMinutes: {
          one: "1\u3077\u3093",
          other: "{{count}}\u3075\u3093"
        },
        aboutXHours: {
          one: "\u3084\u304F1\u3058\u304B\u3093",
          other: "\u3084\u304F{{count}}\u3058\u304B\u3093"
        },
        xHours: {
          one: "1\u3058\u304B\u3093",
          other: "{{count}}\u3058\u304B\u3093"
        },
        xDays: {
          one: "1\u306B\u3061",
          other: "{{count}}\u306B\u3061"
        },
        aboutXWeeks: {
          one: "\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
          other: "\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
        },
        xWeeks: {
          one: "1\u3057\u3085\u3046\u304B\u3093",
          other: "{{count}}\u3057\u3085\u3046\u304B\u3093"
        },
        aboutXMonths: {
          one: "\u3084\u304F1\u304B\u3052\u3064",
          other: "\u3084\u304F{{count}}\u304B\u3052\u3064"
        },
        xMonths: {
          one: "1\u304B\u3052\u3064",
          other: "{{count}}\u304B\u3052\u3064"
        },
        aboutXYears: {
          one: "\u3084\u304F1\u306D\u3093",
          other: "\u3084\u304F{{count}}\u306D\u3093"
        },
        xYears: {
          one: "1\u306D\u3093",
          other: "{{count}}\u306D\u3093"
        },
        overXYears: {
          one: "1\u306D\u3093\u3044\u3058\u3087\u3046",
          other: "{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
        },
        almostXYears: {
          one: "1\u306D\u3093\u3061\u304B\u304F",
          other: "{{count}}\u306D\u3093\u3061\u304B\u304F"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          if (options.addSuffix && formatDistanceLocale[token].oneWithSuffix) {
            result = formatDistanceLocale[token].oneWithSuffix;
          } else {
            result = formatDistanceLocale[token].one;
          }
        } else {
          if (options.addSuffix && formatDistanceLocale[token].otherWithSuffix) {
            result = formatDistanceLocale[token].otherWithSuffix.replace("{{count}}", count);
          } else {
            result = formatDistanceLocale[token].other.replace("{{count}}", count);
          }
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + "\u3042\u3068";
          } else {
            return result + "\u307E\u3048";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
        long: "y\u306D\u3093M\u304C\u3064d\u306B\u3061",
        medium: "y/MM/dd",
        short: "y/MM/dd"
      };
      var timeFormats = {
        full: "H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
        long: "H:mm:ss z",
        medium: "H:mm:ss",
        short: "H:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        long: "{{date}} {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
        yesterday: "\u304D\u306E\u3046\u306Ep",
        today: "\u304D\u3087\u3046\u306Ep",
        tomorrow: "\u3042\u3057\u305F\u306Ep",
        nextWeek: "\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["BC", "AC"],
        abbreviated: ["\u304D\u3052\u3093\u305C\u3093", "\u305B\u3044\u308C\u304D"],
        wide: ["\u304D\u3052\u3093\u305C\u3093", "\u305B\u3044\u308C\u304D"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["\u3060\u30441\u3057\u306F\u3093\u304D", "\u3060\u30442\u3057\u306F\u3093\u304D", "\u3060\u30443\u3057\u306F\u3093\u304D", "\u3060\u30444\u3057\u306F\u3093\u304D"]
      };
      var monthValues = {
        narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
        abbreviated: ["1\u304C\u3064", "2\u304C\u3064", "3\u304C\u3064", "4\u304C\u3064", "5\u304C\u3064", "6\u304C\u3064", "7\u304C\u3064", "8\u304C\u3064", "9\u304C\u3064", "10\u304C\u3064", "11\u304C\u3064", "12\u304C\u3064"],
        wide: ["1\u304C\u3064", "2\u304C\u3064", "3\u304C\u3064", "4\u304C\u3064", "5\u304C\u3064", "6\u304C\u3064", "7\u304C\u3064", "8\u304C\u3064", "9\u304C\u3064", "10\u304C\u3064", "11\u304C\u3064", "12\u304C\u3064"]
      };
      var dayValues = {
        narrow: ["\u306B\u3061", "\u3052\u3064", "\u304B", "\u3059\u3044", "\u3082\u304F", "\u304D\u3093", "\u3069"],
        short: ["\u306B\u3061", "\u3052\u3064", "\u304B", "\u3059\u3044", "\u3082\u304F", "\u304D\u3093", "\u3069"],
        abbreviated: ["\u306B\u3061", "\u3052\u3064", "\u304B", "\u3059\u3044", "\u3082\u304F", "\u304D\u3093", "\u3069"],
        wide: ["\u306B\u3061\u3088\u3046\u3073", "\u3052\u3064\u3088\u3046\u3073", "\u304B\u3088\u3046\u3073", "\u3059\u3044\u3088\u3046\u3073", "\u3082\u304F\u3088\u3046\u3073", "\u304D\u3093\u3088\u3046\u3073", "\u3069\u3088\u3046\u3073"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u3054\u305C\u3093",
          pm: "\u3054\u3054",
          midnight: "\u3057\u3093\u3084",
          noon: "\u3057\u3087\u3046\u3054",
          morning: "\u3042\u3055",
          afternoon: "\u3054\u3054",
          evening: "\u3088\u308B",
          night: "\u3057\u3093\u3084"
        },
        abbreviated: {
          am: "\u3054\u305C\u3093",
          pm: "\u3054\u3054",
          midnight: "\u3057\u3093\u3084",
          noon: "\u3057\u3087\u3046\u3054",
          morning: "\u3042\u3055",
          afternoon: "\u3054\u3054",
          evening: "\u3088\u308B",
          night: "\u3057\u3093\u3084"
        },
        wide: {
          am: "\u3054\u305C\u3093",
          pm: "\u3054\u3054",
          midnight: "\u3057\u3093\u3084",
          noon: "\u3057\u3087\u3046\u3054",
          morning: "\u3042\u3055",
          afternoon: "\u3054\u3054",
          evening: "\u3088\u308B",
          night: "\u3057\u3093\u3084"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u3054\u305C\u3093",
          pm: "\u3054\u3054",
          midnight: "\u3057\u3093\u3084",
          noon: "\u3057\u3087\u3046\u3054",
          morning: "\u3042\u3055",
          afternoon: "\u3054\u3054",
          evening: "\u3088\u308B",
          night: "\u3057\u3093\u3084"
        },
        abbreviated: {
          am: "\u3054\u305C\u3093",
          pm: "\u3054\u3054",
          midnight: "\u3057\u3093\u3084",
          noon: "\u3057\u3087\u3046\u3054",
          morning: "\u3042\u3055",
          afternoon: "\u3054\u3054",
          evening: "\u3088\u308B",
          night: "\u3057\u3093\u3084"
        },
        wide: {
          am: "\u3054\u305C\u3093",
          pm: "\u3054\u3054",
          midnight: "\u3057\u3093\u3084",
          noon: "\u3057\u3087\u3046\u3054",
          morning: "\u3042\u3055",
          afternoon: "\u3054\u3054",
          evening: "\u3088\u308B",
          night: "\u3057\u3093\u3084"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        var options = dirtyOptions || {};
        var unit = String(options.unit);

        switch (unit) {
          case "year":
            return "".concat(number, "\u306D\u3093");

          case "quarter":
            return "\u3060\u3044".concat(number, "\u3057\u306F\u3093\u304D");

          case "month":
            return "".concat(number, "\u304C\u3064");

          case "week":
            return "\u3060\u3044".concat(number, "\u3057\u3085\u3046");

          case "date":
            return "".concat(number, "\u306B\u3061");

          case "hour":
            return "".concat(number, "\u3058");

          case "minute":
            return "".concat(number, "\u3075\u3093");

          case "second":
            return "".concat(number, "\u3073\u3087\u3046");

          default:
            return "".concat(number);
        }
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(B\.?C\.?|A\.?D\.?)/i,
        abbreviated: /^(きげん[前後]|せいれき)/i,
        wide: /^(きげん[前後]|せいれき)/i
      };
      var parseEraPatterns = {
        narrow: [/^B/i, /^A/i],
        any: [/^(きげんぜん)/i, /^(せいれき|きげんご)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^Q[1234]/i,
        wide: /^だい[1234一二三四１２３４]しはんき/i
      };
      var parseQuarterPatterns = {
        any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
      };
      var matchMonthPatterns = {
        narrow: /^([123456789]|1[012])/,
        abbreviated: /^([123456789]|1[012])がつ/i,
        wide: /^([123456789]|1[012])がつ/i
      };
      var parseMonthPatterns = {
        any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
      };
      var matchDayPatterns = {
        narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
        short: /^(にち|げつ|か|すい|もく|きん|ど)/,
        abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
        wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
      };
      var parseDayPatterns = {
        any: [/^にち/, /^げつ/, /^か/, /^すい/, /^もく/, /^きん/, /^ど/]
      };
      var matchDayPeriodPatterns = {
        any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^(A|ごぜん)/i,
          pm: /^(P|ごご)/i,
          midnight: /^しんや|まよなか/i,
          noon: /^しょうご/i,
          morning: /^あさ/i,
          afternoon: /^ごご/i,
          evening: /^よる/i,
          night: /^しんや/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "1\u79D2\u672A\u6E80",
          other: "{{count}}\u79D2\u672A\u6E80",
          oneWithSuffix: "\u7D041\u79D2",
          otherWithSuffix: "\u7D04{{count}}\u79D2"
        },
        xSeconds: {
          one: "1\u79D2",
          other: "{{count}}\u79D2"
        },
        halfAMinute: "30\u79D2",
        lessThanXMinutes: {
          one: "1\u5206\u672A\u6E80",
          other: "{{count}}\u5206\u672A\u6E80",
          oneWithSuffix: "\u7D041\u5206",
          otherWithSuffix: "\u7D04{{count}}\u5206"
        },
        xMinutes: {
          one: "1\u5206",
          other: "{{count}}\u5206"
        },
        aboutXHours: {
          one: "\u7D041\u6642\u9593",
          other: "\u7D04{{count}}\u6642\u9593"
        },
        xHours: {
          one: "1\u6642\u9593",
          other: "{{count}}\u6642\u9593"
        },
        xDays: {
          one: "1\u65E5",
          other: "{{count}}\u65E5"
        },
        aboutXWeeks: {
          one: "\u7D041\u9031\u9593",
          other: "\u7D04{{count}}\u9031\u9593"
        },
        xWeeks: {
          one: "1\u9031\u9593",
          other: "{{count}}\u9031\u9593"
        },
        aboutXMonths: {
          one: "\u7D041\u304B\u6708",
          other: "\u7D04{{count}}\u304B\u6708"
        },
        xMonths: {
          one: "1\u304B\u6708",
          other: "{{count}}\u304B\u6708"
        },
        aboutXYears: {
          one: "\u7D041\u5E74",
          other: "\u7D04{{count}}\u5E74"
        },
        xYears: {
          one: "1\u5E74",
          other: "{{count}}\u5E74"
        },
        overXYears: {
          one: "1\u5E74\u4EE5\u4E0A",
          other: "{{count}}\u5E74\u4EE5\u4E0A"
        },
        almostXYears: {
          one: "1\u5E74\u8FD1\u304F",
          other: "{{count}}\u5E74\u8FD1\u304F"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          if (options.addSuffix && formatDistanceLocale[token].oneWithSuffix) {
            result = formatDistanceLocale[token].oneWithSuffix;
          } else {
            result = formatDistanceLocale[token].one;
          }
        } else {
          if (options.addSuffix && formatDistanceLocale[token].otherWithSuffix) {
            result = formatDistanceLocale[token].otherWithSuffix.replace("{{count}}", count);
          } else {
            result = formatDistanceLocale[token].other.replace("{{count}}", count);
          }
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + "\u5F8C";
          } else {
            return result + "\u524D";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "y\u5E74M\u6708d\u65E5EEEE",
        long: "y\u5E74M\u6708d\u65E5",
        medium: "y/MM/dd",
        short: "y/MM/dd"
      };
      var timeFormats = {
        full: "H\u6642mm\u5206ss\u79D2 zzzz",
        long: "H:mm:ss z",
        medium: "H:mm:ss",
        short: "H:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        long: "{{date}} {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
        yesterday: "\u6628\u65E5\u306Ep",
        today: "\u4ECA\u65E5\u306Ep",
        tomorrow: "\u660E\u65E5\u306Ep",
        nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["BC", "AC"],
        abbreviated: ["\u7D00\u5143\u524D", "\u897F\u66A6"],
        wide: ["\u7D00\u5143\u524D", "\u897F\u66A6"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["\u7B2C1\u56DB\u534A\u671F", "\u7B2C2\u56DB\u534A\u671F", "\u7B2C3\u56DB\u534A\u671F", "\u7B2C4\u56DB\u534A\u671F"]
      };
      var monthValues = {
        narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
        abbreviated: ["1\u6708", "2\u6708", "3\u6708", "4\u6708", "5\u6708", "6\u6708", "7\u6708", "8\u6708", "9\u6708", "10\u6708", "11\u6708", "12\u6708"],
        wide: ["1\u6708", "2\u6708", "3\u6708", "4\u6708", "5\u6708", "6\u6708", "7\u6708", "8\u6708", "9\u6708", "10\u6708", "11\u6708", "12\u6708"]
      };
      var dayValues = {
        narrow: ["\u65E5", "\u6708", "\u706B", "\u6C34", "\u6728", "\u91D1", "\u571F"],
        short: ["\u65E5", "\u6708", "\u706B", "\u6C34", "\u6728", "\u91D1", "\u571F"],
        abbreviated: ["\u65E5", "\u6708", "\u706B", "\u6C34", "\u6728", "\u91D1", "\u571F"],
        wide: ["\u65E5\u66DC\u65E5", "\u6708\u66DC\u65E5", "\u706B\u66DC\u65E5", "\u6C34\u66DC\u65E5", "\u6728\u66DC\u65E5", "\u91D1\u66DC\u65E5", "\u571F\u66DC\u65E5"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u5348\u524D",
          pm: "\u5348\u5F8C",
          midnight: "\u6DF1\u591C",
          noon: "\u6B63\u5348",
          morning: "\u671D",
          afternoon: "\u5348\u5F8C",
          evening: "\u591C",
          night: "\u6DF1\u591C"
        },
        abbreviated: {
          am: "\u5348\u524D",
          pm: "\u5348\u5F8C",
          midnight: "\u6DF1\u591C",
          noon: "\u6B63\u5348",
          morning: "\u671D",
          afternoon: "\u5348\u5F8C",
          evening: "\u591C",
          night: "\u6DF1\u591C"
        },
        wide: {
          am: "\u5348\u524D",
          pm: "\u5348\u5F8C",
          midnight: "\u6DF1\u591C",
          noon: "\u6B63\u5348",
          morning: "\u671D",
          afternoon: "\u5348\u5F8C",
          evening: "\u591C",
          night: "\u6DF1\u591C"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u5348\u524D",
          pm: "\u5348\u5F8C",
          midnight: "\u6DF1\u591C",
          noon: "\u6B63\u5348",
          morning: "\u671D",
          afternoon: "\u5348\u5F8C",
          evening: "\u591C",
          night: "\u6DF1\u591C"
        },
        abbreviated: {
          am: "\u5348\u524D",
          pm: "\u5348\u5F8C",
          midnight: "\u6DF1\u591C",
          noon: "\u6B63\u5348",
          morning: "\u671D",
          afternoon: "\u5348\u5F8C",
          evening: "\u591C",
          night: "\u6DF1\u591C"
        },
        wide: {
          am: "\u5348\u524D",
          pm: "\u5348\u5F8C",
          midnight: "\u6DF1\u591C",
          noon: "\u6B63\u5348",
          morning: "\u671D",
          afternoon: "\u5348\u5F8C",
          evening: "\u591C",
          night: "\u6DF1\u591C"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        var options = dirtyOptions || {};
        var unit = String(options.unit);

        switch (unit) {
          case "year":
            return "".concat(number, "\u5E74");

          case "quarter":
            return "\u7B2C".concat(number, "\u56DB\u534A\u671F");

          case "month":
            return "".concat(number, "\u6708");

          case "week":
            return "\u7B2C".concat(number, "\u9031");

          case "date":
            return "".concat(number, "\u65E5");

          case "hour":
            return "".concat(number, "\u6642");

          case "minute":
            return "".concat(number, "\u5206");

          case "second":
            return "".concat(number, "\u79D2");

          default:
            return "".concat(number);
        }
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(B\.?C\.?|A\.?D\.?)/i,
        abbreviated: /^(紀元[前後]|西暦)/i,
        wide: /^(紀元[前後]|西暦)/i
      };
      var parseEraPatterns = {
        narrow: [/^B/i, /^A/i],
        any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^Q[1234]/i,
        wide: /^第[1234一二三四１２３４]四半期/i
      };
      var parseQuarterPatterns = {
        any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
      };
      var matchMonthPatterns = {
        narrow: /^([123456789]|1[012])/,
        abbreviated: /^([123456789]|1[012])月/i,
        wide: /^([123456789]|1[012])月/i
      };
      var parseMonthPatterns = {
        any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
      };
      var matchDayPatterns = {
        narrow: /^[日月火水木金土]/,
        short: /^[日月火水木金土]/,
        abbreviated: /^[日月火水木金土]/,
        wide: /^[日月火水木金土]曜日/
      };
      var parseDayPatterns = {
        any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
      };
      var matchDayPeriodPatterns = {
        any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^(A|午前)/i,
          pm: /^(P|午後)/i,
          midnight: /^深夜|真夜中/i,
          noon: /^正午/i,
          morning: /^朝/i,
          afternoon: /^午後/i,
          evening: /^夜/i,
          night: /^深夜/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          past: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
          future: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
        },
        xSeconds: {
          past: "{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "{{count}} \u10EC\u10D0\u10DB\u10D8",
          future: "{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
        },
        halfAMinute: {
          past: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
          future: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
        },
        lessThanXMinutes: {
          past: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
          future: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
        },
        xMinutes: {
          past: "{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "{{count}} \u10EC\u10E3\u10D7\u10D8",
          future: "{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
        },
        aboutXHours: {
          past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
          future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
        },
        xHours: {
          past: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
          future: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
        },
        xDays: {
          past: "{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "{{count}} \u10D3\u10E6\u10D4",
          future: "{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
        },
        aboutXWeeks: {
          past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
          present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
          future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
        },
        xWeeks: {
          past: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
          present: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
          future: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
        },
        aboutXMonths: {
          past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
          future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
        },
        xMonths: {
          past: "{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "{{count}} \u10D7\u10D5\u10D4",
          future: "{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
        },
        aboutXYears: {
          past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
          future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
        },
        xYears: {
          past: "{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "{{count}} \u10EC\u10D4\u10DA\u10D8",
          future: "{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
        },
        overXYears: {
          past: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
          future: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
        },
        almostXYears: {
          past: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
          present: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
          future: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (options.addSuffix && options.comparison > 0) {
          result = formatDistanceLocale[token].future.replace("{{count}}", count);
        } else if (options.addSuffix && options.comparison <= 0) {
          result = formatDistanceLocale[token].past.replace("{{count}}", count);
        } else {
          result = formatDistanceLocale[token].present.replace("{{count}}", count);
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, do MMMM, y",
        long: "do, MMMM, y",
        medium: "d, MMM, y",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}'-\u10D6\u10D4'",
        long: "{{date}} {{time}}'-\u10D6\u10D4'",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'\u10EC\u10D8\u10DC\u10D0' eeee LT'-\u10D6\u10D4'",
        yesterday: "'\u10D2\u10E3\u10E8\u10D8\u10DC' LT'-\u10D6\u10D4'",
        today: "'\u10D3\u10E6\u10D4\u10E1' LT'-\u10D6\u10D4'",
        tomorrow: "'\u10EE\u10D5\u10D0\u10DA' LT'-\u10D6\u10D4'",
        nextWeek: "'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee LT'-\u10D6\u10D4'",
        other: "L"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u10E9.\u10EC-\u10DB\u10D3\u10D4", "\u10E9.\u10EC"],
        abbreviated: ["\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4", "\u10E9\u10D5.\u10EC"],
        wide: ["\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4", "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1-\u10DA\u10D8 \u10D9\u10D5", "2-\u10D4 \u10D9\u10D5", "3-\u10D4 \u10D9\u10D5", "4-\u10D4 \u10D9\u10D5"],
        wide: ["1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8", "2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8", "3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8", "4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"]
      }; // Note: in English, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["\u10D8\u10D0", "\u10D7\u10D4", "\u10DB\u10D0", "\u10D0\u10DE", "\u10DB\u10E1", "\u10D5\u10DC", "\u10D5\u10DA", "\u10D0\u10D2", "\u10E1\u10D4", "\u10DD\u10E5", "\u10DC\u10DD", "\u10D3\u10D4"],
        abbreviated: ["\u10D8\u10D0\u10DC", "\u10D7\u10D4\u10D1", "\u10DB\u10D0\u10E0", "\u10D0\u10DE\u10E0", "\u10DB\u10D0\u10D8", "\u10D8\u10D5\u10DC", "\u10D8\u10D5\u10DA", "\u10D0\u10D2\u10D5", "\u10E1\u10D4\u10E5", "\u10DD\u10E5\u10E2", "\u10DC\u10DD\u10D4", "\u10D3\u10D4\u10D9"],
        wide: ["\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8", "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8", "\u10DB\u10D0\u10E0\u10E2\u10D8", "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8", "\u10DB\u10D0\u10D8\u10E1\u10D8", "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8", "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8", "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD", "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8", "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8", "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8", "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"]
      };
      var dayValues = {
        narrow: ["\u10D9\u10D5", "\u10DD\u10E0", "\u10E1\u10D0", "\u10DD\u10D7", "\u10EE\u10E3", "\u10DE\u10D0", "\u10E8\u10D0"],
        short: ["\u10D9\u10D5\u10D8", "\u10DD\u10E0\u10E8", "\u10E1\u10D0\u10DB", "\u10DD\u10D7\u10EE", "\u10EE\u10E3\u10D7", "\u10DE\u10D0\u10E0", "\u10E8\u10D0\u10D1"],
        abbreviated: ["\u10D9\u10D5\u10D8", "\u10DD\u10E0\u10E8", "\u10E1\u10D0\u10DB", "\u10DD\u10D7\u10EE", "\u10EE\u10E3\u10D7", "\u10DE\u10D0\u10E0", "\u10E8\u10D0\u10D1"],
        wide: ["\u10D9\u10D5\u10D8\u10E0\u10D0", "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8", "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8", "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8", "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8", "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8", "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
          noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
          morning: "\u10D3\u10D8\u10DA\u10D0",
          afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
          evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
          night: "\u10E6\u10D0\u10DB\u10D4"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
          noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
          morning: "\u10D3\u10D8\u10DA\u10D0",
          afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
          evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
          night: "\u10E6\u10D0\u10DB\u10D4"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
          noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
          morning: "\u10D3\u10D8\u10DA\u10D0",
          afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
          evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
          night: "\u10E6\u10D0\u10DB\u10D4"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
          noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
          morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
          afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
          evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
          night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
          noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
          morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
          afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
          evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
          night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
          noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
          morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
          afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
          evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
          night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        if (number === 1) {
          return number + "-\u10DA\u10D8";
        }

        return number + "-\u10D4";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ჩვ?\.წ)/i,
        abbreviated: /^(ჩვ?\.წ)/i,
        wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
      };
      var parseEraPatterns = {
        any: [/^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i, /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]-(ლი|ე)? კვ/i,
        wide: /^[1234]-(ლი|ე)? კვარტალი/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
      };
      var parseMonthPatterns = {
        any: [/^ია/i, /^თ/i, /^მარ/i, /^აპ/i, /^მაი/i, /^ი?ვნ/i, /^ი?ვლ/i, /^აგ/i, /^ს/i, /^ო/i, /^ნ/i, /^დ/i]
      };
      var matchDayPatterns = {
        narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
        short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
        long: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
      };
      var parseDayPatterns = {
        any: [/^კვ/i, /^ორ/i, /^სა/i, /^ოთ/i, /^ხუ/i, /^პა/i, /^შა/i]
      };
      var matchDayPeriodPatterns = {
        any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^შუაღ/i,
          noon: /^შუადღ/i,
          morning: /^დილ/i,
          afternoon: /ნაშუადღევს/i,
          evening: /საღამო/i,
          night: /ღამ/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;

      function declension(scheme, count) {
        // scheme for count=1 exists
        if (scheme.one !== undefined && count === 1) {
          return scheme.one;
        }

        var rem10 = count % 10;
        var rem100 = count % 100; // 1, 21, 31, ...

        if (rem10 === 1 && rem100 !== 11) {
          return scheme.singularNominative.replace("{{count}}", count); // 2, 3, 4, 22, 23, 24, 32 ...
        } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
          return scheme.singularGenitive.replace("{{count}}", count); // 5, 6, 7, 8, 9, 10, 11, ...
        } else {
          return scheme.pluralGenitive.replace("{{count}}", count);
        }
      }

      function buildLocalizeTokenFn(scheme) {
        return function (count, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              if (scheme.future) {
                return declension(scheme.future, count);
              } else {
                return declension(scheme.regular, count) + " \u043A\u0435\u0439\u0456\u043D";
              }
            } else {
              if (scheme.past) {
                return declension(scheme.past, count);
              } else {
                return declension(scheme.regular, count) + " \u0431\u04B1\u0440\u044B\u043D";
              }
            }
          } else {
            return declension(scheme.regular, count);
          }
        };
      }

      var formatDistanceLocale = {
        lessThanXSeconds: buildLocalizeTokenFn({
          regular: {
            one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
          },
          future: {
            one: "\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
          }
        }),
        xSeconds: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
          },
          past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
          },
          future: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
          }
        }),
        halfAMinute: function (_, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
            } else {
              return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
            }
          }

          return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
        },
        lessThanXMinutes: buildLocalizeTokenFn({
          regular: {
            one: "1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
          },
          future: {
            one: "\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
          }
        }),
        xMinutes: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
          },
          past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
          },
          future: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
          }
        }),
        aboutXHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
          },
          future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
          }
        }),
        xHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442"
          }
        }),
        xDays: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u043A\u04AF\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D"
          },
          future: {
            singularNominative: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
          }
        }),
        aboutXWeeks: {
          one: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
          other: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
        },
        xWeeks: {
          one: "1 \u0430\u043F\u0442\u0430",
          other: "{{count}} \u0430\u043F\u0442\u0430"
        },
        aboutXMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
          },
          future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
          }
        }),
        xMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0430\u0439",
            singularGenitive: "{{count}} \u0430\u0439",
            pluralGenitive: "{{count}} \u0430\u0439"
          }
        }),
        aboutXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
          },
          future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
          }
        }),
        xYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B",
            singularGenitive: "{{count}} \u0436\u044B\u043B",
            pluralGenitive: "{{count}} \u0436\u044B\u043B"
          },
          future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
          }
        }),
        overXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
          },
          future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
          }
        }),
        almostXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
          },
          future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
          }
        })
      };

      function formatDistance(token, count, options) {
        options = options || {};
        return formatDistanceLocale[token](count, options);
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, do MMMM y '\u0436.'",
        long: "do MMMM y '\u0436.'",
        medium: "d MMM y '\u0436.'",
        short: "dd.MM.yyyy"
      };
      var timeFormats = {
        full: "H:mm:ss zzzz",
        long: "H:mm:ss z",
        medium: "H:mm:ss",
        short: "H:mm"
      };
      var dateTimeFormats = {
        any: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "any"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;

      var _index = _interopRequireDefault(__webpack_require__(8));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var accusativeWeekdays = ["\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435", "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435", "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435", "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435", "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435", "\u0436\u04B1\u043C\u0430\u0434\u0430", "\u0441\u0435\u043D\u0431\u0456\u0434\u0435"];

      function lastWeek(day) {
        var weekday = accusativeWeekdays[day];
        return "'\u04E9\u0442\u043A\u0435\u043D " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
      }

      function thisWeek(day) {
        var weekday = accusativeWeekdays[day];
        return "'" + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
      }

      function nextWeek(day) {
        var weekday = accusativeWeekdays[day];
        return "'\u043A\u0435\u043B\u0435\u0441\u0456 " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
      }

      var formatRelativeLocale = {
        lastWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return lastWeek(day);
          }
        },
        yesterday: "'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
        today: "'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
        tomorrow: "'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
        nextWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return nextWeek(day);
          }
        },
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date, baseDate, options);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u0431.\u0437.\u0434.", "\u0431.\u0437."],
        abbreviated: ["\u0431.\u0437.\u0434.", "\u0431.\u0437."],
        wide: ["\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D", "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1-\u0448\u0456 \u0442\u043E\u049B.", "2-\u0448\u0456 \u0442\u043E\u049B.", "3-\u0448\u0456 \u0442\u043E\u049B.", "4-\u0448\u0456 \u0442\u043E\u049B."],
        wide: ["1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D", "2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D", "3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D", "4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"]
      };
      var monthValues = {
        narrow: ["\u049A", "\u0410", "\u041D", "\u0421", "\u041C", "\u041C", "\u0428", "\u0422", "\u049A", "\u049A", "\u049A", "\u0416"],
        abbreviated: ["\u049B\u0430\u04A3", "\u0430\u049B\u043F", "\u043D\u0430\u0443", "\u0441\u04D9\u0443", "\u043C\u0430\u043C", "\u043C\u0430\u0443", "\u0448\u0456\u043B", "\u0442\u0430\u043C", "\u049B\u044B\u0440", "\u049B\u0430\u0437", "\u049B\u0430\u0440", "\u0436\u0435\u043B"],
        wide: ["\u049B\u0430\u04A3\u0442\u0430\u0440", "\u0430\u049B\u043F\u0430\u043D", "\u043D\u0430\u0443\u0440\u044B\u0437", "\u0441\u04D9\u0443\u0456\u0440", "\u043C\u0430\u043C\u044B\u0440", "\u043C\u0430\u0443\u0441\u044B\u043C", "\u0448\u0456\u043B\u0434\u0435", "\u0442\u0430\u043C\u044B\u0437", "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A", "\u049B\u0430\u0437\u0430\u043D", "\u049B\u0430\u0440\u0430\u0448\u0430", "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"]
      };
      var formattingMonthValues = {
        narrow: ["\u049A", "\u0410", "\u041D", "\u0421", "\u041C", "\u041C", "\u0428", "\u0422", "\u049A", "\u049A", "\u049A", "\u0416"],
        abbreviated: ["\u049B\u0430\u04A3", "\u0430\u049B\u043F", "\u043D\u0430\u0443", "\u0441\u04D9\u0443", "\u043C\u0430\u043C", "\u043C\u0430\u0443", "\u0448\u0456\u043B", "\u0442\u0430\u043C", "\u049B\u044B\u0440", "\u049B\u0430\u0437", "\u049B\u0430\u0440", "\u0436\u0435\u043B"],
        wide: ["\u049B\u0430\u04A3\u0442\u0430\u0440", "\u0430\u049B\u043F\u0430\u043D", "\u043D\u0430\u0443\u0440\u044B\u0437", "\u0441\u04D9\u0443\u0456\u0440", "\u043C\u0430\u043C\u044B\u0440", "\u043C\u0430\u0443\u0441\u044B\u043C", "\u0448\u0456\u043B\u0434\u0435", "\u0442\u0430\u043C\u044B\u0437", "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A", "\u049B\u0430\u0437\u0430\u043D", "\u049B\u0430\u0440\u0430\u0448\u0430", "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"]
      };
      var dayValues = {
        narrow: ["\u0416", "\u0414", "\u0421", "\u0421", "\u0411", "\u0416", "\u0421"],
        short: ["\u0436\u0441", "\u0434\u0441", "\u0441\u0441", "\u0441\u0440", "\u0431\u0441", "\u0436\u043C", "\u0441\u0431"],
        abbreviated: ["\u0436\u0441", "\u0434\u0441", "\u0441\u0441", "\u0441\u0440", "\u0431\u0441", "\u0436\u043C", "\u0441\u0431"],
        wide: ["\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456", "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456", "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456", "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456", "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456", "\u0436\u04B1\u043C\u0430", "\u0441\u0435\u043D\u0431\u0456"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u0422\u0414",
          pm: "\u0422\u041A",
          midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
          noon: "\u0442\u04AF\u0441",
          morning: "\u0442\u0430\u04A3",
          afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
          evening: "\u043A\u0435\u0448",
          night: "\u0442\u04AF\u043D"
        },
        wide: {
          am: "\u0422\u0414",
          pm: "\u0422\u041A",
          midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
          noon: "\u0442\u04AF\u0441",
          morning: "\u0442\u0430\u04A3",
          afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
          evening: "\u043A\u0435\u0448",
          night: "\u0442\u04AF\u043D"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0422\u0414",
          pm: "\u0422\u041A",
          midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
          noon: "\u0442\u04AF\u0441",
          morning: "\u0442\u0430\u04A3",
          afternoon: "\u043A\u04AF\u043D",
          evening: "\u043A\u0435\u0448",
          night: "\u0442\u04AF\u043D"
        },
        wide: {
          am: "\u0422\u0414",
          pm: "\u0422\u041A",
          midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
          noon: "\u0442\u04AF\u0441\u0442\u0435",
          morning: "\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
          afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
          evening: "\u043A\u0435\u0448\u0442\u0435",
          night: "\u0442\u04AF\u043D\u0434\u0435"
        }
      };
      var suffixes = {
        0: "-\u0448\u0456",
        1: "-\u0448\u0456",
        2: "-\u0448\u0456",
        3: "-\u0448\u0456",
        4: "-\u0448\u0456",
        5: "-\u0448\u0456",
        6: "-\u0448\u044B",
        7: "-\u0448\u0456",
        8: "-\u0448\u0456",
        9: "-\u0448\u044B",
        10: "-\u0448\u044B",
        20: "-\u0448\u044B",
        30: "-\u0448\u044B",
        40: "-\u0448\u044B",
        50: "-\u0448\u0456",
        60: "-\u0448\u044B",
        70: "-\u0448\u0456",
        80: "-\u0448\u0456",
        90: "-\u0448\u044B",
        100: "-\u0448\u0456"
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        var a = number % 10;
        var b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "any",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^((б )?з\.?\s?д\.?)/i,
        abbreviated: /^((б )?з\.?\s?д\.?)/i,
        wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
      };
      var parseEraPatterns = {
        any: [/^б/i, /^з/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](-?ші)? тоқ.?/i,
        wide: /^[1234](-?ші)? тоқсан/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
        abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
        wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
      };
      var parseMonthPatterns = {
        narrow: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i],
        abbreviated: [/^қаң/i, /^ақп/i, /^нау/i, /^сәу/i, /^мам/i, /^мау/i, /^шіл/i, /^там/i, /^қыр/i, /^қаз/i, /^қар/i, /^жел/i],
        any: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i]
      };
      var matchDayPatterns = {
        narrow: /^(ж|д|с|с|б|ж|с)/i,
        short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
        wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
      };
      var parseDayPatterns = {
        narrow: [/^ж/i, /^д/i, /^с/i, /^с/i, /^б/i, /^ж/i, /^с/i],
        short: [/^жс/i, /^дс/i, /^сс/i, /^ср/i, /^бс/i, /^жм/i, /^сб/i],
        any: [/^ж[ек]/i, /^д[үй]/i, /^сe[й]/i, /^сә[р]/i, /^б[ей]/i, /^ж[ұм]/i, /^се[н]/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
        wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
        any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ТД/i,
          pm: /^ТК/i,
          midnight: /^түн орта/i,
          noon: /^күндіз/i,
          morning: /таң/i,
          afternoon: /түс/i,
          evening: /кеш/i,
          night: /түн/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
          },
          other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
          }
        },
        xSeconds: {
          one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          },
          other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          }
        },
        halfAMinute: {
          other: {
            default: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          }
        },
        lessThanXMinutes: {
          one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
          },
          other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
          }
        },
        xMinutes: {
          one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          },
          other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          }
        },
        aboutXHours: {
          one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          },
          other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          }
        },
        xHours: {
          one: {
            default: "1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          },
          other: {
            default: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          }
        },
        xDays: {
          one: {
            default: "1 \u0CA6\u0CBF\u0CA8",
            future: "1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          },
          other: {
            default: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          }
        },
        aboutXMonths: {
          one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          },
          other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          }
        },
        xMonths: {
          one: {
            default: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          },
          other: {
            default: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          }
        },
        aboutXYears: {
          one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          },
          other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          }
        },
        xYears: {
          one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          },
          other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
          }
        },
        overXYears: {
          one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
          },
          other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
          }
        },
        almostXYears: {
          one: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
          },
          other: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
          }
        }
      };

      function getResultByTense(parentToken, options) {
        if (options.addSuffix) {
          if (options.comparison > 0) {
            return parentToken.future;
          } else {
            return parentToken.past;
          }
        }

        return parentToken.default;
      }

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = getResultByTense(formatDistanceLocale[token].one, options);
        } else {
          result = getResultByTense(formatDistanceLocale[token].other, options);
        }

        return result.replace("{{count}}", count);
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html


      var dateFormats = {
        full: "EEEE, MMMM d, y",
        // CLDR 1816
        long: "MMMM d, y",
        // CLDR 1817
        medium: "MMM d, y",
        // CLDR 1818
        short: "d/M/yy" // CLDR 1819

      };
      var timeFormats = {
        full: "hh:mm:ss a zzzz",
        // CLDR 1820
        long: "hh:mm:ss a z",
        // CLDR 1821
        medium: "hh:mm:ss a",
        // CLDR 1822
        short: "hh:mm a" // CLDR 1823

      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        // CLDR 1824
        long: "{{date}} {{time}}",
        // CLDR 1825
        medium: "{{date}} {{time}}",
        // CLDR 1826
        short: "{{date}} {{time}}" // CLDR 1827

      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
        yesterday: "'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
        today: "'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
        tomorrow: "'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
        nextWeek: "eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html


      var eraValues = {
        narrow: ["\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2", "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"],
        abbreviated: ["\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2", "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"],
        // CLDR #1618, #1620
        wide: ["\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5", "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"] // CLDR #1614, #1616

      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["\u0CA4\u0CCD\u0CB0\u0CC8 1", "\u0CA4\u0CCD\u0CB0\u0CC8 2", "\u0CA4\u0CCD\u0CB0\u0CC8 3", "\u0CA4\u0CCD\u0CB0\u0CC8 4"],
        // CLDR #1630 - #1638
        wide: ["1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95", "2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95", "3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95", "4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"] // CLDR #1622 - #1629

      }; // CLDR #1646 - #1717

      var monthValues = {
        narrow: ["\u0C9C", "\u0CAB\u0CC6", "\u0CAE\u0CBE", "\u0C8F", "\u0CAE\u0CC7", "\u0C9C\u0CC2", "\u0C9C\u0CC1", "\u0C86", "\u0CB8\u0CC6", "\u0C85", "\u0CA8", "\u0CA1\u0CBF"],
        abbreviated: ["\u0C9C\u0CA8", "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0", "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD", "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF", "\u0CAE\u0CC7", "\u0C9C\u0CC2\u0CA8\u0CCD", "\u0C9C\u0CC1\u0CB2\u0CC8", "\u0C86\u0C97", "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82", "\u0C85\u0C95\u0CCD\u0C9F\u0CCB", "\u0CA8\u0CB5\u0CC6\u0C82", "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"],
        wide: ["\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF", "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF", "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD", "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD", "\u0CAE\u0CC7", "\u0C9C\u0CC2\u0CA8\u0CCD", "\u0C9C\u0CC1\u0CB2\u0CC8", "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD", "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD", "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD", "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD", "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"]
      }; // CLDR #1718 - #1773

      var dayValues = {
        narrow: ["\u0CAD\u0CBE", "\u0CB8\u0CCB", "\u0CAE\u0C82", "\u0CAC\u0CC1", "\u0C97\u0CC1", "\u0CB6\u0CC1", "\u0CB6"],
        short: ["\u0CAD\u0CBE\u0CA8\u0CC1", "\u0CB8\u0CCB\u0CAE", "\u0CAE\u0C82\u0C97\u0CB3", "\u0CAC\u0CC1\u0CA7", "\u0C97\u0CC1\u0CB0\u0CC1", "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0", "\u0CB6\u0CA8\u0CBF"],
        abbreviated: ["\u0CAD\u0CBE\u0CA8\u0CC1", "\u0CB8\u0CCB\u0CAE", "\u0CAE\u0C82\u0C97\u0CB3", "\u0CAC\u0CC1\u0CA7", "\u0C97\u0CC1\u0CB0\u0CC1", "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0", "\u0CB6\u0CA8\u0CBF"],
        wide: ["\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0", "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0", "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0", "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0", "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0", "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0", "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"]
      }; // CLDR #1774 - #1815

      var dayPeriodValues = {
        narrow: {
          am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
          pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
          midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
          noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
          morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
          afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
          evening: "\u0CB8\u0C82\u0C9C\u0CC6",
          night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
        },
        abbreviated: {
          am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
          pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
          midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
          noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
          morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
          afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
          evening: "\u0CB8\u0C82\u0C9C\u0CC6",
          night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
        },
        wide: {
          am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
          pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
          midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
          noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
          morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
          afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
          evening: "\u0CB8\u0C82\u0C9C\u0CC6",
          night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0CAA\u0CC2",
          pm: "\u0C85",
          midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
          noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
          morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
          afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
          evening: "\u0CB8\u0C82\u0C9C\u0CC6",
          night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
        },
        abbreviated: {
          am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
          pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
          midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
          noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
          morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
          afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
          evening: "\u0CB8\u0C82\u0C9C\u0CC6",
          night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
        },
        wide: {
          am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
          pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
          midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
          noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
          morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
          afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
          evening: "\u0CB8\u0C82\u0C9C\u0CC6",
          night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + "\u0CA8\u0CC7";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
        abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
        wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
      };
      var parseEraPatterns = {
        any: [/^ಪೂ/i, /^(ಶ|ಪ್ರ)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
        wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
        abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
        wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ಜ$/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂ/i, /^ಜು$/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i],
        any: [/^ಜನ/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂನ್/i, /^ಜುಲೈ/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i]
      };
      var matchDayPatterns = {
        narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
        short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
        abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
        wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
      };
      var parseDayPatterns = {
        narrow: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i],
        any: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
        any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ಪೂ/i,
          pm: /^ಅ/i,
          midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
          noon: /ಮಧ್ಯಾನ್ಹ/i,
          morning: /ಬೆಳಗ್ಗೆ/i,
          afternoon: /ಮಧ್ಯಾನ್ಹ/i,
          evening: /ಸಂಜೆ/i,
          night: /ರಾತ್ರಿ/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "1\uCD08 \uBBF8\uB9CC",
          other: "{{count}}\uCD08 \uBBF8\uB9CC"
        },
        xSeconds: {
          one: "1\uCD08",
          other: "{{count}}\uCD08"
        },
        halfAMinute: "30\uCD08",
        lessThanXMinutes: {
          one: "1\uBD84 \uBBF8\uB9CC",
          other: "{{count}}\uBD84 \uBBF8\uB9CC"
        },
        xMinutes: {
          one: "1\uBD84",
          other: "{{count}}\uBD84"
        },
        aboutXHours: {
          one: "\uC57D 1\uC2DC\uAC04",
          other: "\uC57D {{count}}\uC2DC\uAC04"
        },
        xHours: {
          one: "1\uC2DC\uAC04",
          other: "{{count}}\uC2DC\uAC04"
        },
        xDays: {
          one: "1\uC77C",
          other: "{{count}}\uC77C"
        },
        aboutXWeeks: {
          one: "\uC57D 1\uC8FC",
          other: "\uC57D {{count}}\uC8FC"
        },
        xWeeks: {
          one: "1\uC8FC",
          other: "{{count}}\uC8FC"
        },
        aboutXMonths: {
          one: "\uC57D 1\uAC1C\uC6D4",
          other: "\uC57D {{count}}\uAC1C\uC6D4"
        },
        xMonths: {
          one: "1\uAC1C\uC6D4",
          other: "{{count}}\uAC1C\uC6D4"
        },
        aboutXYears: {
          one: "\uC57D 1\uB144",
          other: "\uC57D {{count}}\uB144"
        },
        xYears: {
          one: "1\uB144",
          other: "{{count}}\uB144"
        },
        overXYears: {
          one: "1\uB144 \uC774\uC0C1",
          other: "{{count}}\uB144 \uC774\uC0C1"
        },
        almostXYears: {
          one: "\uAC70\uC758 1\uB144",
          other: "\uAC70\uC758 {{count}}\uB144"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + " \uD6C4";
          } else {
            return result + " \uC804";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "y\uB144 M\uC6D4 d\uC77C EEEE",
        long: "y\uB144 M\uC6D4 d\uC77C",
        medium: "y.MM.dd",
        short: "y.MM.dd"
      };
      var timeFormats = {
        full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
        long: "a H:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        long: "{{date}} {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'\uC9C0\uB09C' eeee p",
        yesterday: "'\uC5B4\uC81C' p",
        today: "'\uC624\uB298' p",
        tomorrow: "'\uB0B4\uC77C' p",
        nextWeek: "'\uB2E4\uC74C' eeee p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["BC", "AD"],
        abbreviated: ["BC", "AD"],
        wide: ["\uAE30\uC6D0\uC804", "\uC11C\uAE30"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1\uBD84\uAE30", "2\uBD84\uAE30", "3\uBD84\uAE30", "4\uBD84\uAE30"]
      };
      var monthValues = {
        narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
        abbreviated: ["1\uC6D4", "2\uC6D4", "3\uC6D4", "4\uC6D4", "5\uC6D4", "6\uC6D4", "7\uC6D4", "8\uC6D4", "9\uC6D4", "10\uC6D4", "11\uC6D4", "12\uC6D4"],
        wide: ["1\uC6D4", "2\uC6D4", "3\uC6D4", "4\uC6D4", "5\uC6D4", "6\uC6D4", "7\uC6D4", "8\uC6D4", "9\uC6D4", "10\uC6D4", "11\uC6D4", "12\uC6D4"]
      };
      var dayValues = {
        narrow: ["\uC77C", "\uC6D4", "\uD654", "\uC218", "\uBAA9", "\uAE08", "\uD1A0"],
        short: ["\uC77C", "\uC6D4", "\uD654", "\uC218", "\uBAA9", "\uAE08", "\uD1A0"],
        abbreviated: ["\uC77C", "\uC6D4", "\uD654", "\uC218", "\uBAA9", "\uAE08", "\uD1A0"],
        wide: ["\uC77C\uC694\uC77C", "\uC6D4\uC694\uC77C", "\uD654\uC694\uC77C", "\uC218\uC694\uC77C", "\uBAA9\uC694\uC77C", "\uAE08\uC694\uC77C", "\uD1A0\uC694\uC77C"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\uC624\uC804",
          pm: "\uC624\uD6C4",
          midnight: "\uC790\uC815",
          noon: "\uC815\uC624",
          morning: "\uC544\uCE68",
          afternoon: "\uC624\uD6C4",
          evening: "\uC800\uB141",
          night: "\uBC24"
        },
        abbreviated: {
          am: "\uC624\uC804",
          pm: "\uC624\uD6C4",
          midnight: "\uC790\uC815",
          noon: "\uC815\uC624",
          morning: "\uC544\uCE68",
          afternoon: "\uC624\uD6C4",
          evening: "\uC800\uB141",
          night: "\uBC24"
        },
        wide: {
          am: "\uC624\uC804",
          pm: "\uC624\uD6C4",
          midnight: "\uC790\uC815",
          noon: "\uC815\uC624",
          morning: "\uC544\uCE68",
          afternoon: "\uC624\uD6C4",
          evening: "\uC800\uB141",
          night: "\uBC24"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\uC624\uC804",
          pm: "\uC624\uD6C4",
          midnight: "\uC790\uC815",
          noon: "\uC815\uC624",
          morning: "\uC544\uCE68",
          afternoon: "\uC624\uD6C4",
          evening: "\uC800\uB141",
          night: "\uBC24"
        },
        abbreviated: {
          am: "\uC624\uC804",
          pm: "\uC624\uD6C4",
          midnight: "\uC790\uC815",
          noon: "\uC815\uC624",
          morning: "\uC544\uCE68",
          afternoon: "\uC624\uD6C4",
          evening: "\uC800\uB141",
          night: "\uBC24"
        },
        wide: {
          am: "\uC624\uC804",
          pm: "\uC624\uD6C4",
          midnight: "\uC790\uC815",
          noon: "\uC815\uC624",
          morning: "\uC544\uCE68",
          afternoon: "\uC624\uD6C4",
          evening: "\uC800\uB141",
          night: "\uBC24"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber);
        var options = dirtyOptions || {};
        var unit = String(options.unit);

        switch (unit) {
          case "minute":
          case "second":
            return number;

          case "date":
            return number + "\uC77C";

          default:
            return number + "\uBC88\uC9F8";
        }
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(기원전|서기)/i
      };
      var parseEraPatterns = {
        any: [/^(bc|기원전)/i, /^(ad|서기)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234]사?분기/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(1[012]|[123456789])/,
        abbreviated: /^(1[012]|[123456789])월/i,
        wide: /^(1[012]|[123456789])월/i
      };
      var parseMonthPatterns = {
        any: [/^1월?$/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
      };
      var matchDayPatterns = {
        narrow: /^[일월화수목금토]/,
        short: /^[일월화수목금토]/,
        abbreviated: /^[일월화수목금토]/,
        wide: /^[일월화수목금토]요일/
      };
      var parseDayPatterns = {
        any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
      };
      var matchDayPeriodPatterns = {
        any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^(am|오전)/i,
          pm: /^(pm|오후)/i,
          midnight: /^자정/i,
          noon: /^정오/i,
          morning: /^아침/i,
          afternoon: /^오후/i,
          evening: /^저녁/i,
          night: /^밤/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          standalone: {
            one: "manner w\xE9i eng Sekonn",
            other: "manner w\xE9i {{count}} Sekonnen"
          },
          withPreposition: {
            one: "manner w\xE9i enger Sekonn",
            other: "manner w\xE9i {{count}} Sekonnen"
          }
        },
        xSeconds: {
          standalone: {
            one: "eng Sekonn",
            other: "{{count}} Sekonnen"
          },
          withPreposition: {
            one: "enger Sekonn",
            other: "{{count}} Sekonnen"
          }
        },
        halfAMinute: {
          standalone: "eng hallef Minutt",
          withPreposition: "enger hallwer Minutt"
        },
        lessThanXMinutes: {
          standalone: {
            one: "manner w\xE9i eng Minutt",
            other: "manner w\xE9i {{count}} Minutten"
          },
          withPreposition: {
            one: "manner w\xE9i enger Minutt",
            other: "manner w\xE9i {{count}} Minutten"
          }
        },
        xMinutes: {
          standalone: {
            one: "eng Minutt",
            other: "{{count}} Minutten"
          },
          withPreposition: {
            one: "enger Minutt",
            other: "{{count}} Minutten"
          }
        },
        aboutXHours: {
          standalone: {
            one: "ongef\xE9ier eng Stonn",
            other: "ongef\xE9ier {{count}} Stonnen"
          },
          withPreposition: {
            one: "ongef\xE9ier enger Stonn",
            other: "ongef\xE9ier {{count}} Stonnen"
          }
        },
        xHours: {
          standalone: {
            one: "eng Stonn",
            other: "{{count}} Stonnen"
          },
          withPreposition: {
            one: "enger Stonn",
            other: "{{count}} Stonnen"
          }
        },
        xDays: {
          standalone: {
            one: "een Dag",
            other: "{{count}} Deeg"
          },
          withPreposition: {
            one: "engem Dag",
            other: "{{count}} Deeg"
          }
        },
        aboutXWeeks: {
          standalone: {
            one: "ongef\xE9ier eng Woch",
            other: "ongef\xE9ier {{count}} Wochen"
          },
          withPreposition: {
            one: "ongef\xE9ier enger Woche",
            other: "ongef\xE9ier {{count}} Wochen"
          }
        },
        xWeeks: {
          standalone: {
            one: "eng Woch",
            other: "{{count}} Wochen"
          },
          withPreposition: {
            one: "enger Woch",
            other: "{{count}} Wochen"
          }
        },
        aboutXMonths: {
          standalone: {
            one: "ongef\xE9ier ee Mount",
            other: "ongef\xE9ier {{count}} M\xE9int"
          },
          withPreposition: {
            one: "ongef\xE9ier engem Mount",
            other: "ongef\xE9ier {{count}} M\xE9int"
          }
        },
        xMonths: {
          standalone: {
            one: "ee Mount",
            other: "{{count}} M\xE9int"
          },
          withPreposition: {
            one: "engem Mount",
            other: "{{count}} M\xE9int"
          }
        },
        aboutXYears: {
          standalone: {
            one: "ongef\xE9ier ee Joer",
            other: "ongef\xE9ier {{count}} Joer"
          },
          withPreposition: {
            one: "ongef\xE9ier engem Joer",
            other: "ongef\xE9ier {{count}} Joer"
          }
        },
        xYears: {
          standalone: {
            one: "ee Joer",
            other: "{{count}} Joer"
          },
          withPreposition: {
            one: "engem Joer",
            other: "{{count}} Joer"
          }
        },
        overXYears: {
          standalone: {
            one: "m\xE9i w\xE9i ee Joer",
            other: "m\xE9i w\xE9i {{count}} Joer"
          },
          withPreposition: {
            one: "m\xE9i w\xE9i engem Joer",
            other: "m\xE9i w\xE9i {{count}} Joer"
          }
        },
        almostXYears: {
          standalone: {
            one: "bal ee Joer",
            other: "bal {{count}} Joer"
          },
          withPreposition: {
            one: "bal engem Joer",
            other: "bal {{count}} Joer"
          }
        }
      };
      var EXCEPTION_CONSONANTS = ["d", "h", "n", "t", "z"];
      var VOWELS = ["a,", "e", "i", "o", "u"];
      var DIGITS_SPOKEN_N_NEEDED = [0, 1, 2, 3, 8, 9];
      var FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [40, 50, 60, 70]; // Eifeler Regel

      function isFinalNNeeded(nextWords) {
        var firstLetter = nextWords.charAt(0).toLowerCase();

        if (VOWELS.indexOf(firstLetter) != -1 || EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) {
          return true;
        } // Numbers would need to converted into words for checking.
        // Therefore, I have listed the digits that require a preceeding n with a few exceptions.


        var firstWord = nextWords.split(" ")[0];
        var number = parseInt(firstWord);

        if (!isNaN(number) && DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) {
          return true;
        } // Omit other checks as they are not expected here.


        return false;
      }

      function formatDistance(token, count, options) {
        options = options || {};
        var usageGroup = options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
        var result;

        if (typeof usageGroup === "string") {
          result = usageGroup;
        } else if (count === 1) {
          result = usageGroup.one;
        } else {
          result = usageGroup.other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "a" + (isFinalNNeeded(result) ? "n" : "") + " " + result;
          } else {
            return "viru" + (isFinalNNeeded(result) ? "n" : "") + " " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008


      var dateFormats = {
        full: "EEEE, do MMMM y",
        // Méindeg, 7. Januar 2018
        long: "do MMMM y",
        // 7. Januar 2018
        medium: "do MMM y",
        // 7. Jan 2018
        short: "dd.MM.yy" // 07.01.18

      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'um' {{time}}",
        long: "{{date}} 'um' {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function (date) {
          var day = date.getUTCDay();
          var result = "'l\xE4schte";

          if (day === 2 || day === 4) {
            // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
            result += "n";
          }

          result += "' eeee 'um' p";
          return result;
        },
        yesterday: "'g\xEBschter um' p",
        today: "'haut um' p",
        tomorrow: "'moien um' p",
        nextWeek: "eeee 'um' p",
        other: "P"
      };

      function formatRelative(token, date, _baseDate, _options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["v.Chr.", "n.Chr."],
        abbreviated: ["v.Chr.", "n.Chr."],
        wide: ["viru Christus", "no Christus"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["Jan", "Feb", "M\xE4e", "Abr", "Mee", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
        wide: ["Januar", "Februar", "M\xE4erz", "Abr\xEBll", "Mee", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
      };
      var dayValues = {
        narrow: ["S", "M", "D", "M", "D", "F", "S"],
        short: ["So", "M\xE9", "D\xEB", "M\xEB", "Do", "Fr", "Sa"],
        abbreviated: ["So.", "M\xE9.", "D\xEB.", "M\xEB.", "Do.", "Fr.", "Sa."],
        wide: ["Sonndeg", "M\xE9indeg", "D\xEBnschdeg", "M\xEBttwoch", "Donneschdeg", "Freideg", "Samschdeg"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "mo.",
          pm: "nom\xEB.",
          midnight: "M\xEBtternuecht",
          noon: "M\xEBtteg",
          morning: "Moien",
          afternoon: "Nom\xEBtteg",
          evening: "Owend",
          night: "Nuecht"
        },
        abbreviated: {
          am: "moies",
          pm: "nom\xEBttes",
          midnight: "M\xEBtternuecht",
          noon: "M\xEBtteg",
          morning: "Moien",
          afternoon: "Nom\xEBtteg",
          evening: "Owend",
          night: "Nuecht"
        },
        wide: {
          am: "moies",
          pm: "nom\xEBttes",
          midnight: "M\xEBtternuecht",
          noon: "M\xEBtteg",
          morning: "Moien",
          afternoon: "Nom\xEBtteg",
          evening: "Owend",
          night: "Nuecht"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "mo.",
          pm: "nom.",
          midnight: "M\xEBtternuecht",
          noon: "m\xEBttes",
          morning: "moies",
          afternoon: "nom\xEBttes",
          evening: "owes",
          night: "nuets"
        },
        abbreviated: {
          am: "moies",
          pm: "nom\xEBttes",
          midnight: "M\xEBtternuecht",
          noon: "m\xEBttes",
          morning: "moies",
          afternoon: "nom\xEBttes",
          evening: "owes",
          night: "nuets"
        },
        wide: {
          am: "moies",
          pm: "nom\xEBttes",
          midnight: "M\xEBtternuecht",
          noon: "m\xEBttes",
          morning: "moies",
          afternoon: "nom\xEBttes",
          evening: "owes",
          night: "nuets"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + ".";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
        abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
        wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
      };
      var parseEraPatterns = {
        any: [/^v/i, /^n/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](\.)? Quartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
        wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mä/i, /^ab/i, /^me/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smdf]/i,
        short: /^(so|mé|dë|më|do|fr|sa)/i,
        abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
        wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
      };
      var parseDayPatterns = {
        any: [/^so/i, /^mé/i, /^dë/i, /^më/i, /^do/i, /^f/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
        abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
        wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^m/i,
          pm: /^n/i,
          midnight: /^Mëtter/i,
          noon: /^mëttes/i,
          morning: /moies/i,
          afternoon: /nomëttes/i,
          // will never be matched. Afternoon is matched by `pm`
          evening: /owes/i,
          night: /nuets/i // will never be matched. Night is matched by `pm`

        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: translateSeconds,
          other: translate
        },
        xSeconds: {
          one: translateSeconds,
          other: translate
        },
        halfAMinute: "pus\u0117 minut\u0117s",
        lessThanXMinutes: {
          one: translateSingular,
          other: translate
        },
        xMinutes: {
          one: translateSingular,
          other: translate
        },
        aboutXHours: {
          one: translateSingular,
          other: translate
        },
        xHours: {
          one: translateSingular,
          other: translate
        },
        xDays: {
          one: translateSingular,
          other: translate
        },
        aboutWeeks: {
          one: translateSingular,
          other: translate
        },
        xWeeks: {
          one: translateSingular,
          other: translate
        },
        aboutXMonths: {
          one: translateSingular,
          other: translate
        },
        xMonths: {
          one: translateSingular,
          other: translate
        },
        aboutXYears: {
          one: translateSingular,
          other: translate
        },
        xYears: {
          one: translateSingular,
          other: translate
        },
        overXYears: {
          one: translateSingular,
          other: translate
        },
        almostXYears: {
          one: translateSingular,
          other: translate
        }
      };
      var translations = {
        xseconds_other: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
        xminutes_one: "minut\u0117_minut\u0117s_minut\u0119",
        xminutes_other: "minut\u0117s_minu\u010Di\u0173_minutes",
        xhours_one: "valanda_valandos_valand\u0105",
        xhours_other: "valandos_valand\u0173_valandas",
        xdays_one: "diena_dienos_dien\u0105",
        xdays_other: "dienos_dien\u0173_dienas",
        xweeks_one: "savait\u0117_savait\u0117s_savait\u0119",
        xweeks_other: "savait\u0117s_savai\u010Di\u0173_savaites",
        xmonths_one: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
        xmonths_other: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
        xyears_one: "metai_met\u0173_metus",
        xyears_other: "metai_met\u0173_metus",
        about: "apie",
        over: "daugiau nei",
        almost: "beveik",
        lessthan: "ma\u017Eiau nei"
      };

      function translateSeconds(number, addSuffix, key, isFuture) {
        if (!addSuffix) {
          return "kelios sekund\u0117s";
        } else {
          return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : "kelias sekundes";
        }
      }

      function translateSingular(number, addSuffix, key, isFuture) {
        return !addSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
      }

      function special(number) {
        return number % 10 === 0 || number > 10 && number < 20;
      }

      function forms(key) {
        return translations[key].split("_");
      }

      function translate(number, addSuffix, key, isFuture) {
        var result = number + " ";

        if (number === 1) {
          return result + translateSingular(number, addSuffix, key[0], isFuture);
        } else if (!addSuffix) {
          return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
          if (isFuture) {
            return result + forms(key)[1];
          } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
          }
        }
      }

      function formatDistance(token, count, options) {
        options = options || {};
        var adverb = token.match(/about|over|almost|lessthan/i);
        var unit = token.replace(adverb, "");
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one(count, options.addSuffix, unit.toLowerCase() + "_one");
        } else {
          result = formatDistanceLocale[token].other(count, options.addSuffix, unit.toLowerCase() + "_other");
        }

        if (adverb) {
          result = translations[adverb[0].toLowerCase()] + " " + result;
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "po " + result;
          } else {
            return "prie\u0161 " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "y 'm'. MMMM d 'd'., EEEE",
        long: "y 'm'. MMMM d 'd'.",
        medium: "y-MM-dd",
        short: "y-MM-dd"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        long: "{{date}} {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'Pra\u0117jus\u012F' eeee p",
        yesterday: "'Vakar' p",
        today: "'\u0160iandien' p",
        tomorrow: "'Rytoj' p",
        nextWeek: "eeee p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["pr. Kr.", "po Kr."],
        abbreviated: ["pr. Kr.", "po Kr."],
        wide: ["prie\u0161 Krist\u0173", "po Kristaus"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["I ketv.", "II ketv.", "III ketv.", "IV ketv."],
        wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"]
      };
      var formattingQuarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["I k.", "II k.", "III k.", "IV k."],
        wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"]
      };
      var monthValues = {
        narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
        abbreviated: ["saus.", "vas.", "kov.", "bal.", "geg.", "bir\u017E.", "liep.", "rugp.", "rugs.", "spal.", "lapkr.", "gruod."],
        wide: ["sausis", "vasaris", "kovas", "balandis", "gegu\u017E\u0117", "bir\u017Eelis", "liepa", "rugpj\u016Btis", "rugs\u0117jis", "spalis", "lapkritis", "gruodis"]
      };
      var formattingMonthValues = {
        narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
        abbreviated: ["saus.", "vas.", "kov.", "bal.", "geg.", "bir\u017E.", "liep.", "rugp.", "rugs.", "spal.", "lapkr.", "gruod."],
        wide: ["sausio", "vasario", "kovo", "baland\u017Eio", "gegu\u017E\u0117s", "bir\u017Eelio", "liepos", "rugpj\u016B\u010Dio", "rugs\u0117jo", "spalio", "lapkri\u010Dio", "gruod\u017Eio"]
      };
      var dayValues = {
        narrow: ["S", "P", "A", "T", "K", "P", "\u0160"],
        short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "\u0160t"],
        abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "\u0161t"],
        wide: ["sekmadienis", "pirmadienis", "antradienis", "tre\u010Diadienis", "ketvirtadienis", "penktadienis", "\u0161e\u0161tadienis"]
      };
      var formattingDayValues = {
        narrow: ["S", "P", "A", "T", "K", "P", "\u0160"],
        short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "\u0160t"],
        abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "\u0161t"],
        wide: ["sekmadien\u012F", "pirmadien\u012F", "antradien\u012F", "tre\u010Diadien\u012F", "ketvirtadien\u012F", "penktadien\u012F", "\u0161e\u0161tadien\u012F"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "pr. p.",
          pm: "pop.",
          midnight: "vidurnaktis",
          noon: "vidurdienis",
          morning: "rytas",
          afternoon: "diena",
          evening: "vakaras",
          night: "naktis"
        },
        abbreviated: {
          am: "prie\u0161piet",
          pm: "popiet",
          midnight: "vidurnaktis",
          noon: "vidurdienis",
          morning: "rytas",
          afternoon: "diena",
          evening: "vakaras",
          night: "naktis"
        },
        wide: {
          am: "prie\u0161piet",
          pm: "popiet",
          midnight: "vidurnaktis",
          noon: "vidurdienis",
          morning: "rytas",
          afternoon: "diena",
          evening: "vakaras",
          night: "naktis"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "pr. p.",
          pm: "pop.",
          midnight: "vidurnaktis",
          noon: "perpiet",
          morning: "rytas",
          afternoon: "popiet\u0117",
          evening: "vakaras",
          night: "naktis"
        },
        abbreviated: {
          am: "prie\u0161piet",
          pm: "popiet",
          midnight: "vidurnaktis",
          noon: "perpiet",
          morning: "rytas",
          afternoon: "popiet\u0117",
          evening: "vakaras",
          night: "naktis"
        },
        wide: {
          am: "prie\u0161piet",
          pm: "popiet",
          midnight: "vidurnaktis",
          noon: "perpiet",
          morning: "rytas",
          afternoon: "popiet\u0117",
          evening: "vakaras",
          night: "naktis"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + "-oji";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          formattingValues: formattingQuarterValues,
          defaultFormattingWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide",
          formattingValues: formattingDayValues,
          defaultFormattingWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
        abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
        wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
      };
      var parseEraPatterns = {
        wide: [/prieš/i, /(po|mūsų)/i],
        any: [/^pr/i, /^(po|m)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^([1234])/i,
        abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
        wide: /^(I|II|III|IV)\s?ketvirtis/i
      };
      var parseQuarterPatterns = {
        narrow: [/1/i, /2/i, /3/i, /4/i],
        any: [/I$/i, /II$/i, /III/i, /IV/i]
      };
      var matchMonthPatterns = {
        narrow: /^[svkbglr]/i,
        abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
        wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
      };
      var parseMonthPatterns = {
        narrow: [/^s/i, /^v/i, /^k/i, /^b/i, /^g/i, /^b/i, /^l/i, /^r/i, /^r/i, /^s/i, /^l/i, /^g/i],
        any: [/^saus/i, /^vas/i, /^kov/i, /^bal/i, /^geg/i, /^birž/i, /^liep/i, /^rugp/i, /^rugs/i, /^spal/i, /^lapkr/i, /^gruod/i]
      };
      var matchDayPatterns = {
        narrow: /^[spatkš]/i,
        short: /^(sk|pr|an|tr|kt|pn|št)/i,
        abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
        wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^p/i, /^a/i, /^t/i, /^k/i, /^p/i, /^š/i],
        wide: [/^se/i, /^pi/i, /^an/i, /^tr/i, /^ke/i, /^pe/i, /^še/i],
        any: [/^sk/i, /^pr/i, /^an/i, /^tr/i, /^kt/i, /^pn/i, /^št/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
        any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
      };
      var parseDayPeriodPatterns = {
        narrow: {
          am: /^pr/i,
          pm: /^pop./i,
          midnight: /^vidurnaktis/i,
          noon: /^(vidurdienis|perp)/i,
          morning: /rytas/i,
          afternoon: /(die|popietė)/i,
          evening: /vakaras/i,
          night: /naktis/i
        },
        any: {
          am: /^pr/i,
          pm: /^popiet$/i,
          midnight: /^vidurnaktis/i,
          noon: /^(vidurdienis|perp)/i,
          morning: /rytas/i,
          afternoon: /(die|popietė)/i,
          evening: /vakaras/i,
          night: /naktis/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;

      function buildLocalizeTokenFn(schema) {
        return function (count, options) {
          if (count === 1) {
            if (options.addSuffix) {
              return schema.one[0].replace("{{time}}", schema.one[2]);
            } else {
              return schema.one[0].replace("{{time}}", schema.one[1]);
            }
          } else {
            var rem = count % 10 === 1 && count % 100 !== 11;

            if (options.addSuffix) {
              return schema.other[0].replace("{{time}}", rem ? schema.other[3] : schema.other[4]).replace("{{count}}", count);
            } else {
              return schema.other[0].replace("{{time}}", rem ? schema.other[1] : schema.other[2]).replace("{{count}}", count);
            }
          }
        };
      }

      var formatDistanceLocale = {
        lessThanXSeconds: buildLocalizeTokenFn({
          one: ["maz\u0101k par {{time}}", "sekundi", "sekundi"],
          other: ["maz\u0101k nek\u0101 {{count}} {{time}}", "sekunde", "sekundes", "sekundes", "sekund\u0113m"]
        }),
        xSeconds: buildLocalizeTokenFn({
          one: ["1 {{time}}", "sekunde", "sekundes"],
          other: ["{{count}} {{time}}", "sekunde", "sekundes", "sekundes", "sekund\u0113m"]
        }),
        halfAMinute: function (count, options) {
          if (options.addSuffix) {
            return "pusmin\u016Btes";
          } else {
            return "pusmin\u016Bte";
          }
        },
        lessThanXMinutes: buildLocalizeTokenFn({
          one: ["maz\u0101k par {{time}}", "min\u016Bti", "min\u016Bti"],
          other: ["maz\u0101k nek\u0101 {{count}} {{time}}", "min\u016Bte", "min\u016Btes", "min\u016Btes", "min\u016Bt\u0113m"]
        }),
        xMinutes: buildLocalizeTokenFn({
          one: ["1 {{time}}", "min\u016Bte", "min\u016Btes"],
          other: ["{{count}} {{time}}", "min\u016Bte", "min\u016Btes", "min\u016Btes", "min\u016Bt\u0113m"]
        }),
        aboutXHours: buildLocalizeTokenFn({
          one: ["apm\u0113ram 1 {{time}}", "stunda", "stundas"],
          other: ["apm\u0113ram {{count}} {{time}}", "stunda", "stundas", "stundas", "stund\u0101m"]
        }),
        xHours: buildLocalizeTokenFn({
          one: ["1 {{time}}", "stunda", "stundas"],
          other: ["{{count}} {{time}}", "stunda", "stundas", "stundas", "stund\u0101m"]
        }),
        xDays: buildLocalizeTokenFn({
          one: ["1 {{time}}", "diena", "dienas"],
          other: ["{{count}} {{time}}", "diena", "dienas", "dienas", "dien\u0101m"]
        }),
        aboutXWeeks: buildLocalizeTokenFn({
          one: ["apm\u0113ram 1 {{time}}", "ned\u0113\u013Ca", "ned\u0113\u013Cas"],
          other: ["apm\u0113ram {{count}} {{time}}", "ned\u0113\u013Ca", "ned\u0113\u013Cu", "ned\u0113\u013Cas", "ned\u0113\u013C\u0101m"]
        }),
        xWeeks: buildLocalizeTokenFn({
          one: ["1 {{time}}", "ned\u0113\u013Ca", "ned\u0113\u013Cas"],
          other: ["{{count}} {{time}}", // TODO
          "ned\u0113\u013Ca", "ned\u0113\u013Cu", "ned\u0113\u013Cas", "ned\u0113\u013C\u0101m"]
        }),
        aboutXMonths: buildLocalizeTokenFn({
          one: ["apm\u0113ram 1 {{time}}", "m\u0113nesis", "m\u0113ne\u0161a"],
          other: ["apm\u0113ram {{count}} {{time}}", "m\u0113nesis", "m\u0113ne\u0161i", "m\u0113ne\u0161a", "m\u0113ne\u0161iem"]
        }),
        xMonths: buildLocalizeTokenFn({
          one: ["1 {{time}}", "m\u0113nesis", "m\u0113ne\u0161a"],
          other: ["{{count}} {{time}}", "m\u0113nesis", "m\u0113ne\u0161i", "m\u0113ne\u0161a", "m\u0113ne\u0161iem"]
        }),
        aboutXYears: buildLocalizeTokenFn({
          one: ["apm\u0113ram 1 {{time}}", "gads", "gada"],
          other: ["apm\u0113ram {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
        }),
        xYears: buildLocalizeTokenFn({
          one: ["1 {{time}}", "gads", "gada"],
          other: ["{{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
        }),
        overXYears: buildLocalizeTokenFn({
          one: ["ilg\u0101k par 1 {{time}}", "gadu", "gadu"],
          other: ["vair\u0101k nek\u0101 {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
        }),
        almostXYears: buildLocalizeTokenFn({
          one: ["gandr\u012Bz 1 {{time}}", "gads", "gada"],
          other: ["vair\u0101k nek\u0101 {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
        })
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result = formatDistanceLocale[token](count, options);

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "p\u0113c " + result;
          } else {
            return "pirms " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, y. 'gada' d. MMMM",
        long: "y. 'gada' d. MMMM",
        medium: "dd.MM.y.",
        short: "dd.MM.y."
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'plkst.' {{time}}",
        long: "{{date}} 'plkst.' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;

      var _index = _interopRequireDefault(__webpack_require__(8));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var weekdays = ["sv\u0113tdien\u0101", "pirmdien\u0101", "otrdien\u0101", "tre\u0161dien\u0101", "ceturtdien\u0101", "piektdien\u0101", "sestdien\u0101"];
      var formatRelativeLocale = {
        lastWeek: function (date, baseDate, options) {
          if ((0, _index.default)(date, baseDate, options)) {
            return "eeee 'plkst.' p";
          }

          var weekday = weekdays[date.getUTCDay()];
          return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
        },
        yesterday: "'Vakar plkst.' p",
        today: "'\u0160odien plkst.' p",
        tomorrow: "'R\u012Bt plkst.' p",
        nextWeek: function (date, baseDate, options) {
          if ((0, _index.default)(date, baseDate, options)) {
            return "eeee 'plkst.' p";
          }

          var weekday = weekdays[date.getUTCDay()];
          return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
        },
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date, baseDate, options);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["p.m.\u0113", "m.\u0113"],
        abbreviated: ["p. m. \u0113.", "m. \u0113."],
        wide: ["pirms m\u016Bsu \u0113ras", "m\u016Bsu \u0113r\u0101"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
        wide: ["pirmais ceturksnis", "otrais ceturksnis", "tre\u0161ais ceturksnis", "ceturtais ceturksnis"]
      };
      var formattingQuarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
        wide: ["pirmaj\u0101 ceturksn\u012B", "otraj\u0101 ceturksn\u012B", "tre\u0161aj\u0101 ceturksn\u012B", "ceturtaj\u0101 ceturksn\u012B"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["janv.", "febr.", "marts", "apr.", "maijs", "j\u016Bn.", "j\u016Bl.", "aug.", "sept.", "okt.", "nov.", "dec."],
        wide: ["janv\u0101ris", "febru\u0101ris", "marts", "apr\u012Blis", "maijs", "j\u016Bnijs", "j\u016Blijs", "augusts", "septembris", "oktobris", "novembris", "decembris"]
      };
      var formattingMonthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["janv.", "febr.", "mart\u0101", "apr.", "maijs", "j\u016Bn.", "j\u016Bl.", "aug.", "sept.", "okt.", "nov.", "dec."],
        wide: ["janv\u0101r\u012B", "febru\u0101r\u012B", "mart\u0101", "apr\u012Bl\u012B", "maij\u0101", "j\u016Bnij\u0101", "j\u016Blij\u0101", "august\u0101", "septembr\u012B", "oktobr\u012B", "novembr\u012B", "decembr\u012B"]
      };
      var dayValues = {
        narrow: ["S", "P", "O", "T", "C", "P", "S"],
        short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
        abbreviated: ["sv\u0113td.", "pirmd.", "otrd.", "tre\u0161d.", "ceturtd.", "piektd.", "sestd."],
        wide: ["sv\u0113tdiena", "pirmdiena", "otrdiena", "tre\u0161diena", "ceturtdiena", "piektdiena", "sestdiena"]
      };
      var formattingDayValues = {
        narrow: ["S", "P", "O", "T", "C", "P", "S"],
        short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
        abbreviated: ["sv\u0113td.", "pirmd.", "otrd.", "tre\u0161d.", "ceturtd.", "piektd.", "sestd."],
        wide: ["sv\u0113tdien\u0101", "pirmdien\u0101", "otrdien\u0101", "tre\u0161dien\u0101", "ceturtdien\u0101", "piektdien\u0101", "sestdien\u0101"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "am",
          pm: "pm",
          midnight: "pusn.",
          noon: "pusd.",
          morning: "r\u012Bts",
          afternoon: "diena",
          evening: "vakars",
          night: "nakts"
        },
        abbreviated: {
          am: "am",
          pm: "pm",
          midnight: "pusn.",
          noon: "pusd.",
          morning: "r\u012Bts",
          afternoon: "p\u0113cpusd.",
          evening: "vakars",
          night: "nakts"
        },
        wide: {
          am: "am",
          pm: "pm",
          midnight: "pusnakts",
          noon: "pusdienlaiks",
          morning: "r\u012Bts",
          afternoon: "p\u0113cpusdiena",
          evening: "vakars",
          night: "nakts"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "am",
          pm: "pm",
          midnight: "pusn.",
          noon: "pusd.",
          morning: "r\u012Bt\u0101",
          afternoon: "dien\u0101",
          evening: "vakar\u0101",
          night: "nakt\u012B"
        },
        abbreviated: {
          am: "am",
          pm: "pm",
          midnight: "pusn.",
          noon: "pusd.",
          morning: "r\u012Bt\u0101",
          afternoon: "p\u0113cpusd.",
          evening: "vakar\u0101",
          night: "nakt\u012B"
        },
        wide: {
          am: "am",
          pm: "pm",
          midnight: "pusnakt\u012B",
          noon: "pusdienlaik\u0101",
          morning: "r\u012Bt\u0101",
          afternoon: "p\u0113cpusdien\u0101",
          evening: "vakar\u0101",
          night: "nakt\u012B"
        }
      };

      function ordinalNumber(number, _options) {
        return number + ".";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          formattingValues: formattingQuarterValues,
          defaultFormattingWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide",
          formattingValues: formattingDayValues,
          defaultFormattingWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)\./i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(p\.m\.ē|m\.ē)/i,
        abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
        wide: /^(pirms mūsu ēras|mūsu ērā)/i
      };
      var parseEraPatterns = {
        any: [/^p/i, /^m/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](\. cet\.)/i,
        wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
      };
      var parseQuarterPatterns = {
        narrow: [/^1/i, /^2/i, /^3/i, /^4/i],
        abbreviated: [/^1/i, /^2/i, /^3/i, /^4/i],
        wide: [/^p/i, /^o/i, /^t/i, /^c/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
        wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jūn/i, /^jūl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[spotc]/i,
        short: /^(sv|pi|o|t|c|pk|s)/i,
        abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
        wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^p/i, /^o/i, /^t/i, /^c/i, /^p/i, /^s/i],
        any: [/^sv/i, /^pi/i, /^o/i, /^t/i, /^c/i, /^p/i, /^se/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
        abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
        wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^am/i,
          pm: /^pm/i,
          midnight: /^pusn/i,
          noon: /^pusd/i,
          morning: /^r/i,
          afternoon: /^(d|pēc)/i,
          evening: /^v/i,
          night: /^n/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
          other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        },
        xSeconds: {
          one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
          other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        },
        halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
        lessThanXMinutes: {
          one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
          other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
        },
        xMinutes: {
          one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
          other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
        },
        aboutXHours: {
          one: "\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
          other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
        },
        xHours: {
          one: "1 \u0447\u0430\u0441",
          other: "{{count}} \u0447\u0430\u0441\u0430"
        },
        xDays: {
          one: "1 \u0434\u0435\u043D",
          other: "{{count}} \u0434\u0435\u043D\u0430"
        },
        aboutXWeeks: {
          one: "\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
          other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
        },
        xWeeks: {
          one: "1 \u043D\u0435\u0434\u0435\u043B\u0430",
          other: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
        },
        aboutXMonths: {
          one: "\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
          other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
        },
        xMonths: {
          one: "1 \u043C\u0435\u0441\u0435\u0446",
          other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
        },
        aboutXYears: {
          one: "\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
          other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
        },
        xYears: {
          one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
          other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
        },
        overXYears: {
          one: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
          other: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
        },
        almostXYears: {
          one: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
          other: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "\u0437\u0430 " + result;
          } else {
            return "\u043F\u0440\u0435\u0434 " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, dd MMMM yyyy",
        long: "dd MMMM yyyy",
        medium: "dd MMM yyyy",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "H:mm"
      };
      var dateTimeFormats = {
        any: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "any"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;

      var _index = _interopRequireDefault(__webpack_require__(8));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var weekdays = ["\u043D\u0435\u0434\u0435\u043B\u0430", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u0435\u0434\u0430", "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A", "\u043F\u0435\u0442\u043E\u043A", "\u0441\u0430\u0431\u043E\u0442\u0430"];

      function lastWeek(day) {
        var weekday = weekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 6:
            return "'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 " + weekday + " \u0432\u043E' p";

          case 1:
          case 2:
          case 4:
          case 5:
            return "'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 " + weekday + " \u0432\u043E' p";
        }
      }

      function thisWeek(day) {
        var weekday = weekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 6:
            return "'\u043E\u0432\u0430 " + weekday + " \u0432o' p";

          case 1:
          case 2:
          case 4:
          case 5:
            return "'\u043E\u0432\u043E\u0458 " + weekday + " \u0432o' p";
        }
      }

      function nextWeek(day) {
        var weekday = weekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 6:
            return "'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 " + weekday + " \u0432o' p";

          case 1:
          case 2:
          case 4:
          case 5:
            return "'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 " + weekday + " \u0432o' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return lastWeek(day);
          }
        },
        yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
        today: "'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
        tomorrow: "'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
        nextWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return nextWeek(day);
          }
        },
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date, baseDate, options);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u043F\u0440.\u043D.\u0435.", "\u043D.\u0435."],
        abbreviated: ["\u043F\u0440\u0435\u0434 \u043D. \u0435.", "\u043D. \u0435."],
        wide: ["\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430", "\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1-\u0432\u0438 \u043A\u0432.", "2-\u0440\u0438 \u043A\u0432.", "3-\u0442\u0438 \u043A\u0432.", "4-\u0442\u0438 \u043A\u0432."],
        wide: ["1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
      };
      var monthValues = {
        abbreviated: ["\u0458\u0430\u043D", "\u0444\u0435\u0432", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0458", "\u0458\u0443\u043D", "\u0458\u0443\u043B", "\u0430\u0432\u0433", "\u0441\u0435\u043F\u0442", "\u043E\u043A\u0442", "\u043D\u043E\u0435\u043C", "\u0434\u0435\u043A"],
        wide: ["\u0458\u0430\u043D\u0443\u0430\u0440\u0438", "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0438\u043B", "\u043C\u0430\u0458", "\u0458\u0443\u043D\u0438", "\u0458\u0443\u043B\u0438", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438", "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438", "\u043D\u043E\u0435\u043C\u0432\u0440\u0438", "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"]
      };
      var dayValues = {
        narrow: ["\u041D", "\u041F", "\u0412", "\u0421", "\u0427", "\u041F", "\u0421"],
        short: ["\u043D\u0435", "\u043F\u043E", "\u0432\u0442", "\u0441\u0440", "\u0447\u0435", "\u043F\u0435", "\u0441\u0430"],
        abbreviated: ["\u043D\u0435\u0434", "\u043F\u043E\u043D", "\u0432\u0442\u043E", "\u0441\u0440\u0435", "\u0447\u0435\u0442", "\u043F\u0435\u0442", "\u0441\u0430\u0431"],
        wide: ["\u043D\u0435\u0434\u0435\u043B\u0430", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u0435\u0434\u0430", "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A", "\u043F\u0435\u0442\u043E\u043A", "\u0441\u0430\u0431\u043E\u0442\u0430"]
      };
      var dayPeriodValues = {
        wide: {
          am: "\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
          pm: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
          midnight: "\u043F\u043E\u043B\u043D\u043E\u045C",
          noon: "\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
          morning: "\u043D\u0430\u0443\u0442\u0440\u043E",
          afternoon: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
          evening: "\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
          night: "\u043D\u043E\u045C\u0435"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        var rem100 = number % 100;

        if (rem100 > 20 || rem100 < 10) {
          switch (rem100 % 10) {
            case 1:
              return number + "-\u0432\u0438";

            case 2:
              return number + "-\u0440\u0438";

            case 7:
            case 8:
              return number + "-\u043C\u0438";
          }
        }

        return number + "-\u0442\u0438";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^((пр)?н\.?\s?е\.?)/i,
        abbreviated: /^((пр)?н\.?\s?е\.?)/i,
        wide: /^(пред нашата ера|нашата ера)/i
      };
      var parseEraPatterns = {
        any: [/^п/i, /^н/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
        wide: /^[1234](-?[врт]?и?)? квартал/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchDayPatterns = {
        narrow: /^[нпвсч]/i,
        short: /^(не|по|вт|ср|че|пе|са)/i,
        abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
        wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
      };
      var parseDayPatterns = {
        narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
        any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[аб]/i]
      };
      var matchMonthPatterns = {
        abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
        wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
      };
      var parseMonthPatterns = {
        any: [/^ја/i, /^Ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /претпладне/i,
          pm: /попладне/i,
          midnight: /полноќ/i,
          noon: /напладне/i,
          morning: /наутро/i,
          afternoon: /попладне/i,
          evening: /навечер/i,
          night: /ноќе/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
          other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
        },
        xSeconds: {
          one: "1 \u0441\u0435\u043A\u0443\u043D\u0434",
          other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        halfAMinute: "\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
        lessThanXMinutes: {
          one: "\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
          other: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
        },
        xMinutes: {
          one: "1 \u043C\u0438\u043D\u0443\u0442",
          other: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        aboutXHours: {
          one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
          other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
        },
        xHours: {
          one: "1 \u0446\u0430\u0433",
          other: "{{count}} \u0446\u0430\u0433"
        },
        xDays: {
          one: "1 \u04E9\u0434\u04E9\u0440",
          other: "{{count}} \u04E9\u0434\u04E9\u0440"
        },
        aboutXWeeks: {
          one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
          other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
        },
        xWeeks: {
          one: "1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
          other: "{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
        },
        aboutXMonths: {
          one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
          other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
        },
        xMonths: {
          one: "1 \u0441\u0430\u0440",
          other: "{{count}} \u0441\u0430\u0440"
        },
        aboutXYears: {
          one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
          other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
        },
        xYears: {
          one: "1 \u0436\u0438\u043B",
          other: "{{count}} \u0436\u0438\u043B"
        },
        overXYears: {
          one: "1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
          other: "{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
        },
        almostXYears: {
          one: "\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
          other: "\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          /**
           * Append genitive case
           */
          var words = result.split(" ");
          var lastword = words.pop();
          result = words.join(" ");

          switch (lastword) {
            case "\u0441\u0435\u043A\u0443\u043D\u0434":
              result += " \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
              break;

            case "\u043C\u0438\u043D\u0443\u0442":
              result += " \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
              break;

            case "\u0446\u0430\u0433":
              result += " \u0446\u0430\u0433\u0438\u0439\u043D";
              break;

            case "\u04E9\u0434\u04E9\u0440":
              result += " \u04E9\u0434\u0440\u0438\u0439\u043D";
              break;

            case "\u0441\u0430\u0440":
              result += " \u0441\u0430\u0440\u044B\u043D";
              break;

            case "\u0436\u0438\u043B":
              result += " \u0436\u0438\u043B\u0438\u0439\u043D";
              break;

            case "\u0445\u043E\u043D\u043E\u0433":
              result += " \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
              break;

            case "\u0433\u0430\u0440\u0430\u043D":
              result += " \u0433\u0430\u0440\u0430\u043D\u044B";
              break;

            case "\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
              result += " \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
              break;

            default:
              result += lastword + "-\u043D";
          }

          if (options.comparison > 0) {
            return result + " \u0434\u0430\u0440\u0430\u0430";
          } else {
            return result + " \u04E9\u043C\u043D\u04E9";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
        long: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
        medium: "y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
        short: "y.MM.dd"
      };
      var timeFormats = {
        full: "H:mm:ss zzzz",
        long: "H:mm:ss z",
        medium: "H:mm:ss",
        short: "H:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        long: "{{date}} {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
        yesterday: "'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
        today: "'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
        tomorrow: "'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
        nextWeek: "'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u041D\u0422\u04E8", "\u041D\u0422"],
        abbreviated: ["\u041D\u0422\u04E8", "\u041D\u0422"],
        wide: ["\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445", "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"]
      };
      var quarterValues = {
        narrow: ["I", "II", "III", "IV"],
        abbreviated: ["I \u0443\u043B\u0438\u0440\u0430\u043B", "II \u0443\u043B\u0438\u0440\u0430\u043B", "III \u0443\u043B\u0438\u0440\u0430\u043B", "IV \u0443\u043B\u0438\u0440\u0430\u043B"],
        wide: ["1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B", "2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B", "3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B", "4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"]
      }; // Note: in English, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"],
        abbreviated: ["1-\u0440 \u0441\u0430\u0440", "2-\u0440 \u0441\u0430\u0440", "3-\u0440 \u0441\u0430\u0440", "4-\u0440 \u0441\u0430\u0440", "5-\u0440 \u0441\u0430\u0440", "6-\u0440 \u0441\u0430\u0440", "7-\u0440 \u0441\u0430\u0440", "8-\u0440 \u0441\u0430\u0440", "9-\u0440 \u0441\u0430\u0440", "10-\u0440 \u0441\u0430\u0440", "11-\u0440 \u0441\u0430\u0440", "12-\u0440 \u0441\u0430\u0440"],
        wide: ["\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"]
      };
      var formattingMonthValues = {
        narrow: ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"],
        abbreviated: ["1-\u0440 \u0441\u0430\u0440", "2-\u0440 \u0441\u0430\u0440", "3-\u0440 \u0441\u0430\u0440", "4-\u0440 \u0441\u0430\u0440", "5-\u0440 \u0441\u0430\u0440", "6-\u0440 \u0441\u0430\u0440", "7-\u0440 \u0441\u0430\u0440", "8-\u0440 \u0441\u0430\u0440", "9-\u0440 \u0441\u0430\u0440", "10-\u0440 \u0441\u0430\u0440", "11-\u0440 \u0441\u0430\u0440", "12-\u0440 \u0441\u0430\u0440"],
        wide: ["\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"]
      };
      var dayValues = {
        narrow: ["\u041D", "\u0414", "\u041C", "\u041B", "\u041F", "\u0411", "\u0411"],
        short: ["\u041D\u044F", "\u0414\u0430", "\u041C\u044F", "\u041B\u0445", "\u041F\u04AF", "\u0411\u0430", "\u0411\u044F"],
        abbreviated: ["\u041D\u044F\u043C", "\u0414\u0430\u0432", "\u041C\u044F\u0433", "\u041B\u0445\u0430", "\u041F\u04AF\u0440", "\u0411\u0430\u0430", "\u0411\u044F\u043C"],
        wide: ["\u041D\u044F\u043C", "\u0414\u0430\u0432\u0430\u0430", "\u041C\u044F\u0433\u043C\u0430\u0440", "\u041B\u0445\u0430\u0433\u0432\u0430", "\u041F\u04AF\u0440\u044D\u0432", "\u0411\u0430\u0430\u0441\u0430\u043D", "\u0411\u044F\u043C\u0431\u0430"]
      };
      var formattingDayValues = {
        narrow: ["\u041D", "\u0414", "\u041C", "\u041B", "\u041F", "\u0411", "\u0411"],
        short: ["\u041D\u044F", "\u0414\u0430", "\u041C\u044F", "\u041B\u0445", "\u041F\u04AF", "\u0411\u0430", "\u0411\u044F"],
        abbreviated: ["\u041D\u044F\u043C", "\u0414\u0430\u0432", "\u041C\u044F\u0433", "\u041B\u0445\u0430", "\u041F\u04AF\u0440", "\u0411\u0430\u0430", "\u0411\u044F\u043C"],
        wide: ["\u043D\u044F\u043C", "\u0434\u0430\u0432\u0430\u0430", "\u043C\u044F\u0433\u043C\u0430\u0440", "\u043B\u0445\u0430\u0433\u0432\u0430", "\u043F\u04AF\u0440\u044D\u0432", "\u0431\u0430\u0430\u0441\u0430\u043D", "\u0431\u044F\u043C\u0431\u0430"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u04AF.\u04E9.",
          pm: "\u04AF.\u0445.",
          midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
          noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
          morning: "\u04E9\u0433\u043B\u04E9\u04E9",
          afternoon: "\u04E9\u0434\u04E9\u0440",
          evening: "\u043E\u0440\u043E\u0439",
          night: "\u0448\u04E9\u043D\u04E9"
        },
        abbreviated: {
          am: "\u04AF.\u04E9.",
          pm: "\u04AF.\u0445.",
          midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
          noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
          morning: "\u04E9\u0433\u043B\u04E9\u04E9",
          afternoon: "\u04E9\u0434\u04E9\u0440",
          evening: "\u043E\u0440\u043E\u0439",
          night: "\u0448\u04E9\u043D\u04E9"
        },
        wide: {
          am: "\u04AF.\u04E9.",
          pm: "\u04AF.\u0445.",
          midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
          noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
          morning: "\u04E9\u0433\u043B\u04E9\u04E9",
          afternoon: "\u04E9\u0434\u04E9\u0440",
          evening: "\u043E\u0440\u043E\u0439",
          night: "\u0448\u04E9\u043D\u04E9"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        return number;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide",
          formattingValues: formattingDayValues,
          defaultFormattingWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /\d+/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(нтө|нт)/i,
        abbreviated: /^(нтө|нт)/i,
        wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
      };
      var parseEraPatterns = {
        any: [/^(нтө|нийтийн тооллын өмнө)/i, /^(нт|нийтийн тооллын)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^(iv|iii|ii|i)/i,
        abbreviated: /^(iv|iii|ii|i) улирал/i,
        wide: /^[1-4]-р улирал/i
      };
      var parseQuarterPatterns = {
        any: [/^(i(\s|$)|1)/i, /^(ii(\s|$)|2)/i, /^(iii(\s|$)|3)/i, /^(iv(\s|$)|4)/i]
      };
      var matchMonthPatterns = {
        narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
        abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
        wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
      };
      var parseMonthPatterns = {
        narrow: [/^i$/i, /^ii$/i, /^iii$/i, /^iv$/i, /^v$/i, /^vi$/i, /^vii$/i, /^viii$/i, /^ix$/i, /^x$/i, /^xi$/i, /^xii$/i],
        any: [/^(1|нэгдүгээр)/i, /^(2|хоёрдугаар)/i, /^(3|гуравдугаар)/i, /^(4|дөрөвдүгээр)/i, /^(5|тавдугаар)/i, /^(6|зургаадугаар)/i, /^(7|долоодугаар)/i, /^(8|наймдугаар)/i, /^(9|есдүгээр)/i, /^(10|аравдугаар)/i, /^(11|арван нэгдүгээр)/i, /^(12|арван хоёрдугаар)/i]
      };
      var matchDayPatterns = {
        narrow: /^[ндмлпбб]/i,
        short: /^(ня|да|мя|лх|пү|ба|бя)/i,
        abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
        wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
      };
      var parseDayPatterns = {
        narrow: [/^н/i, /^д/i, /^м/i, /^л/i, /^п/i, /^б/i, /^б/i],
        any: [/^ня/i, /^да/i, /^мя/i, /^лх/i, /^пү/i, /^ба/i, /^бя/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
        any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ү\.ө\./i,
          pm: /^ү\.х\./i,
          midnight: /^шөнө дунд/i,
          noon: /^үд дунд/i,
          morning: /өглөө/i,
          afternoon: /өдөр/i,
          evening: /орой/i,
          night: /шөнө/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "kurang dari 1 saat",
          other: "kurang dari {{count}} saat"
        },
        xSeconds: {
          one: "1 saat",
          other: "{{count}} saat"
        },
        halfAMinute: "setengah minit",
        lessThanXMinutes: {
          one: "kurang dari 1 minit",
          other: "kurang dari {{count}} minit"
        },
        xMinutes: {
          one: "1 minit",
          other: "{{count}} minit"
        },
        aboutXHours: {
          one: "sekitar 1 jam",
          other: "sekitar {{count}} jam"
        },
        xHours: {
          one: "1 jam",
          other: "{{count}} jam"
        },
        xDays: {
          one: "1 hari",
          other: "{{count}} hari"
        },
        aboutXWeeks: {
          one: "sekitar 1 minggu",
          other: "sekitar {{count}} minggu"
        },
        xWeeks: {
          one: "1 minggu",
          other: "{{count}} minggu"
        },
        aboutXMonths: {
          one: "sekitar 1 bulan",
          other: "sekitar {{count}} bulan"
        },
        xMonths: {
          one: "1 bulan",
          other: "{{count}} bulan"
        },
        aboutXYears: {
          one: "sekitar 1 tahun",
          other: "sekitar {{count}} tahun"
        },
        xYears: {
          one: "1 tahun",
          other: "{{count}} tahun"
        },
        overXYears: {
          one: "lebih dari 1 tahun",
          other: "lebih dari {{count}} tahun"
        },
        almostXYears: {
          one: "hampir 1 tahun",
          other: "hampir {{count}} tahun"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "dalam masa " + result;
          } else {
            return result + " yang lalu";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM yyyy",
        long: "d MMMM yyyy",
        medium: "d MMM yyyy",
        short: "d/M/yyyy"
      };
      var timeFormats = {
        full: "HH.mm.ss",
        long: "HH.mm.ss",
        medium: "HH.mm",
        short: "HH.mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'pukul' {{time}}",
        long: "{{date}} 'pukul' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'lepas pada jam' p",
        yesterday: "'Semalam pada jam' p",
        today: "'Hari ini pada jam' p",
        tomorrow: "'Esok pada jam' p",
        nextWeek: "eeee 'pada jam' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // Most data for localization are taken from this page
      // https://www.unicode.org/cldr/charts/32/summary/ms.html


      var eraValues = {
        narrow: ["SM", "M"],
        abbreviated: ["SM", "M"],
        wide: ["Sebelum Masihi", "Masihi"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["S1", "S2", "S3", "S4"],
        wide: ["Suku pertama", "Suku kedua", "Suku ketiga", "Suku keempat"]
      }; // Note: in Malay, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "O", "S", "O", "N", "D"],
        abbreviated: ["Jan", "Feb", "Mac", "Apr", "Mei", "Jun", "Jul", "Ogo", "Sep", "Okt", "Nov", "Dis"],
        wide: ["Januari", "Februari", "Mac", "April", "Mei", "Jun", "Julai", "Ogos", "September", "Oktober", "November", "Disember"]
      };
      var dayValues = {
        narrow: ["A", "I", "S", "R", "K", "J", "S"],
        short: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
        abbreviated: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
        wide: ["Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "am",
          pm: "pm",
          midnight: "tgh malam",
          noon: "tgh hari",
          morning: "pagi",
          afternoon: "tengah hari",
          evening: "petang",
          night: "malam"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "tengah malam",
          noon: "tengah hari",
          morning: "pagi",
          afternoon: "tengah hari",
          evening: "petang",
          night: "malam"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "tengah malam",
          noon: "tengah hari",
          morning: "pagi",
          afternoon: "tengah hari",
          evening: "petang",
          night: "malam"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "am",
          pm: "pm",
          midnight: "tengah malam",
          noon: "tengah hari",
          morning: "pagi",
          afternoon: "tengah hari",
          evening: "petang",
          night: "malam"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "tengah malam",
          noon: "tengah hari",
          morning: "pagi",
          afternoon: "tengah hari",
          evening: "petang",
          night: "malam"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "tengah malam",
          noon: "tengah hari",
          morning: "pagi",
          afternoon: "tengah hari",
          evening: "petang",
          night: "malam"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // Can't use "pertama", "kedua" because can't be parsed

        switch (number) {
          default:
            return "ke-" + number;
        }
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
      var parseOrdinalNumberPattern = /petama|\d+/i;
      var matchEraPatterns = {
        narrow: /^(sm|m)/i,
        abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
        wide: /^(sebelum masihi|masihi)/i
      };
      var parseEraPatterns = {
        any: [/^s/i, /^(m)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^S[1234]/i,
        wide: /Suku (pertama|kedua|ketiga|keempat)/i
      };
      var parseQuarterPatterns = {
        any: [/pertama|1/i, /kedua|2/i, /ketiga|3/i, /keempat|4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
        wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^og/i, /^s/i, /^ok/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[aisrkj]/i,
        short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
        abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
        wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
      };
      var parseDayPatterns = {
        narrow: [/^a/i, /^i/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
        any: [/^a/i, /^i/i, /^se/i, /^r/i, /^k/i, /^j/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
        any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^pm/i,
          midnight: /^tengah m/i,
          noon: /^tengah h/i,
          morning: /pa/i,
          afternoon: /tengah h/i,
          evening: /pe/i,
          night: /m/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "inqas minn sekonda",
          other: "inqas minn {{count}} sekondi"
        },
        xSeconds: {
          one: "sekonda",
          other: "{{count}} sekondi"
        },
        halfAMinute: "nofs minuta",
        lessThanXMinutes: {
          one: "inqas minn minuta",
          other: "inqas minn {{count}} minuti"
        },
        xMinutes: {
          one: "minuta",
          other: "{{count}} minuti"
        },
        aboutXHours: {
          one: "madwar sieg\u0127a",
          other: "madwar {{count}} sieg\u0127at"
        },
        xHours: {
          one: "sieg\u0127a",
          other: "{{count}} sieg\u0127at"
        },
        xDays: {
          one: "\u0121urnata",
          other: "{{count}} \u0121ranet"
        },
        aboutXWeeks: {
          one: "madwar \u0121img\u0127a",
          other: "madwar {{count}} \u0121img\u0127at"
        },
        xWeeks: {
          one: "\u0121img\u0127a",
          other: "{{count}} \u0121img\u0127at"
        },
        aboutXMonths: {
          one: "madwar xahar",
          other: "madwar {{count}} xhur"
        },
        xMonths: {
          one: "xahar",
          other: "{{count}} xhur"
        },
        aboutXYears: {
          one: "madwar sena",
          two: "madwar sentejn",
          other: "madwar {{count}} snin"
        },
        xYears: {
          one: "sena",
          two: "sentejn",
          other: "{{count}} snin"
        },
        overXYears: {
          one: "aktar minn sena",
          two: "aktar minn sentejn",
          other: "aktar minn {{count}} snin"
        },
        almostXYears: {
          one: "kwa\u017Ci sena",
          two: "kwa\u017Ci sentejn",
          other: "kwa\u017Ci {{count}} snin"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var adverb = token.match(/years/i);
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2 && adverb) {
          result = formatDistanceLocale[token].two;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "f'" + result;
          } else {
            return result + " ilu";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM yyyy",
        long: "d MMMM yyyy",
        medium: "d MMM yyyy",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        long: "{{date}} {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'li g\u0127adda' 'fil-'p",
        yesterday: "'Il-biera\u0127 fil-'p",
        today: "'Illum fil-'p",
        tomorrow: "'G\u0127ada fil-'p",
        nextWeek: "eeee 'fil-'p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["Q", "W"],
        abbreviated: ["QK", "WK"],
        wide: ["qabel Kristu", "wara Kristu"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["K1", "K2", "K3", "K4"],
        wide: ["1. kwart", "2. kwart", "3. kwart", "4. kwart"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "\u0120", "L", "A", "S", "O", "N", "D"],
        abbreviated: ["Jan", "Fra", "Mar", "Apr", "Mej", "\u0120un", "Lul", "Aww", "Set", "Ott", "Nov", "Di\u010B"],
        wide: ["Jannar", "Frar", "Marzu", "April", "Mejju", "\u0120unju", "Lulju", "Awwissu", "Settembru", "Ottubru", "Novembru", "Di\u010Bembru"]
      };
      var dayValues = {
        narrow: ["\u0126", "T", "T", "E", "\u0126", "\u0120", "S"],
        short: ["\u0126a", "Tn", "Tl", "Er", "\u0126a", "\u0120i", "Si"],
        abbreviated: ["\u0126ad", "Tne", "Tli", "Erb", "\u0126am", "\u0120im", "Sib"],
        wide: ["Il-\u0126add", "It-Tnejn", "It-Tlieta", "L-Erbg\u0127a", "Il-\u0126amis", "Il-\u0120img\u0127a", "Is-Sibt"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "nofsillejl",
          noon: "nofsinhar",
          morning: "g\u0127odwa",
          afternoon: "wara nofsinhar",
          evening: "filg\u0127axija",
          night: "lejl"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "nofsillejl",
          noon: "nofsinhar",
          morning: "g\u0127odwa",
          afternoon: "wara nofsinhar",
          evening: "filg\u0127axija",
          night: "lejl"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "nofsillejl",
          noon: "nofsinhar",
          morning: "g\u0127odwa",
          afternoon: "wara nofsinhar",
          evening: "filg\u0127axija",
          night: "lejl"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "f'nofsillejl",
          noon: "f'nofsinhar",
          morning: "filg\u0127odu",
          afternoon: "wara nofsinhar",
          evening: "filg\u0127axija",
          night: "billejl"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "f'nofsillejl",
          noon: "f'nofsinhar",
          morning: "filg\u0127odu",
          afternoon: "wara nofsinhar",
          evening: "filg\u0127axija",
          night: "billejl"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "f'nofsillejl",
          noon: "f'nofsinhar",
          morning: "filg\u0127odu",
          afternoon: "wara nofsinhar",
          evening: "filg\u0127axija",
          night: "billejl"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + "\xBA";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(q|w)/i,
        abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
        wide: /^(qabel kristu|before common era|wara kristu|common era)/i
      };
      var parseEraPatterns = {
        any: [/^(q|b)/i, /^(w|c)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^k[1234]/i,
        wide: /^[1234](\.)? kwart/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmaglsond]/i,
        abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
        wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^ġ/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mej/i, /^ġ/i, /^l/i, /^aw/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[ħteġs]/i,
        short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
        abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
        wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
      };
      var parseDayPatterns = {
        narrow: [/^ħ/i, /^t/i, /^t/i, /^e/i, /^ħ/i, /^ġ/i, /^s/i],
        any: [/^(il-)?ħad/i, /^(it-)?tn/i, /^(it-)?tl/i, /^(l-)?er/i, /^(il-)?ham/i, /^(il-)?ġi/i, /^(is-)?si/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
        any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^f'nofsillejl/i,
          noon: /^f'nofsinhar/i,
          morning: /għodwa/i,
          afternoon: /wara(\s.*)nofsinhar/i,
          evening: /filgħaxija/i,
          night: /lejl/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          singular: "mindre enn ett sekund",
          plural: "mindre enn {{count}} sekunder"
        },
        xSeconds: {
          singular: "ett sekund",
          plural: "{{count}} sekunder"
        },
        halfAMinute: "et halvt minutt",
        lessThanXMinutes: {
          singular: "mindre enn ett minutt",
          plural: "mindre enn {{count}} minutter"
        },
        xMinutes: {
          singular: "ett minutt",
          plural: "{{count}} minutter"
        },
        aboutXHours: {
          singular: "omtrent en time",
          plural: "omtrent {{count}} timer"
        },
        xHours: {
          singular: "en time",
          plural: "{{count}} timer"
        },
        xDays: {
          singular: "en dag",
          plural: "{{count}} dager"
        },
        aboutXWeeks: {
          singular: "omtrent en uke",
          plural: "omtrent {{count}} uker"
        },
        xWeeks: {
          singular: "en uke",
          plural: "{{count}} uker"
        },
        aboutXMonths: {
          singular: "omtrent en m\xE5ned",
          plural: "omtrent {{count}} m\xE5neder"
        },
        xMonths: {
          singular: "en m\xE5ned",
          plural: "{{count}} m\xE5neder"
        },
        aboutXYears: {
          singular: "omtrent ett \xE5r",
          plural: "omtrent {{count}} \xE5r"
        },
        xYears: {
          singular: "ett \xE5r",
          plural: "{{count}} \xE5r"
        },
        overXYears: {
          singular: "over ett \xE5r",
          plural: "over {{count}} \xE5r"
        },
        almostXYears: {
          singular: "nesten ett \xE5r",
          plural: "nesten {{count}} \xE5r"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var translation = formatDistanceLocale[token];
        var result;

        if (typeof translation === "string") {
          result = translation;
        } else if (count === 0 || count > 1) {
          result = translation.plural.replace("{{count}}", count);
        } else {
          result = translation.singular;
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "om " + result;
          } else {
            return result + " siden";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE d. MMMM y",
        long: "d. MMMM y",
        medium: "d. MMM y",
        short: "dd.MM.y"
      };
      var timeFormats = {
        full: "'kl'. HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'kl.' {{time}}",
        long: "{{date}} 'kl.' {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'forrige' eeee 'kl.' p",
        yesterday: "'i g\xE5r kl.' p",
        today: "'i dag kl.' p",
        tomorrow: "'i morgen kl.' p",
        nextWeek: "EEEE 'kl.' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["f.Kr.", "e.Kr."],
        abbreviated: ["f.Kr.", "e.Kr."],
        wide: ["f\xF8r Kristus", "etter Kristus"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
        wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
      };
      var dayValues = {
        narrow: ["S", "M", "T", "O", "T", "F", "L"],
        short: ["s\xF8", "ma", "ti", "on", "to", "fr", "l\xF8"],
        abbreviated: ["s\xF8n", "man", "tir", "ons", "tor", "fre", "l\xF8r"],
        wide: ["s\xF8ndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "l\xF8rdag"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "midnatt",
          noon: "middag",
          morning: "p\xE5 morg.",
          afternoon: "p\xE5 etterm.",
          evening: "p\xE5 kvelden",
          night: "p\xE5 natten"
        },
        abbreviated: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnatt",
          noon: "middag",
          morning: "p\xE5 morg.",
          afternoon: "p\xE5 etterm.",
          evening: "p\xE5 kvelden",
          night: "p\xE5 natten"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnatt",
          noon: "middag",
          morning: "p\xE5 morgenen",
          afternoon: "p\xE5 ettermiddagen",
          evening: "p\xE5 kvelden",
          night: "p\xE5 natten"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + ".";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)\.?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
        abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
        wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
      };
      var parseEraPatterns = {
        any: [/^f/i, /^e/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](\.)? kvartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
        wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtofl]/i,
        short: /^(sø|ma|ti|on|to|fr|lø)/i,
        abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
        wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
      };
      var parseDayPatterns = {
        any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
        any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a(\.?\s?m\.?)?$/i,
          pm: /^p(\.?\s?m\.?)?$/i,
          midnight: /^midn/i,
          noon: /^midd/i,
          morning: /morgen/i,
          afternoon: /ettermiddag/i,
          evening: /kveld/i,
          night: /natt/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "minder dan een seconde",
          other: "minder dan {{count}} seconden"
        },
        xSeconds: {
          one: "1 seconde",
          other: "{{count}} seconden"
        },
        halfAMinute: "een halve minuut",
        lessThanXMinutes: {
          one: "minder dan een minuut",
          other: "minder dan {{count}} minuten"
        },
        xMinutes: {
          one: "een minuut",
          other: "{{count}} minuten"
        },
        aboutXHours: {
          one: "ongeveer 1 uur",
          other: "ongeveer {{count}} uur"
        },
        xHours: {
          one: "1 uur",
          other: "{{count}} uur"
        },
        xDays: {
          one: "1 dag",
          other: "{{count}} dagen"
        },
        aboutXWeeks: {
          one: "ongeveer 1 week",
          other: "ongeveer {{count}} weken"
        },
        xWeeks: {
          one: "1 week",
          other: "{{count}} weken"
        },
        aboutXMonths: {
          one: "ongeveer 1 maand",
          other: "ongeveer {{count}} maanden"
        },
        xMonths: {
          one: "1 maand",
          other: "{{count}} maanden"
        },
        aboutXYears: {
          one: "ongeveer 1 jaar",
          other: "ongeveer {{count}} jaar"
        },
        xYears: {
          one: "1 jaar",
          other: "{{count}} jaar"
        },
        overXYears: {
          one: "meer dan 1 jaar",
          other: "meer dan {{count}} jaar"
        },
        almostXYears: {
          one: "bijna 1 jaar",
          other: "bijna {{count}} jaar"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "over " + result;
          } else {
            return result + " geleden";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE d MMMM y",
        long: "d MMMM y",
        medium: "d MMM y",
        short: "dd.MM.y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'om' {{time}}",
        long: "{{date}} 'om' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'vorige' eeee 'om' p",
        yesterday: "'gisteren om' p",
        today: "'vandaag om' p",
        tomorrow: "'morgen om' p",
        nextWeek: "eeee 'om' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["v.C.", "n.C."],
        abbreviated: ["v.Chr.", "n.Chr."],
        wide: ["voor Christus", "na Christus"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["K1", "K2", "K3", "K4"],
        wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
        wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
      };
      var dayValues = {
        narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
        short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
        abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
        wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "middernacht",
          noon: "het middag",
          morning: "'s ochtends",
          afternoon: "'s namiddags",
          evening: "'s avonds",
          night: "'s nachts"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "middernacht",
          noon: "het middag",
          morning: "'s ochtends",
          afternoon: "'s namiddags",
          evening: "'s avonds",
          night: "'s nachts"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "middernacht",
          noon: "het middag",
          morning: "'s ochtends",
          afternoon: "'s namiddags",
          evening: "'s avonds",
          night: "'s nachts"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + "e";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)e?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^([vn]\.? ?C\.?)/,
        abbreviated: /^([vn]\. ?Chr\.?)/,
        wide: /^((voor|na) Christus)/
      };
      var parseEraPatterns = {
        any: [/^v/, /^n/]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^K[1234]/i,
        wide: /^[1234]e kwartaal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
        wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
      };
      var matchDayPatterns = {
        narrow: /^[zmdwv]/i,
        short: /^(zo|ma|di|wo|do|vr|za)/i,
        abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
        wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
      };
      var parseDayPatterns = {
        narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
        any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^am/i,
          pm: /^pm/i,
          midnight: /^middernacht/i,
          noon: /^het middaguur/i,
          morning: /ochtend/i,
          afternoon: /middag/i,
          evening: /avond/i,
          night: /nacht/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "minder dan een seconde",
          other: "minder dan {{count}} seconden"
        },
        xSeconds: {
          one: "1 seconde",
          other: "{{count}} seconden"
        },
        halfAMinute: "een halve minuut",
        lessThanXMinutes: {
          one: "minder dan een minuut",
          other: "minder dan {{count}} minuten"
        },
        xMinutes: {
          one: "een minuut",
          other: "{{count}} minuten"
        },
        aboutXHours: {
          one: "ongeveer 1 uur",
          other: "ongeveer {{count}} uur"
        },
        xHours: {
          one: "1 uur",
          other: "{{count}} uur"
        },
        xDays: {
          one: "1 dag",
          other: "{{count}} dagen"
        },
        aboutXWeeks: {
          one: "ongeveer 1 week",
          other: "ongeveer {{count}} weken"
        },
        xWeeks: {
          one: "1 week",
          other: "{{count}} weken"
        },
        aboutXMonths: {
          one: "ongeveer 1 maand",
          other: "ongeveer {{count}} maanden"
        },
        xMonths: {
          one: "1 maand",
          other: "{{count}} maanden"
        },
        aboutXYears: {
          one: "ongeveer 1 jaar",
          other: "ongeveer {{count}} jaar"
        },
        xYears: {
          one: "1 jaar",
          other: "{{count}} jaar"
        },
        overXYears: {
          one: "meer dan 1 jaar",
          other: "meer dan {{count}} jaar"
        },
        almostXYears: {
          one: "bijna 1 jaar",
          other: "bijna {{count}} jaar"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "over " + result;
          } else {
            return result + " geleden";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE d MMMM y",
        long: "d MMMM y",
        medium: "d MMM y",
        short: "dd-MM-y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'om' {{time}}",
        long: "{{date}} 'om' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'afgelopen' eeee 'om' p",
        yesterday: "'gisteren om' p",
        today: "'vandaag om' p",
        tomorrow: "'morgen om' p",
        nextWeek: "eeee 'om' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["v.C.", "n.C."],
        abbreviated: ["v.Chr.", "n.Chr."],
        wide: ["voor Christus", "na Christus"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["K1", "K2", "K3", "K4"],
        wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
        wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
      };
      var dayValues = {
        narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
        short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
        abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
        wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "middernacht",
          noon: "het middaguur",
          morning: "'s ochtends",
          afternoon: "'s middags",
          evening: "'s avonds",
          night: "'s nachts"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "middernacht",
          noon: "het middaguur",
          morning: "'s ochtends",
          afternoon: "'s middags",
          evening: "'s avonds",
          night: "'s nachts"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "middernacht",
          noon: "het middaguur",
          morning: "'s ochtends",
          afternoon: "'s middags",
          evening: "'s avonds",
          night: "'s nachts"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + "e";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)e?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^([vn]\.? ?C\.?)/,
        abbreviated: /^([vn]\. ?Chr\.?)/,
        wide: /^((voor|na) Christus)/
      };
      var parseEraPatterns = {
        any: [/^v/, /^n/]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^K[1234]/i,
        wide: /^[1234]e kwartaal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
        wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
      };
      var matchDayPatterns = {
        narrow: /^[zmdwv]/i,
        short: /^(zo|ma|di|wo|do|vr|za)/i,
        abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
        wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
      };
      var parseDayPatterns = {
        narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
        any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^am/i,
          pm: /^pm/i,
          midnight: /^middernacht/i,
          noon: /^het middaguur/i,
          morning: /ochtend/i,
          afternoon: /middag/i,
          evening: /avond/i,
          night: /nacht/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          singular: "mindre enn eitt sekund",
          plural: "mindre enn {{count}} sekund"
        },
        xSeconds: {
          singular: "eitt sekund",
          plural: "{{count}} sekund"
        },
        halfAMinute: "eit halvt minutt",
        lessThanXMinutes: {
          singular: "mindre enn eitt minutt",
          plural: "mindre enn {{count}} minutt"
        },
        xMinutes: {
          singular: "eitt minutt",
          plural: "{{count}} minutt"
        },
        aboutXHours: {
          singular: "omtrent ein time",
          plural: "omtrent {{count}} timar"
        },
        xHours: {
          singular: "ein time",
          plural: "{{count}} timar"
        },
        xDays: {
          singular: "ein dag",
          plural: "{{count}} dagar"
        },
        aboutXWeeks: {
          singular: "omtrent ei veke",
          plural: "omtrent {{count}} veker"
        },
        xWeeks: {
          singular: "ei veke",
          plural: "{{count}} veker"
        },
        aboutXMonths: {
          singular: "omtrent ein m\xE5nad",
          plural: "omtrent {{count}} m\xE5nader"
        },
        xMonths: {
          singular: "ein m\xE5nad",
          plural: "{{count}} m\xE5nader"
        },
        aboutXYears: {
          singular: "omtrent eitt \xE5r",
          plural: "omtrent {{count}} \xE5r"
        },
        xYears: {
          singular: "eitt \xE5r",
          plural: "{{count}} \xE5r"
        },
        overXYears: {
          singular: "over eitt \xE5r",
          plural: "over {{count}} \xE5r"
        },
        almostXYears: {
          singular: "nesten eitt \xE5r",
          plural: "nesten {{count}} \xE5r"
        }
      };
      var wordMapping = ["null", "ein", "to", "tre", "fire", "fem", "seks", "sju", "\xE5tte", "ni", "ti", "elleve", "tolv"];

      function formatDistance(token, count, options) {
        options = options || {
          onlyNumeric: false
        };
        var translation = formatDistanceLocale[token];
        var result;

        if (typeof translation === "string") {
          result = translation;
        } else if (count === 0 || count > 1) {
          if (options.onlyNumeric) {
            result = translation.plural.replace("{{count}}", count);
          } else {
            result = translation.plural.replace("{{count}}", count < 13 ? wordMapping[count] : count);
          }
        } else {
          result = translation.singular;
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "om " + result;
          } else {
            return result + " sidan";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE d. MMMM y",
        long: "d. MMMM y",
        medium: "d. MMM y",
        short: "dd.MM.y"
      };
      var timeFormats = {
        full: "'kl'. HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'kl.' {{time}}",
        long: "{{date}} 'kl.' {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'f\xF8rre' eeee 'kl.' p",
        yesterday: "'i g\xE5r kl.' p",
        today: "'i dag kl.' p",
        tomorrow: "'i morgon kl.' p",
        nextWeek: "EEEE 'kl.' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["f.Kr.", "e.Kr."],
        abbreviated: ["f.Kr.", "e.Kr."],
        wide: ["f\xF8r Kristus", "etter Kristus"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
        wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
      };
      var dayValues = {
        narrow: ["S", "M", "T", "O", "T", "F", "L"],
        short: ["su", "m\xE5", "ty", "on", "to", "fr", "lau"],
        abbreviated: ["sun", "m\xE5n", "tys", "ons", "tor", "fre", "laur"],
        wide: ["sundag", "m\xE5ndag", "tysdag", "onsdag", "torsdag", "fredag", "laurdag"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "midnatt",
          noon: "middag",
          morning: "p\xE5 morg.",
          afternoon: "p\xE5 etterm.",
          evening: "p\xE5 kvelden",
          night: "p\xE5 natta"
        },
        abbreviated: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnatt",
          noon: "middag",
          morning: "p\xE5 morg.",
          afternoon: "p\xE5 etterm.",
          evening: "p\xE5 kvelden",
          night: "p\xE5 natta"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnatt",
          noon: "middag",
          morning: "p\xE5 morgonen",
          afternoon: "p\xE5 ettermiddagen",
          evening: "p\xE5 kvelden",
          night: "p\xE5 natta"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + ".";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)\.?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
        abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
        wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
      };
      var parseEraPatterns = {
        any: [/^f/i, /^e/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](\.)? kvartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
        wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtofl]/i,
        short: /^(su|må|ty|on|to|fr|la)/i,
        abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
        wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
      };
      var parseDayPatterns = {
        any: [/^s/i, /^m/i, /^ty/i, /^o/i, /^to/i, /^f/i, /^l/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
        any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a(\.?\s?m\.?)?$/i,
          pm: /^p(\.?\s?m\.?)?$/i,
          midnight: /^midn/i,
          noon: /^midd/i,
          morning: /morgon/i,
          afternoon: /ettermiddag/i,
          evening: /kveld/i,
          night: /natt/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;

      function declensionGroup(scheme, count) {
        if (count === 1) {
          return scheme.one;
        }

        var rem100 = count % 100; // ends with 11-20

        if (rem100 <= 20 && rem100 > 10) {
          return scheme.other;
        }

        var rem10 = rem100 % 10; // ends with 2, 3, 4

        if (rem10 >= 2 && rem10 <= 4) {
          return scheme.twoFour;
        }

        return scheme.other;
      }

      function declension(scheme, count, time) {
        time = time || "regular";
        var group = declensionGroup(scheme, count);
        var finalText = group[time] || group;
        return finalText.replace("{{count}}", count);
      }

      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
          },
          twoFour: "mniej ni\u017C {{count}} sekundy",
          other: "mniej ni\u017C {{count}} sekund"
        },
        xSeconds: {
          one: {
            regular: "sekunda",
            past: "sekund\u0119",
            future: "sekund\u0119"
          },
          twoFour: "{{count}} sekundy",
          other: "{{count}} sekund"
        },
        halfAMinute: {
          one: "p\xF3\u0142 minuty",
          twoFour: "p\xF3\u0142 minuty",
          other: "p\xF3\u0142 minuty"
        },
        lessThanXMinutes: {
          one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
          },
          twoFour: "mniej ni\u017C {{count}} minuty",
          other: "mniej ni\u017C {{count}} minut"
        },
        xMinutes: {
          one: {
            regular: "minuta",
            past: "minut\u0119",
            future: "minut\u0119"
          },
          twoFour: "{{count}} minuty",
          other: "{{count}} minut"
        },
        aboutXHours: {
          one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
          },
          twoFour: "oko\u0142o {{count}} godziny",
          other: "oko\u0142o {{count}} godzin"
        },
        xHours: {
          one: {
            regular: "godzina",
            past: "godzin\u0119",
            future: "godzin\u0119"
          },
          twoFour: "{{count}} godziny",
          other: "{{count}} godzin"
        },
        xDays: {
          one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
          },
          twoFour: "{{count}} dni",
          other: "{{count}} dni"
        },
        aboutXWeeks: {
          one: "oko\u0142o tygodnia",
          twoFour: "oko\u0142o {{count}} tygodni",
          other: "oko\u0142o {{count}} tygodni"
        },
        xWeeks: {
          one: "tydzie\u0144",
          twoFour: "{{count}} tygodnie",
          other: "{{count}} tygodni"
        },
        aboutXMonths: {
          one: "oko\u0142o miesi\u0105c",
          twoFour: "oko\u0142o {{count}} miesi\u0105ce",
          other: "oko\u0142o {{count}} miesi\u0119cy"
        },
        xMonths: {
          one: "miesi\u0105c",
          twoFour: "{{count}} miesi\u0105ce",
          other: "{{count}} miesi\u0119cy"
        },
        aboutXYears: {
          one: "oko\u0142o rok",
          twoFour: "oko\u0142o {{count}} lata",
          other: "oko\u0142o {{count}} lat"
        },
        xYears: {
          one: "rok",
          twoFour: "{{count}} lata",
          other: "{{count}} lat"
        },
        overXYears: {
          one: "ponad rok",
          twoFour: "ponad {{count}} lata",
          other: "ponad {{count}} lat"
        },
        almostXYears: {
          one: "prawie rok",
          twoFour: "prawie {{count}} lata",
          other: "prawie {{count}} lat"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var scheme = formatDistanceLocale[token];

        if (!options.addSuffix) {
          return declension(scheme, count);
        }

        if (options.comparison > 0) {
          return "za " + declension(scheme, count, "future");
        } else {
          return declension(scheme, count, "past") + " temu";
        }
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, do MMMM y",
        long: "do MMMM y",
        medium: "do MMM y",
        short: "dd.MM.y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        long: "{{date}} {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;

      var _index = _interopRequireDefault(__webpack_require__(8));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var adjectivesLastWeek = {
        masculine: "ostatni",
        feminine: "ostatnia"
      };
      var adjectivesThisWeek = {
        masculine: "ten",
        feminine: "ta"
      };
      var adjectivesNextWeek = {
        masculine: "nast\u0119pny",
        feminine: "nast\u0119pna"
      };
      var dayGrammaticalGender = {
        0: "feminine",
        1: "masculine",
        2: "masculine",
        3: "feminine",
        4: "masculine",
        5: "masculine",
        6: "feminine"
      };

      function getAdjectives(token, date, baseDate, options) {
        if ((0, _index.default)(date, baseDate, options)) {
          return adjectivesThisWeek;
        } else if (token === "lastWeek") {
          return adjectivesLastWeek;
        } else if (token === "nextWeek") {
          return adjectivesNextWeek;
        } else {
          throw new Error("Cannot determine adjectives for token ".concat(token));
        }
      }

      function getAdjective(token, date, baseDate, options) {
        var day = date.getUTCDay();
        var adjectives = getAdjectives(token, date, baseDate, options);
        var grammaticalGender = dayGrammaticalGender[day];
        return adjectives[grammaticalGender];
      }

      function dayAndTimeWithAdjective(token, date, baseDate, options) {
        var adjective = getAdjective(token, date, baseDate, options);
        return "'".concat(adjective, "' eeee 'o' p");
      }

      var formatRelativeLocale = {
        lastWeek: dayAndTimeWithAdjective,
        yesterday: "'wczoraj o' p",
        today: "'dzisiaj o' p",
        tomorrow: "'jutro o' p",
        nextWeek: dayAndTimeWithAdjective,
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(token, date, baseDate, options);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return String(number);
      }

      var eraValues = {
        narrow: ["p.n.e.", "n.e."],
        abbreviated: ["p.n.e.", "n.e."],
        wide: ["przed nasz\u0105 er\u0105", "naszej ery"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["I kw.", "II kw.", "III kw.", "IV kw."],
        wide: ["I kwarta\u0142", "II kwarta\u0142", "III kwarta\u0142", "IV kwarta\u0142"]
      };
      var monthValues = {
        narrow: ["S", "L", "M", "K", "M", "C", "L", "S", "W", "P", "L", "G"],
        abbreviated: ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "pa\u017A", "lis", "gru"],
        wide: ["stycze\u0144", "luty", "marzec", "kwiecie\u0144", "maj", "czerwiec", "lipiec", "sierpie\u0144", "wrzesie\u0144", "pa\u017Adziernik", "listopad", "grudzie\u0144"]
      };
      var monthFormattingValues = {
        narrow: ["s", "l", "m", "k", "m", "c", "l", "s", "w", "p", "l", "g"],
        abbreviated: ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "pa\u017A", "lis", "gru"],
        wide: ["stycznia", "lutego", "marca", "kwietnia", "maja", "czerwca", "lipca", "sierpnia", "wrze\u015Bnia", "pa\u017Adziernika", "listopada", "grudnia"]
      };
      var dayValues = {
        narrow: ["N", "P", "W", "\u015A", "C", "P", "S"],
        short: ["nie", "pon", "wto", "\u015Bro", "czw", "pi\u0105", "sob"],
        abbreviated: ["niedz.", "pon.", "wt.", "\u015Br.", "czw.", "pt.", "sob."],
        wide: ["niedziela", "poniedzia\u0142ek", "wtorek", "\u015Broda", "czwartek", "pi\u0105tek", "sobota"]
      };
      var dayFormattingValues = {
        narrow: ["n", "p", "w", "\u015B", "c", "p", "s"],
        short: ["nie", "pon", "wto", "\u015Bro", "czw", "pi\u0105", "sob"],
        abbreviated: ["niedz.", "pon.", "wt.", "\u015Br.", "czw.", "pt.", "sob."],
        wide: ["niedziela", "poniedzia\u0142ek", "wtorek", "\u015Broda", "czwartek", "pi\u0105tek", "sobota"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "p\xF3\u0142n.",
          noon: "po\u0142",
          morning: "rano",
          afternoon: "popo\u0142.",
          evening: "wiecz.",
          night: "noc"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "p\xF3\u0142noc",
          noon: "po\u0142udnie",
          morning: "rano",
          afternoon: "popo\u0142udnie",
          evening: "wiecz\xF3r",
          night: "noc"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "p\xF3\u0142noc",
          noon: "po\u0142udnie",
          morning: "rano",
          afternoon: "popo\u0142udnie",
          evening: "wiecz\xF3r",
          night: "noc"
        }
      };
      var dayPeriodFormattingValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "o p\xF3\u0142n.",
          noon: "w po\u0142.",
          morning: "rano",
          afternoon: "po po\u0142.",
          evening: "wiecz.",
          night: "w nocy"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "o p\xF3\u0142nocy",
          noon: "w po\u0142udnie",
          morning: "rano",
          afternoon: "po po\u0142udniu",
          evening: "wieczorem",
          night: "w nocy"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "o p\xF3\u0142nocy",
          noon: "w po\u0142udnie",
          morning: "rano",
          afternoon: "po po\u0142udniu",
          evening: "wieczorem",
          night: "w nocy"
        }
      };
      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: monthFormattingValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide",
          formattingValues: dayFormattingValues,
          defaultFormattingWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: dayPeriodFormattingValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
        abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
        wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
      };
      var parseEraPatterns = {
        any: [/^p/i, /^n/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
        wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
      };
      var parseQuarterPatterns = {
        narrow: [/1/i, /2/i, /3/i, /4/i],
        any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i]
      };
      var matchMonthPatterns = {
        narrow: /^[slmkcwpg]/i,
        abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
        wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
      };
      var parseMonthPatterns = {
        narrow: [/^s/i, /^l/i, /^m/i, /^k/i, /^m/i, /^c/i, /^l/i, /^s/i, /^w/i, /^p/i, /^l/i, /^g/i],
        any: [/^st/i, /^lu/i, /^mar/i, /^k/i, /^maj/i, /^c/i, /^lip/i, /^si/i, /^w/i, /^p/i, /^lis/i, /^g/i]
      };
      var matchDayPatterns = {
        narrow: /^[npwścs]/i,
        short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
        abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
        wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
      };
      var parseDayPatterns = {
        narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
        abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],
        any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
        any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
      };
      var parseDayPeriodPatterns = {
        narrow: {
          am: /^a$/i,
          pm: /^p$/i,
          midnight: /pó(ł|l)n/i,
          noon: /po(ł|l)/i,
          morning: /rano/i,
          afternoon: /po\s*po(ł|l)/i,
          evening: /wiecz/i,
          night: /noc/i
        },
        any: {
          am: /^am/i,
          pm: /^pm/i,
          midnight: /pó(ł|l)n/i,
          noon: /po(ł|l)/i,
          morning: /rano/i,
          afternoon: /po\s*po(ł|l)/i,
          evening: /wiecz/i,
          night: /noc/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "menos de um segundo",
          other: "menos de {{count}} segundos"
        },
        xSeconds: {
          one: "1 segundo",
          other: "{{count}} segundos"
        },
        halfAMinute: "meio minuto",
        lessThanXMinutes: {
          one: "menos de um minuto",
          other: "menos de {{count}} minutos"
        },
        xMinutes: {
          one: "1 minuto",
          other: "{{count}} minutos"
        },
        aboutXHours: {
          one: "cerca de 1 hora",
          other: "cerca de {{count}} horas"
        },
        xHours: {
          one: "1 hora",
          other: "{{count}} horas"
        },
        xDays: {
          one: "1 dia",
          other: "{{count}} dias"
        },
        aboutXWeeks: {
          one: "cerca de 1 semana",
          other: "cerca de {{count}} semanas"
        },
        xWeeks: {
          one: "1 semana",
          other: "{{count}} semanas"
        },
        aboutXMonths: {
          one: "cerca de 1 m\xEAs",
          other: "cerca de {{count}} meses"
        },
        xMonths: {
          one: "1 m\xEAs",
          other: "{{count}} meses"
        },
        aboutXYears: {
          one: "cerca de 1 ano",
          other: "cerca de {{count}} anos"
        },
        xYears: {
          one: "1 ano",
          other: "{{count}} anos"
        },
        overXYears: {
          one: "mais de 1 ano",
          other: "mais de {{count}} anos"
        },
        almostXYears: {
          one: "quase 1 ano",
          other: "quase {{count}} anos"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "em " + result;
          } else {
            return "h\xE1 " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d 'de' MMMM 'de' y",
        long: "d 'de' MMMM 'de' y",
        medium: "d MMM y",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} '\xE0s' {{time}}",
        long: "{{date}} '\xE0s' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function (date, _baseDate, _options) {
          var weekday = date.getUTCDay();
          var last = weekday === 0 || weekday === 6 ? "\xFAltimo" : "\xFAltima";
          return "'" + last + "' eeee '\xE0s' p";
        },
        yesterday: "'ontem \xE0s' p",
        today: "'hoje \xE0s' p",
        tomorrow: "'amanh\xE3 \xE0s' p",
        nextWeek: "eeee '\xE0s' p",
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date, baseDate, options);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["AC", "DC"],
        abbreviated: ["AC", "DC"],
        wide: ["antes de cristo", "depois de cristo"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["T1", "T2", "T3", "T4"],
        wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
      };
      var monthValues = {
        narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
        abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
        wide: ["janeiro", "fevereiro", "mar\xE7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
      };
      var dayValues = {
        narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
        short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
        abbreviated: ["domingo", "segunda", "ter\xE7a", "quarta", "quinta", "sexta", "s\xE1bado"],
        wide: ["domingo", "segunda-feira", "ter\xE7a-feira", "quarta-feira", "quinta-feira", "sexta-feira", "s\xE1bado"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mn",
          noon: "md",
          morning: "manh\xE3",
          afternoon: "tarde",
          evening: "tarde",
          night: "noite"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "meia-noite",
          noon: "meio-dia",
          morning: "manh\xE3",
          afternoon: "tarde",
          evening: "tarde",
          night: "noite"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "meia-noite",
          noon: "meio-dia",
          morning: "manh\xE3",
          afternoon: "tarde",
          evening: "tarde",
          night: "noite"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mn",
          noon: "md",
          morning: "da manh\xE3",
          afternoon: "da tarde",
          evening: "da tarde",
          night: "da noite"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "meia-noite",
          noon: "meio-dia",
          morning: "da manh\xE3",
          afternoon: "da tarde",
          evening: "da tarde",
          night: "da noite"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "meia-noite",
          noon: "meio-dia",
          morning: "da manh\xE3",
          afternoon: "da tarde",
          evening: "da tarde",
          night: "da noite"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber);
        var options = dirtyOptions || {};
        var unit = String(options.unit);

        if (unit === "week" || unit === "isoWeek") {
          return number + "\xAA";
        }

        return number + "\xBA";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ac|dc|a|d)/i,
        abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
        wide: /^(antes de cristo|depois de cristo)/i
      };
      var parseEraPatterns = {
        any: [/^ac/i, /^dc/i],
        wide: [/^antes de cristo/i, /^depois de cristo/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^T[1234]/i,
        wide: /^[1234](º)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmajsond]/i,
        abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
        wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
      };
      var matchDayPatterns = {
        narrow: /^(dom|[23456]ª?|s[aá]b)/i,
        short: /^(dom|[23456]ª?|s[aá]b)/i,
        abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
        wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
      };
      var parseDayPatterns = {
        short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
        narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
        any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
        any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mn|^meia[-\s]noite/i,
          noon: /^md|^meio[-\s]dia/i,
          morning: /manhã/i,
          afternoon: /tarde/i,
          evening: /tarde/i,
          night: /noite/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "menos de um segundo",
          other: "menos de {{count}} segundos"
        },
        xSeconds: {
          one: "1 segundo",
          other: "{{count}} segundos"
        },
        halfAMinute: "meio minuto",
        lessThanXMinutes: {
          one: "menos de um minuto",
          other: "menos de {{count}} minutos"
        },
        xMinutes: {
          one: "1 minuto",
          other: "{{count}} minutos"
        },
        aboutXHours: {
          one: "aproximadamente 1 hora",
          other: "aproximadamente {{count}} horas"
        },
        xHours: {
          one: "1 hora",
          other: "{{count}} horas"
        },
        xDays: {
          one: "1 dia",
          other: "{{count}} dias"
        },
        aboutXWeeks: {
          one: "aproximadamente 1 semana",
          other: "aproximadamente {{count}} semanas"
        },
        xWeeks: {
          one: "1 semana",
          other: "{{count}} semanas"
        },
        aboutXMonths: {
          one: "aproximadamente 1 m\xEAs",
          other: "aproximadamente {{count}} meses"
        },
        xMonths: {
          one: "1 m\xEAs",
          other: "{{count}} meses"
        },
        aboutXYears: {
          one: "aproximadamente 1 ano",
          other: "aproximadamente {{count}} anos"
        },
        xYears: {
          one: "1 ano",
          other: "{{count}} anos"
        },
        overXYears: {
          one: "mais de 1 ano",
          other: "mais de {{count}} anos"
        },
        almostXYears: {
          one: "quase 1 ano",
          other: "quase {{count}} anos"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "daqui a " + result;
          } else {
            return "h\xE1 " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d 'de' MMMM 'de' y",
        long: "d 'de' MMMM 'de' y",
        medium: "d 'de' MMM 'de' y",
        short: "dd/MM/y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} '\xE0s' {{time}}",
        long: "{{date}} '\xE0s' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'na \xFAltima' eeee '\xE0s' p",
        yesterday: "'ontem \xE0s' p",
        today: "'hoje \xE0s' p",
        tomorrow: "'amanh\xE3 \xE0s' p",
        nextWeek: "eeee '\xE0s' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + "\xBA";
      }

      var eraValues = {
        narrow: ["aC", "dC"],
        abbreviated: ["a.C.", "d.C."],
        wide: ["antes de Cristo", "depois de Cristo"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["T1", "T2", "T3", "T4"],
        wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
      };
      var monthValues = {
        narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
        abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
        wide: ["janeiro", "fevereiro", "mar\xE7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
      };
      var dayValues = {
        narrow: ["d", "s", "t", "q", "q", "s", "s"],
        short: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
        abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
        wide: ["domingo", "segunda-feira", "ter\xE7a-feira", "quarta-feira", "quinta-feira", "sexta-feira", "s\xE1bado"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "meia-noite",
          noon: "meio-dia",
          morning: "manh\xE3",
          afternoon: "tarde",
          evening: "noite",
          night: "madrugada"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "meia-noite",
          noon: "meio-dia",
          morning: "manh\xE3",
          afternoon: "tarde",
          evening: "noite",
          night: "madrugada"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "meia-noite",
          noon: "meio-dia",
          morning: "manh\xE3",
          afternoon: "tarde",
          evening: "noite",
          night: "madrugada"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "meia-noite",
          noon: "meio-dia",
          morning: "da manh\xE3",
          afternoon: "da tarde",
          evening: "da noite",
          night: "da madrugada"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "meia-noite",
          noon: "meio-dia",
          morning: "da manh\xE3",
          afternoon: "da tarde",
          evening: "da noite",
          night: "da madrugada"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "meia-noite",
          noon: "meio-dia",
          morning: "da manh\xE3",
          afternoon: "da tarde",
          evening: "da noite",
          night: "da madrugada"
        }
      };
      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ac|dc|a|d)/i,
        abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
        wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
      };
      var parseEraPatterns = {
        any: [/^ac/i, /^dc/i],
        wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^T[1234]/i,
        wide: /^[1234](º|ª)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
        wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[dstq]/i,
        short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
        abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
        wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
        any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
        any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^meia/i,
          noon: /^meio/i,
          morning: /manh[ãa]/i,
          afternoon: /tarde/i,
          evening: /noite/i,
          night: /madrugada/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "mai pu\u021Bin de o secund\u0103",
          other: "mai pu\u021Bin de {{count}} secunde"
        },
        xSeconds: {
          one: "1 secund\u0103",
          other: "{{count}} secunde"
        },
        halfAMinute: "jum\u0103tate de minut",
        lessThanXMinutes: {
          one: "mai pu\u021Bin de un minut",
          other: "mai pu\u021Bin de {{count}} minute"
        },
        xMinutes: {
          one: "1 minut",
          other: "{{count}} minute"
        },
        aboutXHours: {
          one: "circa 1 or\u0103",
          other: "circa {{count}} ore"
        },
        xHours: {
          one: "1 or\u0103",
          other: "{{count}} ore"
        },
        xDays: {
          one: "1 zi",
          other: "{{count}} zile"
        },
        aboutXWeeks: {
          one: "circa o s\u0103pt\u0103m\xE2n\u0103",
          other: "circa {{count}} s\u0103pt\u0103m\xE2ni"
        },
        xWeeks: {
          one: "1 s\u0103pt\u0103m\xE2n\u0103",
          other: "{{count}} s\u0103pt\u0103m\xE2ni"
        },
        aboutXMonths: {
          one: "circa 1 lun\u0103",
          other: "circa {{count}} luni"
        },
        xMonths: {
          one: "1 lun\u0103",
          other: "{{count}} luni"
        },
        aboutXYears: {
          one: "circa 1 an",
          other: "circa {{count}} ani"
        },
        xYears: {
          one: "1 an",
          other: "{{count}} ani"
        },
        overXYears: {
          one: "peste 1 an",
          other: "peste {{count}} ani"
        },
        almostXYears: {
          one: "aproape 1 an",
          other: "aproape {{count}} ani"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "\xEEn " + result;
          } else {
            return result + " \xEEn urm\u0103";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM yyyy",
        long: "d MMMM yyyy",
        medium: "d MMM yyyy",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'la' {{time}}",
        long: "{{date}} 'la' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'trecut\u0103 la' p",
        yesterday: "'ieri la' p",
        today: "'ast\u0103zi la' p",
        tomorrow: "'m\xE2ine la' p",
        nextWeek: "eeee 'viitoare la' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\xCE", "D"],
        abbreviated: ["\xCE.d.C.", "D.C."],
        wide: ["\xCEnainte de Cristos", "Dup\u0103 Cristos"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["T1", "T2", "T3", "T4"],
        wide: ["primul trimestru", "al doilea trimestru", "al treilea trimestru", "al patrulea trimestru"]
      };
      var monthValues = {
        narrow: ["I", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
        abbreviated: ["ian", "feb", "mar", "apr", "mai", "iun", "iul", "aug", "sep", "oct", "noi", "dec"],
        wide: ["ianuarie", "februarie", "martie", "aprilie", "mai", "iunie", "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"]
      };
      var dayValues = {
        narrow: ["d", "l", "m", "m", "j", "v", "s"],
        short: ["du", "lu", "ma", "mi", "jo", "vi", "s\xE2"],
        abbreviated: ["dum", "lun", "mar", "mie", "joi", "vin", "s\xE2m"],
        wide: ["duminic\u0103", "luni", "mar\u021Bi", "miercuri", "joi", "vineri", "s\xE2mb\u0103t\u0103"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mn",
          noon: "ami",
          morning: "dim",
          afternoon: "da",
          evening: "s",
          night: "n"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "miezul nop\u021Bii",
          noon: "amiaz\u0103",
          morning: "diminea\u021B\u0103",
          afternoon: "dup\u0103-amiaz\u0103",
          evening: "sear\u0103",
          night: "noapte"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "miezul nop\u021Bii",
          noon: "amiaz\u0103",
          morning: "diminea\u021B\u0103",
          afternoon: "dup\u0103-amiaz\u0103",
          evening: "sear\u0103",
          night: "noapte"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mn",
          noon: "amiaz\u0103",
          morning: "diminea\u021B\u0103",
          afternoon: "dup\u0103-amiaz\u0103",
          evening: "sear\u0103",
          night: "noapte"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "miezul nop\u021Bii",
          noon: "amiaz\u0103",
          morning: "diminea\u021B\u0103",
          afternoon: "dup\u0103-amiaz\u0103",
          evening: "sear\u0103",
          night: "noapte"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "miezul nop\u021Bii",
          noon: "amiaz\u0103",
          morning: "diminea\u021B\u0103",
          afternoon: "dup\u0103-amiaz\u0103",
          evening: "sear\u0103",
          night: "noapte"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return String(number);
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(Î|D)/i,
        abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
        wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
      };
      var parseEraPatterns = {
        any: [/^ÎC/i, /^DC/i],
        wide: [/^(Înainte de Cristos|Înaintea erei noastre)/i, /^(După Cristos|Era noastră)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^T[1234]/i,
        wide: /^trimestrul [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[ifmaasond]/i,
        abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
        wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
      };
      var parseMonthPatterns = {
        narrow: [/^i/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ia/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^iun/i, /^iul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[dlmjvs]/i,
        short: /^(d|l|ma|mi|j|v|s)/i,
        abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
        wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
        any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
        any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mn/i,
          noon: /amiaza/i,
          morning: /dimineaţa/i,
          afternoon: /după-amiaza/i,
          evening: /seara/i,
          night: /noaptea/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;

      function declension(scheme, count) {
        // scheme for count=1 exists
        if (scheme.one !== undefined && count === 1) {
          return scheme.one;
        }

        var rem10 = count % 10;
        var rem100 = count % 100; // 1, 21, 31, ...

        if (rem10 === 1 && rem100 !== 11) {
          return scheme.singularNominative.replace("{{count}}", count); // 2, 3, 4, 22, 23, 24, 32 ...
        } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
          return scheme.singularGenitive.replace("{{count}}", count); // 5, 6, 7, 8, 9, 10, 11, ...
        } else {
          return scheme.pluralGenitive.replace("{{count}}", count);
        }
      }

      function buildLocalizeTokenFn(scheme) {
        return function (count, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              if (scheme.future) {
                return declension(scheme.future, count);
              } else {
                return "\u0447\u0435\u0440\u0435\u0437 " + declension(scheme.regular, count);
              }
            } else {
              if (scheme.past) {
                return declension(scheme.past, count);
              } else {
                return declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
              }
            }
          } else {
            return declension(scheme.regular, count);
          }
        };
      }

      var formatDistanceLocale = {
        lessThanXSeconds: buildLocalizeTokenFn({
          regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
          },
          future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
          }
        }),
        xSeconds: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
          },
          past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
          },
          future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
          }
        }),
        halfAMinute: function (_, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            } else {
              return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
            }
          }

          return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
        },
        lessThanXMinutes: buildLocalizeTokenFn({
          regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
          },
          future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
          }
        }),
        xMinutes: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
          },
          past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
          },
          future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
          }
        }),
        aboutXHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
          },
          future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
          }
        }),
        xHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
          }
        }),
        xDays: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
          }
        }),
        aboutXWeeks: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
          },
          future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
          }
        }),
        xWeeks: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
          }
        }),
        aboutXMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
          },
          future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
          }
        }),
        xMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
          }
        }),
        aboutXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
          },
          future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
          }
        }),
        xYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
          }
        }),
        overXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
          },
          future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
          }
        }),
        almostXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
          },
          future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
          }
        })
      };

      function formatDistance(token, count, options) {
        options = options || {};
        return formatDistanceLocale[token](count, options);
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d MMMM y '\u0433.'",
        long: "d MMMM y '\u0433.'",
        medium: "d MMM y '\u0433.'",
        short: "dd.MM.y"
      };
      var timeFormats = {
        full: "H:mm:ss zzzz",
        long: "H:mm:ss z",
        medium: "H:mm:ss",
        short: "H:mm"
      };
      var dateTimeFormats = {
        any: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "any"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;

      var _index = _interopRequireDefault(__webpack_require__(8));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var accusativeWeekdays = ["\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u0435\u0434\u0443", "\u0447\u0435\u0442\u0432\u0435\u0440\u0433", "\u043F\u044F\u0442\u043D\u0438\u0446\u0443", "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"];

      function lastWeek(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";

          case 1:
          case 2:
          case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";

          case 3:
          case 5:
          case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
        }
      }

      function thisWeek(day) {
        var weekday = accusativeWeekdays[day];

        if (day === 2
        /* Tue */
        ) {
          return "'\u0432\u043E " + weekday + " \u0432' p";
        } else {
          return "'\u0432 " + weekday + " \u0432' p";
        }
      }

      function nextWeek(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";

          case 1:
          case 2:
          case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";

          case 3:
          case 5:
          case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return lastWeek(day);
          }
        },
        yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
        today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
        tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
        nextWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return nextWeek(day);
          }
        },
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date, baseDate, options);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u0434\u043E \u043D.\u044D.", "\u043D.\u044D."],
        abbreviated: ["\u0434\u043E \u043D. \u044D.", "\u043D. \u044D."],
        wide: ["\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B", "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1-\u0439 \u043A\u0432.", "2-\u0439 \u043A\u0432.", "3-\u0439 \u043A\u0432.", "4-\u0439 \u043A\u0432."],
        wide: ["1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
      };
      var monthValues = {
        narrow: ["\u042F", "\u0424", "\u041C", "\u0410", "\u041C", "\u0418", "\u0418", "\u0410", "\u0421", "\u041E", "\u041D", "\u0414"],
        abbreviated: ["\u044F\u043D\u0432.", "\u0444\u0435\u0432.", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440.", "\u043C\u0430\u0439", "\u0438\u044E\u043D\u044C", "\u0438\u044E\u043B\u044C", "\u0430\u0432\u0433.", "\u0441\u0435\u043D\u0442.", "\u043E\u043A\u0442.", "\u043D\u043E\u044F\u0431.", "\u0434\u0435\u043A."],
        wide: ["\u044F\u043D\u0432\u0430\u0440\u044C", "\u0444\u0435\u0432\u0440\u0430\u043B\u044C", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0435\u043B\u044C", "\u043C\u0430\u0439", "\u0438\u044E\u043D\u044C", "\u0438\u044E\u043B\u044C", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C", "\u043E\u043A\u0442\u044F\u0431\u0440\u044C", "\u043D\u043E\u044F\u0431\u0440\u044C", "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"]
      };
      var formattingMonthValues = {
        narrow: ["\u042F", "\u0424", "\u041C", "\u0410", "\u041C", "\u0418", "\u0418", "\u0410", "\u0421", "\u041E", "\u041D", "\u0414"],
        abbreviated: ["\u044F\u043D\u0432.", "\u0444\u0435\u0432.", "\u043C\u0430\u0440.", "\u0430\u043F\u0440.", "\u043C\u0430\u044F", "\u0438\u044E\u043D.", "\u0438\u044E\u043B.", "\u0430\u0432\u0433.", "\u0441\u0435\u043D\u0442.", "\u043E\u043A\u0442.", "\u043D\u043E\u044F\u0431.", "\u0434\u0435\u043A."],
        wide: ["\u044F\u043D\u0432\u0430\u0440\u044F", "\u0444\u0435\u0432\u0440\u0430\u043B\u044F", "\u043C\u0430\u0440\u0442\u0430", "\u0430\u043F\u0440\u0435\u043B\u044F", "\u043C\u0430\u044F", "\u0438\u044E\u043D\u044F", "\u0438\u044E\u043B\u044F", "\u0430\u0432\u0433\u0443\u0441\u0442\u0430", "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F", "\u043E\u043A\u0442\u044F\u0431\u0440\u044F", "\u043D\u043E\u044F\u0431\u0440\u044F", "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"]
      };
      var dayValues = {
        narrow: ["\u0412", "\u041F", "\u0412", "\u0421", "\u0427", "\u041F", "\u0421"],
        short: ["\u0432\u0441", "\u043F\u043D", "\u0432\u0442", "\u0441\u0440", "\u0447\u0442", "\u043F\u0442", "\u0441\u0431"],
        abbreviated: ["\u0432\u0441\u043A", "\u043F\u043D\u0434", "\u0432\u0442\u0440", "\u0441\u0440\u0434", "\u0447\u0442\u0432", "\u043F\u0442\u043D", "\u0441\u0443\u0431"],
        wide: ["\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u0435\u0434\u0430", "\u0447\u0435\u0442\u0432\u0435\u0440\u0433", "\u043F\u044F\u0442\u043D\u0438\u0446\u0430", "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u043E\u043B\u043D.",
          noon: "\u043F\u043E\u043B\u0434.",
          morning: "\u0443\u0442\u0440\u043E",
          afternoon: "\u0434\u0435\u043D\u044C",
          evening: "\u0432\u0435\u0447.",
          night: "\u043D\u043E\u0447\u044C"
        },
        abbreviated: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u043E\u043B\u043D.",
          noon: "\u043F\u043E\u043B\u0434.",
          morning: "\u0443\u0442\u0440\u043E",
          afternoon: "\u0434\u0435\u043D\u044C",
          evening: "\u0432\u0435\u0447.",
          night: "\u043D\u043E\u0447\u044C"
        },
        wide: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
          noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
          morning: "\u0443\u0442\u0440\u043E",
          afternoon: "\u0434\u0435\u043D\u044C",
          evening: "\u0432\u0435\u0447\u0435\u0440",
          night: "\u043D\u043E\u0447\u044C"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u043E\u043B\u043D.",
          noon: "\u043F\u043E\u043B\u0434.",
          morning: "\u0443\u0442\u0440\u0430",
          afternoon: "\u0434\u043D\u044F",
          evening: "\u0432\u0435\u0447.",
          night: "\u043D\u043E\u0447\u0438"
        },
        abbreviated: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u043E\u043B\u043D.",
          noon: "\u043F\u043E\u043B\u0434.",
          morning: "\u0443\u0442\u0440\u0430",
          afternoon: "\u0434\u043D\u044F",
          evening: "\u0432\u0435\u0447.",
          night: "\u043D\u043E\u0447\u0438"
        },
        wide: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
          noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
          morning: "\u0443\u0442\u0440\u0430",
          afternoon: "\u0434\u043D\u044F",
          evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
          night: "\u043D\u043E\u0447\u0438"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var suffix;

        if (unit === "date") {
          suffix = "-\u0435";
        } else if (unit === "week" || unit === "minute" || unit === "second") {
          suffix = "-\u044F";
        } else {
          suffix = "-\u0439";
        }

        return dirtyNumber + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "any",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^((до )?н\.?\s?э\.?)/i,
        abbreviated: /^((до )?н\.?\s?э\.?)/i,
        wide: /^(до нашей эры|нашей эры|наша эра)/i
      };
      var parseEraPatterns = {
        any: [/^д/i, /^н/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
        wide: /^[1234](-?[ыои]?й?)? квартал/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[яфмаисонд]/i,
        abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
        wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
      };
      var parseMonthPatterns = {
        narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
        any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
      };
      var matchDayPatterns = {
        narrow: /^[впсч]/i,
        short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
        abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
        wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
      };
      var parseDayPatterns = {
        narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
        any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
        abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
        wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^дп/i,
          pm: /^пп/i,
          midnight: /^полн/i,
          noon: /^полд/i,
          morning: /^у/i,
          afternoon: /^д[ен]/i,
          evening: /^в/i,
          night: /^н/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance; // NOTE: should prolly be improved
      // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308

      function declensionGroup(scheme, count) {
        if (count === 1) {
          return scheme.one;
        }

        if (count >= 2 && count <= 4) {
          return scheme.twoFour;
        } // if count === null || count === 0 || count >= 5


        return scheme.other;
      }

      function declension(scheme, count, time) {
        var group = declensionGroup(scheme, count);
        var finalText = group[time] || group;
        return finalText.replace("{{count}}", count);
      }

      function extractPreposition(token) {
        var result = ["lessThan", "about", "over", "almost"].filter(function (preposition) {
          return !!token.match(new RegExp("^" + preposition));
        });
        return result[0];
      }

      function prefixPreposition(preposition) {
        var translation = "";

        if (preposition === "almost") {
          translation = "takmer";
        }

        if (preposition === "about") {
          translation = "pribli\u017Ene";
        }

        return translation.length > 0 ? translation + " " : "";
      }

      function suffixPreposition(preposition) {
        var translation = "";

        if (preposition === "lessThan") {
          translation = "menej ne\u017E";
        }

        if (preposition === "over") {
          translation = "viac ne\u017E";
        }

        return translation.length > 0 ? translation + " " : "";
      }

      function lowercaseFirstLetter(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
      }

      var formatDistanceLocale = {
        xSeconds: {
          one: {
            regular: "sekunda",
            past: "sekundou",
            future: "sekundu"
          },
          twoFour: {
            regular: "{{count}} sekundy",
            past: "{{count}} sekundami",
            future: "{{count}} sekundy"
          },
          other: {
            regular: "{{count}} sek\xFAnd",
            past: "{{count}} sekundami",
            future: "{{count}} sek\xFAnd"
          }
        },
        halfAMinute: {
          other: {
            regular: "pol min\xFAty",
            past: "pol min\xFAtou",
            future: "pol min\xFAty"
          }
        },
        xMinutes: {
          one: {
            regular: "min\xFAta",
            past: "min\xFAtou",
            future: "min\xFAtu"
          },
          twoFour: {
            regular: "{{count}} min\xFAty",
            past: "{{count}} min\xFAtami",
            future: "{{count}} min\xFAty"
          },
          other: {
            regular: "{{count}} min\xFAt",
            past: "{{count}} min\xFAtami",
            future: "{{count}} min\xFAt"
          }
        },
        xHours: {
          one: {
            regular: "hodina",
            past: "hodinou",
            future: "hodinu"
          },
          twoFour: {
            regular: "{{count}} hodiny",
            past: "{{count}} hodinami",
            future: "{{count}} hodiny"
          },
          other: {
            regular: "{{count}} hod\xEDn",
            past: "{{count}} hodinami",
            future: "{{count}} hod\xEDn"
          }
        },
        xDays: {
          one: {
            regular: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
          },
          twoFour: {
            regular: "{{count}} dni",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dni"
          },
          other: {
            regular: "{{count}} dn\xED",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xED"
          }
        },
        xWeeks: {
          one: {
            regular: "mesiac",
            // TODO
            past: "mesiacom",
            // TODO
            future: "mesiac" // TODO

          },
          twoFour: {
            regular: "{{count}} mesiace",
            // TODO
            past: "{{count}} mesiacmi",
            // TODO
            future: "{{count}} mesiace" // TODO

          },
          other: {
            regular: "{{count}} mesiacov",
            // TODO
            past: "{{count}} mesiacmi",
            // TODO
            future: "{{count}} mesiacov" // TODO

          }
        },
        xMonths: {
          one: {
            regular: "mesiac",
            past: "mesiacom",
            future: "mesiac"
          },
          twoFour: {
            regular: "{{count}} mesiace",
            past: "{{count}} mesiacmi",
            future: "{{count}} mesiace"
          },
          other: {
            regular: "{{count}} mesiacov",
            past: "{{count}} mesiacmi",
            future: "{{count}} mesiacov"
          }
        },
        xYears: {
          one: {
            regular: "rok",
            past: "rokom",
            future: "rok"
          },
          twoFour: {
            regular: "{{count}} roky",
            past: "{{count}} rokmi",
            future: "{{count}} roky"
          },
          other: {
            regular: "{{count}} rokov",
            past: "{{count}} rokmi",
            future: "{{count}} rokov"
          }
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var preposition = extractPreposition(token) || "";
        var key = lowercaseFirstLetter(token.substring(preposition.length));
        var scheme = formatDistanceLocale[key];

        if (!options.addSuffix) {
          return prefixPreposition(preposition) + suffixPreposition(preposition) + declension(scheme, count, "regular");
        }

        if (options.comparison > 0) {
          return prefixPreposition(preposition) + "o " + suffixPreposition(preposition) + declension(scheme, count, "future");
        } else {
          return prefixPreposition(preposition) + "pred " + suffixPreposition(preposition) + declension(scheme, count, "past");
        }
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1986


      var dateFormats = {
        full: "EEEE d. MMMM y",
        long: "d. MMMM y",
        medium: "d. M. y",
        short: "d. M. y"
      }; // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149

      var timeFormats = {
        full: "H:mm:ss zzzz",
        long: "H:mm:ss z",
        medium: "H:mm:ss",
        short: "H:mm"
      }; // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994

      var dateTimeFormats = {
        full: "{{date}}, {{time}}",
        long: "{{date}}, {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;

      var _index = _interopRequireDefault(__webpack_require__(8));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308


      var accusativeWeekdays = ["nede\u013Eu", "pondelok", "utorok", "stredu", "\u0161tvrtok", "piatok", "sobotu"];

      function lastWeek(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
          /* Sun */

          case 3:
          /* Wed */

          case 6
          /* Sat */
          :
            return "'minul\xFA " + weekday + " o' p";

          default:
            return "'minul\xFD' eeee 'o' p";
        }
      }

      function thisWeek(day) {
        var weekday = accusativeWeekdays[day];

        if (day === 4
        /* Thu */
        ) {
          return "'vo' eeee 'o' p";
        } else {
          return "'v " + weekday + " o' p";
        }
      }

      function nextWeek(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
          /* Sun */

          case 4:
          /* Wed */

          case 6
          /* Sat */
          :
            return "'bud\xFAcu " + weekday + " o' p";

          default:
            return "'bud\xFAci' eeee 'o' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return lastWeek(day);
          }
        },
        yesterday: "'v\u010Dera o' p",
        today: "'dnes o' p",
        tomorrow: "'zajtra o' p",
        nextWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return nextWeek(day);
          }
        },
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date, baseDate, options);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // https://www.unicode.org/cldr/charts/32/summary/sk.html#1772


      var eraValues = {
        narrow: ["pred Kr.", "po Kr."],
        abbreviated: ["pred Kr.", "po Kr."],
        wide: ["pred Kristom", "po Kristovi"]
      }; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1780

      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1. \u0161tvr\u0165rok", "2. \u0161tvr\u0165rok", "3. \u0161tvr\u0165rok", "4. \u0161tvr\u0165rok"]
      }; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1804

      var monthValues = {
        narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
        abbreviated: ["jan", "feb", "mar", "apr", "m\xE1j", "j\xFAn", "j\xFAl", "aug", "sep", "okt", "nov", "dec"],
        wide: ["janu\xE1r", "febru\xE1r", "marec", "apr\xEDl", "m\xE1j", "j\xFAn", "j\xFAl", "august", "september", "okt\xF3ber", "november", "december"]
      };
      var formattingMonthValues = {
        narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
        abbreviated: ["jan", "feb", "mar", "apr", "m\xE1j", "j\xFAn", "j\xFAl", "aug", "sep", "okt", "nov", "dec"],
        wide: ["janu\xE1ra", "febru\xE1ra", "marca", "apr\xEDla", "m\xE1ja", "j\xFAna", "j\xFAla", "augusta", "septembra", "okt\xF3bra", "novembra", "decembra"]
      }; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1876

      var dayValues = {
        narrow: ["n", "p", "u", "s", "\u0161", "p", "s"],
        short: ["ne", "po", "ut", "st", "\u0161t", "pi", "so"],
        abbreviated: ["ne", "po", "ut", "st", "\u0161t", "pi", "so"],
        wide: ["nede\u013Ea", "pondelok", "utorok", "streda", "\u0161tvrtok", "piatok", "sobota"]
      }; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1932

      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "poln.",
          noon: "pol.",
          morning: "r\xE1no",
          afternoon: "pop.",
          evening: "ve\u010D.",
          night: "noc"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "poln.",
          noon: "pol.",
          morning: "r\xE1no",
          afternoon: "popol.",
          evening: "ve\u010Der",
          night: "noc"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "polnoc",
          noon: "poludnie",
          morning: "r\xE1no",
          afternoon: "popoludnie",
          evening: "ve\u010Der",
          night: "noc"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "o poln.",
          noon: "nap.",
          morning: "r\xE1no",
          afternoon: "pop.",
          evening: "ve\u010D.",
          night: "v n."
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "o poln.",
          noon: "napol.",
          morning: "r\xE1no",
          afternoon: "popol.",
          evening: "ve\u010Der",
          night: "v noci"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "o polnoci",
          noon: "napoludnie",
          morning: "r\xE1no",
          afternoon: "popoludn\xED",
          evening: "ve\u010Der",
          night: "v noci"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + ".";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues // defaultWidth: 'wide'

        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)\.?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
        abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
        wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
      };
      var parseEraPatterns = {
        any: [/^pr/i, /^(po|n)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234]\. [šs]tvr[ťt]rok/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
        wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^m[áa]j/i, /^j[úu]n/i, /^j[úu]l/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[npusšp]/i,
        short: /^(ne|po|ut|st|št|pi|so)/i,
        abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
        wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
      };
      var parseDayPatterns = {
        narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
        any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
        abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
        any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^am/i,
          pm: /^pm/i,
          midnight: /poln/i,
          noon: /^(nap|(na)?pol(\.|u))/i,
          morning: /^r[áa]no/i,
          afternoon: /^pop/i,
          evening: /^ve[čc]/i,
          night: /^(noc|v n\.)/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var distanceInWordsLocale = {
        lessThanXSeconds: {
          one: "manj kot {{count}} sekunda",
          two: "manj kot {{count}} sekundi",
          few: "manj kot {{count}} sekunde",
          other: "manj kot {{count}} sekund"
        },
        xSeconds: {
          one: "{{count}} sekunda",
          two: "{{count}} sekundi",
          few: "{{count}} sekunde",
          other: "{{count}} sekund"
        },
        halfAMinute: "pol minute",
        lessThanXMinutes: {
          one: "manj kot {{count}} minuta",
          two: "manj kot {{count}} minuti",
          few: "manj kot {{count}} minute",
          other: "manj kot {{count}} minut"
        },
        xMinutes: {
          one: "{{count}} minuta",
          two: "{{count}} minuti",
          few: "{{count}} minute",
          other: "{{count}} minut"
        },
        aboutXHours: {
          one: "pribli\u017Eno {{count}} ura",
          two: "pribli\u017Eno {{count}} uri",
          few: "pribli\u017Eno {{count}} ure",
          other: "pribli\u017Eno {{count}} ur"
        },
        xHours: {
          one: "{{count}} ura",
          two: "{{count}} uri",
          few: "{{count}} ure",
          other: "{{count}} ur"
        },
        xDays: {
          one: "{{count}} dan",
          two: "{{count}} dni",
          few: "{{count}} dni",
          other: "{{count}} dni"
        },
        aboutXWeeks: {
          one: "pribli\u017Eno {{count}} teden",
          two: "pribli\u017Eno {{count}} tedna",
          few: "pribli\u017Eno {{count}} tedne",
          other: "pribli\u017Eno {{count}} tednov"
        },
        xWeeks: {
          one: "{{count}} teden",
          two: "{{count}} tedna",
          few: "{{count}} tedne",
          other: "{{count}} tednov"
        },
        aboutXMonths: {
          one: "pribli\u017Eno {{count}} mesec",
          two: "pribli\u017Eno {{count}} meseca",
          few: "pribli\u017Eno {{count}} mesece",
          other: "pribli\u017Eno {{count}} mesecev"
        },
        xMonths: {
          one: "{{count}} mesec",
          two: "{{count}} meseca",
          few: "{{count}} meseci",
          other: "{{count}} mesecev"
        },
        aboutXYears: {
          one: "pribli\u017Eno {{count}} leto",
          two: "pribli\u017Eno {{count}} leti",
          few: "pribli\u017Eno {{count}} leta",
          other: "pribli\u017Eno {{count}} let"
        },
        xYears: {
          one: "{{count}} leto",
          two: "{{count}} leti",
          few: "{{count}} leta",
          other: "{{count}} let"
        },
        overXYears: {
          one: "ve\u010D kot {{count}} leto",
          two: "ve\u010D kot {{count}} leti",
          few: "ve\u010D kot {{count}} leta",
          other: "ve\u010D kot {{count}} let"
        },
        almostXYears: {
          one: "skoraj {{count}} leto",
          two: "skoraj {{count}} leti",
          few: "skoraj {{count}} leta",
          other: "skoraj {{count}} let"
        }
      };
      var distanceInWordsLocalePast = {
        lessThanXSeconds: {
          one: "manj kot {{count}} sekundo",
          two: "manj kot {{count}} sekundama",
          few: "manj kot {{count}} sekundami",
          other: "manj kot {{count}} sekundami"
        },
        xSeconds: {
          one: "{{count}} sekundo",
          two: "{{count}} sekundama",
          few: "{{count}} sekundami",
          other: "{{count}} sekundami"
        },
        halfAMinute: "pol minute",
        lessThanXMinutes: {
          one: "manj kot {{count}} minuto",
          two: "manj kot {{count}} minutama",
          few: "manj kot {{count}} minutami",
          other: "manj kot {{count}} minutami"
        },
        xMinutes: {
          one: "{{count}} minuto",
          two: "{{count}} minutama",
          few: "{{count}} minutami",
          other: "{{count}} minutami"
        },
        aboutXHours: {
          one: "pribli\u017Eno {{count}} uro",
          two: "pribli\u017Eno {{count}} urama",
          few: "pribli\u017Eno {{count}} urami",
          other: "pribli\u017Eno {{count}} urami"
        },
        xHours: {
          one: "{{count}} uro",
          two: "{{count}} urama",
          few: "{{count}} urami",
          other: "{{count}} urami"
        },
        xDays: {
          one: "{{count}} dnem",
          two: "{{count}} dnevoma",
          few: "{{count}} dnevi",
          other: "{{count}} dnevi"
        },
        aboutXMonths: {
          one: "pribli\u017Eno {{count}} mesecem",
          two: "pribli\u017Eno {{count}} mesecema",
          few: "pribli\u017Eno {{count}} meseci",
          other: "pribli\u017Eno {{count}} meseci"
        },
        xMonths: {
          one: "{{count}} mesecem",
          two: "{{count}} mesecema",
          few: "{{count}} meseci",
          other: "{{count}} meseci"
        },
        aboutXYears: {
          one: "pribli\u017Eno {{count}} letom",
          two: "pribli\u017Eno {{count}} letoma",
          few: "pribli\u017Eno {{count}} leti",
          other: "pribli\u017Eno {{count}} leti"
        },
        xYears: {
          one: "{{count}} letom",
          two: "{{count}} letoma",
          few: "{{count}} leti",
          other: "{{count}} leti"
        },
        overXYears: {
          one: "ve\u010D kot {{count}} letom",
          two: "ve\u010D kot {{count}} letoma",
          few: "ve\u010D kot {{count}} leti",
          other: "ve\u010D kot {{count}} leti"
        },
        almostXYears: {
          one: "skoraj {{count}} letom",
          two: "skoraj {{count}} letoma",
          few: "skoraj {{count}} leti",
          other: "skoraj {{count}} leti"
        }
      };
      var distanceInWordsLocaleFuture = {
        lessThanXSeconds: {
          one: "manj kot {{count}} sekundo",
          two: "manj kot {{count}} sekundi",
          few: "manj kot {{count}} sekunde",
          other: "manj kot {{count}} sekund"
        },
        xSeconds: {
          one: "{{count}} sekundo",
          two: "{{count}} sekundi",
          few: "{{count}} sekunde",
          other: "{{count}} sekund"
        },
        halfAMinute: "pol minute",
        lessThanXMinutes: {
          one: "manj kot {{count}} minuto",
          two: "manj kot {{count}} minuti",
          few: "manj kot {{count}} minute",
          other: "manj kot {{count}} minut"
        },
        xMinutes: {
          one: "{{count}} minuto",
          two: "{{count}} minuti",
          few: "{{count}} minute",
          other: "{{count}} minut"
        },
        aboutXHours: {
          one: "pribli\u017Eno {{count}} uro",
          two: "pribli\u017Eno {{count}} uri",
          few: "pribli\u017Eno {{count}} ure",
          other: "pribli\u017Eno {{count}} ur"
        },
        xHours: {
          one: "{{count}} uro",
          two: "{{count}} uri",
          few: "{{count}} ure",
          other: "{{count}} ur"
        },
        xDays: {
          one: "{{count}} dan",
          two: "{{count}} dni",
          few: "{{count}} dni",
          other: "{{count}} dni"
        },
        aboutXMonths: {
          one: "pribli\u017Eno {{count}} mesec",
          two: "pribli\u017Eno {{count}} meseca",
          few: "pribli\u017Eno {{count}} mesece",
          other: "pribli\u017Eno {{count}} mesecev"
        },
        xMonths: {
          one: "{{count}} mesec",
          two: "{{count}} meseca",
          few: "{{count}} mesece",
          other: "{{count}} mesecev"
        },
        aboutXYears: {
          one: "pribli\u017Eno {{count}} leto",
          two: "pribli\u017Eno {{count}} leti",
          few: "pribli\u017Eno {{count}} leta",
          other: "pribli\u017Eno {{count}} let"
        },
        xYears: {
          one: "{{count}} leto",
          two: "{{count}} leti",
          few: "{{count}} leta",
          other: "{{count}} let"
        },
        overXYears: {
          one: "ve\u010D kot {{count}} leto",
          two: "ve\u010D kot {{count}} leti",
          few: "ve\u010D kot {{count}} leta",
          other: "ve\u010D kot {{count}} let"
        },
        almostXYears: {
          one: "skoraj {{count}} leto",
          two: "skoraj {{count}} leti",
          few: "skoraj {{count}} leta",
          other: "skoraj {{count}} let"
        }
      };

      function getFormFromCount(count) {
        switch (count % 100) {
          case 1:
            return "one";

          case 2:
            return "two";

          case 3:
          case 4:
            return "few";

          default:
            return "other";
        }
      }

      function formatDistance(token, count, options) {
        options = options || {};
        var localeObject = distanceInWordsLocale;
        var result = "";

        if (options.addSuffix) {
          if (options.comparison > 0) {
            localeObject = distanceInWordsLocaleFuture;
            result += "\u010Dez ";
          } else {
            localeObject = distanceInWordsLocalePast;
            result += "pred ";
          }
        }

        if (typeof localeObject[token] === "string") {
          result += localeObject[token];
        } else {
          var form = getFormFromCount(count);
          result += localeObject[token][form].replace("{{count}}", count);
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, dd. MMMM y",
        long: "dd. MMMM y",
        medium: "d. MMM y",
        short: "d. MM. yy"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        long: "{{date}} {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function (date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'prej\u0161njo nedeljo ob' p";

            case 3:
              return "'prej\u0161njo sredo ob' p";

            case 6:
              return "'prej\u0161njo soboto ob' p";

            default:
              return "'prej\u0161nji' EEEE 'ob' p";
          }
        },
        yesterday: "'v\u010Deraj ob' p",
        today: "'danes ob' p",
        tomorrow: "'jutri ob' p",
        nextWeek: function (date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'naslednjo nedeljo ob' p";

            case 3:
              return "'naslednjo sredo ob' p";

            case 6:
              return "'naslednjo soboto ob' p";

            default:
              return "'naslednji' EEEE 'ob' p";
          }
        },
        other: "P"
      };

      function formatRelative(token, date, _baseDate, _options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return String(number).concat(".");
      }

      var eraValues = {
        narrow: ["pr. n. \u0161t.", "po n. \u0161t."],
        abbreviated: ["pr. n. \u0161t.", "po n. \u0161t."],
        wide: ["pred na\u0161im \u0161tetjem", "po na\u0161em \u0161tetju"]
      };
      var monthValues = {
        narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
        abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "avg.", "sep.", "okt.", "nov.", "dec."],
        wide: ["januar", "februar", "marec", "april", "maj", "junij", "julij", "avgust", "september", "oktober", "november", "december"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1. \u010Det.", "2. \u010Det.", "3. \u010Det.", "4. \u010Det."],
        wide: ["1. \u010Detrtletje", "2. \u010Detrtletje", "3. \u010Detrtletje", "4. \u010Detrtletje"]
      };
      var dayValues = {
        narrow: ["n", "p", "t", "s", "\u010D", "p", "s"],
        short: ["ned.", "pon.", "tor.", "sre.", "\u010Det.", "pet.", "sob."],
        abbreviated: ["ned.", "pon.", "tor.", "sre.", "\u010Det.", "pet.", "sob."],
        wide: ["nedelja", "ponedeljek", "torek", "sreda", "\u010Detrtek", "petek", "sobota"]
      };
      var dayPeriodValuesStandalone = {
        narrow: {
          am: "d",
          pm: "p",
          midnight: "24.00",
          noon: "12.00",
          morning: "j",
          afternoon: "p",
          evening: "v",
          night: "n"
        },
        abbreviated: {
          am: "dop.",
          pm: "pop.",
          midnight: "poln.",
          noon: "pold.",
          morning: "jut.",
          afternoon: "pop.",
          evening: "ve\u010D.",
          night: "no\u010D"
        },
        wide: {
          am: "dop.",
          pm: "pop.",
          midnight: "polno\u010D",
          noon: "poldne",
          morning: "jutro",
          afternoon: "popoldne",
          evening: "ve\u010Der",
          night: "no\u010D"
        }
      };
      var dayPeriodValuesFormatting = {
        narrow: {
          am: "d",
          pm: "p",
          midnight: "24.00",
          noon: "12.00",
          morning: "zj",
          afternoon: "p",
          evening: "zv",
          night: "po"
        },
        abbreviated: {
          am: "dop.",
          pm: "pop.",
          midnight: "opoln.",
          noon: "opold.",
          morning: "zjut.",
          afternoon: "pop.",
          evening: "zve\u010D.",
          night: "pono\u010Di"
        },
        wide: {
          am: "dop.",
          pm: "pop.",
          midnight: "opolno\u010Di",
          noon: "opoldne",
          morning: "zjutraj",
          afternoon: "popoldan",
          evening: "zve\u010Der",
          night: "pono\u010Di"
        }
      };
      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValuesStandalone,
          defaultWidth: "wide",
          formattingValues: dayPeriodValuesFormatting,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)\./i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
        wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
      };
      var parseEraPatterns = {
        any: [/^pr/i, /^(po|na[sš]em)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]\.\s?[čc]et\.?/i,
        wide: /^[1234]\. [čc]etrtletje/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
        wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        abbreviated: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i],
        wide: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[nptsčc]/i,
        short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
        abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
        wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
      };
      var parseDayPatterns = {
        narrow: [/^n/i, /^p/i, /^t/i, /^s/i, /^[cč]/i, /^p/i, /^s/i],
        any: [/^n/i, /^po/i, /^t/i, /^sr/i, /^[cč]/i, /^pe/i, /^so/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
        any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
      };
      var parseDayPeriodPatterns = {
        narrow: {
          am: /^d/i,
          pm: /^p/i,
          midnight: /^24/i,
          noon: /^12/i,
          morning: /^(z?j)/i,
          afternoon: /^p/i,
          evening: /^(z?v)/i,
          night: /^(n|po)/i
        },
        any: {
          am: /^dop\./i,
          pm: /^pop\./i,
          midnight: /^o?poln/i,
          noon: /^o?pold/i,
          morning: /j/i,
          afternoon: /^pop\./i,
          evening: /^z?ve/i,
          night: /(po)?no/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "wide"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "m\xEB pak se nj\xEB sekond\xEB",
          other: "m\xEB pak se {{count}} sekonda"
        },
        xSeconds: {
          one: "1 sekond\xEB",
          other: "{{count}} sekonda"
        },
        halfAMinute: "gjys\xEBm minuti",
        lessThanXMinutes: {
          one: "m\xEB pak se nj\xEB minute",
          other: "m\xEB pak se {{count}} minuta"
        },
        xMinutes: {
          one: "1 minut\xEB",
          other: "{{count}} minuta"
        },
        aboutXHours: {
          one: "rreth 1 or\xEB",
          other: "rreth {{count}} or\xEB"
        },
        xHours: {
          one: "1 or\xEB",
          other: "{{count}} or\xEB"
        },
        xDays: {
          one: "1 dit\xEB",
          other: "{{count}} dit\xEB"
        },
        aboutXWeeks: {
          one: "rreth 1 jav\xEB",
          other: "rreth {{count}} jav\xEB"
        },
        xWeeks: {
          one: "1 jav\xEB",
          other: "{{count}} jav\xEB"
        },
        aboutXMonths: {
          one: "rreth 1 muaj",
          other: "rreth {{count}} muaj"
        },
        xMonths: {
          one: "1 muaj",
          other: "{{count}} muaj"
        },
        aboutXYears: {
          one: "rreth 1 vit",
          other: "rreth {{count}} vite"
        },
        xYears: {
          one: "1 vit",
          other: "{{count}} vite"
        },
        overXYears: {
          one: "mbi 1 vit",
          other: "mbi {{count}} vite"
        },
        almostXYears: {
          one: "pothuajse 1 vit",
          other: "pothuajse {{count}} vite"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "n\xEB " + result;
          } else {
            return result + " m\xEB par\xEB";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, MMMM do, y",
        long: "MMMM do, y",
        medium: "MMM d, y",
        short: "MM/dd/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} 'n\xEB' {{time}}",
        long: "{{date}} 'n\xEB' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'t\xEB' eeee 'e shkuar n\xEB' p",
        yesterday: "'dje n\xEB' p",
        today: "'sot n\xEB' p",
        tomorrow: "'nes\xEBr n\xEB' p",
        nextWeek: "eeee 'at' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["P", "M"],
        abbreviated: ["PK", "MK"],
        wide: ["Para Krishtit", "Mbas Krishtit"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["4-mujori I", "4-mujori II", "4-mujori III", "4-mujori IV"]
      }; // Note: in English, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["J", "S", "M", "P", "M", "Q", "K", "G", "S", "T", "N", "D"],
        abbreviated: ["Jan", "Shk", "Mar", "Pri", "Maj", "Qer", "Kor", "Gus", "Sht", "Tet", "N\xEBn", "Dhj"],
        wide: ["Janar", "Shkurt", "Mars", "Prill", "Maj", "Qershor", "Korrik", "Gusht", "Shtator", "Tetor", "N\xEBntor", "Dhjetor"]
      };
      var dayValues = {
        narrow: ["D", "H", "M", "M", "E", "P", "S"],
        short: ["Di", "H\xEB", "Ma", "M\xEB", "En", "Pr", "Sh"],
        abbreviated: ["Die", "H\xEBn", "Mar", "M\xEBr", "Enj", "Pre", "Sht"],
        wide: ["Diel\xEB", "H\xEBn\xEB", "Mart\xEB", "M\xEBrkur\xEB", "Enjte", "Premte", "Shtun\xEB"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "p",
          pm: "m",
          midnight: "m",
          noon: "d",
          morning: "m\xEBngjes",
          afternoon: "dite",
          evening: "mbr\xEBmje",
          night: "nat\xEB"
        },
        abbreviated: {
          am: "PD",
          pm: "MD",
          midnight: "mesn\xEBt\xEB",
          noon: "drek",
          morning: "m\xEBngjes",
          afternoon: "mbasdite",
          evening: "mbr\xEBmje",
          night: "nat\xEB"
        },
        wide: {
          am: "p.d.",
          pm: "m.d.",
          midnight: "mesn\xEBt\xEB",
          noon: "drek",
          morning: "m\xEBngjes",
          afternoon: "mbasdite",
          evening: "mbr\xEBmje",
          night: "nat\xEB"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "p",
          pm: "m",
          midnight: "m",
          noon: "d",
          morning: "n\xEB m\xEBngjes",
          afternoon: "n\xEB mbasdite",
          evening: "n\xEB mbr\xEBmje",
          night: "n\xEB mesnat\xEB"
        },
        abbreviated: {
          am: "PD",
          pm: "MD",
          midnight: "mesnat\xEB",
          noon: "drek",
          morning: "n\xEB m\xEBngjes",
          afternoon: "n\xEB mbasdite",
          evening: "n\xEB mbr\xEBmje",
          night: "n\xEB mesnat\xEB"
        },
        wide: {
          am: "p.d.",
          pm: "m.d.",
          midnight: "mesnat\xEB",
          noon: "drek",
          morning: "n\xEB m\xEBngjes",
          afternoon: "n\xEB mbasdite",
          evening: "n\xEB mbr\xEBmje",
          night: "n\xEB mesnat\xEB"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        var options = _dirtyOptions || {};
        var unit = String(options.unit);
        if (unit === "hour") return number;
        if (number === 1) return number + "-r\xEB";
        if (number === 4) return number + "t";
        return number + "-t\xEB";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(p|m)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(para krishtit|mbas krishtit)/i
      };
      var parseEraPatterns = {
        any: [/^b/i, /^(p|m)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234]-mujori (i{1,3}|iv)/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jsmpqkftnd]/i,
        abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
        wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^s/i, /^m/i, /^p/i, /^m/i, /^q/i, /^k/i, /^g/i, /^s/i, /^t/i, /^n/i, /^d/i],
        any: [/^ja/i, /^shk/i, /^mar/i, /^pri/i, /^maj/i, /^qer/i, /^kor/i, /^gu/i, /^sht/i, /^tet/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[dhmeps]/i,
        short: /^(di|hë|ma|më|en|pr|sh)/i,
        abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
        wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^h/i, /^m/i, /^m/i, /^e/i, /^p/i, /^s/i],
        any: [/^d/i, /^h/i, /^ma/i, /^më/i, /^e/i, /^p/i, /^s/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
        any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^p/i,
          pm: /^m/i,
          midnight: /^me/i,
          noon: /^dr/i,
          morning: /mëngjes/i,
          afternoon: /mbasdite/i,
          evening: /mbrëmje/i,
          night: /natë/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
          },
          dual: "manje od {{count}} sekunde",
          other: "manje od {{count}} sekundi"
        },
        xSeconds: {
          one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
          },
          dual: "{{count}} sekunde",
          other: "{{count}} sekundi"
        },
        halfAMinute: "pola minute",
        lessThanXMinutes: {
          one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
          },
          dual: "manje od {{count}} minute",
          other: "manje od {{count}} minuta"
        },
        xMinutes: {
          one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
          },
          dual: "{{count}} minute",
          other: "{{count}} minuta"
        },
        aboutXHours: {
          one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
          },
          dual: "oko {{count}} sata",
          other: "oko {{count}} sati"
        },
        xHours: {
          one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
          },
          dual: "{{count}} sata",
          other: "{{count}} sati"
        },
        xDays: {
          one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
          },
          dual: "{{count}} dana",
          other: "{{count}} dana"
        },
        aboutXWeeks: {
          one: {
            standalone: "oko 1 nedelju",
            withPrepositionAgo: "oko 1 nedelju",
            withPrepositionIn: "oko 1 nedelju"
          },
          dual: "oko {{count}} nedelje",
          other: "oko {{count}} nedelje"
        },
        xWeeks: {
          one: {
            standalone: "1 nedelju",
            withPrepositionAgo: "1 nedelju",
            withPrepositionIn: "1 nedelju"
          },
          dual: "{{count}} nedelje",
          other: "{{count}} nedelje"
        },
        aboutXMonths: {
          one: {
            standalone: "oko 1 mesec",
            withPrepositionAgo: "oko 1 mesec",
            withPrepositionIn: "oko 1 mesec"
          },
          dual: "oko {{count}} meseca",
          other: "oko {{count}} meseci"
        },
        xMonths: {
          one: {
            standalone: "1 mesec",
            withPrepositionAgo: "1 mesec",
            withPrepositionIn: "1 mesec"
          },
          dual: "{{count}} meseca",
          other: "{{count}} meseci"
        },
        aboutXYears: {
          one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
          },
          dual: "oko {{count}} godine",
          other: "oko {{count}} godina"
        },
        xYears: {
          one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
          },
          dual: "{{count}} godine",
          other: "{{count}} godina"
        },
        overXYears: {
          one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
          },
          dual: "preko {{count}} godine",
          other: "preko {{count}} godina"
        },
        almostXYears: {
          one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
          },
          dual: "gotovo {{count}} godine",
          other: "gotovo {{count}} godina"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              result = formatDistanceLocale[token].one.withPrepositionIn;
            } else {
              result = formatDistanceLocale[token].one.withPrepositionAgo;
            }
          } else {
            result = formatDistanceLocale[token].one.standalone;
          }
        } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
        String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
        ) {
          result = formatDistanceLocale[token].dual.replace("{{count}}", count);
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "za " + result;
          } else {
            return "pre " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d. MMMM yyyy.",
        long: "d. MMMM yyyy.",
        medium: "d. MMM yy.",
        short: "dd. MM. yy."
      };
      var timeFormats = {
        full: "HH:mm:ss (zzzz)",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'u' {{time}}",
        long: "{{date}} 'u' {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function (date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'pro\u0161le nedelje u' p";

            case 3:
              return "'pro\u0161le srede u' p";

            case 6:
              return "'pro\u0161le subote u' p";

            default:
              return "'pro\u0161li' EEEE 'u' p";
          }
        },
        yesterday: "'ju\u010De u' p",
        today: "'danas u' p",
        tomorrow: "'sutra u' p",
        nextWeek: function (date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'slede\u0107e nedelje u' p";

            case 3:
              return "'slede\u0107u sredu u' p";

            case 6:
              return "'slede\u0107u subotu u' p";

            default:
              return "'slede\u0107i' EEEE 'u' p";
          }
        },
        other: "P"
      };

      function formatRelative(token, date, _baseDate, _options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return String(number).concat(".");
      }

      var eraValues = {
        narrow: ["pr.n.e.", "AD"],
        abbreviated: ["pr. Hr.", "po. Hr."],
        wide: ["Pre Hrista", "Posle Hrista"]
      };
      var monthValues = {
        narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
        abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
        wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
      };
      var formattingMonthValues = {
        narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
        abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
        wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
      };
      var quarterValues = {
        narrow: ["1.", "2.", "3.", "4."],
        abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
        wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
      };
      var dayValues = {
        narrow: ["N", "P", "U", "S", "\u010C", "P", "S"],
        short: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
        abbreviated: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
        wide: ["nedelja", "ponedeljak", "utorak", "sreda", "\u010Detvrtak", "petak", "subota"]
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutru",
          afternoon: "popodne",
          evening: "uve\u010De",
          night: "no\u0107u"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutru",
          afternoon: "popodne",
          evening: "uve\u010De",
          night: "no\u0107u"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutru",
          afternoon: "posle podne",
          evening: "uve\u010De",
          night: "no\u0107u"
        }
      };
      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutru",
          afternoon: "popodne",
          evening: "uve\u010De",
          night: "no\u0107u"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutru",
          afternoon: "popodne",
          evening: "uve\u010De",
          night: "no\u0107u"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "pono\u0107",
          noon: "podne",
          morning: "ujutru",
          afternoon: "posle podne",
          evening: "uve\u010De",
          night: "no\u0107u"
        }
      };
      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)\./i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(pr\.n\.e\.|AD)/i,
        abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
        wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
      };
      var parseEraPatterns = {
        any: [/^pr/i, /^(po|nova)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]\.\s?kv\.?/i,
        wide: /^[1234]\. kvartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(10|11|12|[123456789])\./i,
        abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
        wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
      };
      var parseMonthPatterns = {
        narrow: [/(10|11|12|[123456789])/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[npusčc]/i,
        short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
        abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
        wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^pono/i,
          noon: /^pod/i,
          morning: /jutro/i,
          afternoon: /(posle\s|po)+podne/i,
          evening: /(uvece|uveče)/i,
          night: /(nocu|noću)/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
          },
          dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
          other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        },
        xSeconds: {
          one: {
            standalone: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            withPrepositionAgo: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
          },
          dual: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
          other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        },
        halfAMinute: "\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
        lessThanXMinutes: {
          one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
          },
          dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
          other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
        },
        xMinutes: {
          one: {
            standalone: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
            withPrepositionAgo: "1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "1 \u043C\u0438\u043D\u0443\u0442\u0443"
          },
          dual: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
          other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
        },
        aboutXHours: {
          one: {
            standalone: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0441\u0430\u0442"
          },
          dual: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
          other: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
        },
        xHours: {
          one: {
            standalone: "1 \u0441\u0430\u0442",
            withPrepositionAgo: "1 \u0441\u0430\u0442",
            withPrepositionIn: "1 \u0441\u0430\u0442"
          },
          dual: "{{count}} \u0441\u0430\u0442\u0430",
          other: "{{count}} \u0441\u0430\u0442\u0438"
        },
        xDays: {
          one: {
            standalone: "1 \u0434\u0430\u043D",
            withPrepositionAgo: "1 \u0434\u0430\u043D",
            withPrepositionIn: "1 \u0434\u0430\u043D"
          },
          dual: "{{count}} \u0434\u0430\u043D\u0430",
          other: "{{count}} \u0434\u0430\u043D\u0430"
        },
        aboutXWeeks: {
          one: {
            standalone: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
          },
          dual: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
          other: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
        },
        xWeeks: {
          one: {
            standalone: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "1 \u043D\u0435\u0434\u0435\u0459\u0443"
          },
          dual: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
          other: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
        },
        aboutXMonths: {
          one: {
            standalone: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
          },
          dual: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
          other: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
        },
        xMonths: {
          one: {
            standalone: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "1 \u043C\u0435\u0441\u0435\u0446"
          },
          dual: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
          other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
        },
        aboutXYears: {
          one: {
            standalone: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
          },
          dual: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
          other: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
        },
        xYears: {
          one: {
            standalone: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
            withPrepositionAgo: "1 \u0433\u043E\u0434\u0438\u043D\u0435",
            withPrepositionIn: "1 \u0433\u043E\u0434\u0438\u043D\u0443"
          },
          dual: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
          other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
        },
        overXYears: {
          one: {
            standalone: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
          },
          dual: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
          other: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
        },
        almostXYears: {
          one: {
            standalone: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
          },
          dual: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
          other: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              result = formatDistanceLocale[token].one.withPrepositionIn;
            } else {
              result = formatDistanceLocale[token].one.withPrepositionAgo;
            }
          } else {
            result = formatDistanceLocale[token].one.standalone;
          }
        } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
        String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
        ) {
          result = formatDistanceLocale[token].dual.replace("{{count}}", count);
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "\u0437\u0430 " + result;
          } else {
            return "\u043F\u0440\u0435 " + result;
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, d. MMMM yyyy.",
        long: "d. MMMM yyyy.",
        medium: "d. MMM yy.",
        short: "dd. MM. yy."
      };
      var timeFormats = {
        full: "HH:mm:ss (zzzz)",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} '\u0443' {{time}}",
        long: "{{date}} '\u0443' {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function (date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";

            case 3:
              return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";

            case 6:
              return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";

            default:
              return "'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
          }
        },
        yesterday: "'\u0458\u0443\u0447\u0435 \u0443' p",
        today: "'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
        tomorrow: "'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
        nextWeek: function (date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";

            case 3:
              return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";

            case 6:
              return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";

            default:
              return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
          }
        },
        other: "P"
      };

      function formatRelative(token, date, _baseDate, _options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return String(number).concat(".");
      }

      var eraValues = {
        narrow: ["\u043F\u0440.\u043D.\u0435.", "\u0410\u0414"],
        abbreviated: ["\u043F\u0440. \u0425\u0440.", "\u043F\u043E. \u0425\u0440."],
        wide: ["\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430", "\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"]
      };
      var monthValues = {
        narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
        abbreviated: ["\u0458\u0430\u043D", "\u0444\u0435\u0431", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0458", "\u0458\u0443\u043D", "\u0458\u0443\u043B", "\u0430\u0432\u0433", "\u0441\u0435\u043F", "\u043E\u043A\u0442", "\u043D\u043E\u0432", "\u0434\u0435\u0446"],
        wide: ["\u0458\u0430\u043D\u0443\u0430\u0440", "\u0444\u0435\u0431\u0440\u0443\u0430\u0440", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0438\u043B", "\u043C\u0430\u0458", "\u0458\u0443\u043D", "\u0458\u0443\u043B", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440", "\u043E\u043A\u0442\u043E\u0431\u0430\u0440", "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440", "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"]
      };
      var formattingMonthValues = {
        narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
        abbreviated: ["\u0458\u0430\u043D", "\u0444\u0435\u0431", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0458", "\u0458\u0443\u043D", "\u0458\u0443\u043B", "\u0430\u0432\u0433", "\u0441\u0435\u043F", "\u043E\u043A\u0442", "\u043D\u043E\u0432", "\u0434\u0435\u0446"],
        wide: ["\u0458\u0430\u043D\u0443\u0430\u0440", "\u0444\u0435\u0431\u0440\u0443\u0430\u0440", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0438\u043B", "\u043C\u0430\u0458", "\u0458\u0443\u043D", "\u0458\u0443\u043B", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440", "\u043E\u043A\u0442\u043E\u0431\u0430\u0440", "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440", "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"]
      };
      var quarterValues = {
        narrow: ["1.", "2.", "3.", "4."],
        abbreviated: ["1. \u043A\u0432.", "2. \u043A\u0432.", "3. \u043A\u0432.", "4. \u043A\u0432."],
        wide: ["1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
      };
      var dayValues = {
        narrow: ["\u041D", "\u041F", "\u0423", "\u0421", "\u0427", "\u041F", "\u0421"],
        short: ["\u043D\u0435\u0434", "\u043F\u043E\u043D", "\u0443\u0442\u043E", "\u0441\u0440\u0435", "\u0447\u0435\u0442", "\u043F\u0435\u0442", "\u0441\u0443\u0431"],
        abbreviated: ["\u043D\u0435\u0434", "\u043F\u043E\u043D", "\u0443\u0442\u043E", "\u0441\u0440\u0435", "\u0447\u0435\u0442", "\u043F\u0435\u0442", "\u0441\u0443\u0431"],
        wide: ["\u043D\u0435\u0434\u0435\u0459\u0430", "\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A", "\u0443\u0442\u043E\u0440\u0430\u043A", "\u0441\u0440\u0435\u0434\u0430", "\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A", "\u043F\u0435\u0442\u0430\u043A", "\u0441\u0443\u0431\u043E\u0442\u0430"]
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0410\u041C",
          pm: "\u041F\u041C",
          midnight: "\u043F\u043E\u043D\u043E\u045B",
          noon: "\u043F\u043E\u0434\u043D\u0435",
          morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
          afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
          evening: "\u0443\u0432\u0435\u0447\u0435",
          night: "\u043D\u043E\u045B\u0443"
        },
        abbreviated: {
          am: "\u0410\u041C",
          pm: "\u041F\u041C",
          midnight: "\u043F\u043E\u043D\u043E\u045B",
          noon: "\u043F\u043E\u0434\u043D\u0435",
          morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
          afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
          evening: "\u0443\u0432\u0435\u0447\u0435",
          night: "\u043D\u043E\u045B\u0443"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "\u043F\u043E\u043D\u043E\u045B",
          noon: "\u043F\u043E\u0434\u043D\u0435",
          morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
          afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
          evening: "\u0443\u0432\u0435\u0447\u0435",
          night: "\u043D\u043E\u045B\u0443"
        }
      };
      var dayPeriodValues = {
        narrow: {
          am: "AM",
          pm: "PM",
          midnight: "\u043F\u043E\u043D\u043E\u045B",
          noon: "\u043F\u043E\u0434\u043D\u0435",
          morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
          afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
          evening: "\u0443\u0432\u0435\u0447\u0435",
          night: "\u043D\u043E\u045B\u0443"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "\u043F\u043E\u043D\u043E\u045B",
          noon: "\u043F\u043E\u0434\u043D\u0435",
          morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
          afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
          evening: "\u0443\u0432\u0435\u0447\u0435",
          night: "\u043D\u043E\u045B\u0443"
        },
        wide: {
          am: "AM",
          pm: "PM",
          midnight: "\u043F\u043E\u043D\u043E\u045B",
          noon: "\u043F\u043E\u0434\u043D\u0435",
          morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
          afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
          evening: "\u0443\u0432\u0435\u0447\u0435",
          night: "\u043D\u043E\u045B\u0443"
        }
      };
      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(4));

      var _index2 = _interopRequireDefault(__webpack_require__(5));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)\./i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(пр\.н\.е\.|АД)/i,
        abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
        wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
      };
      var parseEraPatterns = {
        any: [/^пр/i, /^(по|нова)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]\.\s?кв\.?/i,
        wide: /^[1234]\. квартал/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(10|11|12|[123456789])\./i,
        abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
        wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
      };
      var parseMonthPatterns = {
        narrow: [/(10|11|12|[123456789])/i],
        any: [/^ја/i, /^ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^авг/i, /^с/i, /^о/i, /^н/i, /^д/i]
      };
      var matchDayPatterns = {
        narrow: /^[пусчн]/i,
        short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
        abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
        wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
      };
      var parseDayPatterns = {
        narrow: [/^п/i, /^у/i, /^с/i, /^ч/i, /^н/i],
        any: [/^нед/i, /^пон/i, /^уто/i, /^сре/i, /^чет/i, /^пет/i, /^суб/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^поно/i,
          noon: /^под/i,
          morning: /ујутру/i,
          afternoon: /(после\s|по)+подне/i,
          evening: /(увече)/i,
          night: /(ноћу)/i
        }
      };
      var match = {
        ordinalNumber: (0, _index2.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          singular: "mindre \xE4n en sekund",
          plural: "mindre \xE4n {{count}} sekunder"
        },
        xSeconds: {
          singular: "en sekund",
          plural: "{{count}} sekunder"
        },
        halfAMinute: "en halv minut",
        lessThanXMinutes: {
          singular: "mindre \xE4n en minut",
          plural: "mindre \xE4n {{count}} minuter"
        },
        xMinutes: {
          singular: "en minut",
          plural: "{{count}} minuter"
        },
        aboutXHours: {
          singular: "ungef\xE4r en timme",
          plural: "ungef\xE4r {{count}} timmar"
        },
        xHours: {
          singular: "en timme",
          plural: "{{count}} timmar"
        },
        xDays: {
          singular: "en dag",
          plural: "{{count}} dagar"
        },
        aboutXWeeks: {
          singular: "ungef\xE4r en vecka",
          plural: "ungef\xE4r {{count}} vecka"
        },
        xWeeks: {
          singular: "en vecka",
          plural: "{{count}} vecka"
        },
        aboutXMonths: {
          singular: "ungef\xE4r en m\xE5nad",
          plural: "ungef\xE4r {{count}} m\xE5nader"
        },
        xMonths: {
          singular: "en m\xE5nad",
          plural: "{{count}} m\xE5nader"
        },
        aboutXYears: {
          singular: "ungef\xE4r ett \xE5r",
          plural: "ungef\xE4r {{count}} \xE5r"
        },
        xYears: {
          singular: "ett \xE5r",
          plural: "{{count}} \xE5r"
        },
        overXYears: {
          singular: "\xF6ver ett \xE5r",
          plural: "\xF6ver {{count}} \xE5r"
        },
        almostXYears: {
          singular: "n\xE4stan ett \xE5r",
          plural: "n\xE4stan {{count}} \xE5r"
        }
      };
      var wordMapping = ["noll", "en", "tv\xE5", "tre", "fyra", "fem", "sex", "sju", "\xE5tta", "nio", "tio", "elva", "tolv"];

      function formatDistance(token, count, options) {
        options = options || {
          onlyNumeric: false
        };
        var translation = formatDistanceLocale[token];
        var result;

        if (typeof translation === "string") {
          result = translation;
        } else if (count === 0 || count > 1) {
          if (options.onlyNumeric) {
            result = translation.plural.replace("{{count}}", count);
          } else {
            result = translation.plural.replace("{{count}}", count < 13 ? wordMapping[count] : count);
          }
        } else {
          result = translation.singular;
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "om " + result;
          } else {
            return result + " sedan";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE d MMMM y",
        long: "d MMMM y",
        medium: "d MMM y",
        short: "y-MM-dd"
      };
      var timeFormats = {
        full: "'kl'. HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'kl.' {{time}}",
        long: "{{date}} 'kl.' {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'i' EEEE's kl.' p",
        yesterday: "'ig\xE5r kl.' p",
        today: "'idag kl.' p",
        tomorrow: "'imorgon kl.' p",
        nextWeek: "EEEE 'kl.' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["f.Kr.", "e.Kr."],
        abbreviated: ["f.Kr.", "e.Kr."],
        wide: ["f\xF6re Kristus", "efter Kristus"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
      };
      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
        wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
      };
      var dayValues = {
        narrow: ["S", "M", "T", "O", "T", "F", "L"],
        short: ["s\xF6", "m\xE5", "ti", "on", "to", "fr", "l\xF6"],
        abbreviated: ["s\xF6n", "m\xE5n", "tis", "ons", "tors", "fre", "l\xF6r"],
        wide: ["s\xF6ndag", "m\xE5ndag", "tisdag", "onsdag", "torsdag", "fredag", "l\xF6rdag"]
      }; // https://www.unicode.org/cldr/charts/32/summary/sv.html#1888

      var dayPeriodValues = {
        narrow: {
          am: "fm",
          pm: "em",
          midnight: "midnatt",
          noon: "middag",
          morning: "morg.",
          afternoon: "efterm.",
          evening: "kv\xE4ll",
          night: "natt"
        },
        abbreviated: {
          am: "f.m.",
          pm: "e.m.",
          midnight: "midnatt",
          noon: "middag",
          morning: "morgon",
          afternoon: "efterm.",
          evening: "kv\xE4ll",
          night: "natt"
        },
        wide: {
          am: "f\xF6rmiddag",
          pm: "eftermiddag",
          midnight: "midnatt",
          noon: "middag",
          morning: "morgon",
          afternoon: "eftermiddag",
          evening: "kv\xE4ll",
          night: "natt"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "fm",
          pm: "em",
          midnight: "midnatt",
          noon: "middag",
          morning: "p\xE5 morg.",
          afternoon: "p\xE5 efterm.",
          evening: "p\xE5 kv\xE4llen",
          night: "p\xE5 natten"
        },
        abbreviated: {
          am: "fm",
          pm: "em",
          midnight: "midnatt",
          noon: "middag",
          morning: "p\xE5 morg.",
          afternoon: "p\xE5 efterm.",
          evening: "p\xE5 kv\xE4llen",
          night: "p\xE5 natten"
        },
        wide: {
          am: "fm",
          pm: "em",
          midnight: "midnatt",
          noon: "middag",
          morning: "p\xE5 morgonen",
          afternoon: "p\xE5 eftermiddagen",
          evening: "p\xE5 kv\xE4llen",
          night: "p\xE5 natten"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        var rem100 = number % 100;

        if (rem100 > 20 || rem100 < 10) {
          switch (rem100 % 10) {
            case 1:
            case 2:
              return number + ":a";
          }
        }

        return number + ":e";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
        abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
        wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
      };
      var parseEraPatterns = {
        any: [/^f/i, /^[ev]/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](:a|:e)? kvartalet/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|aug|sep|okt|nov|dec)\.?/i,
        wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtofl]/i,
        short: /^(sö|må|ti|on|to|fr|lö)/i,
        abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
        wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
      };
      var parseDayPatterns = {
        any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
      };
      var matchDayPeriodPatterns = {
        any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^f/i,
          pm: /^e/i,
          midnight: /^midn/i,
          noon: /^midd/i,
          morning: /morgon/i,
          afternoon: /eftermiddag/i,
          evening: /kväll/i,
          night: /natt/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        },
        xSeconds: {
          one: {
            default: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
            in: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        },
        halfAMinute: {
          default: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
          in: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
          ago: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        lessThanXMinutes: {
          one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        },
        xMinutes: {
          one: {
            default: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            in: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        },
        aboutXHours: {
          one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
          }
        },
        xHours: {
          one: {
            default: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        },
        xDays: {
          one: {
            default: "1 \u0BA8\u0BBE\u0BB3\u0BCD",
            in: "1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        },
        aboutXWeeks: {
          one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        },
        xWeeks: {
          one: {
            default: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        },
        aboutXMonths: {
          one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        },
        xMonths: {
          one: {
            default: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        },
        aboutXYears: {
          one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        },
        xYears: {
          one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        },
        overXYears: {
          one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
            in: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        },
        almostXYears: {
          one: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          },
          other: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
          }
        }
      };

      function getFormatDistanceLocaleWithSuffix(resultObj, options) {
        if (options.addSuffix) {
          if (options.comparison > 0) {
            return resultObj.in;
          } else {
            return resultObj.ago;
          }
        }

        return resultObj.default;
      }

      function formatDistance(token, count) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var result;

        if (formatDistanceLocale[token].default) {
          result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale[token], options);
        } else if (count === 1) {
          result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale[token].one, options);
        } else {
          result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale[token].other, options);
        }

        return result.replace("{{count}}", count);
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
      // CLDR #1846 - #1849


      var dateFormats = {
        full: "EEEE, d MMMM, y",
        long: "d MMMM, y",
        medium: "d MMM, y",
        short: "d/M/yy"
      }; // CLDR #1850 - #1853

      var timeFormats = {
        full: "a h:mm:ss zzzz",
        long: "a h:mm:ss z",
        medium: "a h:mm:ss",
        short: "a h:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        long: "{{date}} {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
        yesterday: "'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
        today: "'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
        tomorrow: "'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
        nextWeek: "eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html


      var eraValues = {
        narrow: ["\u0B95\u0BBF.\u0BAE\u0BC1.", "\u0B95\u0BBF.\u0BAA\u0BBF."],
        abbreviated: ["\u0B95\u0BBF.\u0BAE\u0BC1.", "\u0B95\u0BBF.\u0BAA\u0BBF."],
        // CLDR #1624, #1626
        wide: ["\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD", "\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"] // CLDR #1620, #1622

      };
      var quarterValues = {
        // CLDR #1644 - #1647
        narrow: ["1", "2", "3", "4"],
        // CLDR #1636 - #1639
        abbreviated: ["\u0B95\u0BBE\u0BB2\u0BBE.1", "\u0B95\u0BBE\u0BB2\u0BBE.2", "\u0B95\u0BBE\u0BB2\u0BBE.3", "\u0B95\u0BBE\u0BB2\u0BBE.4"],
        // CLDR #1628 - #1631
        wide: ["\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1", "\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1", "\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1", "\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"]
      };
      var monthValues = {
        // CLDR #700 - #711
        narrow: ["\u0B9C", "\u0BAA\u0BBF", "\u0BAE\u0BBE", "\u0B8F", "\u0BAE\u0BC7", "\u0B9C\u0BC2", "\u0B9C\u0BC2", "\u0B86", "\u0B9A\u0BC6", "\u0B85", "\u0BA8", "\u0B9F\u0BBF"],
        // CLDR #1676 - #1687
        abbreviated: ["\u0B9C\u0BA9.", "\u0BAA\u0BBF\u0BAA\u0BCD.", "\u0BAE\u0BBE\u0BB0\u0BCD.", "\u0B8F\u0BAA\u0BCD.", "\u0BAE\u0BC7", "\u0B9C\u0BC2\u0BA9\u0BCD", "\u0B9C\u0BC2\u0BB2\u0BC8", "\u0B86\u0B95.", "\u0B9A\u0BC6\u0BAA\u0BCD.", "\u0B85\u0B95\u0BCD.", "\u0BA8\u0BB5.", "\u0B9F\u0BBF\u0B9A."],
        // CLDR #1652 - #1663
        wide: ["\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF", // January
        "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF", // February
        "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD", // March
        "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD", // April
        "\u0BAE\u0BC7", // May
        "\u0B9C\u0BC2\u0BA9\u0BCD", // June
        "\u0B9C\u0BC2\u0BB2\u0BC8", // July
        "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD", // August
        "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD", // September
        "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD", // October
        "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD", // November
        "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD" // December
        ]
      };
      var dayValues = {
        // CLDR #1766 - #1772
        narrow: ["\u0B9E\u0BBE", "\u0BA4\u0BBF", "\u0B9A\u0BC6", "\u0BAA\u0BC1", "\u0BB5\u0BBF", "\u0BB5\u0BC6", "\u0B9A"],
        // CLDR #1752 - #1758
        short: ["\u0B9E\u0BBE", "\u0BA4\u0BBF", "\u0B9A\u0BC6", "\u0BAA\u0BC1", "\u0BB5\u0BBF", "\u0BB5\u0BC6", "\u0B9A"],
        // CLDR #1738 - #1744
        abbreviated: ["\u0B9E\u0BBE\u0BAF\u0BBF.", "\u0BA4\u0BBF\u0B99\u0BCD.", "\u0B9A\u0BC6\u0BB5\u0BCD.", "\u0BAA\u0BC1\u0BA4.", "\u0BB5\u0BBF\u0BAF\u0BBE.", "\u0BB5\u0BC6\u0BB3\u0BCD.", "\u0B9A\u0BA9\u0BBF"],
        // CLDR #1724 - #1730
        wide: ["\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1", // Sunday
        "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD", // Monday
        "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD", // Tuesday
        "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD", // Wednesday
        "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD", // Thursday
        "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF", // Friday
        "\u0B9A\u0BA9\u0BBF" // Saturday
        ]
      }; // CLDR #1780 - #1845

      var dayPeriodValues = {
        narrow: {
          am: "\u0BAE\u0BC1.\u0BAA",
          pm: "\u0BAA\u0BBF.\u0BAA",
          midnight: "\u0BA8\u0BB3\u0BCD.",
          noon: "\u0BA8\u0BA3\u0BCD.",
          morning: "\u0B95\u0BBE.",
          afternoon: "\u0BAE\u0BA4\u0BBF.",
          evening: "\u0BAE\u0BBE.",
          night: "\u0B87\u0BB0."
        },
        abbreviated: {
          am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
          pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
          midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
          noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
          morning: "\u0B95\u0BBE\u0BB2\u0BC8",
          afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
          evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
          night: "\u0B87\u0BB0\u0BB5\u0BC1"
        },
        wide: {
          am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
          pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
          midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
          noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
          morning: "\u0B95\u0BBE\u0BB2\u0BC8",
          afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
          evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
          night: "\u0B87\u0BB0\u0BB5\u0BC1"
        }
      }; // CLDR #1780 - #1845

      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0BAE\u0BC1.\u0BAA",
          pm: "\u0BAA\u0BBF.\u0BAA",
          midnight: "\u0BA8\u0BB3\u0BCD.",
          noon: "\u0BA8\u0BA3\u0BCD.",
          morning: "\u0B95\u0BBE.",
          afternoon: "\u0BAE\u0BA4\u0BBF.",
          evening: "\u0BAE\u0BBE.",
          night: "\u0B87\u0BB0."
        },
        abbreviated: {
          am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
          pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
          midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
          noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
          morning: "\u0B95\u0BBE\u0BB2\u0BC8",
          afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
          evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
          night: "\u0B87\u0BB0\u0BB5\u0BC1"
        },
        wide: {
          am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
          pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
          midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
          noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
          morning: "\u0B95\u0BBE\u0BB2\u0BC8",
          afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
          evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
          night: "\u0B87\u0BB0\u0BB5\u0BC1"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'
        // var rem100 = number % 100
        // if (rem100 > 20 || rem100 < 10) {
        //   switch (rem100 % 10) {
        //     case 1:
        //       return number + 'st'
        //     case 2:
        //       return number + 'nd'
        //     case 3:
        //       return number + 'rd'
        //   }
        // }
        // return number + 'th'

        return number;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(கி.மு.|கி.பி.)/i,
        abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
        wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
      };
      var parseEraPatterns = {
        any: [/கி\.?\s?மு\.?/, /கி\.?\s?பி\.?/]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^காலா.[1234]/i,
        wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
      };
      var parseQuarterPatterns = {
        narrow: [/1/i, /2/i, /3/i, /4/i],
        any: [/(1|காலா.1|ஒன்றாம்)/i, /(2|காலா.2|இரண்டாம்)/i, /(3|காலா.3|மூன்றாம்)/i, /(4|காலா.4|நான்காம்)/i]
      };
      var matchMonthPatterns = {
        narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
        abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
        wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ஜ$/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூ/i, /^ஜூ/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i],
        any: [/^ஜன/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூன்/i, /^ஜூலை/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i]
      };
      var matchDayPatterns = {
        narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
        short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
        abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
        wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
      };
      var parseDayPatterns = {
        narrow: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i],
        any: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
        any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^மு/i,
          pm: /^பி/i,
          midnight: /^நள்/i,
          noon: /^நண்/i,
          morning: /காலை/i,
          afternoon: /மதியம்/i,
          evening: /மாலை/i,
          night: /இரவு/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance; // Source: https://www.unicode.org/cldr/charts/32/summary/te.html

      var formatDistanceLocale = {
        lessThanXSeconds: {
          standalone: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
          },
          withPreposition: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
          }
        },
        xSeconds: {
          standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            // CLDR #1314
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
          },
          withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
          }
        },
        halfAMinute: {
          standalone: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
          withPreposition: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
        },
        lessThanXMinutes: {
          standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
          },
          withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
          }
        },
        xMinutes: {
          standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
          },
          withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
          }
        },
        aboutXHours: {
          standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
          },
          withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
          }
        },
        xHours: {
          standalone: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            // CLDR #1308
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
          },
          withPreposition: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32"
          }
        },
        xDays: {
          standalone: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            // CLDR #1292
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
          },
          withPreposition: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
          }
        },
        aboutXWeeks: {
          standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
          },
          withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
          }
        },
        xWeeks: {
          standalone: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
          },
          withPreposition: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
          }
        },
        aboutXMonths: {
          standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
          },
          withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
          }
        },
        xMonths: {
          standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            // CLDR #1281
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
          },
          withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32"
          }
        },
        aboutXYears: {
          standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
          },
          withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
          }
        },
        xYears: {
          standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            // CLDR #1275
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
          },
          withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
          }
        },
        overXYears: {
          standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
          },
          withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
          }
        },
        almostXYears: {
          standalone: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
          },
          withPreposition: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
          }
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var usageGroup = options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
        var result;

        if (typeof usageGroup === "string") {
          result = usageGroup;
        } else if (count === 1) {
          result = usageGroup.one;
        } else {
          result = usageGroup.other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + "\u0C32\u0C4B";
          } else {
            return result + " \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // Source: https://www.unicode.org/cldr/charts/32/summary/te.html
      // CLDR #1807 - #1811


      var dateFormats = {
        full: "d, MMMM y, EEEE",
        long: "d MMMM, y",
        medium: "d MMM, y",
        short: "dd-MM-yy"
      }; // CLDR #1807 - #1811

      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      }; // CLDR #1815 - #1818

      var dateTimeFormats = {
        full: "{{date}} {{time}}'\u0C15\u0C3F'",
        long: "{{date}} {{time}}'\u0C15\u0C3F'",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative; // Source: https://www.unicode.org/cldr/charts/32/summary/te.html

      var formatRelativeLocale = {
        lastWeek: "'\u0C17\u0C24' eeee p",
        // CLDR #1384
        yesterday: "'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
        // CLDR #1393
        today: "'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
        // CLDR #1394
        tomorrow: "'\u0C30\u0C47\u0C2A\u0C41' p",
        // CLDR #1395
        nextWeek: "'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
        // CLDR #1386
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // Source: https://www.unicode.org/cldr/charts/32/summary/te.html
      // Source: https://dsal.uchicago.edu/dictionaries/brown/
      // CLDR #1605 - #1608


      var eraValues = {
        narrow: ["\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.", "\u0C15\u0C4D\u0C30\u0C40.\u0C36."],
        abbreviated: ["\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.", "\u0C15\u0C4D\u0C30\u0C40.\u0C36."],
        wide: ["\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02", "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"]
      }; // CLDR #1613 - #1628

      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["\u0C24\u0C4D\u0C30\u0C481", "\u0C24\u0C4D\u0C30\u0C482", "\u0C24\u0C4D\u0C30\u0C483", "\u0C24\u0C4D\u0C30\u0C484"],
        wide: ["1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02", "2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02", "3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02", "4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"]
      }; // CLDR #1637 - #1708

      var monthValues = {
        narrow: ["\u0C1C", "\u0C2B\u0C3F", "\u0C2E\u0C3E", "\u0C0F", "\u0C2E\u0C47", "\u0C1C\u0C42", "\u0C1C\u0C41", "\u0C06", "\u0C38\u0C46", "\u0C05", "\u0C28", "\u0C21\u0C3F"],
        abbreviated: ["\u0C1C\u0C28", "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30", "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F", "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F", "\u0C2E\u0C47", "\u0C1C\u0C42\u0C28\u0C4D", "\u0C1C\u0C41\u0C32\u0C48", "\u0C06\u0C17", "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02", "\u0C05\u0C15\u0C4D\u0C1F\u0C4B", "\u0C28\u0C35\u0C02", "\u0C21\u0C3F\u0C38\u0C46\u0C02"],
        wide: ["\u0C1C\u0C28\u0C35\u0C30\u0C3F", "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F", "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F", "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D", "\u0C2E\u0C47", "\u0C1C\u0C42\u0C28\u0C4D", "\u0C1C\u0C41\u0C32\u0C48", "\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41", "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D", "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D", "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D", "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"]
      }; // CLDR #1709 - #1764

      var dayValues = {
        narrow: ["\u0C06", "\u0C38\u0C4B", "\u0C2E", "\u0C2C\u0C41", "\u0C17\u0C41", "\u0C36\u0C41", "\u0C36"],
        short: ["\u0C06\u0C26\u0C3F", "\u0C38\u0C4B\u0C2E", "\u0C2E\u0C02\u0C17\u0C33", "\u0C2C\u0C41\u0C27", "\u0C17\u0C41\u0C30\u0C41", "\u0C36\u0C41\u0C15\u0C4D\u0C30", "\u0C36\u0C28\u0C3F"],
        abbreviated: ["\u0C06\u0C26\u0C3F", "\u0C38\u0C4B\u0C2E", "\u0C2E\u0C02\u0C17\u0C33", "\u0C2C\u0C41\u0C27", "\u0C17\u0C41\u0C30\u0C41", "\u0C36\u0C41\u0C15\u0C4D\u0C30", "\u0C36\u0C28\u0C3F"],
        wide: ["\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02", "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02", "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02", "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02", "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02", "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02", "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"]
      }; // CLDR #1767 - #1806

      var dayPeriodValues = {
        narrow: {
          am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
          noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          morning: "\u0C09\u0C26\u0C2F\u0C02",
          afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
          night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
        },
        abbreviated: {
          am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
          noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          morning: "\u0C09\u0C26\u0C2F\u0C02",
          afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
          night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
        },
        wide: {
          am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
          noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          morning: "\u0C09\u0C26\u0C2F\u0C02",
          afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
          night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
          noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          morning: "\u0C09\u0C26\u0C2F\u0C02",
          afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
          night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
        },
        abbreviated: {
          am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
          noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          morning: "\u0C09\u0C26\u0C2F\u0C02",
          afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
          night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
        },
        wide: {
          am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
          noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          morning: "\u0C09\u0C26\u0C2F\u0C02",
          afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
          evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
          night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + "\u0C35";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
        abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
        wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
      };
      var parseEraPatterns = {
        any: [/^(పూ|శ)/i, /^సా/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^త్రై[1234]/i,
        wide: /^[1234](వ)? త్రైమాసికం/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
        abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
        wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
      };
      var parseMonthPatterns = {
        narrow: [/^జ/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూ/i, /^జు/i, /^ఆ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i],
        any: [/^జన/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూన్/i, /^జులై/i, /^ఆగ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i]
      };
      var matchDayPatterns = {
        narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
        short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
        abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
        wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
      };
      var parseDayPatterns = {
        narrow: [/^ఆ/i, /^సో/i, /^మ/i, /^బు/i, /^గు/i, /^శు/i, /^శ/i],
        any: [/^ఆది/i, /^సోమ/i, /^మం/i, /^బుధ/i, /^గురు/i, /^శుక్ర/i, /^శని/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
        any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^పూర్వాహ్నం/i,
          pm: /^అపరాహ్నం/i,
          midnight: /^అర్ధ/i,
          noon: /^మిట్ట/i,
          morning: /ఉదయం/i,
          afternoon: /మధ్యాహ్నం/i,
          evening: /సాయంత్రం/i,
          night: /రాత్రి/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
          other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
        },
        xSeconds: {
          one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
          other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
        },
        halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
        lessThanXMinutes: {
          one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
          other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
        },
        xMinutes: {
          one: "1 \u0E19\u0E32\u0E17\u0E35",
          other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
        },
        aboutXHours: {
          one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
          other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
        },
        xHours: {
          one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
          other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
        },
        xDays: {
          one: "1 \u0E27\u0E31\u0E19",
          other: "{{count}} \u0E27\u0E31\u0E19"
        },
        aboutXWeeks: {
          one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
          other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
        },
        xWeeks: {
          one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
          other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
        },
        aboutXMonths: {
          one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
          other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
        },
        xMonths: {
          one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
          other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
        },
        aboutXYears: {
          one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
          other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
        },
        xYears: {
          one: "1 \u0E1B\u0E35",
          other: "{{count}} \u0E1B\u0E35"
        },
        overXYears: {
          one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
          other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
        },
        almostXYears: {
          one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
          other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            if (token === "halfAMinute") {
              return "\u0E43\u0E19" + result;
            } else {
              return "\u0E43\u0E19 " + result;
            }
          } else {
            return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
        long: "do MMMM y",
        medium: "d MMM y",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "H:mm:ss \u0E19. zzzz",
        long: "H:mm:ss \u0E19. z",
        medium: "H:mm:ss \u0E19.",
        short: "H:mm \u0E19."
      };
      var dateTimeFormats = {
        full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
        long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "medium"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
        yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
        today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
        tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
        nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["B", "\u0E04\u0E28"],
        abbreviated: ["BC", "\u0E04.\u0E28."],
        wide: ["\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25", "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01", "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07", "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21", "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"]
      };
      var dayValues = {
        narrow: ["\u0E2D\u0E32.", "\u0E08.", "\u0E2D.", "\u0E1E.", "\u0E1E\u0E24.", "\u0E28.", "\u0E2A."],
        short: ["\u0E2D\u0E32.", "\u0E08.", "\u0E2D.", "\u0E1E.", "\u0E1E\u0E24.", "\u0E28.", "\u0E2A."],
        abbreviated: ["\u0E2D\u0E32.", "\u0E08.", "\u0E2D.", "\u0E1E.", "\u0E1E\u0E24.", "\u0E28.", "\u0E2A."],
        wide: ["\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C", "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C", "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23", "\u0E1E\u0E38\u0E18", "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35", "\u0E28\u0E38\u0E01\u0E23\u0E4C", "\u0E40\u0E2A\u0E32\u0E23\u0E4C"]
      };
      var monthValues = {
        narrow: ["\u0E21.\u0E04.", "\u0E01.\u0E1E.", "\u0E21\u0E35.\u0E04.", "\u0E40\u0E21.\u0E22.", "\u0E1E.\u0E04.", "\u0E21\u0E34.\u0E22.", "\u0E01.\u0E04.", "\u0E2A.\u0E04.", "\u0E01.\u0E22.", "\u0E15.\u0E04.", "\u0E1E.\u0E22.", "\u0E18.\u0E04."],
        abbreviated: ["\u0E21.\u0E04.", "\u0E01.\u0E1E.", "\u0E21\u0E35.\u0E04.", "\u0E40\u0E21.\u0E22.", "\u0E1E.\u0E04.", "\u0E21\u0E34.\u0E22.", "\u0E01.\u0E04.", "\u0E2A.\u0E04.", "\u0E01.\u0E22.", "\u0E15.\u0E04.", "\u0E1E.\u0E22.", "\u0E18.\u0E04."],
        wide: ["\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21", "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C", "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21", "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19", "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21", "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19", "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21", "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21", "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19", "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21", "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19", "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
          noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          morning: "\u0E40\u0E0A\u0E49\u0E32",
          afternoon: "\u0E1A\u0E48\u0E32\u0E22",
          evening: "\u0E40\u0E22\u0E47\u0E19",
          night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
        },
        abbreviated: {
          am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
          noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          morning: "\u0E40\u0E0A\u0E49\u0E32",
          afternoon: "\u0E1A\u0E48\u0E32\u0E22",
          evening: "\u0E40\u0E22\u0E47\u0E19",
          night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
        },
        wide: {
          am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
          noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          morning: "\u0E40\u0E0A\u0E49\u0E32",
          afternoon: "\u0E1A\u0E48\u0E32\u0E22",
          evening: "\u0E40\u0E22\u0E47\u0E19",
          night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
          noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
          afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
          evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
          night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
        },
        abbreviated: {
          am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
          noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
          afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
          evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
          night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
        },
        wide: {
          am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
          noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
          morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
          afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
          evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
          night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^\d+/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^([bB]|[aA]|คศ)/i,
        abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
        wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
      };
      var parseEraPatterns = {
        any: [/^[bB]/i, /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^ไตรมาส(ที่)? ?[1234]/i
      };
      var parseQuarterPatterns = {
        any: [/(1|แรก|หนึ่ง)/i, /(2|สอง)/i, /(3|สาม)/i, /(4|สี่)/i]
      };
      var matchMonthPatterns = {
        narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
        abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
        wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
      };
      var parseMonthPatterns = {
        wide: [/^มก/i, /^กุม/i, /^มี/i, /^เม/i, /^พฤษ/i, /^มิ/i, /^กรก/i, /^ส/i, /^กัน/i, /^ต/i, /^พฤศ/i, /^ธ/i],
        any: [/^ม\.?ค\.?/i, /^ก\.?พ\.?/i, /^มี\.?ค\.?/i, /^เม\.?ย\.?/i, /^พ\.?ค\.?/i, /^มิ\.?ย\.?/i, /^ก\.?ค\.?/i, /^ส\.?ค\.?/i, /^ก\.?ย\.?/i, /^ต\.?ค\.?/i, /^พ\.?ย\.?/i, /^ธ\.?ค\.?/i]
      };
      var matchDayPatterns = {
        narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
        short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
        abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
        wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
      };
      var parseDayPatterns = {
        wide: [/^อา/i, /^จั/i, /^อั/i, /^พุธ/i, /^พฤ/i, /^ศ/i, /^เส/i],
        any: [/^อา/i, /^จ/i, /^อ/i, /^พ(?!ฤ)/i, /^พฤ/i, /^ศ/i, /^ส/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ก่อนเที่ยง/i,
          pm: /^หลังเที่ยง/i,
          midnight: /^เที่ยงคืน/i,
          noon: /^เที่ยง/i,
          morning: /เช้า/i,
          afternoon: /บ่าย/i,
          evening: /เย็น/i,
          night: /กลางคืน/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "bir saniyeden az",
          other: "{{count}} saniyeden az"
        },
        xSeconds: {
          one: "1 saniye",
          other: "{{count}} saniye"
        },
        halfAMinute: "yar\u0131m dakika",
        lessThanXMinutes: {
          one: "bir dakikadan az",
          other: "{{count}} dakikadan az"
        },
        xMinutes: {
          one: "1 dakika",
          other: "{{count}} dakika"
        },
        aboutXHours: {
          one: "yakla\u015F\u0131k 1 saat",
          other: "yakla\u015F\u0131k {{count}} saat"
        },
        xHours: {
          one: "1 saat",
          other: "{{count}} saat"
        },
        xDays: {
          one: "1 g\xFCn",
          other: "{{count}} g\xFCn"
        },
        aboutXWeeks: {
          one: "yakla\u015F\u0131k 1 hafta",
          other: "yakla\u015F\u0131k {{count}} hafta"
        },
        xWeeks: {
          one: "1 hafta",
          other: "{{count}} hafta"
        },
        aboutXMonths: {
          one: "yakla\u015F\u0131k 1 ay",
          other: "yakla\u015F\u0131k {{count}} ay"
        },
        xMonths: {
          one: "1 ay",
          other: "{{count}} ay"
        },
        aboutXYears: {
          one: "yakla\u015F\u0131k 1 y\u0131l",
          other: "yakla\u015F\u0131k {{count}} y\u0131l"
        },
        xYears: {
          one: "1 y\u0131l",
          other: "{{count}} y\u0131l"
        },
        overXYears: {
          one: "1 y\u0131ldan fazla",
          other: "{{count}} y\u0131ldan fazla"
        },
        almostXYears: {
          one: "neredeyse 1 y\u0131l",
          other: "neredeyse {{count}} y\u0131l"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + " sonra";
          } else {
            return result + " \xF6nce";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "d MMMM y EEEE",
        long: "d MMMM y",
        medium: "d MMM y",
        short: "dd.MM.yyyy"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} 'saat' {{time}}",
        long: "{{date}} 'saat' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'ge\xE7en hafta' eeee 'saat' p",
        yesterday: "'d\xFCn saat' p",
        today: "'bug\xFCn saat' p",
        tomorrow: "'yar\u0131n saat' p",
        nextWeek: "eeee 'saat' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        abbreviated: ["M\xD6", "MS"],
        narrow: ["M\xD6", "MS"],
        wide: ["Milattan \xD6nce", "Milattan Sonra"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1\xC7", "2\xC7", "3\xC7", "4\xC7"],
        wide: ["\u0130lk \xE7eyrek", "\u0130kinci \xC7eyrek", "\xDC\xE7\xFCnc\xFC \xE7eyrek", "Son \xE7eyrek"]
      };
      var monthValues = {
        narrow: ["O", "\u015E", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"],
        abbreviated: ["Oca", "\u015Eub", "Mar", "Nis", "May", "Haz", "Tem", "A\u011Fu", "Eyl", "Eki", "Kas", "Ara"],
        wide: ["Ocak", "\u015Eubat", "Mart", "Nisan", "May\u0131s", "Haziran", "Temmuz", "A\u011Fustos", "Eyl\xFCl", "Ekim", "Kas\u0131m", "Aral\u0131k"]
      };
      var dayValues = {
        narrow: ["P", "P", "S", "\xC7", "P", "C", "C"],
        short: ["Pz", "Pt", "Sa", "\xC7a", "Pe", "Cu", "Ct"],
        abbreviated: ["Paz", "Pts", "Sal", "\xC7ar", "Per", "Cum", "Cts"],
        wide: ["Pazar", "Pazartesi", "Sal\u0131", "\xC7ar\u015Famba", "Per\u015Fembe", "Cuma", "Cumartesi"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\xF6\xF6",
          pm: "\xF6s",
          midnight: "gy",
          noon: "\xF6",
          morning: "sa",
          afternoon: "\xF6s",
          evening: "ak",
          night: "ge"
        },
        abbreviated: {
          am: "\xD6\xD6",
          pm: "\xD6S",
          midnight: "gece yar\u0131s\u0131",
          noon: "\xF6\u011Fle",
          morning: "sabah",
          afternoon: "\xF6\u011Fleden sonra",
          evening: "ak\u015Fam",
          night: "gece"
        },
        wide: {
          am: "\xD6.\xD6.",
          pm: "\xD6.S.",
          midnight: "gece yar\u0131s\u0131",
          noon: "\xF6\u011Fle",
          morning: "sabah",
          afternoon: "\xF6\u011Fleden sonra",
          evening: "ak\u015Fam",
          night: "gece"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\xF6\xF6",
          pm: "\xF6s",
          midnight: "gy",
          noon: "\xF6",
          morning: "sa",
          afternoon: "\xF6s",
          evening: "ak",
          night: "ge"
        },
        abbreviated: {
          am: "\xD6\xD6",
          pm: "\xD6S",
          midnight: "gece yar\u0131s\u0131",
          noon: "\xF6\u011Flen",
          morning: "sabahleyin",
          afternoon: "\xF6\u011Fleden sonra",
          evening: "ak\u015Famleyin",
          night: "geceleyin"
        },
        wide: {
          am: "\xF6.\xF6.",
          pm: "\xF6.s.",
          midnight: "gece yar\u0131s\u0131",
          noon: "\xF6\u011Flen",
          morning: "sabahleyin",
          afternoon: "\xF6\u011Fleden sonra",
          evening: "ak\u015Famleyin",
          night: "geceleyin"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + ".";
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaulFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(mö|ms)/i,
        abbreviated: /^(mö|ms)/i,
        wide: /^(milattan önce|milattan sonra)/i
      };
      var parseEraPatterns = {
        any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]ç/i,
        wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i],
        abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
        wide: [/^(i|İ)lk çeyrek/i, /(i|İ)kinci çeyrek/i, /üçüncü çeyrek/i, /son çeyrek/i]
      };
      var matchMonthPatterns = {
        narrow: /^[oşmnhtaek]/i,
        abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
        wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
      };
      var parseMonthPatterns = {
        narrow: [/^o/i, /^ş/i, /^m/i, /^n/i, /^m/i, /^h/i, /^t/i, /^a/i, /^e/i, /^e/i, /^k/i, /^a/i],
        any: [/^o/i, /^ş/i, /^mar/i, /^n/i, /^may/i, /^h/i, /^t/i, /^ağ/i, /^ey/i, /^ek/i, /^k/i, /^ar/i]
      };
      var matchDayPatterns = {
        narrow: /^[psçc]/i,
        short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
        abbreviated: /^(paz|pts|sal|çar|per|cum|cts)/i,
        wide: /^(pazar|pazartesi|salı|çarşamba|perşembe|cuma|cumartesi)/i
      };
      var parseDayPatterns = {
        narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
        any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
        wide: [/^pazar/i, /^pazartesi/i, /^salı/i, /^çarşamba/i, /^perşembe/i, /^cuma/i, /cumartesi/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
        any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ö\.?ö\.?/i,
          pm: /^ö\.?s\.?/i,
          midnight: /^(gy|gece yarısı)/i,
          noon: /^öğ/i,
          morning: /^sa/i,
          afternoon: /^öğleden sonra/i,
          evening: /^ak/i,
          night: /^ge/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
          other: "\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
        },
        xSeconds: {
          one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
          other: "\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
        },
        halfAMinute: "\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
        lessThanXMinutes: {
          one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
          other: "\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
        },
        xMinutes: {
          one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
          other: "\u0645\u0649\u0646\u06C7\u062A {{count}}"
        },
        aboutXHours: {
          one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
          other: "\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
        },
        xHours: {
          one: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
          other: "\u0633\u0627\u0626\u06D5\u062A {{count}}"
        },
        xDays: {
          one: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
          other: "\u0643\u06C8\u0646 {{count}}"
        },
        aboutXWeeks: {
          one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
          other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
        },
        xWeeks: {
          one: "\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
          other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
        },
        aboutXMonths: {
          one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
          other: "\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
        },
        xMonths: {
          one: "\u0628\u0649\u0631 \u0626\u0627\u064A",
          other: "\u0626\u0627\u064A {{count}}"
        },
        aboutXYears: {
          one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
          other: "\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
        },
        xYears: {
          one: "\u0628\u0649\u0631 \u064A\u0649\u0644",
          other: "\u064A\u0649\u0644 {{count}}"
        },
        overXYears: {
          one: "\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
          other: "\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
        },
        almostXYears: {
          one: "\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
          other: "\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result;
          } else {
            return result + " \u0628\u0648\u0644\u062F\u0649";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, MMMM do, y",
        long: "MMMM do, y",
        medium: "MMM d, y",
        short: "MM/dd/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} '\u062F\u06D5' {{time}}",
        long: "{{date}} '\u062F\u06D5' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
        yesterday: "'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
        today: "'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
        tomorrow: "'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
        nextWeek: "eeee '\u062F\u06D5' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u0628", "\u0643"],
        abbreviated: ["\u0628", "\u0643"],
        wide: ["\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646", "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1", "2", "3", "4"],
        wide: ["\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643", "\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643", "\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643", "\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"]
      }; // Note: in English, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["\u064A", "\u0641", "\u0645", "\u0627", "\u0645", "\u0649", "\u0649", "\u0627", "\u0633", "\u06C6", "\u0646", "\u062F"],
        abbreviated: ["\u064A\u0627\u0646\u06CB\u0627\u0631", "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644", "\u0645\u0627\u0631\u062A", "\u0626\u0627\u067E\u0631\u0649\u0644", "\u0645\u0627\u064A", "\u0626\u0649\u064A\u06C7\u0646", "\u0626\u0649\u064A\u0648\u0644", "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A", "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631", "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631", "\u0646\u0648\u064A\u0627\u0628\u0649\u0631", "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"],
        wide: ["\u064A\u0627\u0646\u06CB\u0627\u0631", "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644", "\u0645\u0627\u0631\u062A", "\u0626\u0627\u067E\u0631\u0649\u0644", "\u0645\u0627\u064A", "\u0626\u0649\u064A\u06C7\u0646", "\u0626\u0649\u064A\u0648\u0644", "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A", "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631", "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631", "\u0646\u0648\u064A\u0627\u0628\u0649\u0631", "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"]
      };
      var dayValues = {
        narrow: ["\u064A", "\u062F", "\u0633", "\u0686", "\u067E", "\u062C", "\u0634"],
        short: ["\u064A", "\u062F", "\u0633", "\u0686", "\u067E", "\u062C", "\u0634"],
        abbreviated: ["\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5", "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5", "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5", "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5", "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5", "\u062C\u06C8\u0645\u06D5", "\u0634\u06D5\u0646\u0628\u06D5"],
        wide: ["\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5", "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5", "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5", "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5", "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5", "\u062C\u06C8\u0645\u06D5", "\u0634\u06D5\u0646\u0628\u06D5"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u0626\u06D5",
          pm: "\u0686",
          midnight: "\u0643",
          noon: "\u0686",
          morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
          afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
          evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
          night: "\u0643\u0649\u0686\u06D5"
        },
        abbreviated: {
          am: "\u0626\u06D5",
          pm: "\u0686",
          midnight: "\u0643",
          noon: "\u0686",
          morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
          afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
          evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
          night: "\u0643\u0649\u0686\u06D5"
        },
        wide: {
          am: "\u0626\u06D5",
          pm: "\u0686",
          midnight: "\u0643",
          noon: "\u0686",
          morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
          afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
          evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
          night: "\u0643\u0649\u0686\u06D5"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0626\u06D5",
          pm: "\u0686",
          midnight: "\u0643",
          noon: "\u0686",
          morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
          afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
          evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
          night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
        },
        abbreviated: {
          am: "\u0626\u06D5",
          pm: "\u0686",
          midnight: "\u0643",
          noon: "\u0686",
          morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
          afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
          evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
          night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
        },
        wide: {
          am: "\u0626\u06D5",
          pm: "\u0686",
          midnight: "\u0643",
          noon: "\u0686",
          morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
          afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
          evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
          night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        return String(dirtyNumber);
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ب|ك)/i,
        wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
      };
      var parseEraPatterns = {
        any: [/^بۇرۇن/i, /^كىيىن/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^چ[1234]/i,
        wide: /^چارەك [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        // eslint-disable-next-line no-misleading-character-class
        narrow: /^[يفمئامئ‍ئاسۆند]/i,
        abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
        wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ي/i, /^ف/i, /^م/i, /^ا/i, /^م/i, /^ى‍/i, /^ى‍/i, /^ا‍/i, /^س/i, /^ۆ/i, /^ن/i, /^د/i],
        any: [/^يان/i, /^فېۋ/i, /^مار/i, /^ئاپ/i, /^ماي/i, /^ئىيۇن/i, /^ئىيول/i, /^ئاۋ/i, /^سىن/i, /^ئۆك/i, /^نوي/i, /^دىك/i]
      };
      var matchDayPatterns = {
        narrow: /^[دسچپجشي]/i,
        short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
        abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
        wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
      };
      var parseDayPatterns = {
        narrow: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
        any: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
        any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ئە/i,
          pm: /^چ/i,
          midnight: /^ك/i,
          noon: /^چ/i,
          morning: /ئەتىگەن/i,
          afternoon: /چۈشتىن كىيىن/i,
          evening: /ئاخشىم/i,
          night: /كىچە/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;

      function declension(scheme, count) {
        // scheme for count=1 exists
        if (scheme.one !== undefined && count === 1) {
          return scheme.one;
        }

        var rem10 = count % 10;
        var rem100 = count % 100; // 1, 21, 31, ...

        if (rem10 === 1 && rem100 !== 11) {
          return scheme.singularNominative.replace("{{count}}", count); // 2, 3, 4, 22, 23, 24, 32 ...
        } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
          return scheme.singularGenitive.replace("{{count}}", count); // 5, 6, 7, 8, 9, 10, 11, ...
        } else {
          return scheme.pluralGenitive.replace("{{count}}", count);
        }
      }

      function buildLocalizeTokenFn(scheme) {
        return function (count, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              if (scheme.future) {
                return declension(scheme.future, count);
              } else {
                return "\u0437\u0430 " + declension(scheme.regular, count);
              }
            } else {
              if (scheme.past) {
                return declension(scheme.past, count);
              } else {
                return declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
              }
            }
          } else {
            return declension(scheme.regular, count);
          }
        };
      }

      var formatDistanceLocale = {
        lessThanXSeconds: buildLocalizeTokenFn({
          regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
          },
          future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
          }
        }),
        xSeconds: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
          },
          past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
          },
          future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
          }
        }),
        halfAMinute: function (_, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
            } else {
              return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
            }
          }

          return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        },
        lessThanXMinutes: buildLocalizeTokenFn({
          regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
          },
          future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
          }
        }),
        xMinutes: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
          },
          past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
          },
          future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
          }
        }),
        aboutXHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
          },
          future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
          }
        }),
        xHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
          }
        }),
        xDays: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
          }
        }),
        aboutXWeeks: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
          },
          future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456"
          }
        }),
        xWeeks: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u044F",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456"
          }
        }),
        aboutXMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
          },
          future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
          }
        }),
        xMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
          }
        }),
        aboutXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
          },
          future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
          }
        }),
        xYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
          }
        }),
        overXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
          },
          future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
          }
        }),
        almostXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
          },
          future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
          }
        })
      };

      function formatDistance(token, count, options) {
        options = options || {};
        return formatDistanceLocale[token](count, options);
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, do MMMM y '\u0440.'",
        long: "do MMMM y '\u0440.'",
        medium: "d MMM y '\u0440.'",
        short: "dd.MM.y"
      };
      var timeFormats = {
        full: "H:mm:ss zzzz",
        long: "H:mm:ss z",
        medium: "H:mm:ss",
        short: "H:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} '\u043E' {{time}}",
        long: "{{date}} '\u043E' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;

      var _index = _interopRequireDefault(__webpack_require__(8));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var accusativeWeekdays = ["\u043D\u0435\u0434\u0456\u043B\u044E", "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A", "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A", "\u0441\u0435\u0440\u0435\u0434\u0443", "\u0447\u0435\u0442\u0432\u0435\u0440", "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E", "\u0441\u0443\u0431\u043E\u0442\u0443"];

      function lastWeek(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 5:
          case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";

          case 1:
          case 2:
          case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
        }
      }

      function thisWeek(day) {
        var weekday = accusativeWeekdays[day];
        return "'\u0443 " + weekday + " \u043E' p";
      }

      function nextWeek(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 5:
          case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";

          case 1:
          case 2:
          case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return lastWeek(day);
          }
        },
        yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
        today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
        tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
        nextWeek: function (date, baseDate, options) {
          var day = date.getUTCDay();

          if ((0, _index.default)(date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return nextWeek(day);
          }
        },
        other: "P"
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(date, baseDate, options);
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u0434\u043E \u043D.\u0435.", "\u043D.\u0435."],
        abbreviated: ["\u0434\u043E \u043D. \u0435.", "\u043D. \u0435."],
        wide: ["\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438", "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["1-\u0439 \u043A\u0432.", "2-\u0439 \u043A\u0432.", "3-\u0439 \u043A\u0432.", "4-\u0439 \u043A\u0432."],
        wide: ["1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
      };
      var monthValues = {
        // ДСТУ 3582:2013
        narrow: ["\u0421", "\u041B", "\u0411", "\u041A", "\u0422", "\u0427", "\u041B", "\u0421", "\u0412", "\u0416", "\u041B", "\u0413"],
        abbreviated: ["\u0441\u0456\u0447.", "\u043B\u044E\u0442.", "\u0431\u0435\u0440\u0435\u0437.", "\u043A\u0432\u0456\u0442.", "\u0442\u0440\u0430\u0432.", "\u0447\u0435\u0440\u0432.", "\u043B\u0438\u043F.", "\u0441\u0435\u0440\u043F.", "\u0432\u0435\u0440\u0435\u0441.", "\u0436\u043E\u0432\u0442.", "\u043B\u0438\u0441\u0442\u043E\u043F.", "\u0433\u0440\u0443\u0434."],
        wide: ["\u0441\u0456\u0447\u0435\u043D\u044C", "\u043B\u044E\u0442\u0438\u0439", "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C", "\u043A\u0432\u0456\u0442\u0435\u043D\u044C", "\u0442\u0440\u0430\u0432\u0435\u043D\u044C", "\u0447\u0435\u0440\u0432\u0435\u043D\u044C", "\u043B\u0438\u043F\u0435\u043D\u044C", "\u0441\u0435\u0440\u043F\u0435\u043D\u044C", "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C", "\u0436\u043E\u0432\u0442\u0435\u043D\u044C", "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434", "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"]
      };
      var formattingMonthValues = {
        narrow: ["\u0421", "\u041B", "\u0411", "\u041A", "\u0422", "\u0427", "\u041B", "\u0421", "\u0412", "\u0416", "\u041B", "\u0413"],
        abbreviated: ["\u0441\u0456\u0447.", "\u043B\u044E\u0442.", "\u0431\u0435\u0440\u0435\u0437.", "\u043A\u0432\u0456\u0442.", "\u0442\u0440\u0430\u0432.", "\u0447\u0435\u0440\u0432.", "\u043B\u0438\u043F.", "\u0441\u0435\u0440\u043F.", "\u0432\u0435\u0440\u0435\u0441.", "\u0436\u043E\u0432\u0442.", "\u043B\u0438\u0441\u0442\u043E\u043F.", "\u0433\u0440\u0443\u0434."],
        wide: ["\u0441\u0456\u0447\u043D\u044F", "\u043B\u044E\u0442\u043E\u0433\u043E", "\u0431\u0435\u0440\u0435\u0437\u043D\u044F", "\u043A\u0432\u0456\u0442\u043D\u044F", "\u0442\u0440\u0430\u0432\u043D\u044F", "\u0447\u0435\u0440\u0432\u043D\u044F", "\u043B\u0438\u043F\u043D\u044F", "\u0441\u0435\u0440\u043F\u043D\u044F", "\u0432\u0435\u0440\u0435\u0441\u043D\u044F", "\u0436\u043E\u0432\u0442\u043D\u044F", "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430", "\u0433\u0440\u0443\u0434\u043D\u044F"]
      };
      var dayValues = {
        narrow: ["\u041D", "\u041F", "\u0412", "\u0421", "\u0427", "\u041F", "\u0421"],
        short: ["\u043D\u0434", "\u043F\u043D", "\u0432\u0442", "\u0441\u0440", "\u0447\u0442", "\u043F\u0442", "\u0441\u0431"],
        abbreviated: ["\u043D\u0435\u0434", "\u043F\u043E\u043D", "\u0432\u0456\u0432", "\u0441\u0435\u0440", "\u0447\u0442\u0432", "\u043F\u0442\u043D", "\u0441\u0443\u0431"],
        wide: ["\u043D\u0435\u0434\u0456\u043B\u044F", "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A", "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A", "\u0441\u0435\u0440\u0435\u0434\u0430", "\u0447\u0435\u0442\u0432\u0435\u0440", "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F", "\u0441\u0443\u0431\u043E\u0442\u0430"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u0456\u0432\u043D.",
          noon: "\u043F\u043E\u043B.",
          morning: "\u0440\u0430\u043D\u043E\u043A",
          afternoon: "\u0434\u0435\u043D\u044C",
          evening: "\u0432\u0435\u0447.",
          night: "\u043D\u0456\u0447"
        },
        abbreviated: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u0456\u0432\u043D.",
          noon: "\u043F\u043E\u043B.",
          morning: "\u0440\u0430\u043D\u043E\u043A",
          afternoon: "\u0434\u0435\u043D\u044C",
          evening: "\u0432\u0435\u0447.",
          night: "\u043D\u0456\u0447"
        },
        wide: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
          noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
          morning: "\u0440\u0430\u043D\u043E\u043A",
          afternoon: "\u0434\u0435\u043D\u044C",
          evening: "\u0432\u0435\u0447\u0456\u0440",
          night: "\u043D\u0456\u0447"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u0456\u0432\u043D.",
          noon: "\u043F\u043E\u043B.",
          morning: "\u0440\u0430\u043D\u043A\u0443",
          afternoon: "\u0434\u043D\u044F",
          evening: "\u0432\u0435\u0447.",
          night: "\u043D\u043E\u0447\u0456"
        },
        abbreviated: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u0456\u0432\u043D.",
          noon: "\u043F\u043E\u043B.",
          morning: "\u0440\u0430\u043D\u043A\u0443",
          afternoon: "\u0434\u043D\u044F",
          evening: "\u0432\u0435\u0447.",
          night: "\u043D\u043E\u0447\u0456"
        },
        wide: {
          am: "\u0414\u041F",
          pm: "\u041F\u041F",
          midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
          noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
          morning: "\u0440\u0430\u043D\u043A\u0443",
          afternoon: "\u0434\u043D\u044F",
          evening: "\u0432\u0435\u0447.",
          night: "\u043D\u043E\u0447\u0456"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var suffix;

        if (unit === "date") {
          if (dirtyNumber === 3 || dirtyNumber === 23) {
            suffix = "-\u0454";
          } else {
            suffix = "-\u0435";
          }
        } else if (unit === "minute" || unit === "second" || unit === "hour") {
          suffix = "-\u0430";
        } else {
          suffix = "-\u0439";
        }

        return dirtyNumber + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "any",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^((до )?н\.?\s?е\.?)/i,
        abbreviated: /^((до )?н\.?\s?е\.?)/i,
        wide: /^(до нашої ери|нашої ери|наша ера)/i
      };
      var parseEraPatterns = {
        any: [/^д/i, /^н/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
        wide: /^[1234](-?[иі]?й?)? квартал/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[слбктчвжг]/i,
        abbreviated: /^(січ|лют|бер|берез|кві|трав?|чер|лип|сер|вер|жов|лис(топ)?|груд)\.?/i,
        wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопада?|грудень|грудня)/i
      };
      var parseMonthPatterns = {
        narrow: [/^с/i, /^л/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^л/i, /^с/i, /^в/i, /^ж/i, /^л/i, /^г/i],
        any: [/^сі/i, /^лю/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^лип/i, /^се/i, /^в/i, /^ж/i, /^лис/i, /^г/i]
      };
      var matchDayPatterns = {
        narrow: /^[нпвсч]/i,
        short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
        abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
        wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
      };
      var parseDayPatterns = {
        narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
        any: [/^н/i, /^п[он]/i, /^в/i, /^с[ер]/i, /^ч/i, /^п\W*?[ят]/i, /^с[уб]/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
        abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
        wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^дп/i,
          pm: /^пп/i,
          midnight: /^півн/i,
          noon: /^пол/i,
          morning: /^р/i,
          afternoon: /^д[ен]/i,
          evening: /^в/i,
          night: /^н/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "sekunddan kam",
          other: "{{count}} sekunddan kam"
        },
        xSeconds: {
          one: "1 sekund",
          other: "{{count}} sekund"
        },
        halfAMinute: "yarim minut",
        lessThanXMinutes: {
          one: "bir minutdan kam",
          other: "{{count}} minutdan kam"
        },
        xMinutes: {
          one: "1 minut",
          other: "{{count}} minut"
        },
        aboutXHours: {
          one: "tahminan 1 soat",
          other: "tahminan {{count}} soat"
        },
        xHours: {
          one: "1 soat",
          other: "{{count}} soat"
        },
        xDays: {
          one: "1 kun",
          other: "{{count}} kun"
        },
        aboutXWeeks: {
          one: "tahminan 1 hafta",
          other: "tahminan {{count}} hafta"
        },
        xWeeks: {
          one: "1 hafta",
          other: "{{count}} hafta"
        },
        aboutXMonths: {
          one: "tahminan 1 oy",
          other: "tahminan {{count}} oy"
        },
        xMonths: {
          one: "1 oy",
          other: "{{count}} oy"
        },
        aboutXYears: {
          one: "tahminan 1 yil",
          other: "tahminan {{count}} yil"
        },
        xYears: {
          one: "1 yil",
          other: "{{count}} yil"
        },
        overXYears: {
          one: "1 yildan ko'p",
          other: "{{count}} yildan ko'p"
        },
        almostXYears: {
          one: "deyarli 1 yil",
          other: "deyarli {{count}} yil"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + " dan keyin";
          } else {
            return result + " oldin";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "EEEE, do MMMM, y",
        long: "do MMMM, y",
        medium: "d MMM, y",
        short: "dd/MM/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss zzzz",
        long: "h:mm:ss z",
        medium: "h:mm:ss",
        short: "h:mm"
      };
      var dateTimeFormats = {
        any: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "any"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'oldingi' eeee p 'da'",
        yesterday: "'kecha' p 'da'",
        today: "'bugun' p 'da'",
        tomorrow: "'ertaga' p 'da'",
        nextWeek: "eeee p 'da'",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["M.A", "M."],
        abbreviated: ["M.A", "M."],
        wide: ["Miloddan Avvalgi", "Milodiy"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["CH.1", "CH.2", "CH.3", "CH.4"],
        wide: ["1-chi chorak", "2-chi chorak", "3-chi chorak", "4-chi chorak"]
      }; // Note: in English, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["Y", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
        abbreviated: ["Yan", "Fev", "Mar", "Apr", "May", "Iyun", "Iyul", "Avg", "Sen", "Okt", "Noy", "Dek"],
        wide: ["Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun", "Iyul", "Avgust", "Sentabr", "Oktabr", "Noyabr", "Dekabr"]
      };
      var dayValues = {
        narrow: ["Y", "D", "S", "CH", "P", "J", "SH"],
        short: ["Ya", "Du", "Se", "Cho", "Pa", "Ju", "Sha"],
        abbreviated: ["Yak", "Dush", "Sesh", "Chor", "Pay", "Jum", "Shan"],
        wide: ["Yakshanba", "Dushanba", "Seshanba", "Chorshanba", "Payshanba", "Juma", "Shanba"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "y.t",
          noon: "p.",
          morning: "ertalab",
          afternoon: "tushdan keyin",
          evening: "kechqurun",
          night: "tun"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "yarim tun",
          noon: "peshin",
          morning: "ertalab",
          afternoon: "tushdan keyin",
          evening: "kechqurun",
          night: "tun"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "yarim tun",
          noon: "peshin",
          morning: "ertalab",
          afternoon: "tushdan keyin",
          evening: "kechqurun",
          night: "tun"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "y.t",
          noon: "p.",
          morning: "ertalab",
          afternoon: "tushdan keyin",
          evening: "kechqurun",
          night: "tun"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "yarim tun",
          noon: "peshin",
          morning: "ertalab",
          afternoon: "tushdan keyin",
          evening: "kechqurun",
          night: "tun"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "yarim tun",
          noon: "peshin",
          morning: "ertalab",
          afternoon: "tushdan keyin",
          evening: "kechqurun",
          night: "tun"
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        return number;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(m\.a|m\.)/i,
        abbreviated: /^(m\.a\.?\s?m\.?)/i,
        wide: /^(miloddan avval|miloddan keyin)/i
      };
      var parseEraPatterns = {
        any: [/^b/i, /^(a|c)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](chi)? chorak/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[yfmasond]/i,
        abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
        wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
      };
      var parseMonthPatterns = {
        narrow: [/^y/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ya/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^iyun/i, /^iyul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[ydschj]/i,
        short: /^(ya|du|se|cho|pa|ju|sha)/i,
        abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
        wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
      };
      var parseDayPatterns = {
        narrow: [/^y/i, /^d/i, /^s/i, /^ch/i, /^p/i, /^j/i, /^sh/i],
        any: [/^ya/i, /^d/i, /^se/i, /^ch/i, /^p/i, /^j/i, /^sh/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
        any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^y\.t/i,
          noon: /^pe/i,
          morning: /ertalab/i,
          afternoon: /tushdan keyin/i,
          evening: /kechqurun/i,
          night: /tun/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "d\u01B0\u1EDBi 1 gi\xE2y",
          other: "d\u01B0\u1EDBi {{count}} gi\xE2y"
        },
        xSeconds: {
          one: "1 gi\xE2y",
          other: "{{count}} gi\xE2y"
        },
        halfAMinute: "n\u1EEDa ph\xFAt",
        lessThanXMinutes: {
          one: "d\u01B0\u1EDBi 1 ph\xFAt",
          other: "d\u01B0\u1EDBi {{count}} ph\xFAt"
        },
        xMinutes: {
          one: "1 ph\xFAt",
          other: "{{count}} ph\xFAt"
        },
        aboutXHours: {
          one: "kho\u1EA3ng 1 gi\u1EDD",
          other: "kho\u1EA3ng {{count}} gi\u1EDD"
        },
        xHours: {
          one: "1 gi\u1EDD",
          other: "{{count}} gi\u1EDD"
        },
        xDays: {
          one: "1 ng\xE0y",
          other: "{{count}} ng\xE0y"
        },
        aboutXWeeks: {
          one: "kho\u1EA3ng 1 tu\u1EA7n",
          other: "kho\u1EA3ng {{count}} tu\u1EA7n"
        },
        xWeeks: {
          one: "1 tu\u1EA7n",
          other: "{{count}} tu\u1EA7n"
        },
        aboutXMonths: {
          one: "kho\u1EA3ng 1 th\xE1ng",
          other: "kho\u1EA3ng {{count}} th\xE1ng"
        },
        xMonths: {
          one: "1 th\xE1ng",
          other: "{{count}} th\xE1ng"
        },
        aboutXYears: {
          one: "kho\u1EA3ng 1 n\u0103m",
          other: "kho\u1EA3ng {{count}} n\u0103m"
        },
        xYears: {
          one: "1 n\u0103m",
          other: "{{count}} n\u0103m"
        },
        overXYears: {
          one: "h\u01A1n 1 n\u0103m",
          other: "h\u01A1n {{count}} n\u0103m"
        },
        almostXYears: {
          one: "g\u1EA7n 1 n\u0103m",
          other: "g\u1EA7n {{count}} n\u0103m"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + " n\u1EEFa";
          } else {
            return result + " tr\u01B0\u1EDBc";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        // thứ Sáu, ngày 25 tháng 08 năm 2017
        full: "EEEE, 'ng\xE0y' d MMMM 'n\u0103m' y",
        // ngày 25 tháng 08 năm 2017
        long: "'ng\xE0y' d MMMM 'n\u0103m' y",
        // 25 thg 08 năm 2017
        medium: "d MMM 'n\u0103m' y",
        // 25/08/2017
        short: "dd/MM/y"
      };
      var timeFormats = {
        full: "HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      };
      var dateTimeFormats = {
        // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
        full: "{{date}} {{time}}",
        // ngày 25 tháng 08 năm 2017 23:25
        long: "{{date}} {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xE0o l\xFAc' p",
        yesterday: "'h\xF4m qua v\xE0o l\xFAc' p",
        today: "'h\xF4m nay v\xE0o l\xFAc' p",
        tomorrow: "'ng\xE0y mai v\xE0o l\xFAc' p",
        nextWeek: "eeee 't\u1EDBi v\xE0o l\xFAc' p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // Vietnamese locale reference: http://www.localeplanet.com/icu/vi-VN/index.html
      // Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134


      var eraValues = {
        narrow: ["TCN", "SCN"],
        abbreviated: ["tr\u01B0\u1EDBc CN", "sau CN"],
        wide: ["tr\u01B0\u1EDBc C\xF4ng Nguy\xEAn", "sau C\xF4ng Nguy\xEAn"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["Qu\xFD 1", "Qu\xFD 2", "Qu\xFD 3", "Qu\xFD 4"]
      };
      var formattingQuarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        // I notice many news outlet use this "quý II/2018"
        wide: ["qu\xFD I", "qu\xFD II", "qu\xFD III", "qu\xFD IV"]
      }; // Note: in English, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
        abbreviated: ["Thg 1", "Thg 2", "Thg 3", "Thg 4", "Thg 5", "Thg 6", "Thg 7", "Thg 8", "Thg 9", "Thg 10", "Thg 11", "Thg 12"],
        wide: ["Th\xE1ng M\u1ED9t", "Th\xE1ng Hai", "Th\xE1ng Ba", "Th\xE1ng T\u01B0", "Th\xE1ng N\u0103m", "Th\xE1ng S\xE1u", "Th\xE1ng B\u1EA3y", "Th\xE1ng T\xE1m", "Th\xE1ng Ch\xEDn", "Th\xE1ng M\u01B0\u1EDDi", "Th\xE1ng M\u01B0\u1EDDi M\u1ED9t", "Th\xE1ng M\u01B0\u1EDDi Hai"]
      }; // In Vietnamese date formatting, month number less than 10 expected to have leading zero

      var formattingMonthValues = {
        narrow: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
        abbreviated: ["thg 1", "thg 2", "thg 3", "thg 4", "thg 5", "thg 6", "thg 7", "thg 8", "thg 9", "thg 10", "thg 11", "thg 12"],
        wide: ["th\xE1ng 01", "th\xE1ng 02", "th\xE1ng 03", "th\xE1ng 04", "th\xE1ng 05", "th\xE1ng 06", "th\xE1ng 07", "th\xE1ng 08", "th\xE1ng 09", "th\xE1ng 10", "th\xE1ng 11", "th\xE1ng 12"]
      };
      var dayValues = {
        narrow: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
        short: ["CN", "Th 2", "Th 3", "Th 4", "Th 5", "Th 6", "Th 7"],
        abbreviated: ["CN", "Th\u1EE9 2", "Th\u1EE9 3", "Th\u1EE9 4", "Th\u1EE9 5", "Th\u1EE9 6", "Th\u1EE9 7"],
        wide: ["Ch\u1EE7 Nh\u1EADt", "Th\u1EE9 Hai", "Th\u1EE9 Ba", "Th\u1EE9 T\u01B0", "Th\u1EE9 N\u0103m", "Th\u1EE9 S\xE1u", "Th\u1EE9 B\u1EA3y"]
      }; // Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
      // `abbreviated` are just like English but I'm leaving the `wide`
      // format being localized with abbreviations found in some systems (SÁng / CHiều);
      // however, personally, I don't think `Chiều` sounds appropriate for `PM`

      var dayPeriodValues = {
        // narrow date period is extremely rare in Vietnamese
        // I used abbreviated form for noon, morning and afternoon
        // which are regconizable by Vietnamese, others cannot be any shorter
        narrow: {
          am: "am",
          pm: "pm",
          midnight: "n\u1EEDa \u0111\xEAm",
          noon: "tr",
          morning: "sg",
          afternoon: "ch",
          evening: "t\u1ED1i",
          night: "\u0111\xEAm"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "n\u1EEDa \u0111\xEAm",
          noon: "tr\u01B0a",
          morning: "s\xE1ng",
          afternoon: "chi\u1EC1u",
          evening: "t\u1ED1i",
          night: "\u0111\xEAm"
        },
        wide: {
          am: "SA",
          pm: "CH",
          midnight: "n\u1EEDa \u0111\xEAm",
          noon: "tr\u01B0a",
          morning: "s\xE1ng",
          afternoon: "chi\u1EC1u",
          evening: "t\u1ED1i",
          night: "\u0111\xEAm"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "am",
          pm: "pm",
          midnight: "n\u1EEDa \u0111\xEAm",
          noon: "tr",
          morning: "sg",
          afternoon: "ch",
          evening: "t\u1ED1i",
          night: "\u0111\xEAm"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "n\u1EEDa \u0111\xEAm",
          noon: "tr\u01B0a",
          morning: "s\xE1ng",
          afternoon: "chi\u1EC1u",
          evening: "t\u1ED1i",
          night: "\u0111\xEAm"
        },
        wide: {
          am: "SA",
          pm: "CH",
          midnight: "n\u1EEDa \u0111\xEAm",
          noon: "gi\u1EEFa tr\u01B0a",
          morning: "v\xE0o bu\u1ED5i s\xE1ng",
          afternoon: "v\xE0o bu\u1ED5i chi\u1EC1u",
          evening: "v\xE0o bu\u1ED5i t\u1ED1i",
          night: "v\xE0o ban \u0111\xEAm"
        }
      }; // If ordinal numbers depend on context, for example,
      // if they are different for different grammatical genders,
      // use `options.unit`:
      //
      //   var options = dirtyOptions || {}
      //   var unit = String(options.unit)
      //
      // where `unit` can be 'month', 'quarter', 'week', 'isoWeek', 'dayOfYear',
      // 'dayOfMonth' or 'dayOfWeek'

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var number = parseInt(dirtyNumber, 10);

        if (unit === "quarter") {
          // many news outlets use "quý I"...
          switch (number) {
            case 1:
              return "I";

            case 2:
              return "II";

            case 3:
              return "III";

            case 4:
              return "IV";
          }
        } else if (unit === "day") {
          // day of week in Vietnamese has ordinal number meaning,
          // so we should use them, else it'll sound weird
          switch (number) {
            case 1:
              return "th\u1EE9 2";
            // meaning 2nd day but it's the first day of the week :D

            case 2:
              return "th\u1EE9 3";
            // meaning 3rd day

            case 3:
              return "th\u1EE9 4";
            // meaning 4th day and so on

            case 4:
              return "th\u1EE9 5";

            case 5:
              return "th\u1EE9 6";

            case 6:
              return "th\u1EE9 7";

            case 7:
              return "ch\u1EE7 nh\u1EADt";
            // meaning Sunday, there's no 8th day :D
          }
        } else if (unit === "week") {
          if (number === 1) {
            return "th\u1EE9 nh\u1EA5t";
          } else {
            return "th\u1EE9 " + number;
          }
        } else if (unit === "dayOfYear") {
          if (number === 1) {
            return "\u0111\u1EA7u ti\xEAn";
          } else {
            return "th\u1EE9 " + number;
          }
        } // there are no different forms of ordinal numbers in Vietnamese


        return number;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          formattingValues: formattingQuarterValues,
          defaultFormattingWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide",
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(\d+)/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(tcn|scn)/i,
        abbreviated: /^(trước CN|sau CN)/i,
        wide: /^(trước Công Nguyên|sau Công Nguyên)/i
      };
      var parseEraPatterns = {
        any: [/^t/i, /^s/i]
      };
      var matchQuarterPatterns = {
        narrow: /^([1234]|i{1,3}v?)/i,
        abbreviated: /^q([1234]|i{1,3}v?)/i,
        wide: /^quý ([1234]|i{1,3}v?)/i
      };
      var parseQuarterPatterns = {
        any: [/(1|i)$/i, /(2|ii)$/i, /(3|iii)$/i, /(4|iv)$/i]
      };
      var matchMonthPatterns = {
        // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
        // note the order of '1' since it is a sub-string of '10', so must be lower priority
        narrow: /^(0?[2-9]|10|11|12|0?1)/i,
        // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
        abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
        // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
        wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
      };
      var parseMonthPatterns = {
        narrow: [/0?1$/i, /0?2/i, /3/, /4/, /5/, /6/, /7/, /8/, /9/, /10/, /11/, /12/],
        abbreviated: [/^thg[ _]?0?1(?!\d)/i, /^thg[ _]?0?2/i, /^thg[ _]?0?3/i, /^thg[ _]?0?4/i, /^thg[ _]?0?5/i, /^thg[ _]?0?6/i, /^thg[ _]?0?7/i, /^thg[ _]?0?8/i, /^thg[ _]?0?9/i, /^thg[ _]?10/i, /^thg[ _]?11/i, /^thg[ _]?12/i],
        wide: [/^tháng ?(Một|0?1(?!\d))/i, /^tháng ?(Hai|0?2)/i, /^tháng ?(Ba|0?3)/i, /^tháng ?(Tư|0?4)/i, /^tháng ?(Năm|0?5)/i, /^tháng ?(Sáu|0?6)/i, /^tháng ?(Bảy|0?7)/i, /^tháng ?(Tám|0?8)/i, /^tháng ?(Chín|0?9)/i, /^tháng ?(Mười|10)/i, /^tháng ?(Mười ?Một|11)/i, /^tháng ?(Mười ?Hai|12)/i]
      };
      var matchDayPatterns = {
        narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
        short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
        abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
        wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
      };
      var parseDayPatterns = {
        narrow: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
        short: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
        abbreviated: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
        wide: [/(Chủ|Chúa) ?Nhật/i, /Hai/i, /Ba/i, /Tư/i, /Năm/i, /Sáu/i, /Bảy/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
        abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
        wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^(a|sa)/i,
          pm: /^(p|ch[^i]*)/i,
          midnight: /nửa đêm/i,
          noon: /trưa/i,
          morning: /sáng/i,
          afternoon: /chiều/i,
          evening: /tối/i,
          night: /^đêm/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u4E0D\u5230 1 \u79D2",
          other: "\u4E0D\u5230 {{count}} \u79D2"
        },
        xSeconds: {
          one: "1 \u79D2",
          other: "{{count}} \u79D2"
        },
        halfAMinute: "\u534A\u5206\u949F",
        lessThanXMinutes: {
          one: "\u4E0D\u5230 1 \u5206\u949F",
          other: "\u4E0D\u5230 {{count}} \u5206\u949F"
        },
        xMinutes: {
          one: "1 \u5206\u949F",
          other: "{{count}} \u5206\u949F"
        },
        xHours: {
          one: "1 \u5C0F\u65F6",
          other: "{{count}} \u5C0F\u65F6"
        },
        aboutXHours: {
          one: "\u5927\u7EA6 1 \u5C0F\u65F6",
          other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
        },
        xDays: {
          one: "1 \u5929",
          other: "{{count}} \u5929"
        },
        aboutXWeeks: {
          one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
          other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
        },
        xWeeks: {
          one: "1 \u4E2A\u661F\u671F",
          other: "{{count}} \u4E2A\u661F\u671F"
        },
        aboutXMonths: {
          one: "\u5927\u7EA6 1 \u4E2A\u6708",
          other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
        },
        xMonths: {
          one: "1 \u4E2A\u6708",
          other: "{{count}} \u4E2A\u6708"
        },
        aboutXYears: {
          one: "\u5927\u7EA6 1 \u5E74",
          other: "\u5927\u7EA6 {{count}} \u5E74"
        },
        xYears: {
          one: "1 \u5E74",
          other: "{{count}} \u5E74"
        },
        overXYears: {
          one: "\u8D85\u8FC7 1 \u5E74",
          other: "\u8D85\u8FC7 {{count}} \u5E74"
        },
        almostXYears: {
          one: "\u5C06\u8FD1 1 \u5E74",
          other: "\u5C06\u8FD1 {{count}} \u5E74"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + "\u5185";
          } else {
            return result + "\u524D";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
        long: "y'\u5E74'M'\u6708'd'\u65E5'",
        medium: "yyyy-MM-dd",
        short: "yy-MM-dd"
      };
      var timeFormats = {
        full: "zzzz a h:mm:ss",
        long: "z a h:mm:ss",
        medium: "a h:mm:ss",
        short: "a h:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        long: "{{date}} {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;

      var _index = _interopRequireDefault(__webpack_require__(8));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function checkWeek(_date, _baseDate, _options, baseFormat) {
        if ((0, _index.default)(_date, _baseDate, _options)) {
          return baseFormat; // in same week
        } else if (_date.getTime() > _baseDate.getTime()) {
          return "'\u4E0B\u4E2A'" + baseFormat; // in next week
        }

        return "'\u4E0A\u4E2A'" + baseFormat; // in last week
      }

      var formatRelativeLocale = {
        lastWeek: checkWeek,
        // days before yesterday, maybe in this week or last week
        yesterday: "'\u6628\u5929' p",
        today: "'\u4ECA\u5929' p",
        tomorrow: "'\u660E\u5929' p",
        nextWeek: checkWeek,
        // days after tomorrow, maybe in this week or next week
        other: "PP p"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        var format = formatRelativeLocale[token];

        if (typeof format === "function") {
          return format(_date, _baseDate, _options, "eeee p");
        }

        return format;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u524D", "\u516C\u5143"],
        abbreviated: ["\u524D", "\u516C\u5143"],
        wide: ["\u516C\u5143\u524D", "\u516C\u5143"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["\u7B2C\u4E00\u523B", "\u7B2C\u4E8C\u523B", "\u7B2C\u4E09\u523B", "\u7B2C\u56DB\u523B"],
        wide: ["\u7B2C\u4E00\u523B\u949F", "\u7B2C\u4E8C\u523B\u949F", "\u7B2C\u4E09\u523B\u949F", "\u7B2C\u56DB\u523B\u949F"]
      };
      var monthValues = {
        narrow: ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u5341\u4E00", "\u5341\u4E8C"],
        abbreviated: ["1\u6708", "2\u6708", "3\u6708", "4\u6708", "5\u6708", "6\u6708", "7\u6708", "8\u6708", "9\u6708", "10\u6708", "11\u6708", "12\u6708"],
        wide: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708"]
      };
      var dayValues = {
        narrow: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"],
        short: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"],
        abbreviated: ["\u5468\u65E5", "\u5468\u4E00", "\u5468\u4E8C", "\u5468\u4E09", "\u5468\u56DB", "\u5468\u4E94", "\u5468\u516D"],
        wide: ["\u661F\u671F\u65E5", "\u661F\u671F\u4E00", "\u661F\u671F\u4E8C", "\u661F\u671F\u4E09", "\u661F\u671F\u56DB", "\u661F\u671F\u4E94", "\u661F\u671F\u516D"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u4E0A",
          pm: "\u4E0B",
          midnight: "\u51CC\u6668",
          noon: "\u5348",
          morning: "\u65E9",
          afternoon: "\u4E0B\u5348",
          evening: "\u665A",
          night: "\u591C"
        },
        abbreviated: {
          am: "\u4E0A\u5348",
          pm: "\u4E0B\u5348",
          midnight: "\u51CC\u6668",
          noon: "\u4E2D\u5348",
          morning: "\u65E9\u6668",
          afternoon: "\u4E2D\u5348",
          evening: "\u665A\u4E0A",
          night: "\u591C\u95F4"
        },
        wide: {
          am: "\u4E0A\u5348",
          pm: "\u4E0B\u5348",
          midnight: "\u51CC\u6668",
          noon: "\u4E2D\u5348",
          morning: "\u65E9\u6668",
          afternoon: "\u4E2D\u5348",
          evening: "\u665A\u4E0A",
          night: "\u591C\u95F4"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u4E0A",
          pm: "\u4E0B",
          midnight: "\u51CC\u6668",
          noon: "\u5348",
          morning: "\u65E9",
          afternoon: "\u4E0B\u5348",
          evening: "\u665A",
          night: "\u591C"
        },
        abbreviated: {
          am: "\u4E0A\u5348",
          pm: "\u4E0B\u5348",
          midnight: "\u51CC\u6668",
          noon: "\u4E2D\u5348",
          morning: "\u65E9\u6668",
          afternoon: "\u4E2D\u5348",
          evening: "\u665A\u4E0A",
          night: "\u591C\u95F4"
        },
        wide: {
          am: "\u4E0A\u5348",
          pm: "\u4E0B\u5348",
          midnight: "\u51CC\u6668",
          noon: "\u4E2D\u5348",
          morning: "\u65E9\u6668",
          afternoon: "\u4E2D\u5348",
          evening: "\u665A\u4E0A",
          night: "\u591C\u95F4"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'
        var number = Number(dirtyNumber);
        var options = dirtyOptions || {};
        var unit = String(options.unit);

        switch (unit) {
          case "date":
            return number.toString() + "\u65E5";

          case "hour":
            return number.toString() + "\u65F6";

          case "minute":
            return number.toString() + "\u5206";

          case "second":
            return number.toString() + "\u79D2";

          default:
            return "\u7B2C " + number.toString();
        }
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(前)/i,
        abbreviated: /^(前)/i,
        wide: /^(公元前|公元)/i
      };
      var parseEraPatterns = {
        any: [/^(前)/i, /^(公元)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^第[一二三四]刻/i,
        wide: /^第[一二三四]刻钟/i
      };
      var parseQuarterPatterns = {
        any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
      };
      var matchMonthPatterns = {
        narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
        abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
        wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
      };
      var parseMonthPatterns = {
        narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
        any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
      };
      var matchDayPatterns = {
        narrow: /^[一二三四五六日]/i,
        short: /^[一二三四五六日]/i,
        abbreviated: /^周[一二三四五六日]/i,
        wide: /^星期[一二三四五六日]/i
      };
      var parseDayPatterns = {
        any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^上午?/i,
          pm: /^下午?/i,
          midnight: /^午夜/i,
          noon: /^[中正]午/i,
          morning: /^早上/i,
          afternoon: /^下午/i,
          evening: /^晚上?/i,
          night: /^凌晨/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "\u5C11\u65BC 1 \u79D2",
          other: "\u5C11\u65BC {{count}} \u79D2"
        },
        xSeconds: {
          one: "1 \u79D2",
          other: "{{count}} \u79D2"
        },
        halfAMinute: "\u534A\u5206\u9418",
        lessThanXMinutes: {
          one: "\u5C11\u65BC 1 \u5206\u9418",
          other: "\u5C11\u65BC {{count}} \u5206\u9418"
        },
        xMinutes: {
          one: "1 \u5206\u9418",
          other: "{{count}} \u5206\u9418"
        },
        xHours: {
          one: "1 \u5C0F\u6642",
          other: "{{count}} \u5C0F\u6642"
        },
        aboutXHours: {
          one: "\u5927\u7D04 1 \u5C0F\u6642",
          other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
        },
        xDays: {
          one: "1 \u5929",
          other: "{{count}} \u5929"
        },
        aboutXWeeks: {
          one: "\u5927\u7D04 1 \u500B\u661F\u671F",
          other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
        },
        xWeeks: {
          one: "1 \u500B\u661F\u671F",
          other: "{{count}} \u500B\u661F\u671F"
        },
        aboutXMonths: {
          one: "\u5927\u7D04 1 \u500B\u6708",
          other: "\u5927\u7D04 {{count}} \u500B\u6708"
        },
        xMonths: {
          one: "1 \u500B\u6708",
          other: "{{count}} \u500B\u6708"
        },
        aboutXYears: {
          one: "\u5927\u7D04 1 \u5E74",
          other: "\u5927\u7D04 {{count}} \u5E74"
        },
        xYears: {
          one: "1 \u5E74",
          other: "{{count}} \u5E74"
        },
        overXYears: {
          one: "\u8D85\u904E 1 \u5E74",
          other: "\u8D85\u904E {{count}} \u5E74"
        },
        almostXYears: {
          one: "\u5C07\u8FD1 1 \u5E74",
          other: "\u5C07\u8FD1 {{count}} \u5E74"
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === "string") {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace("{{count}}", count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + "\u5167";
          } else {
            return result + "\u524D";
          }
        }

        return result;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(2));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var dateFormats = {
        full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
        long: "y'\u5E74'M'\u6708'd'\u65E5'",
        medium: "yyyy-MM-dd",
        short: "yy-MM-dd"
      };
      var timeFormats = {
        full: "zzzz a h:mm:ss",
        long: "z a h:mm:ss",
        medium: "a h:mm:ss",
        short: "a h:mm"
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}",
        long: "{{date}} {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      };
      var formatLong = {
        date: (0, _index.default)({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: (0, _index.default)({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: (0, _index.default)({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      var _default = formatLong;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'\u4E0A\u500B'eeee p",
        yesterday: "'\u6628\u5929' p",
        today: "'\u4ECA\u5929' p",
        tomorrow: "'\u660E\u5929' p",
        nextWeek: "'\u4E0B\u500B'eeee p",
        other: "P"
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(3));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var eraValues = {
        narrow: ["\u524D", "\u516C\u5143"],
        abbreviated: ["\u524D", "\u516C\u5143"],
        wide: ["\u516C\u5143\u524D", "\u516C\u5143"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["\u7B2C\u4E00\u523B", "\u7B2C\u4E8C\u523B", "\u7B2C\u4E09\u523B", "\u7B2C\u56DB\u523B"],
        wide: ["\u7B2C\u4E00\u523B\u9418", "\u7B2C\u4E8C\u523B\u9418", "\u7B2C\u4E09\u523B\u9418", "\u7B2C\u56DB\u523B\u9418"]
      };
      var monthValues = {
        narrow: ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u5341\u4E00", "\u5341\u4E8C"],
        abbreviated: ["1\u6708", "2\u6708", "3\u6708", "4\u6708", "5\u6708", "6\u6708", "7\u6708", "8\u6708", "9\u6708", "10\u6708", "11\u6708", "12\u6708"],
        wide: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708"]
      };
      var dayValues = {
        narrow: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"],
        short: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"],
        abbreviated: ["\u9031\u65E5", "\u9031\u4E00", "\u9031\u4E8C", "\u9031\u4E09", "\u9031\u56DB", "\u9031\u4E94", "\u9031\u516D"],
        wide: ["\u661F\u671F\u65E5", "\u661F\u671F\u4E00", "\u661F\u671F\u4E8C", "\u661F\u671F\u4E09", "\u661F\u671F\u56DB", "\u661F\u671F\u4E94", "\u661F\u671F\u516D"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "\u4E0A",
          pm: "\u4E0B",
          midnight: "\u51CC\u6668",
          noon: "\u5348",
          morning: "\u65E9",
          afternoon: "\u4E0B\u5348",
          evening: "\u665A",
          night: "\u591C"
        },
        abbreviated: {
          am: "\u4E0A\u5348",
          pm: "\u4E0B\u5348",
          midnight: "\u51CC\u6668",
          noon: "\u4E2D\u5348",
          morning: "\u65E9\u6668",
          afternoon: "\u4E2D\u5348",
          evening: "\u665A\u4E0A",
          night: "\u591C\u9593"
        },
        wide: {
          am: "\u4E0A\u5348",
          pm: "\u4E0B\u5348",
          midnight: "\u51CC\u6668",
          noon: "\u4E2D\u5348",
          morning: "\u65E9\u6668",
          afternoon: "\u4E2D\u5348",
          evening: "\u665A\u4E0A",
          night: "\u591C\u9593"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "\u4E0A",
          pm: "\u4E0B",
          midnight: "\u51CC\u6668",
          noon: "\u5348",
          morning: "\u65E9",
          afternoon: "\u4E0B\u5348",
          evening: "\u665A",
          night: "\u591C"
        },
        abbreviated: {
          am: "\u4E0A\u5348",
          pm: "\u4E0B\u5348",
          midnight: "\u51CC\u6668",
          noon: "\u4E2D\u5348",
          morning: "\u65E9\u6668",
          afternoon: "\u4E2D\u5348",
          evening: "\u665A\u4E0A",
          night: "\u591C\u9593"
        },
        wide: {
          am: "\u4E0A\u5348",
          pm: "\u4E0B\u5348",
          midnight: "\u51CC\u6668",
          noon: "\u4E2D\u5348",
          morning: "\u65E9\u6668",
          afternoon: "\u4E2D\u5348",
          evening: "\u665A\u4E0A",
          night: "\u591C\u9593"
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        var options = dirtyOptions || {};
        var unit = String(options.unit);

        switch (unit) {
          case "date":
            return number.toString() + "\u65E5";

          case "hour":
            return number.toString() + "\u6642";

          case "minute":
            return number.toString() + "\u5206";

          case "second":
            return number.toString() + "\u79D2";

          default:
            return "\u7B2C " + number.toString();
        }
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: (0, _index.default)({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: (0, _index.default)({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: (0, _index.default)({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: (0, _index.default)({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: (0, _index.default)({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      var _default = localize;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(5));

      var _index2 = _interopRequireDefault(__webpack_require__(4));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(前)/i,
        abbreviated: /^(前)/i,
        wide: /^(公元前|公元)/i
      };
      var parseEraPatterns = {
        any: [/^(前)/i, /^(公元)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^第[一二三四]刻/i,
        wide: /^第[一二三四]刻鐘/i
      };
      var parseQuarterPatterns = {
        any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
      };
      var matchMonthPatterns = {
        narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
        abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
        wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
      };
      var parseMonthPatterns = {
        narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
        any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
      };
      var matchDayPatterns = {
        narrow: /^[一二三四五六日]/i,
        short: /^[一二三四五六日]/i,
        abbreviated: /^週[一二三四五六日]/i,
        wide: /^星期[一二三四五六日]/i
      };
      var parseDayPatterns = {
        any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^上午?/i,
          pm: /^下午?/i,
          midnight: /^午夜/i,
          noon: /^[中正]午/i,
          morning: /^早上/i,
          afternoon: /^下午/i,
          evening: /^晚上?/i,
          night: /^凌晨/i
        }
      };
      var match = {
        ordinalNumber: (0, _index.default)({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: (0, _index2.default)({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: (0, _index2.default)({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: (0, _index2.default)({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: (0, _index2.default)({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: (0, _index2.default)({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      var _default = match;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      Object.defineProperty(__webpack_exports__, "__esModule", {
        value: true
      });
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__utils_index__ = __webpack_require__(45);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__utils_type__ = __webpack_require__(33);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(18);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__utils_events__ = __webpack_require__(62);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__datePicker__ = __webpack_require__(668);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__timePicker__ = __webpack_require__(764);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__defaultOptions__ = __webpack_require__(767);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__templates__ = __webpack_require__(768);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_8__templates_header__ = __webpack_require__(769);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_9__templates_footer__ = __webpack_require__(770);

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = undefined;

          try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var bulmaCalendar = function (_EventEmitter) {
        _inherits(bulmaCalendar, _EventEmitter);

        function bulmaCalendar(selector) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          _classCallCheck(this || _global, bulmaCalendar);

          var _this = _possibleConstructorReturn(this || _global, (bulmaCalendar.__proto__ || Object.getPrototypeOf(bulmaCalendar)).call(this || _global));

          _this.element = __WEBPACK_IMPORTED_MODULE_1__utils_type__["e"
          /* isString */
          ](selector) ? document.querySelector(selector) : selector; // An invalid selector or non-DOM node has been provided.

          if (!_this.element) {
            throw new Error("An invalid selector or non-DOM node has been provided.");
          }

          _this._clickEvents = ["click", "touch"];
          _this._supportsPassive = __WEBPACK_IMPORTED_MODULE_0__utils_index__["a"
          /* detectSupportsPassive */
          ](); // Use Element dataset values to override options

          var elementConfig = _this.element.dataset ? Object.keys(_this.element.dataset).filter(function (key) {
            return Object.keys(__WEBPACK_IMPORTED_MODULE_6__defaultOptions__["a"
            /* default */
            ]).includes(key);
          }).reduce(function (obj, key) {
            return _extends({}, obj, _defineProperty({}, key, _this.element.dataset[key]));
          }, {}) : {}; // Set default options - dataset attributes are master

          _this.options = _extends({}, __WEBPACK_IMPORTED_MODULE_6__defaultOptions__["a"
          /* default */
          ], options, elementConfig);

          if (_this.options.type === undefined) {
            switch (_this.element.getAttribute("type")) {
              case "date":
                _this.options.type = "date";
                break;

              case "time":
                _this.options.type = "time";
                break;

              default:
                _this.options.type = "datetime";
                break;
            }
          }

          _this._id = __WEBPACK_IMPORTED_MODULE_0__utils_index__["c"
          /* uuid */
          ]("datetimePicker");
          _this.onToggleDateTimePicker = _this.onToggleDateTimePicker.bind(_this);
          _this.onCloseDateTimePicker = _this.onCloseDateTimePicker.bind(_this);
          _this.onDocumentClickDateTimePicker = _this.onDocumentClickDateTimePicker.bind(_this);
          _this.onValidateClickDateTimePicker = _this.onValidateClickDateTimePicker.bind(_this);
          _this.onTodayClickDateTimePicker = _this.onTodayClickDateTimePicker.bind(_this);
          _this.onClearClickDateTimePicker = _this.onClearClickDateTimePicker.bind(_this);
          _this.onCancelClickDateTimePicker = _this.onCancelClickDateTimePicker.bind(_this);
          _this.onSelectDateTimePicker = _this.onSelectDateTimePicker.bind(_this);
          _this.onChangeStartHoursManually = _this.onChangeStartHoursManually.bind(_this);
          _this.onChangeStartMinutesManually = _this.onChangeStartMinutesManually.bind(_this);
          _this.onChangeEndHoursManually = _this.onChangeEndHoursManually.bind(_this);
          _this.onChangeEndMinutesManually = _this.onChangeEndMinutesManually.bind(_this); // Required Handler

          if (_this.element.required) {} // TODO
          // Initiate plugin


          _this._init();

          return _this;
        }
        /**
         * Initiate all DOM element containing datePicker class
         * @method
         * @return {Array} Array of all datePicker instances
         */


        _createClass(bulmaCalendar, [{
          key: "onSelectDateTimePicker",

          /****************************************************
           *                                                  *
           * EVENTS FUNCTIONS                                 *
           *                                                  *
           ****************************************************/
          value: function onSelectDateTimePicker(e) {
            this.refresh();
            this.emit(e.type, this || _global);

            if (e.type === "select" && (this || _global).options.closeOnSelect) {
              this.save();
            }
          }
        }, {
          key: "onDocumentClickDateTimePicker",
          value: function onDocumentClickDateTimePicker(e) {
            var target = e.target || e.srcElement; // Check is e.target not within datepicker element

            if (!(this || _global)._ui.wrapper.contains(target) && (this || _global).options.displayMode !== "inline") {
              this.hide();
            }
          }
        }, {
          key: "onToggleDateTimePicker",
          value: function onToggleDateTimePicker(e) {
            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();
            this.toggle();
          }
        }, {
          key: "onValidateClickDateTimePicker",
          value: function onValidateClickDateTimePicker(e) {
            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();
            this.emit("validate", this || _global);

            if (!__WEBPACK_IMPORTED_MODULE_1__utils_type__["c"
            /* isFunction */
            ]((this || _global).options.onValidate)) {
              this.save();
            }
          }
        }, {
          key: "onTodayClickDateTimePicker",
          value: function onTodayClickDateTimePicker(e) {
            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();

            (this || _global).datePicker.value(new Date());

            (this || _global).timePicker.value(new Date());

            this.refresh();

            if ((this || _global).options.closeOnSelect) {
              this.save();
            }
          }
        }, {
          key: "onClearClickDateTimePicker",
          value: function onClearClickDateTimePicker(e) {
            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();
            this.clear();

            if (!this.isOpen() || (this || _global).options.closeOnSelect) {
              this.save();
            }
          }
        }, {
          key: "onCancelClickDateTimePicker",
          value: function onCancelClickDateTimePicker(e) {
            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation(); // Reset value

            this.value((this || _global).element.value);
            this.refresh();
            this.save();
          }
        }, {
          key: "onCloseDateTimePicker",
          value: function onCloseDateTimePicker(e) {
            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();
            this.hide();
          }
        }, {
          key: "onClickTimeManuallyInput",
          value: function onClickTimeManuallyInput(e) {
            e.currentTarget.select();
          }
        }, {
          key: "onChangeStartHoursManually",
          value: function onChangeStartHoursManually(e) {
            (this || _global).timePicker.start.setHours(e.currentTarget.value);

            this.refresh();

            if ((this || _global).options.closeOnSelect) {
              this.save();
            }
          }
        }, {
          key: "onChangeStartMinutesManually",
          value: function onChangeStartMinutesManually(e) {
            (this || _global).timePicker.start.setMinutes(e.currentTarget.value);

            this.refresh();

            if ((this || _global).options.closeOnSelect) {
              this.save();
            }
          }
        }, {
          key: "onChangeEndHoursManually",
          value: function onChangeEndHoursManually(e) {
            (this || _global).timePicker.end.setHours(e.currentTarget.value);

            this.refresh();

            if ((this || _global).options.closeOnSelect) {
              this.save();
            }
          }
        }, {
          key: "onChangeEndMinutesManually",
          value: function onChangeEndMinutesManually(e) {
            (this || _global).timePicker.end.setMinutes(e.currentTarget.value);

            this.refresh();

            if ((this || _global).options.closeOnSelect) {
              this.save();
            }
          }
          /****************************************************
           *                                                  *
           * PUBLIC FUNCTIONS                                 *
           *                                                  *
           ****************************************************/

        }, {
          key: "isRange",
          value: function isRange() {
            return (this || _global).options.isRange;
          }
          /**
           * Returns true if datetime picker is open, otherwise false.
           * @method isOpen
           * @return {boolean}
           */

        }, {
          key: "isOpen",
          value: function isOpen() {
            return (this || _global)._open;
          }
          /**
           * Get / Set datetimePicker value
           * @param {*} date
           */

        }, {
          key: "value",
          value: function value() {
            var _value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null; // Set


            if (_value) {
              if ((this || _global).options.type == "datetime") {
                if ((this || _global).options.isRange) {
                  if (__WEBPACK_IMPORTED_MODULE_1__utils_type__["e"
                  /* isString */
                  ](_value)) {
                    _value = _value.split(" - ");
                  }

                  if (Array.isArray(_value)) {
                    if (_value.length) _value[0] = __WEBPACK_IMPORTED_MODULE_0__utils_index__["b"
                    /* newDate */
                    ](_value[0], (this || _global).format);
                    if (_value.length === 2) _value[1] = __WEBPACK_IMPORTED_MODULE_0__utils_index__["b"
                    /* newDate */
                    ](_value[1], (this || _global).format);
                  }
                } else {
                  if (__WEBPACK_IMPORTED_MODULE_1__utils_type__["e"
                  /* isString */
                  ](_value)) {
                    _value = __WEBPACK_IMPORTED_MODULE_0__utils_index__["b"
                    /* newDate */
                    ](_value, (this || _global).format);
                  }
                }
              }

              (this || _global).datePicker.value(_value);

              (this || _global).timePicker.value(_value);

              this._refreshInput();

              this.refresh();
              return;
            } // Get


            var string = "";

            switch ((this || _global).options.type) {
              case "date":
                string = (this || _global).datePicker.value();
                break;

              case "time":
                string = (this || _global).timePicker.value();
                break;

              case "datetime":
                var start = (this || _global).datePicker.start;
                var end = (this || _global).datePicker.end;

                if (start && (this || _global).timePicker.start) {
                  start.setHours((this || _global).timePicker.start.getHours());
                  start.setMinutes((this || _global).timePicker.start.getMinutes());
                  string = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                  /* format */
                  ](start, (this || _global).format, {
                    locale: (this || _global).locale
                  });
                }

                if ((this || _global).options.isRange) {
                  if (end && (this || _global).timePicker.end) {
                    end.setHours((this || _global).timePicker.end.getHours());
                    end.setMinutes((this || _global).timePicker.end.getMinutes());
                  }

                  string += " - " + (end ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                  /* format */
                  ](end, (this || _global).format, {
                    locale: (this || _global).locale
                  }) : "");
                }

                break;
            }

            return string;
          }
        }, {
          key: "refresh",
          value: function refresh() {
            (this || _global)._ui.header.start.day.innerHTML = (this || _global).datePicker.start ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
            /* format */
            ]((this || _global).datePicker.start, "dd", {
              locale: (this || _global).locale
            }) : "--";
            (this || _global)._ui.header.start.month.innerHTML = (this || _global).datePicker.start ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
            /* format */
            ]((this || _global).datePicker.start, (this || _global).options.formats.header, {
              locale: (this || _global).locale
            }) : "";

            if ((this || _global).datePicker.start) {
              (this || _global)._ui.header.start.weekday.classList.remove("is-hidden");

              (this || _global)._ui.header.start.weekday.innerHTML = (this || _global).datePicker.start ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
              /* format */
              ]((this || _global).datePicker.start, "EEEE", {
                locale: (this || _global).locale
              }) : "";
            } else {
              (this || _global)._ui.header.start.weekday.classList.add("is-hidden");
            }

            if ((this || _global)._ui.header.start.hour) {
              if ((this || _global).options.editTimeManually) {
                (this || _global)._ui.header.start.inputHours.value = (this || _global).timePicker.start ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ]((this || _global).timePicker.start, "HH", {
                  locale: (this || _global).locale
                }) : "--";
                (this || _global)._ui.header.start.inputMinutes.value = (this || _global).timePicker.start ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ]((this || _global).timePicker.start, "mm", {
                  locale: (this || _global).locale
                }) : "--";
              } else {
                (this || _global)._ui.header.start.hour.innerHTML = (this || _global).timePicker.start ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ]((this || _global).timePicker.start, "HH:mm", {
                  locale: (this || _global).locale
                }) : "--:--";
              }
            }

            if ((this || _global)._ui.header.end) {
              (this || _global)._ui.header.end.day.innerHTML = (this || _global).options.isRange && (this || _global).datePicker.end ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
              /* format */
              ]((this || _global).datePicker.end, "dd", {
                locale: (this || _global).locale
              }) : "--";
              (this || _global)._ui.header.end.month.innerHTML = (this || _global).options.isRange && (this || _global).datePicker.end ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
              /* format */
              ]((this || _global).datePicker.end, (this || _global).options.formats.header, {
                locale: (this || _global).locale
              }) : "";

              if ((this || _global).datePicker.end) {
                (this || _global)._ui.header.end.weekday.classList.remove("is-hidden");

                (this || _global)._ui.header.end.weekday.innerHTML = (this || _global).datePicker.end ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ]((this || _global).datePicker.end, "EEEE", {
                  locale: (this || _global).locale
                }) : "";
              } else {
                (this || _global)._ui.header.end.weekday.classList.add("is-hidden");
              }

              if ((this || _global)._ui.header.end && (this || _global)._ui.header.end.hour) {
                if ((this || _global).options.editTimeManually) {
                  (this || _global)._ui.header.end.inputHours.value = (this || _global).timePicker.end ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                  /* format */
                  ]((this || _global).timePicker.end, "HH", {
                    locale: (this || _global).locale
                  }) : "--";
                  (this || _global)._ui.header.end.inputMinutes.value = (this || _global).timePicker.end ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                  /* format */
                  ]((this || _global).timePicker.end, "mm", {
                    locale: (this || _global).locale
                  }) : "--";
                } else {
                  (this || _global)._ui.header.end.hour.innerHTML = (this || _global).timePicker.end ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                  /* format */
                  ]((this || _global).timePicker.end, "HH:mm", {
                    locale: (this || _global).locale
                  }) : "--:--";
                }
              }
            }

            this.emit("refresh", this || _global);
          }
        }, {
          key: "clear",
          value: function clear() {
            (this || _global).datePicker.clear();

            (this || _global).timePicker.clear();

            this.refresh();

            if (!this.isOpen()) {
              this._refreshInput();
            }

            this.emit("clear", this || _global);
          }
          /**
           * Show datePicker HTML Component
           * @method show
           * @return {void}
           */

        }, {
          key: "show",
          value: function show() {
            (this || _global).datePicker.show();

            (this || _global).timePicker.show();

            if ((this || _global)._ui.modal) {
              (this || _global)._ui.modal.classList.add("is-active");
            }

            (this || _global)._ui.dummy.wrapper.classList.add("is-active");

            (this || _global)._ui.wrapper.classList.add("is-active");

            (this || _global)._open = true;
            this.emit("show", this || _global);
          }
          /**
           * Toggle Component
           */

        }, {
          key: "toggle",
          value: function toggle() {
            if ((this || _global)._open) {
              this.hide();
            } else {
              this.show();
            }
          }
          /**
           * Hide datePicker HTML Component
           * @method hide
           * @return {void}
           */

        }, {
          key: "hide",
          value: function hide() {
            if (!(this || _global)._open) return;

            (this || _global).datePicker.hide();

            (this || _global).timePicker.hide();

            (this || _global)._open = false;
            (this || _global)._focus = false;

            if ((this || _global)._ui.modal) {
              (this || _global)._ui.modal.classList.remove("is-active");
            }

            (this || _global)._ui.dummy.wrapper.classList.remove("is-active");

            (this || _global)._ui.wrapper.classList.remove("is-active");

            this.emit("hide", this || _global);
          } // Set element value to datetime selected based on format

        }, {
          key: "save",
          value: function save() {
            this._refreshInput();

            if ((this || _global).options.displayMode !== "inline") {
              this.hide();
            }

            this.emit("save", this || _global);
          }
          /**
           * Destroy datePicker
           * @method destroy
           */

        }, {
          key: "destroy",
          value: function destroy() {
            document.getElementById((this || _global).id).remove();
            (this || _global).datePicker = null;
            (this || _global).timePicker = null;
            (this || _global)._ui = null;
          }
          /****************************************************
           *                                                  *
           * PRIVATE FUNCTIONS                                *
           *                                                  *
           ****************************************************/

          /**
           * Initiate plugin instance
           * @method _init
           * @return {datePicker} Current plugin instance
           */

        }, {
          key: "_init",
          value: function _init() {
            (this || _global)._open = false;
            (this || _global)._type = ["date", "time", "datetime"].indexOf((this || _global).options.type.toLowerCase()) > -1 ? (this || _global).options.type.toLowerCase() : "date"; // Set component type (date / time / datetime)
            // Change element type to prevent browser default type="date" behavior

            (this || _global).element.setAttribute("type", "text"); // create pickers


            (this || _global).datePicker = new __WEBPACK_IMPORTED_MODULE_4__datePicker__["a"
            /* default */
            ](_extends({}, (this || _global).options));
            (this || _global).timePicker = new __WEBPACK_IMPORTED_MODULE_5__timePicker__["a"
            /* default */
            ](_extends({}, (this || _global).options));
            (this || _global).lang = (this || _global).options.lang;
            (this || _global).format = (this || _global)._type === "date" ? (this || _global).options.dateFormat : (this || _global)._type === "time" ? (this || _global).options.timeFormat : (this || _global).options.dateFormat + " " + (this || _global).options.timeFormat; // Set export format based on component type
            // Force dialog display mode on mobile devices

            if ((this || _global).options.displayMode === "default" && window.matchMedia("screen and (max-width: 768px)").matches) {
              (this || _global).options.displayMode = "dialog";
            }

            if (window.matchMedia("screen and (max-width: 768px)").matches) {
              if ((this || _global).options.displayMode === "default") {
                (this || _global).options.displayMode = "dialog";
              }

              (this || _global).options.displayDual = false;
            }

            this._build();

            this._bindEvents(); // apply value to picker


            if ((this || _global).element.value) {
              this.value((this || _global).element.value);
            }

            this._refreshInput(); // Callbacks


            if (__WEBPACK_IMPORTED_MODULE_1__utils_type__["c"
            /* isFunction */
            ]((this || _global).options.onReady)) {
              this.on("ready", (this || _global).options.onReady);
            }

            if (__WEBPACK_IMPORTED_MODULE_1__utils_type__["c"
            /* isFunction */
            ]((this || _global).options.onValidate)) {
              this.on("validate", (this || _global).options.onValidate);
            }

            this.emit("ready", this || _global);
          }
          /**
           * Build datePicker HTML component and append it to the DOM
           * @method _build
           * @return {datePicker} Current plugin instance
           */

        }, {
          key: "_build",
          value: function _build() {
            var headerNode = document.createRange().createContextualFragment(Object(__WEBPACK_IMPORTED_MODULE_8__templates_header__["a"
            /* default */
            ])(_extends({}, (this || _global).options, {
              type: (this || _global)._type,
              datePicker: (this || _global).options.type !== "time",
              timePicker: (this || _global).options.type !== "date"
            })));
            var footerNode = document.createRange().createContextualFragment(Object(__WEBPACK_IMPORTED_MODULE_9__templates_footer__["a"
            /* default */
            ])((this || _global).options));
            var datetimePickerNode = document.createRange().createContextualFragment(Object(__WEBPACK_IMPORTED_MODULE_7__templates__["a"
            /* default */
            ])(_extends({}, (this || _global).options, {
              id: (this || _global).id
            }))); // Save pointer to each datePicker element for later use

            (this || _global)._ui = {
              modal: datetimePickerNode.querySelector(".datetimepicker-wrapper.modal"),
              wrapper: datetimePickerNode.querySelector(".datetimepicker"),
              container: datetimePickerNode.querySelector(".datetimepicker-container"),
              dummy: {
                container: datetimePickerNode.querySelector(".datetimepicker-dummy"),
                wrapper: datetimePickerNode.querySelector(".datetimepicker-dummy-wrapper"),
                dummy_1: datetimePickerNode.querySelector(".datetimepicker-dummy .datetimepicker-dummy-input:nth-child(1)"),
                dummy_2: datetimePickerNode.querySelector(".datetimepicker-dummy .datetimepicker-dummy-input:nth-child(2)"),
                clear: datetimePickerNode.querySelector(".datetimepicker-dummy .datetimepicker-clear-button")
              },
              calendar: datetimePickerNode.querySelector(".datetimepicker"),
              overlay: (this || _global).options.displayMode === "dialog" ? {
                background: datetimePickerNode.querySelector(".modal-background"),
                close: datetimePickerNode.querySelector(".modal-close")
              } : undefined,
              header: {
                container: headerNode.querySelector(".datetimepicker-header"),
                start: {
                  container: headerNode.querySelector(".datetimepicker-selection-start"),
                  day: headerNode.querySelector(".datetimepicker-selection-start .datetimepicker-selection-day"),
                  month: headerNode.querySelector(".datetimepicker-selection-start .datetimepicker-selection-month"),
                  weekday: headerNode.querySelector(".datetimepicker-selection-start .datetimepicker-selection-weekday"),
                  hour: headerNode.querySelector(".datetimepicker-selection-start .datetimepicker-selection-hour"),
                  inputHours: headerNode.querySelector(".datetimepicker-selection-start .datetimepicker-selection-hour.editable .datetimepicker-selection-input-hours"),
                  inputMinutes: headerNode.querySelector(".datetimepicker-selection-start .datetimepicker-selection-hour.editable .datetimepicker-selection-input-minutes"),
                  empty: headerNode.querySelector(".datetimepicker-selection-start .empty")
                },
                end: (this || _global).options.isRange ? {
                  container: headerNode.querySelector(".datetimepicker-selection-end"),
                  day: headerNode.querySelector(".datetimepicker-selection-end .datetimepicker-selection-day"),
                  month: headerNode.querySelector(".datetimepicker-selection-end .datetimepicker-selection-month"),
                  weekday: headerNode.querySelector(".datetimepicker-selection-end .datetimepicker-selection-weekday"),
                  hour: headerNode.querySelector(".datetimepicker-selection-end .datetimepicker-selection-hour"),
                  inputHours: headerNode.querySelector(".datetimepicker-selection-end .datetimepicker-selection-hour.editable .datetimepicker-selection-input-hours"),
                  inputMinutes: headerNode.querySelector(".datetimepicker-selection-end .datetimepicker-selection-hour.editable .datetimepicker-selection-input-minutes"),
                  empty: headerNode.querySelector(".datetimepicker-selection-start .empty")
                } : undefined
              },
              footer: {
                container: footerNode.querySelector(".datetimepicker-footer"),
                validate: footerNode.querySelector(".datetimepicker-footer-validate"),
                today: footerNode.querySelector(".datetimepicker-footer-today"),
                clear: footerNode.querySelector(".datetimepicker-footer-clear"),
                cancel: footerNode.querySelector(".datetimepicker-footer-cancel")
              }
            };

            if (!__WEBPACK_IMPORTED_MODULE_1__utils_type__["a"
            /* BooleanParse */
            ]((this || _global).options.showHeader)) {
              (this || _global)._ui.header.container.classList.add("is-hidden");
            }

            if (!__WEBPACK_IMPORTED_MODULE_1__utils_type__["a"
            /* BooleanParse */
            ]((this || _global).options.showFooter)) {
              (this || _global)._ui.footer.container.classList.add("is-hidden");
            }

            if (!__WEBPACK_IMPORTED_MODULE_1__utils_type__["a"
            /* BooleanParse */
            ]((this || _global).options.showTodayButton)) {
              (this || _global)._ui.footer.today.classList.add("is-hidden");
            }

            if (!__WEBPACK_IMPORTED_MODULE_1__utils_type__["a"
            /* BooleanParse */
            ]((this || _global).options.showClearButton)) {
              (this || _global)._ui.footer.clear.classList.add("is-hidden");
            }

            if ((this || _global).options.closeOnSelect && (this || _global)._ui.footer.validate) {
              (this || _global)._ui.footer.validate.classList.add("is-hidden");
            }

            (this || _global)._ui.container.appendChild(headerNode);

            switch ((this || _global)._type) {
              case "date":
                (this || _global)._ui.container.appendChild((this || _global).datePicker.render());

                break;

              case "time":
                (this || _global).options.closeOnSelect = false;

                (this || _global)._ui.container.appendChild((this || _global).timePicker.render());

                if ((this || _global).options.labelFrom || (this || _global).options.labelTo) {
                  (this || _global)._ui.header.container.classList.remove("is-hidden");
                }

                if ((this || _global)._ui.footer.validate) {
                  (this || _global)._ui.footer.validate.classList.remove("is-hidden");
                }

                if ((this || _global)._ui.footer.today) {
                  (this || _global)._ui.footer.today.classList.add("is-hidden");
                }

                break;

              case "datetime":
                (this || _global).options.closeOnSelect = false;

                if ((this || _global)._ui.footer.validate) {
                  (this || _global)._ui.footer.validate.classList.remove("is-hidden");
                }

                (this || _global)._ui.container.appendChild((this || _global).datePicker.render());

                (this || _global)._ui.container.appendChild((this || _global).timePicker.render());

                break;
            }

            (this || _global)._ui.wrapper.appendChild(footerNode);

            (this || _global)._ui.wrapper.classList.add("is-" + (this || _global).options.color);

            (this || _global)._ui.dummy.container.classList.add("is-" + (this || _global).options.color); // Add datepicker HTML element to Document Body


            (this || _global).element.parentNode.insertBefore(datetimePickerNode, (this || _global).element.nextSibling);

            (this || _global)._ui.dummy.wrapper.appendChild((this || _global).element);

            (this || _global).element.classList.add("is-hidden");

            if ((this || _global).options.displayMode === "inline") {
              (this || _global)._ui.wrapper.classList.add("is-active");
            } else {
              (this || _global)._ui.dummy.container.classList.remove("is-hidden");

              (this || _global)._ui.wrapper.style.position = "absolute";

              (this || _global)._ui.wrapper.classList.add("is-datetimepicker-default");
            }

            this.refresh();
          }
          /**
           * Bind all events
           * @method _bindEvents
           * @return {void}
           */

        }, {
          key: "_bindEvents",
          value: function _bindEvents() {
            var _this2 = this || _global;

            (this || _global)._clickEvents.forEach(function (clickEvent) {
              document.body.addEventListener(clickEvent, _this2.onDocumentClickDateTimePicker);
            });

            (this || _global).datePicker.on("select", (this || _global).onSelectDateTimePicker);

            (this || _global).datePicker.on("select:start", (this || _global).onSelectDateTimePicker);

            (this || _global).timePicker.on("select", (this || _global).onSelectDateTimePicker);

            (this || _global).timePicker.on("select:start", (this || _global).onSelectDateTimePicker); // Bind event to element in order to display/hide datePicker on click


            if ((this || _global).options.toggleOnInputClick === true) {
              (this || _global)._clickEvents.forEach(function (clickEvent) {
                _this2._ui.dummy.wrapper.addEventListener(clickEvent, _this2.onToggleDateTimePicker);

                _this2.element.addEventListener(clickEvent, _this2.onToggleDateTimePicker);
              });
            } // Bind change time events for header inputs


            if ((this || _global).options.type !== "date" && (this || _global).options.editTimeManually) {
              // Bind event for start hours change
              (this || _global)._ui.header.start.inputHours.addEventListener("change", (this || _global).onChangeStartHoursManually);

              (this || _global)._ui.header.start.inputHours.addEventListener("click", (this || _global).onClickTimeManuallyInput); // Bind event for start minutes change


              (this || _global)._ui.header.start.inputMinutes.addEventListener("change", (this || _global).onChangeStartMinutesManually);

              (this || _global)._ui.header.start.inputMinutes.addEventListener("click", (this || _global).onClickTimeManuallyInput);

              if ((this || _global).options.isRange) {
                // Bind event for end hours change
                (this || _global)._ui.header.end.inputHours.addEventListener("change", (this || _global).onChangeEndHoursManually);

                (this || _global)._ui.header.end.inputHours.addEventListener("click", (this || _global).onClickTimeManuallyInput); // Bind event for end minutes change


                (this || _global)._ui.header.end.inputMinutes.addEventListener("change", (this || _global).onChangeEndMinutesManually);

                (this || _global)._ui.header.end.inputMinutes.addEventListener("click", (this || _global).onClickTimeManuallyInput);
              }
            }

            if ((this || _global).options.displayMode === "dialog" && (this || _global)._ui.overlay) {
              // Bind close event on Close button
              if ((this || _global)._ui.overlay.close) {
                (this || _global)._clickEvents.forEach(function (clickEvent) {
                  _this2.this._ui.overlay.close.addEventListener(clickEvent, _this2.onCloseDateTimePicker);
                });
              } // Bind close event on overlay based on options


              if ((this || _global).options.closeOnOverlayClick && (this || _global)._ui.overlay.background) {
                (this || _global)._clickEvents.forEach(function (clickEvent) {
                  _this2._ui.overlay.background.addEventListener(clickEvent, _this2.onCloseDateTimePicker);
                });
              }
            }

            if ((this || _global)._ui.footer.validate) {
              (this || _global)._clickEvents.forEach(function (clickEvent) {
                _this2._ui.footer.validate.addEventListener(clickEvent, _this2.onValidateClickDateTimePicker);
              });
            }

            if ((this || _global)._ui.footer.today) {
              (this || _global)._clickEvents.forEach(function (clickEvent) {
                _this2._ui.footer.today.addEventListener(clickEvent, _this2.onTodayClickDateTimePicker);
              });
            }

            if ((this || _global)._ui.footer.clear) {
              (this || _global)._clickEvents.forEach(function (clickEvent) {
                _this2._ui.footer.clear.addEventListener(clickEvent, _this2.onClearClickDateTimePicker);
              });
            }

            (this || _global)._clickEvents.forEach(function (clickEvent) {
              _this2._ui.dummy.clear.addEventListener(clickEvent, _this2.onClearClickDateTimePicker);
            });

            if ((this || _global)._ui.footer.cancel) {
              (this || _global)._clickEvents.forEach(function (clickEvent) {
                _this2._ui.footer.cancel.addEventListener(clickEvent, _this2.onCancelClickDateTimePicker);
              });
            }
          }
          /**
           * Refresh Input
           * @private
           */

        }, {
          key: "_refreshInput",
          value: function _refreshInput() {
            var _value$split = this.value().split(" - "),
                _value$split2 = _slicedToArray(_value$split, 2),
                start = _value$split2[0],
                end = _value$split2[1];

            (this || _global)._ui.dummy.dummy_1.value = start ? start : "";

            if ((this || _global)._ui.dummy.dummy_2) {
              (this || _global)._ui.dummy.dummy_2.value = end ? end : "";
            }

            (this || _global).element.setAttribute("value", this.value());
          }
        }, {
          key: "id",

          /****************************************************
           *                                                  *
           * GETTERS and SETTERS                              *
           *                                                  *
           ****************************************************/

          /**
           * Get id of current instance
           */
          get: function get() {
            return (this || _global)._id;
          } // Set language

        }, {
          key: "lang",
          set: function set(lang) {
            try {
              (this || _global)._locale = __webpack_require__(26)("./" + lang + "/index.js");
            } catch (e) {
              lang = "en-US";
              (this || _global)._locale = __webpack_require__(26)("./" + lang + "/index.js");
            } finally {
              (this || _global)._lang = lang;
              (this || _global).datePicker.lang = lang;
              (this || _global).timePicker.lang = lang;
              return this || _global;
            }
          } // Get current language
          ,
          get: function get() {
            return (this || _global)._lang;
          }
        }, {
          key: "locale",
          get: function get() {
            return (this || _global)._locale;
          } // Set format (set to yyyy-mm-dd HH:mm:ss by default)

        }, {
          key: "format",
          set: function set(format) {
            (this || _global)._format = format;
            return this || _global;
          } // Get format
          ,
          get: function get() {
            return (this || _global)._format;
          }
          /**
           * * Date setter and getter
           */

        }, {
          key: "date",
          set: function set(date) {
            (this || _global).datePicker.date = date;
            return this || _global;
          } // Get date object
          ,
          get: function get() {
            return (this || _global).datePicker.date;
          }
        }, {
          key: "startDate",
          set: function set(date) {
            (this || _global).datePicker.start = date;
            return this || _global;
          },
          get: function get() {
            return (this || _global).datePicker.start;
          }
        }, {
          key: "endDate",
          set: function set(date) {
            (this || _global).datePicker.end = date;
            return this || _global;
          },
          get: function get() {
            return (this || _global).datePicker.end;
          }
          /**
           * minDate getter and setters
           */

        }, {
          key: "minDate",
          set: function set(date) {
            (this || _global).datePicker.minDate = date;
            return this || _global;
          } // Get minDate
          ,
          get: function get() {
            return (this || _global).datePicker.minDate;
          } // Set maxDate

        }, {
          key: "maxDate",
          set: function set(date) {
            (this || _global).datePicker.maxDate = date;
            return this || _global;
          } // Get maxDate
          ,
          get: function get() {
            return (this || _global).datePicker.maxDate;
          } // Set dateFormat (set to yyyy-mm-dd by default)

        }, {
          key: "dateFormat",
          set: function set(dateFormat) {
            (this || _global).datePicker.dateFormat = dateFormat;
            return this || _global;
          } // Get dateFormat
          ,
          get: function get() {
            return (this || _global).datePicker.dateFormat;
          }
          /**
           * * Time setter and getter
           */

        }, {
          key: "time",
          set: function set(time) {
            (this || _global).timePicker.time = time;
            return this || _global;
          } // Get time object
          ,
          get: function get() {
            return (this || _global).timePicker.time;
          }
        }, {
          key: "startTime",
          set: function set(time) {
            (this || _global).timePicker.start = time;
            return this || _global;
          },
          get: function get() {
            return (this || _global).timePicker.start;
          }
        }, {
          key: "endTime",
          set: function set(time) {
            (this || _global).timePicker.end = time;
            return this || _global;
          },
          get: function get() {
            return (this || _global).timePicker.end;
          }
          /**
           * minTime getter and setters
           */

        }, {
          key: "minTime",
          set: function set(time) {
            (this || _global).timePicker.minTime = time;
            return this || _global;
          } // Get minTime
          ,
          get: function get() {
            return (this || _global).timePicker.minTime;
          } // Set maxTime

        }, {
          key: "maxTime",
          set: function set(time) {
            (this || _global).timePicker.maxTime = time;
            return this || _global;
          } // Get maxTime
          ,
          get: function get() {
            return (this || _global).timePicker.maxTime;
          } // Set timeFormat (set to HH:MM:SS by default)

        }, {
          key: "timeFormat",
          set: function set(timeFormat) {
            (this || _global).timePicker.timeFormat = timeFormat;
            return this || _global;
          } // Get timeFormat
          ,
          get: function get() {
            return (this || _global).timePicker.timeFormat;
          }
        }], [{
          key: "attach",
          value: function attach() {
            var _this3 = this || _global;

            var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "input[type=\"date\"]";
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var instances = [];
            var elements = __WEBPACK_IMPORTED_MODULE_1__utils_type__["e"
            /* isString */
            ](selector) ? document.querySelectorAll(selector) : Array.isArray(selector) ? selector : [selector];
            [].forEach.call(elements, function (element) {
              if (typeof element[_this3.constructor.name] === "undefined") {
                var instance = new bulmaCalendar(element, options);
                element.bulmaCalendar = instance;
                instances.push(instance);
              } else {
                instances.push(element[_this3.constructor.name]);
              }
            });
            return instances;
          }
        }]);

        return bulmaCalendar;
      }(__WEBPACK_IMPORTED_MODULE_3__utils_events__["a"
      /* default */
      ]);
      /* harmony default export */


      __webpack_exports__["default"] = bulmaCalendar;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(10);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(27);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__ = __webpack_require__(6);
      /**
       * @name add
       * @category Common Helpers
       * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
       *
       * @description
       * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       *
       * | Key            | Description                        |
       * |----------------|------------------------------------|
       * | years          | Amount of years to be added        |
       * | months         | Amount of months to be added       |
       * | weeks          | Amount of weeks to be added        |
       * | days           | Amount of days to be added         |
       * | hours          | Amount of hours to be added        |
       * | minutes        | Amount of minutes to be added      |
       * | seconds        | Amount of seconds to be added      |
       *
       * All values default to 0
       *
       * @returns {Date} the new date with the seconds added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add the following duration to 1 September 2014, 10:19:50
       * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
       *   years: 2,
       *   months: 9,
       *   weeks: 1,
       *   days: 7,
       *   hours: 5,
       *   minutes: 9,
       *   seconds: 30,
       * })
       * //=> Thu Jun 15 2017 15:29:20
       */


      function add(dirtyDate, duration) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        if (!duration || typeof duration !== "object") return new Date(NaN);
        var years = duration.years ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.years) : 0;
        var months = duration.months ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.months) : 0;
        var weeks = duration.weeks ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.weeks) : 0;
        var days = duration.days ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.days) : 0;
        var hours = duration.hours ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.hours) : 0;
        var minutes = duration.minutes ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.minutes) : 0;
        var seconds = duration.seconds ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ])(duration.seconds) : 0; // Add years and months

        var date = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var dateWithMonths = months || years ? Object(__WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["a"
        /* default */
        ])(date, months + years * 12) : date; // Add weeks and days

        var dateWithDays = days || weeks ? Object(__WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a"
        /* default */
        ])(dateWithMonths, days + weeks * 7) : dateWithMonths; // Add days, hours, minutes and seconds

        var minutesToAdd = minutes + hours * 60;
        var secondsToAdd = seconds + minutesToAdd * 60;
        var msToAdd = secondsToAdd * 1000;
        var finalDate = new Date(dateWithDays.getTime() + msToAdd);
        return finalDate;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name areIntervalsOverlapping
       * @category Interval Helpers
       * @summary Is the given time interval overlapping with another time interval?
       *
       * @description
       * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `areRangesOverlapping` to `areIntervalsOverlapping`.
       *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
       *
       *   ```
       *   2.1.3
       *   time interval
       *   part of the time axis limited by two instants
       *   ```
       *
       *   Also, this function now accepts an object with `start` and `end` properties
       *   instead of two arguments as an interval.
       *   This function now throws `RangeError` if the start of the interval is after its end
       *   or if any date in the interval is `Invalid Date`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   areRangesOverlapping(
       *     new Date(2014, 0, 10), new Date(2014, 0, 20),
       *     new Date(2014, 0, 17), new Date(2014, 0, 21)
       *   )
       *
       *   // v2.0.0 onward
       *
       *   areIntervalsOverlapping(
       *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
       *   )
       *   ```
       *
       * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
       * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
       * @param {Object} [options] - the object with options
       * @param {Boolean} [options.inclusive=false] - whether the comparison is inclusive or not
       * @returns {Boolean} whether the time intervals are overlapping
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // For overlapping time intervals:
       * areIntervalsOverlapping(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
       * )
       * //=> true
       *
       * @example
       * // For non-overlapping time intervals:
       * areIntervalsOverlapping(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
       * )
       * //=> false
       *
       * @example
       * // For adjacent time intervals:
       * areIntervalsOverlapping(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
       * )
       * //=> false
       *
       * @example
       * // Using the inclusive option:
       * areIntervalsOverlapping(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
       * )
       * //=> false
       * areIntervalsOverlapping(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
       *   { inclusive: true }
       * )
       * //=> true
       */


      function areIntervalsOverlapping(dirtyIntervalLeft, dirtyIntervalRight) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
          inclusive: false
        };
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var intervalLeft = dirtyIntervalLeft || {};
        var intervalRight = dirtyIntervalRight || {};
        var leftStartTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(intervalLeft.start).getTime();
        var leftEndTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(intervalLeft.end).getTime();
        var rightStartTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(intervalRight.start).getTime();
        var rightEndTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
          throw new RangeError("Invalid interval");
        }

        if (options.inclusive) {
          return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
        }

        return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__max_index_js__ = __webpack_require__(79);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__min_index_js__ = __webpack_require__(80);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name clamp
       * @category Interval Helpers
       * @summary Return a date bounded by the start and the end of the given interval
       *
       * @description
       * Clamps a date to the lower bound with the start of the interval and the upper
       * bound with the end of the interval.
       *
       * - When the date is less than the start of the interval, the start is returned.
       * - When the date is greater than the end of the interval, the end is returned.
       * - Otherwise the date is returned.
       *
       * @example
       * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
       * const result = clamp(new Date(2021, 2, 21), {
       *   start: new Date(2021, 2, 22),
       *   end: new Date(2021, 3, 1),
       * })
       * //=> Mon Mar 22 2021 00:00:00
       *
       * @param {Date | Number} date - the date to be bounded
       * @param {Interval} interval - the interval to bound to
       * @returns {Date} the date bounded by the start and the end of the interval
       * @throws {TypeError} 2 arguments required
       */


      function clamp(date, _ref) {
        var start = _ref.start,
            end = _ref.end;
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__min_index_js__["a"
        /* default */
        ])([Object(__WEBPACK_IMPORTED_MODULE_0__max_index_js__["a"
        /* default */
        ])([date, start]), end]);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name closestIndexTo
       * @category Common Helpers
       * @summary Return an index of the closest date from the array comparing to the given date.
       *
       * @description
       * Return an index of the closest date from the array comparing to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - Now, `closestIndexTo` doesn't throw an exception
       *   when the second argument is not an array, and returns Invalid Date instead.
       *
       * @param {Date|Number} dateToCompare - the date to compare with
       * @param {Date[]|Number[]} datesArray - the array to search
       * @returns {Number} an index of the date closest to the given date
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Which date is closer to 6 September 2015?
       * var dateToCompare = new Date(2015, 8, 6)
       * var datesArray = [
       *   new Date(2015, 0, 1),
       *   new Date(2016, 0, 1),
       *   new Date(2017, 0, 1)
       * ]
       * var result = closestIndexTo(dateToCompare, datesArray)
       * //=> 1
       */


      function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateToCompare);

        if (isNaN(dateToCompare)) {
          return NaN;
        }

        var timeToCompare = dateToCompare.getTime();
        var datesArray; // `dirtyDatesArray` is undefined or null

        if (dirtyDatesArray == null) {
          datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
        } else if (typeof dirtyDatesArray.forEach === "function") {
          datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
        } else {
          datesArray = Array.prototype.slice.call(dirtyDatesArray);
        }

        var result;
        var minDistance;
        datesArray.forEach(function (dirtyDate, index) {
          var currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ])(dirtyDate);

          if (isNaN(currentDate)) {
            result = NaN;
            minDistance = NaN;
            return;
          }

          var distance = Math.abs(timeToCompare - currentDate.getTime());

          if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
          }
        });
        return result;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name closestTo
       * @category Common Helpers
       * @summary Return a date from the array closest to the given date.
       *
       * @description
       * Return a date from the array closest to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - Now, `closestTo` doesn't throw an exception
       *   when the second argument is not an array, and returns Invalid Date instead.
       *
       * @param {Date|Number} dateToCompare - the date to compare with
       * @param {Date[]|Number[]} datesArray - the array to search
       * @returns {Date} the date from the array closest to the given date
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
       * var dateToCompare = new Date(2015, 8, 6)
       * var result = closestTo(dateToCompare, [
       *   new Date(2000, 0, 1),
       *   new Date(2030, 0, 1)
       * ])
       * //=> Tue Jan 01 2030 00:00:00
       */


      function closestTo(dirtyDateToCompare, dirtyDatesArray) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateToCompare);

        if (isNaN(dateToCompare)) {
          return new Date(NaN);
        }

        var timeToCompare = dateToCompare.getTime();
        var datesArray; // `dirtyDatesArray` is undefined or null

        if (dirtyDatesArray == null) {
          datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
        } else if (typeof dirtyDatesArray.forEach === "function") {
          datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
        } else {
          datesArray = Array.prototype.slice.call(dirtyDatesArray);
        }

        var result;
        var minDistance;
        datesArray.forEach(function (dirtyDate) {
          var currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ])(dirtyDate);

          if (isNaN(currentDate)) {
            result = new Date(NaN);
            minDistance = NaN;
            return;
          }

          var distance = Math.abs(timeToCompare - currentDate.getTime());

          if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
          }
        });
        return result;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name compareDesc
       * @category Common Helpers
       * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
       *
       * @description
       * Compare the two dates and return -1 if the first date is after the second,
       * 1 if the first date is before the second or 0 if dates are equal.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to compare
       * @param {Date|Number} dateRight - the second date to compare
       * @returns {Number} the result of the comparison
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
       * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
       * //=> 1
       *
       * @example
       * // Sort the array of dates in reverse chronological order:
       * const result = [
       *   new Date(1995, 6, 2),
       *   new Date(1987, 1, 11),
       *   new Date(1989, 6, 10)
       * ].sort(compareDesc)
       * //=> [
       * //   Sun Jul 02 1995 00:00:00,
       * //   Mon Jul 10 1989 00:00:00,
       * //   Wed Feb 11 1987 00:00:00
       * // ]
       */


      function compareDesc(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        var diff = dateLeft.getTime() - dateRight.getTime();

        if (diff > 0) {
          return -1;
        } else if (diff < 0) {
          return 1; // Return 0 if diff is 0; return NaN if diff is NaN
        } else {
          return diff;
        }
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name daysToWeeks
       * @category Conversion Helpers
       * @summary Convert days to weeks.
       *
       * @description
       * Convert a number of days to a full number of weeks.
       *
       * @param {number} days - number of days to be converted
       *
       * @returns {number} the number of days converted in weeks
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 14 days to weeks:
       * const result = daysToWeeks(14)
       * //=> 2
       *
       * @example
       * // It uses floor rounding:
       * const result = daysToWeeks(13)
       * //=> 1
       */


      function daysToWeeks(days) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var weeks = days / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["a"
        /* daysInWeek */
        ];
        return Math.floor(weeks);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isValid_index_js__ = __webpack_require__(9);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isWeekend_index_js__ = __webpack_require__(34);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__differenceInCalendarDays_index_js__ = __webpack_require__(20);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__addDays_index_js__ = __webpack_require__(10);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__isSameDay_index_js__ = __webpack_require__(30);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInBusinessDays
       * @category Day Helpers
       * @summary Get the number of business days between the given dates.
       *
       * @description
       * Get the number of business day periods between the given dates.
       * Business days being days that arent in the weekend.
       * Like `differenceInCalendarDays`, the function removes the times from
       * the dates before calculating the difference.
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of business days
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many business days are between
       * // 10 January 2014 and 20 July 2014?
       * var result = differenceInBusinessDays(
       *   new Date(2014, 6, 20),
       *   new Date(2014, 0, 10)
       * )
       * //=> 136
       */


      function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_7__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__isValid_index_js__["a"
        /* default */
        ])(dateLeft) || !Object(__WEBPACK_IMPORTED_MODULE_0__isValid_index_js__["a"
        /* default */
        ])(dateRight)) return NaN;
        var calendarDifference = Object(__WEBPACK_IMPORTED_MODULE_3__differenceInCalendarDays_index_js__["a"
        /* default */
        ])(dateLeft, dateRight);
        var sign = calendarDifference < 0 ? -1 : 1;
        var weeks = Object(__WEBPACK_IMPORTED_MODULE_6__lib_toInteger_index_js__["a"
        /* default */
        ])(calendarDifference / 7);
        var result = weeks * 5;
        dateRight = Object(__WEBPACK_IMPORTED_MODULE_4__addDays_index_js__["a"
        /* default */
        ])(dateRight, weeks * 7); // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week

        while (!Object(__WEBPACK_IMPORTED_MODULE_5__isSameDay_index_js__["a"
        /* default */
        ])(dateLeft, dateRight)) {
          // sign is used to account for both negative and positive differences
          result += Object(__WEBPACK_IMPORTED_MODULE_1__isWeekend_index_js__["a"
          /* default */
          ])(dateRight) ? 0 : sign;
          dateRight = Object(__WEBPACK_IMPORTED_MODULE_4__addDays_index_js__["a"
          /* default */
          ])(dateRight, sign);
        }

        return result === 0 ? 0 : result;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(11);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000;
      /**
       * @name differenceInCalendarISOWeeks
       * @category ISO Week Helpers
       * @summary Get the number of calendar ISO weeks between the given dates.
       *
       * @description
       * Get the number of calendar ISO weeks between the given dates.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of calendar ISO weeks
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
       * const result = differenceInCalendarISOWeeks(
       *   new Date(2014, 6, 21),
       *   new Date(2014, 6, 6)
       * )
       * //=> 3
       */

      function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var startOfISOWeekLeft = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var startOfISOWeekRight = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        var timestampLeft = startOfISOWeekLeft.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(startOfISOWeekLeft);
        var timestampRight = startOfISOWeekRight.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(startOfISOWeekRight); // Round the number of days to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)

        return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getQuarter_index_js__ = __webpack_require__(84);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInCalendarQuarters
       * @category Quarter Helpers
       * @summary Get the number of calendar quarters between the given dates.
       *
       * @description
       * Get the number of calendar quarters between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of calendar quarters
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
       * var result = differenceInCalendarQuarters(
       *   new Date(2014, 6, 2),
       *   new Date(2013, 11, 31)
       * )
       * //=> 3
       */


      function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
        var quarterDiff = Object(__WEBPACK_IMPORTED_MODULE_0__getQuarter_index_js__["a"
        /* default */
        ])(dateLeft) - Object(__WEBPACK_IMPORTED_MODULE_0__getQuarter_index_js__["a"
        /* default */
        ])(dateRight);
        return yearDiff * 4 + quarterDiff;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarISOWeekYears_index_js__ = __webpack_require__(82);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(21);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__subISOWeekYears_index_js__ = __webpack_require__(88);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInISOWeekYears
       * @category ISO Week-Numbering Year Helpers
       * @summary Get the number of full ISO week-numbering years between the given dates.
       *
       * @description
       * Get the number of full ISO week-numbering years between the given dates.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `differenceInISOYears` to `differenceInISOWeekYears`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of full ISO week-numbering years
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
       * var result = differenceInISOWeekYears(
       *   new Date(2012, 0, 1),
       *   new Date(2010, 0, 1)
       * )
       * //=> 1
       */


      function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        var sign = Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a"
        /* default */
        ])(dateLeft, dateRight);
        var difference = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarISOWeekYears_index_js__["a"
        /* default */
        ])(dateLeft, dateRight));
        dateLeft = Object(__WEBPACK_IMPORTED_MODULE_3__subISOWeekYears_index_js__["a"
        /* default */
        ])(dateLeft, sign * difference); // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
        // if last calendar ISO year is not full
        // If so, result must be decreased by 1 in absolute value

        var isLastISOWeekYearNotFull = Number(Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a"
        /* default */
        ])(dateLeft, dateRight) === -sign);
        var result = sign * (difference - isLastISOWeekYearNotFull); // Prevent negative zero

        return result === 0 ? 0 : result;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInMonths_index_js__ = __webpack_require__(38);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_roundingMethods_index_js__ = __webpack_require__(31);
      /**
       * @name differenceInQuarters
       * @category Quarter Helpers
       * @summary Get the number of quarters between the given dates.
       *
       * @description
       * Get the number of quarters between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @param {Object} [options] - an object with options.
       * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
       * @returns {Number} the number of full quarters
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many full quarters are between 31 December 2013 and 2 July 2014?
       * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
       * //=> 2
       */


      function differenceInQuarters(dateLeft, dateRight, options) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_0__differenceInMonths_index_js__["a"
        /* default */
        ])(dateLeft, dateRight) / 3;
        return Object(__WEBPACK_IMPORTED_MODULE_2__lib_roundingMethods_index_js__["a"
        /* getRoundingMethod */
        ])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInDays_index_js__ = __webpack_require__(50);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_roundingMethods_index_js__ = __webpack_require__(31);
      /**
       * @name differenceInWeeks
       * @category Week Helpers
       * @summary Get the number of full weeks between the given dates.
       *
       * @description
       * Get the number of full weeks between two dates. Fractional weeks are
       * truncated towards zero by default.
       *
       * One "full week" is the distance between a local time in one day to the same
       * local time 7 days earlier or later. A full week can sometimes be less than
       * or more than 7*24 hours if a daylight savings change happens between two dates.
       *
       * To ignore DST and only measure exact 7*24-hour periods, use this instead:
       * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
       *
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @param {Object} [options] - an object with options.
       * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
       * @returns {Number} the number of full weeks
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many full weeks are between 5 July 2014 and 20 July 2014?
       * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
       * //=> 2
       *
       * // How many full weeks are between
       * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
       * // Note: because local time is used, the
       * // result will always be 8 weeks (54 days),
       * // even if DST starts and the period has
       * // only 54*24-1 hours.
       * const result = differenceInWeeks(
       *   new Date(2020, 5, 1),
       *   new Date(2020, 2, 6)
       * )
       * //=> 8
       */


      function differenceInWeeks(dateLeft, dateRight, options) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_0__differenceInDays_index_js__["a"
        /* default */
        ])(dateLeft, dateRight) / 7;
        return Object(__WEBPACK_IMPORTED_MODULE_2__lib_roundingMethods_index_js__["a"
        /* getRoundingMethod */
        ])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addHours_index_js__ = __webpack_require__(47);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachHourOfInterval
       * @category Interval Helpers
       * @summary Return the array of hours within the specified time interval.
       *
       * @description
       * Return the array of hours within the specified time interval.
       *
       * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
       * @param {Object} [options] - an object with options.
       * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
       * @returns {Date[]} the array with starts of hours from the hour of the interval start to the hour of the interval end
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.step` must be a number greater than 1
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
       * var result = eachHourOfInterval({
       *   start: new Date(2014, 9, 6, 12),
       *   end: new Date(2014, 9, 6, 15)
       * })
       * //=> [
       * //   Mon Oct 06 2014 12:00:00,
       * //   Mon Oct 06 2014 13:00:00,
       * //   Mon Oct 06 2014 14:00:00,
       * //   Mon Oct 06 2014 15:00:00
       * // ]
       */


      function eachHourOfInterval(dirtyInterval, options) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var interval = dirtyInterval || {};
        var startDate = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(interval.start);
        var endDate = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(interval.end);
        var startTime = startDate.getTime();
        var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(startTime <= endTime)) {
          throw new RangeError("Invalid interval");
        }

        var dates = [];
        var currentDate = startDate;
        currentDate.setMinutes(0, 0, 0);
        var step = options && "step" in options ? Number(options.step) : 1;
        if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number greater than 1");

        while (currentDate.getTime() <= endTime) {
          dates.push(Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
          /* default */
          ])(currentDate));
          currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__addHours_index_js__["a"
          /* default */
          ])(currentDate, step);
        }

        return dates;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addMinutes_index_js__ = __webpack_require__(48);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfMinute_index_js__ = __webpack_require__(54);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachMinuteOfInterval
       * @category Interval Helpers
       * @summary Return the array of minutes within the specified time interval.
       *
       * @description
       * Returns the array of minutes within the specified time interval.
       *
       * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
       * @param {Object} [options] - an object with options.
       * @param {Number} [options.step=1] - the step to increment by. The starts of minutes from the hour of the interval start to the hour of the interval end
       * @throws {TypeError} 1 argument requie value should be more than 1.
       * @returns {Date[]} the array withred
       * @throws {RangeError} `options.step` must be a number equal or greater than 1
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
       * const result = eachMinuteOfInterval({
       *   start: new Date(2014, 9, 14, 13),
       *   end: new Date(2014, 9, 14, 13, 3)
       * })
       * //=> [
       * //   Wed Oct 14 2014 13:00:00,
       * //   Wed Oct 14 2014 13:01:00,
       * //   Wed Oct 14 2014 13:02:00,
       * //   Wed Oct 14 2014 13:03:00
       * // ]
       */


      function eachMinuteOfInterval(interval, options) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var startDate = Object(__WEBPACK_IMPORTED_MODULE_2__startOfMinute_index_js__["a"
        /* default */
        ])(Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(interval.start));
        var endDate = Object(__WEBPACK_IMPORTED_MODULE_2__startOfMinute_index_js__["a"
        /* default */
        ])(Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(interval.end));
        var startTime = startDate.getTime();
        var endTime = endDate.getTime();

        if (startTime >= endTime) {
          throw new RangeError("Invalid interval");
        }

        var dates = [];
        var currentDate = startDate;
        var step = options && "step" in options ? Number(options.step) : 1;
        if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number equal or greater than 1");

        while (currentDate.getTime() <= endTime) {
          dates.push(Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
          /* default */
          ])(currentDate));
          currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__addMinutes_index_js__["a"
          /* default */
          ])(currentDate, step);
        }

        return dates;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachMonthOfInterval
       * @category Interval Helpers
       * @summary Return the array of months within the specified time interval.
       *
       * @description
       * Return the array of months within the specified time interval.
       *
       * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
       * @returns {Date[]} the array with starts of months from the month of the interval start to the month of the interval end
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Each month between 6 February 2014 and 10 August 2014:
       * var result = eachMonthOfInterval({
       *   start: new Date(2014, 1, 6),
       *   end: new Date(2014, 7, 10)
       * })
       * //=> [
       * //   Sat Feb 01 2014 00:00:00,
       * //   Sat Mar 01 2014 00:00:00,
       * //   Tue Apr 01 2014 00:00:00,
       * //   Thu May 01 2014 00:00:00,
       * //   Sun Jun 01 2014 00:00:00,
       * //   Tue Jul 01 2014 00:00:00,
       * //   Fri Aug 01 2014 00:00:00
       * // ]
       */


      function eachMonthOfInterval(dirtyInterval) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var interval = dirtyInterval || {};
        var startDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(interval.start);
        var endDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(interval.end);
        var endTime = endDate.getTime();
        var dates = []; // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(startDate.getTime() <= endTime)) {
          throw new RangeError("Invalid interval");
        }

        var currentDate = startDate;
        currentDate.setHours(0, 0, 0, 0);
        currentDate.setDate(1);

        while (currentDate.getTime() <= endTime) {
          dates.push(Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ])(currentDate));
          currentDate.setMonth(currentDate.getMonth() + 1);
        }

        return dates;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addQuarters_index_js__ = __webpack_require__(49);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfQuarter_index_js__ = __webpack_require__(55);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachQuarterOfInterval
       * @category Interval Helpers
       * @summary Return the array of quarters within the specified time interval.
       *
       * @description
       * Return the array of quarters within the specified time interval.
       *
       * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
       * @returns {Date[]} the array with starts of quarters from the quarter of the interval start to the quarter of the interval end
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Each quarter within interval 6 February 2014 - 10 August 2014:
       * var result = eachQuarterOfInterval({
       *   start: new Date(2014, 1, 6),
       *   end: new Date(2014, 7, 10)
       * })
       * //=> [
       * //   Wed Jan 01 2014 00:00:00,
       * //   Tue Apr 01 2014 00:00:00,
       * //   Tue Jul 01 2014 00:00:00,
       * // ]
       */


      function eachQuarterOfInterval(dirtyInterval) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var interval = dirtyInterval || {};
        var startDate = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(interval.start);
        var endDate = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(interval.end);
        var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(startDate.getTime() <= endTime)) {
          throw new RangeError("Invalid interval");
        }

        var startDateQuarter = Object(__WEBPACK_IMPORTED_MODULE_1__startOfQuarter_index_js__["a"
        /* default */
        ])(startDate);
        var endDateQuarter = Object(__WEBPACK_IMPORTED_MODULE_1__startOfQuarter_index_js__["a"
        /* default */
        ])(endDate);
        endTime = endDateQuarter.getTime();
        var quarters = [];
        var currentQuarter = startDateQuarter;

        while (currentQuarter.getTime() <= endTime) {
          quarters.push(Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
          /* default */
          ])(currentQuarter));
          currentQuarter = Object(__WEBPACK_IMPORTED_MODULE_0__addQuarters_index_js__["a"
          /* default */
          ])(currentQuarter, 1);
        }

        return quarters;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addWeeks_index_js__ = __webpack_require__(36);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__ = __webpack_require__(12);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachWeekOfInterval
       * @category Interval Helpers
       * @summary Return the array of weeks within the specified time interval.
       *
       * @description
       * Return the array of weeks within the specified time interval.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Date[]} the array with starts of weeks from the week of the interval start to the week of the interval end
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be 0, 1, ..., 6
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Each week within interval 6 October 2014 - 23 November 2014:
       * var result = eachWeekOfInterval({
       *   start: new Date(2014, 9, 6),
       *   end: new Date(2014, 10, 23)
       * })
       * //=> [
       * //   Sun Oct 05 2014 00:00:00,
       * //   Sun Oct 12 2014 00:00:00,
       * //   Sun Oct 19 2014 00:00:00,
       * //   Sun Oct 26 2014 00:00:00,
       * //   Sun Nov 02 2014 00:00:00,
       * //   Sun Nov 09 2014 00:00:00,
       * //   Sun Nov 16 2014 00:00:00,
       * //   Sun Nov 23 2014 00:00:00
       * // ]
       */


      function eachWeekOfInterval(dirtyInterval, options) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var interval = dirtyInterval || {};
        var startDate = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(interval.start);
        var endDate = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(interval.end);
        var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(startDate.getTime() <= endTime)) {
          throw new RangeError("Invalid interval");
        }

        var startDateWeek = Object(__WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__["a"
        /* default */
        ])(startDate, options);
        var endDateWeek = Object(__WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__["a"
        /* default */
        ])(endDate, options); // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet

        startDateWeek.setHours(15);
        endDateWeek.setHours(15);
        endTime = endDateWeek.getTime();
        var weeks = [];
        var currentWeek = startDateWeek;

        while (currentWeek.getTime() <= endTime) {
          currentWeek.setHours(0);
          weeks.push(Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
          /* default */
          ])(currentWeek));
          currentWeek = Object(__WEBPACK_IMPORTED_MODULE_0__addWeeks_index_js__["a"
          /* default */
          ])(currentWeek, 1);
          currentWeek.setHours(15);
        }

        return weeks;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__eachWeekendOfInterval_index_js__ = __webpack_require__(56);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfMonth_index_js__ = __webpack_require__(39);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__ = __webpack_require__(52);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachWeekendOfMonth
       * @category Month Helpers
       * @summary List all the Saturdays and Sundays in the given month.
       *
       * @description
       * Get all the Saturdays and Sundays in the given month.
       *
       * @param {Date|Number} date - the given month
       * @returns {Date[]} an array containing all the Saturdays and Sundays
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} The passed date is invalid
       *
       * @example
       * // Lists all Saturdays and Sundays in the given month
       * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
       * //=> [
       * //   Sat Feb 05 2022 00:00:00,
       * //   Sun Feb 06 2022 00:00:00,
       * //   Sat Feb 12 2022 00:00:00,
       * //   Sun Feb 13 2022 00:00:00,
       * //   Sat Feb 19 2022 00:00:00,
       * //   Sun Feb 20 2022 00:00:00,
       * //   Sat Feb 26 2022 00:00:00,
       * //   Sun Feb 27 2022 00:00:00
       * // ]
       */


      function eachWeekendOfMonth(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var startDate = Object(__WEBPACK_IMPORTED_MODULE_1__startOfMonth_index_js__["a"
        /* default */
        ])(dirtyDate);
        if (isNaN(startDate.getTime())) throw new RangeError("The passed date is invalid");
        var endDate = Object(__WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__["a"
        /* default */
        ])(dirtyDate);
        return Object(__WEBPACK_IMPORTED_MODULE_0__eachWeekendOfInterval_index_js__["a"
        /* default */
        ])({
          start: startDate,
          end: endDate
        });
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__eachWeekendOfInterval_index_js__ = __webpack_require__(56);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfYear_index_js__ = __webpack_require__(57);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__endOfYear_index_js__ = __webpack_require__(93);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachWeekendOfYear
       * @category Year Helpers
       * @summary List all the Saturdays and Sundays in the year.
       *
       * @description
       * Get all the Saturdays and Sundays in the year.
       *
       * @param {Date|Number} date - the given year
       * @returns {Date[]} an array containing all the Saturdays and Sundays
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} The passed date is invalid
       *
       * @example
       * // Lists all Saturdays and Sundays in the year
       * var result = eachWeekendOfYear(new Date(2020, 1, 1))
       * //=> [
       * //   Sat Jan 03 2020 00:00:00,
       * //   Sun Jan 04 2020 00:00:00,
       * //   ...
       * //   Sun Dec 27 2020 00:00:00
       * // ]
       * ]
       */


      function eachWeekendOfYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var startDate = Object(__WEBPACK_IMPORTED_MODULE_1__startOfYear_index_js__["a"
        /* default */
        ])(dirtyDate);
        if (isNaN(startDate)) throw new RangeError("The passed date is invalid");
        var endDate = Object(__WEBPACK_IMPORTED_MODULE_2__endOfYear_index_js__["a"
        /* default */
        ])(dirtyDate);
        return Object(__WEBPACK_IMPORTED_MODULE_0__eachWeekendOfInterval_index_js__["a"
        /* default */
        ])({
          start: startDate,
          end: endDate
        });
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachYearOfInterval
       * @category Interval Helpers
       * @summary Return the array of yearly timestamps within the specified time interval.
       *
       * @description
       * Return the array of yearly timestamps within the specified time interval.
       *
       * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
       * @returns {Date[]} the array with starts of yearly timestamps from the month of the interval start to the month of the interval end
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Each year between 6 February 2014 and 10 August 2017:
       * const result = eachYearOfInterval({
       *   start: new Date(2014, 1, 6),
       *   end: new Date(2017, 7, 10)
       * })
       * //=> [
       * //   Wed Jan 01 2014 00:00:00,
       * //   Thu Jan 01 2015 00:00:00,
       * //   Fri Jan 01 2016 00:00:00,
       * //   Sun Jan 01 2017 00:00:00
       * // ]
       */


      function eachYearOfInterval(dirtyInterval) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var interval = dirtyInterval || {};
        var startDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(interval.start);
        var endDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(interval.end);
        var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(startDate.getTime() <= endTime)) {
          throw new RangeError("Invalid interval");
        }

        var dates = [];
        var currentDate = startDate;
        currentDate.setHours(0, 0, 0, 0);
        currentDate.setMonth(0, 1);

        while (currentDate.getTime() <= endTime) {
          dates.push(Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ])(currentDate));
          currentDate.setFullYear(currentDate.getFullYear() + 1);
        }

        return dates;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfDecade
       * @category Decade Helpers
       * @summary Return the end of a decade for the given date.
       *
       * @description
       * Return the end of a decade for the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a decade
       * @param {Object} [options] - an object with options.
       * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
       *
       * @example
       * // The end of a decade for 12 May 1984 00:00:00:
       * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
       * //=> Dec 31 1989 23:59:59.999
       */


      function endOfDecade(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var year = date.getFullYear();
        var decade = 9 + Math.floor(year / 10) * 10;
        date.setFullYear(decade, 11, 31);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfHour
       * @category Hour Helpers
       * @summary Return the end of an hour for the given date.
       *
       * @description
       * Return the end of an hour for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of an hour
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of an hour for 2 September 2014 11:55:00:
       * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
       * //=> Tue Sep 02 2014 11:59:59.999
       */


      function endOfHour(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        date.setMinutes(59, 59, 999);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__endOfWeek_index_js__ = __webpack_require__(94);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfISOWeek
       * @category ISO Week Helpers
       * @summary Return the end of an ISO week for the given date.
       *
       * @description
       * Return the end of an ISO week for the given date.
       * The result will be in the local timezone.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of an ISO week
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of an ISO week for 2 September 2014 11:55:00:
       * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Sun Sep 07 2014 23:59:59.999
       */


      function endOfISOWeek(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__endOfWeek_index_js__["a"
        /* default */
        ])(dirtyDate, {
          weekStartsOn: 1
        });
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__ = __webpack_require__(23);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfISOWeekYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Return the end of an ISO week-numbering year for the given date.
       *
       * @description
       * Return the end of an ISO week-numbering year,
       * which always starts 3 days before the year's first Thursday.
       * The result will be in the local timezone.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `endOfISOYear` to `endOfISOWeekYear`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of an ISO week-numbering year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of an ISO week-numbering year for 2 July 2005:
       * const result = endOfISOWeekYear(new Date(2005, 6, 2))
       * //=> Sun Jan 01 2006 23:59:59.999
       */


      function endOfISOWeekYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var year = Object(__WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a"
        /* default */
        ])(dirtyDate);
        var fourthOfJanuaryOfNextYear = new Date(0);
        fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
        fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ])(fourthOfJanuaryOfNextYear);
        date.setMilliseconds(date.getMilliseconds() - 1);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfMinute
       * @category Minute Helpers
       * @summary Return the end of a minute for the given date.
       *
       * @description
       * Return the end of a minute for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a minute
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of a minute for 1 December 2014 22:15:45.400:
       * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
       * //=> Mon Dec 01 2014 22:15:59.999
       */


      function endOfMinute(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        date.setSeconds(59, 999);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfQuarter
       * @category Quarter Helpers
       * @summary Return the end of a year quarter for the given date.
       *
       * @description
       * Return the end of a year quarter for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a quarter
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of a quarter for 2 September 2014 11:55:00:
       * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Sep 30 2014 23:59:59.999
       */


      function endOfQuarter(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var currentMonth = date.getMonth();
        var month = currentMonth - currentMonth % 3 + 3;
        date.setMonth(month, 0);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfSecond
       * @category Second Helpers
       * @summary Return the end of a second for the given date.
       *
       * @description
       * Return the end of a second for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a second
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of a second for 1 December 2014 22:15:45.400:
       * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
       * //=> Mon Dec 01 2014 22:15:45.999
       */


      function endOfSecond(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        date.setMilliseconds(999);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfToday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__endOfDay_index_js__ = __webpack_require__(51);
      /**
       * @name endOfToday
       * @category Day Helpers
       * @summary Return the end of today.
       * @pure false
       *
       * @description
       * Return the end of today.
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @returns {Date} the end of today
       *
       * @example
       * // If today is 6 October 2014:
       * var result = endOfToday()
       * //=> Mon Oct 6 2014 23:59:59.999
       */


      function endOfToday() {
        return Object(__WEBPACK_IMPORTED_MODULE_0__endOfDay_index_js__["a"
        /* default */
        ])(Date.now());
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /**
       * @name endOfTomorrow
       * @category Day Helpers
       * @summary Return the end of tomorrow.
       * @pure false
       *
       * @description
       * Return the end of tomorrow.
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `new Date()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @returns {Date} the end of tomorrow
       *
       * @example
       * // If today is 6 October 2014:
       * const result = endOfTomorrow()
       * //=> Tue Oct 7 2014 23:59:59.999
       */

      function endOfTomorrow() {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth();
        var day = now.getDate();
        var date = new Date(0);
        date.setFullYear(year, month, day + 1);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /**
       * @name endOfYesterday
       * @category Day Helpers
       * @summary Return the end of yesterday.
       * @pure false
       *
       * @description
       * Return the end of yesterday.
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `new Date()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @returns {Date} the end of yesterday
       *
       * @example
       * // If today is 6 October 2014:
       * const result = endOfYesterday()
       * //=> Sun Oct 5 2014 23:59:59.999
       */

      function endOfYesterday() {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth();
        var day = now.getDate();
        var date = new Date(0);
        date.setFullYear(year, month, day - 1);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "less than a second",
          other: "less than {{count}} seconds"
        },
        xSeconds: {
          one: "1 second",
          other: "{{count}} seconds"
        },
        halfAMinute: "half a minute",
        lessThanXMinutes: {
          one: "less than a minute",
          other: "less than {{count}} minutes"
        },
        xMinutes: {
          one: "1 minute",
          other: "{{count}} minutes"
        },
        aboutXHours: {
          one: "about 1 hour",
          other: "about {{count}} hours"
        },
        xHours: {
          one: "1 hour",
          other: "{{count}} hours"
        },
        xDays: {
          one: "1 day",
          other: "{{count}} days"
        },
        aboutXWeeks: {
          one: "about 1 week",
          other: "about {{count}} weeks"
        },
        xWeeks: {
          one: "1 week",
          other: "{{count}} weeks"
        },
        aboutXMonths: {
          one: "about 1 month",
          other: "about {{count}} months"
        },
        xMonths: {
          one: "1 month",
          other: "{{count}} months"
        },
        aboutXYears: {
          one: "about 1 year",
          other: "about {{count}} years"
        },
        xYears: {
          one: "1 year",
          other: "{{count}} years"
        },
        overXYears: {
          one: "over 1 year",
          other: "over {{count}} years"
        },
        almostXYears: {
          one: "almost 1 year",
          other: "almost {{count}} years"
        }
      };

      var formatDistance = function (token, count, options) {
        var result;
        var tokenValue = formatDistanceLocale[token];

        if (typeof tokenValue === "string") {
          result = tokenValue;
        } else if (count === 1) {
          result = tokenValue.one;
        } else {
          result = tokenValue.other.replace("{{count}}", count.toString());
        }

        if (options !== null && options !== void 0 && options.addSuffix) {
          if (options.comparison && options.comparison > 0) {
            return "in " + result;
          } else {
            return result + " ago";
          }
        }

        return result;
      };
      /* harmony default export */


      __webpack_exports__["a"] = formatDistance;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(532);

      var dateFormats = {
        full: "EEEE, MMMM do, y",
        long: "MMMM do, y",
        medium: "MMM d, y",
        short: "MM/dd/yyyy"
      };
      var timeFormats = {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      };
      var formatLong = {
        date: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ])({
          formats: dateFormats,
          defaultWidth: "full"
        }),
        time: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ])({
          formats: timeFormats,
          defaultWidth: "full"
        }),
        dateTime: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ])({
          formats: dateTimeFormats,
          defaultWidth: "full"
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = buildFormatLongFn;

      function buildFormatLongFn(args) {
        return function () {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // TODO: Remove String()

          var width = options.width ? String(options.width) : args.defaultWidth;
          var format = args.formats[width] || args.formats[args.defaultWidth];
          return format;
        };
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      var formatRelativeLocale = {
        lastWeek: "'last' eeee 'at' p",
        yesterday: "'yesterday at' p",
        today: "'today at' p",
        tomorrow: "'tomorrow at' p",
        nextWeek: "eeee 'at' p",
        other: "P"
      };

      var formatRelative = function (token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      };
      /* harmony default export */


      __webpack_exports__["a"] = formatRelative;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(535);

      var eraValues = {
        narrow: ["B", "A"],
        abbreviated: ["BC", "AD"],
        wide: ["Before Christ", "Anno Domini"]
      };
      var quarterValues = {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
      }; // Note: in English, the names of days of the week and months are capitalized.
      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
      // Generally, formatted dates should look like they are in the middle of a sentence,
      // e.g. in Spanish language the weekdays and months should be in the lowercase.

      var monthValues = {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      };
      var dayValues = {
        narrow: ["S", "M", "T", "W", "T", "F", "S"],
        short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      };
      var dayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        }
      };

      var ordinalNumber = function (dirtyNumber, _options) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`.
        //
        // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'.

        var rem100 = number % 100;

        if (rem100 > 20 || rem100 < 10) {
          switch (rem100 % 10) {
            case 1:
              return number + "st";

            case 2:
              return number + "nd";

            case 3:
              return number + "rd";
          }
        }

        return number + "th";
      };

      var localize = {
        ordinalNumber: ordinalNumber,
        era: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ])({
          values: eraValues,
          defaultWidth: "wide"
        }),
        quarter: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ])({
          values: quarterValues,
          defaultWidth: "wide",
          argumentCallback: function (quarter) {
            return quarter - 1;
          }
        }),
        month: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ])({
          values: monthValues,
          defaultWidth: "wide"
        }),
        day: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ])({
          values: dayValues,
          defaultWidth: "wide"
        }),
        dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ])({
          values: dayPeriodValues,
          defaultWidth: "wide",
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: "wide"
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = buildLocalizeFn;

      function buildLocalizeFn(args) {
        return function (dirtyIndex, dirtyOptions) {
          var options = dirtyOptions || {};
          var context = options.context ? String(options.context) : "standalone";
          var valuesArray;

          if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
          } else {
            var _defaultWidth = args.defaultWidth;

            var _width = options.width ? String(options.width) : args.defaultWidth;

            valuesArray = args.values[_width] || args.values[_defaultWidth];
          }

          var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!

          return valuesArray[index];
        };
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(537);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(538);

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
      };
      var parseEraPatterns = {
        any: [/^b/i, /^(a|c)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      };
      var match = {
        ordinalNumber: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ])({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function (value) {
            return parseInt(value, 10);
          }
        }),
        era: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ])({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseEraPatterns,
          defaultParseWidth: "any"
        }),
        quarter: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ])({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: "any",
          valueCallback: function (index) {
            return index + 1;
          }
        }),
        month: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ])({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: "any"
        }),
        day: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ])({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: "wide",
          parsePatterns: parseDayPatterns,
          defaultParseWidth: "any"
        }),
        dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ])({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: "any",
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: "any"
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = buildMatchFn;

      function buildMatchFn(args) {
        return function (string) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var width = options.width;
          var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
          var matchResult = string.match(matchPattern);

          if (!matchResult) {
            return null;
          }

          var matchedString = matchResult[0];
          var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
          var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
            return pattern.test(matchedString);
          }) : findKey(parsePatterns, function (pattern) {
            return pattern.test(matchedString);
          });
          var value;
          value = args.valueCallback ? args.valueCallback(key) : key;
          value = options.valueCallback ? options.valueCallback(value) : value;
          var rest = string.slice(matchedString.length);
          return {
            value: value,
            rest: rest
          };
        };
      }

      function findKey(object, predicate) {
        for (var key in object) {
          if (object.hasOwnProperty(key) && predicate(object[key])) {
            return key;
          }
        }

        return undefined;
      }

      function findIndex(array, predicate) {
        for (var key = 0; key < array.length; key++) {
          if (predicate(array[key])) {
            return key;
          }
        }

        return undefined;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = buildMatchPatternFn;

      function buildMatchPatternFn(args) {
        return function (string) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var matchResult = string.match(args.matchPattern);
          if (!matchResult) return null;
          var matchedString = matchResult[0];
          var parseResult = string.match(args.parsePattern);
          if (!parseResult) return null;
          var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
          value = options.valueCallback ? options.valueCallback(value) : value;
          var rest = string.slice(matchedString.length);
          return {
            value: value,
            rest: rest
          };
        };
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__ = __webpack_require__(96);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_getUTCDayOfYear_index_js__ = __webpack_require__(540);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeek_index_js__ = __webpack_require__(97);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_getUTCISOWeekYear_index_js__ = __webpack_require__(98);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeek_index_js__ = __webpack_require__(99);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_getUTCWeekYear_index_js__ = __webpack_require__(58);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__ = __webpack_require__(25);

      var dayPeriodEnum = {
        am: "am",
        pm: "pm",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      };
      /*
       * |     | Unit                           |     | Unit                           |
       * |-----|--------------------------------|-----|--------------------------------|
       * |  a  | AM, PM                         |  A* | Milliseconds in day            |
       * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
       * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
       * |  d  | Day of month                   |  D  | Day of year                    |
       * |  e  | Local day of week              |  E  | Day of week                    |
       * |  f  |                                |  F* | Day of week in month           |
       * |  g* | Modified Julian day            |  G  | Era                            |
       * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
       * |  i! | ISO day of week                |  I! | ISO week of year               |
       * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
       * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
       * |  l* | (deprecated)                   |  L  | Stand-alone month              |
       * |  m  | Minute                         |  M  | Month                          |
       * |  n  |                                |  N  |                                |
       * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
       * |  p! | Long localized time            |  P! | Long localized date            |
       * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
       * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
       * |  s  | Second                         |  S  | Fraction of second             |
       * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
       * |  u  | Extended year                  |  U* | Cyclic year                    |
       * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
       * |  w  | Local week of year             |  W* | Week of month                  |
       * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
       * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
       * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
       *
       * Letters marked by * are not implemented but reserved by Unicode standard.
       *
       * Letters marked by ! are non-standard, but implemented by date-fns:
       * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
       * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
       *   i.e. 7 for Sunday, 1 for Monday, etc.
       * - `I` is ISO week of year, as opposed to `w` which is local week of year.
       * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
       *   `R` is supposed to be used in conjunction with `I` and `i`
       *   for universal ISO week-numbering date, whereas
       *   `Y` is supposed to be used in conjunction with `w` and `e`
       *   for week-numbering date specific to the locale.
       * - `P` is long localized date format
       * - `p` is long localized time format
       */

      var formatters = {
        // Era
        G: function (date, token, localize) {
          var era = date.getUTCFullYear() > 0 ? 1 : 0;

          switch (token) {
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
              return localize.era(era, {
                width: "abbreviated"
              });
            // A, B

            case "GGGGG":
              return localize.era(era, {
                width: "narrow"
              });
            // Anno Domini, Before Christ

            case "GGGG":
            default:
              return localize.era(era, {
                width: "wide"
              });
          }
        },
        // Year
        y: function (date, token, localize) {
          // Ordinal number
          if (token === "yo") {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
              unit: "year"
            });
          }

          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].y(date, token);
        },
        // Local week-numbering year
        Y: function (date, token, localize, options) {
          var signedWeekYear = Object(__WEBPACK_IMPORTED_MODULE_5__lib_getUTCWeekYear_index_js__["a"
          /* default */
          ])(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

          var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

          if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
            /* default */
            ])(twoDigitYear, 2);
          } // Ordinal number


          if (token === "Yo") {
            return localize.ordinalNumber(weekYear, {
              unit: "year"
            });
          } // Padding


          return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ])(weekYear, token.length);
        },
        // ISO week-numbering year
        R: function (date, token) {
          var isoWeekYear = Object(__WEBPACK_IMPORTED_MODULE_3__lib_getUTCISOWeekYear_index_js__["a"
          /* default */
          ])(date); // Padding

          return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ])(isoWeekYear, token.length);
        },
        // Extended year. This is a single number designating the year of this calendar system.
        // The main difference between `y` and `u` localizers are B.C. years:
        // | Year | `y` | `u` |
        // |------|-----|-----|
        // | AC 1 |   1 |   1 |
        // | BC 1 |   1 |   0 |
        // | BC 2 |   2 |  -1 |
        // Also `yy` always returns the last two digits of a year,
        // while `uu` pads single digit years to 2 characters and returns other years unchanged.
        u: function (date, token) {
          var year = date.getUTCFullYear();
          return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ])(year, token.length);
        },
        // Quarter
        Q: function (date, token, localize) {
          var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

          switch (token) {
            // 1, 2, 3, 4
            case "Q":
              return String(quarter);
            // 01, 02, 03, 04

            case "QQ":
              return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
              /* default */
              ])(quarter, 2);
            // 1st, 2nd, 3rd, 4th

            case "Qo":
              return localize.ordinalNumber(quarter, {
                unit: "quarter"
              });
            // Q1, Q2, Q3, Q4

            case "QQQ":
              return localize.quarter(quarter, {
                width: "abbreviated",
                context: "formatting"
              });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)

            case "QQQQQ":
              return localize.quarter(quarter, {
                width: "narrow",
                context: "formatting"
              });
            // 1st quarter, 2nd quarter, ...

            case "QQQQ":
            default:
              return localize.quarter(quarter, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        // Stand-alone quarter
        q: function (date, token, localize) {
          var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

          switch (token) {
            // 1, 2, 3, 4
            case "q":
              return String(quarter);
            // 01, 02, 03, 04

            case "qq":
              return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
              /* default */
              ])(quarter, 2);
            // 1st, 2nd, 3rd, 4th

            case "qo":
              return localize.ordinalNumber(quarter, {
                unit: "quarter"
              });
            // Q1, Q2, Q3, Q4

            case "qqq":
              return localize.quarter(quarter, {
                width: "abbreviated",
                context: "standalone"
              });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)

            case "qqqqq":
              return localize.quarter(quarter, {
                width: "narrow",
                context: "standalone"
              });
            // 1st quarter, 2nd quarter, ...

            case "qqqq":
            default:
              return localize.quarter(quarter, {
                width: "wide",
                context: "standalone"
              });
          }
        },
        // Month
        M: function (date, token, localize) {
          var month = date.getUTCMonth();

          switch (token) {
            case "M":
            case "MM":
              return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
              /* default */
              ].M(date, token);
            // 1st, 2nd, ..., 12th

            case "Mo":
              return localize.ordinalNumber(month + 1, {
                unit: "month"
              });
            // Jan, Feb, ..., Dec

            case "MMM":
              return localize.month(month, {
                width: "abbreviated",
                context: "formatting"
              });
            // J, F, ..., D

            case "MMMMM":
              return localize.month(month, {
                width: "narrow",
                context: "formatting"
              });
            // January, February, ..., December

            case "MMMM":
            default:
              return localize.month(month, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        // Stand-alone month
        L: function (date, token, localize) {
          var month = date.getUTCMonth();

          switch (token) {
            // 1, 2, ..., 12
            case "L":
              return String(month + 1);
            // 01, 02, ..., 12

            case "LL":
              return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
              /* default */
              ])(month + 1, 2);
            // 1st, 2nd, ..., 12th

            case "Lo":
              return localize.ordinalNumber(month + 1, {
                unit: "month"
              });
            // Jan, Feb, ..., Dec

            case "LLL":
              return localize.month(month, {
                width: "abbreviated",
                context: "standalone"
              });
            // J, F, ..., D

            case "LLLLL":
              return localize.month(month, {
                width: "narrow",
                context: "standalone"
              });
            // January, February, ..., December

            case "LLLL":
            default:
              return localize.month(month, {
                width: "wide",
                context: "standalone"
              });
          }
        },
        // Local week of year
        w: function (date, token, localize, options) {
          var week = Object(__WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeek_index_js__["a"
          /* default */
          ])(date, options);

          if (token === "wo") {
            return localize.ordinalNumber(week, {
              unit: "week"
            });
          }

          return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ])(week, token.length);
        },
        // ISO week of year
        I: function (date, token, localize) {
          var isoWeek = Object(__WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeek_index_js__["a"
          /* default */
          ])(date);

          if (token === "Io") {
            return localize.ordinalNumber(isoWeek, {
              unit: "week"
            });
          }

          return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ])(isoWeek, token.length);
        },
        // Day of the month
        d: function (date, token, localize) {
          if (token === "do") {
            return localize.ordinalNumber(date.getUTCDate(), {
              unit: "date"
            });
          }

          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].d(date, token);
        },
        // Day of year
        D: function (date, token, localize) {
          var dayOfYear = Object(__WEBPACK_IMPORTED_MODULE_1__lib_getUTCDayOfYear_index_js__["a"
          /* default */
          ])(date);

          if (token === "Do") {
            return localize.ordinalNumber(dayOfYear, {
              unit: "dayOfYear"
            });
          }

          return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ])(dayOfYear, token.length);
        },
        // Day of week
        E: function (date, token, localize) {
          var dayOfWeek = date.getUTCDay();

          switch (token) {
            // Tue
            case "E":
            case "EE":
            case "EEE":
              return localize.day(dayOfWeek, {
                width: "abbreviated",
                context: "formatting"
              });
            // T

            case "EEEEE":
              return localize.day(dayOfWeek, {
                width: "narrow",
                context: "formatting"
              });
            // Tu

            case "EEEEEE":
              return localize.day(dayOfWeek, {
                width: "short",
                context: "formatting"
              });
            // Tuesday

            case "EEEE":
            default:
              return localize.day(dayOfWeek, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        // Local day of week
        e: function (date, token, localize, options) {
          var dayOfWeek = date.getUTCDay();
          var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

          switch (token) {
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
              return String(localDayOfWeek);
            // Padded numerical value

            case "ee":
              return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
              /* default */
              ])(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th

            case "eo":
              return localize.ordinalNumber(localDayOfWeek, {
                unit: "day"
              });

            case "eee":
              return localize.day(dayOfWeek, {
                width: "abbreviated",
                context: "formatting"
              });
            // T

            case "eeeee":
              return localize.day(dayOfWeek, {
                width: "narrow",
                context: "formatting"
              });
            // Tu

            case "eeeeee":
              return localize.day(dayOfWeek, {
                width: "short",
                context: "formatting"
              });
            // Tuesday

            case "eeee":
            default:
              return localize.day(dayOfWeek, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        // Stand-alone local day of week
        c: function (date, token, localize, options) {
          var dayOfWeek = date.getUTCDay();
          var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

          switch (token) {
            // Numerical value (same as in `e`)
            case "c":
              return String(localDayOfWeek);
            // Padded numerical value

            case "cc":
              return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
              /* default */
              ])(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th

            case "co":
              return localize.ordinalNumber(localDayOfWeek, {
                unit: "day"
              });

            case "ccc":
              return localize.day(dayOfWeek, {
                width: "abbreviated",
                context: "standalone"
              });
            // T

            case "ccccc":
              return localize.day(dayOfWeek, {
                width: "narrow",
                context: "standalone"
              });
            // Tu

            case "cccccc":
              return localize.day(dayOfWeek, {
                width: "short",
                context: "standalone"
              });
            // Tuesday

            case "cccc":
            default:
              return localize.day(dayOfWeek, {
                width: "wide",
                context: "standalone"
              });
          }
        },
        // ISO day of week
        i: function (date, token, localize) {
          var dayOfWeek = date.getUTCDay();
          var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

          switch (token) {
            // 2
            case "i":
              return String(isoDayOfWeek);
            // 02

            case "ii":
              return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
              /* default */
              ])(isoDayOfWeek, token.length);
            // 2nd

            case "io":
              return localize.ordinalNumber(isoDayOfWeek, {
                unit: "day"
              });
            // Tue

            case "iii":
              return localize.day(dayOfWeek, {
                width: "abbreviated",
                context: "formatting"
              });
            // T

            case "iiiii":
              return localize.day(dayOfWeek, {
                width: "narrow",
                context: "formatting"
              });
            // Tu

            case "iiiiii":
              return localize.day(dayOfWeek, {
                width: "short",
                context: "formatting"
              });
            // Tuesday

            case "iiii":
            default:
              return localize.day(dayOfWeek, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        // AM or PM
        a: function (date, token, localize) {
          var hours = date.getUTCHours();
          var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";

          switch (token) {
            case "a":
            case "aa":
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: "abbreviated",
                context: "formatting"
              });

            case "aaa":
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: "abbreviated",
                context: "formatting"
              }).toLowerCase();

            case "aaaaa":
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: "narrow",
                context: "formatting"
              });

            case "aaaa":
            default:
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        // AM, PM, midnight, noon
        b: function (date, token, localize) {
          var hours = date.getUTCHours();
          var dayPeriodEnumValue;

          if (hours === 12) {
            dayPeriodEnumValue = dayPeriodEnum.noon;
          } else if (hours === 0) {
            dayPeriodEnumValue = dayPeriodEnum.midnight;
          } else {
            dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
          }

          switch (token) {
            case "b":
            case "bb":
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: "abbreviated",
                context: "formatting"
              });

            case "bbb":
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: "abbreviated",
                context: "formatting"
              }).toLowerCase();

            case "bbbbb":
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: "narrow",
                context: "formatting"
              });

            case "bbbb":
            default:
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        // in the morning, in the afternoon, in the evening, at night
        B: function (date, token, localize) {
          var hours = date.getUTCHours();
          var dayPeriodEnumValue;

          if (hours >= 17) {
            dayPeriodEnumValue = dayPeriodEnum.evening;
          } else if (hours >= 12) {
            dayPeriodEnumValue = dayPeriodEnum.afternoon;
          } else if (hours >= 4) {
            dayPeriodEnumValue = dayPeriodEnum.morning;
          } else {
            dayPeriodEnumValue = dayPeriodEnum.night;
          }

          switch (token) {
            case "B":
            case "BB":
            case "BBB":
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: "abbreviated",
                context: "formatting"
              });

            case "BBBBB":
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: "narrow",
                context: "formatting"
              });

            case "BBBB":
            default:
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        // Hour [1-12]
        h: function (date, token, localize) {
          if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
              unit: "hour"
            });
          }

          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].h(date, token);
        },
        // Hour [0-23]
        H: function (date, token, localize) {
          if (token === "Ho") {
            return localize.ordinalNumber(date.getUTCHours(), {
              unit: "hour"
            });
          }

          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].H(date, token);
        },
        // Hour [0-11]
        K: function (date, token, localize) {
          var hours = date.getUTCHours() % 12;

          if (token === "Ko") {
            return localize.ordinalNumber(hours, {
              unit: "hour"
            });
          }

          return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ])(hours, token.length);
        },
        // Hour [1-24]
        k: function (date, token, localize) {
          var hours = date.getUTCHours();
          if (hours === 0) hours = 24;

          if (token === "ko") {
            return localize.ordinalNumber(hours, {
              unit: "hour"
            });
          }

          return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ])(hours, token.length);
        },
        // Minute
        m: function (date, token, localize) {
          if (token === "mo") {
            return localize.ordinalNumber(date.getUTCMinutes(), {
              unit: "minute"
            });
          }

          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].m(date, token);
        },
        // Second
        s: function (date, token, localize) {
          if (token === "so") {
            return localize.ordinalNumber(date.getUTCSeconds(), {
              unit: "second"
            });
          }

          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].s(date, token);
        },
        // Fraction of second
        S: function (date, token) {
          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].S(date, token);
        },
        // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
        X: function (date, token, _localize, options) {
          var originalDate = options._originalDate || date;
          var timezoneOffset = originalDate.getTimezoneOffset();

          if (timezoneOffset === 0) {
            return "Z";
          }

          switch (token) {
            // Hours and optional minutes
            case "X":
              return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`

            case "XXXX":
            case "XX":
              // Hours and minutes without `:` delimiter
              return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`

            case "XXXXX":
            case "XXX": // Hours and minutes with `:` delimiter

            default:
              return formatTimezone(timezoneOffset, ":");
          }
        },
        // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
        x: function (date, token, _localize, options) {
          var originalDate = options._originalDate || date;
          var timezoneOffset = originalDate.getTimezoneOffset();

          switch (token) {
            // Hours and optional minutes
            case "x":
              return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`

            case "xxxx":
            case "xx":
              // Hours and minutes without `:` delimiter
              return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`

            case "xxxxx":
            case "xxx": // Hours and minutes with `:` delimiter

            default:
              return formatTimezone(timezoneOffset, ":");
          }
        },
        // Timezone (GMT)
        O: function (date, token, _localize, options) {
          var originalDate = options._originalDate || date;
          var timezoneOffset = originalDate.getTimezoneOffset();

          switch (token) {
            // Short
            case "O":
            case "OO":
            case "OOO":
              return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long

            case "OOOO":
            default:
              return "GMT" + formatTimezone(timezoneOffset, ":");
          }
        },
        // Timezone (specific non-location)
        z: function (date, token, _localize, options) {
          var originalDate = options._originalDate || date;
          var timezoneOffset = originalDate.getTimezoneOffset();

          switch (token) {
            // Short
            case "z":
            case "zz":
            case "zzz":
              return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long

            case "zzzz":
            default:
              return "GMT" + formatTimezone(timezoneOffset, ":");
          }
        },
        // Seconds timestamp
        t: function (date, token, _localize, options) {
          var originalDate = options._originalDate || date;
          var timestamp = Math.floor(originalDate.getTime() / 1000);
          return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ])(timestamp, token.length);
        },
        // Milliseconds timestamp
        T: function (date, token, _localize, options) {
          var originalDate = options._originalDate || date;
          var timestamp = originalDate.getTime();
          return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ])(timestamp, token.length);
        }
      };

      function formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? "-" : "+";
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;

        if (minutes === 0) {
          return sign + String(hours);
        }

        var delimiter = dirtyDelimiter || "";
        return sign + String(hours) + delimiter + Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
        /* default */
        ])(minutes, 2);
      }

      function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
        if (offset % 60 === 0) {
          var sign = offset > 0 ? "-" : "+";
          return sign + Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ])(Math.abs(offset) / 60, 2);
        }

        return formatTimezone(offset, dirtyDelimiter);
      }

      function formatTimezone(offset, dirtyDelimiter) {
        var delimiter = dirtyDelimiter || "";
        var sign = offset > 0 ? "-" : "+";
        var absOffset = Math.abs(offset);
        var hours = Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
        /* default */
        ])(Math.floor(absOffset / 60), 2);
        var minutes = Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
        /* default */
        ])(absOffset % 60, 2);
        return sign + hours + delimiter + minutes;
      }
      /* harmony default export */


      __webpack_exports__["a"] = formatters;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getUTCDayOfYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376

      function getUTCDayOfYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var timestamp = date.getTime();
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
        var startOfYearTimestamp = date.getTime();
        var difference = timestamp - startOfYearTimestamp;
        return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfUTCISOWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__ = __webpack_require__(98);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(40);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function startOfUTCISOWeekYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var year = Object(__WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__["a"
        /* default */
        ])(dirtyDate);
        var fourthOfJanuary = new Date(0);
        fourthOfJanuary.setUTCFullYear(year, 0, 4);
        fourthOfJanuary.setUTCHours(0, 0, 0, 0);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a"
        /* default */
        ])(fourthOfJanuary);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfUTCWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__getUTCWeekYear_index_js__ = __webpack_require__(58);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(41);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ])(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ])(options.firstWeekContainsDate);
        var year = Object(__WEBPACK_IMPORTED_MODULE_1__getUTCWeekYear_index_js__["a"
        /* default */
        ])(dirtyDate, dirtyOptions);
        var firstWeek = new Date(0);
        firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeek.setUTCHours(0, 0, 0, 0);
        var date = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a"
        /* default */
        ])(firstWeek, dirtyOptions);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__formatDistance_index_js__ = __webpack_require__(102);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name formatDistanceToNow
       * @category Common Helpers
       * @summary Return the distance between the given date and now in words.
       * @pure false
       *
       * @description
       * Return the distance between the given date and now in words.
       *
       * | Distance to now                                                   | Result              |
       * |-------------------------------------------------------------------|---------------------|
       * | 0 ... 30 secs                                                     | less than a minute  |
       * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
       * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
       * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
       * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
       * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
       * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
       * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
       * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
       * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
       * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
       * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
       * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
       * | N yrs ... N yrs 3 months                                          | about N years       |
       * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
       * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
       *
       * With `options.includeSeconds == true`:
       * | Distance to now     | Result               |
       * |---------------------|----------------------|
       * | 0 secs ... 5 secs   | less than 5 seconds  |
       * | 5 secs ... 10 secs  | less than 10 seconds |
       * | 10 secs ... 20 secs | less than 20 seconds |
       * | 20 secs ... 40 secs | half a minute        |
       * | 40 secs ... 60 secs | less than a minute   |
       * | 60 secs ... 90 secs | 1 minute             |
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `distanceInWordsToNow ` to `formatDistanceToNow`
       *   to make its name consistent with `format` and `formatRelative`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   distanceInWordsToNow(new Date(2014, 6, 2), { addSuffix: true })
       *   //=> 'in 6 months'
       *
       *   // v2.0.0 onward
       *
       *   formatDistanceToNow(new Date(2014, 6, 2), { addSuffix: true })
       *   //=> 'in 6 months'
       *   ```
       *
       * @param {Date|Number} date - the given date
       * @param {Object} [options] - the object with options
       * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
       * @param {Boolean} [options.addSuffix=false] - result specifies if now is earlier or later than the passed date
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @returns {String} the distance in words
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `options.locale` must contain `formatDistance` property
       *
       * @example
       * // If today is 1 January 2015, what is the distance to 2 July 2014?
       * var result = formatDistanceToNow(
       *   new Date(2014, 6, 2)
       * )
       * //=> '6 months'
       *
       * @example
       * // If now is 1 January 2015 00:00:00,
       * // what is the distance to 1 January 2015 00:00:15, including seconds?
       * var result = formatDistanceToNow(
       *   new Date(2015, 0, 1, 0, 0, 15),
       *   {includeSeconds: true}
       * )
       * //=> 'less than 20 seconds'
       *
       * @example
       * // If today is 1 January 2015,
       * // what is the distance to 1 January 2016, with a suffix?
       * var result = formatDistanceToNow(
       *   new Date(2016, 0, 1),
       *   {addSuffix: true}
       * )
       * //=> 'in about 1 year'
       *
       * @example
       * // If today is 1 January 2015,
       * // what is the distance to 1 August 2016 in Esperanto?
       * var eoLocale = require('date-fns/locale/eo')
       * var result = formatDistanceToNow(
       *   new Date(2016, 7, 1),
       *   {locale: eoLocale}
       * )
       * //=> 'pli ol 1 jaro'
       */


      function formatDistanceToNow(dirtyDate, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__formatDistance_index_js__["a"
        /* default */
        ])(dirtyDate, Date.now(), dirtyOptions);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__formatDistanceStrict_index_js__ = __webpack_require__(105);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name formatDistanceToNowStrict
       * @category Common Helpers
       * @summary Return the distance between the given date and now in words.
       * @pure false
       *
       * @description
       * Return the distance between the given dates in words, using strict units.
       * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
       * 'less than' and the like.
       *
       * | Distance between dates | Result              |
       * |------------------------|---------------------|
       * | 0 ... 59 secs          | [0..59] seconds     |
       * | 1 ... 59 mins          | [1..59] minutes     |
       * | 1 ... 23 hrs           | [1..23] hours       |
       * | 1 ... 29 days          | [1..29] days        |
       * | 1 ... 11 months        | [1..11] months      |
       * | 1 ... N years          | [1..N]  years       |
       *
       * @param {Date|Number} date - the given date
       * @param {Object} [options] - an object with options.
       * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
       * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
       * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @returns {String} the distance in words
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `options.locale` must contain `formatDistance` property
       *
       * @example
       * // If today is 1 January 2015, what is the distance to 2 July 2014?
       * var result = formatDistanceToNowStrict(
       *   new Date(2014, 6, 2)
       * )
       * //=> '6 months'
       *
       * @example
       * // If now is 1 January 2015 00:00:00,
       * // what is the distance to 1 January 2015 00:00:15, including seconds?
       * var result = formatDistanceToNowStrict(
       *   new Date(2015, 0, 1, 0, 0, 15)
       * )
       * //=> '20 seconds'
       *
       * @example
       * // If today is 1 January 2015,
       * // what is the distance to 1 January 2016, with a suffix?
       * var result = formatDistanceToNowStrict(
       *   new Date(2016, 0, 1),
       *   {addSuffix: true}
       * )
       * //=> 'in 1 year'
       *
       * @example
       * // If today is 28 January 2015,
       * // what is the distance to 1 January 2015, in months, rounded up??
       * var result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
       *   unit: 'month',
       *   roundingMethod: 'ceil'
       * })
       * //=> '1 month'
       *
       * @example
       * // If today is 1 January 2015,
       * // what is the distance to 1 August 2016 in Esperanto?
       * var eoLocale = require('date-fns/locale/eo')
       * var result = formatDistanceToNowStrict(
       *   new Date(2016, 7, 1),
       *   {locale: eoLocale}
       * )
       * //=> '1 jaro'
       */


      function formatDistanceToNowStrict(dirtyDate, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__formatDistanceStrict_index_js__["a"
        /* default */
        ])(dirtyDate, Date.now(), dirtyOptions);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__ = __webpack_require__(24);

      var defaultFormat = ["years", "months", "weeks", "days", "hours", "minutes", "seconds"];
      /**
       * @name formatDuration
       * @category Common Helpers
       * @summary Formats a duration in human-readable format
       *
       * @description
       * Return human-readable duration string i.e. "9 months 2 days"
       *
       * @param {Duration} duration - the duration to format
       * @param {Object} [options] - an object with options.
      
       * @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
       * @param {boolean} [options.zero=false] - should be zeros be included in the output?
       * @param {string} [options.delimiter=' '] - delimiter string
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @returns {string} the formatted date string
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Format full duration
       * formatDuration({
       *   years: 2,
       *   months: 9,
       *   weeks: 1,
       *   days: 7,
       *   hours: 5,
       *   minutes: 9,
       *   seconds: 30
       * })
       * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds
       *
       * @example
       * // Format partial duration
       * formatDuration({ months: 9, days: 2 })
       * //=> '9 months 2 days'
       *
       * @example
       * // Customize the format
       * formatDuration(
       *   {
       *     years: 2,
       *     months: 9,
       *     weeks: 1,
       *     days: 7,
       *     hours: 5,
       *     minutes: 9,
       *     seconds: 30
       *   },
       *   { format: ['months', 'weeks'] }
       * ) === '9 months 1 week'
       *
       * @example
       * // Customize the zeros presence
       * formatDuration({ years: 0, months: 9 })
       * //=> '9 months'
       * formatDuration({ years: 0, months: 9 }, { zero: true })
       * //=> '0 years 9 months'
       *
       * @example
       * // Customize the delimiter
       * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
       * //=> '2 years, 9 months, 3 weeks'
       */

      function formatDuration(duration, options) {
        if (arguments.length < 1) {
          throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
        }

        var format = (options === null || options === void 0 ? void 0 : options.format) || defaultFormat;
        var locale = (options === null || options === void 0 ? void 0 : options.locale) || __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__["a"
        /* default */
        ];
        var zero = (options === null || options === void 0 ? void 0 : options.zero) || false;
        var delimiter = (options === null || options === void 0 ? void 0 : options.delimiter) || " ";
        var result = format.reduce(function (acc, unit) {
          var token = "x".concat(unit.replace(/(^.)/, function (m) {
            return m.toUpperCase();
          }));
          var addChunk = typeof duration[unit] === "number" && (zero || duration[unit]);
          return addChunk ? acc.concat(locale.formatDistance(token, duration[unit])) : acc;
        }, []).join(delimiter);
        return result;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(9);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__ = __webpack_require__(25);
      /**
       * @name formatISO
       * @category Common Helpers
       * @summary Format the date according to the ISO 8601 standard (http://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
       *
       * @description
       * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
       * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with time zone, or both.
       * @returns {String} the formatted date string
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `options.format` must be 'extended' or 'basic'
       * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
       *
       * @example
       * // Represent 18 September 2019 in ISO 8601 format (UTC):
       * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
       * //=> '2019-09-18T19:00:52Z'
       *
       * @example
       * // Represent 18 September 2019 in ISO 8601, short format (UTC):
       * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
       * //=> '20190918T190052'
       *
       * @example
       * // Represent 18 September 2019 in ISO 8601 format, date only:
       * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
       * //=> '2019-09-18'
       *
       * @example
       * // Represent 18 September 2019 in ISO 8601 format, time only (UTC):
       * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
       * //=> '19:00:52Z'
       */


      function formatISO(dirtyDate, dirtyOptions) {
        if (arguments.length < 1) {
          throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
        }

        var originalDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);

        if (!Object(__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a"
        /* default */
        ])(originalDate)) {
          throw new RangeError("Invalid time value");
        }

        var options = dirtyOptions || {};
        var format = options.format == null ? "extended" : String(options.format);
        var representation = options.representation == null ? "complete" : String(options.representation);

        if (format !== "extended" && format !== "basic") {
          throw new RangeError("format must be 'extended' or 'basic'");
        }

        if (representation !== "date" && representation !== "time" && representation !== "complete") {
          throw new RangeError("representation must be 'date', 'time', or 'complete'");
        }

        var result = "";
        var tzOffset = "";
        var dateDelimiter = format === "extended" ? "-" : "";
        var timeDelimiter = format === "extended" ? ":" : ""; // Representation is either 'date' or 'complete'

        if (representation !== "time") {
          var day = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(originalDate.getDate(), 2);
          var month = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(originalDate.getMonth() + 1, 2);
          var year = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.

          result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
        } // Representation is either 'time' or 'complete'


        if (representation !== "date") {
          // Add the timezone.
          var offset = originalDate.getTimezoneOffset();

          if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
            /* default */
            ])(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
            /* default */
            ])(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.

            var sign = offset < 0 ? "+" : "-";
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
          } else {
            tzOffset = "Z";
          }

          var hour = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(originalDate.getHours(), 2);
          var minute = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(originalDate.getMinutes(), 2);
          var second = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'

          var separator = result === "" ? "" : "T"; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.

          var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.

          result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
        }

        return result;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(9);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__ = __webpack_require__(25);
      /**
       * @name formatISO9075
       * @category Common Helpers
       * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
       *
       * @description
       * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
       * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time, or both.
       * @returns {String} the formatted date string
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `options.format` must be 'extended' or 'basic'
       * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
       *
       * @example
       * // Represent 18 September 2019 in ISO 9075 format:
       * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
       * //=> '2019-09-18 19:00:52'
       *
       * @example
       * // Represent 18 September 2019 in ISO 9075, short format:
       * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
       * //=> '20190918 190052'
       *
       * @example
       * // Represent 18 September 2019 in ISO 9075 format, date only:
       * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
       * //=> '2019-09-18'
       *
       * @example
       * // Represent 18 September 2019 in ISO 9075 format, time only:
       * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
       * //=> '19:00:52'
       */


      function formatISO9075(dirtyDate, dirtyOptions) {
        if (arguments.length < 1) {
          throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
        }

        var originalDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);

        if (!Object(__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a"
        /* default */
        ])(originalDate)) {
          throw new RangeError("Invalid time value");
        }

        var options = dirtyOptions || {};
        var format = options.format == null ? "extended" : String(options.format);
        var representation = options.representation == null ? "complete" : String(options.representation);

        if (format !== "extended" && format !== "basic") {
          throw new RangeError("format must be 'extended' or 'basic'");
        }

        if (representation !== "date" && representation !== "time" && representation !== "complete") {
          throw new RangeError("representation must be 'date', 'time', or 'complete'");
        }

        var result = "";
        var dateDelimiter = format === "extended" ? "-" : "";
        var timeDelimiter = format === "extended" ? ":" : ""; // Representation is either 'date' or 'complete'

        if (representation !== "time") {
          var day = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(originalDate.getDate(), 2);
          var month = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(originalDate.getMonth() + 1, 2);
          var year = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.

          result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
        } // Representation is either 'time' or 'complete'


        if (representation !== "date") {
          var hour = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(originalDate.getHours(), 2);
          var minute = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(originalDate.getMinutes(), 2);
          var second = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(originalDate.getSeconds(), 2); // If there's also date, separate it with time with a space

          var separator = result === "" ? "" : " "; // HHmmss or HH:mm:ss.

          result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
        }

        return result;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name formatISODuration
       * @category Common Helpers
       * @summary Format a duration object according as ISO 8601 duration string
       *
       * @description
       * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm)
       *
       * @param {Duration} duration - the duration to format
       *
       * @returns {String} The ISO 8601 duration string
       * @throws {TypeError} Requires 1 argument
       * @throws {Error} Argument must be an object
       *
       * @example
       * // Format the given duration as ISO 8601 string
       * const result = formatISODuration({
       *   years: 39,
       *   months: 2,
       *   days: 20,
       *   hours: 7,
       *   minutes: 5,
       *   seconds: 0
       * })
       * //=> 'P39Y2M20DT0H0M0S'
       */


      function formatISODuration(duration) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        if (typeof duration !== "object") throw new Error("Duration must be an object");
        var _duration$years = duration.years,
            years = _duration$years === void 0 ? 0 : _duration$years,
            _duration$months = duration.months,
            months = _duration$months === void 0 ? 0 : _duration$months,
            _duration$days = duration.days,
            days = _duration$days === void 0 ? 0 : _duration$days,
            _duration$hours = duration.hours,
            hours = _duration$hours === void 0 ? 0 : _duration$hours,
            _duration$minutes = duration.minutes,
            minutes = _duration$minutes === void 0 ? 0 : _duration$minutes,
            _duration$seconds = duration.seconds,
            seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
        return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(9);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__ = __webpack_require__(25);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__ = __webpack_require__(6);
      /**
       * @name formatRFC3339
       * @category Common Helpers
       * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
       *
       * @description
       * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {0|1|2|3} [options.fractionDigits=0] - number of digits after the decimal point after seconds
       * @returns {String} the formatted date string
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `options.fractionDigits` must be between 0 and 3
       *
       * @example
       * // Represent 18 September 2019 in RFC 3339 format:
       * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
       * //=> '2019-09-18T19:00:52Z'
       *
       * @example
       * // Represent 18 September 2019 in RFC 3339 format, 2 digits of second fraction:
       * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 2 })
       * //=> '2019-09-18T19:00:52.23Z'
       *
       * @example
       * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
       * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 3 })
       * //=> '2019-09-18T19:00:52.234Z'
       */


      function formatRFC3339(dirtyDate, dirtyOptions) {
        if (arguments.length < 1) {
          throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
        }

        var originalDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);

        if (!Object(__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a"
        /* default */
        ])(originalDate)) {
          throw new RangeError("Invalid time value");
        }

        var _ref = dirtyOptions || {},
            _ref$fractionDigits = _ref.fractionDigits,
            fractionDigits = _ref$fractionDigits === void 0 ? 0 : _ref$fractionDigits; // Test if fractionDigits is between 0 and 3 _and_ is not NaN


        if (!(fractionDigits >= 0 && fractionDigits <= 3)) {
          throw new RangeError("fractionDigits must be between 0 and 3 inclusively");
        }

        var day = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ])(originalDate.getDate(), 2);
        var month = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ])(originalDate.getMonth() + 1, 2);
        var year = originalDate.getFullYear();
        var hour = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ])(originalDate.getHours(), 2);
        var minute = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ])(originalDate.getMinutes(), 2);
        var second = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ])(originalDate.getSeconds(), 2);
        var fractionalSecond = "";

        if (fractionDigits > 0) {
          var milliseconds = originalDate.getMilliseconds();
          var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
          fractionalSecond = "." + Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(fractionalSeconds, fractionDigits);
        }

        var offset = "";
        var tzOffset = originalDate.getTimezoneOffset();

        if (tzOffset !== 0) {
          var absoluteOffset = Math.abs(tzOffset);
          var hourOffset = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
          /* default */
          ])(absoluteOffset / 60), 2);
          var minuteOffset = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ])(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.

          var sign = tzOffset < 0 ? "+" : "-";
          offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else {
          offset = "Z";
        }

        return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(9);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__ = __webpack_require__(25);

      var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      /**
       * @name formatRFC7231
       * @category Common Helpers
       * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
       *
       * @description
       * Return the formatted date string in RFC 7231 format.
       * The result will always be in UTC timezone.
       *
       * @param {Date|Number} date - the original date
       * @returns {String} the formatted date string
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `date` must not be Invalid Date
       *
       * @example
       * // Represent 18 September 2019 in RFC 7231 format:
       * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
       * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
       */

      function formatRFC7231(dirtyDate) {
        if (arguments.length < 1) {
          throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
        }

        var originalDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);

        if (!Object(__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a"
        /* default */
        ])(originalDate)) {
          throw new RangeError("Invalid time value");
        }

        var dayName = days[originalDate.getUTCDay()];
        var dayOfMonth = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ])(originalDate.getUTCDate(), 2);
        var monthName = months[originalDate.getUTCMonth()];
        var year = originalDate.getUTCFullYear();
        var hour = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ])(originalDate.getUTCHours(), 2);
        var minute = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ])(originalDate.getUTCMinutes(), 2);
        var second = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ])(originalDate.getUTCSeconds(), 2); // Result variables.

        return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInCalendarDays_index_js__ = __webpack_require__(20);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__format_index_js__ = __webpack_require__(95);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__locale_en_US_index_js__ = __webpack_require__(24);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__subMilliseconds_index_js__ = __webpack_require__(32);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(11);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name formatRelative
       * @category Common Helpers
       * @summary Represent the date in words relative to the given base date.
       *
       * @description
       * Represent the date in words relative to the given base date.
       *
       * | Distance to the base date | Result                    |
       * |---------------------------|---------------------------|
       * | Previous 6 days           | last Sunday at 04:30 AM   |
       * | Last day                  | yesterday at 04:30 AM     |
       * | Same day                  | today at 04:30 AM         |
       * | Next day                  | tomorrow at 04:30 AM      |
       * | Next 6 days               | Sunday at 04:30 AM        |
       * | Other                     | 12/31/2017                |
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to format
       * @param {Date|Number} baseDate - the date to compare with
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {String} the date in words
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `baseDate` must not be Invalid Date
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.locale` must contain `localize` property
       * @throws {RangeError} `options.locale` must contain `formatLong` property
       * @throws {RangeError} `options.locale` must contain `formatRelative` property
       *
       * @example
       * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
       * const result = formatRelative(addDays(new Date(), -6), new Date())
       * //=> "last Thursday at 12:45 AM"
       */


      function formatRelative(dirtyDate, dirtyBaseDate, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_6__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var baseDate = Object(__WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a"
        /* default */
        ])(dirtyBaseDate);

        var _ref = dirtyOptions || {},
            _ref$locale = _ref.locale,
            locale = _ref$locale === void 0 ? __WEBPACK_IMPORTED_MODULE_2__locale_en_US_index_js__["a"
        /* default */
        ] : _ref$locale,
            _ref$weekStartsOn = _ref.weekStartsOn,
            weekStartsOn = _ref$weekStartsOn === void 0 ? 0 : _ref$weekStartsOn;

        if (!locale.localize) {
          throw new RangeError("locale must contain localize property");
        }

        if (!locale.formatLong) {
          throw new RangeError("locale must contain formatLong property");
        }

        if (!locale.formatRelative) {
          throw new RangeError("locale must contain formatRelative property");
        }

        var diff = Object(__WEBPACK_IMPORTED_MODULE_0__differenceInCalendarDays_index_js__["a"
        /* default */
        ])(date, baseDate);

        if (isNaN(diff)) {
          throw new RangeError("Invalid time value");
        }

        var token;

        if (diff < -6) {
          token = "other";
        } else if (diff < -1) {
          token = "lastWeek";
        } else if (diff < 0) {
          token = "yesterday";
        } else if (diff < 1) {
          token = "today";
        } else if (diff < 2) {
          token = "tomorrow";
        } else if (diff < 7) {
          token = "nextWeek";
        } else {
          token = "other";
        }

        var utcDate = Object(__WEBPACK_IMPORTED_MODULE_3__subMilliseconds_index_js__["a"
        /* default */
        ])(date, Object(__WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(date));
        var utcBaseDate = Object(__WEBPACK_IMPORTED_MODULE_3__subMilliseconds_index_js__["a"
        /* default */
        ])(baseDate, Object(__WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(baseDate));
        var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
          locale: locale,
          weekStartsOn: weekStartsOn
        });
        return Object(__WEBPACK_IMPORTED_MODULE_1__format_index_js__["a"
        /* default */
        ])(date, formatStr, {
          locale: locale,
          weekStartsOn: weekStartsOn
        });
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name fromUnixTime
       * @category Timestamp Helpers
       * @summary Create a date from a Unix timestamp.
       *
       * @description
       * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Number} unixTime - the given Unix timestamp (in seconds)
       * @returns {Date} the date
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Create the date 29 February 2012 11:45:05:
       * const result = fromUnixTime(1330515905)
       * //=> Wed Feb 29 2012 11:45:05
       */


      function fromUnixTime(dirtyUnixTime) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var unixTime = Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyUnixTime);
        return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(unixTime * 1000);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfYear_index_js__ = __webpack_require__(57);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__differenceInCalendarDays_index_js__ = __webpack_require__(20);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getDayOfYear
       * @category Day Helpers
       * @summary Get the day of the year of the given date.
       *
       * @description
       * Get the day of the year of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the day of year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which day of the year is 2 July 2014?
       * const result = getDayOfYear(new Date(2014, 6, 2))
       * //=> 183
       */


      function getDayOfYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_2__differenceInCalendarDays_index_js__["a"
        /* default */
        ])(date, Object(__WEBPACK_IMPORTED_MODULE_1__startOfYear_index_js__["a"
        /* default */
        ])(date));
        var dayOfYear = diff + 1;
        return dayOfYear;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isLeapYear_index_js__ = __webpack_require__(108);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getDaysInYear
       * @category Year Helpers
       * @summary Get the number of days in a year of the given date.
       *
       * @description
       * Get the number of days in a year of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the number of days in a year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // How many days are in 2012?
       * const result = getDaysInYear(new Date(2012, 0, 1))
       * //=> 366
       */


      function getDaysInYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);

        if (String(new Date(date)) === "Invalid Date") {
          return NaN;
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1__isLeapYear_index_js__["a"
        /* default */
        ])(date) ? 366 : 365;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getDecade
       * @category Decade Helpers
       * @summary Get the decade of the given date.
       *
       * @description
       * Get the decade of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the year of decade
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which decade belongs 27 November 1942?
       * const result = getDecade(new Date(1942, 10, 27))
       * //=> 1940
       */


      function getDecade(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var year = date.getFullYear();
        var decade = Math.floor(year / 10) * 10;
        return decade;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getHours
       * @category Hour Helpers
       * @summary Get the hours of the given date.
       *
       * @description
       * Get the hours of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the hours
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Get the hours of 29 February 2012 11:45:00:
       * const result = getHours(new Date(2012, 1, 29, 11, 45))
       * //=> 11
       */


      function getHours(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var hours = date.getHours();
        return hours;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__ = __webpack_require__(29);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__ = __webpack_require__(36);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000;
      /**
       * @name getISOWeeksInYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Get the number of weeks in an ISO week-numbering year of the given date.
       *
       * @description
       * Get the number of weeks in an ISO week-numbering year of the given date.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the number of ISO weeks in a year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // How many weeks are in ISO week-numbering year 2015?
       * const result = getISOWeeksInYear(new Date(2015, 1, 11))
       * //=> 53
       */

      function getISOWeeksInYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var thisYear = Object(__WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__["a"
        /* default */
        ])(dirtyDate);
        var nextYear = Object(__WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__["a"
        /* default */
        ])(Object(__WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__["a"
        /* default */
        ])(thisYear, 60));
        var diff = nextYear.valueOf() - thisYear.valueOf(); // Round the number of weeks to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)

        return Math.round(diff / MILLISECONDS_IN_WEEK);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getMilliseconds
       * @category Millisecond Helpers
       * @summary Get the milliseconds of the given date.
       *
       * @description
       * Get the milliseconds of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the milliseconds
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Get the milliseconds of 29 February 2012 11:45:05.123:
       * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
       * //=> 123
       */


      function getMilliseconds(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var milliseconds = date.getMilliseconds();
        return milliseconds;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getMinutes
       * @category Minute Helpers
       * @summary Get the minutes of the given date.
       *
       * @description
       * Get the minutes of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the minutes
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Get the minutes of 29 February 2012 11:45:05:
       * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
       * //=> 45
       */


      function getMinutes(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var minutes = date.getMinutes();
        return minutes;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getMonth
       * @category Month Helpers
       * @summary Get the month of the given date.
       *
       * @description
       * Get the month of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which month is 29 February 2012?
       * const result = getMonth(new Date(2012, 1, 29))
       * //=> 1
       */


      function getMonth(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var month = date.getMonth();
        return month;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
      /**
       * @name getOverlappingDaysInIntervals
       * @category Interval Helpers
       * @summary Get the number of days that overlap in two time intervals
       *
       * @description
       * Get the number of days that overlap in two time intervals
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `getOverlappingDaysInRanges` to `getOverlappingDaysInIntervals`.
       *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
       *
       *   ```
       *   2.1.3
       *   time interval
       *   part of the time axis limited by two instants
       *   ```
       *
       *   Also, this function now accepts an object with `start` and `end` properties
       *   instead of two arguments as an interval.
       *   This function now throws `RangeError` if the start of the interval is after its end
       *   or if any date in the interval is `Invalid Date`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   getOverlappingDaysInRanges(
       *     new Date(2014, 0, 10), new Date(2014, 0, 20),
       *     new Date(2014, 0, 17), new Date(2014, 0, 21)
       *   )
       *
       *   // v2.0.0 onward
       *
       *   getOverlappingDaysInIntervals(
       *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
       *   )
       *   ```
       *
       * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
       * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
       * @returns {Number} the number of days that overlap in two time intervals
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // For overlapping time intervals adds 1 for each started overlapping day:
       * getOverlappingDaysInIntervals(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
       * )
       * //=> 3
       *
       * @example
       * // For non-overlapping time intervals returns 0:
       * getOverlappingDaysInIntervals(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
       * )
       * //=> 0
       */

      function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var intervalLeft = dirtyIntervalLeft || {};
        var intervalRight = dirtyIntervalRight || {};
        var leftStartTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(intervalLeft.start).getTime();
        var leftEndTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(intervalLeft.end).getTime();
        var rightStartTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(intervalRight.start).getTime();
        var rightEndTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
          throw new RangeError("Invalid interval");
        }

        var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;

        if (!isOverlapping) {
          return 0;
        }

        var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
        var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
        var differenceInMs = overlapEndDate - overlapStartDate;
        return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getSeconds
       * @category Second Helpers
       * @summary Get the seconds of the given date.
       *
       * @description
       * Get the seconds of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the seconds
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Get the seconds of 29 February 2012 11:45:05.123:
       * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
       * //=> 5
       */


      function getSeconds(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var seconds = date.getSeconds();
        return seconds;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getTime_index_js__ = __webpack_require__(111);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getUnixTime
       * @category Timestamp Helpers
       * @summary Get the seconds timestamp of the given date.
       *
       * @description
       * Get the seconds timestamp of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the timestamp
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Get the timestamp of 29 February 2012 11:45:05 CET:
       * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
       * //=> 1330512305
       */


      function getUnixTime(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__getTime_index_js__["a"
        /* default */
        ])(dirtyDate) / 1000);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getDate_index_js__ = __webpack_require__(106);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__getDay_index_js__ = __webpack_require__(42);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfMonth_index_js__ = __webpack_require__(39);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getWeekOfMonth
       * @category Week Helpers
       * @summary Get the week of the month of the given date.
       *
       * @description
       * Get the week of the month of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Number} the week of month
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // Which week of the month is 9 November 2017?
       * var result = getWeekOfMonth(new Date(2017, 10, 9))
       * //=> 2
       */


      function getWeekOfMonth(date, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ])(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
        }

        var currentDayOfMonth = Object(__WEBPACK_IMPORTED_MODULE_0__getDate_index_js__["a"
        /* default */
        ])(date);

        if (isNaN(currentDayOfMonth)) {
          return currentDayOfMonth;
        }

        var startWeekDay = Object(__WEBPACK_IMPORTED_MODULE_1__getDay_index_js__["a"
        /* default */
        ])(Object(__WEBPACK_IMPORTED_MODULE_2__startOfMonth_index_js__["a"
        /* default */
        ])(date));
        var lastDayOfFirstWeek = 0;

        if (startWeekDay >= weekStartsOn) {
          lastDayOfFirstWeek = weekStartsOn + 7 - startWeekDay;
        } else {
          lastDayOfFirstWeek = weekStartsOn - startWeekDay;
        }

        var weekNumber = 1;

        if (currentDayOfMonth > lastDayOfFirstWeek) {
          var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
          weekNumber = weekNumber + Math.ceil(remainingDaysAfterFirstWeek / 7);
        }

        return weekNumber;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInCalendarWeeks_index_js__ = __webpack_require__(85);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lastDayOfMonth_index_js__ = __webpack_require__(114);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfMonth_index_js__ = __webpack_require__(39);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getWeeksInMonth
       * @category Week Helpers
       * @summary Get the number of calendar weeks a month spans.
       *
       * @description
       * Get the number of calendar weeks the month in the given date spans.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Number} the number of calendar weeks
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // How many calendar weeks does February 2015 span?
       * const result = getWeeksInMonth(new Date(2015, 1, 8))
       * //=> 4
       *
       * @example
       * // If the week starts on Monday,
       * // how many calendar weeks does July 2017 span?
       * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
       * //=> 6
       */


      function getWeeksInMonth(date, options) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__differenceInCalendarWeeks_index_js__["a"
        /* default */
        ])(Object(__WEBPACK_IMPORTED_MODULE_1__lastDayOfMonth_index_js__["a"
        /* default */
        ])(date), Object(__WEBPACK_IMPORTED_MODULE_2__startOfMonth_index_js__["a"
        /* default */
        ])(date), options) + 1;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getYear
       * @category Year Helpers
       * @summary Get the year of the given date.
       *
       * @description
       * Get the year of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which year is 2 July 2014?
       * const result = getYear(new Date(2014, 6, 2))
       * //=> 2014
       */


      function getYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var year = date.getFullYear();
        return year;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name hoursToMilliseconds
       * @category  Conversion Helpers
       * @summary Convert hours to milliseconds.
       *
       * @description
       * Convert a number of hours to a full number of milliseconds.
       *
       * @param {number} hours - number of hours to be converted
       *
       * @returns {number} the number of hours converted to milliseconds
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 2 hours to milliseconds:
       * const result = hoursToMilliseconds(2)
       * //=> 7200000
       */


      function hoursToMilliseconds(hours) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Math.floor(hours * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["b"
        /* millisecondsInHour */
        ]);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name hoursToMinutes
       * @category Conversion Helpers
       * @summary Convert hours to minutes.
       *
       * @description
       * Convert a number of hours to a full number of minutes.
       *
       * @param {number} hours - number of hours to be converted
       *
       * @returns {number} the number of hours converted in minutes
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 2 hours to minutes:
       * const result = hoursToMinutes(2)
       * //=> 120
       */


      function hoursToMinutes(hours) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Math.floor(hours * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["e"
        /* minutesInHour */
        ]);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name hoursToSeconds
       * @category Conversion Helpers
       * @summary Convert hours to seconds.
       *
       * @description
       * Convert a number of hours to a full number of seconds.
       *
       * @param {number} hours - number of hours to be converted
       *
       * @returns {number} the number of hours converted in seconds
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 2 hours to seconds:
       * const result = hoursToSeconds(2)
       * //=> 7200
       */


      function hoursToSeconds(hours) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Math.floor(hours * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["i"
        /* secondsInHour */
        ]);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__ = __webpack_require__(21);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInYears_index_js__ = __webpack_require__(91);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__differenceInMonths_index_js__ = __webpack_require__(38);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__differenceInDays_index_js__ = __webpack_require__(50);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__differenceInHours_index_js__ = __webpack_require__(87);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__differenceInMinutes_index_js__ = __webpack_require__(89);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__differenceInSeconds_index_js__ = __webpack_require__(53);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__isValid_index_js__ = __webpack_require__(9);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_8__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_9__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_10__sub_index_js__ = __webpack_require__(115);
      /**
       * @name intervalToDuration
       * @category Common Helpers
       * @summary Convert interval to duration
       *
       * @description
       * Convert a interval object to a duration object.
       *
       * @param {Interval} interval - the interval to convert to duration
       *
       * @returns {Duration} The duration Object
       * @throws {TypeError} Requires 2 arguments
       * @throws {RangeError} `start` must not be Invalid Date
       * @throws {RangeError} `end` must not be Invalid Date
       *
       * @example
       * // Get the duration between January 15, 1929 and April 4, 1968.
       * intervalToDuration({
       *   start: new Date(1929, 0, 15, 12, 0, 0),
       *   end: new Date(1968, 3, 4, 19, 5, 0)
       * })
       * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
       */


      function intervalToDuration(_ref) {
        var start = _ref.start,
            end = _ref.end;
        Object(__WEBPACK_IMPORTED_MODULE_8__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_9__toDate_index_js__["a"
        /* default */
        ])(start);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_9__toDate_index_js__["a"
        /* default */
        ])(end);

        if (!Object(__WEBPACK_IMPORTED_MODULE_7__isValid_index_js__["a"
        /* default */
        ])(dateLeft)) {
          throw new RangeError("Start Date is invalid");
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_7__isValid_index_js__["a"
        /* default */
        ])(dateRight)) {
          throw new RangeError("End Date is invalid");
        }

        var duration = {
          years: 0,
          months: 0,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        var sign = Object(__WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__["a"
        /* default */
        ])(dateLeft, dateRight);
        duration.years = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_1__differenceInYears_index_js__["a"
        /* default */
        ])(dateLeft, dateRight));
        var remainingMonths = Object(__WEBPACK_IMPORTED_MODULE_10__sub_index_js__["a"
        /* default */
        ])(dateLeft, {
          years: sign * duration.years
        });
        duration.months = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_2__differenceInMonths_index_js__["a"
        /* default */
        ])(remainingMonths, dateRight));
        var remainingDays = Object(__WEBPACK_IMPORTED_MODULE_10__sub_index_js__["a"
        /* default */
        ])(remainingMonths, {
          months: sign * duration.months
        });
        duration.days = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_3__differenceInDays_index_js__["a"
        /* default */
        ])(remainingDays, dateRight));
        var remainingHours = Object(__WEBPACK_IMPORTED_MODULE_10__sub_index_js__["a"
        /* default */
        ])(remainingDays, {
          days: sign * duration.days
        });
        duration.hours = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_4__differenceInHours_index_js__["a"
        /* default */
        ])(remainingHours, dateRight));
        var remainingMinutes = Object(__WEBPACK_IMPORTED_MODULE_10__sub_index_js__["a"
        /* default */
        ])(remainingHours, {
          hours: sign * duration.hours
        });
        duration.minutes = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_5__differenceInMinutes_index_js__["a"
        /* default */
        ])(remainingMinutes, dateRight));
        var remainingSeconds = Object(__WEBPACK_IMPORTED_MODULE_10__sub_index_js__["a"
        /* default */
        ])(remainingMinutes, {
          minutes: sign * duration.minutes
        });
        duration.seconds = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_6__differenceInSeconds_index_js__["a"
        /* default */
        ])(remainingSeconds, dateRight));
        return duration;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name intlFormat
       * @category Common Helpers
       * @summary  Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
       *
       * @description
       * Return the formatted date string in the given format.
       * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
       * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
       *
       * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
       *
       * @param {Date|Number} argument - the original date.
       * @param {Object} [formatOptions] - an object with options.
       * @param {'lookup'|'best fit'} [formatOptions.localeMatcher='best fit'] - locale selection algorithm.
       * @param {'narrow'|'short'|'long'} [formatOptions.weekday] - representation the days of the week.
       * @param {'narrow'|'short'|'long'} [formatOptions.era] - representation of eras.
       * @param {'numeric'|'2-digit'} [formatOptions.year] - representation of years.
       * @param {'numeric'|'2-digit'|'narrow'|'short'|'long'} [formatOptions.month='numeric'] - representation of month.
       * @param {'numeric'|'2-digit'} [formatOptions.day='numeric'] - representation of day.
       * @param {'numeric'|'2-digit'} [formatOptions.hour='numeric'] - representation of hours.
       * @param {'numeric'|'2-digit'} [formatOptions.minute] - representation of minutes.
       * @param {'numeric'|'2-digit'} [formatOptions.second] - representation of seconds.
       * @param {'short'|'long'} [formatOptions.timeZoneName] - representation of names of time zones.
       * @param {'basic'|'best fit'} [formatOptions.formatMatcher='best fit'] - format selection algorithm.
       * @param {Boolean} [formatOptions.hour12] - determines whether to use 12-hour time format.
       * @param {String} [formatOptions.timeZone] - the time zone to use.
       * @param {Object} [localeOptions] - an object with locale.
       * @param {String|String[]} [localeOptions.locale] - the locale code
       * @returns {String} the formatted date string.
       * @throws {TypeError} 1 argument required.
       * @throws {RangeError} `date` must not be Invalid Date
       *
       * @example
       * // Represent 10 October 2019 in German.
       * // Convert the date with format's options and locale's options.
       * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
       *      weekday: 'long',
       *      year: 'numeric',
       *      month: 'long',
       *      day: 'numeric',
       *    }, {
       *      locale: 'de-DE',
       *  })
       * //=> Freitag, 4. Oktober 2019
       *
       * @example
       * // Represent 10 October 2019.
       * // Convert the date with format's options.
       * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
       *      year: 'numeric',
       *      month: 'numeric',
       *      day: 'numeric',
       *      hour: 'numeric',
       *  })
       * //=> 10/4/2019, 12 PM
       *
       * @example
       * // Represent 10 October 2019 in Korean.
       * // Convert the date with locale's options.
       * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
       *      locale: 'ko-KR',
       *  })
       * //=> 2019. 10. 4.
       *
       * @example
       * // Represent 10 October 2019 in middle-endian format:
       * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
       * //=> 10/4/2019
       */


      function intlFormat(date, formatOrLocale, localeOptions) {
        var _localeOptions;

        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var formatOptions;

        if (isFormatOptions(formatOrLocale)) {
          formatOptions = formatOrLocale;
        } else {
          localeOptions = formatOrLocale;
        }

        return new Intl.DateTimeFormat((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.locale, formatOptions).format(date);
      }

      function isFormatOptions(opts) {
        return opts !== undefined && !("locale" in opts);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isAfter;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isAfter
       * @category Common Helpers
       * @summary Is the first date after the second one?
       *
       * @description
       * Is the first date after the second one?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date that should be after the other one to return true
       * @param {Date|Number} dateToCompare - the date to compare with
       * @returns {Boolean} the first date is after the second date
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Is 10 July 1989 after 11 February 1987?
       * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
       * //=> true
       */


      function isAfter(dirtyDate, dirtyDateToCompare) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateToCompare);
        return date.getTime() > dateToCompare.getTime();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isBefore;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isBefore
       * @category Common Helpers
       * @summary Is the first date before the second one?
       *
       * @description
       * Is the first date before the second one?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date that should be before the other one to return true
       * @param {Date|Number} dateToCompare - the date to compare with
       * @returns {Boolean} the first date is before the second date
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Is 10 July 1989 before 11 February 1987?
       * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
       * //=> false
       */


      function isBefore(dirtyDate, dirtyDateToCompare) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDateToCompare);
        return date.getTime() < dateToCompare.getTime();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isEqual;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isEqual
       * @category Common Helpers
       * @summary Are the given dates equal?
       *
       * @description
       * Are the given dates equal?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to compare
       * @param {Date|Number} dateRight - the second date to compare
       * @returns {Boolean} the dates are equal
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
       * var result = isEqual(
       *   new Date(2014, 6, 2, 6, 30, 45, 0),
       *   new Date(2014, 6, 2, 6, 30, 45, 500)
       * )
       * //=> false
       */


      function isEqual(dirtyLeftDate, dirtyRightDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyLeftDate);
        var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyRightDate);
        return dateLeft.getTime() === dateRight.getTime();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /**
       * @name isExists
       * @category Common Helpers
       * @summary Is the given date exists?
       *
       * @description
       * Checks if the given arguments convert to an existing date.
       *
       * @param {Number} year of the date to check
       * @param {Number} month of the date to check
       * @param {Number} day of the date to check
       * @returns {Boolean} the date exists
       * @throws {TypeError} 3 arguments required
       *
       * @example
       * // For the valid date:
       * var result = isExists(2018, 0, 31)
       * //=> true
       *
       * @example
       * // For the invalid date:
       * var result = isExists(2018, 1, 31)
       * //=> false
       */

      function isExists(year, month, day) {
        if (arguments.length < 3) {
          throw new TypeError("3 argument required, but only " + arguments.length + " present");
        }

        var date = new Date(year, month, day);
        return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isFirstDayOfMonth
       * @category Month Helpers
       * @summary Is the given date the first day of a month?
       *
       * @description
       * Is the given date the first day of a month?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is the first day of a month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 1 September 2014 the first day of a month?
       * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
       * //=> true
       */


      function isFirstDayOfMonth(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate).getDate() === 1;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isFriday
       * @category Weekday Helpers
       * @summary Is the given date Friday?
       *
       * @description
       * Is the given date Friday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Friday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 26 September 2014 Friday?
       * var result = isFriday(new Date(2014, 8, 26))
       * //=> true
       */


      function isFriday(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate).getDay() === 5;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isFuture
       * @category Common Helpers
       * @summary Is the given date in the future?
       * @pure false
       *
       * @description
       * Is the given date in the future?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in the future
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 6 October 2014, is 31 December 2014 in the future?
       * var result = isFuture(new Date(2014, 11, 31))
       * //=> true
       */


      function isFuture(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate).getTime() > Date.now();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__parse_index_js__ = __webpack_require__(117);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(9);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isMatch
       * @category Common Helpers
       * @summary validates the date string against given formats
       *
       * @description
       * Return the true if given date is string correct against the given format else
       * will return false.
       *
       * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
       * > See: https://git.io/fxCyr
       *
       * The characters in the format string wrapped between two single quotes characters (') are escaped.
       * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
       *
       * Format of the format string is based on Unicode Technical Standard #35:
       * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
       * with a few additions (see note 5 below the table).
       *
       * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
       * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
       *
       * ```javascript
       * isMatch('23 AM', 'HH a')
       * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
       * ```
       *
       * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
       *
       * Accepted format string patterns:
       * | Unit                            |Prior| Pattern | Result examples                   | Notes |
       * |---------------------------------|-----|---------|-----------------------------------|-------|
       * | Era                             | 140 | G..GGG  | AD, BC                            |       |
       * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
       * |                                 |     | GGGGG   | A, B                              |       |
       * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
       * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
       * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
       * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
       * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
       * |                                 |     | yyyyy   | ...                               | 2,4   |
       * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
       * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
       * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
       * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
       * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
       * |                                 |     | YYYYY   | ...                               | 2,4   |
       * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
       * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
       * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
       * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
       * |                                 |     | RRRRR   | ...                               | 2,4,5 |
       * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
       * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
       * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
       * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
       * |                                 |     | uuuuu   | ...                               | 2,4   |
       * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
       * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
       * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
       * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
       * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
       * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
       * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
       * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
       * |                                 |     | qq      | 01, 02, 03, 04                    |       |
       * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
       * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
       * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
       * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
       * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
       * |                                 |     | MM      | 01, 02, ..., 12                   |       |
       * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
       * |                                 |     | MMMM    | January, February, ..., December  | 2     |
       * |                                 |     | MMMMM   | J, F, ..., D                      |       |
       * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
       * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
       * |                                 |     | LL      | 01, 02, ..., 12                   |       |
       * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
       * |                                 |     | LLLL    | January, February, ..., December  | 2     |
       * |                                 |     | LLLLL   | J, F, ..., D                      |       |
       * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
       * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
       * |                                 |     | ww      | 01, 02, ..., 53                   |       |
       * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
       * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
       * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
       * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
       * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
       * |                                 |     | dd      | 01, 02, ..., 31                   |       |
       * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
       * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
       * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
       * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
       * |                                 |     | DDDD    | ...                               | 2     |
       * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
       * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
       * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
       * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
       * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
       * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
       * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
       * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
       * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
       * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
       * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
       * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
       * |                                 |     | ee      | 02, 03, ..., 01                   |       |
       * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
       * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
       * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
       * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
       * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
       * |                                 |     | cc      | 02, 03, ..., 01                   |       |
       * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
       * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
       * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
       * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
       * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
       * |                                 |     | aaaaa   | a, p                              |       |
       * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
       * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
       * |                                 |     | bbbbb   | a, p, n, mi                       |       |
       * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
       * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
       * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
       * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
       * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
       * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
       * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
       * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
       * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
       * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
       * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
       * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
       * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
       * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
       * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
       * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
       * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
       * |                                 |     | mm      | 00, 01, ..., 59                   |       |
       * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
       * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
       * |                                 |     | ss      | 00, 01, ..., 59                   |       |
       * | Seconds timestamp               |  40 | t       | 512969520                         |       |
       * |                                 |     | tt      | ...                               | 2     |
       * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
       * |                                 |     | SS      | 00, 01, ..., 99                   |       |
       * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
       * |                                 |     | SSSS    | ...                               | 2     |
       * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
       * |                                 |     | TT      | ...                               | 2     |
       * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
       * |                                 |     | XX      | -0800, +0530, Z                   |       |
       * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
       * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
       * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
       * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
       * |                                 |     | xx      | -0800, +0530, +0000               |       |
       * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
       * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
       * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
       * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
       * |                                 |     | PP      | May 29, 1453                      |       |
       * |                                 |     | PPP     | May 29th, 1453                    |       |
       * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
       * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
       * |                                 |     | pp      | 12:00:00 AM                       |       |
       * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
       * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
       * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
       * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
       * Notes:
       * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
       *    are the same as "stand-alone" units, but are different in some languages.
       *    "Formatting" units are declined according to the rules of the language
       *    in the context of a date. "Stand-alone" units are always nominative singular.
       *    In `format` function, they will produce different result:
       *
       *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
       *
       *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
       *
       *    `isMatch` will try to match both formatting and stand-alone units interchangably.
       *
       * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
       *    the single quote characters (see below).
       *    If the sequence is longer than listed in table:
       *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
       *      as wide as the sequence
       *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
       *      These variations are marked with "2" in the last column of the table.
       *
       * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
       *    These tokens represent the shortest form of the quarter.
       *
       * 4. The main difference between `y` and `u` patterns are B.C. years:
       *
       *    | Year | `y` | `u` |
       *    |------|-----|-----|
       *    | AC 1 |   1 |   1 |
       *    | BC 1 |   1 |   0 |
       *    | BC 2 |   2 |  -1 |
       *
       *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
       *
       *    `isMatch('50', 'yy') //=> true`
       *
       *    `isMatch('75', 'yy') //=> true`
       *
       *    while `uu` will use the year as is:
       *
       *    `isMatch('50', 'uu') //=> true`
       *
       *    `isMatch('75', 'uu') //=> true`
       *
       *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
       *    except local week-numbering years are dependent on `options.weekStartsOn`
       *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
       *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
       *
       * 5. These patterns are not in the Unicode Technical Standard #35:
       *    - `i`: ISO day of week
       *    - `I`: ISO week of year
       *    - `R`: ISO week-numbering year
       *    - `o`: ordinal number modifier
       *    - `P`: long localized date
       *    - `p`: long localized time
       *
       * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
       *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
       *
       * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
       *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
       *
       * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
       *    on the given locale.
       *
       *    using `en-US` locale: `P` => `MM/dd/yyyy`
       *    using `en-US` locale: `p` => `hh:mm a`
       *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
       *    using `pt-BR` locale: `p` => `HH:mm`
       *
       * Values will be checked in the descending order of its unit's priority.
       * Units of an equal priority overwrite each other in the order of appearance.
       *
       * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
       * the values will be taken from today's using `new Date()` date which works as a context of parsing.
       *
       * The result may vary by locale.
       *
       * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
       *
       *
       *
       * @param {String} dateString - the date string to verify
       * @param {String} formatString - the string of tokens
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
       *   see: https://git.io/fxCyr
       * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
       *   see: https://git.io/fxCyr
       * @returns {Boolean}
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       * @throws {RangeError} `options.locale` must contain `match` property
       * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
       * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
       * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
       * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
       * @throws {RangeError} format string contains an unescaped latin alphabet character
       *
       * @example
       * // Match 11 February 2014 from middle-endian format:
       * var result = isMatch('02/11/2014', 'MM/dd/yyyy')
       * //=> true
       *
       * @example
       * // Match 28th of February in Esperanto locale in the context of 2010 year:
       * import eo from 'date-fns/locale/eo'
       * var result = isMatch('28-a de februaro', "do 'de' MMMM", {
       *   locale: eo
       * })
       * //=> true
       */


      function isMatch(dateString, formatString, options) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a"
        /* default */
        ])(Object(__WEBPACK_IMPORTED_MODULE_0__parse_index_js__["a"
        /* default */
        ])(dateString, formatString, new Date(), options));
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_getUTCWeekYear_index_js__ = __webpack_require__(58);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__ = __webpack_require__(581);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_setUTCISODay_index_js__ = __webpack_require__(582);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_setUTCISOWeek_index_js__ = __webpack_require__(583);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_setUTCWeek_index_js__ = __webpack_require__(584);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__ = __webpack_require__(40);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__ = __webpack_require__(41);

      var MILLISECONDS_IN_HOUR = 3600000;
      var MILLISECONDS_IN_MINUTE = 60000;
      var MILLISECONDS_IN_SECOND = 1000;
      var numericPatterns = {
        month: /^(1[0-2]|0?\d)/,
        // 0 to 12
        date: /^(3[0-1]|[0-2]?\d)/,
        // 0 to 31
        dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
        // 0 to 366
        week: /^(5[0-3]|[0-4]?\d)/,
        // 0 to 53
        hour23h: /^(2[0-3]|[0-1]?\d)/,
        // 0 to 23
        hour24h: /^(2[0-4]|[0-1]?\d)/,
        // 0 to 24
        hour11h: /^(1[0-1]|0?\d)/,
        // 0 to 11
        hour12h: /^(1[0-2]|0?\d)/,
        // 0 to 12
        minute: /^[0-5]?\d/,
        // 0 to 59
        second: /^[0-5]?\d/,
        // 0 to 59
        singleDigit: /^\d/,
        // 0 to 9
        twoDigits: /^\d{1,2}/,
        // 0 to 99
        threeDigits: /^\d{1,3}/,
        // 0 to 999
        fourDigits: /^\d{1,4}/,
        // 0 to 9999
        anyDigitsSigned: /^-?\d+/,
        singleDigitSigned: /^-?\d/,
        // 0 to 9, -0 to -9
        twoDigitsSigned: /^-?\d{1,2}/,
        // 0 to 99, -0 to -99
        threeDigitsSigned: /^-?\d{1,3}/,
        // 0 to 999, -0 to -999
        fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

      };
      var timezonePatterns = {
        basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
        basic: /^([+-])(\d{2})(\d{2})|Z/,
        basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
        extended: /^([+-])(\d{2}):(\d{2})|Z/,
        extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
      };

      function parseNumericPattern(pattern, string, valueCallback) {
        var matchResult = string.match(pattern);

        if (!matchResult) {
          return null;
        }

        var value = parseInt(matchResult[0], 10);
        return {
          value: valueCallback ? valueCallback(value) : value,
          rest: string.slice(matchResult[0].length)
        };
      }

      function parseTimezonePattern(pattern, string) {
        var matchResult = string.match(pattern);

        if (!matchResult) {
          return null;
        } // Input is 'Z'


        if (matchResult[0] === "Z") {
          return {
            value: 0,
            rest: string.slice(1)
          };
        }

        var sign = matchResult[1] === "+" ? 1 : -1;
        var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
        var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
        var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
        return {
          value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
          rest: string.slice(matchResult[0].length)
        };
      }

      function parseAnyDigitsSigned(string, valueCallback) {
        return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
      }

      function parseNDigits(n, string, valueCallback) {
        switch (n) {
          case 1:
            return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

          case 2:
            return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

          case 3:
            return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

          case 4:
            return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

          default:
            return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), string, valueCallback);
        }
      }

      function parseNDigitsSigned(n, string, valueCallback) {
        switch (n) {
          case 1:
            return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

          case 2:
            return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

          case 3:
            return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

          case 4:
            return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

          default:
            return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), string, valueCallback);
        }
      }

      function dayPeriodEnumToHours(enumValue) {
        switch (enumValue) {
          case "morning":
            return 4;

          case "evening":
            return 17;

          case "pm":
          case "noon":
          case "afternoon":
            return 12;

          case "am":
          case "midnight":
          case "night":
          default:
            return 0;
        }
      }

      function normalizeTwoDigitYear(twoDigitYear, currentYear) {
        var isCommonEra = currentYear > 0; // Absolute number of the current year:
        // 1 -> 1 AC
        // 0 -> 1 BC
        // -1 -> 2 BC

        var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
        var result;

        if (absCurrentYear <= 50) {
          result = twoDigitYear || 100;
        } else {
          var rangeEnd = absCurrentYear + 50;
          var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
          var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
          result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
        }

        return isCommonEra ? result : 1 - result;
      }

      var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

      function isLeapYearIndex(year) {
        return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
      }
      /*
       * |     | Unit                           |     | Unit                           |
       * |-----|--------------------------------|-----|--------------------------------|
       * |  a  | AM, PM                         |  A* | Milliseconds in day            |
       * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
       * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
       * |  d  | Day of month                   |  D  | Day of year                    |
       * |  e  | Local day of week              |  E  | Day of week                    |
       * |  f  |                                |  F* | Day of week in month           |
       * |  g* | Modified Julian day            |  G  | Era                            |
       * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
       * |  i! | ISO day of week                |  I! | ISO week of year               |
       * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
       * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
       * |  l* | (deprecated)                   |  L  | Stand-alone month              |
       * |  m  | Minute                         |  M  | Month                          |
       * |  n  |                                |  N  |                                |
       * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
       * |  p  |                                |  P  |                                |
       * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
       * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
       * |  s  | Second                         |  S  | Fraction of second             |
       * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
       * |  u  | Extended year                  |  U* | Cyclic year                    |
       * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
       * |  w  | Local week of year             |  W* | Week of month                  |
       * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
       * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
       * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
       *
       * Letters marked by * are not implemented but reserved by Unicode standard.
       *
       * Letters marked by ! are non-standard, but implemented by date-fns:
       * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
       * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
       *   i.e. 7 for Sunday, 1 for Monday, etc.
       * - `I` is ISO week of year, as opposed to `w` which is local week of year.
       * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
       *   `R` is supposed to be used in conjunction with `I` and `i`
       *   for universal ISO week-numbering date, whereas
       *   `Y` is supposed to be used in conjunction with `w` and `e`
       *   for week-numbering date specific to the locale.
       */


      var parsers = {
        // Era
        G: {
          priority: 140,
          parse: function (string, token, match, _options) {
            switch (token) {
              // AD, BC
              case "G":
              case "GG":
              case "GGG":
                return match.era(string, {
                  width: "abbreviated"
                }) || match.era(string, {
                  width: "narrow"
                });
              // A, B

              case "GGGGG":
                return match.era(string, {
                  width: "narrow"
                });
              // Anno Domini, Before Christ

              case "GGGG":
              default:
                return match.era(string, {
                  width: "wide"
                }) || match.era(string, {
                  width: "abbreviated"
                }) || match.era(string, {
                  width: "narrow"
                });
            }
          },
          set: function (date, flags, value, _options) {
            flags.era = value;
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["R", "u", "t", "T"]
        },
        // Year
        y: {
          // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
          // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
          // |----------|-------|----|-------|-------|-------|
          // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
          // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
          // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
          // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
          // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
          priority: 130,
          parse: function (string, token, match, _options) {
            var valueCallback = function (year) {
              return {
                year: year,
                isTwoDigitYear: token === "yy"
              };
            };

            switch (token) {
              case "y":
                return parseNDigits(4, string, valueCallback);

              case "yo":
                return match.ordinalNumber(string, {
                  unit: "year",
                  valueCallback: valueCallback
                });

              default:
                return parseNDigits(token.length, string, valueCallback);
            }
          },
          validate: function (_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
          },
          set: function (date, flags, value, _options) {
            var currentYear = date.getUTCFullYear();

            if (value.isTwoDigitYear) {
              var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
              date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
              date.setUTCHours(0, 0, 0, 0);
              return date;
            }

            var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]
        },
        // Local week-numbering year
        Y: {
          priority: 130,
          parse: function (string, token, match, _options) {
            var valueCallback = function (year) {
              return {
                year: year,
                isTwoDigitYear: token === "YY"
              };
            };

            switch (token) {
              case "Y":
                return parseNDigits(4, string, valueCallback);

              case "Yo":
                return match.ordinalNumber(string, {
                  unit: "year",
                  valueCallback: valueCallback
                });

              default:
                return parseNDigits(token.length, string, valueCallback);
            }
          },
          validate: function (_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
          },
          set: function (date, flags, value, options) {
            var currentYear = Object(__WEBPACK_IMPORTED_MODULE_0__lib_getUTCWeekYear_index_js__["a"
            /* default */
            ])(date, options);

            if (value.isTwoDigitYear) {
              var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
              date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
              date.setUTCHours(0, 0, 0, 0);
              return Object(__WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a"
              /* default */
              ])(date, options);
            }

            var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
            date.setUTCHours(0, 0, 0, 0);
            return Object(__WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a"
            /* default */
            ])(date, options);
          },
          incompatibleTokens: ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]
        },
        // ISO week-numbering year
        R: {
          priority: 130,
          parse: function (string, token, _match, _options) {
            if (token === "R") {
              return parseNDigitsSigned(4, string);
            }

            return parseNDigitsSigned(token.length, string);
          },
          set: function (_date, _flags, value, _options) {
            var firstWeekOfYear = new Date(0);
            firstWeekOfYear.setUTCFullYear(value, 0, 4);
            firstWeekOfYear.setUTCHours(0, 0, 0, 0);
            return Object(__WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__["a"
            /* default */
            ])(firstWeekOfYear);
          },
          incompatibleTokens: ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
        },
        // Extended year
        u: {
          priority: 130,
          parse: function (string, token, _match, _options) {
            if (token === "u") {
              return parseNDigitsSigned(4, string);
            }

            return parseNDigitsSigned(token.length, string);
          },
          set: function (date, _flags, value, _options) {
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]
        },
        // Quarter
        Q: {
          priority: 120,
          parse: function (string, token, match, _options) {
            switch (token) {
              // 1, 2, 3, 4
              case "Q":
              case "QQ":
                // 01, 02, 03, 04
                return parseNDigits(token.length, string);
              // 1st, 2nd, 3rd, 4th

              case "Qo":
                return match.ordinalNumber(string, {
                  unit: "quarter"
                });
              // Q1, Q2, Q3, Q4

              case "QQQ":
                return match.quarter(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.quarter(string, {
                  width: "narrow",
                  context: "formatting"
                });
              // 1, 2, 3, 4 (narrow quarter; could be not numerical)

              case "QQQQQ":
                return match.quarter(string, {
                  width: "narrow",
                  context: "formatting"
                });
              // 1st quarter, 2nd quarter, ...

              case "QQQQ":
              default:
                return match.quarter(string, {
                  width: "wide",
                  context: "formatting"
                }) || match.quarter(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.quarter(string, {
                  width: "narrow",
                  context: "formatting"
                });
            }
          },
          validate: function (_date, value, _options) {
            return value >= 1 && value <= 4;
          },
          set: function (date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
        },
        // Stand-alone quarter
        q: {
          priority: 120,
          parse: function (string, token, match, _options) {
            switch (token) {
              // 1, 2, 3, 4
              case "q":
              case "qq":
                // 01, 02, 03, 04
                return parseNDigits(token.length, string);
              // 1st, 2nd, 3rd, 4th

              case "qo":
                return match.ordinalNumber(string, {
                  unit: "quarter"
                });
              // Q1, Q2, Q3, Q4

              case "qqq":
                return match.quarter(string, {
                  width: "abbreviated",
                  context: "standalone"
                }) || match.quarter(string, {
                  width: "narrow",
                  context: "standalone"
                });
              // 1, 2, 3, 4 (narrow quarter; could be not numerical)

              case "qqqqq":
                return match.quarter(string, {
                  width: "narrow",
                  context: "standalone"
                });
              // 1st quarter, 2nd quarter, ...

              case "qqqq":
              default:
                return match.quarter(string, {
                  width: "wide",
                  context: "standalone"
                }) || match.quarter(string, {
                  width: "abbreviated",
                  context: "standalone"
                }) || match.quarter(string, {
                  width: "narrow",
                  context: "standalone"
                });
            }
          },
          validate: function (_date, value, _options) {
            return value >= 1 && value <= 4;
          },
          set: function (date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
        },
        // Month
        M: {
          priority: 110,
          parse: function (string, token, match, _options) {
            var valueCallback = function (value) {
              return value - 1;
            };

            switch (token) {
              // 1, 2, ..., 12
              case "M":
                return parseNumericPattern(numericPatterns.month, string, valueCallback);
              // 01, 02, ..., 12

              case "MM":
                return parseNDigits(2, string, valueCallback);
              // 1st, 2nd, ..., 12th

              case "Mo":
                return match.ordinalNumber(string, {
                  unit: "month",
                  valueCallback: valueCallback
                });
              // Jan, Feb, ..., Dec

              case "MMM":
                return match.month(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.month(string, {
                  width: "narrow",
                  context: "formatting"
                });
              // J, F, ..., D

              case "MMMMM":
                return match.month(string, {
                  width: "narrow",
                  context: "formatting"
                });
              // January, February, ..., December

              case "MMMM":
              default:
                return match.month(string, {
                  width: "wide",
                  context: "formatting"
                }) || match.month(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.month(string, {
                  width: "narrow",
                  context: "formatting"
                });
            }
          },
          validate: function (_date, value, _options) {
            return value >= 0 && value <= 11;
          },
          set: function (date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]
        },
        // Stand-alone month
        L: {
          priority: 110,
          parse: function (string, token, match, _options) {
            var valueCallback = function (value) {
              return value - 1;
            };

            switch (token) {
              // 1, 2, ..., 12
              case "L":
                return parseNumericPattern(numericPatterns.month, string, valueCallback);
              // 01, 02, ..., 12

              case "LL":
                return parseNDigits(2, string, valueCallback);
              // 1st, 2nd, ..., 12th

              case "Lo":
                return match.ordinalNumber(string, {
                  unit: "month",
                  valueCallback: valueCallback
                });
              // Jan, Feb, ..., Dec

              case "LLL":
                return match.month(string, {
                  width: "abbreviated",
                  context: "standalone"
                }) || match.month(string, {
                  width: "narrow",
                  context: "standalone"
                });
              // J, F, ..., D

              case "LLLLL":
                return match.month(string, {
                  width: "narrow",
                  context: "standalone"
                });
              // January, February, ..., December

              case "LLLL":
              default:
                return match.month(string, {
                  width: "wide",
                  context: "standalone"
                }) || match.month(string, {
                  width: "abbreviated",
                  context: "standalone"
                }) || match.month(string, {
                  width: "narrow",
                  context: "standalone"
                });
            }
          },
          validate: function (_date, value, _options) {
            return value >= 0 && value <= 11;
          },
          set: function (date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]
        },
        // Local week of year
        w: {
          priority: 100,
          parse: function (string, token, match, _options) {
            switch (token) {
              case "w":
                return parseNumericPattern(numericPatterns.week, string);

              case "wo":
                return match.ordinalNumber(string, {
                  unit: "week"
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function (_date, value, _options) {
            return value >= 1 && value <= 53;
          },
          set: function (date, _flags, value, options) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a"
            /* default */
            ])(Object(__WEBPACK_IMPORTED_MODULE_4__lib_setUTCWeek_index_js__["a"
            /* default */
            ])(date, value, options), options);
          },
          incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]
        },
        // ISO week of year
        I: {
          priority: 100,
          parse: function (string, token, match, _options) {
            switch (token) {
              case "I":
                return parseNumericPattern(numericPatterns.week, string);

              case "Io":
                return match.ordinalNumber(string, {
                  unit: "week"
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function (_date, value, _options) {
            return value >= 1 && value <= 53;
          },
          set: function (date, _flags, value, options) {
            return Object(__WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__["a"
            /* default */
            ])(Object(__WEBPACK_IMPORTED_MODULE_3__lib_setUTCISOWeek_index_js__["a"
            /* default */
            ])(date, value, options), options);
          },
          incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
        },
        // Day of the month
        d: {
          priority: 90,
          subPriority: 1,
          parse: function (string, token, match, _options) {
            switch (token) {
              case "d":
                return parseNumericPattern(numericPatterns.date, string);

              case "do":
                return match.ordinalNumber(string, {
                  unit: "date"
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function (date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = isLeapYearIndex(year);
            var month = date.getUTCMonth();

            if (isLeapYear) {
              return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
            } else {
              return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
          },
          set: function (date, _flags, value, _options) {
            date.setUTCDate(value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]
        },
        // Day of year
        D: {
          priority: 90,
          subPriority: 1,
          parse: function (string, token, match, _options) {
            switch (token) {
              case "D":
              case "DD":
                return parseNumericPattern(numericPatterns.dayOfYear, string);

              case "Do":
                return match.ordinalNumber(string, {
                  unit: "date"
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function (date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = isLeapYearIndex(year);

            if (isLeapYear) {
              return value >= 1 && value <= 366;
            } else {
              return value >= 1 && value <= 365;
            }
          },
          set: function (date, _flags, value, _options) {
            date.setUTCMonth(0, value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]
        },
        // Day of week
        E: {
          priority: 90,
          parse: function (string, token, match, _options) {
            switch (token) {
              // Tue
              case "E":
              case "EE":
              case "EEE":
                return match.day(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.day(string, {
                  width: "short",
                  context: "formatting"
                }) || match.day(string, {
                  width: "narrow",
                  context: "formatting"
                });
              // T

              case "EEEEE":
                return match.day(string, {
                  width: "narrow",
                  context: "formatting"
                });
              // Tu

              case "EEEEEE":
                return match.day(string, {
                  width: "short",
                  context: "formatting"
                }) || match.day(string, {
                  width: "narrow",
                  context: "formatting"
                });
              // Tuesday

              case "EEEE":
              default:
                return match.day(string, {
                  width: "wide",
                  context: "formatting"
                }) || match.day(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.day(string, {
                  width: "short",
                  context: "formatting"
                }) || match.day(string, {
                  width: "narrow",
                  context: "formatting"
                });
            }
          },
          validate: function (_date, value, _options) {
            return value >= 0 && value <= 6;
          },
          set: function (date, _flags, value, options) {
            date = Object(__WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a"
            /* default */
            ])(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["D", "i", "e", "c", "t", "T"]
        },
        // Local day of week
        e: {
          priority: 90,
          parse: function (string, token, match, options) {
            var valueCallback = function (value) {
              var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
              return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };

            switch (token) {
              // 3
              case "e":
              case "ee":
                // 03
                return parseNDigits(token.length, string, valueCallback);
              // 3rd

              case "eo":
                return match.ordinalNumber(string, {
                  unit: "day",
                  valueCallback: valueCallback
                });
              // Tue

              case "eee":
                return match.day(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.day(string, {
                  width: "short",
                  context: "formatting"
                }) || match.day(string, {
                  width: "narrow",
                  context: "formatting"
                });
              // T

              case "eeeee":
                return match.day(string, {
                  width: "narrow",
                  context: "formatting"
                });
              // Tu

              case "eeeeee":
                return match.day(string, {
                  width: "short",
                  context: "formatting"
                }) || match.day(string, {
                  width: "narrow",
                  context: "formatting"
                });
              // Tuesday

              case "eeee":
              default:
                return match.day(string, {
                  width: "wide",
                  context: "formatting"
                }) || match.day(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.day(string, {
                  width: "short",
                  context: "formatting"
                }) || match.day(string, {
                  width: "narrow",
                  context: "formatting"
                });
            }
          },
          validate: function (_date, value, _options) {
            return value >= 0 && value <= 6;
          },
          set: function (date, _flags, value, options) {
            date = Object(__WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a"
            /* default */
            ])(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]
        },
        // Stand-alone local day of week
        c: {
          priority: 90,
          parse: function (string, token, match, options) {
            var valueCallback = function (value) {
              var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
              return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };

            switch (token) {
              // 3
              case "c":
              case "cc":
                // 03
                return parseNDigits(token.length, string, valueCallback);
              // 3rd

              case "co":
                return match.ordinalNumber(string, {
                  unit: "day",
                  valueCallback: valueCallback
                });
              // Tue

              case "ccc":
                return match.day(string, {
                  width: "abbreviated",
                  context: "standalone"
                }) || match.day(string, {
                  width: "short",
                  context: "standalone"
                }) || match.day(string, {
                  width: "narrow",
                  context: "standalone"
                });
              // T

              case "ccccc":
                return match.day(string, {
                  width: "narrow",
                  context: "standalone"
                });
              // Tu

              case "cccccc":
                return match.day(string, {
                  width: "short",
                  context: "standalone"
                }) || match.day(string, {
                  width: "narrow",
                  context: "standalone"
                });
              // Tuesday

              case "cccc":
              default:
                return match.day(string, {
                  width: "wide",
                  context: "standalone"
                }) || match.day(string, {
                  width: "abbreviated",
                  context: "standalone"
                }) || match.day(string, {
                  width: "short",
                  context: "standalone"
                }) || match.day(string, {
                  width: "narrow",
                  context: "standalone"
                });
            }
          },
          validate: function (_date, value, _options) {
            return value >= 0 && value <= 6;
          },
          set: function (date, _flags, value, options) {
            date = Object(__WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a"
            /* default */
            ])(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]
        },
        // ISO day of week
        i: {
          priority: 90,
          parse: function (string, token, match, _options) {
            var valueCallback = function (value) {
              if (value === 0) {
                return 7;
              }

              return value;
            };

            switch (token) {
              // 2
              case "i":
              case "ii":
                // 02
                return parseNDigits(token.length, string);
              // 2nd

              case "io":
                return match.ordinalNumber(string, {
                  unit: "day"
                });
              // Tue

              case "iii":
                return match.day(string, {
                  width: "abbreviated",
                  context: "formatting",
                  valueCallback: valueCallback
                }) || match.day(string, {
                  width: "short",
                  context: "formatting",
                  valueCallback: valueCallback
                }) || match.day(string, {
                  width: "narrow",
                  context: "formatting",
                  valueCallback: valueCallback
                });
              // T

              case "iiiii":
                return match.day(string, {
                  width: "narrow",
                  context: "formatting",
                  valueCallback: valueCallback
                });
              // Tu

              case "iiiiii":
                return match.day(string, {
                  width: "short",
                  context: "formatting",
                  valueCallback: valueCallback
                }) || match.day(string, {
                  width: "narrow",
                  context: "formatting",
                  valueCallback: valueCallback
                });
              // Tuesday

              case "iiii":
              default:
                return match.day(string, {
                  width: "wide",
                  context: "formatting",
                  valueCallback: valueCallback
                }) || match.day(string, {
                  width: "abbreviated",
                  context: "formatting",
                  valueCallback: valueCallback
                }) || match.day(string, {
                  width: "short",
                  context: "formatting",
                  valueCallback: valueCallback
                }) || match.day(string, {
                  width: "narrow",
                  context: "formatting",
                  valueCallback: valueCallback
                });
            }
          },
          validate: function (_date, value, _options) {
            return value >= 1 && value <= 7;
          },
          set: function (date, _flags, value, options) {
            date = Object(__WEBPACK_IMPORTED_MODULE_2__lib_setUTCISODay_index_js__["a"
            /* default */
            ])(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]
        },
        // AM or PM
        a: {
          priority: 80,
          parse: function (string, token, match, _options) {
            switch (token) {
              case "a":
              case "aa":
              case "aaa":
                return match.dayPeriod(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.dayPeriod(string, {
                  width: "narrow",
                  context: "formatting"
                });

              case "aaaaa":
                return match.dayPeriod(string, {
                  width: "narrow",
                  context: "formatting"
                });

              case "aaaa":
              default:
                return match.dayPeriod(string, {
                  width: "wide",
                  context: "formatting"
                }) || match.dayPeriod(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.dayPeriod(string, {
                  width: "narrow",
                  context: "formatting"
                });
            }
          },
          set: function (date, _flags, value, _options) {
            date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["b", "B", "H", "K", "k", "t", "T"]
        },
        // AM, PM, midnight
        b: {
          priority: 80,
          parse: function (string, token, match, _options) {
            switch (token) {
              case "b":
              case "bb":
              case "bbb":
                return match.dayPeriod(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.dayPeriod(string, {
                  width: "narrow",
                  context: "formatting"
                });

              case "bbbbb":
                return match.dayPeriod(string, {
                  width: "narrow",
                  context: "formatting"
                });

              case "bbbb":
              default:
                return match.dayPeriod(string, {
                  width: "wide",
                  context: "formatting"
                }) || match.dayPeriod(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.dayPeriod(string, {
                  width: "narrow",
                  context: "formatting"
                });
            }
          },
          set: function (date, _flags, value, _options) {
            date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["a", "B", "H", "K", "k", "t", "T"]
        },
        // in the morning, in the afternoon, in the evening, at night
        B: {
          priority: 80,
          parse: function (string, token, match, _options) {
            switch (token) {
              case "B":
              case "BB":
              case "BBB":
                return match.dayPeriod(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.dayPeriod(string, {
                  width: "narrow",
                  context: "formatting"
                });

              case "BBBBB":
                return match.dayPeriod(string, {
                  width: "narrow",
                  context: "formatting"
                });

              case "BBBB":
              default:
                return match.dayPeriod(string, {
                  width: "wide",
                  context: "formatting"
                }) || match.dayPeriod(string, {
                  width: "abbreviated",
                  context: "formatting"
                }) || match.dayPeriod(string, {
                  width: "narrow",
                  context: "formatting"
                });
            }
          },
          set: function (date, _flags, value, _options) {
            date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["a", "b", "t", "T"]
        },
        // Hour [1-12]
        h: {
          priority: 70,
          parse: function (string, token, match, _options) {
            switch (token) {
              case "h":
                return parseNumericPattern(numericPatterns.hour12h, string);

              case "ho":
                return match.ordinalNumber(string, {
                  unit: "hour"
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function (_date, value, _options) {
            return value >= 1 && value <= 12;
          },
          set: function (date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;

            if (isPM && value < 12) {
              date.setUTCHours(value + 12, 0, 0, 0);
            } else if (!isPM && value === 12) {
              date.setUTCHours(0, 0, 0, 0);
            } else {
              date.setUTCHours(value, 0, 0, 0);
            }

            return date;
          },
          incompatibleTokens: ["H", "K", "k", "t", "T"]
        },
        // Hour [0-23]
        H: {
          priority: 70,
          parse: function (string, token, match, _options) {
            switch (token) {
              case "H":
                return parseNumericPattern(numericPatterns.hour23h, string);

              case "Ho":
                return match.ordinalNumber(string, {
                  unit: "hour"
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function (_date, value, _options) {
            return value >= 0 && value <= 23;
          },
          set: function (date, _flags, value, _options) {
            date.setUTCHours(value, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["a", "b", "h", "K", "k", "t", "T"]
        },
        // Hour [0-11]
        K: {
          priority: 70,
          parse: function (string, token, match, _options) {
            switch (token) {
              case "K":
                return parseNumericPattern(numericPatterns.hour11h, string);

              case "Ko":
                return match.ordinalNumber(string, {
                  unit: "hour"
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function (_date, value, _options) {
            return value >= 0 && value <= 11;
          },
          set: function (date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;

            if (isPM && value < 12) {
              date.setUTCHours(value + 12, 0, 0, 0);
            } else {
              date.setUTCHours(value, 0, 0, 0);
            }

            return date;
          },
          incompatibleTokens: ["a", "b", "h", "H", "k", "t", "T"]
        },
        // Hour [1-24]
        k: {
          priority: 70,
          parse: function (string, token, match, _options) {
            switch (token) {
              case "k":
                return parseNumericPattern(numericPatterns.hour24h, string);

              case "ko":
                return match.ordinalNumber(string, {
                  unit: "hour"
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function (_date, value, _options) {
            return value >= 1 && value <= 24;
          },
          set: function (date, _flags, value, _options) {
            var hours = value <= 24 ? value % 24 : value;
            date.setUTCHours(hours, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ["a", "b", "h", "H", "K", "t", "T"]
        },
        // Minute
        m: {
          priority: 60,
          parse: function (string, token, match, _options) {
            switch (token) {
              case "m":
                return parseNumericPattern(numericPatterns.minute, string);

              case "mo":
                return match.ordinalNumber(string, {
                  unit: "minute"
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function (_date, value, _options) {
            return value >= 0 && value <= 59;
          },
          set: function (date, _flags, value, _options) {
            date.setUTCMinutes(value, 0, 0);
            return date;
          },
          incompatibleTokens: ["t", "T"]
        },
        // Second
        s: {
          priority: 50,
          parse: function (string, token, match, _options) {
            switch (token) {
              case "s":
                return parseNumericPattern(numericPatterns.second, string);

              case "so":
                return match.ordinalNumber(string, {
                  unit: "second"
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function (_date, value, _options) {
            return value >= 0 && value <= 59;
          },
          set: function (date, _flags, value, _options) {
            date.setUTCSeconds(value, 0);
            return date;
          },
          incompatibleTokens: ["t", "T"]
        },
        // Fraction of second
        S: {
          priority: 30,
          parse: function (string, token, _match, _options) {
            var valueCallback = function (value) {
              return Math.floor(value * Math.pow(10, -token.length + 3));
            };

            return parseNDigits(token.length, string, valueCallback);
          },
          set: function (date, _flags, value, _options) {
            date.setUTCMilliseconds(value);
            return date;
          },
          incompatibleTokens: ["t", "T"]
        },
        // Timezone (ISO-8601. +00:00 is `'Z'`)
        X: {
          priority: 10,
          parse: function (string, token, _match, _options) {
            switch (token) {
              case "X":
                return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

              case "XX":
                return parseTimezonePattern(timezonePatterns.basic, string);

              case "XXXX":
                return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

              case "XXXXX":
                return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

              case "XXX":
              default:
                return parseTimezonePattern(timezonePatterns.extended, string);
            }
          },
          set: function (date, flags, value, _options) {
            if (flags.timestampIsSet) {
              return date;
            }

            return new Date(date.getTime() - value);
          },
          incompatibleTokens: ["t", "T", "x"]
        },
        // Timezone (ISO-8601)
        x: {
          priority: 10,
          parse: function (string, token, _match, _options) {
            switch (token) {
              case "x":
                return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

              case "xx":
                return parseTimezonePattern(timezonePatterns.basic, string);

              case "xxxx":
                return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

              case "xxxxx":
                return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

              case "xxx":
              default:
                return parseTimezonePattern(timezonePatterns.extended, string);
            }
          },
          set: function (date, flags, value, _options) {
            if (flags.timestampIsSet) {
              return date;
            }

            return new Date(date.getTime() - value);
          },
          incompatibleTokens: ["t", "T", "X"]
        },
        // Seconds timestamp
        t: {
          priority: 40,
          parse: function (string, _token, _match, _options) {
            return parseAnyDigitsSigned(string);
          },
          set: function (_date, _flags, value, _options) {
            return [new Date(value * 1000), {
              timestampIsSet: true
            }];
          },
          incompatibleTokens: "*"
        },
        // Milliseconds timestamp
        T: {
          priority: 20,
          parse: function (string, _token, _match, _options) {
            return parseAnyDigitsSigned(string);
          },
          set: function (_date, _flags, value, _options) {
            return [new Date(value), {
              timestampIsSet: true
            }];
          },
          incompatibleTokens: "*"
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = parsers;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setUTCDay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ])(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
        }

        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var day = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ])(dirtyDay);
        var currentDay = date.getUTCDay();
        var remainder = day % 7;
        var dayIndex = (remainder + 7) % 7;
        var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
        date.setUTCDate(date.getUTCDate() + diff);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setUTCISODay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function setUTCISODay(dirtyDate, dirtyDay) {
        Object(__WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var day = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ])(dirtyDay);

        if (day % 7 === 0) {
          day = day - 7;
        }

        var weekStartsOn = 1;
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var currentDay = date.getUTCDay();
        var remainder = day % 7;
        var dayIndex = (remainder + 7) % 7;
        var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
        date.setUTCDate(date.getUTCDate() + diff);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setUTCISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__getUTCISOWeek_index_js__ = __webpack_require__(97);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
        Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var isoWeek = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ])(dirtyISOWeek);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_2__getUTCISOWeek_index_js__["a"
        /* default */
        ])(date) - isoWeek;
        date.setUTCDate(date.getUTCDate() - diff * 7);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setUTCWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__getUTCWeek_index_js__ = __webpack_require__(99);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function setUTCWeek(dirtyDate, dirtyWeek, options) {
        Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var week = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ])(dirtyWeek);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_2__getUTCWeek_index_js__["a"
        /* default */
        ])(date, options) - week;
        date.setUTCDate(date.getUTCDate() - diff * 7);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isMonday
       * @category Weekday Helpers
       * @summary Is the given date Monday?
       *
       * @description
       * Is the given date Monday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Monday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 22 September 2014 Monday?
       * var result = isMonday(new Date(2014, 8, 22))
       * //=> true
       */


      function isMonday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(date).getDay() === 1;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isPast
       * @category Common Helpers
       * @summary Is the given date in the past?
       * @pure false
       *
       * @description
       * Is the given date in the past?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in the past
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 6 October 2014, is 2 July 2014 in the past?
       * var result = isPast(new Date(2014, 6, 2))
       * //=> true
       */


      function isPast(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate).getTime() < Date.now();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__ = __webpack_require__(29);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameISOWeekYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Are the given dates in the same ISO week-numbering year?
       *
       * @description
       * Are the given dates in the same ISO week-numbering year?
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `isSameISOYear` to `isSameISOWeekYear`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same ISO week-numbering year
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
       * var result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
       * //=> true
       */


      function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var dateLeftStartOfYear = Object(__WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__["a"
        /* default */
        ])(dirtyDateLeft);
        var dateRightStartOfYear = Object(__WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__["a"
        /* default */
        ])(dirtyDateRight);
        return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameHour_index_js__ = __webpack_require__(118);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisHour
       * @category Hour Helpers
       * @summary Is the given date in the same hour as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same hour as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this hour
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If now is 25 September 2014 18:30:15.500,
       * // is 25 September 2014 18:00:00 in this hour?
       * var result = isThisHour(new Date(2014, 8, 25, 18))
       * //=> true
       */


      function isThisHour(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__isSameHour_index_js__["a"
        /* default */
        ])(Date.now(), dirtyDate);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameISOWeek_index_js__ = __webpack_require__(120);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisISOWeek
       * @category ISO Week Helpers
       * @summary Is the given date in the same ISO week as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same ISO week as the current date?
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this ISO week
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
       * var result = isThisISOWeek(new Date(2014, 8, 22))
       * //=> true
       */


      function isThisISOWeek(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__isSameISOWeek_index_js__["a"
        /* default */
        ])(dirtyDate, Date.now());
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameMinute_index_js__ = __webpack_require__(121);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisMinute
       * @category Minute Helpers
       * @summary Is the given date in the same minute as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same minute as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this minute
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If now is 25 September 2014 18:30:15.500,
       * // is 25 September 2014 18:30:00 in this minute?
       * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
       * //=> true
       */


      function isThisMinute(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__isSameMinute_index_js__["a"
        /* default */
        ])(Date.now(), dirtyDate);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameMonth_index_js__ = __webpack_require__(122);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisMonth
       * @category Month Helpers
       * @summary Is the given date in the same month as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same month as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 25 September 2014, is 15 September 2014 in this month?
       * var result = isThisMonth(new Date(2014, 8, 15))
       * //=> true
       */


      function isThisMonth(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__isSameMonth_index_js__["a"
        /* default */
        ])(Date.now(), dirtyDate);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameQuarter_index_js__ = __webpack_require__(123);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisQuarter
       * @category Quarter Helpers
       * @summary Is the given date in the same quarter as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same quarter as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this quarter
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 25 September 2014, is 2 July 2014 in this quarter?
       * var result = isThisQuarter(new Date(2014, 6, 2))
       * //=> true
       */


      function isThisQuarter(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__isSameQuarter_index_js__["a"
        /* default */
        ])(Date.now(), dirtyDate);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameSecond_index_js__ = __webpack_require__(124);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisSecond
       * @category Second Helpers
       * @summary Is the given date in the same second as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same second as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this second
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If now is 25 September 2014 18:30:15.500,
       * // is 25 September 2014 18:30:15.000 in this second?
       * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
       * //=> true
       */


      function isThisSecond(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__isSameSecond_index_js__["a"
        /* default */
        ])(Date.now(), dirtyDate);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__ = __webpack_require__(60);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisWeek
       * @category Week Helpers
       * @summary Is the given date in the same week as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same week as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @param {Object} [options] - the object with options
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Boolean} the date is in this week
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // If today is 25 September 2014, is 21 September 2014 in this week?
       * var result = isThisWeek(new Date(2014, 8, 21))
       * //=> true
       *
       * @example
       * // If today is 25 September 2014 and week starts with Monday
       * // is 21 September 2014 in this week?
       * var result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
       * //=> false
       */


      function isThisWeek(dirtyDate, options) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__["a"
        /* default */
        ])(dirtyDate, Date.now(), options);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameYear_index_js__ = __webpack_require__(126);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisYear
       * @category Year Helpers
       * @summary Is the given date in the same year as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same year as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 25 September 2014, is 2 July 2014 in this year?
       * var result = isThisYear(new Date(2014, 6, 2))
       * //=> true
       */


      function isThisYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__isSameYear_index_js__["a"
        /* default */
        ])(dirtyDate, Date.now());
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThursday
       * @category Weekday Helpers
       * @summary Is the given date Thursday?
       *
       * @description
       * Is the given date Thursday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Thursday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 25 September 2014 Thursday?
       * var result = isThursday(new Date(2014, 8, 25))
       * //=> true
       */


      function isThursday(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate).getDay() === 4;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isToday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameDay_index_js__ = __webpack_require__(30);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isToday
       * @category Day Helpers
       * @summary Is the given date today?
       * @pure false
       *
       * @description
       * Is the given date today?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is today
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 6 October 2014, is 6 October 14:00:00 today?
       * var result = isToday(new Date(2014, 9, 6, 14, 0))
       * //=> true
       */


      function isToday(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__isSameDay_index_js__["a"
        /* default */
        ])(dirtyDate, Date.now());
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(10);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isSameDay_index_js__ = __webpack_require__(30);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isTomorrow
       * @category Day Helpers
       * @summary Is the given date tomorrow?
       * @pure false
       *
       * @description
       * Is the given date tomorrow?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is tomorrow
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
       * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
       * //=> true
       */


      function isTomorrow(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__isSameDay_index_js__["a"
        /* default */
        ])(dirtyDate, Object(__WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a"
        /* default */
        ])(Date.now(), 1));
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isTuesday
       * @category Weekday Helpers
       * @summary Is the given date Tuesday?
       *
       * @description
       * Is the given date Tuesday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Tuesday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 23 September 2014 Tuesday?
       * var result = isTuesday(new Date(2014, 8, 23))
       * //=> true
       */


      function isTuesday(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate).getDay() === 2;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isWednesday
       * @category Weekday Helpers
       * @summary Is the given date Wednesday?
       *
       * @description
       * Is the given date Wednesday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Wednesday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 24 September 2014 Wednesday?
       * const result = isWednesday(new Date(2014, 8, 24))
       * //=> true
       */


      function isWednesday(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate).getDay() === 3;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isWithinInterval;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isWithinInterval
       * @category Interval Helpers
       * @summary Is the given date within the interval?
       *
       * @description
       * Is the given date within the interval? (Including start and end.)
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `isWithinRange` to `isWithinInterval`.
       *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
       *
       *   ```
       *   2.1.3
       *   time interval
       *   part of the time axis limited by two instants
       *   ```
       *
       *   Also, this function now accepts an object with `start` and `end` properties
       *   instead of two arguments as an interval.
       *   This function now throws `RangeError` if the start of the interval is after its end
       *   or if any date in the interval is `Invalid Date`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   isWithinRange(
       *     new Date(2014, 0, 3),
       *     new Date(2014, 0, 1), new Date(2014, 0, 7)
       *   )
       *
       *   // v2.0.0 onward
       *
       *   isWithinInterval(
       *     new Date(2014, 0, 3),
       *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
       *   )
       *   ```
       *
       * @param {Date|Number} date - the date to check
       * @param {Interval} interval - the interval to check
       * @returns {Boolean} the date is within the interval
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // For the date within the interval:
       * isWithinInterval(new Date(2014, 0, 3), {
       *   start: new Date(2014, 0, 1),
       *   end: new Date(2014, 0, 7)
       * })
       * //=> true
       *
       * @example
       * // For the date outside of the interval:
       * isWithinInterval(new Date(2014, 0, 10), {
       *   start: new Date(2014, 0, 1),
       *   end: new Date(2014, 0, 7)
       * })
       * //=> false
       *
       * @example
       * // For date equal to interval start:
       * isWithinInterval(date, { start, end: date }) // => true
       *
       * @example
       * // For date equal to interval end:
       * isWithinInterval(date, { start: date, end }) // => true
       */


      function isWithinInterval(dirtyDate, interval) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var time = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate).getTime();
        var startTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(interval.start).getTime();
        var endTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(startTime <= endTime)) {
          throw new RangeError("Invalid interval");
        }

        return time >= startTime && time <= endTime;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameDay_index_js__ = __webpack_require__(30);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__subDays_index_js__ = __webpack_require__(43);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isYesterday
       * @category Day Helpers
       * @summary Is the given date yesterday?
       * @pure false
       *
       * @description
       * Is the given date yesterday?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is yesterday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
       * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
       * //=> true
       */


      function isYesterday(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__isSameDay_index_js__["a"
        /* default */
        ])(dirtyDate, Object(__WEBPACK_IMPORTED_MODULE_1__subDays_index_js__["a"
        /* default */
        ])(Date.now(), 1));
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfDecade
       * @category Decade Helpers
       * @summary Return the last day of a decade for the given date.
       *
       * @description
       * Return the last day of a decade for the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the last day of a decade
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The last day of a decade for 21 December 2012 21:12:00:
       * var result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
       * //=> Wed Dec 31 2019 00:00:00
       */


      function lastDayOfDecade(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var year = date.getFullYear();
        var decade = 9 + Math.floor(year / 10) * 10;
        date.setFullYear(decade + 1, 0, 0);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lastDayOfWeek_index_js__ = __webpack_require__(127);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfISOWeek
       * @category ISO Week Helpers
       * @summary Return the last day of an ISO week for the given date.
       *
       * @description
       * Return the last day of an ISO week for the given date.
       * The result will be in the local timezone.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the last day of an ISO week
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The last day of an ISO week for 2 September 2014 11:55:00:
       * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Sun Sep 07 2014 00:00:00
       */


      function lastDayOfISOWeek(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_0__lastDayOfWeek_index_js__["a"
        /* default */
        ])(dirtyDate, {
          weekStartsOn: 1
        });
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__ = __webpack_require__(23);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfISOWeekYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Return the last day of an ISO week-numbering year for the given date.
       *
       * @description
       * Return the last day of an ISO week-numbering year,
       * which always starts 3 days before the year's first Thursday.
       * The result will be in the local timezone.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `lastDayOfISOYear` to `lastDayOfISOWeekYear`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of an ISO week-numbering year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The last day of an ISO week-numbering year for 2 July 2005:
       * var result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
       * //=> Sun Jan 01 2006 00:00:00
       */


      function lastDayOfISOWeekYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var year = Object(__WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a"
        /* default */
        ])(dirtyDate);
        var fourthOfJanuary = new Date(0);
        fourthOfJanuary.setFullYear(year + 1, 0, 4);
        fourthOfJanuary.setHours(0, 0, 0, 0);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ])(fourthOfJanuary);
        date.setDate(date.getDate() - 1);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfQuarter
       * @category Quarter Helpers
       * @summary Return the last day of a year quarter for the given date.
       *
       * @description
       * Return the last day of a year quarter for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
       * @returns {Date} the last day of a quarter
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
       *
       * @example
       * // The last day of a quarter for 2 September 2014 11:55:00:
       * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Sep 30 2014 00:00:00
       */


      function lastDayOfQuarter(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var currentMonth = date.getMonth();
        var month = currentMonth - currentMonth % 3 + 3;
        date.setMonth(month, 0);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfYear
       * @category Year Helpers
       * @summary Return the last day of a year for the given date.
       *
       * @description
       * Return the last day of a year for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the last day of a year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The last day of a year for 2 September 2014 11:55:00:
       * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
       * //=> Wed Dec 31 2014 00:00:00
       */


      function lastDayOfYear(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var year = date.getFullYear();
        date.setFullYear(year + 1, 0, 0);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_format_lightFormatters_index_js__ = __webpack_require__(96);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(11);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__isValid_index_js__ = __webpack_require__(9);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__subMilliseconds_index_js__ = __webpack_require__(32);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_requiredArgs_index_js__ = __webpack_require__(0); // This RegExp consists of three parts separated by `|`:
      // - (\w)\1* matches any sequences of the same letter
      // - '' matches two quote characters in a row
      // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
      //   except a single quote symbol, which ends the sequence.
      //   Two quote characters do not end the sequence.
      //   If there is no matching single quote
      //   then the sequence will continue until the end of the string.
      // - . matches any single character unmatched by previous parts of the RegExps


      var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
      var escapedStringRegExp = /^'([^]*?)'?$/;
      var doubleQuoteRegExp = /''/g;
      var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
      /**
       * @name lightFormat
       * @category Common Helpers
       * @summary Format the date.
       *
       * @description
       * Return the formatted date string in the given format. Unlike `format`,
       * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
       *
       * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
       * > See: https://git.io/fxCyr
       *
       * The characters wrapped between two single quotes characters (') are escaped.
       * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
       *
       * Format of the string is based on Unicode Technical Standard #35:
       * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
       *
       * Accepted patterns:
       * | Unit                            | Pattern | Result examples                   |
       * |---------------------------------|---------|-----------------------------------|
       * | AM, PM                          | a..aaa  | AM, PM                            |
       * |                                 | aaaa    | a.m., p.m.                        |
       * |                                 | aaaaa   | a, p                              |
       * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
       * |                                 | yy      | 44, 01, 00, 17                    |
       * |                                 | yyy     | 044, 001, 000, 017                |
       * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
       * | Month (formatting)              | M       | 1, 2, ..., 12                     |
       * |                                 | MM      | 01, 02, ..., 12                   |
       * | Day of month                    | d       | 1, 2, ..., 31                     |
       * |                                 | dd      | 01, 02, ..., 31                   |
       * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
       * |                                 | hh      | 01, 02, ..., 11, 12               |
       * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
       * |                                 | HH      | 00, 01, 02, ..., 23               |
       * | Minute                          | m       | 0, 1, ..., 59                     |
       * |                                 | mm      | 00, 01, ..., 59                   |
       * | Second                          | s       | 0, 1, ..., 59                     |
       * |                                 | ss      | 00, 01, ..., 59                   |
       * | Fraction of second              | S       | 0, 1, ..., 9                      |
       * |                                 | SS      | 00, 01, ..., 99                   |
       * |                                 | SSS     | 000, 0001, ..., 999               |
       * |                                 | SSSS    | ...                               |
       *
       * @param {Date|Number} date - the original date
       * @param {String} format - the string of tokens
       * @returns {String} the formatted date string
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} format string contains an unescaped latin alphabet character
       *
       * @example
       * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
       * //=> '2014-02-11'
       */

      function lightFormat(dirtyDate, formatStr) {
        Object(__WEBPACK_IMPORTED_MODULE_5__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var originalDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);

        if (!Object(__WEBPACK_IMPORTED_MODULE_3__isValid_index_js__["a"
        /* default */
        ])(originalDate)) {
          throw new RangeError("Invalid time value");
        } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
        // This ensures that when UTC functions will be implemented, locales will be compatible with them.
        // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


        var timezoneOffset = Object(__WEBPACK_IMPORTED_MODULE_2__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ])(originalDate);
        var utcDate = Object(__WEBPACK_IMPORTED_MODULE_4__subMilliseconds_index_js__["a"
        /* default */
        ])(originalDate, timezoneOffset);
        var tokens = formatStr.match(formattingTokensRegExp); // The only case when formattingTokensRegExp doesn't match the string is when it's empty

        if (!tokens) return "";
        var result = tokens.map(function (substring) {
          // Replace two single quote characters with one single quote character
          if (substring === "''") {
            return "'";
          }

          var firstCharacter = substring[0];

          if (firstCharacter === "'") {
            return cleanEscapedString(substring);
          }

          var formatter = __WEBPACK_IMPORTED_MODULE_1__lib_format_lightFormatters_index_js__["a"
          /* default */
          ][firstCharacter];

          if (formatter) {
            return formatter(utcDate, substring);
          }

          if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
            throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
          }

          return substring;
        }).join("");
        return result;
      }

      function cleanEscapedString(input) {
        var matches = input.match(escapedStringRegExp);

        if (!matches) {
          return input;
        }

        return matches[1].replace(doubleQuoteRegExp, "'");
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0); // Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
      // 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days


      var daysInYear = 365.2425;
      /**
       * @name milliseconds
       * @category Millisecond Helpers
       * @summary
       * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
       *
       * @description
       * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
       *
       * One years equals 365.2425 days according to the formula:
       *
       * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
       * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
       *
       * One month is a year divided by 12.
       *
       * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {number} the milliseconds
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // 1 year in milliseconds
       * milliseconds({ years: 1 })
       * //=> 31556952000
       *
       * // 3 months in milliseconds
       * milliseconds({ months: 3 })
       * //=> 7889238000
       */

      function milliseconds(_ref) {
        var years = _ref.years,
            months = _ref.months,
            weeks = _ref.weeks,
            days = _ref.days,
            hours = _ref.hours,
            minutes = _ref.minutes,
            seconds = _ref.seconds;
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var totalDays = 0;
        if (years) totalDays += years * daysInYear;
        if (months) totalDays += months * (daysInYear / 12);
        if (weeks) totalDays += weeks * 7;
        if (days) totalDays += days;
        var totalSeconds = totalDays * 24 * 60 * 60;
        if (hours) totalSeconds += hours * 60 * 60;
        if (minutes) totalSeconds += minutes * 60;
        if (seconds) totalSeconds += seconds;
        return Math.round(totalSeconds * 1000);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name millisecondsToHours
       * @category Conversion Helpers
       * @summary Convert milliseconds to hours.
       *
       * @description
       * Convert a number of milliseconds to a full number of hours.
       *
       * @param {number} milliseconds - number of milliseconds to be converted
       *
       * @returns {number} the number of milliseconds converted in hours
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 7200000 milliseconds to hours:
       * const result = millisecondsToHours(7200000)
       * //=> 2
       *
       * @example
       * // It uses floor rounding:
       * const result = millisecondsToHours(7199999)
       * //=> 1
       */


      function millisecondsToHours(milliseconds) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var hours = milliseconds / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["b"
        /* millisecondsInHour */
        ];
        return Math.floor(hours);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name millisecondsToMinutes
       * @category Conversion Helpers
       * @summary Convert milliseconds to minutes.
       *
       * @description
       * Convert a number of milliseconds to a full number of minutes.
       *
       * @param {number} milliseconds - number of milliseconds to be converted.
       *
       * @returns {number} the number of milliseconds converted in minutes
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 60000 milliseconds to minutes:
       * const result = millisecondsToMinutes(60000)
       * //=> 1
       *
       * @example
       * // It uses floor rounding:
       * const result = millisecondsToMinutes(119999)
       * //=> 1
       */


      function millisecondsToMinutes(milliseconds) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var minutes = milliseconds / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["c"
        /* millisecondsInMinute */
        ];
        return Math.floor(minutes);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name millisecondsToSeconds
       * @category Conversion Helpers
       * @summary Convert milliseconds to seconds.
       *
       * @description
       * Convert a number of milliseconds to a full number of seconds.
       *
       * @param {number} milliseconds - number of milliseconds to be converted
       *
       * @returns {number} the number of milliseconds converted in seconds
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 1000 miliseconds to seconds:
       * const result = millisecondsToSeconds(1000)
       * //=> 1
       *
       * @example
       * // It uses floor rounding:
       * const result = millisecondsToSeconds(1999)
       * //=> 1
       */


      function millisecondsToSeconds(milliseconds) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var seconds = milliseconds / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["d"
        /* millisecondsInSecond */
        ];
        return Math.floor(seconds);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name minutesToHours
       * @category Conversion Helpers
       * @summary Convert minutes to hours.
       *
       * @description
       * Convert a number of minutes to a full number of hours.
       *
       * @param {number} minutes - number of minutes to be converted
       *
       * @returns {number} the number of minutes converted in hours
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 140 minutes to hours:
       * const result = minutesToHours(120)
       * //=> 2
       *
       * @example
       * // It uses floor rounding:
       * const result = minutesToHours(179)
       * //=> 2
       */


      function minutesToHours(minutes) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var hours = minutes / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["e"
        /* minutesInHour */
        ];
        return Math.floor(hours);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name minutesToMilliseconds
       * @category Conversion Helpers
       * @summary Convert minutes to milliseconds.
       *
       * @description
       * Convert a number of minutes to a full number of milliseconds.
       *
       * @param {number} minutes - number of minutes to be converted
       *
       * @returns {number} the number of minutes converted in milliseconds
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 2 minutes to milliseconds
       * const result = minutesToMilliseconds(2)
       * //=> 120000
       */


      function minutesToMilliseconds(minutes) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Math.floor(minutes * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["c"
        /* millisecondsInMinute */
        ]);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name minutesToSeconds
       * @category Conversion Helpers
       * @summary Convert minutes to seconds.
       *
       * @description
       * Convert a number of minutes to a full number of seconds.
       *
       * @param { number } minutes - number of minutes to be converted
       *
       * @returns {number} the number of minutes converted in seconds
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 2 minutes to seconds
       * const result = minutesToSeconds(2)
       * //=> 120
       */


      function minutesToSeconds(minutes) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Math.floor(minutes * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["j"
        /* secondsInMinute */
        ]);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name monthsToQuarters
       * @category Conversion Helpers
       * @summary Convert number of months to quarters.
       *
       * @description
       * Convert a number of months to a full number of quarters.
       *
       * @param {number} months - number of months to be converted.
       *
       * @returns {number} the number of months converted in quarters
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 6 months to quarters:
       * const result = monthsToQuarters(6)
       * //=> 2
       *
       * @example
       * // It uses floor rounding:
       * const result = monthsToQuarters(7)
       * //=> 2
       */


      function monthsToQuarters(months) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var quarters = months / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["f"
        /* monthsInQuarter */
        ];
        return Math.floor(quarters);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name monthsToYears
       * @category Conversion Helpers
       * @summary Convert number of months to years.
       *
       * @description
       * Convert a number of months to a full number of years.
       *
       * @param {number} months - number of months to be converted
       *
       * @returns {number} the number of months converted in years
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 36 months to years:
       * const result = monthsToYears(36)
       * //=> 3
       *
       * // It uses floor rounding:
       * const result = monthsToYears(40)
       * //=> 3
       */


      function monthsToYears(months) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var years = months / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["g"
        /* monthsInYear */
        ];
        return Math.floor(years);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__ = __webpack_require__(13);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /**
       * @name nextFriday
       * @category Weekday Helpers
       * @summary When is the next Friday?
       *
       * @description
       * When is the next Friday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the next Friday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the next Friday after Mar, 22, 2020?
       * const result = nextFriday(new Date(2020, 2, 22))
       * //=> Fri Mar 27 2020 00:00:00
       */


      function nextFriday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__["a"
        /* default */
        ])(Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(date), 5);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__ = __webpack_require__(13);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /**
       * @name nextMonday
       * @category Weekday Helpers
       * @summary When is the next Monday?
       *
       * @description
       * When is the next Monday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the next Monday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the next Monday after Mar, 22, 2020?
       * const result = nextMonday(new Date(2020, 2, 22))
       * //=> Mon Mar 23 2020 00:00:00
       */


      function nextMonday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__["a"
        /* default */
        ])(Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(date), 1);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__ = __webpack_require__(13);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /**
       * @name nextSaturday
       * @category Weekday Helpers
       * @summary When is the next Saturday?
       *
       * @description
       * When is the next Saturday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the next Saturday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the next Saturday after Mar, 22, 2020?
       * const result = nextSaturday(new Date(2020, 2, 22))
       * //=> Sat Mar 28 2020 00:00:00
       */


      function nextSaturday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__["a"
        /* default */
        ])(Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(date), 6);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__ = __webpack_require__(13);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /**
       * @name nextSunday
       * @category Weekday Helpers
       * @summary When is the next Sunday?
       *
       * @description
       * When is the next Sunday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the next Sunday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the next Sunday after Mar, 22, 2020?
       * const result = nextSunday(new Date(2020, 2, 22))
       * //=> Sun Mar 29 2020 00:00:00
       */


      function nextSunday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__["a"
        /* default */
        ])(Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(date), 0);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__ = __webpack_require__(13);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /**
       * @name nextThursday
       * @category Weekday Helpers
       * @summary When is the next Thursday?
       *
       * @description
       * When is the next Thursday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the next Thursday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the next Thursday after Mar, 22, 2020?
       * const result = nextThursday(new Date(2020, 2, 22))
       * //=> Thur Mar 26 2020 00:00:00
       */


      function nextThursday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__["a"
        /* default */
        ])(Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(date), 4);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__ = __webpack_require__(13);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /**
       * @name nextTuesday
       * @category Weekday Helpers
       * @summary When is the next Tuesday?
       *
       * @description
       * When is the next Tuesday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the next Tuesday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the next Tuesday after Mar, 22, 2020?
       * const result = nextTuesday(new Date(2020, 2, 22))
       * //=> Tue Mar 24 2020 00:00:00
       */


      function nextTuesday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__["a"
        /* default */
        ])(Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(date), 2);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__ = __webpack_require__(13);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /**
       * @name nextWednesday
       * @category Weekday Helpers
       * @summary When is the next Wednesday?
       *
       * @description
       * When is the next Wednesday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the next Wednesday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the next Wednesday after Mar, 22, 2020?
       * const result = nextWednesday(new Date(2020, 2, 22))
       * //=> Wed Mar 25 2020 00:00:00
       */


      function nextWednesday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__nextDay_index_js__["a"
        /* default */
        ])(Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(date), 3);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_HOUR = 3600000;
      var MILLISECONDS_IN_MINUTE = 60000;
      var DEFAULT_ADDITIONAL_DIGITS = 2;
      var patterns = {
        dateTimeDelimiter: /[T ]/,
        timeZoneDelimiter: /[Z ]/i,
        timezone: /([Z+-].*)$/
      };
      var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
      var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
      var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
      /**
       * @name parseISO
       * @category Common Helpers
       * @summary Parse ISO string
       *
       * @description
       * Parse the given string in ISO 8601 format and return an instance of Date.
       *
       * Function accepts complete ISO 8601 formats as well as partial implementations.
       * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
       *
       * If the argument isn't a string, the function cannot parse the string or
       * the values are invalid, it returns Invalid Date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The previous `parse` implementation was renamed to `parseISO`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *   parse('2016-01-01')
       *
       *   // v2.0.0 onward
       *   parseISO('2016-01-01')
       *   ```
       *
       * - `parseISO` now validates separate date and time values in ISO-8601 strings
       *   and returns `Invalid Date` if the date is invalid.
       *
       *   ```javascript
       *   parseISO('2018-13-32')
       *   //=> Invalid Date
       *   ```
       *
       * - `parseISO` now doesn't fall back to `new Date` constructor
       *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
       *
       * @param {String} argument - the value to convert
       * @param {Object} [options] - an object with options.
       * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
       * @returns {Date} the parsed date in the local time zone
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
       *
       * @example
       * // Convert string '2014-02-11T11:30:30' to date:
       * var result = parseISO('2014-02-11T11:30:30')
       * //=> Tue Feb 11 2014 11:30:30
       *
       * @example
       * // Convert string '+02014101' to date,
       * // if the additional number of digits in the extended year format is 1:
       * var result = parseISO('+02014101', { additionalDigits: 1 })
       * //=> Fri Apr 11 2014 00:00:00
       */

      function parseISO(argument, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var options = dirtyOptions || {};
        var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(options.additionalDigits);

        if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
          throw new RangeError("additionalDigits must be 0, 1 or 2");
        }

        if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) {
          return new Date(NaN);
        }

        var dateStrings = splitDateString(argument);
        var date;

        if (dateStrings.date) {
          var parseYearResult = parseYear(dateStrings.date, additionalDigits);
          date = parseDate(parseYearResult.restDateString, parseYearResult.year);
        }

        if (isNaN(date) || !date) {
          return new Date(NaN);
        }

        var timestamp = date.getTime();
        var time = 0;
        var offset;

        if (dateStrings.time) {
          time = parseTime(dateStrings.time);

          if (isNaN(time) || time === null) {
            return new Date(NaN);
          }
        }

        if (dateStrings.timezone) {
          offset = parseTimezone(dateStrings.timezone);

          if (isNaN(offset)) {
            return new Date(NaN);
          }
        } else {
          var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
          // but we need it to be parsed in our timezone
          // so we use utc values to build date in our timezone.
          // Year values from 0 to 99 map to the years 1900 to 1999
          // so set year explicitly with setFullYear.

          var result = new Date(0);
          result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
          result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
          return result;
        }

        return new Date(timestamp + time + offset);
      }

      function splitDateString(dateString) {
        var dateStrings = {};
        var array = dateString.split(patterns.dateTimeDelimiter);
        var timeString; // The regex match should only return at maximum two array elements.
        // [date], [time], or [date, time].

        if (array.length > 2) {
          return dateStrings;
        }

        if (/:/.test(array[0])) {
          dateStrings.date = null;
          timeString = array[0];
        } else {
          dateStrings.date = array[0];
          timeString = array[1];

          if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
          }
        }

        if (timeString) {
          var token = patterns.timezone.exec(timeString);

          if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
          } else {
            dateStrings.time = timeString;
          }
        }

        return dateStrings;
      }

      function parseYear(dateString, additionalDigits) {
        var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
        var captures = dateString.match(regex); // Invalid ISO-formatted year

        if (!captures) return {
          year: null
        };
        var year = captures[1] && parseInt(captures[1]);
        var century = captures[2] && parseInt(captures[2]);
        return {
          year: century == null ? year : century * 100,
          restDateString: dateString.slice((captures[1] || captures[2]).length)
        };
      }

      function parseDate(dateString, year) {
        // Invalid ISO-formatted year
        if (year === null) return null;
        var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

        if (!captures) return null;
        var isWeekDate = !!captures[4];
        var dayOfYear = parseDateUnit(captures[1]);
        var month = parseDateUnit(captures[2]) - 1;
        var day = parseDateUnit(captures[3]);
        var week = parseDateUnit(captures[4]);
        var dayOfWeek = parseDateUnit(captures[5]) - 1;

        if (isWeekDate) {
          if (!validateWeekDate(year, week, dayOfWeek)) {
            return new Date(NaN);
          }

          return dayOfISOWeekYear(year, week, dayOfWeek);
        } else {
          var date = new Date(0);

          if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
            return new Date(NaN);
          }

          date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
          return date;
        }
      }

      function parseDateUnit(value) {
        return value ? parseInt(value) : 1;
      }

      function parseTime(timeString) {
        var captures = timeString.match(timeRegex);
        if (!captures) return null; // Invalid ISO-formatted time

        var hours = parseTimeUnit(captures[1]);
        var minutes = parseTimeUnit(captures[2]);
        var seconds = parseTimeUnit(captures[3]);

        if (!validateTime(hours, minutes, seconds)) {
          return NaN;
        }

        return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
      }

      function parseTimeUnit(value) {
        return value && parseFloat(value.replace(",", ".")) || 0;
      }

      function parseTimezone(timezoneString) {
        if (timezoneString === "Z") return 0;
        var captures = timezoneString.match(timezoneRegex);
        if (!captures) return 0;
        var sign = captures[1] === "+" ? -1 : 1;
        var hours = parseInt(captures[2]);
        var minutes = captures[3] && parseInt(captures[3]) || 0;

        if (!validateTimezone(hours, minutes)) {
          return NaN;
        }

        return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
      }

      function dayOfISOWeekYear(isoWeekYear, week, day) {
        var date = new Date(0);
        date.setUTCFullYear(isoWeekYear, 0, 4);
        var fourthOfJanuaryDay = date.getUTCDay() || 7;
        var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
        date.setUTCDate(date.getUTCDate() + diff);
        return date;
      } // Validation functions
      // February is null to handle the leap year (using ||)


      var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      function isLeapYearIndex(year) {
        return year % 400 === 0 || year % 4 === 0 && year % 100;
      }

      function validateDate(year, month, date) {
        return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
      }

      function validateDayOfYearDate(year, dayOfYear) {
        return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
      }

      function validateWeekDate(_year, week, day) {
        return week >= 1 && week <= 53 && day >= 0 && day <= 6;
      }

      function validateTime(hours, minutes, seconds) {
        if (hours === 24) {
          return minutes === 0 && seconds === 0;
        }

        return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
      }

      function validateTimezone(_hours, minutes) {
        return minutes >= 0 && minutes <= 59;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name parseJSON
       * @category Common Helpers
       * @summary Parse a JSON date string
       *
       * @description
       * Converts a complete ISO date string in UTC time, the typical format for transmitting
       * a date in JSON, to a JavaScript `Date` instance.
       *
       * This is a minimal implementation for converting dates retrieved from a JSON API to
       * a `Date` instance which can be used with other functions in the `date-fns` library.
       * The following formats are supported:
       *
       * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
       * - `2000-03-15T05:20:10Z`: Without milliseconds
       * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
       * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
       * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
       * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
       * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
       * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
       *
       * For convenience and ease of use these other input types are also supported
       * via [toDate]{@link https://date-fns.org/docs/toDate}:
       *
       * - A `Date` instance will be cloned
       * - A `number` will be treated as a timestamp
       *
       * Any other input type or invalid date strings will return an `Invalid Date`.
       *
       * @param {String|Number|Date} argument A fully formed ISO8601 date string to convert
       * @returns {Date} the parsed date in the local time zone
       * @throws {TypeError} 1 argument required
       */


      function parseJSON(argument) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);

        if (typeof argument === "string") {
          var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);

          if (parts) {
            // Group 8 matches the sign
            return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
          }

          return new Date(NaN);
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(argument);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(14);
      /**
       * @name previousFriday
       * @category Weekday Helpers
       * @summary When is the previous Friday?
       *
       * @description
       * When is the previous Friday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the previous Friday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the previous Friday before Jun, 19, 2021?
       * const result = previousFriday(new Date(2021, 5, 19))
       * //=> Fri June 18 2021 00:00:00
       */


      function previousFriday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a"
        /* default */
        ])(date, 5);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(14);
      /**
       * @name previousMonday
       * @category Weekday Helpers
       * @summary When is the previous Monday?
       *
       * @description
       * When is the previous Monday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the previous Monday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the previous Monday before Jun, 18, 2021?
       * const result = previousMonday(new Date(2021, 5, 18))
       * //=> Mon June 14 2021 00:00:00
       */


      function previousMonday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a"
        /* default */
        ])(date, 1);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(14);
      /**
       * @name previousSaturday
       * @category Weekday Helpers
       * @summary When is the previous Saturday?
       *
       * @description
       * When is the previous Saturday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the previous Saturday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the previous Saturday before Jun, 20, 2021?
       * const result = previousSaturday(new Date(2021, 5, 20))
       * //=> Sat June 19 2021 00:00:00
       */


      function previousSaturday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a"
        /* default */
        ])(date, 6);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(14);
      /**
       * @name previousSunday
       * @category Weekday Helpers
       * @summary When is the previous Sunday?
       *
       * @description
       * When is the previous Sunday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the previous Sunday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the previous Sunday before Jun, 21, 2021?
       * const result = previousSunday(new Date(2021, 5, 21))
       * //=> Sun June 20 2021 00:00:00
       */


      function previousSunday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a"
        /* default */
        ])(date, 0);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(14);
      /**
       * @name previousThursday
       * @category Weekday Helpers
       * @summary When is the previous Thursday?
       *
       * @description
       * When is the previous Thursday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the previous Thursday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the previous Thursday before Jun, 18, 2021?
       * const result = previousThursday(new Date(2021, 5, 18))
       * //=> Thu June 17 2021 00:00:00
       */


      function previousThursday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a"
        /* default */
        ])(date, 4);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(14);
      /**
       * @name previousTuesday
       * @category Weekday Helpers
       * @summary When is the previous Tuesday?
       *
       * @description
       * When is the previous Tuesday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the previous Tuesday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the previous Tuesday before Jun, 18, 2021?
       * const result = previousTuesday(new Date(2021, 5, 18))
       * //=> Tue June 15 2021 00:00:00
       */


      function previousTuesday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a"
        /* default */
        ])(date, 2);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(14);
      /**
       * @name previousWednesday
       * @category Weekday Helpers
       * @summary When is the previous Wednesday?
       *
       * @description
       * When is the previous Wednesday?
       *
       * @param {Date | number} date - the date to start counting from
       * @returns {Date} the previous Wednesday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // When is the previous Wednesday before Jun, 18, 2021?
       * const result = previousWednesday(new Date(2021, 5, 18))
       * //=> Wed June 16 2021 00:00:00
       */


      function previousWednesday(date) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a"
        /* default */
        ])(date, 3);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name quartersToMonths
       * @category Conversion Helpers
       * @summary Convert number of quarters to months.
       *
       * @description
       * Convert a number of quarters to a full number of months.
       *
       * @param {number} quarters - number of quarters to be converted
       *
       * @returns {number} the number of quarters converted in months
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 2 quarters to months
       * const result = quartersToMonths(2)
       * //=> 6
       */


      function quartersToMonths(quarters) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Math.floor(quarters * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["f"
        /* monthsInQuarter */
        ]);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name quartersToYears
       * @category Conversion Helpers
       * @summary Convert number of quarters to years.
       *
       * @description
       * Convert a number of quarters to a full number of years.
       *
       * @param {number} quarters - number of quarters to be converted
       *
       * @returns {number} the number of quarters converted in years
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 8 quarters to years
       * const result = quartersToYears(8)
       * //=> 2
       *
       * @example
       * // It uses floor rounding:
       * const result = quartersToYears(11)
       * //=> 2
       */


      function quartersToYears(quarters) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var years = quarters / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["h"
        /* quartersInYear */
        ];
        return Math.floor(years);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(6);
      /**
       * @name roundToNearestMinutes
       * @category Minute Helpers
       * @summary Rounds the given date to the nearest minute
       *
       * @description
       * Rounds the given date to the nearest minute (or number of minutes).
       * Rounds up when the given date is exactly between the nearest round minutes.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to round
       * @param {Object} [options] - an object with options.
       * @param {Number} [options.nearestTo=1] - nearest number of minutes to round to. E.g. `15` to round to quarter hours.
       * @returns {Date} the new date rounded to the closest minute
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.nearestTo` must be between 1 and 30
       *
       * @example
       * // Round 10 July 2014 12:12:34 to nearest minute:
       * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
       * //=> Thu Jul 10 2014 12:13:00
       *
       * @example
       * // Round 10 July 2014 12:07:30 to nearest quarter hour:
       * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
       * // rounds up because given date is exactly between 12:00:00 and 12:15:00
       * //=> Thu Jul 10 2014 12:15:00
       */


      function roundToNearestMinutes(dirtyDate, options) {
        if (arguments.length < 1) {
          throw new TypeError("1 argument required, but only none provided present");
        }

        var nearestTo = options && "nearestTo" in options ? Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ])(options.nearestTo) : 1;

        if (nearestTo < 1 || nearestTo > 30) {
          throw new RangeError("`options.nearestTo` must be between 1 and 30");
        }

        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case

        var minutes = date.getMinutes() + seconds / 60;
        var roundedMinutes = Math.floor(minutes / nearestTo) * nearestTo;
        var remainderMinutes = minutes % nearestTo;
        var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name secondsToHours
       * @category Conversion Helpers
       * @summary Convert seconds to hours.
       *
       * @description
       * Convert a number of seconds to a full number of hours.
       *
       * @param {number} seconds - number of seconds to be converted
       *
       * @returns {number} the number of seconds converted in hours
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 7200 seconds into hours
       * const result = secondsToHours(7200)
       * //=> 2
       *
       * @example
       * // It uses floor rounding:
       * const result = secondsToHours(7199)
       * //=> 1
       */


      function secondsToHours(seconds) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var hours = seconds / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["i"
        /* secondsInHour */
        ];
        return Math.floor(hours);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name secondsToMilliseconds
       * @category Conversion Helpers
       * @summary Convert seconds to milliseconds.
       *
       * @description
       * Convert a number of seconds to a full number of milliseconds.
       *
       * @param {number} seconds - number of seconds to be converted
       *
       * @returns {number} the number of seconds converted in milliseconds
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 2 seconds into milliseconds
       * const result = secondsToMilliseconds(2)
       * //=> 2000
       */


      function secondsToMilliseconds(seconds) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return seconds * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["d"
        /* millisecondsInSecond */
        ];
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name secondsToMinutes
       * @category Conversion Helpers
       * @summary Convert seconds to minutes.
       *
       * @description
       * Convert a number of seconds to a full number of minutes.
       *
       * @param {number} seconds - number of seconds to be converted
       *
       * @returns {number} the number of seconds converted in minutes
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 120 seconds into minutes
       * const result = secondsToMinutes(120)
       * //=> 2
       *
       * @example
       * // It uses floor rounding:
       * const result = secondsToMinutes(119)
       * //=> 1
       */


      function secondsToMinutes(seconds) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var minutes = seconds / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["j"
        /* secondsInMinute */
        ];
        return Math.floor(minutes);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__setMonth_index_js__ = __webpack_require__(61);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name set
       * @category Common Helpers
       * @summary Set date values to a given date.
       *
       * @description
       * Set date values to a given date.
       *
       * Sets time values to date from object `values`.
       * A value is not set if it is undefined or null or doesn't exist in `values`.
       *
       * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
       * to use native `Date#setX` methods. If you use this function, you may not want to include the
       * other `setX` functions that date-fns provides if you are concerned about the bundle size.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Object} values - an object with options
       * @param {Number} [values.year] - the number of years to be set
       * @param {Number} [values.month] - the number of months to be set
       * @param {Number} [values.date] - the number of days to be set
       * @param {Number} [values.hours] - the number of hours to be set
       * @param {Number} [values.minutes] - the number of minutes to be set
       * @param {Number} [values.seconds] - the number of seconds to be set
       * @param {Number} [values.milliseconds] - the number of milliseconds to be set
       * @returns {Date} the new date with options set
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `values` must be an object
       *
       * @example
       * // Transform 1 September 2014 into 20 October 2015 in a single line:
       * var result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
       * //=> Tue Oct 20 2015 00:00:00
       *
       * @example
       * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
       * var result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
       * //=> Mon Sep 01 2014 12:23:45
       */


      function set(dirtyDate, values) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);

        if (typeof values !== "object" || values === null) {
          throw new RangeError("values parameter must be an object");
        }

        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

        if (isNaN(date.getTime())) {
          return new Date(NaN);
        }

        if (values.year != null) {
          date.setFullYear(values.year);
        }

        if (values.month != null) {
          date = Object(__WEBPACK_IMPORTED_MODULE_1__setMonth_index_js__["a"
          /* default */
          ])(date, values.month);
        }

        if (values.date != null) {
          date.setDate(Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
          /* default */
          ])(values.date));
        }

        if (values.hours != null) {
          date.setHours(Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
          /* default */
          ])(values.hours));
        }

        if (values.minutes != null) {
          date.setMinutes(Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
          /* default */
          ])(values.minutes));
        }

        if (values.seconds != null) {
          date.setSeconds(Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
          /* default */
          ])(values.seconds));
        }

        if (values.milliseconds != null) {
          date.setMilliseconds(Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
          /* default */
          ])(values.milliseconds));
        }

        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setDate;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setDate
       * @category Day Helpers
       * @summary Set the day of the month to the given date.
       *
       * @description
       * Set the day of the month to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} dayOfMonth - the day of the month of the new date
       * @returns {Date} the new date with the day of the month set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set the 30th day of the month to 1 September 2014:
       * var result = setDate(new Date(2014, 8, 1), 30)
       * //=> Tue Sep 30 2014 00:00:00
       */


      function setDate(dirtyDate, dirtyDayOfMonth) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var dayOfMonth = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyDayOfMonth);
        date.setDate(dayOfMonth);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(10);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setDay
       * @category Weekday Helpers
       * @summary Set the day of the week to the given date.
       *
       * @description
       * Set the day of the week to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} day - the day of the week of the new date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Date} the new date with the day of the week set
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // Set week day to Sunday, with the default weekStartsOn of Sunday:
       * var result = setDay(new Date(2014, 8, 1), 0)
       * //=> Sun Aug 31 2014 00:00:00
       *
       * @example
       * // Set week day to Sunday, with a weekStartsOn of Monday:
       * var result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
       * //=> Sun Sep 07 2014 00:00:00
       */


      function setDay(dirtyDate, dirtyDay, dirtyOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ])(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
        }

        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var day = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyDay);
        var currentDay = date.getDay();
        var remainder = day % 7;
        var dayIndex = (remainder + 7) % 7;
        var delta = 7 - weekStartsOn;
        var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
        return Object(__WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a"
        /* default */
        ])(date, diff);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setDayOfYear
       * @category Day Helpers
       * @summary Set the day of the year to the given date.
       *
       * @description
       * Set the day of the year to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} dayOfYear - the day of the year of the new date
       * @returns {Date} the new date with the day of the year set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set the 2nd day of the year to 2 July 2014:
       * var result = setDayOfYear(new Date(2014, 6, 2), 2)
       * //=> Thu Jan 02 2014 00:00:00
       */


      function setDayOfYear(dirtyDate, dirtyDayOfYear) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var dayOfYear = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyDayOfYear);
        date.setMonth(0);
        date.setDate(dayOfYear);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setHours
       * @category Hour Helpers
       * @summary Set the hours to the given date.
       *
       * @description
       * Set the hours to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} hours - the hours of the new date
       * @returns {Date} the new date with the hours set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set 4 hours to 1 September 2014 11:30:00:
       * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
       * //=> Mon Sep 01 2014 04:30:00
       */


      function setHours(dirtyDate, dirtyHours) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var hours = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyHours);
        date.setHours(hours);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__addDays_index_js__ = __webpack_require__(10);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__getISODay_index_js__ = __webpack_require__(109);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setISODay
       * @category Weekday Helpers
       * @summary Set the day of the ISO week to the given date.
       *
       * @description
       * Set the day of the ISO week to the given date.
       * ISO week starts with Monday.
       * 7 is the index of Sunday, 1 is the index of Monday etc.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} day - the day of the ISO week of the new date
       * @returns {Date} the new date with the day of the ISO week set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set Sunday to 1 September 2014:
       * const result = setISODay(new Date(2014, 8, 1), 7)
       * //=> Sun Sep 07 2014 00:00:00
       */


      function setISODay(dirtyDate, dirtyDay) {
        Object(__WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var day = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyDay);
        var currentDay = Object(__WEBPACK_IMPORTED_MODULE_3__getISODay_index_js__["a"
        /* default */
        ])(date);
        var diff = day - currentDay;
        return Object(__WEBPACK_IMPORTED_MODULE_2__addDays_index_js__["a"
        /* default */
        ])(date, diff);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__getISOWeek_index_js__ = __webpack_require__(110);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setISOWeek
       * @category ISO Week Helpers
       * @summary Set the ISO week to the given date.
       *
       * @description
       * Set the ISO week to the given date, saving the weekday number.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} isoWeek - the ISO week of the new date
       * @returns {Date} the new date with the ISO week set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set the 53rd ISO week to 7 August 2004:
       * const result = setISOWeek(new Date(2004, 7, 7), 53)
       * //=> Sat Jan 01 2005 00:00:00
       */


      function setISOWeek(dirtyDate, dirtyISOWeek) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var isoWeek = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyISOWeek);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_2__getISOWeek_index_js__["a"
        /* default */
        ])(date) - isoWeek;
        date.setDate(date.getDate() - diff * 7);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setMilliseconds
       * @category Millisecond Helpers
       * @summary Set the milliseconds to the given date.
       *
       * @description
       * Set the milliseconds to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} milliseconds - the milliseconds of the new date
       * @returns {Date} the new date with the milliseconds set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
       * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
       * //=> Mon Sep 01 2014 11:30:40.300
       */


      function setMilliseconds(dirtyDate, dirtyMilliseconds) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var milliseconds = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyMilliseconds);
        date.setMilliseconds(milliseconds);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setMinutes
       * @category Minute Helpers
       * @summary Set the minutes to the given date.
       *
       * @description
       * Set the minutes to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} minutes - the minutes of the new date
       * @returns {Date} the new date with the minutes set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set 45 minutes to 1 September 2014 11:30:40:
       * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
       * //=> Mon Sep 01 2014 11:45:40
       */


      function setMinutes(dirtyDate, dirtyMinutes) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var minutes = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyMinutes);
        date.setMinutes(minutes);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__ = __webpack_require__(61);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setQuarter
       * @category Quarter Helpers
       * @summary Set the year quarter to the given date.
       *
       * @description
       * Set the year quarter to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} quarter - the quarter of the new date
       * @returns {Date} the new date with the quarter set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set the 2nd quarter to 2 July 2014:
       * const result = setQuarter(new Date(2014, 6, 2), 2)
       * //=> Wed Apr 02 2014 00:00:00
       */


      function setQuarter(dirtyDate, dirtyQuarter) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var quarter = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyQuarter);
        var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
        var diff = quarter - oldQuarter;
        return Object(__WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__["a"
        /* default */
        ])(date, date.getMonth() + diff * 3);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setSeconds
       * @category Second Helpers
       * @summary Set the seconds to the given date.
       *
       * @description
       * Set the seconds to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} seconds - the seconds of the new date
       * @returns {Date} the new date with the seconds set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set 45 seconds to 1 September 2014 11:30:40:
       * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
       * //=> Mon Sep 01 2014 11:30:45
       */


      function setSeconds(dirtyDate, dirtySeconds) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var seconds = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtySeconds);
        date.setSeconds(seconds);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getWeek_index_js__ = __webpack_require__(112);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setWeek
       * @category Week Helpers
       * @summary Set the local week to the given date.
       *
       * @description
       * Set the local week to the given date, saving the weekday number.
       * The exact calculation depends on the values of
       * `options.weekStartsOn` (which is the index of the first day of the week)
       * and `options.firstWeekContainsDate` (which is the day of January, which is always in
       * the first week of the week-numbering year)
       *
       * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} week - the week of the new date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @returns {Date} the new date with the local week set
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       *
       * @example
       * // Set the 1st week to 2 January 2005 with default options:
       * var result = setWeek(new Date(2005, 0, 2), 1)
       * //=> Sun Dec 26 2004 00:00:00
       *
       * @example
       * // Set the 1st week to 2 January 2005,
       * // if Monday is the first day of the week,
       * // and the first week of the year always contains 4 January:
       * var result = setWeek(new Date(2005, 0, 2), 1, {
       *   weekStartsOn: 1,
       *   firstWeekContainsDate: 4
       * })
       * //=> Sun Jan 4 2004 00:00:00
       */


      function setWeek(dirtyDate, dirtyWeek, options) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var week = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyWeek);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_0__getWeek_index_js__["a"
        /* default */
        ])(date, options) - week;
        date.setDate(date.getDate() - diff * 7);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInCalendarDays_index_js__ = __webpack_require__(20);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__ = __webpack_require__(59);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setWeekYear
       * @category Week-Numbering Year Helpers
       * @summary Set the local week-numbering year to the given date.
       *
       * @description
       * Set the local week-numbering year to the given date,
       * saving the week number and the weekday number.
       * The exact calculation depends on the values of
       * `options.weekStartsOn` (which is the index of the first day of the week)
       * and `options.firstWeekContainsDate` (which is the day of January, which is always in
       * the first week of the week-numbering year)
       *
       * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} weekYear - the local week-numbering year of the new date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @returns {Date} the new date with the local week-numbering year set
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       *
       * @example
       * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
       * var result = setWeekYear(new Date(2010, 0, 2), 2004)
       * //=> Sat Jan 03 2004 00:00:00
       *
       * @example
       * // Set the local week-numbering year 2004 to 2 January 2010,
       * // if Monday is the first day of week
       * // and 4 January is always in the first week of the year:
       * var result = setWeekYear(new Date(2010, 0, 2), 2004, {
       *   weekStartsOn: 1,
       *   firstWeekContainsDate: 4
       * })
       * //=> Sat Jan 01 2005 00:00:00
       */


      function setWeekYear(dirtyDate, dirtyWeekYear) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object(__WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ])(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ])(options.firstWeekContainsDate);
        var date = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var weekYear = Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyWeekYear);
        var diff = Object(__WEBPACK_IMPORTED_MODULE_0__differenceInCalendarDays_index_js__["a"
        /* default */
        ])(date, Object(__WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__["a"
        /* default */
        ])(date, options));
        var firstWeek = new Date(0);
        firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
        firstWeek.setHours(0, 0, 0, 0);
        date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__["a"
        /* default */
        ])(firstWeek, options);
        date.setDate(date.getDate() + diff);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setYear
       * @category Year Helpers
       * @summary Set the year to the given date.
       *
       * @description
       * Set the year to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} year - the year of the new date
       * @returns {Date} the new date with the year set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set year 2013 to 1 September 2014:
       * const result = setYear(new Date(2014, 8, 1), 2013)
       * //=> Sun Sep 01 2013 00:00:00
       */


      function setYear(dirtyDate, dirtyYear) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var year = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

        if (isNaN(date.getTime())) {
          return new Date(NaN);
        }

        date.setFullYear(year);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfDecade
       * @category Decade Helpers
       * @summary Return the start of a decade for the given date.
       *
       * @description
       * Return the start of a decade for the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a decade
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a decade for 21 October 2015 00:00:00:
       * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
       * //=> Jan 01 2010 00:00:00
       */


      function startOfDecade(dirtyDate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ])(dirtyDate);
        var year = date.getFullYear();
        var decade = Math.floor(year / 10) * 10;
        date.setFullYear(decade, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfToday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__ = __webpack_require__(35);
      /**
       * @name startOfToday
       * @category Day Helpers
       * @summary Return the start of today.
       * @pure false
       *
       * @description
       * Return the start of today.
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @returns {Date} the start of today
       *
       * @example
       * // If today is 6 October 2014:
       * var result = startOfToday()
       * //=> Mon Oct 6 2014 00:00:00
       */


      function startOfToday() {
        return Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a"
        /* default */
        ])(Date.now());
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /**
       * @name startOfTomorrow
       * @category Day Helpers
       * @summary Return the start of tomorrow.
       * @pure false
       *
       * @description
       * Return the start of tomorrow.
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `new Date()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @returns {Date} the start of tomorrow
       *
       * @example
       * // If today is 6 October 2014:
       * const result = startOfTomorrow()
       * //=> Tue Oct 7 2014 00:00:00
       */

      function startOfTomorrow() {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth();
        var day = now.getDate();
        var date = new Date(0);
        date.setFullYear(year, month, day + 1);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /**
       * @name startOfYesterday
       * @category Day Helpers
       * @summary Return the start of yesterday.
       * @pure false
       *
       * @description
       * Return the start of yesterday.
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `new Date()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @returns {Date} the start of yesterday
       *
       * @example
       * // If today is 6 October 2014:
       * const result = startOfYesterday()
       * //=> Sun Oct 5 2014 00:00:00
       */

      function startOfYesterday() {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth();
        var day = now.getDate();
        var date = new Date(0);
        date.setFullYear(year, month, day - 1);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addBusinessDays_index_js__ = __webpack_require__(73);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subBusinessDays
       * @category Day Helpers
       * @summary Substract the specified number of business days (mon - fri) to the given date.
       *
       * @description
       * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of business days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the business days subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Substract 10 business days from 1 September 2014:
       * var result = subBusinessDays(new Date(2014, 8, 1), 10)
       * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
       */


      function subBusinessDays(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addBusinessDays_index_js__["a"
        /* default */
        ])(dirtyDate, -amount);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subHours;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addHours_index_js__ = __webpack_require__(47);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subHours
       * @category Hour Helpers
       * @summary Subtract the specified number of hours from the given date.
       *
       * @description
       * Subtract the specified number of hours from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the hours subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 2 hours from 11 July 2014 01:00:00:
       * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
       * //=> Thu Jul 10 2014 23:00:00
       */


      function subHours(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addHours_index_js__["a"
        /* default */
        ])(dirtyDate, -amount);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subMinutes;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMinutes_index_js__ = __webpack_require__(48);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subMinutes
       * @category Minute Helpers
       * @summary Subtract the specified number of minutes from the given date.
       *
       * @description
       * Subtract the specified number of minutes from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the minutes subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 30 minutes from 10 July 2014 12:00:00:
       * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
       * //=> Thu Jul 10 2014 11:30:00
       */


      function subMinutes(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addMinutes_index_js__["a"
        /* default */
        ])(dirtyDate, -amount);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addQuarters_index_js__ = __webpack_require__(49);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subQuarters
       * @category Quarter Helpers
       * @summary Subtract the specified number of year quarters from the given date.
       *
       * @description
       * Subtract the specified number of year quarters from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the quarters subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 3 quarters from 1 September 2014:
       * const result = subQuarters(new Date(2014, 8, 1), 3)
       * //=> Sun Dec 01 2013 00:00:00
       */


      function subQuarters(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addQuarters_index_js__["a"
        /* default */
        ])(dirtyDate, -amount);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addSeconds_index_js__ = __webpack_require__(77);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subSeconds
       * @category Second Helpers
       * @summary Subtract the specified number of seconds from the given date.
       *
       * @description
       * Subtract the specified number of seconds from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of seconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the seconds subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 30 seconds from 10 July 2014 12:45:00:
       * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
       * //=> Thu Jul 10 2014 12:44:30
       */


      function subSeconds(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addSeconds_index_js__["a"
        /* default */
        ])(dirtyDate, -amount);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__ = __webpack_require__(36);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subWeeks
       * @category Week Helpers
       * @summary Subtract the specified number of weeks from the given date.
       *
       * @description
       * Subtract the specified number of weeks from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the weeks subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 4 weeks from 1 September 2014:
       * const result = subWeeks(new Date(2014, 8, 1), 4)
       * //=> Mon Aug 04 2014 00:00:00
       */


      function subWeeks(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__["a"
        /* default */
        ])(dirtyDate, -amount);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addYears_index_js__ = __webpack_require__(78);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subYears
       * @category Year Helpers
       * @summary Subtract the specified number of years from the given date.
       *
       * @description
       * Subtract the specified number of years from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the years subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 5 years from 1 September 2014:
       * const result = subYears(new Date(2014, 8, 1), 5)
       * //=> Tue Sep 01 2009 00:00:00
       */


      function subYears(dirtyDate, dirtyAmount) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ])(2, arguments);
        var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ])(dirtyAmount);
        return Object(__WEBPACK_IMPORTED_MODULE_1__addYears_index_js__["a"
        /* default */
        ])(dirtyDate, -amount);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name weeksToDays
       * @category Conversion Helpers
       * @summary Convert weeks to days.
       *
       * @description
       * Convert a number of weeks to a full number of days.
       *
       * @param {number} weeks - number of weeks to be converted
       *
       * @returns {number} the number of weeks converted in days
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 2 weeks into days
       * const result = weeksToDays(2)
       * //=> 14
       */


      function weeksToDays(weeks) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Math.floor(weeks * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["a"
        /* daysInWeek */
        ]);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name yearsToMonths
       * @category Conversion Helpers
       * @summary Convert years to months.
       *
       * @description
       * Convert a number of years to a full number of months.
       *
       * @param {number} years - number of years to be converted
       *
       * @returns {number} the number of years converted in months
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 2 years into months
       * const result = yearsToMonths(2)
       * //=> 24
       */


      function yearsToMonths(years) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Math.floor(years * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["g"
        /* monthsInYear */
        ]);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export default */

      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(7);
      /**
       * @name yearsToQuarters
       * @category Conversion Helpers
       * @summary Convert years to quarters.
       *
       * @description
       * Convert a number of years to a full number of quarters.
       *
       * @param {number} years - number of years to be converted
       *
       * @returns {number} the number of years converted in quarters
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Convert 2 years to quarters
       * const result = yearsToQuarters(2)
       * //=> 8
       */


      function yearsToQuarters(years) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ])(1, arguments);
        return Math.floor(years * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["h"
        /* quartersInYear */
        ]);
      }
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(45);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__utils_type__ = __webpack_require__(33);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(18);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__utils_events__ = __webpack_require__(62);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__templates_datepicker__ = __webpack_require__(669);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__templates_days__ = __webpack_require__(670);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__templates_weekdays__ = __webpack_require__(671);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__templates_months__ = __webpack_require__(672);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_8__templates_years__ = __webpack_require__(673);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_9__defaultOptions__ = __webpack_require__(674);

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var datePicker = function (_EventEmitter) {
        _inherits(datePicker, _EventEmitter);

        function datePicker() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          _classCallCheck(this || _global, datePicker);

          var _this = _possibleConstructorReturn(this || _global, (datePicker.__proto__ || Object.getPrototypeOf(datePicker)).call(this || _global));

          _this.options = _extends({}, __WEBPACK_IMPORTED_MODULE_9__defaultOptions__["a"
          /* default */
          ], options);
          _this._clickEvents = ["click", "touch"];
          _this._supportsPassive = __WEBPACK_IMPORTED_MODULE_0__utils__["a"
          /* detectSupportsPassive */
          ]();
          _this._id = __WEBPACK_IMPORTED_MODULE_0__utils__["c"
          /* uuid */
          ]("datePicker");
          _this.node = null;
          _this.onPreviousDatePicker = _this.onPreviousDatePicker.bind(_this);
          _this.onNextDatePicker = _this.onNextDatePicker.bind(_this);
          _this.onSelectMonthDatePicker = _this.onSelectMonthDatePicker.bind(_this);
          _this.onMonthClickDatePicker = _this.onMonthClickDatePicker.bind(_this);
          _this.onSelectYearDatePicker = _this.onSelectYearDatePicker.bind(_this);
          _this.onYearClickDatePicker = _this.onYearClickDatePicker.bind(_this);
          _this.onDateClickDatePicker = _this.onDateClickDatePicker.bind(_this);

          _this._init();

          return _this;
        }
        /****************************************************
         *                                                  *
         * GETTERS and SETTERS                              *
         *                                                  *
         ****************************************************/

        /**
         * Get id of current datePicker
         */


        _createClass(datePicker, [{
          key: "onPreviousDatePicker",

          /****************************************************
           *                                                  *
           * EVENTS FUNCTIONS                                 *
           *                                                  *
           ****************************************************/
          value: function onPreviousDatePicker(e) {
            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();

            var prevMonth = __WEBPACK_IMPORTED_MODULE_2_date_fns__["y"
            /* lastDayOfMonth */
            ](__WEBPACK_IMPORTED_MODULE_2_date_fns__["M"
            /* subMonths */
            ](new Date(__WEBPACK_IMPORTED_MODULE_2_date_fns__["q"
            /* getYear */
            ]((this || _global)._visibleDate), __WEBPACK_IMPORTED_MODULE_2_date_fns__["p"
            /* getMonth */
            ]((this || _global)._visibleDate)), 1));

            var day = Math.min(__WEBPACK_IMPORTED_MODULE_2_date_fns__["o"
            /* getDaysInMonth */
            ](prevMonth), __WEBPACK_IMPORTED_MODULE_2_date_fns__["m"
            /* getDate */
            ]((this || _global)._visibleDate));

            this._setVisibleDate(__WEBPACK_IMPORTED_MODULE_2_date_fns__["C"
            /* setDate */
            ](prevMonth, day));

            this.refresh();
          }
        }, {
          key: "onNextDatePicker",
          value: function onNextDatePicker(e) {
            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();

            var nextMonth = __WEBPACK_IMPORTED_MODULE_2_date_fns__["d"
            /* addMonths */
            ]((this || _global)._visibleDate, 1);

            var day = Math.min(__WEBPACK_IMPORTED_MODULE_2_date_fns__["o"
            /* getDaysInMonth */
            ](nextMonth), __WEBPACK_IMPORTED_MODULE_2_date_fns__["m"
            /* getDate */
            ]((this || _global)._visibleDate));

            this._setVisibleDate(__WEBPACK_IMPORTED_MODULE_2_date_fns__["C"
            /* setDate */
            ](nextMonth, day));

            this.refresh();
          }
        }, {
          key: "onSelectMonthDatePicker",
          value: function onSelectMonthDatePicker(e) {
            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();

            if ((this || _global).options.enableMonthSwitch) {
              (this || _global)._ui.body.dates.classList.remove("is-active");

              (this || _global)._ui.body.years.classList.remove("is-active");

              (this || _global)._ui.body.months.classList.add("is-active");

              this._toggleNextButton(false);

              this._togglePreviousButton(false);
            }
          }
        }, {
          key: "onSelectYearDatePicker",
          value: function onSelectYearDatePicker(e) {
            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();

            if ((this || _global).options.enableYearSwitch) {
              (this || _global)._ui.body.dates.classList.remove("is-active");

              (this || _global)._ui.body.months.classList.remove("is-active");

              (this || _global)._ui.body.years.classList.add("is-active");

              this._toggleNextButton(false);

              this._togglePreviousButton(false);

              var currentYear = (this || _global)._ui.body.years.querySelector(".calendar-year.is-active");

              if (currentYear) {
                (this || _global)._ui.body.years.scrollTop = currentYear.offsetTop - (this || _global)._ui.body.years.offsetTop - (this || _global)._ui.body.years.clientHeight / 2;
              }
            }
          }
        }, {
          key: "onMonthClickDatePicker",
          value: function onMonthClickDatePicker(e) {
            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();

            var newDate = __WEBPACK_IMPORTED_MODULE_2_date_fns__["D"
            /* setMonth */
            ]((this || _global)._visibleDate, parseInt(e.currentTarget.dataset.month) - 1);

            (this || _global)._visibleDate = (this || _global).min ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["z"
            /* max */
            ]([newDate, (this || _global).min]) : newDate;
            (this || _global)._visibleDate = (this || _global).max ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["A"
            /* min */
            ]([(this || _global)._visibleDate, (this || _global).max]) : (this || _global)._visibleDate;
            this.refresh();
          }
        }, {
          key: "onYearClickDatePicker",
          value: function onYearClickDatePicker(e) {
            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();

            var newDate = __WEBPACK_IMPORTED_MODULE_2_date_fns__["E"
            /* setYear */
            ]((this || _global)._visibleDate, parseInt(e.currentTarget.dataset.year));

            (this || _global)._visibleDate = (this || _global).min ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["z"
            /* max */
            ]([newDate, (this || _global).min]) : newDate;
            (this || _global)._visibleDate = (this || _global).max ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["A"
            /* min */
            ]([(this || _global)._visibleDate, (this || _global).max]) : (this || _global)._visibleDate;
            this.refresh();
          }
        }, {
          key: "onDateClickDatePicker",
          value: function onDateClickDatePicker(e) {
            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();

            if (!e.currentTarget.classList.contains("is-disabled")) {
              this._select(new Date(e.currentTarget.dataset.date));

              this.refresh();
            }
          }
          /****************************************************
           *                                                  *
           * PUBLIC FUNCTIONS                                 *
           *                                                  *
           ****************************************************/

        }, {
          key: "isRange",
          value: function isRange() {
            return (this || _global).options.isRange;
          }
        }, {
          key: "enableDate",
          value: function enableDate() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            if (!Array.isArray((this || _global).disabledDates)) return;

            var index = (this || _global).disabledDates.findIndex(function (disableDate) {
              return __WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
              /* isEqual */
              ](disableDate, date);
            });

            if (index > -1) {
              unset((this || _global).disabledDates[index]);
            }
          }
        }, {
          key: "disableDate",
          value: function disableDate() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            if (!Array.isArray((this || _global).disabledDates)) return;

            var index = (this || _global).disabledDates.findIndex(function (disableDate) {
              return __WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
              /* isEqual */
              ](disableDate, date);
            });

            if (index > -1) {
              (this || _global).disabledDates.push(date);
            }
          }
        }, {
          key: "highlightDate",
          value: function highlightDate() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            if (!Array.isArray((this || _global).highlightedDates)) return;

            var index = (this || _global).highlightedDates.findIndex(function (highlightDate) {
              return __WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
              /* isEqual */
              ](highlightDate, date);
            });

            if (index > -1) {
              unset((this || _global).highlightedDates[index]);
            }
          }
        }, {
          key: "unhighlightDate",
          value: function unhighlightDate() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            if (!Array.isArray((this || _global).highlightedDates)) return;

            var index = (this || _global).highlightedDates.findIndex(function (highlightDate) {
              return __WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
              /* isEqual */
              ](highlightDate, date);
            });

            if (index > -1) {
              (this || _global).highlightedDates.push(date);
            }
          }
        }, {
          key: "enableWeekDay",
          value: function enableWeekDay(day) {
            var index = (this || _global).disabledWeekDays.findIndex(function (disabledWeekDay) {
              return __WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
              /* isEqual */
              ](disabledWeekDay, day);
            });

            if (index > -1) {
              unset((this || _global).disabledWeekDays[index]);
            }
          }
        }, {
          key: "disableWeekDay",
          value: function disableWeekDay(day) {
            var index = (this || _global).disabledWeekDays.findIndex(function (disabledWeekDay) {
              return __WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
              /* isEqual */
              ](disabledWeekDay, date);
            });

            if (index > -1) {
              (this || _global).disabledWeekDays.push(day);
            }
          }
        }, {
          key: "show",
          value: function show() {
            if ((this || _global)._open) return;
            this.refresh();

            (this || _global)._ui.container.classList.add("is-active");

            (this || _global)._open = true;
            (this || _global)._focus = true;
            this.emit("show", this || _global);
          }
        }, {
          key: "hide",
          value: function hide() {
            if (!(this || _global)._open) return;
            (this || _global)._open = false;
            (this || _global)._focus = false;

            (this || _global)._ui.container.classList.remove("is-active");

            this.emit("hide", this || _global);
          }
        }, {
          key: "toggle",
          value: function toggle() {
            if (!(this || _global)._open) {
              this.show();
            } else {
              this.hide();
            }
          }
          /**
           * Get / Set datePicker value
           * @param {null|Date|Object|String} date optional if null then return the current date as String
           */

        }, {
          key: "value",
          value: function value() {
            var _value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null; // Set


            if (_value) {
              if ((this || _global).options.isRange) {
                if (__WEBPACK_IMPORTED_MODULE_1__utils_type__["e"
                /* isString */
                ](_value)) {
                  _value = _value.split(" - ");
                }

                if (Array.isArray(_value)) {
                  if (_value.length) (this || _global).start = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
                  /* newDate */
                  ](_value[0], (this || _global).format, "yyyy-MM-dd");
                  if (_value.length === 2) (this || _global).end = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
                  /* newDate */
                  ](_value[1], (this || _global).format, "yyyy-MM-dd");
                }
              } else {
                this._select(_value, false);
              }

              this.refresh();
              return;
            } // Get


            var string = this._isValidDate((this || _global).start) ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
            /* format */
            ]((this || _global).start, (this || _global).format, {
              locale: (this || _global).locale
            }) : "";

            if ((this || _global).options.isRange && this._isValidDate((this || _global).end)) {
              string += " - " + __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
              /* format */
              ]((this || _global).end, (this || _global).format, {
                locale: (this || _global).locale
              });
            }

            return string;
          }
          /**
           * Refresh datepicker with new year/month days
           * @method _refreshdatepicker
           * @return {[type]}        [description]
           */

        }, {
          key: "refresh",
          value: function refresh() {
            var _this2 = this || _global;

            (this || _global)._ui.body.dates.innerHTML = ""; // the 12 months of the year

            var monthLabels = new Array(12).fill(__WEBPACK_IMPORTED_MODULE_2_date_fns__["J"
            /* startOfYear */
            ]((this || _global)._visibleDate)).map(function (d, i) {
              return __WEBPACK_IMPORTED_MODULE_2_date_fns__["d"
              /* addMonths */
              ](d, i);
            });
            (this || _global)._ui.body.months.innerHTML = "";

            (this || _global)._ui.body.months.appendChild(document.createRange().createContextualFragment(Object(__WEBPACK_IMPORTED_MODULE_7__templates_months__["a"
            /* default */
            ])({
              months: monthLabels,
              format: (this || _global).options.formats.selectMonth,
              locale: (this || _global).locale
            })));

            var months = (this || _global)._ui.body.months.querySelectorAll(".datepicker-month") || [];
            months.forEach(function (month) {
              _this2._clickEvents.forEach(function (clickEvent) {
                month.addEventListener(clickEvent, _this2.onMonthClickDatePicker);
              });

              month.classList.remove("is-active");

              if (month.dataset.month === __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
              /* format */
              ](_this2._visibleDate, "MM", {
                locale: _this2.locale
              })) {
                month.classList.add("is-active");
              }
            }); // years

            var yearLabels = new Array((this || _global).options.displayYearsCount * 2).fill(__WEBPACK_IMPORTED_MODULE_2_date_fns__["N"
            /* subYears */
            ]((this || _global)._visibleDate, (this || _global).options.displayYearsCount)).map(function (d, i) {
              return __WEBPACK_IMPORTED_MODULE_2_date_fns__["e"
              /* addYears */
              ](d, i);
            });
            (this || _global)._ui.body.years.innerHTML = "";

            (this || _global)._ui.body.years.appendChild(document.createRange().createContextualFragment(Object(__WEBPACK_IMPORTED_MODULE_8__templates_years__["a"
            /* default */
            ])({
              visibleDate: (this || _global)._visibleDate,
              years: yearLabels,
              format: (this || _global).options.formats.selectYear,
              locale: (this || _global).locale
            })));

            var years = (this || _global)._ui.body.years.querySelectorAll(".datepicker-year") || [];
            years.forEach(function (year) {
              _this2._clickEvents.forEach(function (clickEvent) {
                year.addEventListener(clickEvent, _this2.onYearClickDatePicker);
              });

              year.classList.remove("is-active");

              if (year.dataset.year === __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
              /* format */
              ](_this2._visibleDate, "yyyy", {
                locale: _this2.locale
              })) {
                year.classList.add("is-active");
              }
            }); // the 7 days of the week (Sun-Sat)

            var weekdayLabels = new Array(7).fill(__WEBPACK_IMPORTED_MODULE_2_date_fns__["I"
            /* startOfWeek */
            ]((this || _global)._visibleDate, {
              weekStartsOn: (this || _global).options.weekStart
            })).map(function (d, i) {
              return __WEBPACK_IMPORTED_MODULE_2_date_fns__["a"
              /* addDays */
              ](d, i);
            });

            (this || _global)._ui.body.dates.appendChild(document.createRange().createContextualFragment(Object(__WEBPACK_IMPORTED_MODULE_6__templates_weekdays__["a"
            /* default */
            ])({
              days: weekdayLabels,
              format: (this || _global).options.formats.weekday,
              locale: (this || _global).locale
            })));

            if ((this || _global).min && __WEBPACK_IMPORTED_MODULE_2_date_fns__["f"
            /* differenceInCalendarMonths */
            ]((this || _global)._visibleDate, (this || _global).min) === 0) {
              this._togglePreviousButton(false);
            } else {
              this._togglePreviousButton();
            }

            if ((this || _global).max && __WEBPACK_IMPORTED_MODULE_2_date_fns__["f"
            /* differenceInCalendarMonths */
            ]((this || _global)._visibleDate, (this || _global).max) === 0) {
              this._toggleNextButton(false);
            } else {
              this._toggleNextButton();
            }

            (this || _global)._ui.navigation.month.innerHTML = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
            /* format */
            ]((this || _global)._visibleDate, (this || _global).options.formats.navigationMonth, {
              locale: (this || _global).locale
            });
            (this || _global)._ui.navigation.year.innerHTML = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
            /* format */
            ]((this || _global)._visibleDate, (this || _global).options.formats.navigationYear, {
              locale: (this || _global).locale
            });

            this._renderDays();

            (this || _global)._ui.body.dates.classList.add("is-active");

            (this || _global)._ui.body.months.classList.remove("is-active");

            (this || _global)._ui.body.years.classList.remove("is-active");

            return this || _global;
          }
        }, {
          key: "clear",
          value: function clear() {
            var today = new Date();
            (this || _global)._date = {
              start: undefined,
              end: undefined
            };

            this._setVisibleDate(today);

            this.refresh();
          }
        }, {
          key: "render",
          value: function render() {
            this.refresh();
            return (this || _global).node;
          }
          /****************************************************
           *                                                  *
           * PRIVATE FUNCTIONS                                *
           *                                                  *
           ****************************************************/

        }, {
          key: "_init",
          value: function _init() {
            var today = new Date();
            (this || _global)._open = false;
            (this || _global).lang = (this || _global).options.lang;
            (this || _global).format = (this || _global).options.dateFormat || "MM/dd/yyyy";
            (this || _global).disabledDates = __WEBPACK_IMPORTED_MODULE_1__utils_type__["c"
            /* isFunction */
            ]((this || _global).options.disabledDates) ? (this || _global).options.disabledDates : [];
            (this || _global).disabledWeekDays = __WEBPACK_IMPORTED_MODULE_1__utils_type__["e"
            /* isString */
            ]((this || _global).options.disabledWeekDays) ? (this || _global).options.disabledWeekDays.split(",") : Array.isArray((this || _global).options.disabledWeekDays) ? (this || _global).options.disabledWeekDays : [];
            (this || _global).highlightedDates = __WEBPACK_IMPORTED_MODULE_1__utils_type__["c"
            /* isFunction */
            ]((this || _global).options.highlightedDates) ? (this || _global).options.highlightedDates : [];

            if (Array.isArray((this || _global).options.disabledDates)) {
              for (var i = 0; i < (this || _global).options.disabledDates.length; i++) {
                (this || _global).disabledDates.push(__WEBPACK_IMPORTED_MODULE_0__utils__["b"
                /* newDate */
                ]((this || _global).options.disabledDates[i], (this || _global).format, "yyyy-MM-dd"));
              }
            }

            if (Array.isArray((this || _global).options.highlightedDates)) {
              for (var _i = 0; _i < (this || _global).options.highlightedDates.length; _i++) {
                (this || _global).highlightedDates.push(__WEBPACK_IMPORTED_MODULE_0__utils__["b"
                /* newDate */
                ]((this || _global).options.highlightedDates[_i], (this || _global).format, "yyyy-MM-dd"));
              }
            }

            (this || _global).min = (this || _global).options.minDate;
            (this || _global).max = (this || _global).options.maxDate;
            (this || _global)._date = {
              start: __WEBPACK_IMPORTED_MODULE_0__utils__["b"
              /* newDate */
              ]((this || _global).options.startDate, (this || _global).format, "yyyy-MM-dd"),
              end: (this || _global).options.isRange ? __WEBPACK_IMPORTED_MODULE_0__utils__["b"
              /* newDate */
              ]((this || _global).options.endDate, (this || _global).format, "yyyy-MM-dd") : undefined
            }; // set visible date on start or today

            (this || _global)._visibleDate = this._isValidDate((this || _global).start) ? (this || _global).start : today; // check if visible date is in the valid min/max range and adjust if necessary

            if (!this._isValidDate((this || _global)._visibleDate, (this || _global).min, (this || _global).max)) {
              (this || _global)._visibleDate = (this || _global).min ? (this || _global).min : (this || _global).max;
            }

            this._build();

            this._bindEvents();

            this.emit("ready", this || _global);
          }
        }, {
          key: "_build",
          value: function _build() {
            (this || _global).node = document.createRange().createContextualFragment(Object(__WEBPACK_IMPORTED_MODULE_4__templates_datepicker__["a"
            /* default */
            ])({
              locale: (this || _global).locale,
              visibleDate: (this || _global)._visibleDate,
              icons: (this || _global).options.icons
            }));
            (this || _global)._ui = {
              container: (this || _global).node.firstChild,
              navigation: {
                container: (this || _global).node.querySelector(".datepicker-nav"),
                previous: (this || _global).node.querySelector(".datepicker-nav-previous"),
                next: (this || _global).node.querySelector(".datepicker-nav-next"),
                month: (this || _global).node.querySelector(".datepicker-nav-month"),
                year: (this || _global).node.querySelector(".datepicker-nav-year")
              },
              body: {
                dates: (this || _global).node.querySelector(".datepicker-dates"),
                days: (this || _global).node.querySelector(".datepicker-days"),
                weekdays: (this || _global).node.querySelector(".datepicker-weekdays"),
                months: (this || _global).node.querySelector(".datepicker-months"),
                years: (this || _global).node.querySelector(".datepicker-years")
              }
            };
          }
        }, {
          key: "_bindEvents",
          value: function _bindEvents() {
            var _this3 = this || _global;

            document.addEventListener("keydown", function (e) {
              if (_this3._focus) {
                switch (e.keyCode || e.which) {
                  case 37:
                    _this3.onPreviousDatePicker(e);

                    break;

                  case 39:
                    _this3.onNextDatePicker(e);

                    break;
                }
              }
            }); // Bind year navigation events

            if ((this || _global)._ui.navigation.previous) {
              (this || _global)._clickEvents.forEach(function (clickEvent) {
                _this3._ui.navigation.previous.addEventListener(clickEvent, _this3.onPreviousDatePicker);
              });
            }

            if ((this || _global)._ui.navigation.next) {
              (this || _global)._clickEvents.forEach(function (clickEvent) {
                _this3._ui.navigation.next.addEventListener(clickEvent, _this3.onNextDatePicker);
              });
            }

            if ((this || _global)._ui.navigation.month) {
              (this || _global)._clickEvents.forEach(function (clickEvent) {
                _this3._ui.navigation.month.addEventListener(clickEvent, _this3.onSelectMonthDatePicker);
              });
            }

            if ((this || _global)._ui.navigation.year) {
              (this || _global)._clickEvents.forEach(function (clickEvent) {
                _this3._ui.navigation.year.addEventListener(clickEvent, _this3.onSelectYearDatePicker);
              });
            }

            var months = (this || _global)._ui.body.months.querySelectorAll(".calendar-month") || [];
            months.forEach(function (month) {
              _this3._clickEvents.forEach(function (clickEvent) {
                month.addEventListener(clickEvent, _this3.onMonthClickDatePicker);
              });
            });
            var years = (this || _global)._ui.body.years.querySelectorAll(".calendar-year") || [];
            years.forEach(function (year) {
              _this3._clickEvents.forEach(function (clickEvent) {
                year.addEventListener(clickEvent, _this3.onYearClickDatePicker);
              });
            });
          }
          /**
           * Bind events on each Day item
           * @method _bindDaysEvents
           * @return {void}
           */

        }, {
          key: "_bindDaysEvents",
          value: function _bindDaysEvents() {
            var _this4 = this || _global;

            [].forEach.call((this || _global)._ui.days, function (day) {
              _this4._clickEvents.forEach(function (clickEvent) {
                // if not in range, no click action
                // if in this month, select the date
                // if out of this month, jump to the date
                var onClick = !_this4._isValidDate(new Date(day.dataset.date), _this4.min, _this4.max) ? null : _this4.onDateClickDatePicker;
                day.addEventListener(clickEvent, onClick);
              });

              day.addEventListener("hover", function (e) {
                e.preventDEfault();
              });
            });
          }
        }, {
          key: "_renderDays",
          value: function _renderDays() {
            var _this5 = this || _global;

            var start = __WEBPACK_IMPORTED_MODULE_2_date_fns__["I"
            /* startOfWeek */
            ](__WEBPACK_IMPORTED_MODULE_2_date_fns__["G"
            /* startOfMonth */
            ]((this || _global)._visibleDate), {
              weekStartsOn: (this || _global).options.weekStart
            }); // first day of current month view


            var end = __WEBPACK_IMPORTED_MODULE_2_date_fns__["k"
            /* endOfWeek */
            ](__WEBPACK_IMPORTED_MODULE_2_date_fns__["i"
            /* endOfMonth */
            ]((this || _global)._visibleDate), {
              weekStartsOn: (this || _global).options.weekStart
            }); // last day of current month view
            // get all days and whether they are within the current month and range


            var days = new Array(__WEBPACK_IMPORTED_MODULE_2_date_fns__["g"
            /* differenceInDays */
            ](end, start) + 1).fill(start).map(function (s, i) {
              var theDate = __WEBPACK_IMPORTED_MODULE_2_date_fns__["F"
              /* startOfDay */
              ](__WEBPACK_IMPORTED_MODULE_2_date_fns__["a"
              /* addDays */
              ](s, i));

              var isThisMonth = __WEBPACK_IMPORTED_MODULE_2_date_fns__["u"
              /* isSameMonth */
              ](_this5._visibleDate, theDate);

              var isInRange = _this5.options.isRange && _this5.end && __WEBPACK_IMPORTED_MODULE_2_date_fns__["x"
              /* isWithinInterval */
              ](theDate, {
                start: __WEBPACK_IMPORTED_MODULE_2_date_fns__["F"
                /* startOfDay */
                ](_this5.start),
                end: __WEBPACK_IMPORTED_MODULE_2_date_fns__["h"
                /* endOfDay */
                ](_this5.end)
              });

              var isDisabled = _this5.max ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["r"
              /* isAfter */
              ](__WEBPACK_IMPORTED_MODULE_2_date_fns__["F"
              /* startOfDay */
              ](theDate), __WEBPACK_IMPORTED_MODULE_2_date_fns__["h"
              /* endOfDay */
              ](_this5.max)) : false;
              isDisabled = !isDisabled && _this5.min ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["s"
              /* isBefore */
              ](__WEBPACK_IMPORTED_MODULE_2_date_fns__["F"
              /* startOfDay */
              ](theDate), __WEBPACK_IMPORTED_MODULE_2_date_fns__["F"
              /* startOfDay */
              ](_this5.min)) : isDisabled;
              var isHighlighted = false; // Disabled Dates

              if (Array.isArray(_this5.disabledDates)) {
                for (var j = 0; j < _this5.disabledDates.length; j++) {
                  if (theDate.toDateString() === _this5.disabledDates[j].toDateString()) {
                    isDisabled = true;
                  }
                }
              } else {
                if (__WEBPACK_IMPORTED_MODULE_1__utils_type__["c"
                /* isFunction */
                ](_this5.disabledDates)) {
                  if (_this5.disabledDates(_this5, theDate)) {
                    isDisabled = true;
                  }
                }
              } // Highlighted Dates


              if (Array.isArray(_this5.highlightedDates)) {
                for (var _j = 0; _j < _this5.highlightedDates.length; _j++) {
                  if (theDate.toDateString() === _this5.highlightedDates[_j].toDateString()) {
                    isHighlighted = true;
                  }
                }
              } else {
                if (__WEBPACK_IMPORTED_MODULE_1__utils_type__["c"
                /* isFunction */
                ](_this5.highlightedDates)) {
                  if (_this5.highlightedDates(_this5, theDate)) {
                    isHighlighted = true;
                  }
                }
              } // Disabled Weekdays


              if (_this5.disabledWeekDays) {
                _this5.disabledWeekDays.forEach(function (day) {
                  if (__WEBPACK_IMPORTED_MODULE_2_date_fns__["n"
                  /* getDay */
                  ](theDate) == day) {
                    isDisabled = true;
                  }
                });
              }

              return {
                date: theDate,
                isRange: _this5.options.isRange,
                isToday: __WEBPACK_IMPORTED_MODULE_2_date_fns__["v"
                /* isToday */
                ](theDate),
                isStartDate: __WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
                /* isEqual */
                ](__WEBPACK_IMPORTED_MODULE_2_date_fns__["F"
                /* startOfDay */
                ](_this5.start), theDate),
                isEndDate: __WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
                /* isEqual */
                ](__WEBPACK_IMPORTED_MODULE_2_date_fns__["F"
                /* startOfDay */
                ](_this5.end), theDate),
                isDisabled: isDisabled,
                isThisMonth: isThisMonth,
                isHighlighted: isHighlighted,
                isInRange: isInRange
              };
            });

            (this || _global)._ui.body.dates.appendChild(document.createRange().createContextualFragment(Object(__WEBPACK_IMPORTED_MODULE_5__templates_days__["a"
            /* default */
            ])(days)));

            (this || _global)._ui.days = (this || _global)._ui.body.dates.querySelectorAll(".datepicker-date");

            this._bindDaysEvents();
          }
        }, {
          key: "_select",
          value: function _select() {
            var _this6 = this || _global;

            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (!__WEBPACK_IMPORTED_MODULE_1__utils_type__["b"
            /* isDate */
            ](date)) {
              date = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
              /* newDate */
              ](date, (this || _global).format, "yyyy-MM-dd");
            }

            if ((this || _global).options.isRange && (!this._isValidDate((this || _global).start) || this._isValidDate((this || _global).start) && this._isValidDate((this || _global).end))) {
              (this || _global).start = date;
              (this || _global).end = undefined;
              if (emit) this.emit("select:start", this || _global);
            } else if ((this || _global).options.isRange && !this._isValidDate((this || _global).end)) {
              if (__WEBPACK_IMPORTED_MODULE_2_date_fns__["s"
              /* isBefore */
              ](date, (this || _global).start)) {
                (this || _global).end = (this || _global).start;
                (this || _global).start = date;
                if (emit) this.emit("select", this || _global);
              } else if (__WEBPACK_IMPORTED_MODULE_2_date_fns__["r"
              /* isAfter */
              ](date, (this || _global).start)) {
                (this || _global).end = date;
                if (emit) this.emit("select", this || _global);
              } else if ((this || _global).options.allowSameDayRange) {
                (this || _global).end = date;
                if (emit) this.emit("select", this || _global);
              } else {
                (this || _global).start = date;
                (this || _global).end = undefined;
                if (emit) this.emit("select:start", this || _global);
              }
            } else {
              (this || _global).start = date;
              (this || _global).end = undefined;
              if (emit) this.emit("select", this || _global);
            }

            this._setVisibleDate((this || _global).start);

            if ((this || _global).options.isRange && this._isValidDate((this || _global).start) && this._isValidDate((this || _global).end)) {
              new Array(__WEBPACK_IMPORTED_MODULE_2_date_fns__["g"
              /* differenceInDays */
              ]((this || _global).end, (this || _global).start) + 1).fill((this || _global).start).map(function (s, i) {
                var theDate = __WEBPACK_IMPORTED_MODULE_2_date_fns__["a"
                /* addDays */
                ](s, i);

                var dateElement = _this6._ui.body.dates.querySelector(".datepicker-date[data-date=\"" + theDate.toString() + "\"]");

                if (dateElement) {
                  if (__WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
                  /* isEqual */
                  ](_this6.start, theDate)) {
                    dateElement.classList.add("datepicker-range-start");
                  }

                  if (__WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
                  /* isEqual */
                  ](_this6.end, theDate)) {
                    dateElement.classList.add("datepicker-range-end");
                  }

                  dateElement.classList.add("datepicker-range");
                }
              });
            }
          }
        }, {
          key: "_isValidDate",
          value: function _isValidDate(date, min, max) {
            try {
              if (!date) {
                return false;
              }

              if (__WEBPACK_IMPORTED_MODULE_2_date_fns__["w"
              /* isValid */
              ](date)) {
                if (!min && !max) {
                  return true;
                }

                if (min && max) {
                  return __WEBPACK_IMPORTED_MODULE_2_date_fns__["x"
                  /* isWithinInterval */
                  ](date, {
                    start: min,
                    end: max
                  });
                }

                if (max) {
                  return __WEBPACK_IMPORTED_MODULE_2_date_fns__["s"
                  /* isBefore */
                  ](date, max) || __WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
                  /* isEqual */
                  ](date, max);
                }

                return __WEBPACK_IMPORTED_MODULE_2_date_fns__["r"
                /* isAfter */
                ](date, min) || __WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
                /* isEqual */
                ](date, min);
              } else {
                return false;
              }
            } catch (e) {
              return false;
            }
          }
        }, {
          key: "_setVisibleDate",
          value: function _setVisibleDate(date) {
            if (!date) return;
            if ((this || _global).min) date = __WEBPACK_IMPORTED_MODULE_2_date_fns__["z"
            /* max */
            ]([date, (this || _global).min]);
            if ((this || _global).max) date = __WEBPACK_IMPORTED_MODULE_2_date_fns__["A"
            /* min */
            ]([date, (this || _global).max]);
            (this || _global)._visibleDate = date;
          }
        }, {
          key: "_togglePreviousButton",
          value: function _togglePreviousButton() {
            var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (!active) {
              (this || _global)._ui.navigation.previous.setAttribute("disabled", "disabled");
            } else {
              (this || _global)._ui.navigation.previous.removeAttribute("disabled");
            }
          }
        }, {
          key: "_toggleNextButton",
          value: function _toggleNextButton() {
            var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (!active) {
              (this || _global)._ui.navigation.next.setAttribute("disabled", "disabled");
            } else {
              (this || _global)._ui.navigation.next.removeAttribute("disabled");
            }
          }
        }, {
          key: "id",
          get: function get() {
            return (this || _global)._id;
          }
        }, {
          key: "date",
          set: function set(date) {
            if (__WEBPACK_IMPORTED_MODULE_1__utils_type__["d"
            /* isObject */
            ](date) && date.start && date.end) {
              (this || _global)._date = date;
            }

            return this || _global;
          },
          get: function get() {
            return (this || _global)._date || {
              start: undefined,
              end: undefined
            };
          } // Set datePicker language

        }, {
          key: "lang",
          set: function set(lang) {
            try {
              (this || _global)._locale = __webpack_require__(26)("./" + lang + "/index.js");
            } catch (e) {
              lang = "en-US";
              (this || _global)._locale = __webpack_require__(26)("./" + lang + "/index.js");
            } finally {
              (this || _global)._lang = lang;
              return this || _global;
            }
          } // Get current datePicker language
          ,
          get: function get() {
            return (this || _global)._lang;
          }
        }, {
          key: "locale",
          get: function get() {
            return (this || _global)._locale;
          }
        }, {
          key: "start",
          set: function set(date) {
            if (!date) {
              (this || _global)._date.start = undefined;
              return this || _global;
            }

            date = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
            /* newDate */
            ](date, (this || _global).format, "yyyy-MM-dd");

            if (this._isValidDate(date, (this || _global).min, (this || _global).max)) {
              (this || _global)._date.start = __WEBPACK_IMPORTED_MODULE_2_date_fns__["F"
              /* startOfDay */
              ](date);
            }

            return this || _global;
          },
          get: function get() {
            return (this || _global)._date.start;
          }
        }, {
          key: "end",
          set: function set(date) {
            if (!date) {
              (this || _global)._date.end = undefined;
              return this || _global;
            }

            date = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
            /* newDate */
            ](date, (this || _global).format, "yyyy-MM-dd");

            if (this._isValidDate(date, (this || _global).min, (this || _global).max)) {
              (this || _global)._date.end = __WEBPACK_IMPORTED_MODULE_2_date_fns__["h"
              /* endOfDay */
              ](date);
            }

            return this || _global;
          },
          get: function get() {
            return (this || _global)._date.end;
          } // Set min

        }, {
          key: "min",
          set: function set(date) {
            (this || _global)._min = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
            /* newDate */
            ](date, (this || _global).format, "yyyy-MM-dd");
            return this || _global;
          } // Get min
          ,
          get: function get() {
            return (this || _global)._min;
          } // Set max

        }, {
          key: "max",
          set: function set(date) {
            (this || _global)._max = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
            /* newDate */
            ](date, (this || _global).format, "yyyy-MM-dd");
            return this || _global;
          } // Get max
          ,
          get: function get() {
            return (this || _global)._max;
          } // Set date format (set to MM/dd/yyyy by default)

        }, {
          key: "format",
          set: function set(format) {
            (this || _global)._format = format;
            return this || _global;
          } // Get date format
          ,
          get: function get() {
            return (this || _global)._format;
          }
        }]);

        return datePicker;
      }(__WEBPACK_IMPORTED_MODULE_3__utils_events__["a"
      /* default */
      ]);
      /* harmony default export */


      __webpack_exports__["a"] = datePicker;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony default export */

      __webpack_exports__["a"] = function (data) {
        return "<div class=\"datepicker\">\n    <div class=\"datepicker-nav\">\n        <button type=\"button\" class=\"datepicker-nav-previous button is-small is-text\">" + data.icons.previous + "</button>\n        <div class=\"datepicker-nav-month-year\">\n          <div class=\"datepicker-nav-month\"></div>\n          &nbsp;\n          <div class=\"datepicker-nav-year\"></div>\n        </div>\n        <button type=\"button\" class=\"datepicker-nav-next button is-small is-text\">" + data.icons.next + "</button>\n      </div>\n      <div class=\"datepicker-body\">\n        <div class=\"datepicker-dates is-active\"></div>\n        <div class=\"datepicker-months\"></div>\n        <div class=\"datepicker-years\"></div>\n      </div>\n    </div>";
      };
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony default export */

      __webpack_exports__["a"] = function (data) {
        return "<div class=\"datepicker-days\">" + data.map(function (theDate) {
          return "<div data-date=\"" + theDate.date.toString() + "\" class=\"datepicker-date" + (theDate.isThisMonth ? " is-current-month" : "") + (theDate.isDisabled ? " is-disabled" : "") + (theDate.isRange && theDate.isInRange ? " datepicker-range" : "") + (theDate.isStartDate ? " datepicker-range-start" : "") + (theDate.isEndDate ? " datepicker-range-end" : "") + "\">\n      <button class=\"date-item" + (theDate.isToday ? " is-today" : "") + (theDate.isHighlighted ? " is-highlighted" : "") + (theDate.isStartDate ? " is-active" : "") + "\" type=\"button\">" + theDate.date.getDate() + "</button>\n  </div>";
        }).join("") + "</div>";
      };
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(18);
      /* harmony default export */


      __webpack_exports__["a"] = function (data) {
        return "<div class=\"datepicker-weekdays\">\n        " + data.days.map(function (day) {
          return "<div class=\"datepicker-date\">\n            " + Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["l"
          /* format */
          ])(day, data.format, {
            locale: data.locale
          }) + "\n        </div>";
        }).join("") + "\n    </div>";
      };
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(18);
      /* harmony default export */


      __webpack_exports__["a"] = function (data) {
        return "" + data.months.map(function (month) {
          return "\n        <div class=\"datepicker-month\" data-month=\"" + Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["l"
          /* format */
          ])(month, "MM", {
            locale: data.locale
          }) + "\">\n            " + Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["l"
          /* format */
          ])(month, data.format, {
            locale: data.locale
          }) + "\n        </div>\n    ";
        }).join("");
      };
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(18);
      /* harmony default export */


      __webpack_exports__["a"] = function (data) {
        return "" + data.years.map(function (year) {
          return "\n        <div class=\"datepicker-year\" data-year=\"" + Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["l"
          /* format */
          ])(year, "yyyy", {
            locale: data.locale
          }) + "\">\n            <span class=\"item\">" + Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["l"
          /* format */
          ])(year, data.format, {
            locale: data.locale
          }) + "</span>\n        </div>\n    ";
        }).join("");
      };
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      var defaultOptions = {
        color: "primary",
        isRange: false,
        allowSameDayRange: true,
        lang: "en-US",
        // internationalization
        startDate: undefined,
        endDate: undefined,
        minDate: null,
        maxDate: null,
        disabledDates: [],
        disabledWeekDays: undefined,
        highlightedDates: [],
        weekStart: 0,
        dateFormat: "MM/dd/yyyy",
        enableMonthSwitch: true,
        enableYearSwitch: true,
        displayYearsCount: 50,
        formats: {
          header: "LLLL yyyy",
          navigationMonth: "LLLL",
          navigationYear: "yyyy",
          selectMonth: "LLL",
          selectYear: "yyyy",
          weekday: "ccc"
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = defaultOptions;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(128));

      var _index2 = _interopRequireDefault(__webpack_require__(129));

      var _index3 = _interopRequireDefault(__webpack_require__(130));

      var _index4 = _interopRequireDefault(__webpack_require__(131));

      var _index5 = _interopRequireDefault(__webpack_require__(132));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Afrikaans locale.
       * @language Afrikaans
       * @iso-639-2 afr
       * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
       */


      var locale = {
        code: "af",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(133));

      var _index2 = _interopRequireDefault(__webpack_require__(134));

      var _index3 = _interopRequireDefault(__webpack_require__(135));

      var _index4 = _interopRequireDefault(__webpack_require__(136));

      var _index5 = _interopRequireDefault(__webpack_require__(137));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Arabic locale (Algerian Arabic).
       * @language Algerian Arabic
       * @iso-639-2 ara
       * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
       * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
       */


      var locale = {
        code: "ar-DZ",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(138));

      var _index2 = _interopRequireDefault(__webpack_require__(139));

      var _index3 = _interopRequireDefault(__webpack_require__(140));

      var _index4 = _interopRequireDefault(__webpack_require__(141));

      var _index5 = _interopRequireDefault(__webpack_require__(142));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Arabic locale (Moroccan Arabic).
       * @language Moroccan Arabic
       * @iso-639-2 ara
       * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
       */


      var locale = {
        code: "ar-MA",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          // Monday is 1
          weekStartsOn: 1,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(143));

      var _index2 = _interopRequireDefault(__webpack_require__(144));

      var _index3 = _interopRequireDefault(__webpack_require__(145));

      var _index4 = _interopRequireDefault(__webpack_require__(146));

      var _index5 = _interopRequireDefault(__webpack_require__(147));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Arabic locale (Sauid Arabic).
       * @language Arabic
       * @iso-639-2 ara
       * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
       */


      var locale = {
        code: "ar-SA",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(148));

      var _index2 = _interopRequireDefault(__webpack_require__(149));

      var _index3 = _interopRequireDefault(__webpack_require__(150));

      var _index4 = _interopRequireDefault(__webpack_require__(151));

      var _index5 = _interopRequireDefault(__webpack_require__(152));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Arabic locale (Tunisian Arabic).
       * @language Arabic
       * @iso-639-2 ara
       * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
       */


      var locale = {
        code: "ar-TN",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(153));

      var _index2 = _interopRequireDefault(__webpack_require__(154));

      var _index3 = _interopRequireDefault(__webpack_require__(155));

      var _index4 = _interopRequireDefault(__webpack_require__(156));

      var _index5 = _interopRequireDefault(__webpack_require__(157));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Azerbaijani locale.
       * @language Azerbaijani
       * @iso-639-2 aze
       */


      var locale = {
        code: "az",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = startOfUTCWeek;

      var _index = _interopRequireDefault(__webpack_require__(682));

      var _index2 = _interopRequireDefault(__webpack_require__(683));

      var _index3 = _interopRequireDefault(__webpack_require__(63));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function startOfUTCWeek(dirtyDate, dirtyOptions) {
        (0, _index3.default)(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
        }

        var date = (0, _index2.default)(dirtyDate);
        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = toInteger;

      function toInteger(dirtyNumber) {
        if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
          return NaN;
        }

        var number = Number(dirtyNumber);

        if (isNaN(number)) {
          return number;
        }

        return number < 0 ? Math.ceil(number) : Math.floor(number);
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = toDate;

      var _index = _interopRequireDefault(__webpack_require__(63));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @name toDate
       * @category Common Helpers
       * @summary Convert the given argument to an instance of Date.
       *
       * @description
       * Convert the given argument to an instance of Date.
       *
       * If the argument is an instance of Date, the function returns its clone.
       *
       * If the argument is a number, it is treated as a timestamp.
       *
       * If the argument is none of the above, the function returns Invalid Date.
       *
       * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
       *
       * @param {Date|Number} argument - the value to convert
       * @returns {Date} the parsed date in the local time zone
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Clone the date:
       * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
       * //=> Tue Feb 11 2014 11:30:30
       *
       * @example
       * // Convert the timestamp to date:
       * const result = toDate(1392098430000)
       * //=> Tue Feb 11 2014 11:30:30
       */


      function toDate(argument) {
        (0, _index.default)(1, arguments);
        var argStr = Object.prototype.toString.call(argument); // Clone the date

        if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
          // Prevent the date to lose the milliseconds when passed to new Date() in IE10
          return new Date(argument.getTime());
        } else if (typeof argument === "number" || argStr === "[object Number]") {
          return new Date(argument);
        } else {
          if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

            console.warn(new Error().stack);
          }

          return new Date(NaN);
        }
      }

      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(158));

      var _index2 = _interopRequireDefault(__webpack_require__(159));

      var _index3 = _interopRequireDefault(__webpack_require__(160));

      var _index4 = _interopRequireDefault(__webpack_require__(161));

      var _index5 = _interopRequireDefault(__webpack_require__(162));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Belarusian locale.
       * @language Belarusian
       * @iso-639-2 bel
       * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
       * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
       */


      var locale = {
        code: "be",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(163));

      var _index2 = _interopRequireDefault(__webpack_require__(164));

      var _index3 = _interopRequireDefault(__webpack_require__(165));

      var _index4 = _interopRequireDefault(__webpack_require__(166));

      var _index5 = _interopRequireDefault(__webpack_require__(167));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Bulgarian locale.
       * @language Bulgarian
       * @iso-639-2 bul
       * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
       * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
       */


      var locale = {
        code: "bg",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(168));

      var _index2 = _interopRequireDefault(__webpack_require__(169));

      var _index3 = _interopRequireDefault(__webpack_require__(170));

      var _index4 = _interopRequireDefault(__webpack_require__(64));

      var _index5 = _interopRequireDefault(__webpack_require__(171));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Bengali locale.
       * @language Bengali
       * @iso-639-2 ben
       * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
       * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
       */


      var locale = {
        code: "bn",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(172));

      var _index2 = _interopRequireDefault(__webpack_require__(173));

      var _index3 = _interopRequireDefault(__webpack_require__(174));

      var _index4 = _interopRequireDefault(__webpack_require__(175));

      var _index5 = _interopRequireDefault(__webpack_require__(176));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Bosnian locale.
       * @language Bosnian
       * @iso-639-2 bos
       * @author Branislav Lazić [@branislavlazic]{@link https://github.com/branislavlazic}
       */


      var locale = {
        code: "bs",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(177));

      var _index2 = _interopRequireDefault(__webpack_require__(178));

      var _index3 = _interopRequireDefault(__webpack_require__(179));

      var _index4 = _interopRequireDefault(__webpack_require__(180));

      var _index5 = _interopRequireDefault(__webpack_require__(181));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Catalan locale.
       * @language Catalan
       * @iso-639-2 cat
       * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
       * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
       */


      var locale = {
        code: "ca",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale; // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')

      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(182));

      var _index2 = _interopRequireDefault(__webpack_require__(183));

      var _index3 = _interopRequireDefault(__webpack_require__(184));

      var _index4 = _interopRequireDefault(__webpack_require__(185));

      var _index5 = _interopRequireDefault(__webpack_require__(186));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Czech locale.
       * @language Czech
       * @iso-639-2 ces
       * @author David Rus [@davidrus]{@link https://github.com/davidrus}
       * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
       * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
       */


      var locale = {
        code: "cs",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(187));

      var _index2 = _interopRequireDefault(__webpack_require__(188));

      var _index3 = _interopRequireDefault(__webpack_require__(189));

      var _index4 = _interopRequireDefault(__webpack_require__(190));

      var _index5 = _interopRequireDefault(__webpack_require__(191));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Welsh locale.
       * @language Welsh
       * @iso-639-2 cym
       * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
       */


      var locale = {
        code: "cy",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(192));

      var _index2 = _interopRequireDefault(__webpack_require__(193));

      var _index3 = _interopRequireDefault(__webpack_require__(194));

      var _index4 = _interopRequireDefault(__webpack_require__(195));

      var _index5 = _interopRequireDefault(__webpack_require__(196));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Danish locale.
       * @language Danish
       * @iso-639-2 dan
       * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
       * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
       * @author [@kgram]{@link https://github.com/kgram}
       * @author [@stefanbugge]{@link https://github.com/stefanbugge}
       */


      var locale = {
        code: "da",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(65));

      var _index2 = _interopRequireDefault(__webpack_require__(66));

      var _index3 = _interopRequireDefault(__webpack_require__(67));

      var _index4 = _interopRequireDefault(__webpack_require__(68));

      var _index5 = _interopRequireDefault(__webpack_require__(197));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // difference to 'de' locale

      /**
       * @type {Locale}
       * @category Locales
       * @summary German locale (Austria).
       * @language German
       * @iso-639-2 deu
       * @author Christoph Tobias Stenglein [@cstenglein]{@link https://github.com/cstenglein}
       */


      var locale = {
        code: "de-AT",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index5.default,
        match: _index4.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(65));

      var _index2 = _interopRequireDefault(__webpack_require__(66));

      var _index3 = _interopRequireDefault(__webpack_require__(67));

      var _index4 = _interopRequireDefault(__webpack_require__(198));

      var _index5 = _interopRequireDefault(__webpack_require__(68));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary German locale.
       * @language German
       * @iso-639-2 deu
       * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
       * @author Asia [@asia-t]{@link https://github.com/asia-t}
       * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
       * @author RomanErnst [@pex]{@link https://github.com/pex}
       * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
       */


      var locale = {
        code: "de",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(199));

      var _index2 = _interopRequireDefault(__webpack_require__(200));

      var _index3 = _interopRequireDefault(__webpack_require__(201));

      var _index4 = _interopRequireDefault(__webpack_require__(202));

      var _index5 = _interopRequireDefault(__webpack_require__(203));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Greek locale.
       * @language Greek
       * @iso-639-2 ell
       * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
       * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
       */


      var locale = {
        code: "el",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(22));

      var _index2 = _interopRequireDefault(__webpack_require__(204));

      var _index3 = _interopRequireDefault(__webpack_require__(15));

      var _index4 = _interopRequireDefault(__webpack_require__(16));

      var _index5 = _interopRequireDefault(__webpack_require__(17));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (Australia).
       * @language English
       * @iso-639-2 eng
       * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
       */


      var locale = {
        code: "en-AU",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(15));

      var _index2 = _interopRequireDefault(__webpack_require__(16));

      var _index3 = _interopRequireDefault(__webpack_require__(17));

      var _index4 = _interopRequireDefault(__webpack_require__(205));

      var _index5 = _interopRequireDefault(__webpack_require__(206));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (Canada).
       * @language English
       * @iso-639-2 eng
       * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
       * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
       */


      var locale = {
        code: "en-CA",
        formatDistance: _index4.default,
        formatLong: _index5.default,
        formatRelative: _index.default,
        localize: _index2.default,
        match: _index3.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(22));

      var _index2 = _interopRequireDefault(__webpack_require__(15));

      var _index3 = _interopRequireDefault(__webpack_require__(16));

      var _index4 = _interopRequireDefault(__webpack_require__(17));

      var _index5 = _interopRequireDefault(__webpack_require__(207));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (United Kingdom).
       * @language English
       * @iso-639-2 eng
       * @author Alex [@glintik]{@link https://github.com/glintik}
       */


      var locale = {
        code: "en-GB",
        formatDistance: _index.default,
        formatLong: _index5.default,
        formatRelative: _index2.default,
        localize: _index3.default,
        match: _index4.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(22));

      var _index2 = _interopRequireDefault(__webpack_require__(15));

      var _index3 = _interopRequireDefault(__webpack_require__(16));

      var _index4 = _interopRequireDefault(__webpack_require__(17));

      var _index5 = _interopRequireDefault(__webpack_require__(208));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (India).
       * @language English
       * @iso-639-2 eng
       * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
       */


      var locale = {
        code: "en-IN",
        formatDistance: _index.default,
        formatLong: _index5.default,
        formatRelative: _index2.default,
        localize: _index3.default,
        match: _index4.default,
        options: {
          weekStartsOn: 1,
          // Monday is the first day of the week.
          firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.

        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(22));

      var _index2 = _interopRequireDefault(__webpack_require__(15));

      var _index3 = _interopRequireDefault(__webpack_require__(16));

      var _index4 = _interopRequireDefault(__webpack_require__(17));

      var _index5 = _interopRequireDefault(__webpack_require__(209));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (New Zealand).
       * @language English
       * @iso-639-2 eng
       * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
       */


      var locale = {
        code: "en-NZ",
        formatDistance: _index.default,
        formatLong: _index5.default,
        formatRelative: _index2.default,
        localize: _index3.default,
        match: _index4.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(22));

      var _index2 = _interopRequireDefault(__webpack_require__(210));

      var _index3 = _interopRequireDefault(__webpack_require__(15));

      var _index4 = _interopRequireDefault(__webpack_require__(16));

      var _index5 = _interopRequireDefault(__webpack_require__(17));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (United States).
       * @language English
       * @iso-639-2 eng
       * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
       * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
       */


      var locale = {
        code: "en-US",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(22));

      var _index2 = _interopRequireDefault(__webpack_require__(15));

      var _index3 = _interopRequireDefault(__webpack_require__(16));

      var _index4 = _interopRequireDefault(__webpack_require__(17));

      var _index5 = _interopRequireDefault(__webpack_require__(211));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (South Africa).
       * @language English
       * @iso-639-2 eng
       * @author Shaila Kavrakova [@shaykav]{@link https://github.com/shaykav}
       */


      var locale = {
        code: "en-ZA",
        formatDistance: _index.default,
        formatLong: _index5.default,
        formatRelative: _index2.default,
        localize: _index3.default,
        match: _index4.default,
        options: {
          weekStartsOn: 0,
          // Sunday is the first day of the week.
          firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.

        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(212));

      var _index2 = _interopRequireDefault(__webpack_require__(213));

      var _index3 = _interopRequireDefault(__webpack_require__(214));

      var _index4 = _interopRequireDefault(__webpack_require__(215));

      var _index5 = _interopRequireDefault(__webpack_require__(216));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Esperanto locale.
       * @language Esperanto
       * @iso-639-2 epo
       * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
       */


      var locale = {
        code: "eo",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(217));

      var _index2 = _interopRequireDefault(__webpack_require__(218));

      var _index3 = _interopRequireDefault(__webpack_require__(219));

      var _index4 = _interopRequireDefault(__webpack_require__(220));

      var _index5 = _interopRequireDefault(__webpack_require__(221));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Spanish locale.
       * @language Spanish
       * @iso-639-2 spa
       * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
       * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
       * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
       * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
       * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
       */


      var locale = {
        code: "es",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(222));

      var _index2 = _interopRequireDefault(__webpack_require__(223));

      var _index3 = _interopRequireDefault(__webpack_require__(224));

      var _index4 = _interopRequireDefault(__webpack_require__(225));

      var _index5 = _interopRequireDefault(__webpack_require__(226));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Estonian locale.
       * @language Estonian
       * @iso-639-2 est
       * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
       */


      var locale = {
        code: "et",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(227));

      var _index2 = _interopRequireDefault(__webpack_require__(228));

      var _index3 = _interopRequireDefault(__webpack_require__(229));

      var _index4 = _interopRequireDefault(__webpack_require__(230));

      var _index5 = _interopRequireDefault(__webpack_require__(231));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Basque locale.
       * @language Basque
       * @iso-639-2 eus
       * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
       */


      var locale = {
        code: "eu",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(232));

      var _index2 = _interopRequireDefault(__webpack_require__(233));

      var _index3 = _interopRequireDefault(__webpack_require__(234));

      var _index4 = _interopRequireDefault(__webpack_require__(235));

      var _index5 = _interopRequireDefault(__webpack_require__(236));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Persian/Farsi locale (Iran).
       * @language Persian
       * @iso-639-2 ira
       * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
       */


      var locale = {
        code: "fa-IR",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 6
          /* Saturday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(237));

      var _index2 = _interopRequireDefault(__webpack_require__(238));

      var _index3 = _interopRequireDefault(__webpack_require__(239));

      var _index4 = _interopRequireDefault(__webpack_require__(240));

      var _index5 = _interopRequireDefault(__webpack_require__(241));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Finnish locale.
       * @language Finnish
       * @iso-639-2 fin
       * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
       * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
       * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
       */


      var locale = {
        code: "fi",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(69));

      var _index2 = _interopRequireDefault(__webpack_require__(70));

      var _index3 = _interopRequireDefault(__webpack_require__(71));

      var _index4 = _interopRequireDefault(__webpack_require__(72));

      var _index5 = _interopRequireDefault(__webpack_require__(242));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // Same as fr
      // Unique for fr-CA

      /**
       * @type {Locale}
       * @category Locales
       * @summary French locale (Canada).
       * @language French
       * @iso-639-2 fra
       * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
       * @author François B [@fbonzon]{@link https://github.com/fbonzon}
       * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
       */


      var locale = {
        code: "fr-CA",
        formatDistance: _index.default,
        formatLong: _index5.default,
        formatRelative: _index2.default,
        localize: _index3.default,
        match: _index4.default,
        // Unique for fr-CA
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var formatters = {}; // Special case for day of month ordinals in long date format context:
      // 1er mars, 2 mars, 3 mars, …
      // See https://github.com/date-fns/date-fns/issues/437

      var monthsTokens = ["MMM", "MMMM"];
      monthsTokens.forEach(function (monthToken) {
        formatters["Do " + monthToken] = function (date, options) {
          var commonFormatters = options.formatters;
          var dayOfMonthToken = date.getUTCDate() === 1 ? "Do" : "D";
          var dayOfMonthFormatter = commonFormatters[dayOfMonthToken];
          var monthFormatter = commonFormatters[monthToken];
          return dayOfMonthFormatter(date, options) + " " + monthFormatter(date, options);
        };
      });
      var _default = formatters;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(243));

      var _index2 = _interopRequireDefault(__webpack_require__(244));

      var _index3 = _interopRequireDefault(__webpack_require__(245));

      var _index4 = _interopRequireDefault(__webpack_require__(246));

      var _index5 = _interopRequireDefault(__webpack_require__(247));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary French locale.
       * @language French
       * @iso-639-2 fra
       * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
       * @author François B [@fbonzon]{@link https://github.com/fbonzon}
       * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
       * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
       */


      var locale = {
        code: "fr-CH",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var formatters = {}; // Special case for day of month ordinals in long date format context:
      // 1er mars, 2 mars, 3 mars, …
      // See https://github.com/date-fns/date-fns/issues/437

      var monthsTokens = ["MMM", "MMMM"];
      monthsTokens.forEach(function (monthToken) {
        formatters["Do " + monthToken] = function (date, options) {
          var commonFormatters = options.formatters;
          var dayOfMonthToken = date.getUTCDate() === 1 ? "Do" : "D";
          var dayOfMonthFormatter = commonFormatters[dayOfMonthToken];
          var monthFormatter = commonFormatters[monthToken];
          return dayOfMonthFormatter(date, options) + " " + monthFormatter(date, options);
        };
      });
      var _default = formatters;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(69));

      var _index2 = _interopRequireDefault(__webpack_require__(248));

      var _index3 = _interopRequireDefault(__webpack_require__(70));

      var _index4 = _interopRequireDefault(__webpack_require__(71));

      var _index5 = _interopRequireDefault(__webpack_require__(72));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary French locale.
       * @language French
       * @iso-639-2 fra
       * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
       * @author François B [@fbonzon]{@link https://github.com/fbonzon}
       */


      var locale = {
        code: "fr",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(249));

      var _index2 = _interopRequireDefault(__webpack_require__(250));

      var _index3 = _interopRequireDefault(__webpack_require__(251));

      var _index4 = _interopRequireDefault(__webpack_require__(252));

      var _index5 = _interopRequireDefault(__webpack_require__(253));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Scottish Gaelic.
       * @language Scottish Gaelic
       * @iso-639-2 gla
       * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
       */


      var locale = {
        code: "gd",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(254));

      var _index2 = _interopRequireDefault(__webpack_require__(255));

      var _index3 = _interopRequireDefault(__webpack_require__(256));

      var _index4 = _interopRequireDefault(__webpack_require__(257));

      var _index5 = _interopRequireDefault(__webpack_require__(258));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Galician locale.
       * @language Galician
       * @iso-639-2 glg
       * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
       * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
       */


      var locale = {
        code: "gl",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(259));

      var _index2 = _interopRequireDefault(__webpack_require__(260));

      var _index3 = _interopRequireDefault(__webpack_require__(261));

      var _index4 = _interopRequireDefault(__webpack_require__(262));

      var _index5 = _interopRequireDefault(__webpack_require__(263));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Gujarati locale (India).
       * @language Gujarati
       * @iso-639-2 guj
       * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
       */


      var locale = {
        code: "gu",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(264));

      var _index2 = _interopRequireDefault(__webpack_require__(265));

      var _index3 = _interopRequireDefault(__webpack_require__(266));

      var _index4 = _interopRequireDefault(__webpack_require__(267));

      var _index5 = _interopRequireDefault(__webpack_require__(268));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Hebrew locale.
       * @language Hebrew
       * @iso-639-2 heb
       * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
       */


      var locale = {
        code: "he",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(269));

      var _index2 = _interopRequireDefault(__webpack_require__(270));

      var _index3 = _interopRequireDefault(__webpack_require__(271));

      var _index4 = _interopRequireDefault(__webpack_require__(44));

      var _index5 = _interopRequireDefault(__webpack_require__(272));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Hindi locale (India).
       * @language Hindi
       * @iso-639-2 hin
       * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
       */


      var locale = {
        code: "hi",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(273));

      var _index2 = _interopRequireDefault(__webpack_require__(274));

      var _index3 = _interopRequireDefault(__webpack_require__(275));

      var _index4 = _interopRequireDefault(__webpack_require__(276));

      var _index5 = _interopRequireDefault(__webpack_require__(277));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Croatian locale.
       * @language Croatian
       * @iso-639-2 hrv
       * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
       * @author Manico [@manico]{@link https://github.com/manico}
       * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
       */


      var locale = {
        code: "hr",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var formatters = {}; // Special case for day of month ordinals in long date format context:
      // 1er mars, 2 mars, 3 mars, …
      // See https://github.com/date-fns/date-fns/issues/437

      var monthsTokens = ["MMM", "MMMM"];
      monthsTokens.forEach(function (monthToken) {
        formatters["Do " + monthToken] = function (date, options) {
          var commonFormatters = options.formatters;
          var dayOfMonthToken = date.getUTCDate() === 1 ? "Do" : "D";
          var dayOfMonthFormatter = commonFormatters[dayOfMonthToken];
          var monthFormatter = commonFormatters[monthToken];
          return dayOfMonthFormatter(date, options) + " " + monthFormatter(date, options);
        };
      });
      var _default = formatters;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(278));

      var _index2 = _interopRequireDefault(__webpack_require__(279));

      var _index3 = _interopRequireDefault(__webpack_require__(280));

      var _index4 = _interopRequireDefault(__webpack_require__(281));

      var _index5 = _interopRequireDefault(__webpack_require__(282));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Haitian Creole locale.
       * @language Haitian Creole
       * @iso-639-2 hat
       * @author Rubens Mariuzzo [@rmariuzzo]{@link https://github.com/rmariuzzo}
       * @author Watson Marcelain [@watsongm24]{@link https://github.com/watsongm24}
       */


      var locale = {
        code: "ht",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(283));

      var _index2 = _interopRequireDefault(__webpack_require__(284));

      var _index3 = _interopRequireDefault(__webpack_require__(285));

      var _index4 = _interopRequireDefault(__webpack_require__(286));

      var _index5 = _interopRequireDefault(__webpack_require__(287));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       *
       * @summary Hungarian locale.
       * @language Hungarian
       *
       * @iso-639-2 hun
       *
       * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
       * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
       * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
       */


      var locale = {
        code: "hu",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(288));

      var _index2 = _interopRequireDefault(__webpack_require__(289));

      var _index3 = _interopRequireDefault(__webpack_require__(290));

      var _index4 = _interopRequireDefault(__webpack_require__(291));

      var _index5 = _interopRequireDefault(__webpack_require__(292));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Armenian locale
       * @language Armenian
       * @iso-639-2 arm
       * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
       */


      var locale = {
        code: "hy",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(293));

      var _index2 = _interopRequireDefault(__webpack_require__(294));

      var _index3 = _interopRequireDefault(__webpack_require__(295));

      var _index4 = _interopRequireDefault(__webpack_require__(296));

      var _index5 = _interopRequireDefault(__webpack_require__(297));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Indonesian locale.
       * @language Indonesian
       * @iso-639-2 ind
       * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
       * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
       * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
       * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
       */


      var locale = {
        code: "id",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(298));

      var _index2 = _interopRequireDefault(__webpack_require__(299));

      var _index3 = _interopRequireDefault(__webpack_require__(300));

      var _index4 = _interopRequireDefault(__webpack_require__(301));

      var _index5 = _interopRequireDefault(__webpack_require__(302));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Icelandic locale.
       * @language Icelandic
       * @iso-639-2 isl
       * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
       * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
       */


      var locale = {
        code: "is",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(303));

      var _index2 = _interopRequireDefault(__webpack_require__(304));

      var _index3 = _interopRequireDefault(__webpack_require__(305));

      var _index4 = _interopRequireDefault(__webpack_require__(306));

      var _index5 = _interopRequireDefault(__webpack_require__(307));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Italian locale.
       * @language Italian
       * @iso-639-2 ita
       * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
       * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
       * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
       */


      var locale = {
        code: "it",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(308));

      var _index2 = _interopRequireDefault(__webpack_require__(309));

      var _index3 = _interopRequireDefault(__webpack_require__(310));

      var _index4 = _interopRequireDefault(__webpack_require__(311));

      var _index5 = _interopRequireDefault(__webpack_require__(312));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Japanese (Hiragana) locale.
       * @language Japanese (Hiragana)
       * @iso-639-2 jpn
       * @author Eri Hiramatsu [@Eritutteo]{@link https://github.com/Eritutteo}
       */


      var locale = {
        code: "ja-Hira",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(313));

      var _index2 = _interopRequireDefault(__webpack_require__(314));

      var _index3 = _interopRequireDefault(__webpack_require__(315));

      var _index4 = _interopRequireDefault(__webpack_require__(316));

      var _index5 = _interopRequireDefault(__webpack_require__(317));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Japanese locale.
       * @language Japanese
       * @iso-639-2 jpn
       * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
       * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
       * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
       * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
       * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
       */


      var locale = {
        code: "ja",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(318));

      var _index2 = _interopRequireDefault(__webpack_require__(319));

      var _index3 = _interopRequireDefault(__webpack_require__(320));

      var _index4 = _interopRequireDefault(__webpack_require__(321));

      var _index5 = _interopRequireDefault(__webpack_require__(322));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Georgian locale.
       * @language Georgian
       * @iso-639-2 geo
       * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
       * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
       */


      var locale = {
        code: "ka",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(323));

      var _index2 = _interopRequireDefault(__webpack_require__(324));

      var _index3 = _interopRequireDefault(__webpack_require__(325));

      var _index4 = _interopRequireDefault(__webpack_require__(326));

      var _index5 = _interopRequireDefault(__webpack_require__(327));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Kazakh locale.
       * @language Kazakh
       * @iso-639-2 kaz
       * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
       */


      var locale = {
        code: "kk",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(328));

      var _index2 = _interopRequireDefault(__webpack_require__(329));

      var _index3 = _interopRequireDefault(__webpack_require__(330));

      var _index4 = _interopRequireDefault(__webpack_require__(331));

      var _index5 = _interopRequireDefault(__webpack_require__(332));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Kannada locale (India).
       * @language Kannada
       * @iso-639-2 kan
       * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
       */


      var locale = {
        code: "kn",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(333));

      var _index2 = _interopRequireDefault(__webpack_require__(334));

      var _index3 = _interopRequireDefault(__webpack_require__(335));

      var _index4 = _interopRequireDefault(__webpack_require__(336));

      var _index5 = _interopRequireDefault(__webpack_require__(337));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Korean locale.
       * @language Korean
       * @iso-639-2 kor
       * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
       * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
       * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
       */


      var locale = {
        code: "ko",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(338));

      var _index2 = _interopRequireDefault(__webpack_require__(339));

      var _index3 = _interopRequireDefault(__webpack_require__(340));

      var _index4 = _interopRequireDefault(__webpack_require__(341));

      var _index5 = _interopRequireDefault(__webpack_require__(342));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Luxembourgish locale.
       * @language Luxembourgish
       * @iso-639-2 ltz
       * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
       */


      var locale = {
        code: "lb",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(343));

      var _index2 = _interopRequireDefault(__webpack_require__(344));

      var _index3 = _interopRequireDefault(__webpack_require__(345));

      var _index4 = _interopRequireDefault(__webpack_require__(346));

      var _index5 = _interopRequireDefault(__webpack_require__(347));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       *
       * @summary Lithuanian locale.
       * @language Lithuanian
       *
       * @iso-639-2 lit
       *
       * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
       * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
       */


      var locale = {
        code: "lt",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(348));

      var _index2 = _interopRequireDefault(__webpack_require__(349));

      var _index3 = _interopRequireDefault(__webpack_require__(350));

      var _index4 = _interopRequireDefault(__webpack_require__(351));

      var _index5 = _interopRequireDefault(__webpack_require__(352));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Latvian locale (Latvia).
       * @language Latvian
       * @iso-639-2 lav
       * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
       */


      var locale = {
        code: "lv",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(353));

      var _index2 = _interopRequireDefault(__webpack_require__(354));

      var _index3 = _interopRequireDefault(__webpack_require__(355));

      var _index4 = _interopRequireDefault(__webpack_require__(356));

      var _index5 = _interopRequireDefault(__webpack_require__(357));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Macedonian locale.
       * @language Macedonian
       * @iso-639-2 mkd
       * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
       * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
       */


      var locale = {
        code: "mk",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(358));

      var _index2 = _interopRequireDefault(__webpack_require__(359));

      var _index3 = _interopRequireDefault(__webpack_require__(360));

      var _index4 = _interopRequireDefault(__webpack_require__(361));

      var _index5 = _interopRequireDefault(__webpack_require__(362));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Mongolian locale.
       * @language Mongolian
       * @iso-639-2 mon
       * @author Bilguun Ochirbat [@bilguun0203]{@link https://github.com/bilguun0203}
       */


      var locale = {
        code: "mn",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(363));

      var _index2 = _interopRequireDefault(__webpack_require__(364));

      var _index3 = _interopRequireDefault(__webpack_require__(365));

      var _index4 = _interopRequireDefault(__webpack_require__(366));

      var _index5 = _interopRequireDefault(__webpack_require__(367));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Malay locale.
       * @language Malay
       * @iso-639-2 msa
       * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
       */


      var locale = {
        code: "ms",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(368));

      var _index2 = _interopRequireDefault(__webpack_require__(369));

      var _index3 = _interopRequireDefault(__webpack_require__(370));

      var _index4 = _interopRequireDefault(__webpack_require__(371));

      var _index5 = _interopRequireDefault(__webpack_require__(372));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Maltese locale.
       * @language Maltese
       * @iso-639-2 mlt
       * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
       * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
       */


      var locale = {
        code: "mt",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(373));

      var _index2 = _interopRequireDefault(__webpack_require__(374));

      var _index3 = _interopRequireDefault(__webpack_require__(375));

      var _index4 = _interopRequireDefault(__webpack_require__(376));

      var _index5 = _interopRequireDefault(__webpack_require__(377));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Norwegian Bokmål locale.
       * @language Norwegian Bokmål
       * @iso-639-2 nob
       * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
       * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
       * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
       */


      var locale = {
        code: "nb",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(378));

      var _index2 = _interopRequireDefault(__webpack_require__(379));

      var _index3 = _interopRequireDefault(__webpack_require__(380));

      var _index4 = _interopRequireDefault(__webpack_require__(381));

      var _index5 = _interopRequireDefault(__webpack_require__(382));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Dutch locale.
       * @language Dutch
       * @iso-639-2 nld
       * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
       * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
       * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
       * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
       */


      var locale = {
        code: "nl-BE",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(383));

      var _index2 = _interopRequireDefault(__webpack_require__(384));

      var _index3 = _interopRequireDefault(__webpack_require__(385));

      var _index4 = _interopRequireDefault(__webpack_require__(386));

      var _index5 = _interopRequireDefault(__webpack_require__(387));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Dutch locale.
       * @language Dutch
       * @iso-639-2 nld
       * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
       * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
       * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
       * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
       * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
       * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
       */


      var locale = {
        code: "nl",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(388));

      var _index2 = _interopRequireDefault(__webpack_require__(389));

      var _index3 = _interopRequireDefault(__webpack_require__(390));

      var _index4 = _interopRequireDefault(__webpack_require__(391));

      var _index5 = _interopRequireDefault(__webpack_require__(392));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Norwegian Nynorsk locale.
       * @language Norwegian Nynorsk
       * @iso-639-2 nno
       * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
       */


      var locale = {
        code: "nn",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(393));

      var _index2 = _interopRequireDefault(__webpack_require__(394));

      var _index3 = _interopRequireDefault(__webpack_require__(395));

      var _index4 = _interopRequireDefault(__webpack_require__(396));

      var _index5 = _interopRequireDefault(__webpack_require__(397));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Polish locale.
       * @language Polish
       * @iso-639-2 pol
       * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
       * @author Just RAG [@justrag]{@link https://github.com/justrag}
       * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
       * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
       */


      var locale = {
        code: "pl",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(398));

      var _index2 = _interopRequireDefault(__webpack_require__(399));

      var _index3 = _interopRequireDefault(__webpack_require__(400));

      var _index4 = _interopRequireDefault(__webpack_require__(401));

      var _index5 = _interopRequireDefault(__webpack_require__(402));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Portuguese locale (Brazil).
       * @language Portuguese
       * @iso-639-2 por
       * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
       * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
       */


      var locale = {
        code: "pt-BR",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(403));

      var _index2 = _interopRequireDefault(__webpack_require__(404));

      var _index3 = _interopRequireDefault(__webpack_require__(405));

      var _index4 = _interopRequireDefault(__webpack_require__(406));

      var _index5 = _interopRequireDefault(__webpack_require__(407));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Portuguese locale.
       * @language Portuguese
       * @iso-639-2 por
       * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
       * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
       */


      var locale = {
        code: "pt",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(408));

      var _index2 = _interopRequireDefault(__webpack_require__(409));

      var _index3 = _interopRequireDefault(__webpack_require__(410));

      var _index4 = _interopRequireDefault(__webpack_require__(411));

      var _index5 = _interopRequireDefault(__webpack_require__(412));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Romanian locale.
       * @language Romanian
       * @iso-639-2 ron
       * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
       * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
       * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
       */


      var locale = {
        code: "ro",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(413));

      var _index2 = _interopRequireDefault(__webpack_require__(414));

      var _index3 = _interopRequireDefault(__webpack_require__(415));

      var _index4 = _interopRequireDefault(__webpack_require__(416));

      var _index5 = _interopRequireDefault(__webpack_require__(417));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Russian locale.
       * @language Russian
       * @iso-639-2 rus
       * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
       * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
       */


      var locale = {
        code: "ru",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(418));

      var _index2 = _interopRequireDefault(__webpack_require__(419));

      var _index3 = _interopRequireDefault(__webpack_require__(420));

      var _index4 = _interopRequireDefault(__webpack_require__(421));

      var _index5 = _interopRequireDefault(__webpack_require__(422));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Slovak locale.
       * @language Slovak
       * @iso-639-2 slk
       * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
       */


      var locale = {
        code: "sk",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(423));

      var _index2 = _interopRequireDefault(__webpack_require__(424));

      var _index3 = _interopRequireDefault(__webpack_require__(425));

      var _index4 = _interopRequireDefault(__webpack_require__(426));

      var _index5 = _interopRequireDefault(__webpack_require__(427));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Slovenian locale.
       * @language Slovenian
       * @iso-639-2 slv
       * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
       * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
       */


      var locale = {
        code: "sl",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(428));

      var _index2 = _interopRequireDefault(__webpack_require__(429));

      var _index3 = _interopRequireDefault(__webpack_require__(430));

      var _index4 = _interopRequireDefault(__webpack_require__(431));

      var _index5 = _interopRequireDefault(__webpack_require__(432));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Albanian locale.
       * @language Shqip
       * @iso-639-2 sqi
       * @author Ardit Dine [@arditdine]{@link https://github.com/arditdine}
       */


      var locale = {
        code: "sq",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(433));

      var _index2 = _interopRequireDefault(__webpack_require__(434));

      var _index3 = _interopRequireDefault(__webpack_require__(435));

      var _index4 = _interopRequireDefault(__webpack_require__(436));

      var _index5 = _interopRequireDefault(__webpack_require__(437));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Serbian latin locale.
       * @language Serbian
       * @iso-639-2 srp
       * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
       */


      var locale = {
        code: "sr-Latn",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(438));

      var _index2 = _interopRequireDefault(__webpack_require__(439));

      var _index3 = _interopRequireDefault(__webpack_require__(440));

      var _index4 = _interopRequireDefault(__webpack_require__(441));

      var _index5 = _interopRequireDefault(__webpack_require__(442));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Serbian cyrillic locale.
       * @language Serbian
       * @iso-639-2 srp
       * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
       */


      var locale = {
        code: "sr",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(443));

      var _index2 = _interopRequireDefault(__webpack_require__(444));

      var _index3 = _interopRequireDefault(__webpack_require__(445));

      var _index4 = _interopRequireDefault(__webpack_require__(446));

      var _index5 = _interopRequireDefault(__webpack_require__(447));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Swedish locale.
       * @language Swedish
       * @iso-639-2 swe
       * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
       * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
       * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
       */


      var locale = {
        code: "sv",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(448));

      var _index2 = _interopRequireDefault(__webpack_require__(449));

      var _index3 = _interopRequireDefault(__webpack_require__(450));

      var _index4 = _interopRequireDefault(__webpack_require__(451));

      var _index5 = _interopRequireDefault(__webpack_require__(452));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Tamil locale (India).
       * @language Tamil
       * @iso-639-2 tam
       * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
       */


      var locale = {
        code: "ta",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(453));

      var _index2 = _interopRequireDefault(__webpack_require__(454));

      var _index3 = _interopRequireDefault(__webpack_require__(455));

      var _index4 = _interopRequireDefault(__webpack_require__(456));

      var _index5 = _interopRequireDefault(__webpack_require__(457));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Telugu locale
       * @language Telugu
       * @iso-639-2 tel
       * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
       */


      var locale = {
        code: "te",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(458));

      var _index2 = _interopRequireDefault(__webpack_require__(459));

      var _index3 = _interopRequireDefault(__webpack_require__(460));

      var _index4 = _interopRequireDefault(__webpack_require__(461));

      var _index5 = _interopRequireDefault(__webpack_require__(462));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Thai locale.
       * @language Thai
       * @iso-639-2 tha
       * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
       * @author [@hawkup]{@link https://github.com/hawkup}
       * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
       */


      var locale = {
        code: "th",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(463));

      var _index2 = _interopRequireDefault(__webpack_require__(464));

      var _index3 = _interopRequireDefault(__webpack_require__(465));

      var _index4 = _interopRequireDefault(__webpack_require__(466));

      var _index5 = _interopRequireDefault(__webpack_require__(467));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Turkish locale.
       * @language Turkish
       * @iso-639-2 tur
       * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
       * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
       * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
       * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
       *
       *
       */


      var locale = {
        code: "tr",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(468));

      var _index2 = _interopRequireDefault(__webpack_require__(469));

      var _index3 = _interopRequireDefault(__webpack_require__(470));

      var _index4 = _interopRequireDefault(__webpack_require__(471));

      var _index5 = _interopRequireDefault(__webpack_require__(472));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Uighur locale
       * @language Uighur
       * @iso-639-2 uig
       * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
       */


      var locale = {
        code: "ug",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(473));

      var _index2 = _interopRequireDefault(__webpack_require__(474));

      var _index3 = _interopRequireDefault(__webpack_require__(475));

      var _index4 = _interopRequireDefault(__webpack_require__(476));

      var _index5 = _interopRequireDefault(__webpack_require__(477));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Ukrainian locale.
       * @language Ukrainian
       * @iso-639-2 ukr
       * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
       * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
       */


      var locale = {
        code: "uk",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(478));

      var _index2 = _interopRequireDefault(__webpack_require__(479));

      var _index3 = _interopRequireDefault(__webpack_require__(480));

      var _index4 = _interopRequireDefault(__webpack_require__(481));

      var _index5 = _interopRequireDefault(__webpack_require__(482));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Uzbek locale.
       * @language Uzbek
       * @iso-639-2 uzb
       * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
       */


      var locale = {
        code: "uz",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(483));

      var _index2 = _interopRequireDefault(__webpack_require__(484));

      var _index3 = _interopRequireDefault(__webpack_require__(485));

      var _index4 = _interopRequireDefault(__webpack_require__(486));

      var _index5 = _interopRequireDefault(__webpack_require__(487));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Vietnamese locale (Vietnam).
       * @language Vietnamese
       * @iso-639-2 vie
       * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
       * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
       */


      var locale = {
        code: "vi",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
          /* First week of new year contains Jan 1st  */

        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(488));

      var _index2 = _interopRequireDefault(__webpack_require__(489));

      var _index3 = _interopRequireDefault(__webpack_require__(490));

      var _index4 = _interopRequireDefault(__webpack_require__(491));

      var _index5 = _interopRequireDefault(__webpack_require__(492));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Chinese Simplified locale.
       * @language Chinese Simplified
       * @iso-639-2 zho
       * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
       * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
       * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
       * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
       * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
       */


      var locale = {
        code: "zh-CN",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;

      var _index = _interopRequireDefault(__webpack_require__(493));

      var _index2 = _interopRequireDefault(__webpack_require__(494));

      var _index3 = _interopRequireDefault(__webpack_require__(495));

      var _index4 = _interopRequireDefault(__webpack_require__(496));

      var _index5 = _interopRequireDefault(__webpack_require__(497));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * @type {Locale}
       * @category Locales
       * @summary Chinese Traditional locale.
       * @language Chinese Traditional
       * @iso-639-2 zho
       * @author tonypai [@tpai]{@link https://github.com/tpai}
       * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
       * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
       */


      var locale = {
        code: "zh-TW",
        formatDistance: _index.default,
        formatLong: _index2.default,
        formatRelative: _index3.default,
        localize: _index4.default,
        match: _index5.default,
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      var _default = locale;
      exports.default = _default;
      module.exports = exports.default;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(45);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__utils_type__ = __webpack_require__(33);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(18);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__utils_events__ = __webpack_require__(62);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__templates_timepicker__ = __webpack_require__(765);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__defaultOptions__ = __webpack_require__(766);

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var timePicker = function (_EventEmitter) {
        _inherits(timePicker, _EventEmitter);

        function timePicker() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          _classCallCheck(this || _global, timePicker);

          var _this = _possibleConstructorReturn(this || _global, (timePicker.__proto__ || Object.getPrototypeOf(timePicker)).call(this || _global));

          _this.options = _extends({}, __WEBPACK_IMPORTED_MODULE_5__defaultOptions__["a"
          /* default */
          ], options);
          _this._clickEvents = ["click", "touch"];
          _this._supportsPassive = __WEBPACK_IMPORTED_MODULE_0__utils__["a"
          /* detectSupportsPassive */
          ]();
          _this._id = __WEBPACK_IMPORTED_MODULE_0__utils__["c"
          /* uuid */
          ]("timePicker");
          _this.node = null;
          _this.onPreviousHourStartTimePicker = _this.onPreviousHourStartTimePicker.bind(_this);
          _this.onNextHourStartTimePicker = _this.onNextHourStartTimePicker.bind(_this);
          _this.onPreviousMinuteStartTimePicker = _this.onPreviousMinuteStartTimePicker.bind(_this);
          _this.onNextMinuteStartTimePicker = _this.onNextMinuteStartTimePicker.bind(_this);
          _this.onPreviousHourEndTimePicker = _this.onPreviousHourEndTimePicker.bind(_this);
          _this.onNextHourEndTimePicker = _this.onNextHourEndTimePicker.bind(_this);
          _this.onPreviousMinuteEndTimePicker = _this.onPreviousMinuteEndTimePicker.bind(_this);
          _this.onNextMinuteEndTimePicker = _this.onNextMinuteEndTimePicker.bind(_this);

          _this._init();

          return _this;
        }
        /****************************************************
         *                                                  *
         * PRIVATE FUNCTIONS                                *
         *                                                  *
         ****************************************************/


        _createClass(timePicker, [{
          key: "_init",
          value: function _init() {
            (this || _global)._open = false;
            (this || _global).lang = (this || _global).options.lang;
            (this || _global).format = (this || _global).options.format || "HH:mm";
            (this || _global).min = (this || _global).options.min;
            (this || _global).max = (this || _global).options.max;
            (this || _global)._time = {
              start: __WEBPACK_IMPORTED_MODULE_2_date_fns__["H"
              /* startOfToday */
              ](),
              end: __WEBPACK_IMPORTED_MODULE_2_date_fns__["j"
              /* endOfToday */
              ]()
            };
            (this || _global).start = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
            /* newDate */
            ]((this || _global).options.startTime, (this || _global).format, "HH:mm") || __WEBPACK_IMPORTED_MODULE_2_date_fns__["H"
            /* startOfToday */
            ]();
            (this || _global).end = (this || _global).options.isRange ? __WEBPACK_IMPORTED_MODULE_0__utils__["b"
            /* newDate */
            ]((this || _global).options.endTime, (this || _global).format, "HH:mm") : __WEBPACK_IMPORTED_MODULE_2_date_fns__["j"
            /* endOfToday */
            ]();

            this._build();

            this._bindEvents();

            this.emit("ready", this || _global);
          }
        }, {
          key: "_build",
          value: function _build() {
            (this || _global).node = document.createRange().createContextualFragment(Object(__WEBPACK_IMPORTED_MODULE_4__templates_timepicker__["a"
            /* default */
            ])({
              locale: (this || _global).locale,
              isRange: (this || _global).options.isRange,
              editTimeManually: (this || _global).options.editTimeManually,
              icons: (this || _global).options.icons
            }));
            (this || _global)._ui = {
              container: (this || _global).node.firstChild,
              start: {
                container: (this || _global).node.querySelector(".timepicker-start"),
                hours: {
                  container: (this || _global).node.querySelector(".timepicker-start .timepicker-hours"),
                  input: (this || _global).node.querySelector(".timepicker-start .timepicker-hours input"),
                  number: (this || _global).node.querySelector(".timepicker-start .timepicker-hours .timepicker-input-number"),
                  previous: (this || _global).node.querySelector(".timepicker-start .timepicker-hours .timepicker-previous"),
                  next: (this || _global).node.querySelector(".timepicker-start .timepicker-hours .timepicker-next")
                },
                minutes: {
                  container: (this || _global).node.querySelector(".timepicker-start .timepicker-minutes"),
                  input: (this || _global).node.querySelector(".timepicker-start .timepicker-minutes input"),
                  number: (this || _global).node.querySelector(".timepicker-start .timepicker-minutes .timepicker-input-number"),
                  previous: (this || _global).node.querySelector(".timepicker-start .timepicker-minutes .timepicker-previous"),
                  next: (this || _global).node.querySelector(".timepicker-start .timepicker-minutes .timepicker-next")
                }
              },
              end: {
                container: (this || _global).node.querySelector(".timepicker-end"),
                hours: {
                  container: (this || _global).node.querySelector(".timepicker-end .timepicker-hours"),
                  input: (this || _global).node.querySelector(".timepicker-end .timepicker-hours input"),
                  number: (this || _global).node.querySelector(".timepicker-end .timepicker-hours .timepicker-input-number"),
                  previous: (this || _global).node.querySelector(".timepicker-end .timepicker-hours .timepicker-previous"),
                  next: (this || _global).node.querySelector(".timepicker-end .timepicker-hours .timepicker-next")
                },
                minutes: {
                  container: (this || _global).node.querySelector(".timepicker-end .timepicker-minutes"),
                  input: (this || _global).node.querySelector(".timepicker-end .timepicker-minutes input"),
                  number: (this || _global).node.querySelector(".timepicker-end .timepicker-minutes .timepicker-input-number"),
                  previous: (this || _global).node.querySelector(".timepicker-end .timepicker-minutes .timepicker-previous"),
                  next: (this || _global).node.querySelector(".timepicker-end .timepicker-minutes .timepicker-next")
                }
              }
            };
          }
        }, {
          key: "_bindEvents",
          value: function _bindEvents() {
            var _this2 = this || _global;

            (this || _global)._clickEvents.forEach(function (clickEvent) {
              _this2._ui.start.hours.previous.addEventListener(clickEvent, _this2.onPreviousHourStartTimePicker);

              _this2._ui.start.hours.next.addEventListener(clickEvent, _this2.onNextHourStartTimePicker);

              _this2._ui.start.minutes.previous.addEventListener(clickEvent, _this2.onPreviousMinuteStartTimePicker);

              _this2._ui.start.minutes.next.addEventListener(clickEvent, _this2.onNextMinuteStartTimePicker);

              if (_this2.options.isRange) {
                _this2._ui.end.hours.previous.addEventListener(clickEvent, _this2.onPreviousHourEndTimePicker);

                _this2._ui.end.hours.next.addEventListener(clickEvent, _this2.onNextHourEndTimePicker);

                _this2._ui.end.minutes.previous.addEventListener(clickEvent, _this2.onPreviousMinuteEndTimePicker);

                _this2._ui.end.minutes.next.addEventListener(clickEvent, _this2.onNextMinuteEndTimePicker);
              }
            });
          }
        }, {
          key: "_select",
          value: function _select() {
            var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (!__WEBPACK_IMPORTED_MODULE_1__utils_type__["b"
            /* isDate */
            ](time)) {
              time = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
              /* newDate */
              ](time, (this || _global).format, "HH:mm");
            }

            if ((this || _global).options.isRange && (!this._isValidTime((this || _global).start) || this._isValidTime((this || _global).start) && this._isValidTime((this || _global).end))) {
              (this || _global).start = time;
              (this || _global).end = __WEBPACK_IMPORTED_MODULE_2_date_fns__["j"
              /* endOfToday */
              ]();
              if (emit) this.emit("select:start", this || _global);
            } else if ((this || _global).options.isRange && !this._isValidTime((this || _global).end)) {
              if (__WEBPACK_IMPORTED_MODULE_2_date_fns__["s"
              /* isBefore */
              ](time, (this || _global).start)) {
                (this || _global).end = (this || _global).start;
                (this || _global).start = __WEBPACK_IMPORTED_MODULE_2_date_fns__["j"
                /* endOfToday */
                ]();
                if (emit) this.emit("select", this || _global);
              } else if (__WEBPACK_IMPORTED_MODULE_2_date_fns__["r"
              /* isAfter */
              ](time, (this || _global).start)) {
                (this || _global).end = time;
                if (emit) this.emit("select", this || _global);
              } else {
                (this || _global).start = time;
                (this || _global).end = __WEBPACK_IMPORTED_MODULE_2_date_fns__["j"
                /* endOfToday */
                ]();
                if (emit) this.emit("select:start", this || _global);
              }
            } else {
              (this || _global).start = time;
              (this || _global).end = __WEBPACK_IMPORTED_MODULE_2_date_fns__["j"
              /* endOfToday */
              ]();
              if (emit) this.emit("select", this || _global);
            }
          }
        }, {
          key: "_isValidTime",
          value: function _isValidTime(time, min, max) {
            try {
              if (!time) {
                return false;
              }

              if (__WEBPACK_IMPORTED_MODULE_2_date_fns__["w"
              /* isValid */
              ](time)) {
                if (!min && !max) {
                  return true;
                }

                if (min && max) {
                  return __WEBPACK_IMPORTED_MODULE_2_date_fns__["x"
                  /* isWithinInterval */
                  ](time, {
                    start: min,
                    end: max
                  });
                }

                if (max) {
                  return __WEBPACK_IMPORTED_MODULE_2_date_fns__["s"
                  /* isBefore */
                  ](time, max) || __WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
                  /* isEqual */
                  ](time, max);
                }

                return __WEBPACK_IMPORTED_MODULE_2_date_fns__["r"
                /* isAfter */
                ](time, min) || __WEBPACK_IMPORTED_MODULE_2_date_fns__["t"
                /* isEqual */
                ](time, min);
              } else {
                return false;
              }
            } catch (e) {
              return false;
            }
          }
          /****************************************************
           *                                                  *
           * GETTERS and SETTERS                              *
           *                                                  *
           ****************************************************/

          /**
           * Get id of current TimePicker
           */

        }, {
          key: "onPreviousHourStartTimePicker",

          /****************************************************
           *                                                  *
           * EVENTS FUNCTIONS                                 *
           *                                                  *
           ****************************************************/
          value: function onPreviousHourStartTimePicker(e) {
            var _this3 = this || _global;

            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();
            (this || _global).start = __WEBPACK_IMPORTED_MODULE_2_date_fns__["K"
            /* subHours */
            ]((this || _global).start, 1);
            setTimeout(function () {
              _this3._ui.start.hours.number.classList.add("is-decrement-hide");

              setTimeout(function () {
                _this3._ui.start.hours.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this3.start, "HH");
                _this3._ui.start.hours.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this3.start, "HH");

                _this3._ui.start.hours.number.classList.add("is-decrement-visible");

                _this3.emit("select", _this3);
              }, 100);
              setTimeout(function () {
                _this3._ui.start.hours.number.classList.remove("is-decrement-hide");

                _this3._ui.start.hours.number.classList.remove("is-decrement-visible");
              }, 1100);
            }, 100);
          }
        }, {
          key: "onNextHourStartTimePicker",
          value: function onNextHourStartTimePicker(e) {
            var _this4 = this || _global;

            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();
            (this || _global).start = __WEBPACK_IMPORTED_MODULE_2_date_fns__["b"
            /* addHours */
            ]((this || _global).start, 1);
            setTimeout(function () {
              _this4._ui.start.hours.number.classList.add("is-increment-hide");

              setTimeout(function () {
                _this4._ui.start.hours.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this4.start, "HH");
                _this4._ui.start.hours.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this4.start, "HH");

                _this4._ui.start.hours.number.classList.add("is-increment-visible");

                _this4.emit("select", _this4);
              }, 100);
              setTimeout(function () {
                _this4._ui.start.hours.number.classList.remove("is-increment-hide");

                _this4._ui.start.hours.number.classList.remove("is-increment-visible");
              }, 1100);
            }, 100);
          }
        }, {
          key: "onPreviousMinuteStartTimePicker",
          value: function onPreviousMinuteStartTimePicker(e) {
            var _this5 = this || _global;

            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();
            (this || _global).start = __WEBPACK_IMPORTED_MODULE_2_date_fns__["L"
            /* subMinutes */
            ]((this || _global).start, (this || _global).options.minuteSteps);
            setTimeout(function () {
              _this5._ui.start.minutes.number.classList.add("is-decrement-hide");

              setTimeout(function () {
                _this5._ui.start.minutes.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this5.start, "mm");
                _this5._ui.start.minutes.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this5.start, "mm");

                _this5._ui.start.minutes.number.classList.add("is-decrement-visible");

                _this5.emit("select", _this5);

                if (__WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this5.start, "HH") !== _this5._ui.start.hours.input.value) {
                  _this5._ui.start.hours.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                  /* format */
                  ](_this5.start, "HH");
                  _this5._ui.start.hours.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                  /* format */
                  ](_this5.start, "HH");

                  _this5._ui.start.hours.number.classList.add("is-decrement-visible");
                }
              }, 100);
              setTimeout(function () {
                _this5._ui.start.minutes.number.classList.remove("is-decrement-hide");

                _this5._ui.start.minutes.number.classList.remove("is-decrement-visible");

                _this5._ui.start.hours.number.classList.remove("is-decrement-hide");

                _this5._ui.start.hours.number.classList.remove("is-decrement-visible");
              }, 1100);
            }, 100);
          }
        }, {
          key: "onNextMinuteStartTimePicker",
          value: function onNextMinuteStartTimePicker(e) {
            var _this6 = this || _global;

            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();
            (this || _global).start = __WEBPACK_IMPORTED_MODULE_2_date_fns__["c"
            /* addMinutes */
            ]((this || _global).start, (this || _global).options.minuteSteps);
            setTimeout(function () {
              _this6._ui.start.minutes.number.classList.add("is-increment-hide");

              setTimeout(function () {
                _this6._ui.start.minutes.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this6.start, "mm");
                _this6._ui.start.minutes.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this6.start, "mm");

                _this6._ui.start.minutes.number.classList.add("is-increment-visible");

                _this6.emit("select", _this6);

                if (__WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this6.start, "HH") !== _this6._ui.start.hours.input.value) {
                  _this6._ui.start.hours.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                  /* format */
                  ](_this6.start, "HH");
                  _this6._ui.start.hours.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                  /* format */
                  ](_this6.start, "HH");

                  _this6._ui.start.hours.number.classList.add("is-increment-visible");
                }
              }, 100);
              setTimeout(function () {
                _this6._ui.start.minutes.number.classList.remove("is-increment-hide");

                _this6._ui.start.minutes.number.classList.remove("is-increment-visible");

                _this6._ui.start.hours.number.classList.remove("is-increment-hide");

                _this6._ui.start.hours.number.classList.remove("is-increment-visible");
              }, 1100);
            }, 100);
          }
        }, {
          key: "onPreviousHourEndTimePicker",
          value: function onPreviousHourEndTimePicker(e) {
            var _this7 = this || _global;

            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();
            (this || _global).end = __WEBPACK_IMPORTED_MODULE_2_date_fns__["K"
            /* subHours */
            ]((this || _global).end, 1);
            setTimeout(function () {
              _this7._ui.end.hours.number.classList.add("is-decrement-hide");

              setTimeout(function () {
                _this7._ui.end.hours.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this7.end, "HH");
                _this7._ui.end.hours.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this7.end, "HH");

                _this7._ui.end.hours.number.classList.add("is-decrement-visible");

                _this7.emit("select", _this7);
              }, 100);
              setTimeout(function () {
                _this7._ui.end.hours.number.classList.remove("is-decrement-hide");

                _this7._ui.end.hours.number.classList.remove("is-decrement-visible");
              }, 1100);
            }, 100);
          }
        }, {
          key: "onNextHourEndTimePicker",
          value: function onNextHourEndTimePicker(e) {
            var _this8 = this || _global;

            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();
            (this || _global).end = __WEBPACK_IMPORTED_MODULE_2_date_fns__["b"
            /* addHours */
            ]((this || _global).end, 1);
            setTimeout(function () {
              _this8._ui.end.hours.number.classList.add("is-increment-hide");

              setTimeout(function () {
                _this8._ui.end.hours.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this8.end, "HH");
                _this8._ui.end.hours.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this8.end, "HH");

                _this8._ui.end.hours.number.classList.add("is-increment-visible");

                _this8.emit("select", _this8);
              }, 100);
              setTimeout(function () {
                _this8._ui.end.hours.number.classList.remove("is-increment-hide");

                _this8._ui.end.hours.number.classList.remove("is-increment-visible");
              }, 1100);
            }, 100);
          }
        }, {
          key: "onPreviousMinuteEndTimePicker",
          value: function onPreviousMinuteEndTimePicker(e) {
            var _this9 = this || _global;

            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();
            (this || _global).end = __WEBPACK_IMPORTED_MODULE_2_date_fns__["L"
            /* subMinutes */
            ]((this || _global).end, (this || _global).options.minuteSteps);
            setTimeout(function () {
              _this9._ui.end.minutes.number.classList.add("is-decrement-hide");

              setTimeout(function () {
                _this9._ui.end.minutes.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this9.end, "mm");
                _this9._ui.end.minutes.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this9.end, "mm");

                _this9._ui.end.minutes.number.classList.add("is-decrement-visible");

                _this9.emit("select", _this9);

                if (__WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this9.end, "HH") !== _this9._ui.end.hours.input.value) {
                  _this9._ui.end.hours.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                  /* format */
                  ](_this9.end, "HH");
                  _this9._ui.end.hours.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                  /* format */
                  ](_this9.end, "HH");

                  _this9._ui.end.hours.number.classList.add("is-decrement-visible");
                }
              }, 100);
              setTimeout(function () {
                _this9._ui.end.minutes.number.classList.remove("is-decrement-hide");

                _this9._ui.end.minutes.number.classList.remove("is-decrement-visible");
              }, 1100);
            }, 100);
          }
        }, {
          key: "onNextMinuteEndTimePicker",
          value: function onNextMinuteEndTimePicker(e) {
            var _this10 = this || _global;

            if (!(this || _global)._supportsPassive) {
              e.preventDefault();
            }

            e.stopPropagation();
            (this || _global).end = __WEBPACK_IMPORTED_MODULE_2_date_fns__["c"
            /* addMinutes */
            ]((this || _global).end, (this || _global).options.minuteSteps);
            setTimeout(function () {
              _this10._ui.end.minutes.number.classList.add("is-increment-hide");

              setTimeout(function () {
                _this10._ui.end.minutes.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this10.end, "mm");
                _this10._ui.end.minutes.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this10.end, "mm");

                _this10._ui.end.minutes.number.classList.add("is-increment-visible");

                _this10.emit("select", _this10);

                if (__WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                /* format */
                ](_this10.end, "HH") !== _this10._ui.end.hours.input.value) {
                  _this10._ui.end.hours.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                  /* format */
                  ](_this10.end, "HH");
                  _this10._ui.end.hours.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
                  /* format */
                  ](_this10.end, "HH");

                  _this10._ui.end.hours.number.classList.add("is-increment-visible");
                }
              }, 100);
              setTimeout(function () {
                _this10._ui.end.minutes.number.classList.remove("is-increment-hide");

                _this10._ui.end.minutes.number.classList.remove("is-increment-visible");
              }, 1100);
            }, 100);
          }
          /****************************************************
           *                                                  *
           * PUBLIC FUNCTIONS                                 *
           *                                                  *
           ****************************************************/

        }, {
          key: "isRange",
          value: function isRange() {
            return (this || _global).options.isRange;
          }
        }, {
          key: "show",
          value: function show() {
            if (!(this || _global)._open) {
              (this || _global)._ui.container.classList.add("is-active");

              (this || _global)._open = true;
              (this || _global)._focus = true;
              this.emit("show", this || _global);
            }
          }
        }, {
          key: "hide",
          value: function hide() {
            (this || _global)._open = false;
            (this || _global)._focus = false;

            (this || _global)._ui.container.classList.remove("is-active");

            this.emit("hide", this || _global);
          }
        }, {
          key: "toggle",
          value: function toggle() {
            if (!(this || _global)._open) {
              this.show();
            } else {
              this.hide();
            }
          }
          /**
           * Get / Set TimePicker value
           * @param {null|time|Object|String} time optional if null then return the current time as String
           */

        }, {
          key: "value",
          value: function value() {
            var _value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null; // Set


            if (_value) {
              if ((this || _global).options.isRange) {
                if (__WEBPACK_IMPORTED_MODULE_1__utils_type__["e"
                /* isString */
                ](_value)) {
                  _value = _value.split(" - ");
                }

                if (Array.isArray(_value)) {
                  if (_value.length) (this || _global).start = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
                  /* newDate */
                  ](_value[0], (this || _global).format, "yyyy-MM-dd");
                  if (_value.length === 2) (this || _global).end = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
                  /* newDate */
                  ](_value[1], (this || _global).format, "yyyy-MM-dd");
                }
              } else {
                this._select(_value, false);
              }

              this.refresh();
              return;
            } // Get


            var string = this._isValidTime((this || _global).start) ? __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
            /* format */
            ]((this || _global).start, (this || _global).format, {
              locale: (this || _global).locale
            }) : "";

            if ((this || _global).options.isRange && this._isValidTime((this || _global).end)) {
              string += " - " + __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
              /* format */
              ]((this || _global).end, (this || _global).format, {
                locale: (this || _global).locale
              });
            }

            return string;
          }
          /**
           * Refresh Timepicker with new year/month days
           * @method _refreshTimepicker
           * @return {[type]}        [description]
           */

        }, {
          key: "refresh",
          value: function refresh() {
            (this || _global)._ui.start.hours.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
            /* format */
            ]((this || _global).start, "HH");
            (this || _global)._ui.start.hours.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
            /* format */
            ]((this || _global).start, "HH");
            (this || _global)._ui.start.minutes.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
            /* format */
            ]((this || _global).start, "mm");
            (this || _global)._ui.start.minutes.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
            /* format */
            ]((this || _global).start, "mm");

            if ((this || _global).options.isRange) {
              (this || _global)._ui.end.hours.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
              /* format */
              ]((this || _global).end, "HH");
              (this || _global)._ui.end.hours.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
              /* format */
              ]((this || _global).end, "HH");
              (this || _global)._ui.end.minutes.input.value = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
              /* format */
              ]((this || _global).end, "mm");
              (this || _global)._ui.end.minutes.number.innerText = __WEBPACK_IMPORTED_MODULE_2_date_fns__["l"
              /* format */
              ]((this || _global).end, "mm");
            }

            return this || _global;
          }
        }, {
          key: "clear",
          value: function clear() {
            (this || _global).time = {
              start: __WEBPACK_IMPORTED_MODULE_2_date_fns__["H"
              /* startOfToday */
              ](),
              end: __WEBPACK_IMPORTED_MODULE_2_date_fns__["j"
              /* endOfToday */
              ]()
            };
            this.refresh();
          }
        }, {
          key: "render",
          value: function render() {
            this.refresh();
            return (this || _global).node;
          }
        }, {
          key: "id",
          get: function get() {
            return (this || _global)._id;
          }
        }, {
          key: "time",
          set: function set(time) {
            if (__WEBPACK_IMPORTED_MODULE_1__utils_type__["d"
            /* isObject */
            ](time) && time.start && time.end) {
              (this || _global)._time = time;
            }

            return this || _global;
          },
          get: function get() {
            return (this || _global)._time || {
              start: undefined,
              end: undefined
            };
          } // Set TimePicker language

        }, {
          key: "lang",
          set: function set(lang) {
            try {
              (this || _global)._locale = __webpack_require__(26)("./" + lang + "/index.js");
            } catch (e) {
              lang = "en-US";
              (this || _global)._locale = __webpack_require__(26)("./" + lang + "/index.js");
            } finally {
              (this || _global)._lang = lang;
              return this || _global;
            }
          } // Get current TimePicker language
          ,
          get: function get() {
            return (this || _global)._lang;
          }
        }, {
          key: "locale",
          get: function get() {
            return (this || _global)._locale;
          }
        }, {
          key: "start",
          set: function set(time) {
            if (!time) {
              (this || _global)._time.start = __WEBPACK_IMPORTED_MODULE_2_date_fns__["H"
              /* startOfToday */
              ]();
              return this || _global;
            }

            time = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
            /* newDate */
            ](time, (this || _global).format, "HH:mm");

            if (this._isValidTime(time, (this || _global).min, (this || _global).max)) {
              (this || _global)._time.start = time;
            }

            return this || _global;
          },
          get: function get() {
            return (this || _global)._time.start;
          }
        }, {
          key: "end",
          set: function set(time) {
            if (!time) {
              (this || _global)._time.end = __WEBPACK_IMPORTED_MODULE_2_date_fns__["j"
              /* endOfToday */
              ]();
              return this || _global;
            }

            time = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
            /* newDate */
            ](time, (this || _global).format, "HH:mm");

            if (this._isValidTime(time, (this || _global).min, (this || _global).max)) {
              (this || _global)._time.end = time;
            }

            return this || _global;
          },
          get: function get() {
            return (this || _global)._time.end;
          } // Set min

        }, {
          key: "min",
          set: function set(time) {
            (this || _global)._min = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
            /* newDate */
            ](time, (this || _global).format, "HH:mm");
            return this || _global;
          } // Get min
          ,
          get: function get() {
            return (this || _global)._min;
          } // Set max

        }, {
          key: "max",
          set: function set(time) {
            (this || _global)._max = __WEBPACK_IMPORTED_MODULE_0__utils__["b"
            /* newDate */
            ](time, (this || _global).format, "HH:mm");
            return this || _global;
          } // Get max
          ,
          get: function get() {
            return (this || _global)._max;
          } // Set time format (set to HH:mm by default)

        }, {
          key: "format",
          set: function set(format) {
            (this || _global)._format = format;
            return this || _global;
          } // Get time format
          ,
          get: function get() {
            return (this || _global)._format;
          }
        }]);

        return timePicker;
      }(__WEBPACK_IMPORTED_MODULE_3__utils_events__["a"
      /* default */
      ]);
      /* harmony default export */


      __webpack_exports__["a"] = timePicker;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony default export */

      __webpack_exports__["a"] = function (data) {
        return "<div class=\"timepicker" + (data.editTimeManually ? " is-hidden" : "") + "\">\n    <div class=\"timepicker-start\">\n      <div class=\"timepicker-hours\">\n        <span class=\"timepicker-next\">+</span>\n        <div class=\"timepicker-input\">\n          <input type=\"number\">\n          <div class=\"timepicker-input-number\"></div>\n        </div>\n        <span class=\"timepicker-previous\">-</span>\n      </div>\n      <div class=\"timepicker-time-divider\">:</div>\n      <div class=\"timepicker-minutes\">\n        <span class=\"timepicker-next\">+</span>\n        <div class=\"timepicker-input\">\n          <input type=\"number\">\n          <div class=\"timepicker-input-number\"></div>\n        </div>\n        <span class=\"timepicker-previous\">-</span>\n      </div>\n    </div>\n    " + (data.isRange ? "<div class=\"timepicker-end\">\n      <div class=\"timepicker-hours\">\n        <span class=\"timepicker-next\">+</span>\n        <div class=\"timepicker-input\">\n          <input type=\"number\">\n          <div class=\"timepicker-input-number\"></div>\n        </div>\n        <span class=\"timepicker-previous\">-</span>\n      </div>\n      <div class=\"timepicker-time-divider\">:</div>\n      <div class=\"timepicker-minutes\">\n        <span class=\"timepicker-next\">+</span>\n        <div class=\"timepicker-input\">\n          <input type=\"number\">\n          <div class=\"timepicker-input-number\"></div>\n        </div>\n        <span class=\"timepicker-previous\">-</span>\n      </div>\n    </div>" : "") + "\n  </div>";
      };
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      var defaultOptions = {
        timeFormat: "HH:mm",
        editTimeManually: false,
        color: "primary",
        isRange: false,
        lang: "en-US",
        // internationalization
        startTime: undefined,
        endTime: undefined,
        minTime: null,
        maxTime: null,
        minuteSteps: 5
      };
      /* harmony default export */

      __webpack_exports__["a"] = defaultOptions;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      var defaultOptions = {
        type: undefined,
        color: "primary",
        isRange: false,
        allowSameDayRange: true,
        lang: navigator.language || "en-US",
        // internationalization
        dateFormat: "MM/dd/yyyy",
        timeFormat: "HH:mm",
        displayMode: "default",
        editTimeManually: false,
        position: "auto",
        showHeader: true,
        headerPosition: "top",
        showFooter: true,
        showButtons: true,
        showTodayButton: true,
        showClearButton: true,
        cancelLabel: "Cancel",
        clearLabel: "Clear",
        todayLabel: "Today",
        nowLabel: "Now",
        validateLabel: "Validate",
        enableMonthSwitch: true,
        enableYearSwitch: true,
        startDate: undefined,
        endDate: undefined,
        minDate: null,
        maxDate: null,
        disabledDates: [],
        disabledWeekDays: undefined,
        highlightedDates: [],
        weekStart: 0,
        startTime: undefined,
        endTime: undefined,
        minuteSteps: 5,
        labelFrom: "",
        labelTo: "",
        closeOnOverlayClick: true,
        closeOnSelect: true,
        toggleOnInputClick: true,
        onReady: null,
        onValidate: null,
        formats: {
          header: "LLLL yyyy",
          navigationMonth: "LLLL",
          navigationYear: "yyyy",
          selectMonth: "LLL",
          selectYear: "yyyy",
          weekday: "ccc"
        },
        icons: {
          previous: "<svg viewBox=\"0 0 50 80\" xml:space=\"preserve\">\n      <polyline fill=\"none\" stroke-width=\".5em\" stroke-linecap=\"round\" stroke-linejoin=\"round\" points=\"45.63,75.8 0.375,38.087 45.63,0.375 \"/>\n    </svg>",
          next: "<svg viewBox=\"0 0 50 80\" xml:space=\"preserve\">\n      <polyline fill=\"none\" stroke-width=\".5em\" stroke-linecap=\"round\" stroke-linejoin=\"round\" points=\"0.375,0.375 45.63,38.087 0.375,75.8 \"/>\n    </svg>",
          time: "<svg version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 60 60\" xml:space=\"preserve\">\n      <g>\n        <path fill=\"currentcolor\" d=\"M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z\"/>\n\t      <path fill=\"currentcolor\" d=\"M30,6c-0.552,0-1,0.447-1,1v23H14c-0.552,0-1,0.447-1,1s0.448,1,1,1h16c0.552,0,1-0.447,1-1V7C31,6.447,30.552,6,30,6z\"/>\n      </g>\n    </svg>",
          date: "<svg version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 60 60\" xml:space=\"preserve\">\n      <g>\n        <path d=\"M57,4h-7V1c0-0.553-0.447-1-1-1h-7c-0.553,0-1,0.447-1,1v3H19V1c0-0.553-0.447-1-1-1h-7c-0.553,0-1,0.447-1,1v3H3C2.447,4,2,4.447,2,5v11v43c0,0.553,0.447,1,1,1h54c0.553,0,1-0.447,1-1V16V5C58,4.447,57.553,4,57,4z M43,2h5v3v3h-5V5V2z M12,2h5v3v3h-5V5V2z M4,6h6v3c0,0.553,0.447,1,1,1h7c0.553,0,1-0.447,1-1V6h22v3c0,0.553,0.447,1,1,1h7c0.553,0,1-0.447,1-1V6h6v9H4V6zM4,58V17h52v41H4z\"/>\n        <path d=\"M38,23h-7h-2h-7h-2h-9v9v2v7v2v9h9h2h7h2h7h2h9v-9v-2v-7v-2v-9h-9H38z M31,25h7v7h-7V25z M38,41h-7v-7h7V41z M22,34h7v7h-7V34z M22,25h7v7h-7V25z M13,25h7v7h-7V25z M13,34h7v7h-7V34z M20,50h-7v-7h7V50z M29,50h-7v-7h7V50z M38,50h-7v-7h7V50z M47,50h-7v-7h7V50z M47,41h-7v-7h7V41z M47,25v7h-7v-7H47z\"/>\n      </g>\n    </svg>"
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = defaultOptions;
      /***/
    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony default export */

      __webpack_exports__["a"] = function (data) {
        return "<div id='" + data.id + "'>\n    <div class=\"datetimepicker-dummy is-hidden\">\n      <div class=\"datetimepicker-dummy-wrapper\">\n        <input placeholder=\"" + data.labelFrom + "\" readonly=\"readonly\" class=\"datetimepicker-dummy-input" + (data.isRange ? " is-datetimepicker-range" : "") + "\" type=\"text\">\n        " + (data.isRange ? "<input placeholder=\"" + data.labelTo + "\" readonly=\"readonly\" class=\"datetimepicker-dummy-input\" type=\"text\">" : "") + "\n      </div>\n      <button class=\"datetimepicker-clear-button\" type=\"button\">\uFF0B</button>\n    </div>\n    <div class=\"datetimepicker-wrapper" + (data.displayMode === "dialog" ? " modal" : "") + "\">\n        <div class=\"modal-background" + (data.displayMode === "dialog" ? "" : " is-hidden") + "\"></div>\n        <div class=\"datetimepicker\">\n          <div class=\"datetimepicker-container" + (data.headerPosition === "top" ? "" : " has-header-bottom") + "\"></div>\n        </div>\n    </div>\n  </div>";
      };
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony default export */

      __webpack_exports__["a"] = function (data) {
        return "<div class=\"datetimepicker-header" + (data.type === "time" ? " is-hidden" : "") + (data.type === "date" ? " is-date-only" : "") + "\">\n\t\t<div class=\"datetimepicker-selection-details\">\n\t\t\t<div class=\"datetimepicker-selection-from" + (data.labelFrom === "" ? " is-hidden" : "") + "\">" + data.labelFrom + "</div>\n\t\t\t<div class=\"datetimepicker-selection-start" + (data.isRange ? "" : " is-centered") + "\">\n\t\t\t\t<div class=\"datetimepicker-selection-wrapper\">\n\t\t\t\t\t<div class=\"datetimepicker-selection-day\"></div>\n\t\t\t\t\t<div class=\"datetimepicker-selection-date\">\n\t\t\t\t\t\t<div class=\"datetimepicker-selection-month\"></div>\n\t\t\t\t\t\t<div class=\"datetimepicker-selection-weekday\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t" + (data.type !== "date" ? "<div class=\"datetimepicker-selection-time\">\n\t\t\t\t\t<div class=\"datetimepicker-selection-time-icon\">\n\t\t\t\t\t\t<figure class=\"image is-16x16\">\n\t\t\t\t\t\t\t" + (data.icons ? data.icons.time : "") + "\n\t\t\t\t\t\t</figure>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"datetimepicker-selection-hour" + (data.editTimeManually ? " editable " : "") + "\">\n\t\t\t\t\t\t" + (data.editTimeManually ? "\n\t\t\t\t\t\t\t<input type=\"text\" class=\"datetimepicker-selection-input-hours\" maxlength=\"2\">:\n\t\t\t\t\t\t\t<input type=\"text\" class=\"datetimepicker-selection-input-minutes\" maxlength=\"2\">\n\t\t\t\t\t\t" : "") + "\n\t\t\t\t\t</div>\n\t\t\t\t</div>" : "") + "\n\t\t\t</div>\n\t\t</div>\n\t\t" + (data.isRange ? "\n\t\t<div class=\"datetimepicker-selection-details\">\n\t\t\t<div class=\"datetimepicker-selection-to " + (data.labelTo === "" ? " is-hidden" : "") + "\">" + data.labelTo + "</div>\n\t\t\t<div class=\"datetimepicker-selection-end\">\n\t\t\t\t<div class=\"datetimepicker-selection-wrapper\">\n\t\t\t\t\t<div class=\"datetimepicker-selection-day\"></div>\n\t\t\t\t\t<div class=\"datetimepicker-selection-date\">\n\t\t\t\t\t\t<div class=\"datetimepicker-selection-month\"></div>\n\t\t\t\t\t\t<div class=\"datetimepicker-selection-weekday\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t" + (data.type !== "date" ? "<div class=\"datetimepicker-selection-time\">\n\t\t\t\t\t<div class=\"datetimepicker-selection-time-icon\">\n\t\t\t\t\t\t<figure class=\"image is-16x16\">\n\t\t\t\t\t\t\t" + (data.icons ? data.icons.time : "") + "\n\t\t\t\t\t\t</figure>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"datetimepicker-selection-hour" + (data.editTimeManually ? " editable " : "") + "\">\n\t\t\t\t\t\t" + (data.editTimeManually ? "\n\t\t\t\t\t\t\t<input type=\"text\" class=\"datetimepicker-selection-input-hours\" maxlength=\"2\">:\n\t\t\t\t\t\t\t<input type=\"text\" class=\"datetimepicker-selection-input-minutes\" maxlength=\"2\">\n\t\t\t\t\t\t" : "") + "\n\t\t\t\t\t</div>\n\t\t\t\t</div>" : "") + "\n\t\t\t</div>\n\t\t</div>" : "") + "\n\t</div>";
      };
      /***/

    }, function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony default export */

      __webpack_exports__["a"] = function (data) {
        return "<div class=\"datetimepicker-footer\">\n\t\t<button type=\"button\" class=\"datetimepicker-footer-validate has-text-success button is-small is-text " + (data.displayMode === "inline" ? "is-hidden" : "") + "\">" + (data.icons.validate ? data.icons.validate : "") + data.validateLabel + " </button>\n\t\t<button type=\"button\" class=\"datetimepicker-footer-today has-text-warning button is-small is-text\">" + (data.icons.today ? data.icons.today : "") + data.todayLabel + "</button>\n\t\t<button type=\"button\" class=\"datetimepicker-footer-clear has-text-danger button is-small is-text\">" + (data.icons.clear ? data.icons.clear : "") + data.clearLabel + "</button>\n\t\t<button type=\"button\" class=\"datetimepicker-footer-cancel button is-small is-text " + (data.displayMode === "inline" ? "is-hidden" : "") + "\">" + (data.icons.cancel ? data.icons.cancel : "") + data.cancelLabel + "</button>\n\t</div>";
      };
      /***/

    }])["default"]
  );
});

export default exports;
export const bulmaCalendar = exports.bulmaCalendar,
      __esModule = exports.__esModule;